import { Autocomplete, Avatar, Backdrop, Badge, Box, Button, Card, CardHeader, Checkbox, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Alert, Divider, FormControlLabel, Grid, IconButton, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Popover, Stack, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip, Typography, Radio, RadioGroup, Skeleton } from "@material-ui/core";
import Page from '../../components/Page';
import { capitalCase, sentenceCase } from "change-case";
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import lockOpenFill from '@iconify/icons-ph/lock-open-fill';
import editFill from '@iconify/icons-eva/edit-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
import RequestProgressModal from "src/components/RequestProgressModal";
import RevertStatusDialog from 'src/components/revert/RevertStatusDialog';
import { isAdminUser } from '../../utils/adminUserTypes';
import { buildRevertStatusOptions, getRevertOptionKey } from 'src/utils/revertStatusOptions'; 
//materail
import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Label from "src/components/Label";
import { useLocation, useNavigate, useParams } from "react-router";
// import { io } from 'socket.io-client'; // OLD
import createAppSocket from 'src/Helpers/createSocket';

import ViewRequest from "src/components/_dashboard/official-request/ViewRequest";
import React, { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from "react";
import PublicMsgBoard from "src/components/_dashboard/official-request/PublicMsgBoard";
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import PublicMessageBoard from 'src/components/_dashboard/user/profile/PublicMessageBoard.js'
import RequestUpdates from "src/components/_dashboard/official-request/RequestUpdates";
import PaymentRequest from "src/components/_dashboard/official-request/PaymentRequest";
import { AddCircle, BlockOutlined, Delete, KeyboardBackspaceOutlined, Print, LocationOn, Add, Remove, CenterFocusStrong, NoteAdd, AddCircleOutlined, UploadFile, Description, DragIndicator, Receipt, AccountBalanceWallet, AttachMoney, MonetizationOn } from "@material-ui/icons";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Modal from "src/components/_dashboard/blog/ProjectModel";
import Icon from "@iconify/react";
import Scrollbar from "src/components/Scrollbar";
import axios from "axios";
import { currentFacilityId, DOMAIN, FacilityTypes, REST_API, REST_API_END_POINT, REST_API_IO, SEND_EMAIL, UNITS } from "src/constants/Defaultvalues";
import {
  computeFilteredServicesForDropdown,
  fetchLabourCostServicesForDropdown,
} from 'src/utils/labourCostServiceDropdown';
import quickbookLogo from 'src/assets/quickbookLogo-removebg-preview.png';
import moment from "moment";
import { formatDateOnly, dateOnlyMoment, dateOnlyToUnix, localTodayDateOnlyUnix } from "src/utils/dateOnly";
import { getBaseUnixForLeadTime, getInstallEndPatchFromLead, isInstallBeforeRequiredLead, resolveProductsLeadTime } from 'src/utils/installationLeadTime';
import { calcRushFeeAmount, calcTotalWithRushFee, createRushFeeSyncRefs, runRushFeeLeadSync, markRushFeeUserToggled } from 'src/utils/rushFee';
import getLabourCostServiceTabLabel from 'src/utils/getLabourCostServiceTabLabel';
import {
  sortServicesByProductIndex,
  buildServiceIndexMapping,
} from 'src/utils/sortServicesByIndex';
import {
  getCustomerOrderProductGroupDisplayName,
  getGroupInstallNotesDisplay,
  collapseProductsForAutocompleteChips,
  getCatalogAutocompleteDisplayName,
  getCatalogAutocompleteTooltip,
  hydrateGroupedMemberMarketingFromRow,
  resolveGroupMemberMarketingForSave,
  getGroupMemberProductQty,
  getGroupMemberInstallQty,
  getNestedLineMarketingAdjustmentValue,
  formatNestedMarketingAdjustmentDisplay,
  getNestedLineMarketingAdjValueType,
  computeGroupedProducts,
  GROUP_QUANTITY_MODE_SET_MULTIPLIER,
  buildGroupAddressesForProduct,
} from 'src/pages/dashboard/quotation/quotationGroupingHelpers';
import {
  buildGroupedDesignOrderDisplayRows,
  serializeDesignOrderGroupedRowsForInvoice,
} from 'src/utils/designOrderInvoiceUtils';
import { PATH_DASHBOARD } from "src/routes/paths";
import { useSnackbar } from "notistack";
import { LoadingButton, MobileDatePicker, MobileDateRangePicker } from "@material-ui/lab";
import { UploadAvatar, UploadMultiFile, UploadSingleFile } from "src/components/upload";
import AddClients from "src/components/_dashboard/official-request/AddClients";
import AddProposal from "src/components/_dashboard/official-request/AddProposal";
import ConfirmationPopup from "src/components/_dashboard/official-request/ConfirmationPopup";
import ReactToPrint, { useReactToPrint } from 'react-to-print'
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref as imageref, uploadBytesResumable } from 'firebase/storage';
import { Link } from "react-router-dom";
import { empty } from "src/Helpers/Common";
import { resolveAttachmentProxyPath } from 'src/Helpers/FileDownloadUtils';
import { PRESERVE_WHITESPACE_SX } from "src/utils/preserveWhitespace";
import Locations from "src/components/_dashboard/official-request/Locations";
import Workflow from "src/components/_dashboard/general-analytics/RfqForm";
import { AccountNotifications } from '../../components/_dashboard/user/account'
import { set } from "lodash";
import Proposals from "src/components/_dashboard/official-request/Proposals";
import useCompanyProfile from "src/hooks/useCompanyProfile";
import LoadingScreen from "src/components/LoadingScreen";
import Lottie from 'lottie-react';
import GroupedSalesOrdersLoadAnimation from 'src/Gif/document checking loader.json';
import PrintableContent from './printPreview';
import { red } from "@material-ui/core/colors";
import AnimatedButton from "src/components/animate/AnimatedButton";
import { MapControlScale } from "src/components/map";
import RouteMap from "src/components/_dashboard/official-request/RouteMap";
import RouteMapInstall from "src/components/_dashboard/official-request/RouteMapInstalls";
import SalesOrderInstallationReportView from "src/components/_dashboard/official-request/SalesOrderInstallationReportView";
import JobNotesMessageBoard from "src/components/_dashboard/user/profile/JobNotesMessageBoard";
import JobNoteWindow from 'src/components/_dashboard/chat/JobNoteWindow';
import { SalesOrderNewBadgeList } from 'src/components/_dashboard/official-request/SalesOrderNewBadge';
import useJobNoteTabUnread from 'src/hooks/useJobNoteTabUnread';
import { supabase } from '../../supabase/supabaseClient';
import AVALARALOGO from 'src/assets/Avalara_Logo.png';
import emailFillIcon from '@iconify/icons-eva/email-fill';
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal';
import { DialogAnimate } from '../../components/animate';
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import SalesOrderInvoicePage from "./SalesOrderInvoicePage";
import RecipeCost from "./recipeCost";
import { cancelAllGlobalRequests } from "src/utils/globalApiCancellationManager";
import { fUSPrice } from "src/utils/formatNumber";
import ViewProductFormulaModal from 'src/components/ViewProductFormulaModal';
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton';
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton';
import AttachmentPreviewDialog from 'src/components/_dashboard/official-request/AttachmentPreviewDialog';
import {
  applyInstallPriceEdit,
  applyRetailPriceEdit,
  distributeGroupTotalByFormulaShare,
  ensureCatalogBaselines,
  formatPriceToTwoDecimals,
  formatRetailPriceDisplay,
  getDisplayedInstallPrice,
  getInstallFormulaEach,
  getProductFormulaEach,
  getSignedMarketingAdjustment,
  getSignedInstallMarketingAdjustment,
  hydrateEstimateLineMarketingPrices,
  canShowProductFormulaIcon,
  hydrateSavedOrderLinePrices,
  limitDecimalInput,
  normalizeProductForSave,
  normalizeRetailArrowChange,
  reconcileCatalogMarketingPrices,
  clearCatalogInstallCost,
  stepRetailPriceByArrow,
  mapAdditionalServiceFromApi,
  normalizeServiceForSave,
  dedupeRequestServicesByRowId,
} from 'src/utils/retailPriceEdit';
import { roundMoneyValue } from 'src/utils/formatNumber';
import {
  getGroupedInvoiceDisplayNumbersText,
  getGroupedSalesOrderJobNumbersText,
  getSalesOrderDisplayJobNumber,
} from 'src/utils/salesOrderDisplayNumbers';
import { getInvoiceProductDisplayName } from 'src/utils/designOrderInvoiceUtils';

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));
const MAX_CHARACTERS = 500;

const ATTACHMENTS_PUBLIC_MARKER = '/storage/v1/object/public/signwise-attachments/';

const normalizeUrlString = (raw) => {
  if (!raw) return '';
  try {
    return decodeURIComponent(String(raw).split('?')[0].split('#')[0].trim());
  } catch {
    return String(raw).split('?')[0].split('#')[0].trim();
  }
};

/** True for URLs / storage paths — false for bare filenames like "Screenshot.png". */
const looksLikeAttachmentRef = (raw) => {
  const s = String(raw || '');
  if (!s) return false;
  if (
    s.includes('://') ||
    s.includes('/attachments/file') ||
    s.includes('/storage/v1/object/') ||
    s.includes(ATTACHMENTS_PUBLIC_MARKER)
  ) {
    return true;
  }
  // storage-relative path e.g. sales-orders/123_file.png
  return s.includes('/') && /\.[a-z0-9]+$/i.test(s);
};

/** Collapse proxy URLs + direct Supabase URLs to the same storage path. */
const normalizeAttachmentIdentifier = (raw) => {
  if (!raw) return '';
  const str = String(raw).trim();
  if (!str) return '';

  if (str.includes('/attachments/file') && str.includes('path=')) {
    return normalizeUrlString(resolveAttachmentProxyPath(str));
  }

  const publicIdx = str.indexOf(ATTACHMENTS_PUBLIC_MARKER);
  if (publicIdx !== -1) {
    return normalizeUrlString(str.slice(publicIdx + ATTACHMENTS_PUBLIC_MARKER.length));
  }

  return normalizeUrlString(str);
};

const getAttachmentRecordId = (f) =>
  f?.id ?? f?.ID ?? f?.attachment_id ?? f?.request_attachment_id ?? null;

/** Prefer url/file_url; only use name when it is a URL/path (not a bare filename). */
const getAttachmentPrimaryRef = (f) => {
  if (!f) return '';
  if (f.url) return f.url;
  if (f.file_url) return f.file_url;
  if (looksLikeAttachmentRef(f.name)) return f.name;
  return '';
};

const attachmentFileKey = (f) => {
  const primary = getAttachmentPrimaryRef(f);
  if (primary) return normalizeAttachmentIdentifier(primary);
  // last resort: bare name (unique only when filenames differ)
  return normalizeAttachmentIdentifier(f?.name || '');
};

const attachmentMatches = (a, b) => {
  const idA = getAttachmentRecordId(a);
  const idB = getAttachmentRecordId(b);
  if (idA != null && idB != null && String(idA) !== '' && String(idB) !== '') {
    return String(idA) === String(idB);
  }

  const keyA = attachmentFileKey(a);
  const keyB = attachmentFileKey(b);
  return Boolean(keyA && keyB && keyA === keyB);
};

const pruneAttachmentMapsByFile = (map, fileToRemove) => {
  if (!fileToRemove || !map) return map || {};
  const next = { ...map };
  Object.keys(next).forEach((k) => {
    const arr = next[k];
    if (!Array.isArray(arr)) return;
    const filtered = arr.filter((f) => !attachmentMatches(f, fileToRemove));
    if (filtered.length === 0) {
      delete next[k];
    } else {
      next[k] = filtered;
    }
  });
  return next;
};

const sanitizeAvatarPoolFile = (file) => {
  if (!file) return null;
  const url = file.url || file.name;
  if (!url) return null;
  return {
    url,
    name: file.name || url,
    file_type: file.file_type,
    extension: file.extension,
    size: file.size,
    id: file.id ?? file.ID ?? file.attachment_id,
    preview: file.preview,
  };
};

const mergeFilesIntoAvatarPool = (pool, filesToAdd) => {
  const next = [...(pool || [])];
  (filesToAdd || []).forEach((file) => {
    const sanitized = sanitizeAvatarPoolFile(file);
    if (!sanitized) return;
    if (!next.some((f) => attachmentMatches(f, sanitized))) {
      next.push(sanitized);
    }
  });
  return next;
};

const collectAttachmentKeys = (attachmentMap) =>
  new Set(
    Object.values(attachmentMap || {})
      .flat()
      .map(attachmentFileKey)
      .filter(Boolean),
  );

const releaseFilesToAvatarPool = (files, productMap, serviceMap) => {
  const productKeys = collectAttachmentKeys(productMap);
  const serviceKeys = collectAttachmentKeys(serviceMap);
  return (files || []).filter((file) => {
    const key = attachmentFileKey(file);
    if (!key) return false;
    return !productKeys.has(key) && !serviceKeys.has(key);
  });
};

// const getStatusColorAndLabel = (status,installationStatus,allInstallationCompleted,accepted,min_payment_status,project_category,billing_type,installationCompleteStatus) => {
// console.log('project_categoryproject_category',project_category)
//   switch (status) {
//     case 0:
//       return { color: 'error', label: 'Status: Removed' };
//     case 1:
//       return { color: 'warning', label: 'Status: Draft' };
//     case 2:
//       return { color: 'info', label: 'Status: Open' };
//     case 3:
//       // return { color: 'primary', label: 'Status: Accepted' }; // Evaluating
//       // return { color: `${min_payment_status==0? 'warning' :'primary'}`, label: `Status: ${min_payment_status==1? 'Approved and Paid' :'Approved & Awaiting for Payment'}` }
//       return { color: 
//         `${project_category == 'No Charge'? "primary" 
//           : min_payment_status==0? 'warning' :'primary'}`,
//            label: `Status: ${
//        ( project_category == 'No Charge' || billing_type==0)
//           ? 'Approved'
//           : min_payment_status == 1
//           ? 'Approved and Paid'
//           : 'Approved and Payment Due'
//       }` }
//     case 4:
//       // return { color: empty(accepted) ? 'warning' : 'success', label: empty(accepted) ? 'Installation completed & Awaiting approval' : !empty(allInstallationCompleted) ? 'Completed & Accepted' : !empty(installationStatus) ? 'Status: Installation' : 'Status: In Production' }; // return { color: 'primary', label: 'Status: Converted to Job' };
//       return { color: (empty(accepted) && !empty(allInstallationCompleted)) ? 'warning' : 'success', label: (empty(accepted) && !empty(allInstallationCompleted)) ? 'Installation completed & Awaiting approval' : (!empty(accepted) && !empty(allInstallationCompleted)) ? 'Completed' : !empty(installationStatus) ? 'Status: Installation' : 'Status: In Production' }; // return { color: 'primary', label: 'Status: Converted to Job' };
//     case 5:
//       return { color: 'warning', label: 'Status: Closed' };
//     case 6:
//       return { color: 'error', label: 'Status: Rejected' };
//     default:
//       return { color: 'default', label: 'Status: Open' };
//   }
// };


const catalogBuildOrderOptionsArray = [
  { id: 1, name: 'Inhouse',},
  { id: 2, name: 'Traffic Catalog', },
  { id: 3, name: 'Sub Contract', },
]


const markupTypes = [
  { id: 1, name: 'Wholesale Markup' },
  { id: 2, name: 'Retail Markup' }
]

const marketingAdjustmentType = [
  { id: 1, name: '%' },
  { id: 2, name: '$' },
  // { id: 3, name: '¢' }
];

const paymentModeOptions = [
  { id: 0, name: 'Cash' },
  { id: 1, name: 'Check' },
  { id: 2, name: 'Debit Card' },
  { id: 3, name: 'Credit Card' },
  { id: 4, name: 'Consignment' },
];

const catalogTypes = [
  { id: 'in_stock', label: 'In Stock',inhouse:4,isTrafficCatalog:false },
  { id: 'client_owned', label: 'Client Owned',inhouse:5 ,isTrafficCatalog:false},
  { id: 'traffic', label: 'Traffic',inhouse:1 ,isTrafficCatalog:true}
]

const formatProjectAddress = (project) => {
  if (!project) return 'No address available';
  const addressParts = [project.address, project.city, project.state, project.zip]
    .map((part) => (part || '').toString().trim())
    .filter(Boolean);
  return addressParts.length > 0 ? addressParts.join(', ') : 'No address available';
}

/** Group marketing: DB stores 1 = positive, 0 = negative (must not use || when loading). */
const parseGroupMarketingAdjValueTypeFromDb = (raw) => {
  if (raw === 0 || raw === false || raw === '0') return 0
  if (raw === 1 || raw === true || raw === '1') return 1
  if (raw != null && raw !== '') return Number(raw) === 0 ? 0 : 1
  return 1
}

const getGroupProductMarketingStateFromApi = (group) => ({
  adjustment: Number(
    group?.product_marketing_adjustment ?? group?.productMarketingAdjustment ?? 0,
  ),
  adjValueType: parseGroupMarketingAdjValueTypeFromDb(
    group?.product_marketing_adj_value_type ?? group?.productMarketingAdjValueType,
  ),
})

const getGroupInstallMarketingStateFromApi = (group) => ({
  adjustment: Number(
    group?.install_marketing_adjustment ?? group?.installMarketingAdjustment ?? 0,
  ),
  adjValueType: parseGroupMarketingAdjValueTypeFromDb(
    group?.install_marketing_adj_value_type ?? group?.installMarketingAdjValueType,
  ),
})

const selectInputValue = (event) => {
  const input = event.target
  setTimeout(() => {
    if (input?.select) {
      input.select()
    }
  }, 0)
}

// Catalog types for split orders (all types + All option)
const splitOrderCatalogTypes = [
  { id: 'all', label: 'All',inhouse:null ,isTrafficCatalog:null},
  { id: 'in_stock', label: 'In Stock',inhouse:4,isTrafficCatalog:false },
  { id: 'client_owned', label: 'Client Owned',inhouse:5 ,isTrafficCatalog:false},
  { id: 'traffic', label: 'Traffic',inhouse:1 ,isTrafficCatalog:true},
  { id: 'production_catalog', label: 'Production Catalog',inhouse:1 ,isTrafficCatalog:false},
  { id: 'split_catalog', label: 'Split Catalog',inhouse:6 ,isTrafficCatalog:false},
  { id: 'estimate_catalog', label: 'Estimate Catalog',inhouse:7 ,isTrafficCatalog:false}
]

const getMaterialMaxNegativeAdjustment = (item, hasPermission) => {
  // Quantity and location quantities
  const qty = Number(item.quantity) || 1;
  const formulaEach = Number(item.price)
  const retailEachBase = Number(item.markUpCost)
  const formulaTotal = formulaEach * qty ;
  const retailTotal = retailEachBase * qty ;

  // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
  // const maxNegative = Math.max(0, retailTotal - formulaTotal);
  let maxNegative = Math.max(0, retailEachBase - formulaEach);
  if (hasPermission) {
    maxNegative = retailEachBase;
  }
  // console.log('getMaxNegativeAdjustment1-item--', item);
  // console.log('getMaxNegativeAdjustment1-formulaEach--', formulaEach);
  // console.log('getMaxNegativeAdjustment1-retailEachBase--', retailEachBase);
  // console.log('getMaxNegativeAdjustment1-qty--', qty);
  // console.log('getMaxNegativeAdjustment1-formulaTotal--', formulaTotal);
  // console.log('getMaxNegativeAdjustment1-retailTotal--', retailTotal);
  // console.log('getMaxNegativeAdjustment1-maxNegative--', maxNegative);

  return maxNegative.toFixed(2);
};
// Helper: calculate max allowed negative adjustment based on Product Formula Cost
const getMaxNegativeAdjustment = (item, hasPermission) => {
  const qty = Number(item.quantity) || 1;
  const locQty = Number(item.locationQuantity) || 1;

  // Product Formula Cost per unit
  // const formulaEach = Number(item.formula_cost ?? item.expected_cost ?? 0);
  const formulaEach = item?.inhouse === 0 ? Number(item?.sub_contract_price || 0) : Number((item?.expected_material_cost_with_markup || 0) + (item?.expected_service_cost_with_markup || 0));
  const formulaTotal = formulaEach * qty * locQty;

  // Base retail each BEFORE marketing adjustment
  const retailEachBase = Math.max(
    0,
    Number(
      item.original_actual_retail_price ??
      item.original_retail_price ??
      item.actual_retail_price ??
      item.retail_price ??
      item.product_retail_price ??
      0
    )
  );
  const retailTotal = retailEachBase * qty * locQty;

  // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
  // const maxNegative = Math.max(0, retailTotal - formulaTotal);
  let maxNegative = Math.max(0, retailEachBase - formulaEach);
  if (hasPermission) {
    maxNegative = retailEachBase;
  }
  console.log('getMaxNegativeAdjustment-maxNegative--',maxNegative)
  return { maxNegative, formulaTotal, retailTotal };
};

const getMaxNegativeInstallAdjustment = (data, hasPermission) => {
  const formula = Number(data?.expected_install_labor_cost_with_markup) || 0;
  const retail = Math.max(
    0,
    Number(data?.original_install_cost) || Number(data?.install_cost) || 0,
  );
  const qty = Number(data?.install_quantity) || 1;
  const locQty = Number(data?.locationQuantity) || 1;

  const totalFormula = formula * qty * locQty;
  const totalRetail = retail * qty * locQty;
  // console.log('getMaxNegativeInstallAdjustment-data--',data)
  // console.log('getMaxNegativeInstallAdjustment-formula--',formula)
  // console.log('getMaxNegativeInstallAdjustment-retail--',retail)
  // console.log('getMaxNegativeInstallAdjustment-qty--',qty)
  // console.log('getMaxNegativeInstallAdjustment-locQty--',locQty)
  // console.log('getMaxNegativeInstallAdjustment-totalFormula--',totalFormula)
  // console.log('getMaxNegativeInstallAdjustment-totalRetail--',totalRetail)

  if (hasPermission) {
    return retail;
  }
  return Math.max(0, retail - formula);
  // return Math.max(0, totalRetail - totalFormula);
};

const isNegativeAdjustmentMode = (value) =>
  value === false || value === 0 || value === '0' || value === 'false';


// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

const generatePDFFile = async () => {
  const element = printableContentRef.current;

  const canvas = await html2canvas(element, {
    scale: 2, // good quality
    useCORS: true,
  });

  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a3"); // A3 like your print

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

  const pdfBlob = pdf.output("blob");

  return pdfBlob; // return for upload
};

export default function ViewofficialRequest({popupOn,idOfProject,isEditSalesOrder,closeView,setRenderCards = () => {},renderCards,onDataChange = () => {}, openServiceNote,setOpenServiceNote,fromSplitEstimate,isFromCompletedTab,openEmailModal,setOpenEmailModal,heading,setHeading = () => {},handleOpenViewSalesOrder,mainCurrentTab, headerStepBackRef, onExitSalesOrderEditMode, combineGroupedInvoice = false}) {

  // console.log("tsssssssssssssssssssssssssssssssssss", openEmailModal);
// openInvoice



  const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
  const theme = useTheme()
  const { id:ids } = useParams()
  const id =popupOn ? idOfProject :ids
  const user = JSON.parse(localStorage.getItem('user'))
  
  let isClient =user?.isClient

  let userType = isClient ? 3 : user.user_type
  let userId = user.user_id
let teamId = user?.team_id? user.team_id : null
  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }

  const location = useLocation();
  const fromSplitSalesOrder = location.state?.fromSplitEstimate || fromSplitEstimate || false;
  const isFromProjects = location.state?.fromProjects || false;
  const isFromDashboard = location.state?.newTab || false;
  const communitySalesOrderStorageKey = id ? `viewOfficialFromCommunitySalesOrder_${id}` : null
  const communityRfqBackStorageKey = id ? `viewOfficialCommunityRfqBack_${id}` : null
  const communityInstallsStorageKey = id ? `viewOfficialFromCommunityInstalls_${id}` : null
  const communityInstallsBackStorageKey = id ? `viewOfficialCommunityInstallsBack_${id}` : null
  useEffect(() => {
    if (!id) return
    if (location?.state?.fromCommunitySalesOrder) {
      sessionStorage.setItem(`viewOfficialFromCommunitySalesOrder_${id}`, '1')
      const listState = location.state?.communityRfqListState
      if (listState && communityRfqBackStorageKey) {
        try {
          sessionStorage.setItem(communityRfqBackStorageKey, JSON.stringify(listState))
        } catch (e) {
          /* ignore */
        }
      }
    }
    if (location?.state?.fromCommunityInstalls) {
      sessionStorage.setItem(`viewOfficialFromCommunityInstalls_${id}`, '1')
      const listState = location.state?.communityInstallsListState
      if (listState && communityInstallsBackStorageKey) {
        try {
          sessionStorage.setItem(communityInstallsBackStorageKey, JSON.stringify(listState))
        } catch (e) {
          /* ignore */
        }
      }
    }
  }, [
    location?.state?.fromCommunitySalesOrder,
    location?.state?.communityRfqListState,
    location?.state?.fromCommunityInstalls,
    location?.state?.communityInstallsListState,
    id,
    communityRfqBackStorageKey,
    communityInstallsBackStorageKey,
  ])

  const isFromCommunityInstalls =
    Boolean(location?.state?.fromCommunityInstalls) ||
    Boolean(communityInstallsStorageKey && sessionStorage.getItem(communityInstallsStorageKey) === '1')

  const isFromCommunitySalesOrder =
    !isFromCommunityInstalls &&
    (Boolean(location?.state?.fromCommunitySalesOrder) ||
    Boolean(communitySalesOrderStorageKey && sessionStorage.getItem(communitySalesOrderStorageKey) === '1'))

  const isFromCommunityList = isFromCommunityInstalls || isFromCommunitySalesOrder

  const edit = popupOn ? isEditSalesOrder : !!(location.state && !isFromProjects && !isFromCommunityList);
  const explodedPermissions = user?.exploded_permissions
  const hasEditPermission = explodedPermissions?.some(permission => ['Edit Request'].includes(permission)) ? true : false
  const  hasEditFinalInvoicePermission = explodedPermissions?.some(permission => ['Edit Final Invoice'].includes(permission)) ? true : false
  // Manual: can ON/OFF when not lead-time locked; cannot turn OFF under lead-time lock
  const canManuallyToggleRushFee = !!explodedPermissions?.some((permission) =>
    ['Manage Rush Fee Toggle'].includes(permission),
  )
  // Override: full authority (manual + can turn OFF under lead-time lock); independent of Manual
  const canOverrideRushFeeLock = !!explodedPermissions?.some((permission) =>
    ['Override Rush Fee'].includes(permission),
  )
  const canControlRushFee = canManuallyToggleRushFee || canOverrideRushFeeLock
  let editState = (userType == 3 || (!isAdminUser (userType) && !hasEditPermission) || isFromDashboard) ? false : !!(location.state && !isFromProjects && !isFromCommunityList);  
  // const edit = false
  console.log('useruservuser',user)
  console.log('popupOn=isEditSalesOrder===',isEditSalesOrder,editState,isFromDashboard)
  console.log('popupOn=state===',useLocation().state)

  const componentRef = useRef();
  const productInputValueRef = useRef(''); // Track product autocomplete input value for production builds
  const rushFeeSyncRefs = useRef(createRushFeeSyncRefs());
  const [facilityProductInputs, setFacilityProductInputs] = useState({});
  const prevSplitFacilityIdsRef = useRef(null); // Track split facilities to only cleanup on removal
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();
  const [currentRFQData, setCurrentRFQdata] = useState({})
  console.log('currentRFQData', currentRFQData)
  const [nameFileds, setNameFileds] = useState({
    name: '',
    po_number: '',
    description: '',
    notes: '',
  })
  const [fieldErrors, setFieldErrors] = useState({})
  console.log('-nameFiledsnameFileds', nameFileds)
  const [openEdit, setOpenEdit] = useState(false)
  const [showServices, setShowServices] = useState(true)
  const [selectedProducts, setSelectedProducts] = useState([])
  console.log('selectedProducts++++++++', selectedProducts)
  const [initialServiceCostInProductFormula, setInitialServiceCostInProductFormula] = useState(0)
  const [markupType, setMarkupType] = useState();
  const [clientApprove , setClientApprove] = useState()
  const [managerApprovalRequired, setManagerApprovalRequired] = useState(0)
  const [showManagerApprovalToggle, setShowManagerApprovalToggle] = useState(true)
  const [isManagerApprovalLocked, setIsManagerApprovalLocked] = useState(false)
  const [designs, setDesigns] = useState([])
  const [details, setDetails] = useState(null)
  console.log('detailsdetailsdetails', details)
  const isGroupedRequest = Number(details?.is_grouped_request || 0) === 1;
  const isGroupedInvoiceCombined = Number(details?.is_grouped_invoice_combined || 0) === 1;
  const isDedicatedGroupedParent = isGroupedRequest && !isGroupedInvoiceCombined;
  const effectiveCombineGroupedInvoice = isDedicatedGroupedParent ? false : Boolean(combineGroupedInvoice);
  const isGroupedCombinedView = Boolean(effectiveCombineGroupedInvoice) && (isGroupedRequest || isGroupedInvoiceCombined);
  const isGroupedSalesOrderView = isGroupedRequest || isGroupedInvoiceCombined || isGroupedCombinedView;
  const canShowGroupedParentSalesOrderActions = !isGroupedCombinedView || isDedicatedGroupedParent;
  const [taxRateData, setTaxRateData] = useState([])
  const [totalTaxRate, setTotalTaxRate] = useState(0)




  useEffect(() => {
    if (!currentRFQData) return
    setNameFileds({
      name: currentRFQData?.name ?? '',
      po_number: currentRFQData?.po_number ?? '',
      description: currentRFQData?.description ?? '',
      notes: currentRFQData?.notes ?? '',
    })
  }, [currentRFQData])
  const [unlinkedLocations, setUnlinkedLocations] = useState([])
  
  // State for change detection
  const [initialProducts, setInitialProducts] = useState([])
  const [initialServices, setInitialServices] = useState([])
  const [initialMaterials, setInitialMaterials] = useState([])
  const [initialRfpProducts, setInitialRfpProducts] = useState([])
  const [initialRfpServices, setInitialRfpServices] = useState([])
  const [showChangesDialog, setShowChangesDialog] = useState(false)
  const [pendingSubmission, setPendingSubmission] = useState(null)
  const [detectedChanges, setDetectedChanges] = useState([])
  console.log('setDetails+++++++++++++++++', details)
  const [skills, setSkill] = useState(null)
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null)
  const [changeOrderReason, setChangeOrderReason] = useState('')
  const [openChangeOrderReasonDialog, setOpenChangeOrderReasonDialog] = useState(false)
  const [workflow, setWorkFlow] = useState(null)
  const [allProducts, setAllproducts] = useState(null)
  const [invoice, setInvoice] = useState(null)
  console.log('invoiceinvoice', invoice)
  const [open, setIsOpen] = useState(false)
  const [totalsum, setTotalSum] = useState(0);
  const [rfqSubTotal, setRFQSubTotal] = useState(0);
  const [DiscountTotal, setDiscountTotal] = useState(0);
  const [totalWholesalePrice, setTotalWholesalePrice] = useState(0);
  const [totalRetailPrice, setTotalRetailPrice] = useState(0);
  const [totalProductFormula, setTotalProductFormula] = useState(0);
  const [addClient, setAddClient] = useState(false)
  const [addVendor, setAddVendor] = useState(false)
  const [addProposal, setAddProposal] = useState(false)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [requestAccept, setRequestAccept] = useState(false)
  const [requestReject, setRequestReject] = useState(false)
  const [allClients, setAllClients] = useState(null)
  const [allClientsEdit, setAllClientsEdit] = useState(null)
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'));
  const [currentTab, setCurrentTab] = useState(user.isVendor ? 'Details' : 'Sales Order Details')
  const {
    hasNew: designNotesHasNew,
    clearNew: clearDesignNotesNew,
  } = useJobNoteTabUnread({
    requestId: id,
    designOrderId: details?.design_order_id || null,
    noteType: 'design',
    userId: user?.user_id,
    // Wait for details so design_order_id is known — avoids NEW flash on open
    enabled: !user?.isVendor && user?.user_type !== 3 && details != null,
    isActiveTab: currentTab === 'Design Notes',
    activeTab: currentTab,
  })
  const {
    hasNew: jobNotesHasNew,
    clearNew: clearJobNotesNew,
  } = useJobNoteTabUnread({
    requestId: id,
    designOrderId: details?.design_order_id || null,
    noteType: 'job',
    userId: user?.user_id,
    enabled: !user?.isVendor && user?.user_type !== 3 && details != null,
    isActiveTab: currentTab === 'Job Notes',
    activeTab: currentTab,
  })
  const [openPreview, setOpenPreview] = useState(false)
  const [openConvertToRFQ, setOpenConvertToRFQ] = useState(false)
  const [openDuplicate,setOpenDuplicate] = useState(false)
  const [skipNoChargeCheck, setSkipNoChargeCheck] = useState(false)
  const [isSavingNoChargeReason, setIsSavingNoChargeReason] = useState(false)
  const [avatarUrl, setAvatarUrl] = useState([])
  const [openDelete, setOpenDelete] = useState(false)
  const [openJobCostPopup, setOpenJobCostPopup] = useState(false)
  const [jobCostProjectId, setJobCostProjectId] = useState(null)
  const [recipeCostCurrentTab, setRecipeCostCurrentTab] = useState('Labor')
  const [openVoid, setOpenVoid] = useState(false)
  const [openReopenVoid, setOpenReopenVoid] = useState(false)
  const [voidReason, setVoidReason] = useState('')
  const [voidReasonError, setVoidReasonError] = useState('')
  const [reOpen, setReopen] = useState(false)
  const [confirmInvoice, setConfirmInvoice] = useState(false)
  const [openGroupedQbWarning, setOpenGroupedQbWarning] = useState(false)
  const [groupedQbSyncIssues, setGroupedQbSyncIssues] = useState([])
  const [checkingGroupedQbSync, setCheckingGroupedQbSync] = useState(false)
  const [confirmManagerAccept, setConfirmManagerAccept] = useState(false)
  const [openJobTypeWarning, setOpenJobTypeWarning] = useState(false)
  const [jobTypeWarningMessage, setJobTypeWarningMessage] = useState('Unable to approve or reject this sales order.')
  const [orderTypeSelection, setOrderTypeSelection] = useState(false)
  const [selectedOrderType, setSelectedOrderType] = useState('1')
  const [convertToRFQ, setConvertToRFQ] = useState(false)
  const [invoiceReject, setRejectInvoice] = useState(false)
  // const [reqAcceptClient,setReqAcceptClient] = useState(false)
  const [reason, setReason] = useState('')
  const [rejectFile, setRejectFile] = useState(null)
  const [isUploadingRejectFile, setIsUploadingRejectFile] = useState(false)
  const [isSubmittingReject, setIsSubmittingReject] = useState(false)
  const [acceptedClients, setAcceptedClients] = useState(null)
  const [jobNoteMembers, setJobNoteMembers] = useState(null)
  console.log('accccccccccccc',acceptedClients)
  const [updates, setUpdates] = useState(null)
  const [isSaving, setIsSaving] = useState(false)
  const [previewData, setPreviewData] = useState({})
  const [locationStates, setLocationStates] = useState({});
  const [serviceOnlyLocationStates, setServiceOnlyLocationStates] = useState({});
  const [payments, setPayments] = useState(null)
  const [projectTypes, setProjectTypes] = useState([]);
  const [projectCategories, setProjectCategories] = useState([]);
  const [noChargeType, setNoChargeType] = useState([]);
  const [isCommunityLoading, setIsCommunityLoading] = useState(false);
  const [communities, setCommunities] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [refreshData, setRefreshData] = useState(false)
  const ref = useRef()
  const [openWorkflow, setWorkflowOpen] = useState(false)
  const [manual, setManual] = useState(false)
  const [signAgreements, setSignAgreements] = useState(null)
  const [portfolio, setPortfolio] = useState(null)
  const [customTemplate, setCustomTemplate] = useState(null)
  const [questionnaireTemplate, setQuestionnaireTemplate] = useState(null)
  const [allDataEmpty, setDataEmpty] = useState(true)
  const [proposalData, setProposalData] = useState(null)
  const [teamMembers, setTeamMember] = useState([])
  const [allTeamMembers, setAllTeamMembers] = useState([])
  console.log('allTeamMembersallTeamMembers', allTeamMembers)
  const [customerData, setCustomerData] = useState([])
  const [labourCostServices, setLabourCostServices] = useState([])
  console.log('labourCostServicesssssss', labourCostServices)
  const [designersList, setDesignersList] = useState([])
  // console.log('designersList', designersList)
  const [selectedServices, setSelectedServices] = useState([]);
  const [labourInstallService, setLabourInstallService] = useState([]);
  const [invoiceSelectedServices, setInvoiceSelectedServices] = useState([]);
  // console.log('invoiceSelectedServices', invoiceSelectedServices)
  const [filteredServices, setFilteredServices] = useState([])
  const [requestServices, setRequestServices] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingEdit, setLoadingEdit] = useState(false) 
  const [loadingEditInvoice, setLoadingEditInvoice] = useState(false) 
  const [loadingEditData, setLoadingEditData] = useState(false)
  const [budget, setBudget] = useState(0)
  const [totalMarkupPercentage, setTotalMarkupPercentage] = useState(0)
  const [totalMarkupAmount, setTotalMarkupAmount] = useState(0)
  const [changeOccurredPSJ, setChangeOccurredPSJ] = useState(false);
  const printableContentRef = useRef();
  const socketRef = useRef(null);
  const [billingTypes, setBillingTypes] = useState([]);
  const [depositAndProgressBilling, setDepositAndProgressBilling] = useState(false);
  const [depositProgressBillingRows, setDepositProgressBillingRows] = useState([{ title: '', amount: '', markAsPaid: 0 }]);
  const [openDepositPaymentModeDialog, setOpenDepositPaymentModeDialog] = useState(false);
  const [openDepositPaymentModeWarningDialog, setOpenDepositPaymentModeWarningDialog] = useState(false);
  const [submitAfterDepositPaymentModeWarning, setSubmitAfterDepositPaymentModeWarning] = useState(false);
  const [selectedDepositPaymentModeRow, setSelectedDepositPaymentModeRow] = useState(null);
  const [selectedDepositPaymentMode, setSelectedDepositPaymentMode] = useState(null);
  const [isSavingDepositPaymentMode, setIsSavingDepositPaymentMode] = useState(false);
  const [initialBillingType,setInitialBillingType] = useState(null)

useEffect(() => {
if (typeof setHeading === 'function') {
setHeading(details?.name);
}
}, [details?.name, setHeading]);

  const handlePrintA3 = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @page { size: A3; margin: 12mm; }
      body { font-family: 'Public Sans', sans-serif; font-size: 12pt; }
      table { width: 100%; border-collapse: collapse; }
      #right { text-align: right; margin-top: -200px; }
      #total { text-align: right; display:flex; justify-content: flex-end; }
      #subtotal { text-align: left; }
      #discount { text-align: left; word-wrap: break-word; margin-right: 100px; }
      #totalmain { text-align: left; }
      #subtotal1 { text-align: left; }
      #discount1 { text-align: left; word-wrap: break-word; margin-right: 30px; }
      #totalmain1 { text-align: left; }
      .sales-order-heading-print { text-align: center; width: 100%; position: absolute; left: -60px; top: -20px; }
      #total1 { text-align: right; display:flex; justify-content: flex-end; margin-top: -320px; }
      #logoImage { height: 100px; width:100px; }
      #order, #title, #orderID, #to { margin-bottom:-20px; }
    `,
  });

  const handlePrintPreview = useReactToPrint({
    content: () => printableContentRef.current,
    pageStyle: `@media print {
      .print-black { color: black !important; background:white !important; }
      table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
      * { color: black !important; background-color: white !important; }
      .MuiTableCell-root { color: black !important; }
      .MuiInputBase-input { color: black !important; }
      .no-scrollbar::-webkit-scrollbar { display: none; }
      .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      .enable-for-print { pointer-events: auto; color: black !important; }
      .print-black .enable-for-print input[type='number'],
      .print-black .enable-for-print input[type='text'] { color: black !important; }
      .css-wr96yv-MuiInputBase-input-MuiOutlinedInput-input { color: black !important; opacity: 1; -webkit-text-fill-color:black !important; }
      input[type=number] { color:black !important; }
    }`,
  });
  const [showAllCollaborators, setShowAllCollaborators] = useState(false);
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([]);
  // console.log('additionalSelectedServices----', additionalSelectedServices)
  const [isLoadingInvoice, setIsLoadingInvoice] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingVoid, setLoadingVoid] = useState(false);
  const [loadingReopenVoid, setLoadingReopenVoid] = useState(false);
  const [catalogBuildOrderOptions, setCatalogBuildOrderOptions] = useState(catalogBuildOrderOptionsArray);
  localStorage.setItem('requestId', id ? id : null)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  console.log('setOpenHoldPopup', openHoldPopup)
  const [holdReason, setHoldReason] = useState('');
  const [isSubmittingHold, setIsSubmittingHold] = useState(false);
  const [holdReasonError, setHoldReasonError] = useState('');
  const [openInvoiceEmailModal, setOpenInvoiceEmailModal] = useState(false);
  const [invoicePdfData, setInvoicePdfData] = useState(null);
  // Print/preview ready only after products + additional services are wired
  const [invoicePreviewReady, setInvoicePreviewReady] = useState(false);
  const [isMirrored, setIsMirrored] = useState(false);
  const [mirrorApproved, setMirrorApproved] = useState(false);
  const [splitIntiator, setSplitIntiator] = useState(false);
  const [salesRepName, setSalesRepName] = useState('');
  const [salesRepId, setSalesRepId] = useState(null);
  const [allSalesRepIds, setAllSalesRepIds] = useState('');
  const [allCommunities, setAllCommunities] = useState([]);

  const hasMarkupPermission = explodedPermissions?.some(permission => ['View Markup'].includes(permission)) ? true : false
  const hasDiscountPermission = explodedPermissions?.some(permission => ['Manage Discount'].includes(permission)) ? false : true
  const [showWarning, setShowWarning] = useState(selectedServices.map(() => false));
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [allServiceLocationSame, setAllServiceLocationSame] = useState(true)
  const [allRfpServiceLocationSame, setAllRfpServiceLocationSame] = useState(true)
  const [allRfpProductsLocationSame, setAllRfpProductsLocationSame] = useState(true)
  const [indexCounter, setIndexCounter] = useState(0)
  const [serviceIndexCounter, setServiceIndexCounter] = useState(0)
  const [totalLabourCost, setTotalLabourCost] = useState(0)
  const [totalProductLabourCost, setTotalProductLabourCost] = useState(0)
  const [totalProductInstallCost, setTotalProductInstallCost] = useState(0)
  const [checkLength,setCheckLength]= useState(false)
  let productFormulaCost = 0
  const [rfps, setRfps] = useState([]); // List of RFPs
  const [selectedRfp, setSelectedRfp] = useState(null); // Selected RFP
  const [openModal, setOpenModal] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [rfpServices, setRfpServices] = useState([]);
  const [rfpProducts, setRfpProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [cartService, setCartService] = useState([]);
  const [rfpServicesEdit, setRfpServicesEdit] = useState([]);
  const [rfpLocationStates, setRfpLocationStates] = useState({});
  const [rfpServiceLocationStates, setRfpServiceLocationStates] = useState({});
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  console.log('selectedMaterials++++++++++++++++++', selectedMaterials)
  const [materials, setAllMaterials] = useState([]);
  const [openProductNote, setOpenProductNote] = useState({});
  const [openInstallNote, setOpenInstallNote] = useState({});
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [isClearingNote, setIsClearingNote] = useState(false);
  const [currentNote, setCurrentNote] = useState('');
  const [productAttachments, setProductAttachments] = useState({}) // Store attachments per product by indexId
  const [openProductFormulaModal, setOpenProductFormulaModal] = useState(false);
  const [selectedProductFormulaId, setSelectedProductFormulaId] = useState(null);
  const [isUploadingProduct, setIsUploadingProduct] = useState({}) // Track upload state per product
  const [productAttachmentDragOver, setProductAttachmentDragOver] = useState({})
  const [openProductAttachment, setOpenProductAttachment] = useState({}) // Track open state for attachment modal per product
  const [attachmentTabValue, setAttachmentTabValue] = useState({}) // Track tab value per product attachment modal
  const [selectedUploadedImages, setSelectedUploadedImages] = useState({}) // Track selected images from avatarUrl per product
  const [serviceAttachments, setServiceAttachments] = useState({}) // Store attachments per service by indexId
  const [isUploadingService, setIsUploadingService] = useState({})
  const [serviceAttachmentDragOver, setServiceAttachmentDragOver] = useState({})
  const [openServiceAttachment, setOpenServiceAttachment] = useState({})
  const [attachmentTabValueService, setAttachmentTabValueService] = useState({})
  const [selectedUploadedImagesService, setSelectedUploadedImagesService] = useState({})
  const [selectedPDF, setSelectedPDF] = useState(null)
  const [selectedPDFFile, setSelectedPDFFile] = useState(null)
  const [openPDFModal, setOpenPDFModal] = useState(false)
  const [pdfLoading, setPdfLoading] = useState(true)
  const [useOfficeViewer, setUseOfficeViewer] = useState(true)

  const openAttachmentPreview = useCallback((file, url) => {
    setPdfLoading(true)
    setSelectedPDF(url)
    setSelectedPDFFile(file && typeof file === 'object' ? file : null)
    setOpenPDFModal(true)
    setUseOfficeViewer(true)
  }, [])
  const [error, setError] = useState(false);

  // Create local state for service notes if not provided as props
  const [localOpenServiceNote, setLocalOpenServiceNote] = useState({})
  const [localCurrentNote, setLocalCurrentNote] = useState('')
  const [localIsSavingNote, setLocalIsSavingNote] = useState(false)
  const [localIsClearingNote, setLocalIsClearingNote] = useState(false)

  // Use provided props or fall back to local state
  const serviceNoteState = openServiceNote !== undefined ? openServiceNote : localOpenServiceNote
  const setServiceNoteState = setOpenServiceNote !== undefined ? setOpenServiceNote : setLocalOpenServiceNote
  const serviceCurrentNote = currentNote || localCurrentNote
  const setServiceCurrentNote = setCurrentNote || setLocalCurrentNote
  const serviceIsSavingNote = isSavingNote || localIsSavingNote
  const setServiceIsSavingNote = setIsSavingNote || setLocalIsSavingNote
  const serviceIsClearingNote = isClearingNote || localIsClearingNote
  const setServiceIsClearingNote = setIsClearingNote || setLocalIsClearingNote
  const [taxAmount, setTaxAmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const getDepositProgressBillingBalanceDue = () =>
    Number(Math.max((Number(grandTotal) || 0) - (Number(details?.totalPaidAmount) || 0), 0).toFixed(2));

  const handleDepositProgressBillingChange = (index, field, value) => {
    if (field === 'amount') {
      setDepositProgressBillingRows((prevRows) => {
        const maxAmount = Math.max(
          (Number(grandTotal) || 0) -
            prevRows.reduce((sum, row, rowIndex) => (
              rowIndex === index ? sum : sum + (Number(row.amount) || 0)
            ), 0),
          0
        );
        const amount = value === ''
          ? ''
          : Number(value) > maxAmount
            ? maxAmount.toFixed(2)
            : value;

        return prevRows.map((row, rowIndex) =>
          rowIndex === index ? { ...row, [field]: amount } : row
        );
      });
      return;
    }

    setDepositProgressBillingRows((prevRows) =>
      prevRows.map((row, rowIndex) =>
        rowIndex === index
          ? { ...row, [field]: value, ...(field === 'markAsPaid' && Number(value) === 0 ? { paymentMode: null } : {}) }
          : row
      )
    );
  };

  const handleAddDepositProgressBillingRow = () => {
    setDepositProgressBillingRows((prevRows) => [...prevRows, { title: '', amount: '', markAsPaid: 0 }]);
  };

  const handleDeleteDepositProgressBillingRow = async (index) => {
    const rowToDelete = depositProgressBillingRows[index];

    if (rowToDelete?.id) {
      try {
        const res = await axios.post(`${REST_API}webservice/request/delete-payment`, {
          id: rowToDelete.id,
        });

        if (res.data.status === 1) {
          enqueueSnackbar('Payment deleted successfully', { variant: 'success' });
          if (typeof onDataChange === 'function') {
            onDataChange();
          }
        } else {
          enqueueSnackbar(res.data.message || 'Failed to delete payment', { variant: 'error' });
          return;
        }
      } catch (error) {
        console.error('Error deleting payment:', error);
        enqueueSnackbar('Error deleting payment', { variant: 'error' });
        return;
      }
    }

    setDepositProgressBillingRows((prevRows) =>
      prevRows.length === 1
        ? [{ title: '', amount: '', markAsPaid: 0 }]
        : prevRows.filter((_, rowIndex) => rowIndex !== index)
    );
  };

  const handleOpenDepositPaymentModeDialog = (row, index) => {
    setSelectedDepositPaymentModeRow({ row, index });
    setSelectedDepositPaymentMode(
      paymentModeOptions.find((option) => option.name === row.paymentMode) || null
    );
    setOpenDepositPaymentModeDialog(true);
  };

  const handleSaveDepositPaymentMode = () => {
    if (!selectedDepositPaymentMode) {
      setOpenDepositPaymentModeWarningDialog(true);
      return;
    }

    setDepositProgressBillingRows((prevRows) =>
      prevRows.map((currentRow, rowIndex) =>
        rowIndex === selectedDepositPaymentModeRow.index
          ? { ...currentRow, markAsPaid: 1, paymentMode: selectedDepositPaymentMode.name }
          : currentRow
      )
    );
    setOpenDepositPaymentModeDialog(false);
    setSelectedDepositPaymentModeRow(null);
    setSelectedDepositPaymentMode(null);
  };

  const getDepositProgressBillingTotal = (excludeIndex = null) =>
    depositProgressBillingRows.reduce((sum, row, rowIndex) => (
      rowIndex === excludeIndex ? sum : sum + (Number(row.amount) || 0)
    ), 0);

  const getDepositProgressBillingMaxAmount = (index) => {
    const maxAmount =
      (Number(grandTotal) || 0) - getDepositProgressBillingTotal(index);

    return Math.max(maxAmount, 0).toFixed(2);
  };

  // const canAddDepositProgressBillingRow = () =>
  //   getDepositProgressBillingTotal() < getDepositProgressBillingBalanceDue();
  const canAddDepositProgressBillingRow = () => {
  const total = Number(getDepositProgressBillingTotal() || 0);
  const grand = Number(grandTotal || 0);

  return total < grand;
};

  const validateDepositProgressBillingPaidAmount = async (rows, totalAmount) => {
    const paymentRows = Array.isArray(rows)
      ? rows.filter((row) => row?.title?.trim() && Number(row?.amount) > 0)
      : [];
    const markedAsPaidRows = paymentRows.filter((row) => Number(row?.markAsPaid) === 1);

    if (markedAsPaidRows.length === 0) {
      return { isValid: true, balanceAmount: Number(totalAmount) || 0 };
    }

    const res = await axios.post(`${REST_API_END_POINT}request/fetch-all-payments`, { request_id: id });
    const existingPayments = Array.isArray(res?.data?.payments) ? res.data.payments : [];
    const payloadPaymentIds = new Set(
      paymentRows.map((row) => Number(row?.id)).filter((paymentId) => paymentId > 0)
    );
    const existingPaidTotal = existingPayments.reduce((total, payment) => {
      if (payloadPaymentIds.has(Number(payment?.id))) {
        return total;
      }
      return total + (Number(payment?.amount) || 0);
    }, 0);
    const payloadPaidTotal = markedAsPaidRows.reduce(
      (total, row) => total + (Number(row?.amount) || 0),
      0
    );
    const balanceAmount = Number(((Number(totalAmount) || 0) - existingPaidTotal).toFixed(2));

    return {
      isValid: payloadPaidTotal <= balanceAmount + 0.005,
      balanceAmount: Math.max(balanceAmount, 0),
    };
  };
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
  const [data, setData] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [singleLocationCard,setSingleLocationCard] = useState(false)
  // const [backupProducts, setBackupProducts] = useState([]);
console.log('taxAmounttttt',taxAmount)
  const [openMakeTaskDialog,setOpenMakeTaskDialog] = useState(false)
  const [showMakeTaskErrorDialog,setShowMakeTaskErrorDialog] = useState(false)
  const [confirmMakeTask,setConfirmMakeTask] = useState(false)

  const [openDialog, setOpenDialog] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [formDatas, setFormDatas] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [noCharge, setNoCharge] = useState(false);
  
  const [mapServices,setMapServices]=  useState([]);
  const [mapServicesLoading, setMapServicesLoading] = useState(false);

  // Progress Modal States
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressRequestData, setProgressRequestData] = useState(null);
  const [socketReady, setSocketReady] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [progressHeading, setProgressHeading] = useState("Processing Sales Order");
  const [selectedMapserviceProducts, setSelectedMapserviceProducts] = useState([]);
    const [progress, setProgress] = useState(null)
    const [openDialogPartial,setOpenDialogPartial] = useState(false);
    const [openDialogNoStock,setOpenDialogNoStock] = useState(false);
    const [isUploading,setIsUploading] = useState(false)
    const [pendingProject, setPendingProject] = useState(null);
    const [stockType, setStockType] = useState(1);
    const [pendingMaterial, setPendingMaterial] = useState(null);
    const [partialProducts, setPartialProducts] = useState([]);
    const [finishedProducts, setFinishedProducts] = useState([]);
    const [convertionUnit, setConvertionUnit] = useState(0);
    const [pendingAutocompleteMaterials, setPendingAutocompleteMaterials] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMember, setIsMember] = useState(false);
    const [produtFormulaMaterial,setProductFormulaMaterial] = useState([])
    const [incomingSplitMarkup,setIncomingSplitMarkup] = useState(0)
    const [splitPercentage,setSplitPerscentage] = useState(0)
    const [splitManagementSettings,setSplitManagementSettings] = useState([])
    const [isSplitOrder,setIsSplitOrder] = useState(false)
    const [selectedSplitOrderSettings,setSelectedSplitOrderSettings] = useState([])
    const [refreshCalculation,setRefreshCalculation] = useState(false)
    const [customerOrderProductGroups, setCustomerOrderProductGroups] = useState([])
    const [openGroupedRows, setOpenGroupedRows] = useState({})
    const [groupProductMarketingValues, setGroupProductMarketingValues] = useState({})
    const [groupInstallMarketingValues, setGroupInstallMarketingValues] = useState({})
    const [groupProductRetailDrafts, setGroupProductRetailDrafts] = useState({})
    const [groupInstallRetailDrafts, setGroupInstallRetailDrafts] = useState({})
    const [groupNoteTargets, setGroupNoteTargets] = useState({})
    const [groupInstallNoteTargets, setGroupInstallNoteTargets] = useState({})

    const getProductGroupId = (product) => product?.group_id ?? product?.customer_order_product_group_id ?? product?.groupId ?? null;

    const getProductLineTotalExcludingInstall = (product) => {
      const quantity = Number(product?.quantity) || 1
      const locationQuantity = Number(product?.locationQuantity) || 1
      const installCost = Number(product?.install_cost) || 0
      let spma = Number(product?.product_retail_price || 0)
      if (Number(product?.material) === 1) {
        const adjustment = Number(product?.adjustment || 0)
        spma += Number(product?.adj_value_type) === 1 ? adjustment : -adjustment
      }
      if (installCost) {
        return (Number(product?.actual_retail_price) || 0) * (locationQuantity * quantity)
      }
      if (Number(product?.material) === 1) {
        return spma * locationQuantity
      }
      return spma * (locationQuantity * quantity)
    }

    const getProductDisplayTotal = (product) => {
      const quantity = Number(product?.quantity) || 1
      const locationQuantity = Number(product?.locationQuantity) || 1
      const installQty = Number(product?.install_qty ?? product?.install_quantity ?? 1) || 1
      const installCost = Number(product?.install_cost) || 0
      let spma = Number(product?.product_retail_price || 0)
      if (Number(product?.material) === 1) {
        const adjustment = Number(product?.adjustment || 0)
        spma += Number(product?.adj_value_type) === 1 ? adjustment : -adjustment
      }
      const productTotal = installCost
        ? (Number(product?.actual_retail_price) || 0) * (locationQuantity * quantity)
        : Number(product?.material) === 1
        ? spma * locationQuantity
        : spma * (locationQuantity * quantity)
      const installTotal = installCost * installQty
      return Number(productTotal || 0) + Number(installTotal || 0)
    }

    const groupedInvoiceDisplayRows = useMemo(() => {
      const rows = buildGroupedDesignOrderDisplayRows({
        designOrderProducts: invoice?.cust_product || [],
        customerOrderProductGroups,
        markupType: Number(markupType ?? details?.markup_type) || 2,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      })
      const isMaterialRow = (row) =>
        row?.__type === 'group'
          ? Number(row?.representative?.material) === 1
          : Number(row?.material) === 1
      return [...rows].sort((a, b) => Number(isMaterialRow(a)) - Number(isMaterialRow(b)))
    }, [
      invoice?.cust_product,
      customerOrderProductGroups,
      markupType,
      details?.markup_type,
      groupProductMarketingValues,
      groupInstallMarketingValues,
    ])

    const groupedTandMDisplayRows = useMemo(
      () =>
        buildGroupedDesignOrderDisplayRows({
          designOrderProducts: (invoice?.cust_product || []).filter((item) => item.material != 1),
          customerOrderProductGroups,
          markupType: Number(markupType ?? details?.markup_type) || 2,
          groupProductMarketingValues,
          groupInstallMarketingValues,
        }),
      [
        invoice?.cust_product,
        customerOrderProductGroups,
        markupType,
        details?.markup_type,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      ],
    )

    // NEW: Product line total for Invoice Preview footer — must match line-row / backend totals
    // (old version ignored product_total and adjustments, so Subtotal was wrong vs Total)
    const getInvoiceModalNonGroupProductTotal = useCallback((val) => {
      const {
        markAdjType,
        material = 0,
        adjustment = 0,
        // REMOVED: adj_value_type — was only used by old material path that double-applied adjustment
        // adj_value_type,
        actual_retail_price,
        product_retail_price,
        product_total, // NEW: needed so wholesale (markAdjType 1) uses stored DB line total
        locationQuantity = 1,
        quantity = 1,
      } = val || {}
      // NEW: Wholesale markup — use stored product_total (matches line rows / backend totals)
      // Old code recalculated SPMA * qty and undercounted vs invoice.grandTotal
      if (Number(markAdjType) === 1 && Number(material) !== 1) {
        return Number(product_total) || 0
      }
      // actual_retail_price already includes marketing adjustment (same as form Product Total).
      // Do not add `adjustment` again — that double-counts and inflates PRODUCT TOTAL.
      let basePriceForUnit = Number(actual_retail_price) || Number(product_retail_price) || 0;
      let SPMA = basePriceForUnit;
      if (Number(material) === 1) {
        SPMA = SPMA + (Number(val.adj_value_type) === 1 ? Number(adjustment || 0) : -Number(adjustment || 0));
        return Number(SPMA) * (Number(locationQuantity) || 1)
      }
      return Number(SPMA) * ((Number(locationQuantity) || 1) * (Number(quantity) || 1))
      // const basePrice =
      //   actual_retail_price !== 0 && actual_retail_price != null
      //     ? actual_retail_price
      //     : product_retail_price
      // let SPMA = markAdjType === 2 || markAdjType === 3 ? basePrice : basePrice
      // if (material === 1) {
      //   SPMA = Number(SPMA) + (Number(adj_value_type) === 1 ? Number(adjustment) : -Number(adjustment))
      // }
      // if (markAdjType === 1 && material === 0) {
      //   return SPMA * (locationQuantity * quantity) // undercounted: ignored product_total
      // }
      // return material === 1 ? SPMA * locationQuantity : SPMA * (locationQuantity * quantity)
    }, [])

    // NEW: Prefer stored install_total (same as backend); fall back to install_cost * qty
    const getInvoiceModalNonGroupInstallTotal = useCallback((val) => {
      if (!val) return 0
      if (Number(val?.install_qty) === 0) return 0
      const installTotalLine = parseFloat(val?.install_total || 0)
      if (installTotalLine) return installTotalLine
      const installCost = parseFloat(val?.install_cost || 0)
      const qty = parseFloat(val?.install_qty ?? val?.install_quantity ?? 1) || 1
      if (installCost) return installCost * qty
      return 0
    }, [])

    const invoiceModalProductTotalFromRows = useMemo(
      () =>
        (groupedInvoiceDisplayRows || []).reduce((sum, row) => {
          if (row?.__type === 'group') {
            // Match invoice table rows: group set-multiplier subtotal, not sum of member lines
            const groupHasInstall = Boolean(row?.groupHasInstall)
            return (
              sum +
              (groupHasInstall
                ? Number(row?.groupProductOnlyTotal ?? 0)
                : Number(row?.totalValue ?? 0))
            )
          }
          return sum + getInvoiceModalNonGroupProductTotal(row)
        }, 0),
      [groupedInvoiceDisplayRows, getInvoiceModalNonGroupProductTotal],
    )

    const invoiceModalInstallTotalFromRows = useMemo(
      () =>
        (groupedInvoiceDisplayRows || []).reduce((sum, row) => {
          if (row?.__type === 'group') {
            return sum + Number(row?.groupInstallSubtotal ?? 0)
          }
          return sum + getInvoiceModalNonGroupInstallTotal(row)
        }, 0),
      [groupedInvoiceDisplayRows, getInvoiceModalNonGroupInstallTotal],
    )

    const invoiceModalCustProductSubtotalForServices = useMemo(
      () => invoiceModalProductTotalFromRows + invoiceModalInstallTotalFromRows,
      [invoiceModalProductTotalFromRows, invoiceModalInstallTotalFromRows],
    )

    const findCustProductRowForLineCatalog = (product) => {
      const rows = invoice?.cust_product
      if (!product || !Array.isArray(rows) || rows.length === 0) return null
      const byIndex =
        product.indexId != null
          ? rows.find((r) => Number(r?.product_index) === Number(product.indexId))
          : null
      if (byIndex) return byIndex
      if (product.backendId != null) {
        return (
          rows.find((r) => r?.id != null && String(r.id) === String(product.backendId)) ||
          null
        )
      }
      return null
    }

    const isProductLineCatalog = (product) => {
      if (!product) return false
      if (Number(product.is_line_catalog) === 1) return true
      const row = findCustProductRowForLineCatalog(product)
      return Number(row?.is_line_catalog) === 1
    }

    const groupedSelectedProducts = useMemo(
      () =>
        computeGroupedProducts({
          selectedProducts,
          markupType,
          customerOrderProductGroups,
          groupProductMarketingValues,
          groupInstallMarketingValues,
          groupQuantityMode: GROUP_QUANTITY_MODE_SET_MULTIPLIER,
        }),
      [
        selectedProducts,
        markupType,
        customerOrderProductGroups,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      ],
    )

    const groupedSelectedProductsMap = useMemo(() => {
      return new Map((groupedSelectedProducts || []).map((g) => [String(g.id), g]))
    }, [groupedSelectedProducts])

    const groupedPreviewDisplayRows = useMemo(() => {
      const rows = buildGroupedDesignOrderDisplayRows({
        designOrderProducts: selectedProducts || [],
        customerOrderProductGroups,
        markupType: Number(markupType ?? details?.markup_type) || 2,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      })
      const isMaterialRow = (row) =>
        row?.__type === 'group'
          ? Number(row?.representative?.material) === 1
          : Number(row?.material) === 1
      return [...rows].sort((a, b) => Number(isMaterialRow(a)) - Number(isMaterialRow(b)))
    }, [
      selectedProducts,
      customerOrderProductGroups,
      markupType,
      details?.markup_type,
      groupProductMarketingValues,
      groupInstallMarketingValues,
    ])

    const groupedPreviewTandMDisplayRows = useMemo(
      () =>
        buildGroupedDesignOrderDisplayRows({
          designOrderProducts: (selectedProducts || []).filter((item) => item.material != 1),
          customerOrderProductGroups,
          markupType: Number(markupType ?? details?.markup_type) || 2,
          groupProductMarketingValues,
          groupInstallMarketingValues,
        }),
      [
        selectedProducts,
        customerOrderProductGroups,
        markupType,
        details?.markup_type,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      ],
    )

    const getGroupMemberIndexIdsByProductIndexId = useCallback(
      (productIndexId) => {
        const numId = Number(productIndexId)
        if (Number.isNaN(numId)) return []
        const product = (selectedProducts || []).find((p) => Number(p?.indexId) === numId)
        const gid = getProductGroupId(product)
        if (gid == null || gid === '') return [numId]
        const group = groupedSelectedProductsMap.get(String(gid))
        if (group?.products?.length) {
          const ids = group.products
            .map((p) => Number(p.indexId))
            .filter((id) => !Number.isNaN(id))
          if (ids.length) return ids
        }
        const ids = (selectedProducts || [])
          .filter((p) => String(getProductGroupId(p) || '') === String(gid))
          .map((p) => Number(p.indexId))
          .filter((id) => !Number.isNaN(id))
        return ids.length ? ids : [numId]
      },
      [selectedProducts, groupedSelectedProductsMap],
    )

    const getProductAttachmentsList = useCallback(
      (productIndexId) => {
        const numId = Number(productIndexId)
        const memberIds = getGroupMemberIndexIdsByProductIndexId(numId)
        if (memberIds.length <= 1) {
          return productAttachments[numId] || productAttachments[String(numId)] || []
        }
        const seen = new Set()
        const merged = []
        memberIds.forEach((mid) => {
          const list = productAttachments[mid] || productAttachments[String(mid)] || []
          list.forEach((f) => {
            const key = f?.url || f?.name
            if (key && !seen.has(key)) {
              seen.add(key)
              merged.push(f)
            }
          })
        })
        return merged
      },
      [productAttachments, getGroupMemberIndexIdsByProductIndexId],
    )

    const uploadDesignsDisplayFiles = useMemo(() => {
      const allProductAttachmentFiles = Object.values(productAttachments).flat()
      const allServiceAttachmentFiles = Object.values(serviceAttachments).flat()
      const productAttachmentKeys = new Set(
        allProductAttachmentFiles.map(attachmentFileKey).filter(Boolean),
      )
      const serviceAttachmentKeys = new Set(
        allServiceAttachmentFiles.map(attachmentFileKey).filter(Boolean),
      )

      const availableAvatarFiles = (avatarUrl || [])
        .filter((file) => {
          const fileKey = attachmentFileKey(file)
          return (
            (!fileKey || !productAttachmentKeys.has(fileKey)) &&
            (!fileKey || !serviceAttachmentKeys.has(fileKey))
          )
        })
        .map((file) => ({
          ...file,
          product_index_id: undefined,
          service_index_id: undefined,
          productNames: [],
          serviceNames: [],
          _productAttachment: false,
          _serviceAttachment: false,
          _groupAttachment: false,
        }))

      const mapProductAttachmentForDisplay = (file, product) => {
        if (!product) {
          return {
            ...file,
            url: file.url || file.name,
            name: file.name || file.url,
            location_ids: '',
            productNames: [],
            _productAttachment: true,
            _groupAttachment: false,
          }
        }
        const location_ids =
          product.location
            ?.map((loc) => loc.id || loc.request_location_id)
            .filter(Boolean)
            .join(',') || ''
        const productName = product.product_name || product.name || ''
        return {
          ...file,
          url: file.url || file.name,
          name: file.name || file.url,
          location_ids,
          productNames: productName
            ? [{ product_id: product.product_id || product.id, product_name: productName }]
            : [],
          _productAttachment: true,
          _groupAttachment: false,
        }
      }

      const mapGroupAttachmentForDisplay = (file, groupId, products) => {
        const group = groupedSelectedProductsMap.get(String(groupId))
        const groupName =
          group?.name ||
          products[0]?.group_name ||
          products[0]?.groupName ||
          'Group'
        const labelProduct = products[0]
        const location_ids =
          labelProduct?.location
            ?.map((loc) => loc.id || loc.request_location_id)
            .filter(Boolean)
            .join(',') || 'group'
        return {
          ...file,
          url: file.url || file.name,
          name: file.name || file.url,
          location_ids,
          productNames: [{ product_id: groupId, product_name: groupName }],
          _productAttachment: true,
          _groupAttachment: true,
        }
      }

      const productFilesByUrl = new Map()
      allProductAttachmentFiles.forEach((file) => {
        const fileKey = attachmentFileKey(file)
        if (!fileKey) return
        const product = (selectedProducts || []).find(
          (p) => Number(p?.indexId) === Number(file.product_index_id),
        )
        if (!productFilesByUrl.has(fileKey)) {
          productFilesByUrl.set(fileKey, { file, products: [] })
        }
        const entry = productFilesByUrl.get(fileKey)
        if (
          product &&
          !entry.products.some((p) => Number(p.indexId) === Number(product.indexId))
        ) {
          entry.products.push(product)
        }
      })

      const dedupedProductFiles = []
      productFilesByUrl.forEach(({ file, products }, fileKey) => {
        const filesForUrl = allProductAttachmentFiles.filter(
          (f) => attachmentFileKey(f) === fileKey,
        )
        const groupIds = [
          ...new Set(
            products
              .map((p) => getProductGroupId(p))
              .filter((gid) => gid != null && gid !== ''),
          ),
        ]
        const isSameGroup =
          groupIds.length === 1 &&
          products.length > 0 &&
          products.every(
            (p) => String(getProductGroupId(p) || '') === String(groupIds[0]),
          )
        const shouldShowAsGroup =
          isSameGroup && filesForUrl.length > 1

        if (shouldShowAsGroup) {
          dedupedProductFiles.push(
            mapGroupAttachmentForDisplay(file, groupIds[0], products),
          )
          return
        }

        filesForUrl.forEach((attachmentFile) => {
          const product = (selectedProducts || []).find(
            (p) => Number(p?.indexId) === Number(attachmentFile.product_index_id),
          )
          const gid = getProductGroupId(product)
          if (
            gid != null &&
            gid !== '' &&
            filesForUrl.length === 1 &&
            isSameGroup
          ) {
            dedupedProductFiles.push(
              mapGroupAttachmentForDisplay(attachmentFile, gid, products),
            )
          } else {
            dedupedProductFiles.push(
              mapProductAttachmentForDisplay(attachmentFile, product),
            )
          }
        })
      })

      const serviceFiles = allServiceAttachmentFiles.map((file) => {
        const svc =
          additionalSelectedServices?.find(
            (s) => String(s.indexId) === String(file.service_index_id),
          ) || null
        const serviceName = svc?.name || ''
        const fileUrl = file.url || file.name
        return {
          ...file,
          url: fileUrl,
          name: file.name || fileUrl,
          serviceNames: serviceName ? [{ service_name: serviceName }] : [],
          _serviceAttachment: true,
          _fileUrl: fileUrl,
        }
      })

      const all = [...availableAvatarFiles, ...dedupedProductFiles, ...serviceFiles]
      const seenKeys = new Set()
      return all.filter((file) => {
        const key = attachmentFileKey(file)
        if (!key) return true
        if (seenKeys.has(key)) return false
        seenKeys.add(key)
        return true
      })
    }, [
      productAttachments,
      serviceAttachments,
      avatarUrl,
      selectedProducts,
      groupedSelectedProductsMap,
      additionalSelectedServices,
    ])

    const getGroupAnchorIndexId = (group) => {
      const products = group?.products || []
      const explicit = products.find((p) => p?.group_catalog_anchor_index_id != null)
      if (explicit) {
        const aid = Number(explicit.group_catalog_anchor_index_id)
        if (!Number.isNaN(aid) && products.some((p) => Number(p.indexId) === aid)) {
          return aid
        }
      }
      const line = products.find((p) => isProductLineCatalog(p))
      if (line?.indexId != null) return line.indexId
      const ids = products
        .map((p) => Number(p.indexId))
        .filter((n) => !Number.isNaN(n))
      return ids.length ? Math.min(...ids) : null
    }

    const productTableBodyRenderOrder = useMemo(() => {
      const sorted = [...(selectedProducts || [])].sort(
        (a, b) => (a?.indexId || 0) - (b?.indexId || 0),
      )
      const groupMemberIndexIds = new Set()
      ;(groupedSelectedProducts || []).forEach((g) => {
        ;(g.products || []).forEach((p) => {
          if (p?.indexId != null) groupMemberIndexIds.add(Number(p.indexId))
        })
      })
      const out = []
      const seenGroups = new Set()
      for (const p of sorted) {
        const gidRaw = getProductGroupId(p)
        if (!gidRaw) {
          out.push({ type: 'product', indexId: p.indexId })
          continue
        }
        const gid = String(gidRaw)
        if (seenGroups.has(gid)) continue
        const group = groupedSelectedProductsMap.get(gid)
        if (!group) continue
        const anchorId = getGroupAnchorIndexId(group)
        if (anchorId == null || p.indexId !== anchorId) continue
        seenGroups.add(gid)
        out.push({ type: 'group', groupId: gid })
      }
      return out.filter((item) => {
        if (item.type !== 'product') return true
        return !groupMemberIndexIds.has(Number(item.indexId))
      })
    }, [selectedProducts, groupedSelectedProductsMap, groupedSelectedProducts, invoice])

    const [salesRepOptions, setSalesRepOptions] = useState([]);
    const [openMaterialNote, setOpenMaterialNote] = useState({});
    const [collaborators, setCollaborators] = useState([]);
    const [teamMembersOptions, setTeamMembersOptions] = useState([]);
    const [teamMembersLoading, setTeamMembersLoading] = useState(false);

    const [openRevertStatusDialog, setOpenRevertStatusDialog] = useState(false);
    const [selectedRevertOptionKey, setSelectedRevertOptionKey] = useState(null);
    const [isSubmittingStatusRevert, setIsSubmittingStatusRevert] = useState(false);

  const [isOpenPopup, setIsOpenPopup] = useState(false)
  // Keep Sales Order / Invoice button in spinner after edit until refreshed data is ready and preview popup opens
  const [awaitingInvoicePopup, setAwaitingInvoicePopup] = useState(false)
    const handleOpenRevertStatusDialog = () => {
      setSelectedRevertOptionKey(null);
      setOpenRevertStatusDialog(true);
    };

    const handleCloseRevertStatusDialog = () => {
      setOpenRevertStatusDialog(false);
      setSelectedRevertOptionKey(null);
    };

    const currentQS = Number(details?.quotation_status);
    const currentSt = Number(details?.status);
    const isQuotation = details?.quotation === 1 || details?.is_request_estimate === 1;
    const currentProjStatus = Number(details?.proj_status);
    const hasProject = !!currentProjStatus;
    const availableRevertOptions = useMemo(
      () =>
        buildRevertStatusOptions({
          isQuotation,
          currentQS,
          currentSt,
          currentProjStatus,
          hasProject,
          allInstallationCompleted: !!details?.allInstallationCompleted,
        }),
      [isQuotation, currentQS, currentSt, hasProject, currentProjStatus, details?.allInstallationCompleted],
    );

    const handleConfirmRevertStatus = async () => {
      const option = availableRevertOptions.find(
        (opt) => getRevertOptionKey(opt) === selectedRevertOptionKey
      );
      if (!option) {
        enqueueSnackbar('Please select a status to revert to', { variant: 'warning' });
        return;
      }
      await handleRevertStatus(option);
    };

    const handleRevertStatus = async (option) => {
      handleCloseRevertStatusDialog();
      setIsSubmittingStatusRevert(true);
      const payload = {
        requestId: details?.id,
        userId: user?.user_id || user?.id,
      };
      if (option.type === 'project') {
        payload.targetProjectStatus = option.value;
      } else if (option.type === 'quotation') {
        payload.targetQuotationStatus = option.value;
      } else if (option.type === 'installation') {
        payload.targetInstallationStatus = option.value;
      } else {
        payload.targetStatus = option.value;
      }

      try {
        const res = await axios.post(`${REST_API_END_POINT}request/revert-status`, payload);
        if (res.data.status === 1) {
          enqueueSnackbar(res.data.message, { variant: 'success' });
          setRefresh((prev) => !prev);
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
      } catch (err) {
        console.error(err);
        enqueueSnackbar('Error reverting status', { variant: 'error' });
      } finally {
        setIsSubmittingStatusRevert(false);
      }
    };

    const hasPermission = (incommingPermission) => {
      return explodedPermissions?.some(permission => [incommingPermission].includes(permission)) ? true : false
    }
    const hasInvoicePermissions = hasPermission('Invoicing Privilege')
    const hasViewCostPermission = hasPermission('View Sales Order Cost')
    const canViewCosts = !!hasViewCostPermission
    const hiddenPriceColumnCount = !canViewCosts
      ? 2 +
        (details?.is_split_order &&
        details?.origin_facility_id == currentFacilityId &&
        !details?.real_for_parent_facility &&
        userType != 3
          ? 2
          : 0)
      : 0
    console.log('hasInvoicePermissions',hasInvoicePermissions)
    // let invoicePermissions= details?.installation_acceptance == 1 ? hasInvoicePermissions :true;   
    const getSalesRepOptionsFromCommunity = (community) => {
      console.log('repOptionscommunity',community)
      // Use ?? so an empty eligible list does not fall back to raw stored IDs.
      const rawNames = community?.all_sales_rep_names ?? community?.sales_rep_names;
      const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;

      const names = Array.isArray(rawNames)
        ? rawNames
        : typeof rawNames === 'string'
          ? rawNames.split(',').map((s) => s.trim()).filter(Boolean)
          : [];

      const ids = Array.isArray(rawIds)
        ? rawIds
        : typeof rawIds === 'string'
          ? rawIds.split(',').map((s) => s.trim()).filter(Boolean)
          : [];

      return names.map((name, idx) => ({
        id: ids[idx] ?? null,
        name,
      }));
    };
    // Split-order: per-product Delivery & Installation assignment (facility + delivery type)
    const [deliveryInstallDialog, setDeliveryInstallDialog] = useState({
      open: false,
      productIndexId: null,
      productFacilityId: null, // used to apply same selection to all products from that facility
      complete_status: 1, // 1=Installs, 2=Pickup, 3=Shipping
      installerFacility: null, // facility option (from FacilityTypes)
      facilityOptions: [],
      isEditMode: false, // true when editing existing delivery type (apply to single item only)
      itemType: 'product', // 'product' | 'service' - which list the item belongs to
    })

    const deliveryTypeLabelById = (deliveryTypeId) => {
      if (Number(deliveryTypeId) === 1) return 'Installs'
      if (Number(deliveryTypeId) === 2) return 'Pickup'
      if (Number(deliveryTypeId) === 3) return 'Shipping'
      return 'Installs'
    }

    const getItemDeliveryTypeId = (item) => Number(
      item?.delivery_installation?.delivery_type_id
      || item?.delivery_installation?.complete_status
      || item?.delivery_type_id
      || 0,
    )

    const buildDeliveryInstallationSelection = (item, deliveryTypeId) => {
      const currentFacility = getFacilityOption(currentFacilityId)
      return {
        ...(item?.delivery_installation || {}),
        delivery_type_id: Number(deliveryTypeId),
        installer_facility_id: Number(currentFacilityId),
        installer_facility_name: currentFacility?.name || null,
      }
    }

    const withGroupedParentDeliveryDefault = (item) => {
      if (!isDedicatedGroupedParent || getItemDeliveryTypeId(item)) return item
      return {
        ...item,
        delivery_installation: buildDeliveryInstallationSelection(item, 1),
      }
    }

    const getFacilityOption = (facilityId) => {
      const fid = Number(facilityId)
      const match = FacilityTypes?.find((f) => Number(f?.id) === fid)
      if (match) return { id: match.id, name: match.label || match.name || match.value || `Facility ${fid}` }
      return { id: fid, name: `Facility ${fid}` }
    }

    // Helper function to get existing delivery/installer settings for a facility
    const getExistingDeliverySettingsForFacility = (facilityId) => {
      const isOtherFacility = Number(facilityId) !== Number(currentFacilityId);
      const isCurrentFacility = Number(facilityId) === Number(currentFacilityId);
      
      // Check products first
      const existingProductSettings = selectedProducts.find(
        (p) => Number(p?.facility_id) === Number(facilityId) &&
               p?.delivery_installation &&
               (isSplitOrder ? (isOtherFacility || isCurrentFacility) : true) // For split orders, check both other and current facilities; for normal, all facilities
      );

      if (existingProductSettings?.delivery_installation) {
        const deliverySettings = existingProductSettings.delivery_installation;
        
        // For split orders: return full delivery_installation object
        // For normal sales orders: only return delivery_type_id (no installer_facility_id)
        if (isSplitOrder) {
          // For current facility in split orders, ensure installer_facility_id is set
          if (isCurrentFacility) {
            const currentFacility = getFacilityOption(currentFacilityId);
            return {
              ...deliverySettings,
              installer_facility_id: Number(currentFacilityId),
              installer_facility_name: currentFacility?.name || null,
            };
          }
          return deliverySettings;
        } else {
          // Normal sales order: only inherit delivery_type_id
          if (deliverySettings?.delivery_type_id) {
            return {
              delivery_type_id: deliverySettings.delivery_type_id,
              installer_facility_id: Number(currentFacilityId),
            };
          }
        }
      }

      // Check services
      const existingServiceSettings = additionalSelectedServices.find(
        (s) => Number(s?.facility_id) === Number(facilityId) &&
               s?.delivery_installation &&
               (isSplitOrder ? (isOtherFacility || isCurrentFacility) : true) // For split orders, check both other and current facilities; for normal, all facilities
      );

      if (existingServiceSettings?.delivery_installation) {
        const deliverySettings = existingServiceSettings.delivery_installation;
        
        // For split orders: return full delivery_installation object
        // For normal sales orders: only return delivery_type_id (no installer_facility_id)
        if (isSplitOrder) {
          // For current facility in split orders, ensure installer_facility_id is set
          if (isCurrentFacility) {
            const currentFacility = getFacilityOption(currentFacilityId);
            return {
              ...deliverySettings,
              installer_facility_id: Number(currentFacilityId),
              installer_facility_name: currentFacility?.name || null,
            };
          }
          return deliverySettings;
        } else {
          // Normal sales order: only inherit delivery_type_id
          if (deliverySettings?.delivery_type_id) {
            return {
              delivery_type_id: deliverySettings.delivery_type_id,
              installer_facility_id: Number(currentFacilityId),
            };
          }
        }
      }

      // For split orders with current facility: if no existing settings found, return default with currentFacilityId
      if (isSplitOrder && isCurrentFacility) {
        const currentFacility = getFacilityOption(currentFacilityId);
        // Try to find delivery_type_id from any existing product/service from current facility
        const currentFacilityProduct = selectedProducts.find(
          (p) => Number(p?.facility_id) === Number(currentFacilityId) && p?.delivery_installation?.delivery_type_id
        );
        const currentFacilityService = additionalSelectedServices.find(
          (s) => Number(s?.facility_id) === Number(currentFacilityId) && s?.delivery_installation?.delivery_type_id
        );
        
        const deliveryTypeId = currentFacilityProduct?.delivery_installation?.delivery_type_id || 
                              currentFacilityService?.delivery_installation?.delivery_type_id || 
                              1; // default to 1 (Installs)
        
        return {
          delivery_type_id: deliveryTypeId,
          installer_facility_id: Number(currentFacilityId),
          installer_facility_name: currentFacility?.name || null,
        };
      }

      return null;
    };

    const openDeliveryInstallDialog = (productRow) => {
      if (!productRow) return
      if (details?.allInstallationCompleted == 1) return
      // Only for products from other facilities and only on the parent facility view
      if (Number(productRow?.facility_id) === Number(currentFacilityId)) return
      if (details?.for_parent_facility) return

      const existing = productRow?.delivery_installation || null
      const facilityOptions = [
        ...new Map(
          [currentFacilityId, productRow?.facility_id]
            .map((id) => getFacilityOption(id))
            .map((o) => [Number(o.id), o]),
        ).values(),
      ]
      const existingFacilityId =
        existing?.installer_facility_id || existing?.installerFacility?.id || null
      const existingFacility =
        facilityOptions.find((o) => Number(o.id) === Number(existingFacilityId)) ||
        facilityOptions.find((o) => Number(o.id) === Number(productRow?.facility_id)) ||
        facilityOptions[0] ||
        null

      setDeliveryInstallDialog({
        open: true,
        productIndexId: productRow?.indexId,
        productFacilityId: productRow?.facility_id || null,
        complete_status: Number(existing?.delivery_type_id || existing?.complete_status || 1),
        installerFacility: existingFacility,
        facilityOptions,
      })
    }

    const closeDeliveryInstallDialog = () => {
      setDeliveryInstallDialog({
        open: false,
        productIndexId: null,
        productFacilityId: null,
        complete_status: 1,
        installerFacility: null,
        facilityOptions: [],
        isEditMode: false,
        itemType: 'product',
      })
    }

    const saveDeliveryInstallSelection = () => {
      const { productIndexId, productFacilityId, complete_status, installerFacility } = deliveryInstallDialog

      if (productIndexId == null) return
      if (!installerFacility?.id) {
        enqueueSnackbar('Please choose an installer facility', { variant: 'error' })
        return
      }
      if (![1, 2, 3].includes(Number(complete_status))) {
        enqueueSnackbar('Please choose Installs / Pickup / Shipping', { variant: 'error' })
        return
      }

      setSelectedProducts((prev) =>
        (prev || []).map((p) => {
          // Apply to all products from the same facility as the one being edited (other-facility only)
          const shouldApplyByFacility =
            productFacilityId != null &&
            Number(p?.facility_id) === Number(productFacilityId) &&
            Number(p?.facility_id) !== Number(currentFacilityId)

          const shouldApply = shouldApplyByFacility || p?.indexId === productIndexId

          if (!shouldApply) return p
          return {
            ...p,
            delivery_installation: {
              delivery_type_id: Number(complete_status),
              installer_facility_id: Number(installerFacility?.id),
              installer_facility_name: installerFacility?.name,
            },
          }
        }),
      )

      // Update selected services in a similar manner as products
      setAdditionalSelectedServices((prev) =>
        (prev || []).map((s) => {
          // Apply to all services from the same facility as the one being edited
          const shouldApplyByFacility =
            productFacilityId != null &&
            Number(s?.facility_id) === Number(productFacilityId) &&
            Number(s?.facility_id) !== Number(currentFacilityId);

          const shouldApply = shouldApplyByFacility || s?.indexId === productIndexId;

          if (!shouldApply) return s;
          return {
            ...s,
            delivery_installation: {
              delivery_type_id: Number(complete_status),
              installer_facility_id: Number(installerFacility?.id),
              installer_facility_name: installerFacility?.name,
            },
          };
        })
      );

      closeDeliveryInstallDialog()
    }

    // Normal sales order: open dialog for delivery type only (no installer facility)
    // itemType: 'product' | 'service' - when Edit mode, changes apply only to this specific item
    const openDeliveryTypeDialog = (productRow, itemType = 'product') => {
      if (!productRow) return
      if (details?.allInstallationCompleted == 1) return
      const existing = productRow?.delivery_installation || null
      const isEditMode = !!(existing?.delivery_type_id || existing?.complete_status)

      setDeliveryInstallDialog({
        open: true,
        productIndexId: productRow?.indexId,
        productFacilityId: productRow?.facility_id || null,
        complete_status: Number(existing?.delivery_type_id || existing?.complete_status || 1),
        installerFacility: existing?.installer_facility_id
          ? getFacilityOption(existing?.installer_facility_id)
          : null,
        facilityOptions: [], // not used for non-split orders
        isEditMode,
        itemType,
      })
    }

    // Normal sales order: save delivery_type_id and set installer_facility_id to currentFacilityId
    // Edit mode: apply only to the specific product/service; Set mode: apply to all from same facility
    const saveDeliveryTypeSelection = () => {
      const { productIndexId, productFacilityId, complete_status, isEditMode, itemType } = deliveryInstallDialog

      if (productIndexId == null) return

      if (![1, 2, 3].includes(Number(complete_status))) {
        enqueueSnackbar('Please choose Installs / Pickup / Shipping', {
          variant: 'error',
        })
        return
      }

      // Single-item edit only when: Edit mode AND not split order AND not project category 12
      const useSingleItemEdit = isEditMode && !isSplitOrder && values?.project_category?.id !== 12
      const applyToAllGroupedLines = (isDedicatedGroupedParent || isGroupedCombinedView) && !useSingleItemEdit

      if (useSingleItemEdit) {
        // Edit: apply only to the specific item that was clicked
        if (itemType === 'product') {
          setSelectedProducts((prev) =>
            (prev || []).map((p) =>
              p?.indexId === productIndexId
                ? {
                    ...p,
                    delivery_installation: buildDeliveryInstallationSelection(p, complete_status),
                  }
                : p,
            ),
          )
        } else {
          setAdditionalSelectedServices((prev) =>
            (prev || []).map((s) =>
              s?.indexId === productIndexId || s?.newIndexId === productIndexId
                ? {
                    ...s,
                    delivery_installation: buildDeliveryInstallationSelection(s, complete_status),
                  }
                : s,
            ),
          )
        }
      } else if (applyToAllGroupedLines) {
        // Grouped parent/combined invoice: one selection applies to every product and service line
        setSelectedProducts((prev) =>
          (prev || []).map((p) => ({
            ...p,
            delivery_installation: buildDeliveryInstallationSelection(p, complete_status),
          })),
        )
        setAdditionalSelectedServices((prev) =>
          (prev || []).map((s) => ({
            ...s,
            delivery_installation: buildDeliveryInstallationSelection(s, complete_status),
          })),
        )
      } else {
        // Initial Set: apply to all products/services from the same facility
        setSelectedProducts((prev) =>
          (prev || []).map((p) => {
            const shouldApplyByFacility =
              productFacilityId != null &&
              Number(p?.facility_id) === Number(productFacilityId)

            const shouldApply = shouldApplyByFacility || p?.indexId === productIndexId

            if (!shouldApply) return p

            return {
              ...p,
              delivery_installation: buildDeliveryInstallationSelection(p, complete_status),
            }
          }),
        )

        setAdditionalSelectedServices((prev) =>
          (prev || []).map((s) => {
            const shouldApplyByFacility =
              productFacilityId != null &&
              Number(s?.facility_id) === Number(productFacilityId)

            const shouldApply =
              shouldApplyByFacility
              || s?.indexId === productIndexId
              || s?.newIndexId === productIndexId

            if (!shouldApply) return s

            return {
              ...s,
              delivery_installation: buildDeliveryInstallationSelection(s, complete_status),
            }
          }),
        )
      }

      closeDeliveryInstallDialog()
    }

    
// show install price in view declaration
    const showInstallPriceInView = details?.show_install_price === 1;



    const [installCost, setInstallCost] = useState(0);

    const [openChangeJobTypeDialog, setOpenChangeJobTypeDialog] = useState(false);
    const [pendingJobType, setPendingJobType] = useState(null);

        const closeDialog=()=>{
      setOpenDialogPartial(false);
    }
    const closeDialogNoStock=()=>{
      setOpenDialogNoStock(false);
    }
    const openDialogs = (partialLen, finishedLen) => {
      if (details?.isReview == 2 && !empty(details?.allInstallationCompleted)) {
        if (partialLen > 0 || finishedLen > 0) {
          setOpenDialogPartial(true);
        } else {
          setOpenDialogNoStock(true);
        }
      } else {
        setOpenDialogPartial(true);
      }
    };
      const handleMaterialStockCheck = async (material) => {
        setPendingMaterial(material);
        setStockType(1); // default to Finished
        setConvertionUnit(0);
        setPartialProducts([]);
        setFinishedProducts([]);
  
        // if (material.inhouse !== 1) {
        //   enqueueSnackbar('Only inhouse materials can be stocked', { variant: 'warning' });
        //   return;
        // }
  
        try {
          const res = await axios.post(`${REST_API_END_POINT}product/get-partial-finished-products-stock-by-unit`, { editId: material?.id });
          
          const partial = res.data?.results?.filter(item => item?.partial == 1) || [];
          const finished = res.data?.results?.filter(item => item?.partial == 0) || [];

          // update state
          setPartialProducts(partial);
          setFinishedProducts(finished);

          openDialogs(partial?.length, finished?.length);
        } catch (err) {
          console.error(err);
          setPartialProducts([]);
          setFinishedProducts([]);
          openDialogs(0, 0);
        }
      };
 

// Function to detect changes in sales order data
const detectChanges = () => {
  const changes = [];
  
  console.log('🔍 Detecting changes...');
  console.log('📦 Current products:', selectedProducts.length, selectedProducts);
  console.log('📦 Initial products:', initialProducts.length, initialProducts);
  console.log('🔧 Current services (all):', additionalSelectedServices.length, additionalSelectedServices);
  console.log('🔧 Current services (recipe_id=null):', additionalSelectedServices.filter(s => s.recipe_id === null).length);
  console.log('🔧 Initial services (all):', initialServices.length, initialServices);
  console.log('🔧 Initial services (recipe_id=null):', initialServices.filter(s => s.recipe_id === null).length);
  console.log('🧱 Current materials:', selectedMaterials.length, selectedMaterials);
  console.log('🧱 Initial materials:', initialMaterials.length, initialMaterials);
  console.log('🛒 Current RFP services (all):', cartService.length, cartService);
  console.log('🛒 Current RFP services (recipe_id=null):', cartService.filter(s => s.recipe_id === null).length);
  console.log('🛒 Initial RFP services (all):', initialRfpServices.length, initialRfpServices);
  console.log('🛒 Initial RFP services (recipe_id=null):', initialRfpServices.filter(s => s.recipe_id === null).length);
  
  // Check products length
  if (selectedProducts.length !== initialProducts.length) {
    changes.push(`Products count changed from ${initialProducts.length} to ${selectedProducts.length}`);
  }
  
  // Check services length (only count services with recipe_id = null)
  const currentServicesCount = additionalSelectedServices.filter(service => service.recipe_id === null || !service.recipe_id).length;
  const initialServicesCount = initialServices.filter(service => service.recipe_id === null || !service.recipe_id).length;
  if (currentServicesCount !== initialServicesCount) {
    changes.push(`Services count changed from ${initialServicesCount} to ${currentServicesCount}`);
  }
  
  // Check materials length
  if (selectedMaterials.length !== initialMaterials.length) {
    changes.push(`Materials count changed from ${initialMaterials.length} to ${selectedMaterials.length}`);
  }
  
  // Check RFP products length
  if (cart.length !== initialRfpProducts.length) {
    changes.push(`RFP Products count changed from ${initialRfpProducts.length} to ${cart.length}`);
  }
  
  // Check RFP services length (only count services with recipe_id = null)
  const currentRfpServicesCount = cartService.filter(service => service.recipe_id === null).length;
  const initialRfpServicesCount = initialRfpServices.filter(service => service.recipe_id === null).length;
  if (currentRfpServicesCount !== initialRfpServicesCount) {
    changes.push(`RFP Services count changed from ${initialRfpServicesCount} to ${currentRfpServicesCount}`);
  }
  
  // Always check individual items for quantity changes, regardless of length changes
  // Check products
  const minProductsLength = Math.min(selectedProducts.length, initialProducts.length);
  for (let i = 0; i < minProductsLength; i++) {
    const current = selectedProducts[i];
    const initial = initialProducts[i];
    
    if (current && initial) {
      // Check if it's the same product by ID
      const currentId = current.id || current.product_id;
      const initialId = initial.id || initial.product_id;
      
      if (currentId === initialId) {
        // Same product, check quantity
        console.log(`🔍 Comparing product "${current.name || current.product_name}":`, {
          currentQty: current.locationQuantity,
          initialQty: initial.locationQuantity,
          isDifferent: current.locationQuantity !== initial.locationQuantity
        });
        if (current.locationQuantity !== initial.locationQuantity) {
          changes.push(`Product "${current.name || current.product_name}" quantity changed from ${initial.locationQuantity} to ${current.locationQuantity}`);
        }
      }
    }
  }
  
  // Check services (only those with recipe_id = null)
  const currentServicesFiltered = additionalSelectedServices.filter(service => service.recipe_id === null);
  const initialServicesFiltered = initialServices.filter(service => service.recipe_id === null);
  const minServicesLength = Math.min(currentServicesFiltered.length, initialServicesFiltered.length);
  
  for (let i = 0; i < minServicesLength; i++) {
    const current = currentServicesFiltered[i];
    const initial = initialServicesFiltered[i];
    
    if (current && initial) {
      if (current.id === initial.id) {
        if (current.quantity !== initial.quantity) {
          changes.push(`Service "${current.name}" quantity changed from ${initial.quantity} to ${current.quantity}`);
        }
      }
    }
  }
  
  // Check materials
  const minMaterialsLength = Math.min(selectedMaterials.length, initialMaterials.length);
  for (let i = 0; i < minMaterialsLength; i++) {
    const current = selectedMaterials[i];
    const initial = initialMaterials[i];
    
    if (current && initial) {
      const currentId = current.id || current.product_id;
      const initialId = initial.id || initial.product_id;
      
      if (currentId === initialId) {
        if (current.quantity !== initial.quantity) {
          changes.push(`Material "${current.name || current.product_name}" quantity changed from ${initial.quantity} to ${current.quantity}`);
        }
      }
    }
  }
  
  // Check RFP products
  const minRfpProductsLength = Math.min(cart.length, initialRfpProducts.length);
  for (let i = 0; i < minRfpProductsLength; i++) {
    const current = cart[i];
    const initial = initialRfpProducts[i];
    
    if (current && initial) {
      const currentId = current.id || current.product_id;
      const initialId = initial.id || initial.product_id;
      
      if (currentId === initialId) {
        if (current.quantity !== initial.quantity) {
          changes.push(`RFP Product "${current.name || current.product_name}" quantity changed from ${initial.quantity} to ${current.quantity}`);
        }
      }
    }
  }
  
  // Check RFP services (only those with recipe_id = null)
  const currentRfpServicesFiltered = cartService.filter(service => service.recipe_id === null);
  const initialRfpServicesFiltered = initialRfpServices.filter(service => service.recipe_id === null);
  const minRfpServicesLength = Math.min(currentRfpServicesFiltered.length, initialRfpServicesFiltered.length);
  
  for (let i = 0; i < minRfpServicesLength; i++) {
    const current = currentRfpServicesFiltered[i];
    const initial = initialRfpServicesFiltered[i];
    
    if (current && initial) {
      if (current.id === initial.id) {
        if (current.quantity !== initial.quantity) {
          changes.push(`RFP Service "${current.name}" quantity changed from ${initial.quantity} to ${current.quantity}`);
        }
      }
    }
  }
  
  console.log('✅ Detected changes:', changes);
  return changes;
};

// Helpers (no change to detectChanges)
const sectionFromMessage = (msg = '') => {
  // Collapse ALL RFP-related changes into one bucket
  if (/\bRFP\b/i.test(msg)) return 'Proposals';

  // Non-RFP buckets
  if (/Materials?/i.test(msg)) return 'Materials';
  if (/\bProducts?\b/i.test(msg)) return 'Products';
  if (/\bServices?\b/i.test(msg)) return 'Services';
  return null;
};

const getChangedSectionNames = () => {
  const msgs = detectChanges() // <-- your existing function
  const sections = new Set(
    msgs
      .map(sectionFromMessage)
      .filter(Boolean)
  )
  return Array.from(sections)
}

useEffect(() => {
  // Initialize socket connection
  if (!socketRef.current) {
    // OLD CODE (keep for future restore):
    // socketRef.current = io(REST_API_IO, { path: "/socket.io", transports: ["websocket", "polling"], secure: true });
    socketRef.current = createAppSocket();
    setSocketReady(true);
  }

  if (user?.user_id && socketRef.current && id) {
    socketRef.current.emit("request-online-user", { userId: user.user_id, requestId: id });
    socketRef.current.emit("get-request-online-users", { requestId: id });
  }

  if (socketRef.current) {
    socketRef.current.on("update-request-online-users", (payload) => {
      // Payload shape: { requestId, users }
      if (!payload) return;
      const { requestId, users } = payload;
      if (String(requestId) !== String(id)) return; // ignore updates for other requests
      console.log("ONLINE USERS FOR THIS REQUEST:", users);
      setOnlineUsers((users || []).map(String));
    });
  }

  return () => {
    // When component unmounts or request ID changes, leave the request
    if (socketRef.current && user?.user_id && id) {
      socketRef.current.emit("leave-request", { userId: user.user_id, requestId: id });
      console.log(`Leaving request ${id}`);
    }
    if (socketRef.current) {
      socketRef.current.off("update-request-online-users");
    }
  };
}, [user?.user_id, id]);


const handleSubmitPopUp = () => {
  if (!pendingMaterial) return;

  if (stockType === 2 && !convertionUnit) {
    enqueueSnackbar('Please choose a conversion unit', { variant: 'error' });
    return;
  }

  const normalizedId = pendingMaterial.product_id || pendingMaterial.id;

  console.log('🔹 Selected stock type:', stockType);
  console.log('🔹 Conversion unit:', convertionUnit);

  // const alreadyAdded = selectedMaterials.some(
  //   (item) =>
  //     (item.product_id || item.id) === normalizedId &&
  //     item.stock_type === stockType &&
  //     (stockType === 1 || item.convertion_unit === convertionUnit)
  // );
  const alreadyAdded = selectedMaterials.some((item) => {
  const sameProduct = (item.product_id || item.id) === normalizedId;
  const sameStock = item.stock_type === stockType;

  if (!sameProduct || !sameStock) return false;

  // ❌ Prevent Finished duplicate
  if (stockType === 1) return true;

  // ❌ Prevent *any* other Partial for same product
  if (stockType === 2) return true;

  return false;
});


  if (alreadyAdded) {
    enqueueSnackbar('Material Already Added', { variant: 'error' });
    console.warn('❌ Duplicate detected. Skipping...');
    return;
  }

  let initial_max_price = 0;
  let unit = 4;
  let partial_qty = 0

  if (stockType === 1) {
    initial_max_price = pendingMaterial.max_price || pendingMaterial.special_price;
    unit = pendingMaterial.unit || 4;
    console.log("qqqqqqqqqqqqqqqqqqq1",initial_max_price);
  } else {
    const selectedUnitData = partialProducts.find(p => p.partial_unit === convertionUnit);
    if (!selectedUnitData || selectedUnitData.total_qty <= 0) {
      enqueueSnackbar('No Partial Stock Available', { variant: 'error' });
      return;
    }
    initial_max_price = selectedUnitData.max_unit_cost || 0;
    unit = selectedUnitData.partial_unit || 4;
    partial_qty = selectedUnitData?.total_qty
  }

  const existingIndexIds = selectedMaterials.map(item => item.newIndexId || 0);
  const maxIndexId = existingIndexIds.length > 0 ? Math.max(...existingIndexIds) : 0;

  const newMaterial = {
    ...pendingMaterial,
    product_id: normalizedId,
    quantity: 1,
    price: initial_max_price,
    unit,
    partial_stock: partial_qty,
    stock_type: stockType,
    convertion_unit: convertionUnit || 0,
    initial_max_price,
    newIndexId: maxIndexId + 1,
    adj_value_type: true,
  };

  console.log('✅ New Material:', newMaterial);

  const combined = [...selectedMaterials.filter(item => !item.isAdditionalProduct), newMaterial];

  // 🔁 De-duplicate by (product_id + stock_type + convertion_unit)
  const uniqueKey = (item) =>
    `${item.product_id || item.id}-${item.stock_type}-${item.stock_type === 2 ? item.convertion_unit : 0}`;

  const dedupedMap = new Map();
  combined.forEach((item) => dedupedMap.set(uniqueKey(item), item));
  const uniqueMaterials = Array.from(dedupedMap.values());

  // ✅ Merge back additional rows
  const additionalRows = selectedMaterials.filter(item => item.isAdditionalProduct === true);
  const finalList = [...uniqueMaterials, ...additionalRows];

  console.log('📦 Final Material List:', finalList);

  setPendingAutocompleteMaterials(finalList);
  setFieldValue('additionalMaterials', finalList);
  handleMaterial(finalList);
  setSelectedMaterials(finalList);

  // Reset dialog state
  setPendingMaterial(null);
  setPartialProducts([]);
  setFinishedProducts([]);
  setStockType(1);
  setConvertionUnit(0);
  closeDialog();
  closeDialogNoStock();
};





    

  const accessPublicMessageBoard =  explodedPermissions?.some((permission) => ['Access Sales Order Client Message Board'].includes(permission))

  // Sales orders no longer use manager approval (estimate jobs only via EditEstimateJob)
  /* const canSalesOrderManagerApprove = explodedPermissions?.some((permission) =>
    ['Sales Order Manager Approve'].includes(permission),
  );
  const canSalesOrderManagerReject = explodedPermissions?.some((permission) =>
    ['Sales Order Manager Reject'].includes(permission),
  ); */

  const checkJobTypeBeforeApprovalAction = (warningMessage = 'Unable to approve or reject this sales order.') => {
    if (!details?.project_category) {
      setJobTypeWarningMessage(warningMessage);
      setOpenJobTypeWarning(true);
      return false;
    }
    return true;
  };

    const getStatusColorAndLabel = (
      status,
      installationStatus,
      allInstallationCompleted,
      accepted,
      min_payment_status,
      job_category_name,
      billing_type,
      installationCompleteStatus,
      noServiceNoTask,
      proj_status,
      partial_install,
      received_status,
      manager_approval_required,
      send_to_client,
      quotation_status,
      is_scheduled
    ) => {

  console.log('installationCompleteStatus',details?.installationCompleteStatus,installationCompleteStatus)

  console.log('billing_type', billing_type)

  console.log('details?.project_category', details?.project_category)

    if (details?.new_order === 1 && details?.isFromDesignOrder == 1) {
      return { color: 'info', label: 'New' }
    }

  let CommunityJob = false
      let CompletedStatus =
      details?.mixed_installation == 1 ? 'Mixed Installations' :
  (installationCompleteStatus == 1 || details?.installationCompleteStatus == 1)
    ? 'Installation'
    : (installationCompleteStatus == 2 || details?.installationCompleteStatus == 2)
    ? received_status == 1 ? 'Picked Up' : 'Pick up'
    :  (installationCompleteStatus == 3 || details?.installationCompleteStatus == 3) ? received_status == 1 ? 'Shipped' : 'Shipping' :''
      switch (status) {
        case 1:
          // return { color: 'warning', label: 'Status: Draft' }
          return { color: 'warning', label: details?.hold === 1 ? 'Status: Hold' : 'Status: Draft' }
        case 2:
          // return { color: 'info', label: 'Status: Open' }
          // Previous (with manager approval):
          // return { color: details?.hold === 1 ?'warning' : 'warning', label: details?.hold === 1 ? 'Status: Hold' : (details?.isAddedByClient === 1 ? 'Status: New' : (quotation_status == 2 && (manager_approval_required === true || manager_approval_required === 1)) ? (min_payment_status == 0 ? 'Status: Awaiting Manager Approval and Payment Due' : 'Status: Awaiting Manager Approval') : min_payment_status == 0 ? ((manager_approval_required === true || manager_approval_required === 1) ? 'Status: Awaiting Manager Approval and Payment Due' : 'Status: Awaiting Approval and Payment Due') : ((manager_approval_required === true || manager_approval_required === 1) ? 'Status: Awaiting Manager Approval' : 'Status: Awaiting Approval')) }
           return { color: details?.hold === 1 ?'warning' : details?.isAddedByClient === 1 ? 'info' : 'warning', label: details?.hold === 1 ? 'Status: Hold' : (details?.isAddedByClient === 1 ? 'Status: New' : min_payment_status == 0 ? 'Status: Awaiting Approval and Payment Due' : 'Status: Awaiting Approval') }
        case 3:
          return {
            color: `${
              details?.hold === 1 ?'warning' :
              details?.project_category == 13
                ? 'primary'
                : min_payment_status == 0
                ? 'warning'
                : 'primary'
            }`,
            label: `Status: ${
              details?.hold === 1 ? 'Hold' :
              details?.project_category == 13 || billing_type == 0 || details?.project_category == 15
                ? 'Approved'
                : min_payment_status == 1
                ? 'Approved and Paid'
                : 'Approved and Payment Due'
            }`,
          }
        // return { color: `${min_payment_status==0? 'warning' :'primary'}`, label: `Status: ${min_payment_status==1? 'Approved and Paid' :'Approved & Awaiting for Payment'}` }
        case 4:
          // return { color: 'success', label: !empty(allInstallationCompleted) ? 'Completed' : (!empty(installationStatus) ? 'Status: Installation' : 'Status: In Production') }
          return {
            color: details?.hold==1 ? 'warning' :
              (details?.installation_pending_review == 2 && !empty(allInstallationCompleted) && empty(details?.installation_acceptance)) ? 'success' :
              (details?.isReview == 2 && (!empty(allInstallationCompleted))) || (details?.installation_pending_review == 1 && !empty(allInstallationCompleted) && empty(details?.installation_acceptance)) ?  'warning' :
              min_payment_status == 0 ? 'warning' :
              (noServiceNoTask == 1 && proj_status == 3 && details?.project_category !== 12) ? 'success' :
              empty(accepted) && !empty(allInstallationCompleted && received_status !== 1)
                ? 'warning'
                : 'success',
            label: details?.hold==1 ? 'Hold' : (noServiceNoTask == 1 && proj_status == 3 && details?.project_category !== 12) ? 'No Service No Task' :
             (details?.isReview == 2 && (!empty(allInstallationCompleted))) ? 'Completed & Awaiting Review' : (details?.installation_pending_review == 2 && !empty(allInstallationCompleted) && empty(details?.installation_acceptance)) ? 'Installation' : (details?.installation_pending_review == 1 && !empty(allInstallationCompleted) && empty(details?.installation_acceptance)) ? "Installation In Review"  :
              empty(accepted) && (!empty(allInstallationCompleted && received_status !== 1))
                ? `${CompletedStatus} completed & Awaiting approval`
                : (job_category_name === 'Build Order' && status === 4 && accepted === 1) ? 'Completed' 
                : !empty(accepted) && (!empty(allInstallationCompleted))
                ? `${CompletedStatus} completed & Approved`
                : !empty(installationStatus)
                ? partial_install == 1 ? 'Status: Partial Install' : (proj_status != 3 && is_scheduled == 1) ? 'Status: Production' : (proj_status != 3 && installationStatus) ? `Status: ${CompletedStatus}` :proj_status !=3 ? `Status: Production` : min_payment_status == 0 ? `Status: Payment Due for ${CompletedStatus}` : `Status: ${CompletedStatus}`
                : CommunityJob ? `${CompletedStatus} completed & Approved` : `Status: Production`,
          } // return { color: 'primary', label: 'Status: Converted to Job' };
        case 5:
          return { color: 'warning', label: 'Status: Closed' }
        case 6:
          // if ((manager_approval_required === true || manager_approval_required === 1) && (send_to_client == 0 || quotation_status == 2)) {
          //   return { color: 'error', label: 'Status: Rejected by Manager' };
          // }
          return { color: 'error', label: 'Status: Rejected' }
           case 10:
        return { color: 'error', label: 'Void' }
        default:
          return { color: 'default', label: 'Status: Open' }
      }
    }

  const getSalesOrderStatusFromDetails = () => getStatusColorAndLabel(
    details?.status,
    details?.installationStatus,
    details?.allInstallationCompleted,
    details?.installation_acceptance,
    details?.min_payment_status,
    details?.job_category_name,
    details?.billing_type,
    details?.installationCompleteStatus,
    details?.noServiceNoTask,
    details?.proj_status,
    details?.partial_install,
    details?.received_status,
    details?.manager_approval_required,
    details?.send_to_client,
    details?.quotation_status,
    details?.is_scheduled,
  )

  const isGroupedInvoiceFullyApproved = () => {
    if (Number(details?.installation_acceptance) === 1) {
      return true
    }
    const members = details?.grouped_invoice_members
    if (!Array.isArray(members) || members.length === 0) {
      return false
    }
    return members.every(
      (member) => Number(member?.requestDetails?.installation_acceptance) === 1,
    )
  }

  const getEffectiveSalesOrderStatusInfo = () => {
    const isGroupedDisplay =
      Number(details?.is_grouped_request || 0) === 1
      || Number(details?.is_grouped_invoice_combined || 0) === 1

    if (!isGroupedDisplay) {
      return getSalesOrderStatusFromDetails()
    }

    if (isGroupedInvoiceFullyApproved()) {
      return { color: 'success', label: 'Grouped Completed & Approved' }
    }

    const resolvedTab =
      (mainCurrentTab === 'COMPLETED' || isFromCompletedTab ? 'COMPLETED' : null)
      || (mainCurrentTab === 'INVOICING' ? 'INVOICING' : null)
      || mainCurrentTab
      || 'INVOICING'

    if (resolvedTab === 'COMPLETED') {
      return { color: 'success', label: 'Grouped Completed & Approved' }
    }
    return { color: 'warning', label: 'Grouped Completed & Waiting For Approval' }
  }

  const isGroupedInvoiceDetails =
    Number(details?.is_grouped_request || 0) === 1
    || Number(details?.is_grouped_invoice_combined || 0) === 1

  const getGroupedJobNumbersText = () => {
    const members = details?.grouped_invoice_members
    if (!Array.isArray(members) || members.length === 0) {
      return ''
    }
    const childRows = members
      .map((member) => member?.requestDetails)
      .filter(Boolean)
    if (Number(details?.is_grouped_request || 0) === 1) {
      return getGroupedSalesOrderJobNumbersText(details, childRows)
    }
    const numbers = childRows
      .map((row) => getSalesOrderDisplayJobNumber(row))
      .filter(Boolean)
    return numbers.length ? numbers.join(', ') : ''
  }

  const getGroupedParentOrderIdText = () => getSalesOrderDisplayJobNumber(details)

  const getGroupedInvoiceNumbersText = () => {
    const members = details?.grouped_invoice_members
    if (!Array.isArray(members) || members.length === 0) {
      return ''
    }
    const childRows = members
      .map((member) => member?.requestDetails)
      .filter(Boolean)
    return getGroupedInvoiceDisplayNumbersText(details, childRows)
  }

  const renderSalesOrderJobInvoiceNumbers = (variant = 'body2') => {
    const groupedJobNumbersText = getGroupedJobNumbersText()
    const groupedInvoiceNumbersText = getGroupedInvoiceNumbersText()
    const isGroupedApproved = Number(details?.installation_acceptance || 0) === 1

    if (isGroupedInvoiceDetails && groupedJobNumbersText) {
      const parentOrderIdText = getGroupedParentOrderIdText()
      return (
        <>
          {parentOrderIdText ? (
            <Typography variant={variant}>
              Order Id : #{parentOrderIdText}
            </Typography>
          ) : null}
          <Typography variant={variant}>
            Job Number : #{groupedJobNumbersText}
          </Typography>
          {isGroupedApproved && groupedInvoiceNumbersText ? (
            <Typography variant={variant}>
              Invoice Number : #{groupedInvoiceNumbersText}
            </Typography>
          ) : null}
        </>
      )
    }

    if (
      (depositAndProgressBilling || (details?.installation_acceptance && details?.est_doc_number))
      && (details?.doc_number !== details?.est_doc_number)
    ) {
      return (
        <>
          <Typography variant={variant}>
            Job Number : {details?.est_doc_number ? `#${details?.est_doc_number}` : ''}
          </Typography>
          <Typography variant={variant}>
            Invoice Number : {details?.doc_number ? `#${details?.doc_number}` : ''}
          </Typography>
        </>
      )
    }

    const orderIdText = getSalesOrderDisplayJobNumber(details)

    return (
      <Typography variant={variant}>
        {variant === 'overline' ? (
          <>
            <strong>Order Id :</strong> {orderIdText ? `#${orderIdText}` : ''}
          </>
        ) : (
          <>Order ID: #{orderIdText || ''}</>
        )}
      </Typography>
    )
  }

  console.log('allRfpServiceLocationSame',allRfpServiceLocationSame)
  const fetchDetails = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}settings/get-companyProfile-details`);
      if (res.data.status === 1) {
        setData(res.data.data?.[0] || {});
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error);
    }
  };

  const updatePaymentFromQb =async(ids)=>{
    try {
      let user = JSON.parse(localStorage.getItem('user'))
      // console.log('useruseruseruser',user)
     
      
      let admin_email = user.email
      let company_name= user.company_name
      let username = user.person_name
      let user_role = user.user_role
      const response= await axios.post(`${REST_API_END_POINT}sales-order/update-payment-from-qb`,{userId,allId:ids,admin_email,company_name,username,user_role})
    if(response.data.details.success > 0){
      // fetchAllRequest()
      setRefresh(!refresh)
      enqueueSnackbar('Payment updated successfully', { variant: 'success' });
    }
    } catch (error) {
      console.log("error",error)
    }
  }

  useEffect(() => {
    fetchDetails();
    if(id){
      let ids =[id]
      updatePaymentFromQb(ids)
    }

  }, [id]);

const getQbEstimateEffectiveTaxPercent = async (estimateId) => {
  try {
    const response = await axios.post(`${REST_API_END_POINT}request/get-qb-transaction-tax-details`, {
      estimate_id: estimateId
    });

    if (response?.data?.success) {
      const data = response.data;
      return {
        estimateId: data.estimate_id,
        docNumber: data.doc_number,
        taxableSubtotal: data.taxable_subtotal,
        totalTaxAmount: data.total_tax_amount,
        effectiveTaxPercent: data.total_tax_percent,
        taxRateDetails: (data.tax_rates || []).map(rate => ({
          name: rate.tax_rate_name || `Tax Rate (${rate.tax_percent}%)`,
          percent: rate.tax_percent
        }))
      };
    } else {
      throw new Error(response?.data?.message || "Failed to fetch tax details");
    }
  } catch (error) {
    console.error("Error in getQbEstimateEffectiveTaxPercent:", error);
    throw error;
  }
};

// const getTransactionTaxDetails = async (salesOrderId) => {
//   try {
//     const response = await axios.post(`${REST_API_END_POINT}request/get-qb-transaction-tax-details`, {
//       sales_order_id: salesOrderId
//     });
//     const items = response?.data?.items || [];
//     if (response?.data?.total_tax_rate !== undefined) {
//       items.total_tax_rate = response.data.total_tax_rate;
//       setTotalTaxRate(response.data.total_tax_rate);
//     }
//     setTaxRateData(items);
//     console.log('response43434343434343433', response);
//   } catch (error) {
//     console.log("error", error)
//   }
// }
// const fetchEstimateTaxDetails = async (estimateDocNumber) => {
//   try {
//     if (!estimateDocNumber) return;
//     const response = await axios.post(`${REST_API_END_POINT}request/get-estimate-tax-rate`, {
//       estimate_id: estimateDocNumber
//     });
    
//     if (response?.data?.total_tax_rate !== undefined) {
//       setTotalTaxRate(response.data.total_tax_rate);
//       setTaxRateData((prev) => {
//         const next = Array.isArray(prev) ? [...prev] : [];
//         next.total_tax_rate = response.data.total_tax_rate;
//         return next;
//       });
//     }
//     console.log('response43434343434343433e222rrrr', response);
//   } catch (error) {
//     console.log("error", error)
//   }
// }
// useEffect(() => {
//   if (id) {
//     getTransactionTaxDetails(id);
//   }
// }, [id]);

// useEffect(() => {
//   if (details?.doc_number) {
//     fetchEstimateTaxDetails(details.doc_number);
//   }
// }, [details?.doc_number]);

  useEffect(() => {
    if(details){
      const isMirrored = details?.real_for_parent_facility == 2 && details?.project_category == 15 && details?.is_split_order == 1 && details?.received_status != 2 ? true : false;
      // const splitIntiator =  details?.project_category == 9 && details?.is_split_order == 1  ? true : false;
      const splitIntiator =  details?.is_split_order == 1  ? true : false;
      console.log('isMirroredddd',isMirrored)
      setIsMirrored(isMirrored);
      setSplitIntiator(splitIntiator);
    }
  }, [details]);


    const handleSalesOrderTabCount = async () => {
      try {
        await axios.post(`${REST_API}webservice/sales-order/reduce-tabs-count`, {
          userId,
          request_id: id,
        });
        
      } catch (error) {
        console.error("Error reducing sales order count:", error);
      }
    };

    const handleSalesOrderNewOrder = async () => {
      try {
        const response = await axios.post(`${REST_API}webservice/sales-order/change-new-order-sales-order-tab`, {
          request_id: id,
          userId,
        });
        
      } catch (error) {
        console.error("Error reducing sales order count:", error);
      }
    };

    const handleDuplicateSalesOrder = async () => {
      try {
        // 🚀 PROGRESS TRACKING: Show progress modal and make API call
        const requestData = {
          userId,
          request_id: id,
          userType,
          socketId: null, // Will be set by the progress modal
          duplicateAsSalesOrder: true // Duplicate appears in Sales Order Awaiting Approval, not Estimate
        };

        setProgressHeading("Duplicating Sales Order");
        setProgressRequestData(requestData);
        setShowProgressModal(true);
        
        // Wait for socket connection to establish and stabilize
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // Additional wait if socket is not ready yet
        if (!socketReady) {
            console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        
        const response = await axios.post(`${REST_API}webservice/duplicate-request`, requestData);

        if(response?.data?.status === 1){
        enqueueSnackbar(response?.data?.message, { variant: 'success' });
          if(popupOn){
          closeView()
          localStorage.removeItem('salesOrderProjectId');
          localStorage.removeItem('salesOrderProjectName');
          localStorage.removeItem('isEditSalesOrder');
          localStorage.removeItem('salesOrderOpenPopup',);
          setRenderCards(!renderCards)
          onDataChange()
          setShowProgressModal(false);
        }else{
          navigate(PATH_DASHBOARD.official.root)
        }
        }
      } catch (error) {
        console.error("Error duplicating sales order:", error);
        enqueueSnackbar('Error duplicating sales order:', { variant: 'error' });
      }
    };
  
    useEffect(() => {
      if (!details?.id) return
      if (Number(details?.quotation) !== 0) return
      if (Number(details?.isFromEstimate) === 1) return
      if (Number(details?.isFromDesignOrder) === 1) return
      const skipKey = `salesOrderSkipRibbonDismiss_${details.id}`
      if (sessionStorage.getItem(skipKey)) {
        sessionStorage.removeItem(skipKey)
        return
      }
      handleSalesOrderTabCount()
    }, [details?.id, details?.quotation, details?.isFromEstimate, details?.isFromDesignOrder])

    const validateRequestExistInQb = async (requestId) => {
      try {
        const response = await axios.post(`${REST_API}webservice/request/validate-request-exist-in-qb`, {
          requestId: requestId,
          qb_estimate_id : details?.estimate_id,
          invoice_qb_id:details?.invoice_qb_id,
          installation_acceptance:details?.installation_acceptance,
          quotation:details?.quotation,
        });
        if(response?.data?.status === 1){
          console.log(response?.data?.message);
        }else{
          enqueueSnackbar(response?.data?.message, { variant: 'error' });
           setRefresh(!refresh);
        }
       
      } catch (error) {
        console.error("Error validating request exist in QB:", error);
      }
    }
    useEffect(() => {
      if (!details?.id) return
      if (details?.new_order === 1 && details?.isAddedByClient !== 1 && details?.isFromDesignOrder !== 1) {
        handleSalesOrderNewOrder();
      }
    }, [details?.id, details?.new_order, details?.isAddedByClient, details?.isFromDesignOrder]);

  const getGroupMemberIndexIdsByAnchor = (anchorIndexId) => {
    const anchor = (selectedProducts || []).find(
      (p) => Number(p?.indexId) === Number(anchorIndexId),
    )
    const gid = getProductGroupId(anchor)
    if (!gid) return [anchorIndexId]
    return (selectedProducts || [])
      .filter((p) => String(getProductGroupId(p) || '') === String(gid))
      .map((p) => p?.indexId)
      .filter((id) => id != null)
  }

  const handleOpenNote = (indexId, note, applyToGroup = false) => {
    setCurrentNote(note || '');
    const key = String(indexId)
    if (applyToGroup) {
      setGroupNoteTargets((prev) => ({
        ...prev,
        [key]: getGroupMemberIndexIdsByAnchor(indexId),
      }))
    } else {
      setGroupNoteTargets((prev) => ({ ...prev, [key]: undefined }))
    }
    setOpenProductNote((prev) => ({ ...prev, [indexId]: true }));
  };

  const handleCloseNote = (indexId) => {
    setOpenProductNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleNoteChange = (event) => {
    const newNote = event.target.value;
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote);
    }
    if (error) {
      setError(false);
    }
  };

  const handleSaveNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; // Exit early if validation fails
    }
    setIsSavingNote(true);
    setTimeout(() => {
      const targetIds = groupNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.includes(product.indexId)
            ? { ...product, product_notes: currentNote }
            : product
        )
      );
      setIsSavingNote(false);
      handleCloseNote(indexId);
    }, 100);
  };

  // Clear product note and save empty value
  const handleClearNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      const targetIds = groupNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.includes(product.indexId)
            ? { ...product, product_notes: '' }
            : product
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };

  // Install notes handlers
  const handleOpenInstallNote = (indexId, note, applyToGroup = false) => {
    setCurrentNote(note || '');
    const key = String(indexId)
    if (applyToGroup) {
      setGroupInstallNoteTargets((prev) => ({
        ...prev,
        [key]: getGroupMemberIndexIdsByAnchor(indexId),
      }))
    } else {
      setGroupInstallNoteTargets((prev) => ({ ...prev, [key]: undefined }))
    }
    setOpenInstallNote((prev) => ({ ...prev, [indexId]: true }));
  };

  const handleCloseInstallNote = (indexId) => {
    setOpenInstallNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleSaveInstallNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return; // Exit early if validation fails
    }
    setIsSavingNote(true);
    setTimeout(() => {
      const targetIds = groupInstallNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.includes(product.indexId)
            ? { ...product, install_notes: currentNote }
            : product
        )
      );
      setIsSavingNote(false);
      handleCloseInstallNote(indexId);
    }, 100);
  };
  const handleOpenMaterialNote = (indexId, note) => {
    setCurrentNote(note || '');
    setOpenMaterialNote((prev) => ({ ...prev, [indexId]: true }));
  };
  const handleCloseMaterialNote = (indexId) => {
    setOpenMaterialNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };
  const handleSaveMaterialNote = (indexId) => {
    if (!currentNote.trim()) {
      setError('Note cannot be empty or just spaces');
      return;
    }
    setIsSavingNote(true);
    setTimeout(() => {
      setSelectedMaterials((prev) =>
        prev.map((material) =>
          material.newIndexId === indexId ? { ...material, material_notes: currentNote } : material
        )
      );
      setIsSavingNote(false);
      handleCloseMaterialNote(indexId);
    }, 100);
  };
  // Clear material note and save empty value
  const handleClearMaterialNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      setSelectedMaterials((prev) =>
        prev.map((material) =>
          material.newIndexId === indexId ? { ...material, material_notes: '' } : material
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };
  // Clear install note and save empty value
  const handleClearInstallNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      const targetIds = groupInstallNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.includes(product.indexId)
            ? { ...product, install_notes: '' }
            : product
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };

  // Product attachment handlers
  const handleOpenAttachment = (indexId) => {
    const key = String(indexId ?? '');
    const currentAttachments = getProductAttachmentsList(indexId);
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: true }));
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }));
    setSelectedUploadedImages((prev) => ({ ...prev, [key]: [...currentAttachments] }));
  };

  const handleOpenProductFormula = (id) => {
    setSelectedProductFormulaId(id);
    setOpenProductFormulaModal(true);
  };

  const handleCloseAttachment = (indexId) => {
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 })); // Reset to first tab
    setSelectedUploadedImages((prev) => ({ ...prev, [indexId]: [] })); // Clear selections
  };

  const handleAttachmentTabChange = (event, newValue, indexId) => {
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: newValue }));
  };

  const handleImageSelect = (file, indexId, isSelected) => {
    const key = String(indexId ?? '');
    setSelectedUploadedImages((prev) => {
      const current = prev[key] || prev[indexId] || [];
      if (isSelected) {
        if (current.some((f) => attachmentMatches(f, file))) return prev;
        return { ...prev, [key]: [...current, file] };
      }
      return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) };
    });
  };

  const handleAddSelectedImages = (indexId) => {
    const key = String(indexId ?? '');
    const selected = selectedUploadedImages[key] || selectedUploadedImages[indexId] || [];
    const original = getProductAttachmentsList(indexId);
    const toLink = selected.filter((file) => !original.some((orig) => attachmentMatches(orig, file)));
    const toUnlink = original.filter((file) => !selected.some((sel) => attachmentMatches(sel, file)));
    if (toLink.length === 0 && toUnlink.length === 0) {
      setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
      return;
    }

    const memberIds = getGroupMemberIndexIdsByProductIndexId(indexId);
    setProductAttachments((prev) => {
      const next = { ...prev };
      memberIds.forEach((mid) => {
        next[String(mid)] = selected.map((file) => ({ ...file, product_index_id: mid }));
      });
      if (toUnlink.length > 0) {
        const released = releaseFilesToAvatarPool(toUnlink, next, serviceAttachments);
        if (released.length > 0) {
          setAvatarUrl((avatarPrev) => mergeFilesIntoAvatarPool(avatarPrev, released));
        }
      }
      return next;
    });
    setSelectedUploadedImages((prev) => {
      const next = { ...prev };
      memberIds.forEach((mid) => {
        next[String(mid)] = [];
        next[mid] = [];
      });
      return next;
    });
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
    enqueueSnackbar('Product attachments updated successfully', { variant: 'success' });
  };

  // Service attachment modal handlers
  const handleOpenServiceAttachment = (indexId) => {
    const key = String(indexId ?? '');
    const currentAttachments = serviceAttachments[key] || serviceAttachments[indexId] || [];
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: true }));
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: 0 }));
    setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [...currentAttachments] }));
  };

  const handleCloseServiceAttachment = (indexId) => {
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: 0 }));
    setSelectedUploadedImagesService((prev) => ({ ...prev, [indexId]: [] }));
  };

  const handleAttachmentTabChangeService = (event, newValue, indexId) => {
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: newValue }));
  };

  const handleImageSelectService = (file, indexId, isSelected) => {
    const key = String(indexId ?? '');
    setSelectedUploadedImagesService((prev) => {
      const current = prev[key] || prev[indexId] || [];
      if (isSelected) {
        if (current.some((f) => attachmentMatches(f, file))) return prev;
        return { ...prev, [key]: [...current, file] };
      }
      return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) };
    });
  };

  const handleAddSelectedImagesService = (indexId) => {
    const key = String(indexId ?? '');
    const selected = selectedUploadedImagesService[key] || selectedUploadedImagesService[indexId] || [];
    const original = serviceAttachments[key] || serviceAttachments[indexId] || [];
    const toLink = selected.filter((file) => !original.some((orig) => attachmentMatches(orig, file)));
    const toUnlink = original.filter((file) => !selected.some((sel) => attachmentMatches(sel, file)));
    if (toLink.length === 0 && toUnlink.length === 0) {
      setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
      return;
    }

    setServiceAttachments((prev) => {
      const next = {
        ...prev,
        [key]: selected.map((file) => ({ ...file, service_index_id: indexId })),
      };
      if (toUnlink.length > 0) {
        const released = releaseFilesToAvatarPool(toUnlink, productAttachments, next);
        if (released.length > 0) {
          setAvatarUrl((avatarPrev) => mergeFilesIntoAvatarPool(avatarPrev, released));
        }
      }
      return next;
    });
    setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [], [indexId]: [] }));
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
    enqueueSnackbar('Service attachments updated successfully', { variant: 'success' });
  };

  const handleProductDrop = useCallback(
    async (acceptedFiles, productIndexId) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order'
      );
      if (noPermission && user?.added_by_client === 1) {
        return enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error'
        });
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return;

      // Single file upload (commented for backup)
      // const file = acceptedFiles[0];

      setIsUploadingProduct(prev => ({ ...prev, [productIndexId]: true }));

      try {
        // Multiple file upload
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `sales-orders/${fileName}`;

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const {
            data: publicUrlData,
            error: urlError,
          } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            product_index_id: productIndexId,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        if (id) {
          for (const fileData of uploadedFiles) {
            const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
              requestId: id,
              userId: user.user_id,
              uploaded: [fileData.url],
              type: fileData.file_type,
              size: fileData.size,
              extension: fileData.extension,
              attachmentType: 'product',
            });
            if (res.data?.status !== 1) {
              throw new Error(res.data?.message || 'Failed to save attachment');
            }
          }
        }

        const memberIds = getGroupMemberIndexIdsByProductIndexId(productIndexId);
        const pKey = String(productIndexId ?? '');
        setProductAttachments((prev) => {
          const next = { ...prev };
          memberIds.forEach((mid) => {
            const mKey = String(mid);
            const current = next[mKey] || [];
            const existingKeys = current.map(attachmentFileKey);
            const newFiles = uploadedFiles
              .map((f) => ({ ...f, product_index_id: mid }))
              .filter((f) => !existingKeys.includes(attachmentFileKey(f)));
            next[mKey] = [...current, ...newFiles];
          });
          return next;
        });
        setSelectedUploadedImages((prev) => {
          const current = prev[pKey] || prev[productIndexId] || [];
          const merged = [...current];
          uploadedFiles.forEach((file) => {
            const withMeta = { ...file, product_index_id: productIndexId };
            if (!merged.some((f) => attachmentMatches(f, withMeta))) {
              merged.push(withMeta);
            }
          });
          return { ...prev, [pKey]: merged };
        });

        // await fetchRequestDetails();
        enqueueSnackbar('Attachment uploaded successfully', { variant: 'success' });
      } catch (error) {
        console.error('Error uploading product file:', error);
        enqueueSnackbar(error.response?.data?.message || 'Failed to upload file', { variant: 'error' });
      } finally {
        setIsUploadingProduct(prev => ({ ...prev, [productIndexId]: false }));
      }
    },
    [explodedPermissions, user,id, enqueueSnackbar, getGroupMemberIndexIdsByProductIndexId]
  );

  const getDragTransferTypes = (dataTransfer) => {
    if (!dataTransfer?.types) return [];
    const { types } = dataTransfer;
    if (typeof types.includes === 'function') return [...types];
    const list = [];
    for (let i = 0; i < types.length; i += 1) {
      list.push(types[i]);
    }
    return list;
  };

  const isExternalFileDragEvent = (e) => {
    const types = getDragTransferTypes(e.dataTransfer);
    if (types.some((type) => String(type).toLowerCase().includes('react-beautiful-dnd'))) {
      return false;
    }
    return (
      types.includes('Files') ||
      types.includes('application/x-moz-file') ||
      Array.from(e.dataTransfer?.items || []).some((item) => item.kind === 'file')
    );
  };

  const handleProductIconDragOver = (e, productIndexId) => {
    if (!isExternalFileDragEvent(e)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy';
    }
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: true }));
  };

  const handleProductIconDragLeave = (e, productIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    const related = e.relatedTarget;
    if (related && e.currentTarget.contains(related)) return;
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }));
  };

  const handleProductIconDrop = (e, productIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }));
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length > 0) {
      handleProductDrop(files, productIndexId);
    }
  };

  const handleProductRemove = async (file, productIndexId) => {
    if (!file) {
      const memberIds = getGroupMemberIndexIdsByProductIndexId(productIndexId)
      setProductAttachments((prev) => {
        const next = { ...prev }
        for (const mid of memberIds) {
          next[String(mid)] = []
        }
        return next
      })
      setSelectedUploadedImages((prev) => {
        const next = { ...prev }
        for (const mid of memberIds) {
          next[String(mid)] = []
        }
        return next
      })
      return
    }
    if (getAttachmentRecordId(file)) {
      const ok = await persistDeleteDesignAttachment(file)
      if (!ok) {
        enqueueSnackbar('Failed to remove file', { variant: 'error' })
        return
      }
    }
    removeDesignFromState(file)
  };

  // Service attachment handlers (mirror products)
  const handleServiceDrop = useCallback(
    async (acceptedFiles, serviceIndexId) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order'
      );
      if (noPermission && user?.added_by_client === 1) {
        return enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error'
        });
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return;

      setIsUploadingService((prev) => ({ ...prev, [serviceIndexId]: true }));

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `sales-orders/${fileName}`;

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            displayName: file.name,
            service_index_id: serviceIndexId,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        if (id) {
          for (const fileData of uploadedFiles) {
            const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
              requestId: id,
              userId: user.user_id,
              uploaded: [fileData.url],
              type: fileData.file_type,
              size: fileData.size,
              extension: fileData.extension,
              attachmentType: 'service',
            });
            if (res.data?.status !== 1) {
              throw new Error(res.data?.message || 'Failed to save attachment');
            }
          }
        }

        const sKey = String(serviceIndexId ?? '');
        setServiceAttachments((prev) => {
          const current = prev[sKey] || prev[serviceIndexId] || [];
          const existingKeys = current.map(attachmentFileKey);
          const newFiles = uploadedFiles
            .map((f) => ({ ...f, service_index_id: serviceIndexId }))
            .filter((f) => !existingKeys.includes(attachmentFileKey(f)));
          return {
            ...prev,
            [sKey]: [...current, ...newFiles],
          };
        });
        setSelectedUploadedImagesService((prev) => {
          const current = prev[sKey] || prev[serviceIndexId] || [];
          const merged = [...current];
          uploadedFiles.forEach((file) => {
            const withMeta = { ...file, service_index_id: serviceIndexId };
            if (!merged.some((f) => attachmentMatches(f, withMeta))) {
              merged.push(withMeta);
            }
          });
          return { ...prev, [sKey]: merged };
        });

        // await fetchRequestDetails();
        enqueueSnackbar('Attachment uploaded successfully', { variant: 'success' });
      } catch (error) {
        console.error('Error uploading service file:', error);
        enqueueSnackbar(error.response?.data?.message || 'Failed to upload file', { variant: 'error' });
      } finally {
        setIsUploadingService((prev) => ({ ...prev, [serviceIndexId]: false }));
      }
    },
    [explodedPermissions, user, id, enqueueSnackbar]
  );

  const handleServiceIconDragOver = (e, serviceIndexId) => {
    if (!isExternalFileDragEvent(e)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy';
    }
    setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: true }));
  };

  const handleServiceIconDragLeave = (e, serviceIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    const related = e.relatedTarget;
    if (related && e.currentTarget.contains(related)) return;
    setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: false }));
  };

  const handleServiceIconDrop = (e, serviceIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: false }));
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length > 0) {
      handleServiceDrop(files, serviceIndexId);
    }
  };

  const handleServiceRemove = async (file, serviceIndexId) => {
    const key = String(serviceIndexId ?? '');
    if (!file) {
      setServiceAttachments((prev) => ({ ...prev, [key]: [] }));
      setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [] }));
      return;
    }
    if (getAttachmentRecordId(file)) {
      const ok = await persistDeleteDesignAttachment(file);
      if (!ok) {
        enqueueSnackbar('Failed to remove file', { variant: 'error' });
        return;
      }
    }
    removeDesignFromState(file);
  };

  const renderAttachmentModalContent = ({
    itemKey,
    isService = false,
    tabValue,
    onTabChange,
    selectedImages,
    linkedAttachments,
    onImageSelect,
    onAddSelected,
    onDrop,
    onRemove,
    isUploadingItem,
    disabled = false,
  }) => (
    <Grid
      container
      spacing={3}
      sx={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Upload Attachment
        </Typography>
        <Tabs
          value={tabValue || 0}
          onChange={(e, newValue) => {
            if (disabled && newValue === 1) return;
            onTabChange(e, newValue, itemKey);
          }}
          sx={{ mb: 2 }}
        >
          <Tab label="Select from Uploaded" />
          <Tab label="Upload New" disabled={disabled} sx={disabled ? tmInvoicingUploadTabDisabledSx : {}} />
        </Tabs>

        {(tabValue || 0) === 0 ? (
          <Box>
            {(() => {
              const allProductAttachmentFiles = isService
                ? []
                : Object.values(productAttachments).flat()
              const allServiceAttachmentFiles = Object.values(serviceAttachments).flat()
              const currentLinkedAttachments = linkedAttachments || []

              const availableAvatarFiles = (avatarUrl || []).filter((file) => (
                !allProductAttachmentFiles.some((pfile) => attachmentMatches(pfile, file)) &&
                !allServiceAttachmentFiles.some((sfile) => attachmentMatches(sfile, file))
              ))

              const enrichProductAttachment = (file) => {
                const product = (selectedProducts || []).find(
                  (p) =>
                    Number(p?.indexId) === Number(file.product_index_id) ||
                    Number(p?.indexId) === Number(itemKey),
                )
                if (!product) {
                  return {
                    ...file,
                    product_index_id: file.product_index_id ?? itemKey,
                  }
                }
                const locationIds =
                  product.location
                    ?.map((loc) => loc.id || loc.request_location_id)
                    .filter(Boolean)
                    .join(',') || ''
                const productName = product.product_name || product.name || ''
                return {
                  ...file,
                  product_index_id: file.product_index_id ?? product.indexId ?? itemKey,
                  location_ids: file.location_ids || locationIds || String(itemKey),
                  productNames: file.productNames || (productName
                    ? [
                        {
                          product_id: product.product_id || product.id,
                          product_name: productName,
                        },
                      ]
                    : []),
                }
              }

              const enrichServiceAttachment = (file) => {
                const svc =
                  additionalSelectedServices?.find(
                    (s) =>
                      String(s.newIndexId ?? s.indexId ?? s.id) === String(file.service_index_id ?? itemKey),
                  ) || null
                const serviceName = svc?.name || svc?.service_name || ''
                return {
                  ...file,
                  service_index_id: file.service_index_id ?? itemKey,
                  serviceNames: file.serviceNames || (serviceName ? [{ service_name: serviceName }] : []),
                }
              }

              const allFiles = isService
                ? [
                    ...availableAvatarFiles,
                    ...allServiceAttachmentFiles.map(enrichServiceAttachment),
                    ...currentLinkedAttachments.map(enrichServiceAttachment),
                  ]
                : [
                    ...availableAvatarFiles,
                    ...allProductAttachmentFiles.map(enrichProductAttachment),
                    ...currentLinkedAttachments.map(enrichProductAttachment),
                  ]

              const allFilesUnique = (() => {
                const seen = []
                return allFiles.filter((file) => {
                  if (seen.some((f) => attachmentMatches(f, file))) return false
                  seen.push(file)
                  return true
                })
              })()

              if (allFilesUnique.length === 0) {
                return (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    No uploaded files available. Please upload files first.
                  </Typography>
                )
              }

              const availableImages = isService
                ? allFilesUnique.filter((file) => {
                    const isAddedToOtherService = Object.entries(serviceAttachments).some(
                      ([serviceId, attachments]) => {
                        if (String(serviceId) === String(itemKey)) return false
                        return (
                          attachments &&
                          attachments.some((f) => attachmentMatches(f, file))
                        )
                      },
                    )
                    const isAddedToAnyProduct = Object.values(productAttachments).some(
                      (atts) => atts && atts.some((f) => attachmentMatches(f, file)),
                    )
                    return !isAddedToOtherService && !isAddedToAnyProduct
                  })
                : (() => {
                    const groupMemberIds = getGroupMemberIndexIdsByProductIndexId(itemKey)
                    const groupSiblingIndexIdSet =
                      groupMemberIds.length > 1
                        ? new Set(groupMemberIds.map(String))
                        : null
                    return allFilesUnique.filter((file) => {
                      const isAddedToOtherProduct = Object.entries(productAttachments).some(
                        ([productId, attachments]) => {
                          if (String(productId) === String(itemKey)) return false
                          if (groupSiblingIndexIdSet?.has(String(productId))) return false
                          return (
                            attachments &&
                            attachments.some((f) => attachmentMatches(f, file))
                          )
                        },
                      )
                      const isUsedOnService = Object.values(serviceAttachments).some(
                        (atts) => atts && atts.some((f) => attachmentMatches(f, file)),
                      )
                      return !isAddedToOtherProduct && !isUsedOnService
                    })
                  })()

              if (availableImages.length === 0) {
                return (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    {isService
                      ? 'All files are already linked to other items.'
                      : 'All images are added to other products. No images left in the uploaded files.'}
                  </Typography>
                )
              }

              const toLink = (selectedImages || []).filter(
                (file) => !(linkedAttachments || []).some((orig) => attachmentMatches(orig, file)),
              )
              const toUnlink = (linkedAttachments || []).filter(
                (file) => !(selectedImages || []).some((sel) => attachmentMatches(sel, file)),
              )
              const hasChanges = toLink.length > 0 || toUnlink.length > 0

              return (
                <>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {availableImages.map((file, idx) => {
                      const isSelected = (selectedImages || []).some((f) => attachmentMatches(f, file))
                      const isAlreadyAddedToCurrent = (linkedAttachments || []).some((f) => attachmentMatches(f, file))
                      return (
                        <Grid item xs={6} sm={4} md={3} key={idx}>
                          <Card
                            sx={{
                              position: 'relative',
                              border: isSelected ? '2px solid' : '1px solid',
                              borderColor: isSelected ? 'primary.main' : 'divider',
                              cursor: disabled ? 'not-allowed' : 'pointer',
                              opacity: 1,
                            }}
                            onClick={() => !disabled && onImageSelect(file, itemKey, !isSelected)}
                          >
                            <Box
                              sx={{
                                position: 'relative',
                                width: '100%',
                                paddingTop: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              {(() => {
                                const url = file.url || file.name
                                const preview = file.preview || url
                                const isActualPdf = file.file_type === 'pdf' || file.file_type === 'application/pdf' || file.extension === 'pdf' || (file.name || '').toLowerCase().split('?')[0].endsWith('.pdf')
                                const isImage = file.file_type?.startsWith('image/') || file.file_type === 'img' || file.file_type === 'image'

                                return isActualPdf ? (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      openAttachmentPreview(file, url)
                                    }}
                                    aria-label="open pdf"
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      p: 0,
                                      borderRadius: 0,
                                    }}
                                  >
                                    <Box
                                      component="iframe"
                                      src={url}
                                      title="PDF Preview"
                                      frameBorder="0"
                                      sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        pointerEvents: 'none',
                                      }}
                                    />
                                  </IconButton>
                                ) : !isImage ? (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      window.open(url, '_blank')
                                    }}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      p: 0,
                                      borderRadius: 0,
                                    }}
                                  >
                                    <Description style={{ fontSize: 50, color: 'gray' }} />
                                  </IconButton>
                                ) : (
                                  <Box
                                    component="img"
                                    src={preview}
                                    alt={file.name || 'Uploaded file'}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                    }}
                                    onError={(e) => {
                                      if (preview !== url) {
                                        e.target.src = url
                                      }
                                    }}
                                  />
                                )
                              })()}
                              <AttachmentDownloadIconButton
                                file={file}
                                fileIndex={idx}
                                hidden={isClient || userType === 3}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  left: 4,
                                  zIndex: 2,
                                }}
                              />
                              <Checkbox
                                checked={isSelected}
                                disabled={disabled}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  right: 4,
                                  bgcolor: 'rgba(255, 255, 255, 0.8)',
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  if (!disabled) {
                                    onImageSelect(file, itemKey, !isSelected)
                                  }
                                }}
                              />
                              {isAlreadyAddedToCurrent && isSelected && (
                                <Chip
                                  label="Added"
                                  size="small"
                                  color="success"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 4,
                                    left: 4,
                                  }}
                                />
                              )}
                            </Box>
                          </Card>
                        </Grid>
                      )
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <AttachmentDownloadAllButton
                      files={selectedImages || []}
                      allFiles={availableImages}
                      onToggleSelectAll={(checked) => {
                        availableImages.forEach((file) =>
                          onImageSelect(file, itemKey, checked),
                        )
                      }}
                      label="Download Selected"
                      hidden={isClient || userType === 3}
                    />
                    <Button
                      variant="contained"
                      onClick={() => onAddSelected(itemKey)}
                      disabled={!hasChanges || disabled}
                    >
                      Save Selection ({selectedImages?.length || 0})
                    </Button>
                  </Box>
                </>
              )
            })()}
          </Box>
        ) : (
          <UploadMultiFile
            showPreview
            allowDownload
            multiple={true}
            maxSize={1024 * 1024 * 1024}
            files={linkedAttachments || []}
            onDrop={disabled ? () => {} : (acceptedFiles) => onDrop(acceptedFiles, itemKey)}
            onRemove={disabled ? () => {} : (file) => onRemove(file, itemKey)}
            onRemoveAll={disabled ? () => {} : () => onRemove(null, itemKey)}
            noClick={disabled}
            noDrag={disabled}
            disabled={disabled}
            isUploading={isUploadingItem || false}
            sx={disabled ? tmInvoicingUploadDisabledSx : {}}
          />
        )}
      </Grid>
    </Grid>
  )


      // Service notes handlers
      const handleOpenServiceNote = (indexId, note) => {
        setServiceCurrentNote(note || '');
        setServiceNoteState((prev) => ({ ...prev, [indexId]: true }));
    };

    const handleCloseServiceNote = (indexId) => {
        setServiceNoteState((prev) => ({ ...prev, [indexId]: false }));
        setServiceCurrentNote('');
    };

    const handleServiceNoteChange = (event) => {
        const newNote = event.target.value;
        if (newNote.length <= MAX_CHARACTERS) {
            setServiceCurrentNote(newNote);
        }
        if (error) {
            setError(false);
        }
    };

    const handleSaveServiceNote = (indexId) => {
      if (!serviceCurrentNote.trim()) {
        setError('Note cannot be empty or just spaces');
        return; // Exit early if validation fails
    }
        setServiceIsSavingNote(true);
        setTimeout(() => {
            // Update selectedServices
            setSelectedServices((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: serviceCurrentNote } : service
                )
            );
            // Update additionalSelectedServices
            setAdditionalSelectedServices((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: serviceCurrentNote } : service
                )
            );
            // Update cartService
            setCartService((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: serviceCurrentNote } : service
                )
            );
            setServiceIsSavingNote(false);
            handleCloseServiceNote(indexId);
        }, 100);
    };

    // Clear service note and save empty value
    const handleClearServiceNote = (indexId) => {
      setError(false);
      setServiceIsClearingNote(true);
      setTimeout(() => {
        setSelectedServices((prev) =>
          prev.map((service) =>
            service.indexId === indexId ? { ...service, service_notes: '' } : service
          )
        );
        setAdditionalSelectedServices((prev) =>
          prev.map((service) =>
            service.indexId === indexId ? { ...service, service_notes: '' } : service
          )
        );
        setCartService((prev) =>
          prev.map((service) =>
            service.indexId === indexId ? { ...service, service_notes: '' } : service
          )
        );
        setCurrentNote('');
        setLocalCurrentNote('');
        setServiceIsClearingNote(false);
      }, 100);
    };

  const handleRfpSelect = (event, value) => {
    setSelectedRfp(value);
    // Sort RFP services alphanumerically by name
    const filteredRfpServices = value?.services?.filter(service => !isInCartService(service)) || [];
    const sortedRfpServices = [...filteredRfpServices].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
    setRfpServices(sortedRfpServices);
    setRfpProducts(value?.products?.filter(product => !isInCart(product)) || []);
    if (!empty(value)) {
      setOpenModal(true);
    }

  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  
  const addToCart = (item) => {
    // Extract project/community address
    const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };

    const locationQuantity = item.location_quantity || 1; // Ensure a default value of 1

    if (tabIndex === 1) {
        // ✅ Adding to RFP Services
        const newService = assignDefaultLocation(cartService, item, allRfpServiceLocationSame, communityAddress, locationQuantity);
        setCartService([...cartService, newService]);

        if (allRfpServiceLocationSame) {
            setCartService((prevServices) =>
                prevServices.map((service) => ({
                    ...service,
                    location: Array.from({ length: locationQuantity }, () => ({ ...communityAddress })),
                }))
            );
        }
    } else {
      // ✅ Adding to RFP Products
      // Always start with a single location; the Qty Location toggle will control count later
      const baseLocation = {
        id: 0,
        address: communityAddress.address || '',
        city: communityAddress.city || '',
        state: communityAddress.state || '',
        zip: communityAddress.zip || '',
      };

      const newProduct = {
        ...item,
        is_single_card: true,
        allRfpProductsLocationSame: true,
        location: [baseLocation],
      };

      setCart([...cart, newProduct]);
    }

    // ✅ Close modal and reset form fields
    setOpenModal(false);
    setSelectedRfp(null);
    setFieldValue('rfp', null);
  };


  const assignDefaultLocation = (existingItems, newItem, allLocationsSame, communityAddress) => {
    let assignedLocation = [];
  
    if (allLocationsSame && existingItems.length > 0) {
      // Use the first item's location as the common location
      const commonLocation = existingItems[0]?.location?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
      assignedLocation = [{ ...commonLocation }];
    } else if (
      communityAddress.address &&
      communityAddress.city &&
      communityAddress.state &&
      communityAddress.zip
    ) {
      // Use the community address as the default location
      assignedLocation = [
        {
          id: 0,
          address: communityAddress.address,
          city: communityAddress.city,
          state: communityAddress.state,
          zip: communityAddress.zip,
        },
      ];
    } else {
      // Default to an empty location
      assignedLocation = [
        {
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        },
      ];
    }
  
    return {
      ...newItem,
      location: assignedLocation,
    };
  };
  
  // const handleMaterial = (newValue) => {
  //   setSelectedMaterials((prevMaterials) => {
  //     const additionals = prevMaterials?.filter(item => item.isAdditionalProduct == true);
  //     const baseIndex = prevMaterials?.filter(item => !item.isAdditionalProduct)?.length || 0;
  //     const updatedNewValue = newValue.map((item, idx) => ({
  //       ...item,
  //       newIndexId: baseIndex + 1,
  //       quantity:item.quantity ?? 1,
  //     }));
  //     return [...updatedNewValue, ...additionals];
  //   });
  // };
const handleMaterial = (newValue) => {
  const cleaned = newValue.filter((item, index, self) =>
    index === self.findIndex(t =>
      (t.product_id || t.id) === (item.product_id || item.id) &&
      t.stock_type === item.stock_type &&
      (t.stock_type === 1 || t.convertion_unit === item.convertion_unit)
    )
  );
  

  const baseIndex = cleaned.length > 0 ? Math.max(...cleaned.map(item => item.newIndexId || 0)) : 0;

  const updatedNewValue = cleaned.map((item, idx) => ({
    ...item,
    newIndexId: baseIndex + idx + 1,
    quantity: item.quantity ?? 1,
  }));

  const additionals = selectedMaterials?.filter(item => item.isAdditionalProduct === true);
  setSelectedMaterials([...updatedNewValue, ...additionals]);
};


  // const handleDeleteMaterial = (id, indexId) => {
  //   const updatedMaterials = selectedMaterials?.filter((data) => {
  //     if (data?.isAdditionalProduct) {
  //       return data?.newIndexId !== indexId;
  //     }
  //     return data?.id !== id;
  //   });
    
  //   setSelectedMaterials(updatedMaterials);
  //   };
const handleDeleteMaterial = (productId, stockType, convertionUnit = 0) => {
  const updatedMaterials = selectedMaterials.filter((data) => {
    const currentId = data.product_id || data.id;
    const isSameMaterial =
      currentId === productId &&
      data.stock_type === stockType &&
      (stockType === 1 || data.convertion_unit === convertionUnit);

    return !isSameMaterial;
  });

  setSelectedMaterials(updatedMaterials);
  setPendingAutocompleteMaterials(updatedMaterials);
  setFieldValue('additionalMaterials', updatedMaterials);
  handleMaterial(updatedMaterials);
};

  console.log("######################Cart", cart);
  console.log("######################Cart Service", cartService);
  const isInCart = (item) => {
    return cart.some(cartItem => cartItem.product_id === item.product_id);
  };
  const isInCartService = (item) => {
    return cartService.some(cartItem => cartItem.labour_cost_service_id
      === item.labour_cost_service_id);
  };
  const closeModal = () => {
    setOpenModal(false);
    setFieldValue('rfp',null)
  };
  const handleDeleteRFPProduct = (productId) => {
    setCheckLength(!checkLength)
    setCart(prevCart => prevCart.filter(item => item.product_id !== productId));
  };
  const handleDeleteRFPService = (productId) => {
    setCheckLength(!checkLength)
    console.log("######################Cartde", productId);
    setCartService(prevCart => prevCart.filter(item => item.labour_cost_service_id !== productId));
  };
  const VALUE = [
    { id: 1, value: 'Sl No.' },
    { id: 22, value: 'Qb' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    { id: 19, value: 'Attachments' },
    { id: 4, value: 'Product Formula' },
    { id: 5, value: 'Product formula cost Each' },
    { id: 20, value: 'Markup (%)' },
    { id: 16, value: 'Split Markup' },
    { id: 6, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    { id: 7, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    // { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 8, value: hasMarkupPermission ? 'Markup (%)' : null },
    // { id: 9, value: 'Unit' },
    { id: 10, value: 'Quantity' },
    { id: 18, value: details?.is_split_order ? 'Delivery & Installation' : 'Installation' },
    { id: 11, value: 'Location' },
    { id: 17, value: 'Marketing Adjustment Type' },
    { id: 12, value: 'Marketing Adjustment' },
    // { id: 12, value: 'Discount' },
    { id: 13, value: 'Subtotal' },
    { id: 14, value: 'Product Total' },
    { id: 15, value: '' }
  ];

  const isOfficialProductTableValueColumnVisible = useCallback(
    (val) => {
      if (!val || val.value === null) return false
      if (isSplitOrder && (val.id === 17 || val.id === 12)) return false
      if (val.id === 20 && isSplitOrder) return false
      if (val.id === 16 && !isSplitOrder) return false
      return true
    },
    [isSplitOrder],
  )

  const visibleOfficialRequestProductColumns = useMemo(
    () => (VALUE || []).filter((v) => isOfficialProductTableValueColumnVisible(v)),
    [VALUE, isOfficialProductTableValueColumnVisible],
  )

  const VALUEPreview = [
    { id: 0, value: 'Sl No.' },
    { id: 1, value: 'Products & Notes' },
    // { id: 2, value: 'Product formula cost (Material cost + Service cost with markup)' },
    { id: 3, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    { id: 4, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    // { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 5, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 6, value: 'Unit' },
    { id: 7, value: 'Quantity' },
    { id: 15, value: 'TAX' },
    // { id: 11, value: 'Marketing Adjustment Type' },
    // { id: 8, value: 'Marketing Adjustment' },
    // { id: 8, value: 'Discount' },
    { id: 9, value: 'Subtotal' },
    { id: 11, value: 'Product Total' },
    { id: 10, value: '' }
  ]

  const VALUE_SERVICES = [
    { id: 0, value: 'Sl No.' },  
    { id: 22, value: 'Qb' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Note' },
    { id: 19, value: 'Attachments' },
    { id: 3, value: 'Markup (%)' },
    { id: 4, value: 'Cost (Hourly)' },
    { id: 5, value: 'Markup Cost (Hourly)' },
    { id: 6, value: 'Hours' },
    { id: 18, value: details?.is_split_order ? 'Delivery & Installation' : 'Installation' },
    // { id: 7, value: 'Make As Task' },
    // { id: 8, value: 'Make Install Card' },
    { id: 9, value: 'Location' },
    // { id: 10, value: 'Product Formula Cost'},
    { id: 11, value: 'Additional Cost' },
    { id: 12, value: 'Total cost' },
    { id: 13, value: '' }
  ];

    const PREVIEW_VALUE_SERVICES = [
    // { id: 0, value: 'Product Sl No.' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Note' },
    { id: 3, value: 'Markup (%)' },
    { id: 4, value: 'Cost (Hourly)' },
    { id: 5, value: 'Markup Cost (Hourly)' },
    { id: 6, value: 'Hours' },
    // { id: 7, value: 'Make As Task' },
    // { id: 8, value: 'Make Install Card' },
    // { id: 9, value: 'Location' },
    { id: 10, value: 'Product Formula Cost'},
    { id: 11, value: 'Additional Cost' },
    { id: 12, value: 'Total cost' },
    { id: 13, value: '' }
  ];

  const VALUE_TIME = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    { id: 17, value: 'Attachments' },
    { id: 4, value: 'Retail Price Each'},
    // { id: 14, value: 'SPMA' },
    { id: 5, value: 'Unit' },
    { id: 6, value: 'Quantity' },
    { id: 7, value: 'Location' },
    // { id: 11, value: 'Marketing Adjustment Type' },
    // { id: 8, value: 'Marketing Adjustment' },
    { id: 9, value: 'Subtotal' },
    { id: 10, value: '' }
  ];
  const VALUE_TIME_Preview = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    // { id: 3, value: 'Note' },
    { id: 4, value: 'Retail Price Each'},
    // { id: 14, value: 'SPMA' },
    { id: 5, value: 'Unit' },
    { id: 6, value: 'Quantity' },
    { id: 15, value: 'TAX' },
    // { id: 7, value: 'Location' },
    // { id: 11, value: 'Marketing Adjustment Type' },
    // { id: 8, value: 'Marketing Adjustment' },
    { id: 9, value: 'Subtotal' },
    { id: 11, value: 'Product Total' },
    { id: 10, value: '' }
  ];
  const VALUE_MATERIAL=[
    {id: -1, value: 'Sl No.' },
    {id: 22, value: 'Qb' },
    {id: 0, value: 'Material'},
    {id: 8, value: 'Note'},
    {id: 9, value: 'Stock Type'},
    {id: 1, value: 'Unit Price'},
    {id: 2, value: 'Markup (%)'},
    {id: 3, value: 'Markup Cost (Unit)' },
    {id: 4, value: 'Quantity'},
    { id: 8, value: 'Marketing Adjustment Type' },
    { id: 10, value: 'Marketing Adjustment' },
    // {id: 5, value: 'Product Formula Cost'},
    {id: 6, value: 'Total'},
    {id: 7, value: '' }
  ]
  const VALUE_RFP_Product = [
    { id: -1, value: 'Sl No.' },
    { id: 22, value: 'Qb' },
    { id: 0, value: 'Name' },
    { id: 1, value: 'Mark Up (%)' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Retail Price Each' },
    { id: 4, value: 'Unit' },
    { id: 5, value: 'Quantity' },
    // { id: 6, value: 'Product Formula Cost'},
    { id: 7, value: 'Total' },
    // { id: 8, value: 'Make As Task' },
    // { id: 9, value: 'Make Install Card' },
    { id: 10, value: 'Location' },
    { id: 11, value: '' }
  ]
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue)
    // setRefresh(true)
    console.log('tab--newValuenewValue--',newValue)
    if (newValue === 'Design Notes') {
      clearDesignNotesNew()
    }
    if (newValue === 'Job Notes') {
      clearJobNotesNew()
    }
    if(newValue == 'Locations and Notes'){
      // setRefresh(!refresh);
      fetchRequestDetails();
    }
    if(newValue == "Sales Order Details"){
      if(popupOn){
        setRenderCards(!renderCards)
      }
    }
  }
  const HandleClickmenu = () => {
    setAddClient(true)
  }
  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
        if(response.data.status === 1){
            setTaxCategories(response.data.taxResult);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }

  //add clients
  const fetchAllRequestClients = async () => {

    try {
      const res = await axios.post(`${REST_API}webservice/request/fetch-all-clients-request`, { requestId: id })

      await setAllClients(res.data.data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
    }
  }

  useEffect(() => {
    fetchAllRequestClients()
  }, [addClient])
  const NewUserSchema = Yup.object().shape({
    // name: Yup.string().required('Name is required'),
    // description: Yup.string().required('Description is required'),
    //  avatarUrl: Yup.mixed().required('Image is required'),
    // skills:userType!=3 && Yup.array().min(1, 'Skill is required'),
    // workflow:userType!=3 && Yup.array().min(1, 'Workflow is required'),
    start: Yup.mixed().required('Start Date is required'),
    end: Yup.mixed()
      .nullable()
      .test(
        'end-on-or-after-start',
        'Installation Date must be on or after the Start Date',
        function (end) {
          const { start } = this.parent;
          if (end == null || end === '' || start == null || start === '') return true;
          return moment
            .unix(Number(end))
            .startOf('day')
            .isSameOrAfter(moment.unix(Number(start)).startOf('day'));
        },
      ),
    products: isAdminUser (userType) && Yup.array(),
    //.min(1, 'At least one product is required')
    // services:userType!=3 && Yup.array().min(1, 'At least one service is required'), 
    markup_type: userType != 3 && Yup.object().nullable().required('Please select the markup type'),
    project_type: userType != 3 && Yup.object().nullable().required('Job Class is required'),
    project_category: userType != 3 && Yup.object().nullable().required('Job Type is required'),
    map_service: Yup.mixed().when('project_category', {
      is: (project_category) => userType !== 3 && project_category?.id == 14,
      then: Yup.object().nullable().required('Please select the map service'),
      otherwise: Yup.mixed().nullable(),
    }),
    community: userType != 3 && Yup.object().nullable().required('Project is required'),
    billing_type: Yup.object().nullable(),
  });
  //
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }));
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  //delete official request 
  const handleDeleteRFQ = async () => {
    try {
      setLoadingDelete(true);
      const data = { request_id: id,request:true,userId }
      const res = await axios.post(`${REST_API}webservice/delete-request/id`, data)

      if (res.data.data == true) {
        enqueueSnackbar('Delete success', { variant: 'success' });
        // 
        if(popupOn){
          closeView()
          localStorage.removeItem('salesOrderProjectId');
          localStorage.removeItem('salesOrderProjectName');
          localStorage.removeItem('isEditSalesOrder');
          localStorage.removeItem('salesOrderOpenPopup',);
          setRenderCards(!renderCards)
          onDataChange()
        }else{
          navigate(PATH_DASHBOARD.official.root)
        }
      }
    } catch (error) {
      console.log(error, 'Error in deleting the order')
    } finally {
      setLoadingDelete(false);
    }

  }

  const handleVoidSalesOrder = async () => {
    if (!voidReason.trim()) {
      setVoidReasonError('Reason is required to void this sales order');
      return;
    }

    try {
      setLoadingVoid(true);
      const res = await axios.post(`${REST_API_END_POINT}sales_order/void-sales-order`, {
        request_id: Number(id),
        userId,
        reason: voidReason.trim(),
      });

      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message || 'Sales order voided successfully', { variant: 'success' });
        setOpenVoid(false);
        setVoidReason('');
        setVoidReasonError('');
        if (popupOn) {
          closeView();
          localStorage.removeItem('salesOrderProjectId');
          localStorage.removeItem('salesOrderProjectName');
          localStorage.removeItem('isEditSalesOrder');
          localStorage.removeItem('salesOrderOpenPopup');
          setRenderCards(!renderCards);
          onDataChange();
        } else {
          navigate(PATH_DASHBOARD.official.root);
        }
      } else {
        enqueueSnackbar(res.data.message || 'Failed to void sales order', { variant: 'error' });
      }
    } catch (error) {
      console.log(error, 'Error voiding the sales order');
      enqueueSnackbar('Failed to void sales order', { variant: 'error' });
    } finally {
      setLoadingVoid(false);
    }
  }

  const reopenVoidSalesOrder = async (requestId) => {
    const res = await axios.post(`${REST_API_END_POINT}sales_order/reopen-void-sales-order`, {
      request_id: Number(requestId),
      userId,
    });
    return res.data;
  };

  const handleReopenVoidMenu = () => {
    setOpenReopenVoid(!openReopenVoid);
  };

  const handleReopenVoidSalesOrder = async () => {
    try {
      setLoadingReopenVoid(true);
      const data = await reopenVoidSalesOrder(id);

      if (data.status === 1) {
        enqueueSnackbar(data.message || 'Sales order reopened successfully', { variant: 'success' });
        setOpenReopenVoid(false);
        if (popupOn) {
          closeView();
          localStorage.removeItem('salesOrderProjectId');
          localStorage.removeItem('salesOrderProjectName');
          localStorage.removeItem('isEditSalesOrder');
          localStorage.removeItem('salesOrderOpenPopup');
          setRenderCards(!renderCards);
          onDataChange();
        } else {
          navigate(PATH_DASHBOARD.official.root);
        }
      } else {
        enqueueSnackbar(data.message || 'Failed to reopen sales order', { variant: 'error' });
        setOpenReopenVoid(false);
      }
    } catch (error) {
      console.log(error, 'Error reopening void sales order');
      enqueueSnackbar('Failed to reopen sales order', { variant: 'error' });
    } finally {
      setLoadingReopenVoid(false);
    }
  };
  //fetch request details
const fetchRequestDetails = async () => {
    try {
      // setLoadingEdit(true)
      setLoadingEditData(true)
      // const [productRes,res] = await Promise.all([
      //   axios.post(`${REST_API}webservice/view-request-products-materials`, { request_id: id }),
      //   axios.post(`${REST_API}webservice/view-request`, { request_id: id, userId, userType, noMaterials: true, noProducts: true })
      // ])

      // const res = await axios.post(`${REST_API}webservice/view-request`, { request_id: id, userId, userType,noMaterials: true, noProducts: true, combineGroupedInvoice: !!combineGroupedInvoice })
      const [res,groupsRes] = await Promise.all([
        axios.post(`${REST_API}webservice/view-request`, { request_id: id, userId, userType,noMaterials: true, noProducts: true, combineGroupedInvoice: !!effectiveCombineGroupedInvoice  }),
       axios.post(`${REST_API}webservice/view-request-groups`, { request_id: id }),
      ])
      const groupsFromApi = groupsRes?.data?.customerOrderProductGroups || []
      setCustomerOrderProductGroups(groupsFromApi)

      const initialProductMarketing = {}
      const initialInstallMarketing = {}
      groupsFromApi.forEach((group) => {
        const gid = group?.id ?? group?.group_id
        if (gid == null) return
        const key = String(gid)
        initialProductMarketing[key] = getGroupProductMarketingStateFromApi(group)
        initialInstallMarketing[key] = getGroupInstallMarketingStateFromApi(group)
      })
      setGroupProductMarketingValues(initialProductMarketing)
      setGroupInstallMarketingValues(initialInstallMarketing) 
      const partnerIdForClients = res.data?.data?.[0]?.partners?.[0]?.id;

      if (partnerIdForClients) {
        if (combineGroupedInvoice) {
          fetchAllClients(partnerIdForClients).catch((err) => console.error('Error fetching clients:', err));
        } else {
          await fetchAllClients(partnerIdForClients);
        }
      }else {
        await fetchAllClients(partnerIdForClients);
      }
      // const [productRes,materialsRes,res] = await Promise.all([
      //   axios.post(`${REST_API}webservice/view-request-products`),
      //   axios.post(`${REST_API}webservice/view-request-materials`),
      //   axios.post(`${REST_API}webservice/view-request`, { request_id: id, userId, userType,noMaterials: true, noProducts: true })
      // ])
      // const productRes = await axios.post(`${REST_API}webservice/view-request-products`)
      // const materialsRes = await axios.post(`${REST_API}webservice/view-request-materials`)
      // const res = await axios.post(`${REST_API}webservice/view-request`, { request_id: id, userId, userType,noMaterials: true, noProducts: true });
      // const materials = materialsRes?.data?.materials || []
      // await fetchAllClients(res.data?.data[0]?.partners[0]?.id)
      // // const products = productRes.data.products
      // const allMatData = Array.isArray(materials) 
      // ? materials.map((material) => ({
      //     ...material,
      //     markup: Number(material.retail_price || 0), 
      //   }))
      // : [];
      // console.log('allMatData---2',allMatData)
      // const filteredMaterials = allMatData?.filter(item=>item.isAdditionalProduct == 0)
      // // Sort materials alphanumerically by description (fallback to name)
      // const sortedMaterials = [...(filteredMaterials || [])].sort((a, b) => {
      //   const aValue = a?.description || a?.name || '';
      //   const bValue = b?.description || b?.name || '';
      //   return alphanumericCompare(aValue, bValue);
      // })
      // setAllMaterials(sortedMaterials)
      // const res = await axios.post(`${REST_API}webservice/view-request`, { request_id: id, userId, userType,noMaterials:true });
      res.data;
      setTeamMember(res.data.team)
      // setAllTeamMembers(res.data.team_members.data || [])
      setCustomerData(res.data.customerData)
      setTaxAmount(res.data.customerData?.tax_amount || 0)
      setAvatarUrl((() => {
        const seen = new Set();
        return (res.data.attachments || []).filter((attachment) => {
          if (attachment.location_ids && attachment.location_ids !== null) return false;
          if (attachment.product_id != null && attachment.product_id !== '') return false;
          if (attachment.status === 0) return false;
          const key = attachmentFileKey(attachment);
          if (key && seen.has(key)) return false;
          if (key) seen.add(key);
          return true;
        });
      })())
      setDetails(res.data?.data[0])
      setBillingTypes(res.data.billingTypes)

      const depositProgressPayments = Array.isArray(res.data?.depositProgressBillingRows)
        ? res.data.depositProgressBillingRows
        : [];
      setDepositProgressBillingRows(
        depositProgressPayments.length > 0
          ? depositProgressPayments.map((payment) => ({
            id: payment.id,
            title: payment.title || '',
            amount: payment.amount || '',
            partialAmount: payment.partialAmount || null,
            markAsPaid: payment.markAsPaid || 0,
            paymentMode: payment.paymentMode || null,
            originalPaymentMode: payment.paymentMode || null,
            originalMarkAsPaid: payment.markAsPaid || 0,
          }))
          : [{ title: '', amount: '', markAsPaid: 0 }]
      )

      let isDepositAndProgressBilling = depositProgressPayments.length > 0 || (res.data?.data[0]?.req_billing_type ? true : false || res.data?.data[0]?.customerTypeId == null ? false : true);
      console.log("filteredTypefilteredType 1",isDepositAndProgressBilling)
      setDepositAndProgressBilling(isDepositAndProgressBilling)

      if(isDepositAndProgressBilling){
        const selectedBillingTypeId = res.data?.data[0]?.req_billing_type || res.data?.data[0]?.customerTypeId
        let filteredType = res.data.billingTypes.find(result => result.id == selectedBillingTypeId)
        setInitialBillingType(filteredType)
        console.log("filteredTypefilteredType 2",filteredType,res.data?.data[0].req_billing_type)
      }

      // Sort labour cost services alphanumerically by name
      let currentInstallationServiceData = res?.data?.labourCostServices
      let otherInstallationServiceData = res?.data?.otherInstallationServices
      let combinedServices = [...(currentInstallationServiceData || []), ...(otherInstallationServiceData || [])];
      const sortedLabourCostServices = [...(combinedServices || [])].sort((_a_, b) => alphanumericCompare(_a_?.name || '', b?.name || ''))
      setLabourCostServices(sortedLabourCostServices)
      // const sortedLabourCostServices = [...(res.data.labourCostServices || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      // setLabourCostServices(sortedLabourCostServices)
      setDesignersList(res.data.projectMembers)
      setFilteredServices(sortedLabourCostServices)
      setRequestServices(dedupeRequestServicesByRowId(res.data.requestServices?.filter(row => row.rfp === 0)))
      setRfpServicesEdit(res.data.requestServices?.filter(row => row.rfp === 1))
      setClientApprove(res.data?.data[0]?.client_approve)
      setManagerApprovalRequired(res.data?.data[0]?.manager_approval_required ?? 0)
      // setIsSingleCard(res.data?.data[0]?.is_single_card)
      // setSingleLocationCard(res.data?.data[0]?.is_single_card === 1);
      console.log("setDetailssetDetailssetDetails",res.data.data)
      // Sort proposals alphanumerically by description
      const sortedProposals = [...(res.data.allProposals || [])].sort((a, b) => alphanumericCompare(a?.description || '', b?.description || ''))
      setRfps(sortedProposals)
      setMarkupType(res.data?.data[0]?.markup_type)
      setDesigns(res.data?.attachments)
      // setSkill(res.data.skill)
      // setWorkFlow(res.data.workflows)
      // setAllproducts(res.data.products)
      // let currentInstallationProductData = productRes?.data?.products
      // currentInstallationProductData = currentInstallationProductData?.filter(row=>row.inhouse!==6)
      // let otherInstallationProductData = res?.data?.otherInstallationProducts
      // let combinedProducts = [...(currentInstallationProductData || []), ...(otherInstallationProductData || [])];
      // console.log('combinedProductscombinedProducts',combinedProducts)
      // setAllproducts(combinedProducts)
      let incomingSplitMarkup = res?.data?.currentFacilitySplitManagementSettings?.find(setting => setting?.is_default)?.incoming_percentage
      setIncomingSplitMarkup(incomingSplitMarkup)
      // Store unlinked locations data
      if (res.data?.getRequestLocationsByRequestIdWhereIsLinkedAllZero) {
        setUnlinkedLocations(res.data.getRequestLocationsByRequestIdWhereIsLinkedAllZero) 
      } else {
        setUnlinkedLocations([])
      }
      setSplitManagementSettings(res?.data?.otherInstallationSplitManagementSettings)

      let filteredValue = res.data?.data[0].facility_type; // e.g. "2,3,4"

      const selectedData = String(filteredValue)  
        .split(",")                               
        .map(v => v.trim())                     
        .map(id => res?.data?.otherInstallationSplitManagementSettings?.find(s => s?.id == id)) 
        .filter(Boolean);                        
      
      setSelectedSplitOrderSettings(res?.data?.otherInstallationSplitManagementSettings);
      console.log('selectedData11212121212 1',selectedData)
      // setAllMaterials(res.data.materials)   15-01-25 previos
      if (editState && Number(res.data?.data[0]?.status) !== 10) {
        setOpenEdit(true)
        console.log('truetruetruetrue==editState',editState)
      }
      
      
      setAcceptedClients(res.data.requestAcceptedPartners)
      setJobNoteMembers(res?.data?.jobNoteMembers || res.data.team || [])
      // setUpdates(res.data.updates)
      // setPayments(res.data.payments)
      setCustomTemplate(res.data.fieldTemplates)
      setQuestionnaireTemplate(res.data.QuestionTemplates)
      setSignAgreements(res.data.signAgrementData)
      setDataEmpty(res.data.allDataEmpty)
      setPortfolio(res.data.portfolio)
      setRefresh(false)
      setProposalData(res.data.requestProposals)
      setBillingTypes(res.data.billingTypes)
      const splitStatus = res.data?.splitStatus == 2 ? true : false
      setMirrorApproved(splitStatus)
      if(res.data?.data[0].project_category == 13){
        setNoCharge(true)
      }
      setIsSplitOrder(res.data?.data[0]?.is_split_order)

    } catch (error) {
      console.error('Error fetching request details:', error);
    } 
    finally {
      setLoadingEditData(false)
      // setLoadingEdit(false)
    }
  };

  const fetchProductAndMaterials = async () => {
    try {
      setLoadingEdit(true)
      // setLoadingEditData(true)
      const [productRes,materialsRes,res,groupsRes] = await Promise.all([
        axios.post(`${REST_API}webservice/view-request-products`),
        axios.post(`${REST_API}webservice/view-request-materials`),
        axios.post(`${REST_API}webservice/other-facility-products`, { request_id: id, userId, userType}),
       axios.post(`${REST_API}webservice/view-request-groups`, { request_id: id }),
      ])
      const groupsFromApi = groupsRes?.data?.customerOrderProductGroups || []
      setCustomerOrderProductGroups(groupsFromApi)

      const initialProductMarketing = {}
      const initialInstallMarketing = {}
      groupsFromApi.forEach((group) => {
        const gid = group?.id ?? group?.group_id
        if (gid == null) return
        const key = String(gid)
        initialProductMarketing[key] = getGroupProductMarketingStateFromApi(group)
        initialInstallMarketing[key] = getGroupInstallMarketingStateFromApi(group)
      })
      setGroupProductMarketingValues(initialProductMarketing)
      setGroupInstallMarketingValues(initialInstallMarketing) 
      const materials = materialsRes?.data?.materials || []
      const allMatData = Array.isArray(materials) 
      ? materials.map((material) => ({
          ...material,
          markup: Number(material.retail_price || 0), 
        }))
      : [];
      console.log('allMatData---2',allMatData)
      const filteredMaterials = allMatData?.filter(item=>item.isAdditionalProduct == 0)
      // Sort materials alphanumerically by description (fallback to name)
      const sortedMaterials = [...(filteredMaterials || [])].sort((a, b) => {
        const aValue = a?.description || a?.name || '';
        const bValue = b?.description || b?.name || '';
        return alphanumericCompare(aValue, bValue);
      })
      setAllMaterials(sortedMaterials)
      res.data;
      let currentInstallationProductData = productRes?.data?.products
      currentInstallationProductData = currentInstallationProductData?.filter(row=>row.inhouse!==6)
      let otherInstallationProductData = res?.data?.otherInstallationProducts
      let combinedProducts = [...(currentInstallationProductData || []), ...(otherInstallationProductData || [])];
      setAllproducts(combinedProducts)
    } catch (error) {
      console.error('Error fetching request details:', error);
      setAllproducts([])
      setAllMaterials([])
    } 
    finally {
      // setLoadingEditData(false)
      setLoadingEdit(false)
    }
  };

  //fetch request details
  const fetchRequestDetailsNew = async () => {
    try {
      setLoading(true)
      const res = await axios.post(`${REST_API}webservice/view-request-new`,
        { request_id: id, userId, userType });
      setTeamMember(res.data.team)
      setCustomerData(res.data.customerData)
      setAvatarUrl((() => {
        const seen = new Set();
        return (res.data.attachments || []).filter((attachment) => {
          if (attachment.location_ids && attachment.location_ids !== null) return false;
          if (attachment.product_id != null && attachment.product_id !== '') return false;
          if (attachment.status === 0) return false;
          const key = attachmentFileKey(attachment);
          if (key && seen.has(key)) return false;
          if (key) seen.add(key);
          return true;
        });
      })()) 
      //  this chnage is for a ui for grouped invoice (count  of the grouped sales order and dropdown details after edit  )
      // view-request-new does not attach grouped child metadata; keep the
      // grouped fields from view-request so the "Grouped Sales Orders" count
      // and child accordions survive whichever fetch resolves last.
      setDetails((prev) => {
        const next = res.data?.data?.[0]
        if (!next) return prev
        if (
          Number(next?.is_grouped_request || 0) === 1 &&
          next?.grouped_invoice_members === undefined &&
          Array.isArray(prev?.grouped_invoice_members)
        ) {
          return {
            ...next,
            grouped_invoice_members: prev.grouped_invoice_members,
            grouped_member_count: prev.grouped_member_count,
            is_grouped_invoice_combined: prev.is_grouped_invoice_combined,
          }
        }
        return next
      })
      setDesigns(res.data?.attachments)
      setAcceptedClients(res.data.requestAcceptedPartners)
      // setUpdates(res.data.updates)
      // setPayments(res.data.payments)
      setJobNoteMembers(res?.data?.jobNoteMembers)
      const splitStatus = res.data?.splitStatus == 2 ? true : false
      setMirrorApproved(splitStatus)
      // Store unlinked locations data
      if (res.data?.getRequestLocationsByRequestIdWhereIsLinkedAllZero) {
        setUnlinkedLocations(res.data.getRequestLocationsByRequestIdWhereIsLinkedAllZero)
      } else {
        setUnlinkedLocations([])
      }
      // setRefresh(false)
      // setTimeout(()=>{
      //   setLoading(false)
      // },2000)
    } catch (error) {
      console.error('Error fetching request details:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllCommunityByClient = async (clientId) => {
    setIsCommunityLoading(true);
    try {
      clientId = clientId.id
      const res = await axios.post(`${REST_API}webservice/rfq/get-community-by-client`, { clientId,userType,From:"addSalesOrder",teamId: null })
      let data = res.data?.community
      let allCommunity = res.data?.allCommunity
      // Sort communities alphanumerically by name
      const sortedCommunities = [...(data || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      await setCommunities(sortedCommunities)
      setAllCommunities(allCommunity)
    } catch (error) {
      console.log(error, 'Error in fetching all clients');
      setCommunities([]);
    } finally {
      setIsCommunityLoading(false)
    }
  }

  const fetchAllMapServices = async () => {
    setMapServicesLoading(true);
    try {
      const res = await axios.post(`${REST_API}webservice/route/fetch-routes-with-locations`,{ requestId : id })
      let data = res.data?.routeData
      if(data){
        const newData = data?.filter((i) => i.locations != null)
        if(newData){
          setMapServices(newData);
        }else{
          setMapServices([]);
        }
      }else{
        setMapServices([]);
      }
    } catch (error) {
      setMapServices([]);
      console.log(error, 'Error in fetching map services');
    }finally {
      setMapServicesLoading(false)
    }
  }

  const fetchAllClients = async (clientId) => {
    const requestClientId = clientId ||details?.partners[0]?.id || null
    try {
      const res = await axios.post(`${REST_API}webservice/clients/getAllClients`, { userType, userId,order:true ,From:"addSalesOrder",teamId })
      let data = res.data?.customer
      await setAllClientsEdit(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients', error)
    }
  }

  const fetchTeamMembersForCollaborators = async () => {
    setTeamMembersLoading(true);
    try {
      const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
        usersId: userId,
        usersType: userType,
        isClient: isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      });
      const raw = res.data?.team_members?.data || res.data?.team_members || [];
      const list = Array.isArray(raw) ? raw : [];
      const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
      setTeamMembersOptions(filteredList);
      setAllTeamMembers(filteredList);
    } catch (error) {
      console.log(error, 'Error fetching team members for collaborators');
      setTeamMembersOptions([]);
    } finally {
      setTeamMembersLoading(false);
    }
  }

  useEffect(() => {
    if (!id) return;
    console.log('id=outside=3==',id)
    fetchRequestDetailsNew()
    fetchRequestDetails()
    fetchProductAndMaterials()
    fetchTaxCategory()
    fetchAllMapServices()
    // fetchAllClients()
    fetchTeamMembersForCollaborators()

    // setFieldValue('markup_type', markupTypes[1])
    setMarkupType(markupTypes[1]?.id)
  }, [id, refresh, combineGroupedInvoice, effectiveCombineGroupedInvoice])
  console.log('reqqqqqqqqqqqqqqqqqqq details',details)
  console.log('reqqqqqqqqqqqqqqqqqqq invoice',invoice)
  useEffect(() => {
    if (!id) return;
    try {
      axios
        .post(`${REST_API_END_POINT}project/get-data-for-add-project`, {isSalesOrder:true}, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          if (response.data.status === 1) {
            setProjectTypes(response.data.projectTypes)
            setProjectCategories(response.data.projectCategories)
            setNoChargeType(response.data.noChargeType)
          } else {
            setProjectTypes([])
            setProjectCategories([])
            setNoChargeType([])
          }
        })
        .catch((error) => {
          console.error(error)
          setProjectTypes([])
          setProjectCategories([])
          setNoChargeType([])
        })
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }, [id, refresh])

  useEffect(() => {
    // Sync collaborators state from current data when team member options load
    const raw = currentRFQData?.collaborators || details?.collaborators || null;
    if (!raw) return;
    const collaboratorIds = Array.isArray(raw)
      ? raw.map((c) => String(c?.id ?? c))
      : String(raw || '').split(',').map((s) => s.trim()).filter(Boolean);
    if (teamMembersOptions && teamMembersOptions.length > 0) {
      const selected = teamMembersOptions.filter((opt) => collaboratorIds.includes(String(opt.id)));
      setCollaborators(selected);
    }
  }, [teamMembersOptions, currentRFQData, details]);
  //rfq product detais
  const fetchOrderProductDetails = async () => {
    try {
      // cancelAllGlobalRequests('fetchOrderProductDetails');
      setLoadingEditInvoice(true)
      const targetFacilityId = isMirrored ? details?.real_origin_facility_id : null;
      let orderId = isMirrored ? details?.real_origin_facility_request_id : (id || details?.id) ;
      if (orderId && (orderId != 'undefined')) {
        const [res, groupsRes] = await Promise.all([
          axios.post(`${REST_API}webservice/get-customer-order-product/${orderId}`, { isMirrored : isMirrored, targetFacilityId, userType, userId, From:"addSalesOrder", teamId: userType !== 12 ? teamId : null, combineGroupedInvoice: !!effectiveCombineGroupedInvoice}),
          id
            ? axios.post(`${REST_API}webservice/view-request-groups`, { request_id: id })
            : Promise.resolve({ data: { customerOrderProductGroups: [] } }),
        ]);
        const groupsFromApi = groupsRes?.data?.customerOrderProductGroups || []
        if (groupsFromApi.length) {
          setCustomerOrderProductGroups(groupsFromApi)
        }
     
      
        const invoiceData = res?.data?.data
        setTaxAmount(res.data.data?.tax_amount || 0)

        // console.log("res.data.datares.data.datares.data.data",res?.data?.data)
        // let jobcostTotal = 0
        // let jobcostServiceTotal = 0
        // if(invoiceData?.jobcost_product && invoiceData?.jobcost_product?.length > 0){
        //   jobcostTotal = invoiceData?.jobcost_product?.reduce((sum, product) => {
        //     return sum + (product.total || 0);
        //   }, 0);
        // }
        // if(invoiceData?.jobcost_service && invoiceData?.jobcost_service?.length > 0){
        //   jobcostServiceTotal = invoiceData?.jobcost_service?.filter(it=>it.total_cost == 0)?.reduce((sum, product) => {
        //     return sum + (parseFloat(product.total_service_cost) || 0);
        //   }, 0);
        // }
        const jobcostTotal = invoiceData?.jobcost_product?.reduce((sum, product) => sum + (product.total || 0), 0) || 0;
        const jobcostServiceTotal = invoiceData?.jobcost_service?.reduce((sum, product) => sum + (parseFloat(product.total_service_cost) || 0), 0) || 0;
  
        const isMergedGroupedInvoice = Number(invoiceData?.is_grouped_invoice_combined || 0) === 1;
        const isDedicatedGroupedParent = Number(details?.is_grouped_request || 0) === 1;
        const total = invoiceData?.total || 0;
        const extraDiscount = parseFloat(invoice?.extra_discount) || 0;
        const taxAmount = parseFloat(invoice?.tax_amount) || 0;
        const totalPaidAmount = details?.totalPaidAmount || 0;

        // let grandTotal = (total + (jobcostTotal || 0) + (jobcostServiceTotal || 0)) - extraDiscount + taxAmount;
        // const grandTotal = details?.allInstallationCompleted ? invoiceData?.total : invoiceData?.grandTotal || 0;
        // Combined parent: keep grandTotal in sync with total so card/preview match view Subtotal.
      //  const grandTotal = isMergedGroupedInvoice
      //     ? (invoiceData?.grandTotal || invoiceData?.total || 0)
        const grandTotal = (isMergedGroupedInvoice || isDedicatedGroupedParent)
          ? (invoiceData?.total || invoiceData?.grandTotal || 0)
          : (details?.project_category == 12 ? invoiceData?.total : invoiceData?.grandTotal || 0);
        let balanceDue = grandTotal - totalPaidAmount;

        const updatedInvoiceData = {
          ...invoiceData,
          jobcostTotal,
          jobcostServiceTotal,
          grandTotal : grandTotal || invoiceData?.total,
          //  ...(isMergedGroupedInvoice ? { total: grandTotal || invoiceData?.total } : {}),
          ...((isMergedGroupedInvoice || isDedicatedGroupedParent) ? { total: grandTotal || invoiceData?.total } : {}),
          newBalanceDue : balanceDue
        };
        // console.log('updatedInvoiceData===',updatedInvoiceData)
        setInvoice(updatedInvoiceData);


        const rfqServicesData = updatedInvoiceData?.cust_product?.flatMap(product => {
          // console.log('product1234', product)
          return (product.services || []).map(service => ({
            ...service,
            productIndex: product.product_index,
            product_id: product.product_id,
            qtyData: product.quantity,
            locationQuantity: product.locationQuantity || 1,
            productName :product?.product_name
    
          }));
        });
        let labourInstallData =rfqServicesData?.filter(item =>item.labour_cost_service_id == 10)
        setLabourInstallService(labourInstallData)

        // Sort communities alphanumerically by name
        const sortedCommunities = [...(res?.data?.community || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setCommunities(sortedCommunities)

        let rfqCommunity = (res?.data?.community || [])?.find(com => details?.community === com.id)

        // Sales reps dropdown: populate all sales reps for selected project
        const repOptions = getSalesRepOptionsFromCommunity(rfqCommunity);
        console.log('repOptions',repOptions)
        setSalesRepOptions(repOptions);
        // setAllSalesRepIds(rfqCommunity?.all_sales_rep_ids || rfqCommunity?.sales_rep_ids || '');
        if (repOptions.length > 0) {
          // Keep current behavior (auto-select first), but allow changing via dropdown
          setSalesRepName(repOptions?.find(rep => rep.id === details?.sales_rep_ids)?.name || '');
          setSalesRepId(repOptions?.find(rep => rep.id === details?.sales_rep_ids)?.id || null);
        } else {
          setSalesRepName('');
          setSalesRepId(null);
        }

        if(rfqCommunity){
          const { address, city, state, zip } = rfqCommunity;
          setAdditionalSelectedServices((prevServices) =>
            prevServices.map((service) => {
              const updatedAddresses = (service.addresses || []).map((loc) => ({
                ...loc,
                address: address || loc.address,
                city: city || loc.city,
                state: state || loc.state,
                zip: zip || loc.zip,
              }));
              return { ...service, makeAsTask: service?.makeAsTask_lcs, makeInstallCard: service?.makeInstallCard_lcs, addresses: updatedAddresses };
            })
          );
        }

        // NEW: Return enriched invoice so preview can wire services AFTER fetch completes
        // (old `return res?.data` alone left callers without jobcostTotal/grandTotal enrichment)
        return {
          ...res?.data,
          data: updatedInvoiceData,
          updatedInvoiceData,
        };
        // OLD:
        // return res?.data;
      }
    } catch (error) {
      console.error('Error fetching request details:', error);
    }
    finally{
      setLoadingEditInvoice(false)
    }
  };

  // NEW: Build invoice-preview service state from the freshly fetched invoice payload.
  // Extracted so we never wire services from stale `invoice` React state before fetch finishes
  // (that race made Subtotal wrong the first time the preview opened).
  const applyInvoicePreviewServices = (invoiceData, servicesFromApi, rfpFromApi) => {
    const rfqServicesData = invoiceData?.cust_product?.flatMap((product) => {
      return (product.services || []).map((service) => ({
        ...service,
        productIndex: product.product_index,
        product_id: product.product_id,
        qtyData: product.quantity,
        locationQuantity: product.locationQuantity || 1,
        productName: product?.product_name,
      }));
    }) || [];

    setLabourInstallService(rfqServicesData.filter((item) => item.labour_cost_service_id == 10));

    const newrfqServicesData = rfqServicesData
      .filter((item) => {
        const newQty = parseFloat((item.prQty * item.qtyData * item.locationQuantity)?.toFixed(2));
        return newQty !== item.qty;
      })
      .map((item) => {
        const newQty = item.prQty * item.qtyData * item.locationQuantity;
        const quantityDifference =
          details?.job_category_name === 'Time & Material' ? 0 : item.qty - newQty;
        return {
          ...item,
          quantity: quantityDifference,
          quantityDifference,
          total_cost: item.unit_cost * quantityDifference,
        };
      });

    setInvoiceSelectedServices(newrfqServicesData || []);

    const additionalServices = dedupeRequestServicesByRowId(
      servicesFromApi?.filter((item) => item?.recipe_id === null),
    );
    const updatedServicesData = (additionalServices || []).map((serviceItem, index) => {
      const mappedService = mapAdditionalServiceFromApi(serviceItem, index);
      return {
        ...mappedService,
        productId: serviceItem.labour_cost_service_id,
        makeAsTask: serviceItem?.makeAsTask_lcs,
        makeInstallCard: serviceItem?.makeInstallCard_lcs,
        facility_id: serviceItem?.facility_id,
        name: serviceItem?.name || serviceItem?.service_name,
        addresses: [
          {
            address: serviceItem.address,
            city: serviceItem.city,
            state: serviceItem.state,
            zip: serviceItem.zip,
          },
        ],
      };
    });
    setAdditionalSelectedServices(updatedServicesData);

    const rfpServices = rfpFromApi?.filter((item) => item?.recipe_id === null && item?.rfp === 1);
    setCartService(rfpServices);
  };

  const handleJobLogUpdates = async (search = '') => {
    try {
      const res = await axios.post(`${REST_API}webservice/request/get-job-log-updates`, {
        request_id: id,
        userId,
        userType,
        combineGroupedInvoice: !!effectiveCombineGroupedInvoice,
        search,
      });

      if (res.data.status === 1) {
        if (!search) {
          setUpdates(res.data.updates)
        }
        return res.data.updates || []
      }
      return []
    } catch (error) {
      console.error('Error fetching job log details:', error);
      if (search) {
        return []
      }
      throw error;
    }
  };

  const handleJobLogSearch = useCallback(async (search) => {
    return handleJobLogUpdates(search);
  }, [id, userId, userType, combineGroupedInvoice]);

  useEffect(() => {
    if (currentTab === 'Job Log') {
      handleJobLogUpdates();
    }
  }, [currentTab, effectiveCombineGroupedInvoice, id]);

  const groupedCombinedHiddenTabs = [
    'client message board',
    'Job Notes',
    'Design Notes',
    'payments',
    'Locations and Notes',
    'Installation Reports',
    'Route - Map Services',
  ];
  useEffect(() => {
    if (isGroupedCombinedView && groupedCombinedHiddenTabs.includes(currentTab)) {
      setCurrentTab(user.isVendor ? 'Details' : 'Sales Order Details');
    }
  }, [isGroupedCombinedView, currentTab, user.isVendor]);
  // useEffect(()=>{

    
  //   let rfqCommunity = communities?.find(com => details.community === com.id)
  //   console.log("additionalSelectedServicesrfqCommunity",rfqCommunity)
  //   console.log("additionalSelectedServicesadditionalSelectedServices",additionalSelectedServices)

  //   if(rfqCommunity){
  //     const { address, city, state, zip } = rfqCommunity;
  //     setAdditionalSelectedServices((prevServices) =>
  //       prevServices.map((service) => {
  //         const updatedAddresses = service.addresses.map((loc) => ({
  //           ...loc,
  //           address: address || loc.address,
  //           city: city || loc.city,
  //           state: state || loc.state,
  //           zip: zip || loc.zip,
  //         }));
  //         return { ...service, addresses: updatedAddresses };
  //       })
  //     );
  //   }

  //   assignProjectAgain()

  // },[communities,details,loadingEdit])

  const assignProjectAgain = (rfqCommunity, shouldCallAssignProject, shouldCallAssignProjectRFP, shouldCallAssignProjectProducts) => {
    console.log('New Value:', rfqCommunity);
    const { address, city, state, zip } = rfqCommunity;
    if (shouldCallAssignProjectProducts) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) => {
          const locations = product.location?.length
            ? product.location
            : [{ id: 0, address: '', city: '', state: '', zip: '' }];
          const updatedLocations = locations.map((loc) => ({
            ...loc,
            address: address ?? loc.address,
            city: city ?? loc.city,
            state: state ?? loc.state,
            zip: zip ?? loc.zip,
          }));

          return { ...product, location: updatedLocations };
        })
      );
    }
    if (shouldCallAssignProject) {
      setAdditionalSelectedServices((prevServices) =>
        prevServices.map((service) => {
          const updatedAddresses = service.addresses?.map((loc) => ({
            ...loc,
            address: address ?? loc.address,
            city: city ?? loc.city,
            state: state ?? loc.state,
            zip: zip ?? loc.zip,
          })) ?? []; // Ensures addresses is never undefined
  
          return { ...service, addresses: updatedAddresses };
        })
      );
    }
    if (shouldCallAssignProjectRFP) {
      setCartService((prevServices) =>
        prevServices.map((service) => {
          const updatedAddresses = service.addresses?.map((loc) => ({
            ...loc,
            address: address ?? loc.address,
            city: city ?? loc.city,
            state: state ?? loc.state,
            zip: zip ?? loc.zip,
          })) ?? []; 
  
          return { ...service, addresses: updatedAddresses };
        })
      );
    }
  };

  const handleSendEmail = async () => {
    try {
      let orderId = details?.id;
      const res = await axios.post(`${REST_API}webservice/settings/send-mail`, { id: orderId, allInstallationCompleted:details?.allInstallationCompleted || null });

      if (res.data.status === 1) {
        enqueueSnackbar('Email send successfully', { variant: 'success' });
        setOpenInvoice(false)
      }
      return res.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };

  const handleSendInvoiceEmail = () => {
    if (!invoice || !details) {
      enqueueSnackbar('Invoice data not available', { variant: 'warning' });
      return;
    }
    
    // Create invoice PDF object formatted for SendDesignsEmailModal
    const pageTypePrefix = (location?.state?.isFromCompletedTab ?? isFromCompletedTab ?? false)
      ? 'invoice' : details?.installation_acceptance == 1 ? 'invoice'
      : 'sales_order';
    const groupedDesignOrderDisplayRows = serializeDesignOrderGroupedRowsForInvoice(
      buildGroupedDesignOrderDisplayRows({
        designOrderProducts: invoice?.cust_product || selectedProducts || [],
        customerOrderProductGroups,
        markupType: Number(markupType ?? details?.markup_type) || 2,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      }),
    );
    const invoicePdfObject = {
      id: `invoice_${details.id}`,
      name: `${pageTypePrefix}_${details.name || details.id}_${moment().format('YYYY-MM-DD')}.pdf`,
      file_type: 'application/pdf',
      extension: 'pdf',
      url: null, // Will be generated on backend
      invoiceData: {
        invoice: invoice,
        details: details,
        invoiceDate: invoiceDate,
        subTotal: treatInvoiceAsTimeMaterial
          ? subTotal
          : invoiceModalCustProductSubtotalForServices,
        groupedInvoiceProductTotal: invoiceModalProductTotalFromRows,
        groupedInvoiceInstallTotal: invoiceModalInstallTotalFromRows,
        cartService: cartService,
        additionalSelectedServices: additionalSelectedServices,
        invoiceSelectedServices: invoiceSelectedServices,
        labourInstallService: labourInstallService,
        installation_acceptance: details?.installation_acceptance,
        isFromCompletedTab: location?.state?.isFromCompletedTab ?? isFromCompletedTab ?? false,
        customerOrderProductGroups: customerOrderProductGroups || [],
        markupType,
        groupProductMarketingValues,
        groupInstallMarketingValues,
        groupedDesignOrderDisplayRows,
        taxRateData: taxRateData,
        taxAmount: taxAmount,
      }
    };
    
    setInvoicePdfData([invoicePdfObject]);
    setOpenInvoiceEmailModal(true);
  };

  const handleInvoiceEmailSent = () => {
    setInvoicePdfData(null);
  };
  const fetchRequestServicesDetails = async () => {
    try {
      let orderId = details?.id;
      const res = await axios.post(`${REST_API}webservice/get-request-services/${orderId}`);
      setInvoice(res.data.data);
      return res.data.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };


  const ensureLabourCostServicesLoaded = async () => {
    if (labourCostServices?.length) return labourCostServices
    try {
      const loaded = await fetchLabourCostServicesForDropdown(axios, REST_API, {
        isNotSplitOrder: isSplitOrder ? false : true,
      })
      if (loaded.length) {
        const sorted = [...loaded].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setLabourCostServices(sorted)
        setFilteredServices(sorted)
      }
      return loaded
    } catch (error) {
      console.error('Error loading labour cost services:', error)
      return []
    }
  }

  const addingInitialdataRFQ = async () => {
    // setLoadingEdit(true)
    try {
      if (openEdit) {
        let servicesArray = details?.services?.split(',')?.map(Number);
        let workflowSet = details?.workflows?.split(',')?.map(Number);
        const newInvoiceData = await fetchOrderProductDetails();
        const invoiceData = newInvoiceData?.data
        const communityData = newInvoiceData?.community
        
        console.log('🔍 addingInitialdataRFQ - invoiceData:', invoiceData);
        console.log('🔍 addingInitialdataRFQ - allProducts length:', allProducts?.length);
        console.log('🔍 addingInitialdataRFQ - cust_product count:', invoiceData?.cust_product?.length);
        
        if (!invoiceData || !invoiceData.cust_product) {
          console.warn('⚠️ No invoiceData or cust_product found');
          // Still sync Order Date so edit picker matches print/email after reaching invoice stage
          setCurrentRFQdata((prev) => ({
            ...prev,
            name: details?.name,
            timestamp: details?.timestamp,
            po_number: details?.po_number,
            description: details?.description,
            notes: details?.notes,
          }));
          return;
        }
        const rfqTaxCategory = taxCategories?.find(cat => invoiceData.tax_category === cat.id) || null
        setSelectedTaxCategory(rfqTaxCategory)
        // let rfqSkill = skills?.filter((row) => row.id == details?.services);
        // let rfqSkill = skills.filter(skill => servicesArray.includes(skill.id));
        // let rfqWorkFlow = workflow?.filter(skill => workflowSet?.includes(skill.id));
        let rfqProjectType = projectTypes?.find(type => details.project_type === type.id)
        let rfqCustomerData = allClientsEdit?.find(cat => cat?.id === customerData?.customer_id);
        let rfqProjectcategory = projectCategories?.find(cat => details.project_category === cat.id)
        let rfqNOChargeTypes = noChargeType?.find(cat => details.no_charge_type === cat.id)
        let rfqMarkupType = markupTypes?.find(cat => details?.markup_type === cat.id)
        let rfqMapServices = mapServices?.find(cat=>details?.map_service === cat.id)   
        let rfqCommunity = communityData?.find(com => details.community === com.id)

        // rfqProduct = invoiceData?.cust_product.filter((row) => {
        //   return allProducts.filter(data => data.id == row.product_id)
        // })
        let rfqProduct = [];
        // if(rfqProjectcategory?.name == 'Time & Material'){
        //   rfqProduct = invoiceData?.cust_product?.filter((newItem)=>(newItem.material != 1 && newItem.rfp != 1))?.map((row) => {
        //       return {
        //         ...row,
        //         indexId: row.product_index,
        //         retail_price: row.product_retail_price || row.retail_price || 0,
        //         price:row.product_price || row.price || 0,
        //         expected_cost:0,
        //         expected_total_service_cost:0,
        //         expected_service_cost:0,
        //         expected_material_cost:0,
        //         markAdjType:row.markAdjType

        //       };
        //   }).filter(item => item !== undefined);
        // }else{
          rfqProduct = invoiceData?.cust_product?.filter((row) => row.rfp === 0 && row.material===0)?.map((row) => {
            // First try to find exact match with facility_id
            let match = allProducts?.find(
              (data) =>
                data.id == row.product_id &&
                data.facility_id == row.facility_id
            );
            
            // If no exact match, try matching by product_id only (for cases where facility_id might be null/undefined)
            if (!match) {
              match = allProducts?.find(
                (data) => data.id == row.product_id
              );
            }
            
            console.log('row---------', row)
            console.log('match found---------', match ? 'YES' : 'NO', { product_id: row.product_id, facility_id: row.facility_id })
            
            if (match) {
              const isPendingEstimateCatalog =
                Number(match.status) === 0 &&
                Number(match.created_with_approval) === 1 &&
                Number(match.inhouse) === 7
              if (Number(match.status) !== 1 && !isPendingEstimateCatalog) {
                console.warn('Omitting inactive catalog from SO edit (matched but inactive):', row.product_id, match?.name);
                return null;
              }
              const isLoadedNoChargeProduct = details?.project_category == 13
              const savedAdjustment = row?.adj_value_type === false ? -(Number(row?.adjustment) || 0) : (Number(row?.adjustment) || 0)
              const catalogActualRetail = Number(match?.product_retail_price ?? match?.actual_retail_price ?? match?.retail_price ?? match?.max_price ?? 0)
              const catalogOriginalActualRetail = catalogActualRetail ? catalogActualRetail - savedAdjustment : undefined
              const catalogInstallCost = match?.install_cost ?? match?.product_install_cost ?? row?.install_cost
              const catalogRetail = catalogOriginalActualRetail != null
                ? catalogOriginalActualRetail + (Number(catalogInstallCost) || 0) + savedAdjustment
                : undefined
              // If a match is found, return a new object with data from allProducts and quantity from invoiceData?.cust_product
              return {
                ...match,
                ...hydrateSavedOrderLinePrices(row, match),
                indexId: row.product_index,
                product_notes: row.product_notes,
                install_notes: row.install_notes,
                discount: row.discount,
                adjustment: row.adjustment,
                install_cost: row.install_cost,
                // original_install_cost: match.install_cost,
                install_adjustment: row.install_adjustment,
                install_adj_value_type: row.install_adj_value_type,
                install_formula_cost_each: row.install_formula_cost_each ?? null,
                product_formula_cost_each: row.product_formula_cost_each ?? null,
                install_quantity: row.install_quantity ?? row.install_qty,
                productAttachments: row.attachments,
                backendId: row.id || null,
                quantity: row.quantity,
                location: row.location,
                allLocationSame:row.allLocationSame == 1 ? true : false,
                locationQuantity: row.locationQuantity,
                group_product_quantity:
                  row.group_product_quantity ?? row.locationQuantity ?? row.location_quantity ?? 1,
                group_install_quantity:
                  row.group_install_quantity ?? row.install_qty ?? row.install_quantity ?? 1,
                markAdjType:row.markAdjType,
                fromMapServices : row.map_service == 1 ? true : false,
                is_single_card : row.is_single_card == 1 ? true : false,
                group_id: row.group_id || row.customer_order_product_group_id || null,
                group_name: row.group_name || null,
                group_description: row.group_description || null,
                group_catalog_anchor_index_id:
                  row.group_catalog_anchor_index_id != null && row.group_catalog_anchor_index_id !== ''
                    ? Number(row.group_catalog_anchor_index_id)
                    : null,
                // product_install_cost : row.install_cost || match.install_cost,
                max_price_mi_id:row.materialInvId || null,
                split_percentage: row.split_percentage,
                incoming_split_percentage: row.incoming_split_percentage,
                outgoing_split_percentage: row.split_percentage,
                facility_id: row.facility_id,
                adj_value_type: row.adj_value_type,
                // Hydrate Delivery & Installation selection from DB (customer_order_products)
                delivery_installation:
                  row?.delivery_installation || row?.delivery_type_id || row?.complete_status || row?.installer_facility_id
                    ? {
                        ...(row?.delivery_installation || {}),
                        delivery_type_id: Number(row?.delivery_installation?.delivery_type_id || row?.delivery_type_id || row?.complete_status || 1),
                        installer_facility_id: Number(row?.delivery_installation?.installer_facility_id || row?.installer_facility_id || 0),
                        installer_facility_name: row?.delivery_installation?.installer_facility_name || (row?.installer_facility_id
                          ? getFacilityOption(row?.installer_facility_id)?.name
                          : row?.delivery_installation?.installer_facility_id
                          ? getFacilityOption(row?.delivery_installation?.installer_facility_id)?.name
                          : null
                        ),
                      }
                    : null,
                    sub_contract_markup : match?.markup,
                    name : row.product_name || match?.name,
                    description : row.product_desc || match?.description,
                    current_workflow: row.current_workflow,
                    ...(isLoadedNoChargeProduct ? {
                      expected_cost_before_no_charge: Number((match?.expected_service_cost_with_markup || 0) + (match?.expected_material_cost_with_markup || 0)) || undefined,
                      retail_price_before_no_charge: catalogRetail,
                      actual_retail_price_before_no_charge: catalogActualRetail || undefined,
                      product_retail_price_before_no_charge: catalogActualRetail || undefined,
                      price_before_no_charge: match?.price,
                      original_actual_retail_price_before_no_charge: catalogOriginalActualRetail,
                      original_retail_price_before_no_charge: catalogOriginalActualRetail != null ? catalogOriginalActualRetail + (Number(catalogInstallCost) || 0) : undefined,
                      original_price_before_no_charge: match?.price,
                      install_cost_before_no_charge: catalogInstallCost,
                      original_install_cost_before_no_charge: catalogInstallCost,
                    } : {}),
                ...(row.group_id || row.customer_order_product_group_id
                  ? hydrateGroupedMemberMarketingFromRow(row)
                  : {}),
              };
            } else {
              // Inactive/deleted catalogs are omitted from active allProducts. Do not rebuild them
              // for edit UI — user must not see or re-save them. Pending-estimate catalogs (status 0 +
              // created_with_approval) are the exception and still use the COP-row fallback.
              const catalogStatus =
                row.product_catalog_status != null ? Number(row.product_catalog_status) : null;
              const isPendingEstimateCatalog =
                catalogStatus === 0 &&
                Number(row.created_with_approval) === 1 &&
                Number(row.inhouse) === 7;

              if (catalogStatus === 2) {
                console.warn('Omitting deleted catalog from SO edit:', row.product_id, row.catalog_product_name || row.product_name);
                return null;
              }
              if (catalogStatus === 0 && !isPendingEstimateCatalog) {
                console.warn('Omitting inactive catalog from SO edit:', row.product_id, row.catalog_product_name || row.product_name);
                return null;
              }
              if (catalogStatus == null && row.product_id) {
                console.warn('Omitting missing catalog from SO edit:', row.product_id);
                return null;
              }

              // Fallback: use row data directly if no match found in allProducts (e.g. pending estimate)
              console.warn('No product match found in allProducts for product_id:', row.product_id, 'Using row data as fallback');
              return {
                ...row,
                id: row.product_id,
                backendId: row.id || null,
                productAttachments: row.attachments,
                indexId: row.product_index,
                name: row.product_name || row.name,
                product_name: row.product_name || row.name,
                allLocationSame: row.allLocationSame == 1 ? true : false,
                fromMapServices: row.map_service == 1 ? true : false,
                is_single_card: row.is_single_card == 1 ? true : false,
                group_id: row.group_id || row.customer_order_product_group_id || null,
                group_name: row.group_name || null,
                group_description: row.group_description || null,
                group_product_quantity:
                  row.group_product_quantity ?? row.locationQuantity ?? row.location_quantity ?? 1,
                group_install_quantity:
                  row.group_install_quantity ?? row.install_qty ?? row.install_quantity ?? 1,
                group_catalog_anchor_index_id:
                  row.group_catalog_anchor_index_id != null && row.group_catalog_anchor_index_id !== ''
                    ? Number(row.group_catalog_anchor_index_id)
                    : null,
                delivery_installation:
                  row?.delivery_installation || row?.delivery_type_id || row?.complete_status || row?.installer_facility_id
                    ? {
                        ...(row?.delivery_installation || {}),
                        delivery_type_id: Number(row?.delivery_installation?.delivery_type_id || row?.delivery_type_id || row?.complete_status || 1),
                        installer_facility_id: Number(row?.delivery_installation?.installer_facility_id || row?.installer_facility_id || 0),
                        installer_facility_name: row?.delivery_installation?.installer_facility_name || (row?.installer_facility_id
                          ? getFacilityOption(row?.installer_facility_id)?.name
                          : row?.delivery_installation?.installer_facility_id
                          ? getFacilityOption(row?.delivery_installation?.installer_facility_id)?.name
                          : null
                        ),
                      }
                    : null,
                    current_workflow: row.current_workflow,
                    install_formula_cost_each: row.install_formula_cost_each ?? null,
                    product_formula_cost_each: row.product_formula_cost_each ?? null,
                    ...hydrateSavedOrderLinePrices(row),
                    ...(row.group_id || row.customer_order_product_group_id
                      ? hydrateGroupedMemberMarketingFromRow(row)
                      : {}),
              };
            }
          }).filter(item => item !== undefined && item !== null);
        // }

        console.log("####################RFQ", rfqProduct);
        console.log("invoiceData----", invoiceData);

        const highestIndexId = rfqProduct?.reduce((max, product) => {
          return typeof product.indexId === 'number' && product.indexId > max ? product.indexId : max;
        }, 0);

        setIndexCounter(highestIndexId);
        const filteredData = rfqProduct?.filter(item=>item?.fromMapServices == true)
        setSelectedMapserviceProducts(filteredData || [])
        setSelectedProducts(rfqProduct || [])
        
        // Populate productAttachments state with attachments from fetched data
        const attachmentsMap = {};
        const productLevelRequestAttachments = (designs || []).filter(
          (att) => att?.product_id != null && att?.product_id !== '',
        )
        rfqProduct?.forEach((product) => {
          if (product.indexId == null || product.indexId === '') return

          const mappedByProductId = productLevelRequestAttachments.filter((att) => {
            const requestProductId = Number(att?.product_id)
            if (!Number.isFinite(requestProductId)) return false
            const productBackendId = Number(product?.backendId)
            const productId = Number(product?.id || product?.product_id)
            return requestProductId === productBackendId || requestProductId === productId
          })

          const existingAttachments = product.productAttachments
            ? (Array.isArray(product.productAttachments)
              ? product.productAttachments
              : [product.productAttachments])
            : []

          const raw = [...existingAttachments, ...mappedByProductId]
          if (!raw.length) return

          const seen = new Set()
          const formattedAttachments = raw
            .filter((att) => {
              const key = att?.url || att?.name || att?.file_url
              if (!key || seen.has(key)) return false
              seen.add(key)
              return true
            })
            .map((att) => ({
              url: att.url || att.name || att.file_url,
              name: att.name || att.file_url || att.url,
              file_type: att.file_type || att.fileType || 'application/octet-stream',
              extension: att.extension || att.name?.split('.').pop() || '',
              size: att.size || att.file_size || 0,
              product_index_id: product.indexId,
            }))

          attachmentsMap[product.indexId] = formattedAttachments
          console.log('📎 [VIEW] Loaded attachments for product:', {
            indexId: product.indexId,
            attachmentsCount: formattedAttachments.length,
            attachments: formattedAttachments,
          })
        });
        const groupMembersByGid = {}
        rfqProduct?.forEach((product) => {
          const gid = getProductGroupId(product)
          if (gid == null || gid === '') return
          const key = String(gid)
          if (!groupMembersByGid[key]) groupMembersByGid[key] = []
          groupMembersByGid[key].push(product)
        })
        Object.values(groupMembersByGid).forEach((members) => {
          if (members.length <= 1) return
          const seen = new Set()
          const merged = []
          members.forEach((product) => {
            ;(attachmentsMap[product.indexId] || []).forEach((f) => {
              const fileKey = f?.url || f?.name
              if (fileKey && !seen.has(fileKey)) {
                seen.add(fileKey)
                merged.push(f)
              }
            })
          })
          if (!merged.length) return
          members.forEach((product) => {
            attachmentsMap[product.indexId] = merged.map((f) => ({
              ...f,
              product_index_id: product.indexId,
            }))
          })
        })
        console.log('📎 [VIEW] Total productAttachments loaded:', {
          totalProducts: Object.keys(attachmentsMap).length,
          attachmentsMap
        });
        setProductAttachments(attachmentsMap);


        // let rfpProduct = invoiceData?.cust_product.filter((row) => row.rfp === 1 && row.material===0)
        let rfpProduct = invoiceData?.cust_product.filter((row) => row.rfp === 1)
        console.log('rfpProduct---', rfpProduct)
        let materialsData = invoiceData?.cust_product.filter(row => row.material === 1 && row.rfp === 0);
        console.log('materialsData+++++++++++++++++++++++++++++', materialsData)

        let rfpProductUpdated = rfpProduct?.map(item => ({
          ...item,
          allRfpProductsLocationSame:item.allLocationSame == 1 ? true : false,
        }))
        console.log('rfpProduct---rfpProductUpdated', rfpProductUpdated)

        let materialsWithPrices = materialsData.map((material,index) => {
          let matchedMaterial = materials.find(item => item.id === material.product_id);
          console.log('materialsData+++++++++++++++++++++++++++++', matchedMaterial)
          console.log('materialsData+++++++++++++++++++++++++++++', material)
            const price = material.stock_type === 2
                    ? material.product_price
                    : (matchedMaterial ? matchedMaterial.max_price : material.product_price);
          // let price = material.product_price;
          console.log('materialsData+++++++++++++++++++++++++++++', price)
          return {
            ...material,
            newIndexId: index + 1,
            price,
            inhouse : matchedMaterial ? matchedMaterial.inhouse : 1,
            product_description:matchedMaterial ? matchedMaterial.description : material.description,
          };
        });
        setSelectedMaterials(materialsWithPrices)
        setCart(rfpProductUpdated);
        
        // Store initial data for change detection
        setInitialProducts(rfqProduct || []);
        setInitialMaterials(materialsWithPrices || []);
        setInitialRfpProducts(rfpProductUpdated || []);
        // const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1);
        const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1)?.map(serviceItem => ({
          ...serviceItem,
          location: [
            {
              address: serviceItem.address,
              city: serviceItem.city,
              state: serviceItem.state,
              zip: serviceItem.zip,
            }
          ],
        }));

        
        setCartService(rfpServices)
        console.log("####################rfpProduct", rfpProduct);
        console.log("####################rfpServices", rfpServices);



        // const serviceIdArray = details?.labour_cost_services?.split(',')?.map(Number);
        // const rfqServices = invoiceData?.cust_product?.map((row)=>
        //   labourCostServices?.find(data => data.id == row.id)
        // )
        //   const rfqServices = invoiceData?.cust_product?.map(product => {
        //     const productServices = product.services?.map(service => {
        //         const serviceData = labourCostServices.find(data => data.id === service.id);
        //         return serviceData;
        //     });

        //     // Return an object containing product details along with its services
        //     return productServices;
        // });
        const rfqServicesData =
          invoiceData?.cust_product?.flatMap((product) => {
            console.log('product123', product)
            return (product.services || []).map((service) => ({
              ...service,
              productIndex: product.product_index,
              product_id: product.product_id,
              qtyData: product.quantity,
              fromMapServices: product.map_service == 1 ? true : false,
              locationQuantity: product.locationQuantity || 0,
            }))
          }) ?? []
        console.log('##################rfqServiceData', rfqServicesData)
        await setSelectedServices(rfqServicesData)

        // Store initial services for change detection
        setInitialServices(requestServices || [])
        setInitialRfpServices(rfpServices || [])

        const servicesSource = await ensureLabourCostServicesLoaded()
        setFilteredServices(
          computeFilteredServicesForDropdown(servicesSource, rfqServicesData),
        )

        const additionalServices = dedupeRequestServicesByRowId(
          requestServices?.filter(item => item?.recipe_id === null),
        );
        const additionalServicesData = sortServicesByProductIndex(additionalServices || []);
        console.log('additionalServicesData-------',additionalServicesData)
        let newIndexCounter = serviceIndexCounter
        const updatedServicesData = additionalServicesData?.map((serviceItem, index) => {
          newIndexCounter = newIndexCounter + 1
          setServiceIndexCounter(newIndexCounter);
          console.log('newIndexCounter-------',newIndexCounter)
          const mappedService = mapAdditionalServiceFromApi(serviceItem, index)
          const matchedService = (servicesSource || []).find((service) =>
            Number(service?.id) === Number(serviceItem?.labour_cost_service_id || serviceItem?.id) &&
            (!serviceItem?.facility_id || Number(service?.facility_id) === Number(serviceItem?.facility_id))
          )
          return {
            ...mappedService,
            serviceAttachments: serviceItem?.attachments || [],
            productId : serviceItem.labour_cost_service_id,
            makeAsTask: serviceItem?.makeAsTask_lcs, 
            makeInstallCard: serviceItem?.makeInstallCard_lcs,
            facility_id: serviceItem?.facility_id,
            name:serviceItem?.name || serviceItem?.service_name,
            syncWithQuickbooks: serviceItem?.syncWithQuickbooks,
            delivery_installation:
                  serviceItem?.delivery_type_id || serviceItem?.installer_facility_id
                    ? {
                        delivery_type_id: Number(serviceItem?.delivery_type_id || 1),
                        installer_facility_id: Number(serviceItem?.installer_facility_id || 0),
                        installer_facility_name: serviceItem?.installer_facility_id
                          ? getFacilityOption(serviceItem?.installer_facility_id)?.name
                          : null,
                      }
                    : null,
            name: serviceItem.service_name || serviceItem.name,
            description: serviceItem.service_desc || serviceItem.description,
            ...(details?.project_category == 13 && matchedService ? {
              original_total_cost: matchedService?.total_cost ?? matchedService?.unit_cost ?? serviceItem?.total_cost,
              original_unit_cost: matchedService?.unit_cost ?? matchedService?.total_cost ?? serviceItem?.unit_cost,
              original_service_markup: matchedService?.originalMarkup ?? matchedService?.original_markup ?? serviceItem?.originalMarkup,
            } : {}),
            addresses: [
              {
                address: serviceItem.address,
                city: serviceItem.city,
                state: serviceItem.state,
                zip: serviceItem.zip,
              }
            ]
          };
        });
        console.log('updatedServicesData----',updatedServicesData);
        
        setAdditionalSelectedServices(updatedServicesData);

        // Populate serviceAttachments state with attachments from fetched data
        const serviceAttachmentsMap = {};
        (updatedServicesData || []).forEach((svc) => {
          const idx = svc?.indexId ?? svc?.newIndexId;
          const atts = Array.isArray(svc?.serviceAttachments) ? svc.serviceAttachments : (svc?.serviceAttachments ? [svc.serviceAttachments] : []);
          if (idx && atts.length > 0) {
            serviceAttachmentsMap[idx] = atts.map((att) => {
              const downloadUrl =
                att.url || att.file_url || (att.name && String(att.name).startsWith('http') ? att.name : null);
              const shortName =
                att.displayName ||
                (att.name && !String(att.name).startsWith('http') ? att.name : null);
              return {
                url: downloadUrl,
                name: shortName || downloadUrl,
                file_type: att.file_type || att.fileType || 'application/octet-stream',
                extension: att.extension || (downloadUrl || att.name || '').split('.').pop() || '',
                size: att.size || att.file_size || 0,
                service_index_id: idx,
              };
            });
          }
        });
        if (Object.keys(serviceAttachmentsMap).length > 0) {
          setServiceAttachments(serviceAttachmentsMap);
        }

        const shouldCallAssignProject = (updatedServicesData ?? []).some((service) =>
          (service.addresses ?? []).some((loc) =>
            !loc.address || !loc.city || !loc.state || !loc.zip
          )
        );
        
        const shouldCallAssignProjectRFP = (rfpServices ?? []).some((service) =>
          (service.addresses ?? []).some((loc) =>
            loc.address == null || loc.city == null || loc.state == null || loc.zip == null
          )
        );

        const shouldCallAssignProjectProducts = (rfqProduct ?? []).some((product) =>
          !(product.location ?? []).length ||
          (product.location ?? []).some((loc) =>
            loc.address == null || loc.city == null || loc.state == null || loc.zip == null
          )
        );
        
        if(rfqCommunity && (shouldCallAssignProject || shouldCallAssignProjectRFP || shouldCallAssignProjectProducts)){
          assignProjectAgain(rfqCommunity, shouldCallAssignProject, shouldCallAssignProjectRFP, shouldCallAssignProjectProducts);
        }
        setAllSalesRepIds(details?.sales_rep_ids || '')
        setCurrentRFQdata({
          name: details?.name,
          timestamp: details?.timestamp,
          no_charge_reason: details?.no_charge_reason || null,
          description: details?.description,
          notes: details?.notes,
          po_number: details?.po_number,
          // skills: rfqSkill,
          // workflow: rfqWorkFlow,
          client:rfqCustomerData,
          project_category: rfqProjectcategory,
          catalog_type : details?.catalog_type,
          no_charge_type: rfqNOChargeTypes,
          markup_type: rfqMarkupType,
          community: rfqCommunity,
          sales_rep_ids: details?.sales_rep_ids,
          sales_rep_names: details?.sales_rep_names,
          map_service: rfqMapServices,
          project_type: rfqProjectType,
          start: details?.submission_deadline,
          end: details?.participation_ends,
          installation_start_date: details?.installation_start_date,
          installation_end_date: details?.installation_end_date,
          labour_cost: details?.labour_cost,
          budget: invoiceData?.budget || 0,
          products: rfqProduct || null,
          services: additionalServicesData || null,
          invoice_discount: invoiceData?.extra_discount,
          welcome_message: details?.welcome_message == 1 ? true : false || null,
          show_install_price: details?.show_install_price ?? 1,
          rush_fee: details?.rush_fee == 1 ? 1 : 0,
          rush_fee_amount: details?.rush_fee_amount || 0,
          total: invoiceData?.total,
          taxAmount: invoiceData?.taxAmount || 0,
          tax: invoiceData?.tax,
          draft: details?.status == 1 ? true : false || null,
          sub_total: invoiceData?.sub_total,
          order_id: invoiceData?.id,
          subject: details?.subject || null,
          email_content: details?.email_content || null,
          estimate_id:details?.estimate_id,
          // avatarUrl:details?.thumbnail||null,
          facility_type: typeof details?.facility_type === 'string' && details.facility_type
          ? details.facility_type.split(',').map(id => 
              FacilityTypes.find(type => type.id == id.trim())
            ).filter(Boolean)
          : Array.isArray(details?.facility_type) 
            ? details.facility_type 
            : [],
          bill_to: details?.bill_to || '',
          ship_to: details?.ship_to || '',
        });
      }
    } catch (error) {
      console.error('Error adding initial data for Sales Order:', error);
    // } finally {
    //   setTimeout(() => {
    //     setLoadingEdit(false)
    //   }, 3000);
    }
  };

  useEffect(() => {
    if (invoice?.id) return;
    const mirroredNeedsDetails = isMirrored && !details?.real_origin_facility_request_id;
    const orderId = isMirrored
      ? details?.real_origin_facility_request_id
      : (id || details?.id);
    if (!mirroredNeedsDetails && orderId && orderId !== 'undefined') {
      fetchOrderProductDetails();
    }
    if (details){
 if(details?.is_service_location ==1 || details?.is_service_location !=0) {
      setAllServiceLocationSame(true)
    }else{
      setAllServiceLocationSame(false)
    }

    if(details?.is_rfp_service_location == 1){
      setAllRfpServiceLocationSame(true)
    }else{
      setAllRfpServiceLocationSame(false)
    }
    if(details?.is_rfp_product_location == 1){
      setAllRfpProductsLocationSame(true)
    }else{
      setAllRfpProductsLocationSame(false)
    }
  }
  }, [id, details, isMirrored, invoice?.id]);

  useEffect(() => {
    // NOTE:
    // Edit-mode product hydration depends on `allProducts` and `details`.
    // If the user opens edit before `allProducts` is loaded, the join will return no matches
    // and products won't show. We keep the loading screen up until products are ready,
    // and re-run once `allProducts` arrives.
    if (!openEdit) return;
    
    // Need details to have an id before we can fetch product details
    if (!details?.id) {
      setLoadingEdit(true);
      return;
    }

    // Keep spinner on while waiting for dependencies needed to hydrate products.
    if (!Array.isArray(allProducts) || allProducts.length === 0) {
      setLoadingEdit(true);
      return;
    }

    const loadInitialData = async () => {
      setLoadingEdit(true);
      try {
        await ensureLabourCostServicesLoaded();
        await addingInitialdataRFQ();
      } catch (error) {
        console.error('Error loading initial data for edit:', error);
      } finally {
        setLoadingEdit(false);
      }
    };

    loadInitialData();
  }, [openEdit, allProducts, details?.id, details?.timestamp, designs]);

  useEffect(() => {
    if (!openEdit || !labourCostServices?.length) return
    setFilteredServices(
      computeFilteredServicesForDropdown(labourCostServices, selectedServices),
    )
  }, [openEdit, labourCostServices, selectedServices])

    
  useEffect(() => {
    if (Array.isArray(jobNoteMembers) && user?.user_id) {
      const found = jobNoteMembers?.some(member => member.user_id === user.user_id);
      setIsMember(found);
    }
  }, [jobNoteMembers, user?.user_id]);

  // NEW: Load invoice preview only when preview is open; await fetch, then wire services from that result.
  // Fixes first-open wrong Subtotal (race: old code set services from stale invoice while fetch was still in flight).
  // Also wait for view-request (`loadingEditData`) so `requestServices` is available before print.
  useEffect(() => {
    if (!openInvoice || openEdit) {
      setInvoicePreviewReady(false);
      return;
    }
    // Services come from view-request → requestServices; wait until that load finishes
    if (loadingEditData) {
      setInvoicePreviewReady(false);
      return;
    }

    let cancelled = false;
    setInvoicePreviewReady(false);
    (async () => {
      try {
        const invoiceResult = await fetchOrderProductDetails();
        if (cancelled) return;
        const invoiceData = invoiceResult?.updatedInvoiceData || invoiceResult?.data;
        if (!invoiceData) return;
        applyInvoicePreviewServices(invoiceData, requestServices, rfpServicesEdit);
        if (!cancelled) setInvoicePreviewReady(true);
      } catch (error) {
        console.error('Error loading invoice preview for print:', error);
        if (!cancelled) setInvoicePreviewReady(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [openInvoice, openEdit, loadingEditData]);

  // Refresh company profile (rush fee %) whenever invoice modal / print surface opens
  useEffect(() => {
    if (openInvoice) {
      fetchDetails();
    }
  }, [openInvoice]);  
  // OLD (removed — raced on first open: fetch was not awaited, services used stale invoice.cust_product):
  // useEffect(() => {
  //   // Only fetch data when viewing invoice modal, not when editing
  //   if (!openEdit) {
  //     fetchOrderProductDetails();
  //   console.log('requestServices--', requestServices);
  //
  //   const rfqServicesData = invoice?.cust_product?.flatMap(product => {
  //     console.log('product1234', product)
  //     return product.services.map(service => ({
  //       ...service,
  //       productIndex: product.product_index,
  //       product_id: product.product_id,
  //       qtyData: product.quantity,
  //       locationQuantity: product.locationQuantity || 1,
  //       productName :product?.product_name
  //     }));
  //   });
  //   let labourInstallData =rfqServicesData?.filter(item =>item.labour_cost_service_id == 10)
  //   setLabourInstallService(labourInstallData)
  //   console.log("##################rfqInvoiceServiceData", rfqServicesData);
  //   const newrfqServicesData = rfqServicesData?.filter(item => {
  //     const newQty = parseFloat((item.prQty * item.qtyData * item.locationQuantity)?.toFixed(2));
  //     console.log('rfqInvoiceServiceDatanewQty-----------', newQty);
  //     console.log('rfqInvoiceServiceDataitem.qty-----------', item.qty);
  //     return newQty !== item.qty;
  //   }).map(item => {
  //     const newQty = item.prQty * item.qtyData * item.locationQuantity;
  //     let quantityDifference = 0;
  //     if(details?.job_category_name === 'Time & Material'){
  //       quantityDifference = 0;
  //     }else{
  //       quantityDifference = item.qty - newQty;
  //     }
  //     return {
  //       ...item,
  //       quantity: quantityDifference,
  //       quantityDifference: quantityDifference,
  //       total_cost: item.unit_cost * quantityDifference
  //     };
  //   });
  //
  //   console.log('newrfqServicesData-------', newrfqServicesData);
  //
  //   setInvoiceSelectedServices(newrfqServicesData || [])
  //
  //   const additionalServices = dedupeRequestServicesByRowId(
  //     requestServices?.filter(item => item?.recipe_id === null),
  //   );
  //   const additionalServicesData = additionalServices || [];
  //   const updatedServicesData = additionalServicesData?.map((serviceItem, index) => {
  //     const mappedService = mapAdditionalServiceFromApi(serviceItem, index)
  //     return {
  //       ...mappedService,
  //       productId : serviceItem.labour_cost_service_id,
  //       makeAsTask: serviceItem?.makeAsTask_lcs,
  //       makeInstallCard: serviceItem?.makeInstallCard_lcs,
  //       facility_id: serviceItem?.facility_id,
  //       name:serviceItem?.name || serviceItem?.service_name,
  //       addresses: [
  //         {
  //           address: serviceItem.address,
  //           city: serviceItem.city,
  //           state: serviceItem.state,
  //           zip: serviceItem.zip,
  //         }
  //       ]
  //     }
  //   })
  //   console.log('updatedServicesData----',updatedServicesData);
  //   setAdditionalSelectedServices(updatedServicesData);
  //   const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1);
  //
  //   setCartService(rfpServices)
  // // }, [openInvoice]);
  //   }
  // }, [openInvoice, openEdit]);



  const invoiceDate = formatDateOnly(details?.timestamp)

  //edit rfq
  const handleEditClick = () => {
    if (Number(details?.status) === 10) {
      enqueueSnackbar('Cannot edit a voided sales order', { variant: 'error' });
      return;
    }
    setOpenEdit(true)
  }
  const handleDeleteMenu = () => {
    setOpenDelete(!openDelete)
  }
  const handleVoidMenu = () => {
    setVoidReason('');
    setVoidReasonError('');
    setOpenVoid(!openVoid)
  }
  const handleReopen = () => {
    setReopen(!reOpen)
  }

  const addNewProductRow = () => {
    const newIndexCounter = indexCounter + 1
    setIndexCounter(newIndexCounter)
    const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    // Auto-populate addresses from the selected Project
    const newAddresses = [{
      id: 0,
      address: projAddress,
      city: projCity,
      state: projState,
      zip: projZip
    }];
  
    setSelectedProducts((prevProducts) => {
    // if (allLocationSame && prevProducts.length > 0) {
    //     const commonAddress = { ...prevProducts[0].addresses[0] } || {
    //     address: '',
    //     city: '',
    //     state: '',
    //     zip: '',
    //     };
    //     newAddresses[0] = commonAddress;
    // }
    return [
    ...prevProducts,
    { 
        indexId: newIndexCounter, 
        name: '', 
        quantity: 1, 
        price: 0,
        retail_price:0, 
        adjustment:0,
        unit:4,
        locationQuantity: 1, 
        expected_total_service_cost:0,
        expected_service_cost:0,
        expected_material_cost:0,
        discount: 0 ,
        allLocationSame: true,
        service:[],
        isAdditionalProduct:true,
        location: newAddresses,
        is_single_card:values?.project_category?.id !==14 ? true : false
    },
    ]});
  };


  const addNewServiceRow = () => {
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = ''
    } = values?.community || {};
  
    const newAddresses = [{
      id: 0,
      address: projAddress,
      city: projCity,
      state: projState,
      zip: projZip
    }];
  
    setAdditionalSelectedServices((prevServices) => {
      const maxId = prevServices.reduce(
        (max, item) => Math.max(max, item.newIndexId || 0),
        0
      );
  
      return [
        ...prevServices,
        {
          id: null,
          newIndexId: maxId + 1,
          // newIndexId: prevServices?.length + 1,
          name: '',
          avatarUrl: null,
          quantity: 1,
          cost: 0,
          markup: 0,
          workflow: null,
          originalMarkup: 0,
          service_type: null,
          total_cost: 0,
          product_total: 0,
          allLocationSame: true,
          isAdditionalProduct: true,
          addresses: newAddresses,
        }
      ];
    });
  };


  const addNewMaterialRow = () => {
    setSelectedMaterials((prevProducts) => {
      const maxId = prevProducts.reduce(
        (max, item) => Math.max(max, item.newIndexId || 0),
        0
      );
  
      return [
        ...prevProducts,
        {
          newIndexId: maxId + 1,
          // newIndexId: prevProducts?.length + 1,
          quantity: 1,
          allLocationSame: true,
          isAdditionalProduct: true,
          description: '',
          finishedProductQty: 0,
          markUpCost: 0,
          markup: 0,
          material_types: 1,
          max_price: null,
          max_value: 10,
          meterial: 1,
          min_value: 1,
          name: '',
          partial: 0,
          partialProductQty: 0,
          pf_retail_markup: null,
          price: 0,
          product_price:0,
          recipe_id: null,
          retail_price: 0,
          special_price: 0,
          tags: '',
          tax: null,
          tax_category: 0,
          total_qty: 0,
          twilio_field_value_sid: null,
          unit: 4,
          unit_qty: 0,
          vendor_id: '',
          vpt_number: '',
          product_retail_price:0,
          workflow: null,
          adj_value_type: true,
        }
      ];
    });
  };
  


  const handleProduct = (value) => {
  console.log('handleProduct---value--', value)
  console.log('handleProduct---selectedProducts--', selectedProducts)
  
    // Find deleted products and remove their linked images from avatarUrl
    const deletedProducts = selectedProducts?.filter((prevProduct) => {
      const isFromMapServices = prevProduct?.fromMapServices === true;
      const isAdditionalProduct = prevProduct?.isAdditionalProduct === true;
      // Only check products that are not from map services or additional products
      if (isFromMapServices || isAdditionalProduct) return false;
      
      // Check if this product still exists in the new value
      return !value.some((newProduct) => 
        (newProduct.id === prevProduct.id || newProduct.id === prevProduct.product_id) &&
        newProduct.indexId === prevProduct.indexId
      );
    });
    
    // Remove linked images for deleted products
    if (deletedProducts?.length > 0) {
      deletedProducts.forEach((deletedProduct) => {
        if (deletedProduct?.location) {
          const deletedLocationIds = deletedProduct.location.map(loc => loc.id || loc.request_location_id).filter(Boolean);
          if (deletedLocationIds.length > 0) {
            setAvatarUrl((prev) => {
              return prev.filter((file) => {
                if (!file?.location_ids) return true;
                const fileLocationIds = file.location_ids.split(',').map(id => parseInt(id.trim(), 10)).filter(Boolean);
                // Check if any of the deleted location IDs are in the file's location_ids
                const hasDeletedLocation = fileLocationIds.some(id => deletedLocationIds.includes(id));
                return !hasDeletedLocation;
              });
            });
          }
        }
        // Remove attachments from productAttachments for deleted product
        if (deletedProduct?.indexId) {
          setProductAttachments((prev) => {
            const updated = { ...prev };
            delete updated[deletedProduct.indexId];
            return updated;
          });
          // Also clear from selectedUploadedImages
          setSelectedUploadedImages((prev) => {
            const updated = { ...prev };
            delete updated[deletedProduct.indexId];
            return updated;
          });
        }
      });
    }
  
    // Extract community address from Formik's values
    const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
  
    setSelectedProducts((prevProducts) => {
  
      // Determine common address if allLocationSame is enabled
      // const commonAddress = allLocationSame && prevProducts.length > 0
      //   ? { ...prevProducts[0].location[0] }
      //   : null;
      const commonAddress = null;
      
      const updatedProducts = value.map((product) => {
        const dataRetailPrice = product.product_retail_price || product.retail_price;
        const dataWholesalePrice = product.product_price || product.price || 0;
  
        // Check if the product already exists in the selected products
        const existingProduct = prevProducts.find((p) =>
          (p.id === product.id || p.id === product.product_id) &&
          p.indexId !== undefined &&
          p.indexId === product.indexId
        );
  
        console.log("###############ExistingProduct", existingProduct);
  
        if (existingProduct) {
          // Update existing product's quantity and location
          const quantity = existingProduct.quantity;
          const locationQuantity = existingProduct.locationQuantity;
          const marketingAdjustment = Number(existingProduct?.adjustment);
          let location = [...existingProduct.location];
          // Preserve existing address if it exists, otherwise assign dynamically

          if (allLocationSame && commonAddress) {
            // Overwrite all location with the "common" location (from the first product)
            location = [...commonAddress];
          } else {
              // Ensure at least one address object
              for (let i = location.length; i < 1; i++) {
                location.push({
                  id: i,
                  address: '',
                  city: '',
                  state: '',
                  zip: '',
              });
              }
          }
  
          const rowTotal = calculateTotal(
            markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
            product.dataQuantity,
            product.dataDiscount,
            quantity,
            locationQuantity,
            marketingAdjustment,
          );
  
          return {
            ...existingProduct,
            quantity,
            rowTotal,
            location: location, // Ensure location is always an array
          };
        } else {
          // Add new product with default quantity and location
          const location = commonAddress || {
            id: 0,
            address: communityAddress.address || '',
            city: communityAddress.city || '',
            state: communityAddress.state || '',
            zip: communityAddress.zip || '',
          };
  
          const newIndexCounter = indexCounter + 1;
          setIndexCounter(newIndexCounter);

          // Auto-apply existing delivery/installer settings for this facility
          const existingDeliverySettings = getExistingDeliverySettingsForFacility(product.facility_id);

          const hasInstallCost =
            (Number(product?.install_cost) ||
              Number(product?.product_install_cost) ||
              Number(product?.original_install_cost) ||
              0) > 0
          return {
            ...product,
            indexId: newIndexCounter,
            quantity: 1,
            locationQuantity: 1,
            // Seed install qty so Sub Total includes install immediately (qty edit used to set this later)
            install_quantity:
              product?.install_quantity ??
              product?.install_qty ??
              (hasInstallCost ? 1 : 0),
            discount: 0,
            allLocationSame: true,
            adjustment: 0,
            markAdjType: 2,
            sub_contract_markup : product?.markup,
            product_formula_cost_each:
              product?.product_formula_cost_each != null && product?.product_formula_cost_each !== ''
                ? Number(product.product_formula_cost_each)
                : product?.inhouse === 0
                  ? Number(product?.sub_contract_price || 0)
                  : Number(
                      (Number(product?.expected_material_cost_with_markup) || 0) +
                        (Number(product?.expected_service_cost_with_markup) || 0),
                    ),
            install_formula_cost_each:
              product?.install_formula_cost_each != null && product?.install_formula_cost_each !== ''
                ? Number(product.install_formula_cost_each)
                : Number(product?.expected_install_labor_cost_with_markup || 0),
            rowTotal: calculateTotal(
              markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
              product.dataQuantity,
              product.dataDiscount,
              1,
              1,
              0
            ),
            location: [location],
            ...(existingDeliverySettings && { delivery_installation: existingDeliverySettings })
          };
        }
      });

       // Reassign indexId starting from 1 for remaining products
    const resetIndexProducts = updatedProducts.map((product, idx) => ({
      ...product,
      indexId: idx + 1 // Reset the index to start from 1
    }));

    setSelectedProducts(resetIndexProducts);
      // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
      const allSelectedProducts = [
        ...updatedProducts,
        ...selectedProducts?.filter((item)=>item.isAdditionalProduct == true),
        ...selectedMapserviceProducts?.filter(product => product?.fromMapServices == true)
      ];
      const productServices = allSelectedProducts?.reduce((services, product) => {
        console.log("updatedProducts--product---------", product);
        if (product.services && product.services.length > 0) {
          return services.concat(
            product.services.map((service) => ({
              ...service,
              fromMapServices: product?.fromMapServices,
              productIndex: product.indexId,
              locationQuantity: 1,
            }))
          );
        }
        return services;
      }, []);
  
      setSelectedServices((prevServices) => {
        const filteredProductServices = productServices.filter((service) => {
          console.log("productServices-----service--", service);
          return !prevServices.some(
            (existingService) =>
              existingService?.labour_cost_service_id === service?.id &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          );
        });
  
        let updatedServices = prevServices.map((service) => ({
          ...service,
          quantity: service.quantity || 1,
          locationQuantity: service.locationQuantity || 1,
        }));
  
        updatedServices = updatedServices.filter((existingService) =>
          productServices.some(
            (service) =>
              (existingService?.labour_cost_service_id === service?.id ||
                existingService?.id === service?.id) &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          )
        );
  
        const filteredProductServicesUnique = filteredProductServices.filter((service) => {
          console.log("filteredProductServicesUnique--service---", service);
          return !updatedServices.some(
            (existingService) =>
              (existingService?.labour_cost_service_id === service?.id ||
                existingService?.id === service?.id) &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          );
        });
  
        return updatedServices.concat(filteredProductServicesUnique);
      });
  
      const filteredServices =
        productServices.length === 0
          ? labourCostServices
          : labourCostServices.filter(
              (service) =>
                !productServices.find(
                  (selectedService) => selectedService.id === service.id
                )
            );
      // setFilteredServices(filteredServices);
///////////////////////for additional service filter
      const updatedAdditionalSelectedServices = additionalSelectedServices?.filter(
        (service) => !productServices.some(
          (selectedService) => selectedService.id === service.id
        )
      );
      
      // Now update the state
      setAdditionalSelectedServices(updatedAdditionalSelectedServices);
      setFieldValue('services', updatedAdditionalSelectedServices)
////////////////////////
  
      let initialServicesCost = 0;
      if (updatedProducts.length > 0) {
        initialServicesCost = updatedProducts.reduce((total, data) => {
          return (
            total +
            data.quantity *
              parseFloat(data.expected_total_service_cost?.toFixed(2))
          );
        }, 0);
      }
  
      setInitialServiceCostInProductFormula(initialServicesCost);
      
      const patch = getInstallEndPatchFromLead(
        values,
        getBaseUnixForLeadTime(values),
        allSelectedProducts
      );
      if (patch) setFieldValue(patch.field, patch.finalUnix);
      
      return allSelectedProducts;
    });
  };
  
  console.log('selectedServices-------', selectedServices);
  console.log("currentttt" , currentRFQData)
  // const handleAllLocationSameChange = () => {

  //   console.log("##################Alllll", allLocationSame);
  //   if (!allLocationSame) {
  //     const commonAddress = selectedProducts[0]?.location[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  //     console.log("##################Alllll", commonAddress);
  //     setSelectedProducts(prevProducts =>
  //       prevProducts.map(product => ({
  //         ...product,
  //         location: product.location.map(() => commonAddress),
  //       }))
  //     );
  //   }
  //   setAllLocationSame(!allLocationSame);
  // };

  // const handleAllServiceLocationSameChange = () => {
  //   console.log("##################Alllll", allServiceLocationSame);
    
  //   if (!allServiceLocationSame) {
  //     // Ensure there's at least one service and its location array is valid
  //     const commonAddress = additionalSelectedServices[0]?.location?.[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  
  //     console.log("Common Address being applied:", commonAddress);
  
  //     // Update all locations to use the commonAddress
  //     setAdditionalSelectedServices(prevProducts =>
  //       prevProducts.map(product => ({
  //         ...product,
  //         location: product.location ? product.location.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
  //       }))
  //     );
  //   }
  
  //   setAllServiceLocationSame(!allServiceLocationSame);
  // };
  
  const handleAllLocationSameChange = (productIndex) => {
    setSelectedProducts(prevProducts =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          console.log('productIndex--1---', index)
          console.log('productIndex--2---', productIndex)

          // Toggle allLocationSame flag
          const isAllSame = !product?.allLocationSame;
          // Get the first address of the selected product
          const commonAddress = product.location[0] || {
            address: '',
            city: '',
            state: '',
            zip: '',
          };
  
          return {
            ...product,
            allLocationSame: isAllSame,
            location: product.location.map(() => commonAddress),
          };
        }
        return product;
      })
    );
  };

  const handleAllServiceLocationSameChange = () => {

    console.log("##################Alllll", allLocationSame);
    if (!allServiceLocationSame) {
      const commonAddress = additionalSelectedServices[0]?.addresses[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
      setAdditionalSelectedServices(prevProducts =>
        prevProducts.map(product => ({
          ...product,
          addresses: product.addresses.map(() => commonAddress),
        }))
      );
    }
    setAllServiceLocationSame(!allServiceLocationSame);
  };
  
  const handleAllRfpServiceLocationSameChange = () => {
    
    if (!allRfpServiceLocationSame) {
      // Ensure there's at least one service and its location array is valid
      const commonAddress = cartService[0]?.location?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
  
      console.log("Common Address being applied:", commonAddress);
  
      // Update all locations to use the commonAddress
      setCartService(prevProducts =>
        prevProducts.map(product => ({
          ...product,
          location: product.location ? product.location.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
        }))
      );
    }
  
    setAllRfpServiceLocationSame(!allRfpServiceLocationSame);
  };
  
  // const handleAllRfpProductsLocationSameChange = () => {
    
  //   if (!allRfpProductsLocationSame) {
  //     // Ensure there's at least one service and its location array is valid
  //     const commonAddress = cart[0]?.location?.[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  
  //     console.log("Common Address being applied:", commonAddress);
  
  //     // Update all locations to use the commonAddress
  //     setCart(prevProducts =>
  //       prevProducts.map(product => ({
  //         ...product,
  //         location: product.location ? product.location.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
  //       }))
  //     );
  //     setAllRfpProductsLocationSame(true);

  //   }else{

  //     setAllRfpProductsLocationSame(false);
  //   }
  
  // };
  
  const handleAllRfpProductsLocationSameChange = (productIndex) => {
    setCart(prevProducts =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          const isAllSame = !product.allRfpProductsLocationSame;

          // Keep a single base address; when "all same" is on, edits to first will mirror to others
          const baseAddress = product?.location?.[0] || {
            id: 0,
            address: '',
            city: '',
            state: '',
            zip: '',
          };

          console.log("Common Address being applied:", baseAddress);

          return {
            ...product,
            allRfpProductsLocationSame: isAllSame,
            location: product.location && product.location.length
              ? product.location.map((_, i) => ({ ...baseAddress, id: i }))
              : [{ ...baseAddress }],
          };
        }
        return product;
      })
    );
  };

  const handleDeleteProduct = (productId, indexId) => {
    setCheckLength(!checkLength)
    const fileredProduct = selectedProducts.filter(data => !((data.id || data.product_id) === productId && data.indexId === indexId))
    const reIndexedProducts = fileredProduct.map((product, index) => ({
      ...product,
      indexId: index + 1, // Assign new sequential indexId
    }));
    setFieldValue('products', reIndexedProducts);
    setSelectedProducts(reIndexedProducts)
    // setFieldValue('products', fileredProduct);
    // setSelectedProducts(fileredProduct)
    const quantityFieldName = `quantity_${productId}`;
    const discountFieldName = `discount_${productId}`;
    setFieldValue(quantityFieldName, 1);
    setFieldValue(discountFieldName, 1);
    console.log('fileredProduct-------', fileredProduct);
    console.log('selectedServices-------', selectedServices);
    console.log("###############InitialserviceCost", initialServiceCostInProductFormula);
    // const filteredServices = (selectedServices || [])
    //   .filter((service) =>
    //     fileredProduct?.some(
    //       (product) =>
    //         product?.recipe_id === service?.recipe_id &&
    //         product?.id === service?.product_id &&
    //         product?.indexId === service?.productIndex,
    //     ),
    //   )
    //   .map((service) => ({
    //     ...service,
    //     productIndex: indexIdMap[String(service.productIndex)] ?? service.productIndex,
    //     indexId: indexIdMap[String(service.indexId)] ?? service.indexId,
    //     newIndexId: indexIdMap[String(service.newIndexId)] ?? service.newIndexId,
    //     product_index: indexIdMap[String(service.product_index)] ?? service.product_index,
    //   }))
    const filteredServices = selectedServices?.filter(service => {
      // Check if there is any product in fileredProduct array which contains the service
      return fileredProduct?.some(product => (
        product?.recipe_id === service?.recipe_id &&
        product?.id === service?.product_id &&
        product?.indexId === service?.productIndex
      ));
    });


    setSelectedServices(filteredServices);

    setSelectedServices(filteredServices);
    let initialServicesCost = 0
    if (fileredProduct.length > 0) {
      initialServicesCost = fileredProduct?.reduce((total, data, index) => {
        return total + ((data?.quantity) * (parseFloat(data?.expected_total_service_cost?.toFixed(2))));
      }, 0);
    }
    console.log('initialServiceCost In ProductFormula-----', initialServicesCost);
    setInitialServiceCostInProductFormula(initialServicesCost)
    
    // Clear attachments and selected images for the deleted product indexId
    // setProductAttachments((prev) => {
    //   // Create mapping from old indexId to new indexId based on product id
    //   const indexMapping = {};
    //   fileredProduct.forEach((product, idx) => {
    //     const oldIndexId = product.indexId;
    //     const newIndexId = idx + 1;
    //     indexMapping[oldIndexId] = newIndexId;
    //   });
      
    //   // Reindex attachments based on the mapping
    //   const reIndexedAttachments = {};
    //   Object.keys(prev).forEach((oldIndexIdKey) => {
    //     const oldIndexId = Number(oldIndexIdKey);
    //     if (oldIndexId !== indexId && indexMapping[oldIndexId]) {
    //       reIndexedAttachments[indexMapping[oldIndexId]] = prev[oldIndexIdKey];
    //     }
    //   });
    //   return reIndexedAttachments;
    // });

    setProductAttachments((prev) => {
      const reIndexedAttachments = {};
    
      fileredProduct.forEach((product, newIndex) => {
        const oldIndexId = product.indexId;
    
        // Skip deleted product attachment
        if (oldIndexId === indexId) return;
    
        const newIndexId = newIndex + 1;
    
        if (prev[oldIndexId]) {
          reIndexedAttachments[newIndexId] = prev[oldIndexId];
        }
      });
    
      return reIndexedAttachments;
    });
    
    // Clear selected uploaded images for the deleted product indexId
    // setSelectedUploadedImages((prev) => {
    //   // Create mapping from old indexId to new indexId based on product id
    //   const indexMapping = {};
    //   fileredProduct.forEach((product, idx) => {
    //     const oldIndexId = product.indexId;
    //     const newIndexId = idx + 1;
    //     indexMapping[oldIndexId] = newIndexId;
    //   });
      
    //   // Reindex selected images based on the mapping
    //   const reIndexedSelected = {};
    //   Object.keys(prev).forEach((oldIndexIdKey) => {
    //     const oldIndexId = Number(oldIndexIdKey);
    //     if (oldIndexId !== indexId && indexMapping[oldIndexId]) {
    //       reIndexedSelected[indexMapping[oldIndexId]] = prev[oldIndexIdKey];
    //     }
    //   });
    //   return reIndexedSelected;
    // });

    setSelectedUploadedImages((prev) => {
      const reIndexedSelected = {};
    
      fileredProduct.forEach((product, newIndex) => {
        const oldIndexId = product.indexId;
    
        // Skip deleted product selected images
        if (oldIndexId === indexId) return;
    
        const newIndexId = newIndex + 1;
    
        if (prev[oldIndexId]) {
          reIndexedSelected[newIndexId] = prev[oldIndexId];
        }
      });
    
      return reIndexedSelected;
    });
    
    // Remove linked images from avatarUrl for the deleted product
    const deletedProduct = selectedProducts.find(data => ((data.id || data.product_id) === productId && data.indexId === indexId));
    if (deletedProduct?.location) {
      const deletedLocationIds = deletedProduct.location.map(loc => loc.id || loc.request_location_id).filter(Boolean);
      if (deletedLocationIds.length > 0) {
        setAvatarUrl((prev) => {
          return prev.filter((file) => {
            if (!file?.location_ids) return true;
            const fileLocationIds = file.location_ids.split(',').map(id => parseInt(id.trim(), 10)).filter(Boolean);
            // Check if any of the deleted location IDs are in the file's location_ids
            const hasDeletedLocation = fileLocationIds.some(id => deletedLocationIds.includes(id));
            return !hasDeletedLocation;
          });
        });
      }
    }
    
    const patch = getInstallEndPatchFromLead(
      values,
      getBaseUnixForLeadTime(values),
      fileredProduct
    );
    if (patch) setFieldValue(patch.field, patch.finalUnix);
        // Recalculate installation date based on remaining products
    const productsWithLeadTime = fileredProduct.filter(product => product.lead_time && product.lead_time > 0);
    
    if (productsWithLeadTime.length > 0) {
      const highestLeadTime = Math.max(...productsWithLeadTime.map(product => product.lead_time));
      const installationDate = moment().add(highestLeadTime, 'days');
      
      // Set only the single installation date field
      setFieldValue('end', dateOnlyToUnix(installationDate));
    } else {
      // If no products with lead_time remain, reset installation date to current date
      setFieldValue('end', localTodayDateOnlyUnix());
    }

  }

  const handleDeleteGroup = (groupId) => {
    const sid = String(groupId)
    const fileredProduct = (selectedProducts || []).filter(
      (p) => String(getProductGroupId(p) || '') !== sid,
    )
    const resetIndexProducts = fileredProduct.map((product, idx) => ({
      ...product,
      indexId: idx + 1,
    }))

    setProductAttachments((prev) => {
      const next = {}
      fileredProduct.forEach((product, idx) => {
        const oldIndexId = String(product.indexId ?? '')
        const newIndexId = String(idx + 1)
        if (prev[oldIndexId]?.length) {
          next[newIndexId] = prev[oldIndexId].map((f) => ({
            ...f,
            product_index_id: newIndexId,
          }))
        }
      })
      return next
    })
    const remapIdx = (prev) => {
      const next = {}
      fileredProduct.forEach((product, idx) => {
        const oldKey = String(product.indexId ?? '')
        const newKey = String(idx + 1)
        if (prev[oldKey] !== undefined) next[newKey] = prev[oldKey]
      })
      return next
    }
    setOpenProductAttachment((prev) => remapIdx(prev))
    setAttachmentTabValue((prev) => remapIdx(prev))
    setSelectedUploadedImages((prev) => remapIdx(prev))
    setIsUploadingProduct((prev) => remapIdx(prev))

    setOpenGroupedRows((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setGroupProductMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setGroupInstallMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })

    setFieldValue('products', resetIndexProducts)
    setSelectedProducts(resetIndexProducts)

    const filteredServices = selectedServices?.filter((service) =>
      fileredProduct?.some(
        (product) =>
          product?.recipe_id === service?.recipe_id &&
          product?.id === service?.product_id &&
          product?.indexId === service?.productIndex,
      ),
    )
    setSelectedServices(filteredServices)

    let initialServicesCost = 0
    if (fileredProduct.length > 0) {
      initialServicesCost = fileredProduct?.reduce((total, data) => {
        return total + (data?.quantity || 0) * parseFloat(data?.expected_total_service_cost?.toFixed(2) || 0)
      }, 0)
    }
    setInitialServiceCostInProductFormula(initialServicesCost)

    const productsWithLeadTime = fileredProduct.filter((product) => product.lead_time && product.lead_time > 0)
    if (productsWithLeadTime.length > 0) {
      const highestLeadTime = Math.max(...productsWithLeadTime.map((product) => product.lead_time))
      const installationDate = moment().add(highestLeadTime, 'days')
      setFieldValue('end', dateOnlyToUnix(installationDate))
    } else {
      setFieldValue('end', localTodayDateOnlyUnix())
    }

    setRefreshCalculation((v) => !v)
    setCheckLength(!checkLength)
  }

  const handleDeleteGroupInstall = (groupId) => {
    const sid = String(groupId)
    const updatedProducts = (selectedProducts || []).map((product) => {
      if (String(getProductGroupId(product) || '') !== sid) return product
      const cleared = clearCatalogInstallCost(product)
      return {
        ...cleared,
        retail_price: cleared.actual_retail_price,
      }
    })
    setSelectedProducts(updatedProducts)
    setFieldValue('products', updatedProducts)
    setGroupInstallMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setGroupInstallRetailDrafts((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[sid]
      return next
    })
    setCustomerOrderProductGroups((prev) =>
      (prev || []).map((g) => {
        if (String(g?.id ?? g?.group_id) !== sid) return g
        return {
          ...g,
          install_marketing_adjustment: 0,
          install_marketing_adj_value_type: true,
          installMarketingAdjustment: 0,
          installMarketingAdjValueType: true,
        }
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleGroupQuantityChange = (groupId, value) => {
    let newValue = String(value ?? '')
    if (newValue.startsWith('-')) newValue = newValue.slice(1)
    newValue = newValue.replace(/[^0-9]/g, '')
    if (newValue === '' || Number(newValue) <= 0) newValue = 1
    else newValue = Number(newValue)

    setCustomerOrderProductGroups((prev) => {
      const list = prev || []
      const idx = list.findIndex(
        (group) => String(group?.id ?? group?.group_id) === String(groupId),
      )
      const existingGroup = idx >= 0 ? list[idx] : null
      const existingProdQty = Number(
        existingGroup?.product_marketing_quantity ??
          existingGroup?.productMarketingQuantity ??
          0,
      )
      const existingInstQty = Number(
        existingGroup?.install_marketing_quantity ??
          existingGroup?.installMarketingQuantity ??
          0,
      )
      const hasManualInstallQty =
        Boolean(existingGroup?.install_qty_manually_set) ||
        (existingProdQty > 0 &&
          existingInstQty > 0 &&
          existingProdQty !== existingInstQty) ||
        (selectedProducts || []).some(
          (product) =>
            String(getProductGroupId(product) || '') === String(groupId) &&
            product?.manually_updated_install_quantity,
        )
      if (idx === -1) {
        return [
          ...list,
          {
            id: groupId,
            group_id: groupId,
            product_marketing_quantity: Number(newValue),
            ...(hasManualInstallQty
              ? {}
              : { install_marketing_quantity: Number(newValue) }),
          },
        ]
      }
      return list.map((group, groupIndex) =>
        groupIndex !== idx
          ? group
          : {
              ...group,
              product_marketing_quantity: Number(newValue),
              ...(hasManualInstallQty
                ? {}
                : { install_marketing_quantity: Number(newValue) }),
            },
      )
    })
    // Keep group location slots in sync with set qty (Multiple mode).
    setSelectedProducts((prevProducts) => {
      const groupProducts = (prevProducts || []).filter(
        (product) => String(getProductGroupId(product) || '') === String(groupId),
      )
      if (!groupProducts.length) return prevProducts
      const representative = groupProducts[0]
      const sourceAddr = representative?.location || representative?.addresses || []
      const templateAddresses = buildGroupAddressesForProduct(
        { ...representative, locationQuantity: Number(newValue) },
        sourceAddr,
        {
          allLocationSame: representative?.allLocationSame,
          isSingleCard: representative?.is_single_card,
          locationQuantity: Number(newValue),
        },
      )
      setCustomerOrderProductGroups((prev) => {
        const list = prev || []
        const idx = list.findIndex(
          (group) => String(group?.id ?? group?.group_id) === String(groupId),
        )
        if (idx === -1) return prev
        return list.map((group, groupIndex) =>
          groupIndex !== idx
            ? group
            : { ...group, group_addresses: templateAddresses },
        )
      })
      return (prevProducts || []).map((product) => {
        if (String(getProductGroupId(product) || '') !== String(groupId)) return product
        return {
          ...product,
          location: buildGroupAddressesForProduct(
            { ...product, locationQuantity: Number(newValue) },
            templateAddresses,
            {
              allLocationSame: product?.allLocationSame,
              isSingleCard: product?.is_single_card,
              locationQuantity: Number(newValue),
            },
          ),
        }
      })
    })
    setRefreshCalculation((v) => !v)
  }

  const getGroupLocationQuantityForProduct = useCallback(
    (product) => {
      const gid = getProductGroupId(product)
      if (gid == null || gid === '') {
        return Math.max(1, Number(product?.locationQuantity || 1))
      }
      const group = groupedSelectedProductsMap.get(String(gid))
      const fromGroup = Number(group?.groupQuantity)
      if (fromGroup > 0) return fromGroup
      return Math.max(1, Number(product?.locationQuantity || 1))
    },
    [groupedSelectedProductsMap],
  )

  const applyGroupLocationUpdate = useCallback(
    (groupId, updater) => {
      setSelectedProducts((prevProducts) => {
        const members = (prevProducts || []).filter(
          (p) => String(getProductGroupId(p) || '') === String(groupId),
        )
        if (!members.length) return prevProducts
        const representative = members[0]
        const locationQuantity = (() => {
          const group = groupedSelectedProductsMap.get(String(groupId))
          return Math.max(
            1,
            Number(group?.groupQuantity || representative?.locationQuantity || 1),
          )
        })()
        const patch = updater(representative, locationQuantity)
        if (!patch) return prevProducts
        setCustomerOrderProductGroups((prev) => {
          const list = prev || []
          const idx = list.findIndex(
            (g) => String(g?.id ?? g?.group_id) === String(groupId),
          )
          const metaPatch = {
            group_addresses: patch.location,
            group_all_location_same: patch.allLocationSame ? 1 : 0,
            group_is_single_card: patch.is_single_card ? 1 : 0,
          }
          if (idx === -1) {
            return [...list, { id: groupId, group_id: groupId, ...metaPatch }]
          }
          return list.map((g, i) => (i === idx ? { ...g, ...metaPatch } : g))
        })
        return (prevProducts || []).map((p) =>
          String(getProductGroupId(p) || '') === String(groupId)
            ? { ...p, ...patch }
            : p,
        )
      })
    },
    [groupedSelectedProductsMap],
  )

  const handleProductLocationFieldChange = useCallback(
    (data, locationIndex, field, value) => {
      const gid = getProductGroupId(data)
      if (gid != null && gid !== '') {
        applyGroupLocationUpdate(gid, (representative) => {
          let updatedLocations = [...(representative?.location || [])]
          if (representative?.allLocationSame) {
            updatedLocations = updatedLocations.map(() => ({
              ...(updatedLocations[0] || {}),
              [field]: value,
            }))
          } else {
            updatedLocations[locationIndex] = {
              ...(updatedLocations[locationIndex] || {}),
              [field]: value,
            }
          }
          return {
            allLocationSame: Boolean(representative?.allLocationSame),
            is_single_card: Boolean(representative?.is_single_card),
            location: updatedLocations,
          }
        })
        return
      }
      setSelectedProducts((prevProducts) =>
        prevProducts.map((p) => {
          if (p.indexId !== data.indexId) return p
          let updatedLocations = [...(p.location || [])]
          if (p.allLocationSame) {
            updatedLocations = updatedLocations.map(() => ({
              ...(updatedLocations[0] || {}),
              [field]: value,
            }))
          } else {
            updatedLocations[locationIndex] = {
              ...(updatedLocations[locationIndex] || {}),
              [field]: value,
            }
          }
          return { ...p, location: updatedLocations }
        }),
      )
    },
    [applyGroupLocationUpdate],
  )

  const handleGroupInstallQuantityChange = (groupId, value) => {
    let newValue = String(value ?? '')
    if (newValue.startsWith('-')) newValue = newValue.slice(1)
    newValue = newValue.replace(/[^0-9]/g, '')
    if (newValue === '' || Number(newValue) <= 0) newValue = 1
    else newValue = Number(newValue)

    setCustomerOrderProductGroups((prev) => {
      const list = prev || []
      const idx = list.findIndex(
        (group) => String(group?.id ?? group?.group_id) === String(groupId),
      )
      if (idx === -1) {
        return [
          ...list,
          {
            id: groupId,
            group_id: groupId,
            install_marketing_quantity: Number(newValue),
            install_qty_manually_set: true,
          },
        ]
      }
      return list.map((group, groupIndex) =>
        groupIndex !== idx
          ? group
          : {
              ...group,
              install_marketing_quantity: Number(newValue),
              install_qty_manually_set: true,
            },
      )
    })
    setRefreshCalculation((v) => !v)
  }

  const handleGroupMarketingTypeChange = (groupId, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
    )
    if (newValue === false) {
      const group = groupedSelectedProductsMap.get(String(groupId))
      const formulaEach = Number(group?.totalProductFormulaEach || 0)
      const retailEachBase = Number(group?.totalProductRetailEach || 0)
      if (!hasPermission && retailEachBase <= formulaEach) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
          { variant: 'error' },
        )
        return
      }
      let maxNegative = Math.max(0, retailEachBase - formulaEach)
      if (hasPermission) maxNegative = retailEachBase
      const currentAdjustment = Number(group?.groupAdjustment || 0)
      if (currentAdjustment >= maxNegative && hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      }
      if (currentAdjustment > maxNegative && !hasPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
          { variant: 'error' },
        )
        return
      }
    }
    setGroupProductMarketingValues((prev) => ({
      ...prev,
      [String(groupId)]: {
        ...(prev[String(groupId)] || {}),
        adjValueType: newValue,
      },
    }))
  }

  const handleGroupMarketingAdjustmentChange = (groupId, value) => {
    const adjustment = Math.max(0, Number(value) || 0)
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
    )
    const group = groupedSelectedProductsMap.get(String(groupId))
    const isNegative =
      group?.groupAdjValueType === false || Number(group?.groupAdjValueType) === 0
    if (isNegative) {
      const formulaEach = Number(group?.totalProductFormulaEach || 0)
      const retailEachBase = Number(group?.totalProductRetailEach || 0)
      let maxNegative = Math.max(0, retailEachBase - formulaEach)
      if (hasPermission) maxNegative = retailEachBase
      if (adjustment >= maxNegative && hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      }
      if (adjustment > maxNegative && !hasPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
          { variant: 'error' },
        )
        return
      }
    }
    const key = String(groupId)
    const groupMeta =
      (customerOrderProductGroups || []).find((g) => String(g?.id) === key) || {}
    setGroupProductMarketingValues((prev) => {
      const prevEntry = prev[key] || {}
      return {
        ...prev,
        [key]: {
          ...prevEntry,
          adjustment,
          adjValueType:
            prevEntry.adjValueType ??
            parseGroupMarketingAdjValueTypeFromDb(
              groupMeta.product_marketing_adj_value_type ??
                groupMeta.productMarketingAdjValueType,
            ),
        },
      }
    })
  }

  const handleGroupInstallMarketingTypeChange = (groupId, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
    )
    if (newValue === false) {
      const group = groupedSelectedProductsMap.get(String(groupId))
      const formulaEach = Number(group?.totalInstallFormulaEach || 0)
      const retailEachBase = Number(group?.totalInstallRetailEach || 0)
      if (!hasPermission && retailEachBase <= formulaEach) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
          { variant: 'error' },
        )
        return
      }
      let maxNegative = Math.max(0, retailEachBase - formulaEach)
      if (hasPermission) maxNegative = retailEachBase
      const currentAdjustment = Number(group?.groupInstallAdjustment || 0)
      if (currentAdjustment >= maxNegative && hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      }
      if (currentAdjustment > maxNegative && !hasPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce below $${Number(maxNegative).toFixed(2)} (Install Formula Limit)`,
          { variant: 'error' },
        )
        return
      }
    }
    setGroupInstallMarketingValues((prev) => ({
      ...prev,
      [String(groupId)]: {
        ...(prev[String(groupId)] || {}),
        adjValueType: newValue,
      },
    }))
  }

  const handleGroupInstallMarketingAdjustmentChange = (groupId, value) => {
    const adjustment = Math.max(0, Number(value) || 0)
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
    )
    const group = groupedSelectedProductsMap.get(String(groupId))
    const isNegative =
      group?.groupInstallAdjValueType === false ||
      Number(group?.groupInstallAdjValueType) === 0
    if (isNegative) {
      const formulaEach = Number(group?.totalInstallFormulaEach || 0)
      const retailEachBase = Number(group?.totalInstallRetailEach || 0)
      let maxNegative = Math.max(0, retailEachBase - formulaEach)
      if (hasPermission) maxNegative = retailEachBase
      if (adjustment >= maxNegative && hasPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      }
      if (adjustment > maxNegative && !hasPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce below $${Number(maxNegative).toFixed(2)} (Install Formula Limit)`,
          { variant: 'error' },
        )
        return
      }
    }
    const key = String(groupId)
    const groupMeta =
      (customerOrderProductGroups || []).find((g) => String(g?.id) === key) || {}
    setGroupInstallMarketingValues((prev) => {
      const prevEntry = prev[key] || {}
      return {
        ...prev,
        [key]: {
          ...prevEntry,
          adjustment,
          adjValueType:
            prevEntry.adjValueType ??
            parseGroupMarketingAdjValueTypeFromDb(
              groupMeta.install_marketing_adj_value_type ??
                groupMeta.installMarketingAdjValueType,
            ),
        },
      }
    })
  }

  const getGroupProductSignedAdjustment = (group, groupId) => {
    const groupKey = String(groupId)
    const productMarketing = groupProductMarketingValues?.[groupKey] || {}
    const groupAdjValueType =
      productMarketing.adjValueType ?? group?.groupAdjValueType ?? true
    const groupAdjustment = Number(
      productMarketing.adjustment ?? group?.groupAdjustment ?? 0,
    )
    return groupAdjValueType === false || Number(groupAdjValueType) === 0
      ? -groupAdjustment
      : groupAdjustment
  }

  const getGroupInstallSignedAdjustment = (group, groupId) => {
    const groupKey = String(groupId)
    const installMarketing = groupInstallMarketingValues?.[groupKey] || {}
    const groupInstallAdjValueType =
      installMarketing.adjValueType ?? group?.groupInstallAdjValueType ?? true
    const groupInstallAdjustment = Number(
      installMarketing.adjustment ?? group?.groupInstallAdjustment ?? 0,
    )
    return groupInstallAdjValueType === false || Number(groupInstallAdjValueType) === 0
      ? -groupInstallAdjustment
      : groupInstallAdjustment
  }

  const handleGroupRetailPriceChange = (groupId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const groupKey = String(groupId)

    if (rawValue === '' || rawValue === '-') {
      if (isBlur) {
        setGroupProductRetailDrafts((prev) => {
          const next = { ...prev }
          delete next[groupKey]
          return next
        })
      }
      return
    }

    const group = groupedSelectedProductsMap.get(groupKey)
    if (!group) return

    const numValue = parseFloat(rawValue)
    if (Number.isNaN(numValue)) return

    const members = group.products || []
    if (!members.length) return

    const productSignedAdj = getGroupProductSignedAdjustment(group, groupId)
    const newTotalRetailEach = Number((numValue - productSignedAdj).toFixed(2))
    const formulaEach = Number(group.totalProductFormulaEach || 0)

    if (newTotalRetailEach < formulaEach) {
      if (!isBlur) {
        setGroupProductRetailDrafts((prev) => ({ ...prev, [groupKey]: rawValue }))
        return
      }
      enqueueSnackbar(
        `Retail Price Each cannot be below Product formula cost ($${formulaEach.toFixed(2)})`,
        { variant: 'error' },
      )
      setGroupProductRetailDrafts((prev) => {
        const next = { ...prev }
        delete next[groupKey]
        return next
      })
      return
    }

    const memberTargets = distributeGroupTotalByFormulaShare(
      members,
      getProductFormulaEach,
      newTotalRetailEach,
    )
    const productsByIndexId = new Map(
      (selectedProducts || []).map((p) => [Number(p.indexId), p]),
    )
    const memberEdits = new Map()

    for (const member of members) {
      const product = productsByIndexId.get(Number(member.indexId))
      if (!product) continue

      const editResult = applyRetailPriceEdit(
        product,
        String(memberTargets.get(member.indexId)),
        markupType,
        {
          hasNegativePermission: explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Sales Order'].includes(
              permission,
            ),
          ),
        },
      )

      if (!editResult) {
        setGroupProductRetailDrafts((prev) => ({ ...prev, [groupKey]: rawValue }))
        return
      }

      if (editResult.error) {
        if (!isBlur) {
          setGroupProductRetailDrafts((prev) => ({ ...prev, [groupKey]: rawValue }))
          return
        }
        enqueueSnackbar(editResult.error, { variant: 'error' })
        setGroupProductRetailDrafts((prev) => {
          const next = { ...prev }
          delete next[groupKey]
          return next
        })
        return
      }

      memberEdits.set(Number(member.indexId), editResult)
    }

    setGroupProductRetailDrafts((prev) => {
      const next = { ...prev }
      delete next[groupKey]
      return next
    })

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        const editResult = memberEdits.get(Number(product.indexId))
        if (!editResult) return product

        const priceForTotal =
          markupType === 1
            ? editResult.price
            : editResult.install_cost && parseFloat(editResult.install_cost) > 0
            ? editResult.retail_price
            : editResult.actual_retail_price

        const total = calculateTotal(
          priceForTotal,
          Number(product.quantity),
          product.discount || 0,
          product.quantity,
          product.locationQuantity,
          Number(product?.adjustment),
          product.markAdjType,
          product?.split_percentage || splitPercentage,
          product.adj_value_type,
        )

        return {
          ...product,
          ...editResult,
          ...(markupType === 1 ? { product_price: editResult.price } : {}),
          retail_price_draft: undefined,
          product_total: total,
        }
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleGroupInstallRetailPriceChange = (groupId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const groupKey = String(groupId)

    if (rawValue === '' || rawValue === '-') {
      if (isBlur) {
        setGroupInstallRetailDrafts((prev) => {
          const next = { ...prev }
          delete next[groupKey]
          return next
        })
      }
      return
    }

    const group = groupedSelectedProductsMap.get(groupKey)
    if (!group) return

    const numValue = parseFloat(rawValue)
    if (Number.isNaN(numValue)) return

    const members = group.products || []
    const installMembers = members.filter(
      (p) =>
        Number(p?.install_cost || 0) > 0 ||
        Number(p?.expected_install_labor_cost_with_markup || 0) > 0 ||
        Number(p?.original_install_cost || 0) > 0,
    )
    if (!installMembers.length) return

    const installSignedAdj = getGroupInstallSignedAdjustment(group, groupId)
    const newTotalInstallEach = Number((numValue - installSignedAdj).toFixed(2))
    const formulaEach = Number(group.totalInstallFormulaEach || 0)

    if (newTotalInstallEach < formulaEach) {
      if (!isBlur) {
        setGroupInstallRetailDrafts((prev) => ({ ...prev, [groupKey]: rawValue }))
        return
      }
      enqueueSnackbar(
        `Install Price Each cannot be below Install formula cost ($${formulaEach.toFixed(2)})`,
        { variant: 'error' },
      )
      setGroupInstallRetailDrafts((prev) => {
        const next = { ...prev }
        delete next[groupKey]
        return next
      })
      return
    }

    const installTargets = distributeGroupTotalByFormulaShare(
      installMembers,
      getInstallFormulaEach,
      newTotalInstallEach,
    )
    const productsByIndexId = new Map(
      (selectedProducts || []).map((p) => [Number(p.indexId), p]),
    )
    const memberEdits = new Map()

    for (const member of installMembers) {
      const product = productsByIndexId.get(Number(member.indexId))
      if (!product) continue

      const editResult = applyInstallPriceEdit(
        product,
        String(installTargets.get(member.indexId)),
        {
          hasNegativePermission: explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Sales Order'].includes(
              permission,
            ),
          ),
        },
      )

      if (!editResult) {
        setGroupInstallRetailDrafts((prev) => ({ ...prev, [groupKey]: rawValue }))
        return
      }

      if (editResult.error) {
        if (!isBlur) {
          setGroupInstallRetailDrafts((prev) => ({ ...prev, [groupKey]: rawValue }))
          return
        }
        enqueueSnackbar(editResult.error, { variant: 'error' })
        setGroupInstallRetailDrafts((prev) => {
          const next = { ...prev }
          delete next[groupKey]
          return next
        })
        return
      }

      memberEdits.set(Number(member.indexId), editResult)
    }

    setGroupInstallRetailDrafts((prev) => {
      const next = { ...prev }
      delete next[groupKey]
      return next
    })

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        const editResult = memberEdits.get(Number(product.indexId))
        if (!editResult) return product

        const total = calculateTotal(
          editResult.retail_price,
          Number(product.quantity),
          product.discount || 0,
          product.quantity,
          product.locationQuantity,
          Number(product?.adjustment),
          product.markAdjType,
          product?.split_percentage || splitPercentage,
          product.adj_value_type,
        )

        return {
          ...product,
          ...editResult,
          install_price_draft: undefined,
          product_total: total,
        }
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const getLosingMoneyRowSx = (isLosingMoneyItem) =>
    isLosingMoneyItem
      ? {
          '& .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)), & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)) .MuiFormLabel-root':
            {
              color: `${theme.palette.error.main} !important`,
            },
        }
      : undefined

  const getGroupLosingMoneyFlags = (group) => {
    if (!group) {
      return { isGroupProductLosingMoney: false, isGroupInstallLosingMoney: false }
    }
    const groupKey = String(group.id)
    const productMarketing =
      groupProductMarketingValues?.[groupKey] ||
      groupProductMarketingValues?.[group.id] ||
      {}
    const installMarketing =
      groupInstallMarketingValues?.[groupKey] ||
      groupInstallMarketingValues?.[group.id] ||
      {}

    const groupAdjValueType =
      productMarketing.adjValueType ?? group.groupAdjValueType ?? 1
    const groupInstallAdjValueType =
      installMarketing.adjValueType ?? group.groupInstallAdjValueType ?? 1

    const isNegativeGroupProductAdjustmentMode =
      groupAdjValueType === false ||
      groupAdjValueType === 0 ||
      groupAdjValueType === '0' ||
      groupAdjValueType === 'false'
    const isNegativeGroupInstallAdjustmentMode =
      groupInstallAdjValueType === false ||
      groupInstallAdjValueType === 0 ||
      groupInstallAdjValueType === '0' ||
      groupInstallAdjValueType === 'false'

    const productFormulaEach = Number(group.totalProductFormulaEach ?? 0)
    const productRetailEach = Number(group.adjustedGroupRetailEach ?? 0)
    const installFormulaEach = Number(group.totalInstallFormulaEach ?? 0)
    const installRetailEach = Number(group.adjustedGroupInstallRetailEach ?? 0)

    return {
      isGroupProductLosingMoney:
        isNegativeGroupProductAdjustmentMode &&
        productRetailEach < productFormulaEach,
      isGroupInstallLosingMoney:
        isNegativeGroupInstallAdjustmentMode &&
        installRetailEach < installFormulaEach,
    }
  }

  const handleDeleteInstallCost = (productId, indexId) => {
    const updatedProducts = (selectedProducts || []).map((product) => {
      const matchesIndex = Number(product?.indexId) === Number(indexId)
      if (!matchesIndex) return product
      const cleared = clearCatalogInstallCost(product)
      return {
        ...cleared,
        retail_price: cleared.actual_retail_price,
      }
    })

    setSelectedProducts(updatedProducts)
    setFieldValue('products', updatedProducts)
    setRefreshCalculation((v) => !v)
  }

  const assignServiceAddresses = (existingServices, newService, allServiceLocationSame, communityAddress) => {
    let assignedAddresses = [];
  
    if (allServiceLocationSame && existingServices.length > 0) {
      // Use the first service's address as the common address
      const commonAddress = existingServices[0]?.addresses[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
      assignedAddresses = [{ ...commonAddress }];
    } else if (
      communityAddress.address &&
      communityAddress.city &&
      communityAddress.state &&
      communityAddress.zip
    ) {
      // Assign the community address if available
      assignedAddresses = [
        {
          id: 0,
          address: communityAddress.address,
          city: communityAddress.city,
          state: communityAddress.state,
          zip: communityAddress.zip,
        },
      ];
    } else {
      // Default to an empty address
      assignedAddresses = [
        {
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        },
      ];
    }
  
    return {
      ...newService,
      addresses: assignedAddresses,
    };
  };
console.log('details++++++++++', details)
const actionsLoading = loadingEdit || loadingEditData;
  const isGroupedCombinedLoading = Boolean(effectiveCombineGroupedInvoice) && (loadingEditData || loadingEditInvoice);
const selectListLoading = loadingEditData || loadingEditInvoice;
// SW-114828 / ALL-854: T&M sales order edit – only dates and bill/ship to editable once installation is complete / invoiced
// Restriction lifted for now; edit stays on this sales-order tab.
// Backup before T&M restriction lift:
// const isTmInvoicingLimitedEdit = openEdit && details?.project_category == 12 && details?.allInstallationCompleted == 1;
const isTmInvoicingLimitedEdit = false;
const editFormValuesEnabled = openEdit && !isTmInvoicingLimitedEdit;
const tmInvoicingFieldDisabled = isTmInvoicingLimitedEdit;
const tmInvoicingReadOnlyCursorSx = tmInvoicingFieldDisabled ? { cursor: 'not-allowed' } : {};
const tmInvoicingFormReadOnlySx = tmInvoicingFieldDisabled ? {
  '& .Mui-disabled, & .MuiInputBase-readOnly, & .MuiAutocomplete-root.Mui-disabled, & .MuiFormControlLabel-root.Mui-disabled, & fieldset[disabled] *': {
    cursor: 'not-allowed !important',
  },
  '& [data-tm-editable], & [data-tm-editable] *': {
    cursor: 'auto',
  },
} : {};
const tmInvoicingUploadDisabledSx = tmInvoicingFieldDisabled ? {
  '& > div:first-of-type': { opacity: 0.5, pointerEvents: 'none', cursor: 'not-allowed' },
  '& > .MuiStack-root': { opacity: 0.5, cursor: 'not-allowed' },
  '& > .MuiStack-root .MuiButton-root, & > .MuiStack-root .MuiLoadingButton-root': {
    cursor: 'not-allowed !important',
  },
} : {};
const tmInvoicingUploadTabDisabledSx = tmInvoicingFieldDisabled ? {
  opacity: 0.5,
  cursor: 'not-allowed !important',
  pointerEvents: 'none',
} : {};
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: currentRFQData.name || '',
      timestamp: currentRFQData.timestamp || null,
      no_charge_reason: currentRFQData.no_charge_reason || null,
      po_number: currentRFQData.po_number || '',
      description: currentRFQData.description || '',
      notes: currentRFQData.notes || '',
      bill_to: currentRFQData.bill_to || '',
      ship_to: currentRFQData.ship_to || '',
      // skills: currentRFQData.skills || [],
      // workflow: currentRFQData.workflow || [],
      clients:currentRFQData.client || null,
      project_type: currentRFQData.project_type || null,
      project_category: currentRFQData.project_category || null,
      map_service:currentRFQData.map_service || null,
      catalog_type: catalogTypes.find((type) => type.id === currentRFQData?.catalog_type) || null,
      split_catalog_type: splitOrderCatalogTypes.find((type) => type.id === currentRFQData?.split_catalog_type) || splitOrderCatalogTypes.find((type) => type.id === 'all'), // Default to "All"
      community: currentRFQData.community || null,
      sales_rep_ids: currentRFQData.sales_rep_ids || null,
      customerTypeId: initialBillingType?.id || details?.customerTypeId || currentRFQData.customerTypeId || null,
      sales_rep_names:  details?.sales_rep_names || currentRFQData.sales_rep_names || '',
      collaborators: currentRFQData.collaborators || null,
      start: currentRFQData.start || currentDate,
      // Range mode wins: clear single Installation Date even if participation_ends is still in DB
      end:
        currentRFQData.installation_start_date || currentRFQData.installation_end_date
          ? null
          : (currentRFQData.end || currentDate),
      installation_start_date: currentRFQData.installation_start_date || null,
      installation_end_date: currentRFQData.installation_end_date || null,
      // avatarUrl: currentRFQData.avatarUrl||'',
      products: currentRFQData.products || [],
      services: currentRFQData.services || [],
      markup_type: currentRFQData.markup_type || null,
      no_charge_type: currentRFQData.no_charge_type || null,
      invoice_discount: currentRFQData.invoice_discount || '',
      welcome_message: currentRFQData.welcome_message || false,
      draft: currentRFQData.draft || false,
      total: currentRFQData.total || '',
      labour_cost: currentRFQData.labour_cost || 0,
      budget: currentRFQData.budget || 0,
      tax: 0,
      client_approve: clientApprove == 0 ? false : true,
      manager_approval_required: false,
      show_install_price: currentRFQData.show_install_price ?? 1,
      rush_fee: currentRFQData.rush_fee == 1 ? 1 : 0,
      rush_fee_amount: currentRFQData.rush_fee_amount || 0,

      // is_single_card: singleLocationCard  ? true : false,
      order_id: currentRFQData.order_id || '',
      subject: currentRFQData.subject || '',
      email_content: currentRFQData.email_content || '',
      rfp:null,
      estimate_id:currentRFQData.estimate_id,
      editReq:true,
      edit_reason:'',
      change_order_reason: currentRFQData.change_order_reason || '',
      is_split:isSplitOrder ? { id: 1, label: 'Split' } : null,
      facility_type: typeof currentRFQData?.facility_type === 'string' && currentRFQData.facility_type
      ? currentRFQData.facility_type.split(',').map(id => 
          FacilityTypes.find(type => type.id == id.trim())
        ).filter(Boolean)
      : Array.isArray(currentRFQData?.facility_type) 
        ? currentRFQData.facility_type 
        : [] || FacilityTypes?.filter(fac => fac.default) || [] ,
      billing_type: initialBillingType || null
    },
    validationSchema: NewUserSchema,
    
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const totalDepositProgressBillingAmount = depositProgressBillingRows.reduce( 
          (total, row) => total + (parseFloat(row.amount) || 0),
          0
        )
        console.log("totalDepositProgressBillingAmount",grandTotal);
        console.log("totalDepositProgressBillingAmount",totalDepositProgressBillingAmount);
        if (canAddDepositProgressBillingRow() && depositAndProgressBilling) {
          
          return enqueueSnackbar('Total deposit amount should be equal to grand total', { variant: 'error' });
        }
        console.log('🎯 onSubmit called with values:', values);
        console.log('🎯 isFromEstimate value:', values.isFromEstimate);
        values.bill_to = billToInputValue;
        values.ship_to = shipToInputValue;
        if (!values?.bill_to?.trim()) {
          values.bill_to = buildMultilineAddress(
            invoice?.customer_name ||  values?.clients?.name ||  '',
            invoice?.customer_address || values?.clients?.address || '',
            invoice?.customer_city || values?.clients?.city || '',
            invoice?.customer_state || values?.clients?.state || '',
            invoice?.customer_zipcode || values?.clients?.zip || values?.clients?.zip_code || '',
          );
        }
        if (!values?.ship_to?.trim()) {
          values.ship_to = buildMultilineAddress(
            values?.community?.name || '',
            values?.community?.address || '',
            values?.community?.city || '',
            values?.community?.state || '',
            values?.community?.zip || '',
          );
        }
        if(!values.edit_reason && details?.installationStatus == 2 ){
          enqueueSnackbar('Please enter a reason for edit.', { variant: 'error' });
          setErrors({ edit_reason: 'Please enter a reason for edit.' });
          setSubmitting(false);
          return;
        }
        if (Number(details?.proj_status) === 2) {
          const changeOrderReasonValue = values.change_order_reason?.trim() || changeOrderReason.trim();
          if (!changeOrderReasonValue) {
            setOpenChangeOrderReasonDialog(true);
            setSubmitting(false);
            return;
          }
          values.change_order_reason = changeOrderReasonValue;
        }
        setIsSubmitted(true);
        const newErrors = {}
        if (!nameFileds?.name?.trim()) {
          newErrors.name = 'Name is required.'
        }
        if (!nameFileds?.description?.trim()) {
          newErrors.description = 'Description is required.'
        }
        if (Object.keys(newErrors).length > 0) {
          setFieldErrors(newErrors)
          return
        }
        values.name = nameFileds?.name || ''
        values.po_number = nameFileds?.po_number || ''
        values.description = nameFileds?.description || ''
        values.notes = nameFileds?.notes || ''
        const isFromEstimateValue = values?.isFromEstimate !== undefined ? values?.isFromEstimate : details?.isFromEstimate
        // Check for changes when isFromEstimate === 1
        if (isFromEstimateValue === 1) {
          const changes = detectChanges();
          if (changes.length > 0) {
            // Store the submission data for later use
            setPendingSubmission({ values, setSubmitting, resetForm, setErrors });
            setDetectedChanges(changes);
            setShowChangesDialog(true);
            return;
          }
        }
        if (skipNoChargeCheck) {
          setSkipNoChargeCheck(false);
        }
        // if (values.project_category?.name === 'Time & Material') {
        //   const hasEmptyName = selectedProducts?.some(product => {
        //     return !product.product_name?.trim(); // Safe check for empty or undefined product names
        //   });
        //   if (hasEmptyName) {
        //     enqueueSnackbar('Please fill in all required product names.', { variant: 'error' });
        //     return;
        //   }
        //   const hasInvalidName = selectedProducts?.some(product => {
        //     const trimmedName = product.product_name?.trim();
        //     if (trimmedName === '.') {
        //       enqueueSnackbar('Product name cannot be just a dot.', { variant: 'error' });
        //       return true;
        //     }
        //     if (trimmedName === '-') {
        //       enqueueSnackbar('Product name cannot be just a hyphen.', { variant: 'error' });
        //       return true;
        //     }
        //     if (!/^[a-zA-Z0-9\s-]+$/.test(trimmedName)) {
        //       enqueueSnackbar('Product name can only contain letters, numbers, and hyphens.', { variant: 'error' });
        //       return true;
        //     }
        //     if (trimmedName[0] === '.') {
        //       enqueueSnackbar('Product name cannot start with a dot.', { variant: 'error' });
        //       return true;
        //     }
        //     if (trimmedName[0] === '-') {
        //       enqueueSnackbar('Product name cannot start with a hyphen.', { variant: 'error' });
        //       return true;
        //     }
        //     if (trimmedName === '') {
        //       enqueueSnackbar('Product name cannot be empty or just spaces.', { variant: 'error' });
        //       return true;
        //     }
        //     return false;
        //   });          
        //   if (hasInvalidName) {
        //     // enqueueSnackbar('Product names must contain letters or numbers.', { variant: 'error' });
        //     return;
        //   }
        // }
        // Filter out items with id == 10 when project_category.id !== 11
        const filteredAdditionalServices =
        values.project_category?.id !== 11
          ? additionalSelectedServices.filter(item => {
              if (item?.labour_cost_service_id) {
                // Exclude if labour_cost_service_id is 10
                return item.labour_cost_service_id !== 10;
              } else {
                // Exclude if id is 10
                return item.id !== 10;
              }
            })
          : additionalSelectedServices;
          console.log('filteredAdditionalServices', filteredAdditionalServices);
          console.log('filteredAdditionalServices  2', values.project_category?.id );
          values.sales_rep_names = details?.sales_rep_names;

        const hasEmptyProductName = selectedProducts?.some(product => (product.name || product.product_name || '').trim() === '');
        const hasEmptyServiceName = filteredAdditionalServices?.some(product => product.name.trim() === '');
        const hasEmptyMaterialName = selectedMaterials?.some(product => (product.name || product.product_name || '').trim() === '');
          
       if(selectedProducts?.length ==0 && additionalSelectedServices?.length == 0 && selectedMaterials?.length ==0 && userType !==3){
          enqueueSnackbar(values?.project_category?.id == 11 || values?.project_category?.id == 12 ? 'Please add at least one service.' : 'Please add at least one product or service.', { variant: 'error' });
          return;
        }

        const areAllAdditionalServicesTasks = filteredAdditionalServices.every(item => item.makeAsTask === 0);
        const hasMixedMakeAsTask = !filteredAdditionalServices.every(item => item.makeAsTask === 0 || item.makeAsTask === 1) ||
          (filteredAdditionalServices.some(item => item.makeAsTask === 0) &&
          filteredAdditionalServices.some(item => item.makeAsTask === 1));
        const areAllAdditionalServicesInstalls = filteredAdditionalServices.every(item => item.makeInstallCard === 0);
        const hasMixedMakeInstalls = !filteredAdditionalServices.every(item => item.makeInstallCard === 0 || item.makeInstallCard === 1) ||
          (filteredAdditionalServices.some(item => item.makeInstallCard === 0) &&
          filteredAdditionalServices.some(item => item.makeInstallCard === 1));
        
        const areAllAdditionalServicesJobCost = filteredAdditionalServices.every(item => item.jobCost === 0);
        const hasMixedMakeJobCost = !filteredAdditionalServices.every(item => item.jobCost === 0 || item.jobCost === 1) ||
          (filteredAdditionalServices.some(item => item.jobCost === 0) &&
          filteredAdditionalServices.some(item => item.jobCost === 1));
        // 🛑 Block submission if all tasks are off
        const additionalAllOff = filteredAdditionalServices?.length > 0 && filteredAdditionalServices.every(item => item?.makeInstallCard === 0);

        const cartServiceAllOff = cartService?.length > 0 && cartService.every(item => item?.makeInstallCard_lcs === 0);

        const allInstallCardsOff = (additionalAllOff || !filteredAdditionalServices?.length) && (cartServiceAllOff || !cartService?.length);

        let noServiceNoTask = false;
        // 🛑 Block submission if Service Only job and all tasks are off
        if ( values?.project_category?.id == 11 && allInstallCardsOff && selectedProducts.length == 0) {
          noServiceNoTask = true;
          // setShowMakeTaskErrorDialog(true);
          // return;
        }
        // 🛑 Block submission if T&M job and no products and material is there and all tasks are off
        if (
          values?.project_category?.id == 12 &&
          selectedProducts?.length === 0 &&
          selectedMaterials?.length === 0 &&
          allInstallCardsOff
        ) {
          // noServiceNoTask = true;
          noServiceNoTask = false;
          // setShowMakeTaskErrorDialog(true);
          // return;
        }
        // 🛑 Block submission if No Charge job and no products and material is there and all tasks are off
        if (
          values?.project_category?.id == 13 &&
          selectedProducts?.length === 0 &&
          selectedMaterials?.length === 0 &&
          allInstallCardsOff
        ) {
          noServiceNoTask = true;
          // setShowMakeTaskErrorDialog(true);
          // return;
        }

        // Use this condition inside your if-block
        if (!confirmMakeTask && (areAllAdditionalServicesTasks || areAllAdditionalServicesInstalls || areAllAdditionalServicesJobCost) && !hasMixedMakeAsTask && !hasMixedMakeInstalls && !hasMixedMakeJobCost && filteredAdditionalServices.length > 0 && userType != 3) {
            setOpenMakeTaskDialog(true); // your state for opening dialog
            return;
        }

        if (hasEmptyProductName) {
          enqueueSnackbar('Please fill in all required product names.', { variant: 'error' });
          return;
        }
        if (hasEmptyServiceName) {
          enqueueSnackbar('Please fill in all required service names.', { variant: 'error' });
          return;
        }
        if (hasEmptyMaterialName) {
          enqueueSnackbar('Please fill in all required material names.', { variant: 'error' });
          return;
        }

        // ✅ Split-order validation: for products from OTHER facilities, Delivery & Installation must be set
        if (details?.allInstallationCompleted != 1 && isSplitOrder && (Array.isArray(selectedProducts) && selectedProducts.length > 0 || Array.isArray(additionalSelectedServices) && additionalSelectedServices.length > 0)) {
          const missingDelivery = selectedProducts.filter((p) => {
            if (Number(p?.facility_id) === Number(currentFacilityId)) return false; // only other-facility products
            if (details?.for_parent_facility) return false; // mirror view shouldn't require setting
            const di = p?.delivery_installation || {};
            const deliveryTypeId = Number(di?.delivery_type_id || di?.complete_status || 0);
            const installerFacilityId = Number(di?.installer_facility_id || 0);
            return !deliveryTypeId || !installerFacilityId;
          });
          const missingDeliveryServices = additionalSelectedServices?.filter((p) => {
            if (Number(p?.facility_id) === Number(currentFacilityId)) return false; // only other-facility products
            if (details?.for_parent_facility) return false; // mirror view shouldn't require setting
            const di = p?.delivery_installation || {};
            const deliveryTypeId = Number(di?.delivery_type_id || di?.complete_status || 0);
            const installerFacilityId = Number(di?.installer_facility_id || 0);
            return !deliveryTypeId || !installerFacilityId;
          });

          if (missingDelivery.length > 0 || missingDeliveryServices.length > 0) {
            enqueueSnackbar(
              'Please set Delivery & Installation (facility + type) for other-facility products',
              { variant: 'error' },
            );

            // Optional: open the picker for the first missing product to speed up fixing
            try {
              openDeliveryInstallDialog(missingDelivery[0] || missingDeliveryServices[0]);
            } catch (e) {
              // no-op
            }

            return;
          }
        }

        const allServicesMatchCondition = additionalSelectedServices?.every(
          (service) => service.makeAsTask === 0 && service.makeInstallCard === 0
        );

        // ✅ Normal sales order validation: for ALL products/services, Delivery Type must be set
        // if (!isSplitOrder && (Array.isArray(selectedProducts) && selectedProducts.length > 0 || Array.isArray(additionalSelectedServices) && additionalSelectedServices.length > 0)) {
          if (
            details?.allInstallationCompleted != 1 &&
            !isSplitOrder &&
            !isDedicatedGroupedParent &&
            (
              (Array.isArray(selectedProducts) && selectedProducts.length > 0) || 
              (Array.isArray(additionalSelectedServices) && additionalSelectedServices.length > 0)
            ) && 
            !(allServicesMatchCondition && values.project_category?.id === 11)
          ) {
        const missingDelivery = selectedProducts.filter((p) => !getItemDeliveryTypeId(p));
          const missingDeliveryServices = additionalSelectedServices?.filter((p) => !getItemDeliveryTypeId(p));
          console.log('missingDelivery (normal sales order)', missingDelivery);
          console.log('missingDeliveryServices (normal sales order)', missingDeliveryServices);
          if (missingDelivery.length > 0 || missingDeliveryServices.length > 0) {
            enqueueSnackbar(
              'Please set Installation type (Installs/Pickup/Shipping) for all products and services',
              { variant: 'error' },
            );

            // Optional: open the picker for the first missing product to speed up fixing
            try {
              const firstMissing = missingDelivery[0] || missingDeliveryServices[0];
              const itemType = missingDelivery[0] ? 'product' : 'service';
              openDeliveryTypeDialog(firstMissing, itemType);
            } catch (e) {
              // no-op: keep submit blocked with snackbar error
            }

            return;
          }
        }

        // Check if all products have attachments
        const productsWithoutAttachments = selectedProducts?.filter((product) => {
          return getProductAttachmentsList(product.indexId).length === 0;
        });

        // Check if all products have attachments
        // const productsWithoutAttachments = selectedProducts?.filter(product => {
        //   const attachments = productAttachments[product.indexId] || [];
        //   return attachments.length === 0;
        // });

        // if (productsWithoutAttachments && productsWithoutAttachments.length > 0) {
        //   enqueueSnackbar('Please upload image/PDF for all selected products/catalogs.', { variant: 'error' });
        //   return;
        // }

        const hasInvalidProductName = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const newName = product.product_name || product.name;
          const trimmedName = newName.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Product name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Product name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          // if (!/^[a-zA-Z0-9\s-]+$/.test(trimmedName)) {
          //   enqueueSnackbar('Product name can only contain letters, numbers, and hyphens.', { variant: 'error' });
          //   return true;
          // }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Product name cannot contain colon (:).', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Product name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Product name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Product name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        const hasInvalidServiceName = filteredAdditionalServices?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const trimmedName = product.name.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Service name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Service name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Service name cannot contain colon (:).', { variant: 'error' });
            return true;
          }                
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Service name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Service name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Service name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        const hasInvalidMaterialName = selectedMaterials?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const newName = product.product_name || product.name;
          const trimmedName = newName.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Material name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Material name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Material name cannot contain colon (:).', { variant: 'error' });
            return true;
          }                
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Material name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Material name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Material name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        if (hasInvalidProductName || hasInvalidServiceName || hasInvalidMaterialName) {
          // enqueueSnackbar('Product names must contain letters or numbers.', { variant: 'error' });
          return;
        }

        // 🛑 Block if only proposal service or proposal exists and project_category is invalid
        if (
          selectedProducts?.length <= 0 &&
          selectedMaterials?.length <= 0 &&
          additionalSelectedServices?.length <= 0 &&
          (cartService?.length > 0 || cart?.length > 0)
        ) {
          if(values.project_category?.id == 11) {
            enqueueSnackbar("Please choose at least one additional service.",{ variant: 'error' });
          }else if(values.project_category?.id == 12 || values.project_category?.id == 13) {
            enqueueSnackbar("Please choose at least one additional service or catalog or material.",{ variant: 'error' });
          }else{
            enqueueSnackbar("Please choose at least one catalog.", { variant: 'error' });
          }
          return;
        }

        if(selectedProducts?.length <= 0 && selectedMaterials?.length <= 0 && additionalSelectedServices?.length > 0 && values.project_category?.id != 11 && values.project_category?.id != 12 && values.project_category?.id != 13 ) {
          enqueueSnackbar("Please select 'Service Only', 'Time & Material', or 'No Charge' as the job type or choose at least one catalog.", { variant: 'error' });
          return;
        }

        if(selectedProducts?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedMaterials?.length > 0 && values.project_category?.id != 12 && values.project_category?.id != 13 ) {
          if(values.project_category?.id == 11) {
            enqueueSnackbar("You have selected 'Service Only'. Please choose at least one additional service or choose 'Time & Material' as the job type.",{ variant: 'error' });
          }else{
            enqueueSnackbar("Please select 'Time & Material' as the job type or choose at least one catalog.", { variant: 'error' });
          }
          return;
        }

        if(selectedProducts?.length <= 0 && additionalSelectedServices?.length > 0 && selectedMaterials?.length > 0 && values.project_category?.id != 11 && values.project_category?.id != 12 && values.project_category?.id != 13 ) {
          enqueueSnackbar("Please select 'Service Only' or 'Time & Material' as the job type or choose at least one catalog.", { variant: 'error' });
          return;
        }
        const request_id = id
        const clientsArray = values.clients ? [values.clients] : [];
        values.clientsData = clientsArray
        // ALL-815 backup - previous submit without normalize: values.products = selectedProducts
        // Drop catalogs that were deactivated after the order was created (not in active allProducts).
        // Pending-estimate catalogs (status 0 + created_with_approval) are kept.
        const activeCatalogIds = new Set((allProducts || []).map((p) => Number(p.id)))
        const activeProductsForSave = (selectedProducts || []).filter((p) => {
          const productId = Number(p?.id ?? p?.product_id)
          if (!Number.isFinite(productId)) return false
          if (activeCatalogIds.has(productId)) return true
          const isPendingEstimateCatalog =
            Number(p?.status) === 0 &&
            Number(p?.created_with_approval) === 1 &&
            Number(p?.inhouse) === 7
          return isPendingEstimateCatalog
        })
        if (activeProductsForSave.length !== (selectedProducts || []).length) {
          console.warn(
            'Stripped inactive catalogs from SO save:',
            (selectedProducts || []).length - activeProductsForSave.length
          )
        }
        const productsForSave = isDedicatedGroupedParent
          ? activeProductsForSave.map(withGroupedParentDeliveryDefault)
          : activeProductsForSave
        values.products = productsForSave.map((product) =>
          normalizeProductForSave(resolveGroupMemberMarketingForSave(product, markupType)),
        )
        values.userName = user.first_name;
        // const allServices = [...selectedServices, ...additionalSelectedServices];
        // OLD: no dedupe — same service in selectedServices + additionalSelectedServices was submitted twice
        const dedupeServicesForSubmit = (list) => {
          const seenBackendIds = new Set()
          const seenLineKeys = new Set()
          return (list || []).filter((s) => {
            const backendId = s?.request_service_id ?? s?.backendId ?? (
              s?.id != null &&
              s?.labour_cost_service_id != null &&
              Number(s.id) !== Number(s.labour_cost_service_id)
                ? s.id
                : null
            )
            if (backendId != null) {
              const key = String(backendId)
              if (seenBackendIds.has(key)) return false
              seenBackendIds.add(key)
              return true
            }
            const lineKey = `${s?.labour_cost_service_id ?? s?.id ?? ''}_${s?.newIndexId ?? s?.indexId ?? s?.product_index ?? ''}`
            if (lineKey && seenLineKeys.has(lineKey)) return false
            if (lineKey) seenLineKeys.add(lineKey)
            return true
          })
        }
        const allServices = dedupeServicesForSubmit([
          ...selectedServices.map((s) => normalizeServiceForSave({ ...s, quantityDifference: 0 })),
          ...(isDedicatedGroupedParent
            ? (additionalSelectedServices || []).map((s) => normalizeServiceForSave(withGroupedParentDeliveryDefault(s)))
            : (additionalSelectedServices || []).map(normalizeServiceForSave)),
        ]);
        const servicesIdArray = allServices?.map(service => service.id);

        // Filter out images from avatarUrl that are already in productAttachments to avoid duplicates in database
        // Only images in productAttachments are linked to products/catalogs - filter those out
        // All other images in avatarUrl are unlinked and should be kept
        const allProductAttachmentUrls = Object.values(productAttachments).flat().map(f => f?.url || f?.name).filter(Boolean);
        const allServiceAttachmentUrls = Object.values(serviceAttachments).flat().map(f => f?.url || f?.name).filter(Boolean);
        const filteredAvatarUrl = avatarUrl.filter(file => {
          const fileIdentifier = file?.url || file?.name;
          // Keep the file if it has an identifier and is NOT in productAttachments (unlinked images)
          return fileIdentifier && !allProductAttachmentUrls.includes(fileIdentifier) && !allServiceAttachmentUrls.includes(fileIdentifier);
        });
        // Set avatarUrl in values - unlinked images are preserved, linked images are filtered out
        values.avatarUrl = filteredAvatarUrl || []
        values.productAttachments = productAttachments // Pass product attachments to backend
        values.serviceAttachments = serviceAttachments
        console.log('📤 [VIEW] Sending productAttachments to backend:', {
          productAttachmentsKeys: Object.keys(productAttachments),
          productAttachmentsCount: Object.keys(productAttachments).length,
          productAttachments: productAttachments
        });

        // values.project_category = values.project_type?.name == 'TS' ? (values.project_category || null) : null
        values.map_service = (values.project_type?.name == 'TS' && (values.project_category && values.project_category?.id == 14)) ? values.map_service : null

        values.services = servicesIdArray?.join(',')
        values.totalMarkup = totalMarkup
        values.selectedServices = allServices
        values.additionalSelectedServices = isDedicatedGroupedParent
          ? (additionalSelectedServices || []).map(withGroupedParentDeliveryDefault)
          : additionalSelectedServices
        values.depositAndProgressBilling = depositAndProgressBilling
        const allDepositRows = depositAndProgressBilling
          ? depositProgressBillingRows.reduce((rows, row) => {
            const title = row.title?.trim() || '';
            const remainingAmount = Math.max(
              (Number(grandTotal) || 0) -
                rows.reduce((sum, currentRow) => sum + (Number(currentRow.amount) || 0), 0),
              0
            );
            const amount = Math.min(Number(row.amount) || 0, remainingAmount);

            if (title && amount > 0) {
              rows.push({
                id: row.id,
                title,
                amount,
                markAsPaid: row.paymentMode ? 1 : row.markAsPaid || 0,
                paymentMode: row.paymentMode || null,
                originalPaymentMode: row.originalPaymentMode || null,
                originalMarkAsPaid: row.originalMarkAsPaid || 0,
              });
            }

            return rows;
          }, [])
          : [];
          
        // Filter out items that were already marked as paid when the edit page opened unless their payment mode changed
        values.depositProgressBillingRows = allDepositRows.filter(
          row => row.originalMarkAsPaid !== 1 || row.paymentMode !== row.originalPaymentMode
        );
        values['labour_cost'] = totalLabourCost;
        const prodAddress= selectedProducts.reduce((acc, product) => {
          return [
            ...acc,
            ...product.location.map((address) => ({
              ...address,
              productId: product.id,
              productIndex: product.indexId,
              isService:0
            })),
          ];
        }, []);
        const serviceAddress= additionalSelectedServices?.reduce((acc, product) => {
          return [
            ...acc,
            ...product.addresses.map((address) => ({
              ...address,
              productId: product.labour_cost_service_id || product.id,
              productIndex: product.indexId,
              newIndexId: product.newIndexId,
              isService:1
            })),
          ];
        }, []);

        const combinedAddress = [...serviceAddress, ...prodAddress];
        const finalNoChargeReason = values.no_charge_reason ?? details?.no_charge_reason ?? '';
        console.log('🔍 [FRONTEND] Sending noChargeReason:', finalNoChargeReason);
        console.log('🔍 [FRONTEND] details?.no_charge_reason:', details?.no_charge_reason);
        const submitIsNoChargeJob = values.project_category?.id === 13 || noCharge;
        const submitHasNegativeMarketingAdjustment =
          (selectedProducts || []).some(
            (p) => p?.adj_value_type === false || p?.install_adj_value_type === false || p?.adj_value_type === 0 || p?.install_adj_value_type === 0,
          ) ||
          (additionalSelectedServices || []).some(
            (s) => s?.adj_value_type === false || s?.install_adj_value_type === false || s?.adj_value_type === 0 || s?.install_adj_value_type === 0,
          ) ||
          (selectedMaterials || []).some((m) => m?.adj_value_type === false || m?.adj_value_type === 0);
        const shouldSendManagerApproval = submitIsNoChargeJob || submitHasNegativeMarketingAdjustment;

        const data = {
          values, userId, noServiceNoTask, userType, request_id,
          avalara_transaction_id:details?.avalara_transaction_id,
          avalara_code:details?.avalara_code,
          allLocationSame : (values.project_category?.name == 'Service only' || values.project_category?.name == 'Time & Material') ? false : allLocationSame ,
          allServiceLocationSame : allServiceLocationSame ,
          allRfpServiceLocationSame : allRfpServiceLocationSame ,
          allRfpProductsLocationSame : (values.project_category?.name == 'Service only' || values.project_category?.name == 'Time & Material') ? false : allRfpProductsLocationSame ,
          rfpProducts: cart,
          taxCategory : selectedTaxCategory?.id || null,
          rfpServices: cartService,
          materials:selectedMaterials,
          proj_status: details?.proj_status,
          sales_rep_ids: salesRepId,
          all_sales_rep_ids: allSalesRepIds,
          salesRepName:salesRepName,
          collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
          new_order: userType != 3 ? 0 : (details?.new_order || 0),
          noChargeReason: finalNoChargeReason,
          customerTypeId: values.customerTypeId,
          billingType: values.billing_type,
          manager_approval_required: false,
          // address: (values.project_category?.name == 'Service only' || values.project_category?.name == 'Time & Material')  ? serviceAddress : prodAddress
          address: combinedAddress,
          produtFormulaMaterial: produtFormulaMaterial,
          isFinalInvoiceEdit: isDedicatedGroupedParent
            ? (details?.allInstallationCompleted == 1 || Number(details?.isReview || 0) === 1)
            : (details?.allInstallationCompleted == 1 ? true : false),
           installation_acceptance : details?.installation_acceptance,
           isGroupedParentEdit: isDedicatedGroupedParent,
           estimate_qb_id : details?.estimate_id,
           invoice_qb_id : details?.invoice_qb_id,
           inv_doc_number : details?.doc_number,
           est_doc_number : details?.est_doc_number,
          groupProductMarketingData: groupedSelectedProducts ? groupedSelectedProducts.map((group) => ({
            group_id: group.id,
            group_name: group.name,
            group_description: group.description,
            quantity: group.groupQuantity || 1,
            adj_value_type: group.groupAdjValueType ?? true,
            adjustment: Number(group.groupAdjustment ?? 0),
            total_formula_each: Number((group.totalProductFormulaEach || 0).toFixed(2)),
            total_retail_each: Number((group.totalProductRetailEach || 0).toFixed(2)),
            adjusted_retail_each: Number((group.adjustedGroupRetailEach || 0).toFixed(2)),
            adjusted_subtotal: Number((group.adjustedGroupSubtotal || 0).toFixed(2)),
          })) : [],
          groupInstallMarketingData: groupedSelectedProducts ? groupedSelectedProducts.map((group) => ({
            group_id: group.id,
            group_name: group.name,
            group_description: group.description,
            quantity: group.groupInstallQuantity || 1,
            adj_value_type: group.groupInstallAdjValueType ?? true,
            adjustment: Number(group.groupInstallAdjustment ?? 0),
            total_formula_each: Number((group.totalInstallFormulaEach || 0).toFixed(2)),
            total_retail_each: Number((group.totalInstallRetailEach || 0).toFixed(2)),
            adjusted_retail_each: Number((group.adjustedGroupInstallRetailEach || 0).toFixed(2)),
            adjusted_subtotal: Number((group.adjustedGroupInstallSubtotal || 0).toFixed(2)),
          })) : [],
        }
        let isvalidationNotOk = false
        let isServicevalidationNotOk = false
        // if((values.project_category?.name == 'Service only') || (values?.project_category?.name == 'Time & Material')){
        if(additionalSelectedServices?.length > 0){
          isServicevalidationNotOk = additionalSelectedServices?.find(product => {
            if (product.addresses.length && product.addresses.some(obj =>
              [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
            )) {
              return true
            } else {
              return false
            }
          })
        }
        if((values.project_category?.name != 'Service only') && (values?.project_category?.name != 'Time & Material')){
          isvalidationNotOk = selectedProducts.find(product => {
            if (product.location.length && product.location.some(obj =>
              [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
            )) {
              return true
            } else {
              return false
            }
          })
        }
        values.total = totalsum
        values.taxAmount = taxAmount
        values.sub_total = rfqSubTotal
        values.budget = budget
        const productsForRushSave =
          selectedProducts?.length > 0
            ? selectedProducts
            : (values.products?.length > 0 ? values.products : [])
        if (isInstallBeforeRequiredLead(values, productsForRushSave)) {
          // Auto-ON unless override user explicitly saved/toggled rush_fee off
          if (!(canOverrideRushFeeLock && Number(values.rush_fee) === 0)) {
            values.rush_fee = 1
          }
        }
        values.rush_fee_amount = values.rush_fee == 1
          ? parseFloat((parseFloat(totalsum || 0) * ((Number(data?.rush_fee_percentage) || 0) / 100)).toFixed(2))
          : 0
        values.installationStatus = details?.installationStatus

        const isvalidationNotOkRfp = cart?.find(product => {
          if (product.location.length > 0 && product.location.some(obj =>
            [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
          )) {
            console.log("Validation failed for product:", product);
            return true;
          } else {
            console.log("Validation passed for product:", product);
            return false;
          }
        });

        let isvalidationNotOkRfpServices= false
        // if(values.project_category?.name == 'Service only' || (values?.project_category?.name == 'Time & Material')){
        if(cartService?.length > 0){
          isvalidationNotOkRfpServices = cartService?.find(product => {
            if (product.location.length > 0 && product.location.some(obj =>
              [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
            )) {
              console.log("Validation failed for product:", product);
              return true;
            } else {
              console.log("Validation passed for product:", product);
              return false;
            }
          });
        }

        if(userType != 3 &&
          (values?.project_category?.name == "Time & Material") && 
          // (cart.length <= 0 && cartService?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedProducts?.length <= 0)
          // (cartService?.length <= 0 && additionalSelectedServices?.length <= 0)
          // values.total <= 0
          (cartService?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedMaterials?.length <=0 && selectedProducts?.length <= 0)
        ){
          enqueueSnackbar('Please choose atleast one Service/ Proposal service', { variant: 'error' });
        }else if((values?.project_category?.name != "Time & Material") && (values.total <= 0) && values.project_categories == 15){
          enqueueSnackbar('Please select at least one product, service, Proposal, or material.', { variant: 'error' });
        }else if (
          isvalidationNotOk ||
          isServicevalidationNotOk || 
          isvalidationNotOkRfp || 
          isvalidationNotOkRfpServices 
        ) {
          enqueueSnackbar('Please fill all the address fields', { variant: 'error' });
        } else {
          setFormValues(values);
          setFormDatas(data);
          if (values.depositProgressBillingRows?.some((row) => Number(row.markAsPaid) === 1 && !row.paymentMode)) {
            setSubmitAfterDepositPaymentModeWarning(true);
            setOpenDepositPaymentModeWarningDialog(true);
            return;
          }

          if(details?.status == 4){
            setOpenDialog(true);
          }else{
            // Show client approval warning popup for any edits
            handleConfirmSubmit(values,data);
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  });

  console.log('details1234567890===details', details)
  console.log('details1234567890===isSplitOrder', isSplitOrder)
  const handleConfirmSubmit = async (values=null,data=null) =>{
    if (isSubmitting) {
      return;
    }
    setOpenDialog(false);
    setIsSubmitting(true);
    try{
      const formValuesData = values || formValues;
      const formDatasData = data || formDatas;
      console.log('Form Values:', formValuesData);
      console.log('Form Data:', formDatasData);

      const paymentAmountValidation = await validateDepositProgressBillingPaidAmount(
        formValuesData?.depositProgressBillingRows,
        Number(!empty(details?.allInstallationCompleted) ? invoice?.grandTotal : invoice?.total) || Number(grandTotal) || ((Number(formValuesData?.total) || 0) + (Number(formValuesData?.taxAmount) || 0))
      );
      if (!paymentAmountValidation.isValid) {
        enqueueSnackbar(`Amount exceeds the balance due. Please change the amount. Balance due is ${fUSPrice(paymentAmountValidation.balanceAmount)}.`, { variant: 'error' });
        return;
      }

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        ...formDatasData,
        collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
        quotation: formValuesData?.quotation || 0,
        socketId: null // Will be set by the progress modal
      };

      setProgressHeading("Updating Sales Order");
      setProgressRequestData(requestData);
      setShowProgressModal(true);
      
      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }
      // if(formValuesData.project_category.name =="Time & Material"){ 
      //   const productResponse = await axios.post(`${REST_API_END_POINT}product/add-product-on-request`,{values:formValuesData})

      //   if(productResponse) {
      //     await axios.post(`${REST_API}webservice/edit-request`, formDatasData)
      //     .then((res) => {
      //       setOpenEdit(false)
      //       setIsOpen(false)
      //       setSelectedTaxCategory(null);
      //       setCurrentRFQdata({}) // added on 3-01-2024
      //       setSelectedProducts([])
      //       setSelectedMapserviceProducts([]);
      //       setSelectedServices([]);
      //       setAdditionalSelectedServices([])
      //       setFilteredServices([])
      //       fetchRequestDetailsNew()
      //       fetchRequestDetails()
      //       if (edit) {
      //         navigate(`/dashboard/official-request`)
      //       }
      //       enqueueSnackbar('Update success', { variant: 'success' });
      //       formik.resetForm();
      //       // resetForm();
      //     })
      //     .catch((errors) => {
      //       console.log(errors, 'error')
      //     })
      //   }

      // }else{

// const newProductsAdded = selectedProducts.some(
//   (product) => !initialProducts.some(
//     (item) => item.id === product.id 
//   )
// );

const initialProductIds = new Set(initialProducts.map(p => p.id));
const currentProductIds = new Set(selectedProducts.map(p => p.id));

const newProductsAdded = selectedProducts.some(p => !initialProductIds.has(p.id));
const productsRemoved = initialProducts.some(p => !currentProductIds.has(p.id));

const productsChanged = newProductsAdded || productsRemoved || (selectedProducts.length !== initialProducts.length);
            // console.log("testststststs",selectedProducts);
            // console.log("testststststs",initialProducts);
            // console.log("testststststs",newProductsAdded);
            
//           const filteredCurrentServices = additionalSelectedServices.filter(
//   s => s.recipe_id === null || !s.recipe_id
// );

// const filteredInitialServices = initialServices.filter(
//   s => s.recipe_id === null || !s.recipe_id
// );

// const initialServiceIds = new Set(
//   filteredInitialServices.map(s => s.id)
// );

// const newServicesAdded = filteredCurrentServices.some(
//   service => !initialServiceIds.has(service.id) 
// );

const filterNoRecipe = (s) => !s.recipe_id;

const filteredCurrentServices = additionalSelectedServices.filter(filterNoRecipe);
const filteredInitialServices = initialServices.filter(filterNoRecipe);

const initialServiceIds = new Set(filteredInitialServices.map(s => s.id));
const currentServiceIds = new Set(filteredCurrentServices.map(s => s.id));

const newServicesAdded = filteredCurrentServices.some(s => !initialServiceIds.has(s.id));
const servicesRemoved = filteredInitialServices.some(s => !currentServiceIds.has(s.id));

const servicesChanged = newServicesAdded || servicesRemoved || 
                        (filteredCurrentServices.length !== filteredInitialServices.length);
            console.log("testststststs",additionalSelectedServices);
            console.log("testststststs",initialServices);
            console.log("testststststs333",servicesChanged);

const projectCategoryChanged =
  formValuesData?.project_category?.id !== details?.project_category;
            console.log("testststststs", projectCategoryChanged, formValuesData?.project_category?.id, details?.project_category);
            console.log("installationstatussssssssssss", details);

        const changeOccurredPSJ = !isDedicatedGroupedParent
          && (productsChanged || servicesChanged || projectCategoryChanged)
          && details?.installationStatus == 1;
        setChangeOccurredPSJ(changeOccurredPSJ);
        formDatasData.changeOccurredPSJ = changeOccurredPSJ;
 
  await axios.post(`${REST_API}webservice/edit-request`, formDatasData)
        .then((res) => {
          //  setChangeOccurredPSJ(false)
          if (res.data?.status === 0) {
            enqueueSnackbar(res.data?.message || 'Amount exceeds the balance due. Please change the amount.', { variant: 'error' });
            setShowProgressModal(false);
            return;
          }
          if (isDedicatedGroupedParent && res.data?.quickBooksError) {
            enqueueSnackbar(res.data.quickBooksError, { variant: 'warning' });
          } else if (isDedicatedGroupedParent && res.data?.qbReason && String(res.data.qbReason).includes('QuickBooks sync failed')) {
            enqueueSnackbar(res.data.qbReason, { variant: 'warning' });
          }
          // Check for changes before fetching updated details (compare with original details)
          const productServiceChanges = detectChanges();
          
          // Check form field changes (compare with original details before update)
          const formFieldChanges = [];
          
          if (formValuesData?.name !== details?.name) {
            formFieldChanges.push('name');
          }
          if (formValuesData?.description !== details?.description) {
            formFieldChanges.push('description');
          }
          if (formValuesData?.notes !== details?.notes) {
            formFieldChanges.push('notes');
          }
          if ((formValuesData?.no_charge_reason ?? '') !== (details?.no_charge_reason ?? '')) {
            formFieldChanges.push('no_charge_reason');
          }
          if (formValuesData?.project_category?.id !== details?.project_category) {
            formFieldChanges.push('project_category');
          }
          if (formValuesData?.project_type?.id !== details?.project_type) {
            formFieldChanges.push('project_type');
          }
          if (formValuesData?.markup_type?.id !== details?.markup_type) {
            formFieldChanges.push('markup_type');
          }
          
          // hasChanges is true if any products/services/materials changed, or the form has edits.
          // Using Formik's `dirty` is more reliable than comparing against `details` (which can
          // be re-fetched / reinitialized).
          // console.log("trtrtrtr");
          if(formValuesData?.project_category?.name === "Time & Material"){
            console.log("Time & Material project - treating all changes as significant");
              setAwaitingInvoicePopup(true)
              setOpenInvoice(true)
          }
          const hasChanges =
            productServiceChanges.length > 0 ||
            formFieldChanges.length > 0 ||
            formik.dirty;
          
          setOpenEdit(false)
          setIsOpen(false)
          setSelectedTaxCategory(null);
          setCurrentRFQdata({}) // added on 3-01-2024
          setSelectedProducts([])
          setSelectedMapserviceProducts([]);
          setSelectedServices([]);
          setAdditionalSelectedServices([])
          setFilteredServices([])
          setShowProgressModal(false);
Promise.all([
  fetchRequestDetailsNew(),
  fetchRequestDetails(),
  fetchProductAndMaterials(),
  handleJobLogUpdates(),
  // NEW: refresh invoice after save so view header waits on loadingEditInvoice (not stale invoice)
  fetchOrderProductDetails(),
]);
          let movedToProduction = res.data.movedToProduction
          let changeOccurredpsj = res.data.changeOccurredPSJ
          console.log('movedToProduction3', movedToProduction)
         const isTimeMaterial = formValuesData?.project_category?.name === "Time & Material"
         if(
           !isDedicatedGroupedParent &&
           res.data.checkProjectExist &&
           formValuesData?.client_approve === false &&
           !isSplitOrder && details?.allInstallationCompleted !== 1
         ){
            // enqueueSnackbar('Invoice approved. Converting to production now...', { variant: 'success' });
            // Don't close modal, just change heading and continue with conversion
           setProgressHeading("Converting to Production");
           handleConvertToJob(true, movedToProduction,isTimeMaterial,changeOccurredpsj); // Comment this line to work the previous state of the approved / in production dynamic
         }else if (
           !isDedicatedGroupedParent &&
           formValuesData?.project_category?.name === "Time & Material" &&
           formValuesData?.client_approve === false &&
           !isSplitOrder &&
           details?.allInstallationCompleted !== 1 &&
           mainCurrentTab !== 'INVOICING' &&
           mainCurrentTab !== 'COMPLETED'
         ) {
            // Don't close modal, just change heading and continue with conversion
            setProgressHeading("Converting to Production");
            editHandleConvertToJob(movedToProduction,isTimeMaterial)
            // if(popupOn){
            //   onDataChange()
              // closeView()
            // }
              //  setOpenInvoice(true)
        }else{
          // Close progress modal explicitly to ensure it closes in production
          setShowProgressModal(false);
          if(popupOn){        
            // localStorage.removeItem('salesOrderProjectId');
            // localStorage.removeItem('salesOrderProjectName');
            // localStorage.removeItem('isEditSalesOrder');
            // localStorage.removeItem('salesOrderOpenPopup',);
            // closeView()
            // setRenderCards(!renderCards)
            // onDataChange()
            //  localStorage.setItem('salesOrderProjectName', name);
              //  setOpenInvoice(true)
              // this chnage is for  delay the pop up for getting new data
                  setAwaitingInvoicePopup(true)
                  setTimeout(() => {
                    setIsOpenPopup(true);
                  }, 5000);
          }else{
            if (edit) {
              if(fromSplitSalesOrder){
                navigate(`/dashboard/split-order/split-sales-order`)
              }else{ 
              // navigate(`/dashboard/official-request`)
                editState=false
                setOpenEdit(false)
                  setAwaitingInvoicePopup(true)
                  setTimeout(() => {
                  setOpenInvoice(true)   
                  }, 500);

              }
            }
          }
        }
          // Show appropriate message based on changes detected
          if (hasChanges) {
            enqueueSnackbar('Update success', { variant: 'success' });
          } 
          // else {
          //   enqueueSnackbar('No changes', { variant: 'info' });
          // }
          formik.resetForm();
          // resetForm();
        })
        .catch((errors) => {
           setChangeOccurredPSJ(false)
          console.log(errors, 'error')
          // Close progress modal on error as well
          setShowProgressModal(false);
          setAwaitingInvoicePopup(false);
        })   
      // }
    } catch (error) {
      console.error('Error submitting form:', error);
      enqueueSnackbar('An error occurred during submission.', { variant: 'error' });
      // Close progress modal on error
      setShowProgressModal(false);
    } finally {
      setIsSubmitting(false);
      setFormValues({});
      setFormDatas({});
    }
  }

  const editHandleConvertToJob = async (movedToProduction,isTimeMaterial) => {
    console.log('isTimeMaterial', isTimeMaterial)
    try {
      // Check for unlinked locations before converting
      let unlinkedLocationsRes;
      try {
        unlinkedLocationsRes = await axios.post(`${REST_API}webservice/view-request-new`,
          { request_id: id, userId, userType });
      } catch (error) {
        // Fallback to view-request if view-request-new fails
        unlinkedLocationsRes = await axios.post(`${REST_API}webservice/view-request`,
          { request_id: id, userId, userType });
      }
      const unlinkedLocations = unlinkedLocationsRes?.data?.getRequestLocationsByRequestIdWhereIsLinkedAllZero || [];
      
      if (unlinkedLocations && unlinkedLocations.length > 0) {
        enqueueSnackbar('REMINDER: One or more catalog items are not linked to PDF or image.', { 
          variant: 'warning',
          autoHideDuration: 6000
        });
      }

      // setOpenConvertToRFQ(false);
      // setConvertToRFQ(true);
      let requestId = id
      let requestPartnerId = details?.rt_partner_id
      let acceptStatus = 1
      
      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        requestId,
        requestPartnerId,
        acceptStatus,
        userId,
        projectCategoryId: details?.project_category || values?.project_category?.id || isTimeMaterial ? 12 : null,
        socketId: null // Will be set by the progress modal
      };

      // If modal is already open (from previous operation), just update the data and continue
      if (showProgressModal) {
        setProgressRequestData(requestData);
        // Don't close and reopen modal, just continue with new data
      } else {
        setProgressHeading("Converting to Production");
        setProgressRequestData(requestData);
        setShowProgressModal(true);
      }

      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      const data = { requestId, requestPartnerId, acceptStatus, userId ,projectCategoryId: details?.project_category || values?.project_category?.id || isTimeMaterial ? 12 : null,installationStatus: details?.installationStatus}
      const res = await axios.post(`${REST_API}`, data);

      if (res.data.status == 1) {
        // setConfirmInvoice(false)
        // setRejectInvoice(false)
        setShowProgressModal(false);
        enqueueSnackbar('Job created successfully', { variant: 'success' });
        console.log('movedToProduction11', movedToProduction)
        console.log('time and materialssssssssss 2')
        console.log('details?.isSplitOrder',details?.isSplitOrder)
        // Exclude Category 11 (Service Only) and Category 13 (No Charge) from auto-triggering job-to-installation conversion
        if( (details?.project_status == 3 || res?.data?.directInstalls) && details?.project_category !== 11 && details?.project_category !== 13 && values?.project_category?.id !== 11 && values?.project_category?.id !== 13){
        // if( (res.data.allCreatedTask?.length <= 0 && !isTimeMaterial && details?.is_split_order !==1 && details?.project_category !== 11) || (isTimeMaterial && details?.allInstallationCompleted !==1 && details?.project_status == 3)){
          handleConvertJobToInstallation(requestId,res?.data?.directInstalls) // uncomment this if any section breaks
        }
      } else {
        // setConfirmInvoice(false)
        // setRejectInvoice(false)
        setShowProgressModal(false);
        enqueueSnackbar('Failed to convert Sales Order to Job', { variant: 'error' });
      }
      if(popupOn){
        localStorage.removeItem('salesOrderProjectId');
        localStorage.removeItem('salesOrderProjectName');
        localStorage.removeItem('isEditSalesOrder');
        localStorage.removeItem('salesOrderOpenPopup',);
        closeView()
        setRenderCards(!renderCards)
        onDataChange()
      }else{
        if (edit) {
          if(fromSplitSalesOrder){
            navigate(`/dashboard/split-order/split-sales-order`)
          }else{
            navigate(`/dashboard/official-request`)
          }
        }
      }
    } catch (error) {
      console.log(error, 'error in Converting Sales Order to job')
      // setConfirmInvoice(false)
      // setRejectInvoice(false)
      setShowProgressModal(false);
      enqueueSnackbar('Server Error', { variant: 'error' })
    }
    // finally{
    //   setConvertToRFQ(false);
    // }
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleUpdateSalesOrderHoldStatus = async (reason) => {
    if (Number(details?.status) === 6 || Number(details?.rejected) === 1) return;
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}sales_order/update-sales-order-hold-status`,
        {
          request_id: details?.id,
          userId: user.user_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        fetchRequestDetailsNew();
        fetchRequestDetails();
        fetchProductAndMaterials();
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  // useEffect(()=>{
  //   // let currentUnix = moment(currentDate).unix()
  //   //  let requestSubmitDeadline = details?.submission_deadline

  //    if((user?.user_id == details?.partner_user_id)&& (details?.accept_status == 0)){
  //     setReqAcceptClient(true)
  //    }

  // },[details])

  const submissionDeadlineUnix = details?.submission_deadline;
  const submissionDeadlineMoment = moment.unix(submissionDeadlineUnix);

  const current = moment();

  const daysLeft = submissionDeadlineMoment.diff(current, 'days');

  const handleDeleteTask = (id)=>{
    try {
      let newStatus = 2
      axios.post(`${REST_API_END_POINT}project/delete-project`,{ id: Number(id), status: newStatus },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4 || response.data.status === 2 || response.data.status === 1){
          enqueueSnackbar('Job deleted successfully', { variant: 'success' });
          onDataChange()
        }else if(response.data.status === 5 || response.data.status === 3 || response.data.status === 0){
          enqueueSnackbar('Failed to delete Job', { variant: 'error' });
        }
      }).catch((error) => {
        console.error(error);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleSplitOrderApproval = async () => {
    try {
      setRequestAccept(true);
      const data = {
        requestId: id,
        originRequestId: details?.origin_facility_request_id
      };

      const res = await axios.post(`${REST_API}webservice/request/approve-split-order-invoice`, data);
      if (res.data.status == 1) {
        enqueueSnackbar('Split order approved successfully', { variant: 'success' });
        onDataChange();
        fetchRequestDetailsNew();
        fetchRequestDetails();
        fetchProductAndMaterials();
      } else {
        console.log('res.data.message ==== ', res.data.message)
        enqueueSnackbar('Failed to approve split order', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error approving split order:', error);
      enqueueSnackbar('Error approving split order', { variant: 'error' });
    } finally {
      setRequestAccept(false);
      setConfirmInvoice(false);
    }
  };

  const handleUpdateReceivedStatus = async () => {
    setIsLoadingInvoice(true);
    try {
      const response = await axios.post(`${REST_API}webservice/request/update-received-status`, {
        requestId: id
      });
      if (response.data.status === 1) {
        enqueueSnackbar('Order marked as received successfully', { variant: 'success' });

        // Convert to production first - simplified version without UI updates
        let jobConversionSuccess = false;
        try {
          const jobResponse = await axios.post(`${REST_API}webservice/request/accept-or-reject-invoice`, {
            requestId: id,
            requestPartnerId: details?.rt_partner_id,
            acceptStatus: 1,
            userId,
            reason: '',
            movedToProduction: false,
            projectCategoryId: details?.project_category,
            installationStatus: details?.installationStatus,
            changeOccurredPSJ
          });
          if (jobResponse.data.status == 1) {
            jobConversionSuccess = true;
            console.log('Job conversion successful');
          } else {
            console.error('Job conversion failed:', jobResponse.data.message);
          }
        } catch (convertError) {
          console.error('Error in job conversion:', convertError);
        }

        // Only convert to installation if job conversion was successful
        if (jobConversionSuccess) {
          const completeStatus = Number(selectedOrderType) || 1;
          console.log('Sending completeStatus:', completeStatus, 'selectedOrderType:', selectedOrderType);
          console.log('Full payload being sent:', {
            selectedIds: id,
            userId,
            request: true,
            userType,
            clientId: details?.customer_id,
            completeStatus
          });
          try {
          if(!changeOccurredPSJ){  
            console.log("hiiiiiiiiiiiiiiiiiiiiiii2");
            
            const installResponse = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`, {
              selectedIds: id,
              userId,
              request: true,
              userType,
              clientId: details?.customer_id,
              completeStatus,
              receive_order: true
            });
            console.log('Install API response:', installResponse.data);
            if (installResponse.data.status == 1) {
              console.log('Installation conversion successful');
            } else {
              console.error('Installation conversion failed');
            }}
          } catch (installError) {
            console.error('Error in installation conversion:', installError);
          }
        }

        setOrderTypeSelection(false)
        onDataChange();
        fetchRequestDetailsNew();
        fetchRequestDetails();
        fetchProductAndMaterials();
      } else {
        enqueueSnackbar(response.data.message || 'Failed to update received status', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating received status:', error);
      enqueueSnackbar('Error updating received status', { variant: 'error' });
    } finally {
      setIsLoadingInvoice(false);
      setOrderTypeSelection(false);
    }
  };

  // Sales orders no longer use manager approval (estimate jobs only via EditEstimateJob)
  /* const handleManagerAccept = async () => {
    if (Number(details?.hold) === 1) return;
    try {
      setConfirmManagerAccept(false);
      const res = await axios.post(`${REST_API}webservice/request/manager-approve-reject-quotation`, {
        requestId: id,
        userId,
        action: 'accept',
      });
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message || 'Sales Order approved by manager.', { variant: 'success' });
       editState = false;     
       setOpenEdit(false); 
        fetchRequestDetailsNew();
        fetchRequestDetails();
        fetchProductAndMaterials();
        onDataChange?.();
      } else {
        enqueueSnackbar(res.data.message || 'Failed to approve', { variant: 'error' });
      }
    } catch (err) {
      console.log(err, 'error in manager accept');
      enqueueSnackbar(err?.response?.data?.message || 'Failed to approve', { variant: 'error' });
    }
  }; */

  const handleAcceptorRejectInvoice = async (value,underReview) => {
    try {
      if (Number(details?.hold) === 1) return;
      if ((value === 2 || value === 4) && reason === '') {
        enqueueSnackbar('Please fill rejected reason ', { variant: 'warning' })
        return
      }
      setConfirmInvoice(false)
      setRejectInvoice(false)
      setRequestAccept(true);
      // Sales orders no longer use manager approval reject flow
      /* if (value === 2 && userType != 3 && (details?.quotation_status === 9 || (details?.status === 2 && details?.quotation_status === 2 && (details?.manager_approval_required === true || details?.manager_approval_required === 1)))) {
        try {
          const res = await axios.post(`${REST_API}webservice/request/manager-approve-reject-quotation`, {
            requestId: id,
            userId,
            action: 'reject',
            reason: reason || '',
            rejectFile: rejectFile || undefined,
          });
          setRequestAccept(false);
          if (res.data.status === 1) {
            setRejectInvoice(false);
            setReason('');
            setRejectFile(null);
            enqueueSnackbar('Sales Order rejected by manager', { variant: 'success' });
            editState = false;     
       setOpenEdit(false); 
            fetchRequestDetailsNew();
            fetchRequestDetails();
            fetchProductAndMaterials();
            onDataChange?.();
          } else {
            enqueueSnackbar(res.data.message || 'Failed to reject', { variant: 'error' });
          }
        } catch (err) {
          setRequestAccept(false);
          console.log(err, 'error in manager reject');
          enqueueSnackbar(err?.response?.data?.message || 'Failed to reject', { variant: 'error' });
        }
        return;
      } */
      // Client estimate Accept/Reject (quotation_status 2 or 9, send_to_client 1): use accept-or-reject-quotation
      // if ((value === 1 || value === 2) && (details?.quotation_status === 2 || details?.quotation_status === 9) && details?.send_to_client != 0) {
      //   try {
      //     const data = { requestId: id, requestPartnerId: details?.rt_partner_id, acceptStatus: value, userId, reason };
      //     const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-quotation`, data);
      //     setRequestAccept(false);
      //     if (res.data.status == 1) {
      //       setOpenInvoice(false);
      //       setConfirmInvoice(false);
      //       setRejectInvoice(false);
      //       enqueueSnackbar('Sales Order approved', { variant: 'success' });
      //       fetchRequestDetailsNew();
      //       fetchRequestDetails();
      //       onDataChange?.();
      //     } else if (res.data.status == 2) {
      //       setOpenInvoice(false);
      //       setConfirmInvoice(false);
      //       setRejectInvoice(false);
      //       setReason('');
      //       enqueueSnackbar('Sales Order rejected', { variant: 'error' });
      //       fetchRequestDetailsNew();
      //       fetchRequestDetails();
      //       onDataChange?.();
      //     } else {
      //       enqueueSnackbar(res.data?.message || 'Failed', { variant: 'error' });
      //     }
      //   } catch (err) {
      //     setRequestAccept(false);
      //     enqueueSnackbar(err?.response?.data?.message || 'Failed', { variant: 'error' });
      //   }
      //   return;
      // }
      /* if(underReview){
        setConfirmInvoice(false);
        setRejectInvoice(false);
        let requestId = id
        let requestPartnerId = details?.rt_partner_id;
       
        const data = { requestId, requestPartnerId, userId, additionalAmount : ((invoice.jobcostTotal || 0) + (invoice.jobcostServiceTotal || 0)), grandTotal : invoice.grandTotal || invoice.total };
        const res = await axios.post(`${REST_API}webservice/sales-order/accept-review-order`,data);
        if (res.data.status == 1) {
          enqueueSnackbar('Moved to Invoicing', { variant: 'success' });
          setConfirmInvoice(false);
          setRejectInvoice(false);
          setOpenInvoice(false);
        }else{
          enqueueSnackbar('Failed to Approve final invoice', { variant: 'error' });
          setConfirmInvoice(false);
          setRejectInvoice(false);
          setOpenInvoice(false);
        }
        onDataChange()
        fetchRequestDetailsNew();
        fetchRequestDetails();
        fetchProductAndMaterials();
      }else */ if (value == 3) {
        setConfirmInvoice(false);
        setRejectInvoice(false);
        let requestId = id
        let requestPartnerId = details?.rt_partner_id;
       
        const data = { requestId, requestPartnerId, userId, additionalAmount : ((invoice.jobcostTotal || 0) + (invoice.jobcostServiceTotal || 0)), grandTotal : invoice.grandTotal || invoice.total };
        const res = await axios.post(`${REST_API}webservice/request/accept-final-invoice`,data);
        if (res.data.status == 1) {
          enqueueSnackbar('Final invoice approved', { variant: 'success' });
          setConfirmInvoice(false);
          setRejectInvoice(false);
          setOpenInvoice(false);
          onDataChange?.()
          fetchRequestDetailsNew();
          fetchRequestDetails();
          fetchProductAndMaterials();
        }else{
          enqueueSnackbar('Failed to Approve final invoice', { variant: 'error' });
          setConfirmInvoice(false);
          setRejectInvoice(false);
          setOpenInvoice(false);
          onDataChange?.()
          fetchRequestDetailsNew();
          fetchRequestDetails();
          fetchProductAndMaterials();
        }
      } else {
        let requestId = id
        let requestPartnerId = details?.rt_partner_id
        let acceptStatus = value
        let mirroredOrder = details?.for_parent_facility == 1
        let billing_type =details?.billing_type

        const data = { requestId, requestPartnerId, acceptStatus, userId, reason, billing_type,mirroredOrder, rejectFile,installationStatus: details?.installationStatus }
        // const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-invoice`, data);
        const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-request-new`, data);

        if (res.data.status == 1) {
          const isTimeMaterial = details?.project_category ==12
          if(res.data.checkProjectExist && !mirroredOrder){
            enqueueSnackbar('Invoice approved. Converting to production now...', { variant: 'success' });
            console.log('isTimeMaterial for client approve 1', isTimeMaterial)
         await handleConvertToJob(true,false,isTimeMaterial);
            setOpenInvoice(false);
          }else if(details.project_category ==13 || (invoice?.grandTotal <= 0  && !mirroredOrder)){
            enqueueSnackbar('Invoice approved. Converting to production now...', { variant: 'success' });
            console.log('isTimeMaterial for client approve 2', isTimeMaterial)
           await handleConvertToJob(true,false,isTimeMaterial);
            setOpenInvoice(false);
          }else{
            setOpenInvoice(false)
            setConfirmInvoice(false)
            setRejectInvoice(false)
            enqueueSnackbar(isMirrored ? 'Split Order approved' : 'Invoice approved', { variant: 'success' });
            editState = false;     
       setOpenEdit(false); 
            fetchRequestDetailsNew()
            fetchRequestDetails()
            fetchProductAndMaterials();
          }
        } else if (res.data.status == 2) {
          setOpenInvoice(false)
          setConfirmInvoice(false)
          setRejectInvoice(false)
          fetchRequestDetailsNew()
          fetchRequestDetails()
          fetchProductAndMaterials();
          if (res.data.jobRejected) {
            enqueueSnackbar(
              isMirrored ? 'Split Order and related Job moved to Rejected' : 'Sales Order and related Job moved to Rejected',
              { variant: 'error' }
            )
          } else if (res.data.checkProjectExist && Number(details?.proj_status) === 3) {
            enqueueSnackbar(
              isMirrored ? 'Split Order Rejected.' : 'Sales Order Rejected',
              { variant: 'error' }
            )
          } else {
            enqueueSnackbar(isMirrored ? 'Split Order Rejected' : 'Invoice Rejected', { variant: 'error' })
          }
          setReason('')
          setRejectFile(null)
          // navigate(PATH_DASHBOARD.official.root)
        } else {
          setOpenInvoice(false)
          setConfirmInvoice(false)
          setRejectInvoice(false)
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
      }
    } catch (error) {
      console.log(error, 'error in accepting invoice')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Failed to approve invoice'
      enqueueSnackbar(errorMessage, { variant: 'error' })
    }finally{
      setRequestAccept(false);
      if (typeof setRenderCards === 'function') {
        setRenderCards(!renderCards);
      }
    }
  }

  const submitGroupedFinalInvoiceApproval = async () => {
    setIsLoadingInvoice(true);
    try {
      await handleAcceptorRejectInvoice(3);
    } finally {
      setIsLoadingInvoice(false);
    }
  };

  const handleApproveInvoiceClick = async () => {
    if (Number(details?.hold) === 1) return;
    if (!checkJobTypeBeforeApprovalAction()) {
      return;
    }
    const permission = !explodedPermissions?.some((permission) => [
      'Approve Proofs(Final Client invoice approval)',
    ].includes(permission));

    if (details?.status == 4 && user.added_by_client == 1 && permission) {
      enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
      return;
    }

    const isFinalInvoiceApproval = details?.allInstallationCompleted === 1;

    if (isGroupedCombinedView && isFinalInvoiceApproval) {
      setCheckingGroupedQbSync(true);
      try {
        const res = await axios.post(`${REST_API}webservice/request/get-grouped-invoice-qb-sync-status`, {
          parentRequestId: id,
        });
        if (res.data?.status === 1 && res.data?.unsynced?.length > 0) {
          setGroupedQbSyncIssues(res.data.unsynced);
          setOpenGroupedQbWarning(true);
          return;
        }
      } catch (error) {
        console.error('Failed to check grouped QuickBooks sync status', error);
      } finally {
        setCheckingGroupedQbSync(false);
      }

      setConfirmInvoice(true);
      return;
    }

    setConfirmInvoice(true);
  };

  const allServicesTaskAndInstallOff = (services) =>
  !Array.isArray(services) ||
  services.length === 0 ||
  services.every(
    (service) =>
      Number(service?.makeAsTask ?? service?.makeAsTask_lcs ?? 0) === 0 &&
      Number(
        service?.makeInstallCard ?? service?.makeInstallcard_lcs ?? 0
      ) === 0
  );

// Prefer the form category while editing; fall back to saved project category.
const projectCategoryId = Number(
  formik?.values?.project_category?.id ?? details?.project_category
);

// Prefer currently selected form services; otherwise use saved services.
const servicesToCheck =
  Array.isArray(additionalSelectedServices) &&
  additionalSelectedServices.length > 0
    ? additionalSelectedServices
    : invoice?.jobcost_service;

const isConvertToInvoicing =
  (projectCategoryId === 11 || projectCategoryId === 13) &&
  (!invoice?.cust_product || invoice.cust_product.length === 0) &&
  allServicesTaskAndInstallOff(servicesToCheck);

  const handleConvertToJob = async (existingJob = false, movedToProduction = false,isTimeMaterial,changeOccurredpsj) => {
    try {
      // Check for unlinked locations before converting
      let unlinkedLocationsRes;
      try {
        unlinkedLocationsRes = await axios.post(`${REST_API}webservice/view-request-new`,
          { request_id: id, userId, userType });
      } catch (error) {
        // Fallback to view-request if view-request-new fails
        unlinkedLocationsRes = await axios.post(`${REST_API}webservice/view-request`,
          { request_id: id, userId, userType });
      }
      const unlinkedLocations = unlinkedLocationsRes?.data?.getRequestLocationsByRequestIdWhereIsLinkedAllZero || [];
      
      if (unlinkedLocations && unlinkedLocations.length > 0) {
        enqueueSnackbar('REMINDER: One or more catalog items are not linked to PDF or image.', { 
          variant: 'warning',
          autoHideDuration: 6000
        });
      }

      setOpenConvertToRFQ(false);
      setConvertToRFQ(true);
      let requestId = id
      let requestPartnerId = details?.rt_partner_id
      let acceptStatus = 1
     
      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        requestId,
        requestPartnerId,
        acceptStatus,
        userId,
        reason,
        details,
        movedToProduction,
        projectCategoryId:details?.project_category || values?.project_category?.id ||  isTimeMaterial ? 12 : null,
        socketId: null // Will be set by the progress modal
      };

      // If modal is already open (from previous operation), just update the data and continue
      if (showProgressModal) {
        setProgressRequestData(requestData);
        // Don't close and reopen modal, just continue with new data
      } else {
        setProgressHeading(isConvertToInvoicing ? " Converting to Invoicing" : " Converting to Production");
        setProgressRequestData(requestData);
        setShowProgressModal(true);
      }

      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }
      let projectCat = details?.project_category || values?.project_category?.id 

      const data = {
        requestId,
        requestPartnerId,
        acceptStatus,
        userId,
        reason,
        movedToProduction,
        projectCategoryId: projectCat,
        details: details,
        isTimeMaterial,
        installationStatus: details?.installationStatus,
        isConvertToInvoicing,
        salesOrderTabGlowTab: isConvertToInvoicing ? 'INVOICING' : 'IN PRODUCTION',
        changeOccurredPSJ: changeOccurredpsj,
        oldProjectStatus: details?.proj_status,
      }
      const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-invoice`, data);

      if (res.data.status == 1) {
        setConfirmInvoice(false)
        setRejectInvoice(false)
        setShowProgressModal(false);
        editState = false        
        setOpenEdit(false)  
        // if((details?.noServiceNoTask === 1 &&invoice?.cust_product?.length === 0 
        //     && invoice?.jobcost_service?.every(service => service?.makeAsTask === 0) && details?.project_category !== 12) ){
        //   enqueueSnackbar('Converted to Invoicing successfully', { variant: 'success' });
        // }
        // else{

        //   enqueueSnackbar(existingJob ? 'Job updated successfully' :'Job created successfully', { variant: 'success' });
        // }
        if (isConvertToInvoicing) {
          // ALL-1194: Order date updates when converting to / reaching invoice stage
          const orderDateUnix = moment().unix();
          setDetails((prev) => (prev ? { ...prev, timestamp: orderDateUnix } : prev));
          setCurrentRFQdata((prev) => ({ ...prev, timestamp: orderDateUnix }));
          formik.setFieldValue('timestamp', orderDateUnix);
          enqueueSnackbar('Converted to Invoicing successfully', { variant: 'success' });
          await Promise.all([
            fetchRequestDetailsNew(),
            fetchRequestDetails(),
            fetchProductAndMaterials(),
          ]);
          setDetails((prev) => (prev ? { ...prev, timestamp: orderDateUnix } : prev));
          setCurrentRFQdata((prev) => ({ ...prev, timestamp: orderDateUnix }));
          formik.setFieldValue('timestamp', orderDateUnix);
        } else {
          enqueueSnackbar(
            existingJob
              ? 'Job updated successfully'
              : 'Job created successfully',
            { variant: 'success' }
          );
        }
        console.log('movedToProduction', movedToProduction)
        console.log('time and materialssssssssss 1',isTimeMaterial)
        // if( (details?.proj_status === 3)){
        editState = false 
        // Convert to Invoicing must NOT run install conversion — that pushes some orders into production/installs
        if (isConvertToInvoicing) {
          // details/refetch already handled above with Order date sync
        } else if (res?.data?.hasPartialInstall){
          handleConvertPartialInstallation(requestId)
        // Exclude Category 11 (Service Only) and Category 13 (No Charge) from auto-converting to installation when directInstalls is returned
        } else if(res?.data?.directInstalls && details?.project_category !== 11 && details?.project_category !== 13 && values?.project_category?.id !== 11 && values?.project_category?.id !== 13){
          handleConvertJobToInstallation(requestId,res?.data?.directInstalls)
        // Exclude Category 11 (Service Only) and Category 13 (No Charge) from auto-converting to installation when there are no tasks created
        } else if (((res.data.allCreatedTask?.length <= 0 && details?.project_category !== 11 && details?.project_category !== 13 && values?.project_category?.id !== 11 && values?.project_category?.id !== 13) && !isTimeMaterial && details?.is_split_order !==1) || (isTimeMaterial && details?.allInstallationCompleted !==1 && details?.proj_status === 3)) {
          handleConvertJobToInstallation(requestId)
        } else {
          editState = false 
          fetchRequestDetailsNew()
          fetchRequestDetails()
          fetchProductAndMaterials()
        }
        // if(res.data.allCreatedTask?.length <= 0 && details?.job_category_name !== 11){
        //   handleConvertJobToInstallation(requestId)
        // }else if(details?.job_category_name== "Service only" || details?.job_category_name == 11){
        //   handleConvertJobToInstallation(requestId)
        // }else{
        //   fetchRequestDetailsNew()
        //   fetchRequestDetails()
        // }
        editState = false 
        onDataChange?.()
      } else {
        setConfirmInvoice(false)
        setRejectInvoice(false)
        setShowProgressModal(false);
         editState = false        
        setOpenEdit(false) 
        enqueueSnackbar('Failed to convert Sales Order to Job', { variant: 'error' });
      }
    } catch (error) {
      console.log(error, 'error in Converting Sales Order to job')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      setShowProgressModal(false);
      // enqueueSnackbar('Server Error', { variant: 'error' })
    }finally{
      editState = false 
      setConvertToRFQ(false);
    }
  }

  const handleConvertJobToInstallation = async (id,directInstalls)=>{
    const user = JSON.parse(window.localStorage.getItem('user'))
    let selectedIds=id
    let request = true
    let noChangeOrder = true
    // if (!changeOccurredPSJ) {
      console.log("hiiiiiiiiiiiiiiiiiiiiiii1");
      
       const response = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`,{selectedIds,userId,request,userType:userType , clientId:details?.customer_id,directInstalls,noChangeOrder})
    if(response.data.status==1){
      // enqueueSnackbar("Moved to Installation successfully !", { variant: 'success' });
      fetchRequestDetailsNew()
      fetchRequestDetails()
      fetchProductAndMaterials()
    }else{
      // enqueueSnackbar("Installation Not Moved !", { variant: 'error' });
      fetchRequestDetailsNew()
      fetchRequestDetails()
      fetchProductAndMaterials()
    }
    // }
   
  }

  const handleConvertPartialInstallation = async (id)=>{
       const response = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-partial-installation`,{ requestId: id,userId:user?.user_id })
    if(response.data.status==1){
      // enqueueSnackbar("Moved to Installation successfully !", { variant: 'success' });
      fetchRequestDetailsNew()
      fetchRequestDetails()
      fetchProductAndMaterials()
    }else{
      // enqueueSnackbar("Installation Not Moved !", { variant: 'error' });
      fetchRequestDetailsNew()
      fetchRequestDetails()
      fetchProductAndMaterials()
    }
   
  }

  const handleReopeningRequest = async () => {
    try {
      let requestId = id
      
      const data = { requestId, userId }
      const res = await axios.post(`${REST_API}webservice/request/reopen`, data)
      if (res.data.status == 1) {
        enqueueSnackbar('Order reopened successfully', { variant: "success" })
        setReopen(false)
        fetchRequestDetailsNew()
        fetchRequestDetails()
        fetchProductAndMaterials()
      } else if (res.data.status == 0) {
        enqueueSnackbar('Order reopened failed', { variant: "error" })
        setReopen(false)
      }
    } catch (error) {
      console.log(error, 'Error in reopen')
    }
  }
  // const handleAcceptOrRejectRequest=async(value)=>{
  //   try {
  //     console.log(value)
  //     let requestId = id
  //     let requestPartnerId = details?.rt_partner_id
  //     let acceptStatus = value
  //     let userId=user.user_id

  //     const data={requestId,requestPartnerId,acceptStatus,userId}
  //     const res = await axios.post(`${REST_API_END_POINT}request/accept-or-reject-request`,data)

  //     if(res.data.status ==1){
  //       setReqAcceptClient(!reqAcceptClient)
  //       setRequestAccept(false)
  //       setRequestReject(false)
  //       enqueueSnackbar(value === 1 ? 'Request Accepted' : 'Request Rejected', { variant: value === 1 ? 'success' : 'error' });
  //       if(value==2){
  //         navigate(PATH_DASHBOARD.official.root)
  //       }
  //     }
  //     // setReqAcceptClient(false)
  //     // setRequestAccept(false)
  //     // setRequestReject(false)
  //   } catch (error) {
  //     console.log(error,'error in reject request')
  //   }

  // }

  const { errors, values, touched, handleSubmit, setFieldValue, getFieldProps } = formik;

  // Keep edit Order/Invoice Date in sync with details.timestamp (print/email source) after INVOICING entry
  useEffect(() => {
    if (!openEdit || details?.timestamp == null) return;
    setFieldValue('timestamp', Number(details.timestamp));
  }, [openEdit, details?.timestamp, setFieldValue]);

  const remapProductIndexIds = useCallback(
    (indexIdMap, productsSnapshot) => {
      const remapKey = (oldKey) => {
        const mapped = indexIdMap[String(oldKey)]
        return mapped !== undefined ? String(mapped) : String(oldKey)
      }

      const remappedProducts = (productsSnapshot || []).map((product) => {
        const newId = indexIdMap[String(product.indexId)]
        if (newId === undefined) return product
        return {
          ...product,
          indexId: newId,
          product_index: newId,
        }
      })

      const remapKeyedState = (prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          next[newKey] = prev[oldKey]
        })
        return next
      }

      setSelectedProducts(remappedProducts)
      setFieldValue('products', remappedProducts)

      setProductAttachments((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          next[newKey] = (prev[oldKey] || []).map((f) => ({
            ...f,
            product_index_id: newKey,
          }))
        })
        return next
      })

      setAttachmentTabValue(remapKeyedState)
      setSelectedUploadedImages(remapKeyedState)
      setOpenProductAttachment(remapKeyedState)
      setLocationStates(remapKeyedState)
      setOpenProductNote(remapKeyedState)
      setOpenInstallNote(remapKeyedState)

      setSelectedServices((prev) =>
        (prev || []).map((service) => ({
          ...service,
          productIndex:
            indexIdMap[String(service.productIndex)] ?? service.productIndex,
          indexId: indexIdMap[String(service.indexId)] ?? service.indexId,
          newIndexId:
            indexIdMap[String(service.newIndexId)] ?? service.newIndexId,
          product_index:
            indexIdMap[String(service.product_index)] ?? service.product_index,
        })),
      )

      setAdditionalSelectedServices((prev) =>
        (prev || []).map((service) => ({
          ...service,
          productIndex:
            indexIdMap[String(service.productIndex)] ?? service.productIndex,
          indexId: indexIdMap[String(service.indexId)] ?? service.indexId,
          newIndexId:
            indexIdMap[String(service.newIndexId)] ?? service.newIndexId,
          product_index:
            indexIdMap[String(service.product_index)] ?? service.product_index,
        })),
      )

      setSelectedMaterials((prev) =>
        (prev || []).map((material) => ({
          ...material,
          newIndexId:
            indexIdMap[String(material.newIndexId)] ?? material.newIndexId,
          product_index:
            indexIdMap[String(material.product_index)] ?? material.product_index,
        })),
      )

      const maxIndex =
        remappedProducts.length > 0
          ? Math.max(...remappedProducts.map((p) => Number(p.indexId) || 0))
          : 0
      setIndexCounter(maxIndex)

      return remappedProducts
    },
    [setFieldValue],
  )

  const handleProductTableDragEnd = useCallback(
    async (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }
      if (!openEdit) return

      const renderOrder = [...productTableBodyRenderOrder]
      const [moved] = renderOrder.splice(result.source.index, 1)
      renderOrder.splice(result.destination.index, 0, moved)

      const orderedOldIds = []
      renderOrder.forEach((item) => {
        if (item.type === 'product') {
          orderedOldIds.push(item.indexId)
        } else if (item.type === 'group') {
          const group = groupedSelectedProductsMap.get(item.groupId)
          const groupProducts = [...(group?.products || [])].sort(
            (a, b) => (Number(a?.indexId) || 0) - (Number(b?.indexId) || 0),
          )
          groupProducts.forEach((p) => orderedOldIds.push(p.indexId))
        }
      })

      const orderedSet = new Set(orderedOldIds.map(String))
      ;(selectedProducts || []).forEach((p) => {
        if (p?.indexId != null && !orderedSet.has(String(p.indexId))) {
          orderedOldIds.push(p.indexId)
        }
      })

      const indexIdMap = {}
      orderedOldIds.forEach((oldId, idx) => {
        indexIdMap[String(oldId)] = idx + 1
      })

      remapProductIndexIds(indexIdMap, selectedProducts)

      if (id) {
        try {
          await axios.post(`${REST_API_END_POINT}request/reorder-estimate-products`, {
            requestId: id,
            indexMapping: indexIdMap,
            userId: user?.user_id,
          })
        } catch (error) {
          console.error('Error saving product order:', error)
          enqueueSnackbar('Failed to save product order', { variant: 'error' })
        }
      }
    },
    [
      productTableBodyRenderOrder,
      groupedSelectedProductsMap,
      selectedProducts,
      openEdit,
      id,
      user?.user_id,
      remapProductIndexIds,
      enqueueSnackbar,
    ],
  )

  const getServiceLineKey = (service) =>
    String(service?.newIndexId ?? service?.indexId ?? service?.product_index ?? '')

  const remapServiceIndexIds = useCallback((indexIdMap) => {
    const remapKey = (oldKey) => {
      const mapped = indexIdMap[String(oldKey)]
      return mapped !== undefined ? String(mapped) : String(oldKey)
    }

    const remapKeyedState = (prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = prev[oldKey]
      })
      return next
    }

    setAdditionalSelectedServices((prev) =>
      (prev || []).map((service) => {
        const oldKey = getServiceLineKey(service)
        const newId = indexIdMap[oldKey]
        if (newId === undefined) return service
        return {
          ...service,
          newIndexId: newId,
          indexId: newId,
          product_index: newId,
        }
      }),
    )

    setServiceAttachments((prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = (prev[oldKey] || []).map((f) => ({
          ...f,
          service_index_id: newKey,
        }))
      })
      return next
    })

    setAttachmentTabValueService(remapKeyedState)
    setSelectedUploadedImagesService(remapKeyedState)
    setOpenServiceAttachment(remapKeyedState)
    setIsUploadingService(remapKeyedState)
    setServiceNoteState(remapKeyedState)
    setServiceOnlyLocationStates(remapKeyedState)
  }, [setServiceNoteState])

  const handleServiceTableDragEnd = useCallback(
    async (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }
      if (!openEdit) return

      const sorted = [...(additionalSelectedServices || [])].sort(
        (a, b) =>
          (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
          (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
      )
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)

      const indexIdMap = buildServiceIndexMapping(sorted)

      remapServiceIndexIds(indexIdMap)

      if (id) {
        try {
          const res = await axios.post(`${REST_API_END_POINT}request/reorder-estimate-services`, {
            requestId: id,
            indexMapping: indexIdMap,
            userId: user?.user_id,
          })
          // OLD: fetchRequestDetails() on success reloaded the whole form (page refresh feel)
          // if (res?.data?.status === 1) {
          //   fetchRequestDetails()
          // } else {
          if (res?.data?.status !== 1) {
            enqueueSnackbar(res?.data?.message || 'Failed to save service order', { variant: 'error' })
          }
        } catch (error) {
          console.error('Error saving service order:', error)
          enqueueSnackbar('Failed to save service order', { variant: 'error' })
        }
      }
    },
    [
      additionalSelectedServices,
      openEdit,
      id,
      user?.user_id,
      remapServiceIndexIds,
      enqueueSnackbar,
    ],
  )

  const applyLeadTimeInstallPatch = (baseUnix, productsList) => {
    const products =
      productsList ??
      (selectedProducts?.length > 0 ? selectedProducts : values.products || []);
    const patch = getInstallEndPatchFromLead(values, baseUnix, products);
    if (patch) setFieldValue(patch.field, patch.finalUnix);
  };

  const applyInstallationFromStartAndLead = (newStartUnix) => {
    applyLeadTimeInstallPatch(getBaseUnixForLeadTime(values, newStartUnix));
  };

  // Needed for no-charge pricing UI (not manager approval)
  const isNoChargeJob = useMemo(() => {
    return values?.project_category?.id === 13 || noCharge;
  }, [values?.project_category, noCharge]);

  // Sales orders no longer use manager approval (estimate jobs only via EditEstimateJob)
  /* const hasNegativeMarketingAdjustment = useMemo(
    () =>
      (selectedProducts || []).some(
        (p) =>
          p?.adj_value_type === false ||
          p?.install_adj_value_type === false ||
          p?.adj_value_type === 0 ||
          p?.install_adj_value_type === 0
      ) ||
      (additionalSelectedServices || []).some(
        (s) =>
          s?.adj_value_type === false ||
          s?.install_adj_value_type === false ||
          s?.adj_value_type === 0 ||
          s?.install_adj_value_type === 0
      ) ||
      (selectedMaterials || []).some(
        (m) => m?.adj_value_type === false || m?.adj_value_type === 0
      ),
    [selectedProducts, additionalSelectedServices, selectedMaterials]
  );

  // const isNoChargeJob = useMemo(() => {
  //   return values?.project_category?.id === 13 || noCharge;
  // }, [values?.project_category, noCharge]);

  const managerApprovalLimit = Number(data?.manager_approval_amount) || 5000;
  
  const isAboveLimit = useMemo(() => {
    if (isNoChargeJob) {
      const ncl = Number(data?.no_charge_amount) || 5000;
      return Math.abs(parseFloat(grandTotal)) > Math.abs(ncl);
    }
    return parseFloat(grandTotal) > managerApprovalLimit;
  }, [isNoChargeJob, grandTotal, data?.no_charge_amount, managerApprovalLimit]);

  const isLocked = useMemo(() => {
    return (isNoChargeJob && isAboveLimit) || (hasNegativeMarketingAdjustment && isAboveLimit);
  }, [isNoChargeJob, hasNegativeMarketingAdjustment, isAboveLimit]);

  const prevIsNoCharge = useRef(isNoChargeJob);
  const prevHasNeg = useRef(hasNegativeMarketingAdjustment);
  const prevIsAbove = useRef(isAboveLimit);

  useEffect(() => {
    if (isLocked) {
      if (!values.manager_approval_required && details?.allInstallationCompleted != 1) {
        setFieldValue('manager_approval_required', true);
      }
    } else {
      if (isNoChargeJob && !prevIsNoCharge.current) {
        setFieldValue('manager_approval_required', false);
      } else if (hasNegativeMarketingAdjustment && !prevHasNeg.current) {
        setFieldValue('manager_approval_required', true);
      }
      else if (!isAboveLimit && prevIsAbove.current && showManagerApprovalToggle) {
        setFieldValue('manager_approval_required', false);
      }
      else if (!isNoChargeJob && prevIsNoCharge.current && !hasNegativeMarketingAdjustment && !isAboveLimit) {
         setFieldValue('manager_approval_required', false);
      }
      else if (!showManagerApprovalToggle && values.manager_approval_required) {
        setFieldValue('manager_approval_required', false);
      }
    }
    prevIsNoCharge.current = isNoChargeJob;
    prevHasNeg.current = hasNegativeMarketingAdjustment;
    prevIsAbove.current = isAboveLimit;
  }, [isLocked, isNoChargeJob, hasNegativeMarketingAdjustment, isAboveLimit, showManagerApprovalToggle, values.manager_approval_required, setFieldValue]); */
  const buildAddressLine = useCallback((addressParts = []) => {
    return addressParts
      .map((part) => (part == null ? '' : String(part).trim()))
      .filter(Boolean)
      .join(', ');
  }, []);

  const buildMultilineAddress = useCallback((name, address, city, state, zip) => {
    const line1 = (name == null ? '' : String(name).trim());
    const line2 = (address == null ? '' : String(address).trim());
    const line3 = buildAddressLine([city, state, zip]);
    return [line1, line2, line3].filter(Boolean).join('\n');
  }, [buildAddressLine]);

  const clientAddressForBillTo = useMemo(() => {
    return buildMultilineAddress(
    invoice?.customer_name || values?.clients?.name || values?.clients?.customer_name || '',
      invoice?.customer_address || values?.clients?.address || values?.clients?.customer_address || '',
      invoice?.customer_city || values?.clients?.city || values?.clients?.customer_city || '',
      invoice?.customer_state || values?.clients?.state || values?.clients?.customer_state || '',
      invoice?.customer_zipcode || values?.clients?.zip || values?.clients?.customer_zipcode || values?.clients?.zip_code || '',
    );
  }, [buildMultilineAddress, values?.clients]);

  const projectAddressForShipTo = useMemo(() => {
    return buildMultilineAddress(
      values?.community?.name || '',
      values?.community?.address || '',
      values?.community?.city || '',
      values?.community?.state || '',
      values?.community?.zip || '',
    );
  }, [buildMultilineAddress, values?.community]);

  const [isBillToDirty, setIsBillToDirty] = useState(false);
  const [isShipToDirty, setIsShipToDirty] = useState(false);
  const [billToInputValue, setBillToInputValue] = useState('');
  const [shipToInputValue, setShipToInputValue] = useState('');

  useEffect(() => {
    setIsBillToDirty(false);
  }, [values?.clients?.id, details?.id]);

  useEffect(() => {
    setIsShipToDirty(false);
  }, [values?.community?.id, details?.id]);

  // Seed / re-sync from saved value or client/project default only when user hasn't edited.
  useEffect(() => {
    if (isBillToDirty) return;
    const nextValue = (values?.bill_to || '').trim()
      ? values.bill_to
      : (clientAddressForBillTo || '');
    setBillToInputValue(nextValue);
  }, [isBillToDirty, values?.bill_to, clientAddressForBillTo, values?.clients?.id, details?.id]);

  useEffect(() => {
    if (isShipToDirty) return;
    const nextValue = (values?.ship_to || '').trim()
      ? values.ship_to
      : (projectAddressForShipTo || '');
    setShipToInputValue(nextValue);
  }, [isShipToDirty, values?.ship_to, projectAddressForShipTo, values?.community?.id, details?.id]);

  const currentProjectTypeId =
    values?.project_type?.id != null ? values.project_type.id : values?.project_type;

  const matchingProjectType =
    currentProjectTypeId != null
      ? projectTypes?.find((t) => String(t?.id) === String(currentProjectTypeId))
      : null;

  const isCurrentJobClassValid = Boolean(matchingProjectType);
  const isSingleJobClass = DOMAIN === 'la' && Array.isArray(projectTypes) && projectTypes.length === 1;
  const shouldHideJobClassDropdown = isSingleJobClass && isCurrentJobClassValid;

  // If the saved Job Class was deleted, keep the field BLANK (do NOT auto-pick the remaining one).
  // If we have an id but Formik doesn't hold the full object, normalize it to the matching object.
  useEffect(() => {
    // Only act once options are loaded.
    if (!Array.isArray(projectTypes)) return;

    if (currentProjectTypeId == null || currentProjectTypeId === '') {
      return;
    }

    if (!matchingProjectType) {
      setFieldValue('project_type', null);
      return;
    }

    // Normalize primitive id -> object.
    if (
      values?.project_type == null ||
      typeof values.project_type !== 'object' ||
      values.project_type?.id == null ||
      String(values.project_type.id) !== String(matchingProjectType.id)
    ) {
      setFieldValue('project_type', matchingProjectType);
    }
  }, [
    projectTypes,
    currentProjectTypeId,
    matchingProjectType,
    setFieldValue,
    values?.project_type,
  ]);

  const collaboratorSalesRepIds = useMemo(() => {
    const rawIds = values?.community?.all_sales_rep_ids ?? values?.community?.sales_rep_ids;
    if (!rawIds) {
      return [];
    }

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',')
        : [];

    return ids
      .map((id) => String(id ?? '').trim())
      .filter(Boolean);
  }, [values?.community]);

  const collaboratorOptions = useMemo(() => {
    const availableTeamMembers = Array.isArray(teamMembersOptions)
      ? teamMembersOptions
      : [];
  
    let collaboratorMembers = [...availableTeamMembers];
  
    // Preserve selected collaborators that are not currently
    // available in teamMembersOptions.
    if (collaborators?.length) {
      const availableMemberIds = new Set(
        collaboratorMembers
          .map((member) => member?.id ?? member?.user_id)
          .filter((id) => id != null)
          .map(String)
      );
  
      const missingSelections = collaborators.filter((member) => {
        const memberId = member?.id ?? member?.user_id;
  
        return (
          memberId != null &&
          !availableMemberIds.has(String(memberId))
        );
      });
  
      if (missingSelections.length) {
        collaboratorMembers = [
          ...collaboratorMembers,
          ...missingSelections,
        ];
      }
    }
  
    return collaboratorMembers;
  }, [teamMembersOptions, collaborators]);

  // const collaboratorOptions = useMemo(() => {
  //   const availableTeamMembers = Array.isArray(teamMembersOptions) ? teamMembersOptions : [];
  //   let filteredMembers = availableTeamMembers;

  //   if (collaboratorSalesRepIds.length > 0) {
  //     const allowedIds = new Set(collaboratorSalesRepIds);
  //     filteredMembers = availableTeamMembers.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && allowedIds.has(String(memberId));
  //     });
  //   }

  //   if (collaborators?.length) {
  //     const filteredIds = new Set(
  //       filteredMembers.map((member) => String(member?.id ?? member?.user_id))
  //     );
  //     const missingSelections = collaborators.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && !filteredIds.has(String(memberId));
  //     });
  //     if (missingSelections.length) {
  //       filteredMembers = [...filteredMembers, ...missingSelections];
  //     }
  //   }

  //   return filteredMembers;
  // }, [teamMembersOptions, collaboratorSalesRepIds, collaborators]);

  useEffect(() => {
    console.log('isSplitOrder>>>>', isSplitOrder)
    if (!isSplitOrder) return;
    if (!Array.isArray(values?.services) || !values?.services?.length) return;
    console.log('isSplitOrder>>>> values?.services?.length', values?.services?.length)
    const selectedFacilities = values?.facility_type || [];
    const regularSelectedServices = values?.services.filter(
      (item) => !item?.isAdditionalProduct
    ) || [];
    if (!selectedFacilities?.length) {
      if (!regularSelectedServices.length) return;
      const additionals = Array.isArray(values?.services) ? values.services.filter(item => item.isAdditionalProduct === true) : [];
      setFieldValue('services', additionals, false)
      setAdditionalSelectedServices(additionals)
      return;
    }
    console.log('isSplitOrder>>>> selectedFacilities', selectedFacilities)
    const selectedIds = new Set(selectedFacilities.map((f) => Number(f?.id)));
    const filteredRegular = regularSelectedServices.filter((s) => {
      if (!s?.facility_id) return true;
      return selectedIds.has(Number(s?.facility_id));
    });
    
    // Check if additionalSelectedServices is out of sync with filtered services
    const currentAdditionalServices = additionalSelectedServices?.filter(item => !item.isAdditionalProduct) || [];
    const needsSync = currentAdditionalServices.length !== filteredRegular.length || 
      currentAdditionalServices.some(service => {
        if (!service?.facility_id) return false;
        return !selectedIds.has(Number(service?.facility_id));
      });
    
    if (filteredRegular.length === regularSelectedServices.length && !needsSync) return;
    console.log('isSplitOrder>>>> filteredRegular', filteredRegular)
    const additionals = Array.isArray(values?.services) ? values.services.filter(item => item.isAdditionalProduct === true) : [];
    const updated = [...filteredRegular, ...additionals];
    console.log('isSplitOrder>>>> updated', updated)
    setFieldValue('services', updated, false)
    setAdditionalSelectedServices(updated)
  }, [isSplitOrder, values?.facility_type, values?.services]);

  // Function to handle submission after changes dialog
  const handleChangesDialogSubmit = (shouldApprove) => {
    console.log('🟢 Changes dialog submit:', shouldApprove);
    // Capture before clearing so we don't rely on state after setState
    const submission = pendingSubmission;
    setShowChangesDialog(false);
    setPendingSubmission(null);

    if (!submission) {
      console.log('❌ No pending submission found');
      return;
    }

    // Rename to avoid shadowing formik `values` (TDZ: Cannot access 'values' before initialization)
    const { values: submissionValues } = submission;
    const updatedValues = {
      ...submissionValues,
      isFromEstimate: 0,
      client_approve: !!shouldApprove,
    };
    console.log('🔄 Resubmitting with updated flags', {
      isFromEstimate: updatedValues.isFromEstimate,
      client_approve: updatedValues.client_approve,
    });

    formik.setValues(updatedValues);
    // Allow Formik state to flush before re-entering onSubmit
    setTimeout(() => {
      formik.submitForm();
    }, 100);
  };


  const handleCloseMakeTastDialog = () => {
    setOpenMakeTaskDialog(false)
 }

 const handleContinueMakeTastDialog = () => {
    setOpenMakeTaskDialog(false)
    setConfirmMakeTask(true)
 }

  const setValuesToPreview = () => {
    setPreviewData(values)
  }

  // let  totalsum = 0
  // let DiscountTotal=0
  // let newTotalProductFormula1 = 0;
  // let newTotalWholesalePrice1 = 0;
  // let newTotalRetailPrice1 = 0;

  const calculateTotal = (price, quantity, discount, value, location = 1, adjustment = 0,markAdjType=0,percentageSplit=0,adj_value_type=true) => {

    const parsedQuantity = parseFloat(quantity ? quantity : value) || 1;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity = parseFloat(location) || 1
    const newPrice = parseFloat(price) || 0
    // let subtotal = price * parsedQuantity * locationQuantity;
    let SPMA = newPrice //+ ((newPrice * (adjustment ? Number(adjustment) : 0)) / 100)
    let subtotal = parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity;

    if(markAdjType ==2 || markAdjType ==3){
      SPMA = newPrice //+ (adjustment ? Number(adjustment) : 0)
      subtotal = parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity;
    }

    if (discount) {
      subtotal = subtotal - discount;
    }
    // if (adjustment) {
    //   subtotal = subtotal + ((subtotal * adjustment) / 100);
    // }
    // if(adjustment){
    //   subtotal = subtotal + (adj_value_type ? Number(adjustment) : -(Number(adjustment)))
    // }
    if(details?.for_parent_facility){
      let amoutForSplit = parseFloat(Number(subtotal) * (Number(percentageSplit) / 100))
      subtotal = subtotal + amoutForSplit
    }
    console.log('calculateTotal--subtotal-price---',price)
    console.log('calculateTotal--subtotal-SPMA---',SPMA)
    console.log('calculateTotal--subtotal-adjustment---',adjustment)
    console.log('calculateTotal--subtotal----',subtotal)
    return subtotal;
  };

  const handleRetailPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, retail_price_draft: undefined }
              : product,
          ),
        )
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, retail_price_draft: limitedValue }
              : product,
          ),
        )
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.indexId === indexId
            ? { ...product, retail_price_draft: limitedValue }
            : product,
        ),
      )
      return
    }

    let adjustmentFieldToSync = null
    let adjustmentValueToSync = null

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const editResult = applyRetailPriceEdit(
          ensureCatalogBaselines(product),
          valueToApply,
          markupType,
          {
            hasNegativePermission: explodedPermissions?.some((permission) =>
              ['Allow Negative Marketing Adjustment Sales Order'].includes(
                permission,
              ),
            ),
          },
        )

        if (!editResult) {
          return { ...product, retail_price_draft: limitedValue }
        }

        if (editResult.error) {
          if (!isBlur) {
            return { ...product, retail_price_draft: limitedValue }
          }
          enqueueSnackbar(editResult.error, { variant: 'error' })
          return { ...product, retail_price_draft: undefined }
        }

        const reconciled = reconcileCatalogMarketingPrices({
          ...product,
          ...editResult,
          adjustment_draft: undefined,
        })

        const priceForTotal =
          markupType === 1
            ? reconciled.price
            : reconciled.install_cost && parseFloat(reconciled.install_cost) > 0
            ? reconciled.retail_price
            : reconciled.actual_retail_price

        const total = calculateTotal(
          priceForTotal,
          Number(product.quantity),
          product.discount || 0,
          product.quantity,
          product.locationQuantity,
          reconciled.adjustment,
          product.markAdjType,
          product?.split_percentage || splitPercentage,
          reconciled.adj_value_type,
        )

        adjustmentFieldToSync = `adjustment_${product.product_id || product.id}`
        adjustmentValueToSync = Number(reconciled.adjustment)
          ? reconciled.adjustment
          : ''

        return {
          ...reconciled,
          retail_price_draft: isBlur ? undefined : limitedValue,
          ...(markupType === 1 ? { product_price: reconciled.price } : {}),
          product_total: total,
        }
      }),
    )

    if (adjustmentFieldToSync != null) {
      setFieldValue(adjustmentFieldToSync, adjustmentValueToSync)
    }
    setRefreshCalculation((v) => !v)
  }

  const handleMarketingAdjustmentChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)

    if (limitedValue === '' || limitedValue === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            const originalActual = Number(
              baselined.original_actual_retail_price ?? 0,
            )
            const originalRetail = Number(
              baselined.original_retail_price ?? originalActual,
            )
            setFieldValue(
              `adjustment_${product.product_id || product.id}`,
              '',
            )
            return reconcileCatalogMarketingPrices({
              ...baselined,
              adjustment: 0,
              adjustment_draft: undefined,
              retail_price_edited: false,
              actual_retail_price: originalActual,
              retail_price: originalRetail,
            })
          }),
        )
        setRefreshCalculation((v) => !v)
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            const originalActual = Number(
              baselined.original_actual_retail_price ?? 0,
            )
            const originalRetail = Number(
              baselined.original_retail_price ?? originalActual,
            )
            return {
              ...product,
              adjustment_draft: '',
              adjustment: '',
              actual_retail_price: originalActual,
              retail_price: originalRetail,
              retail_price_edited: false,
              retail_price_draft: undefined,
            }
          }),
        )
        setRefreshCalculation((v) => !v)
      }
      return
    }

    if (!isBlur) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) => {
          if (product.indexId !== indexId) return product

          const hasPermission = explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Sales Order'].includes(
              permission,
            ),
          )
          const { maxNegative } = getMaxNegativeAdjustment(product, hasPermission)
          if (
            Number(limitedValue) >= maxNegative &&
            (product.adj_value_type === false || product.adj_value_type === 0) &&
            hasPermission
          ) {
            enqueueSnackbar('Retail value cannot be zero or less', {
              variant: 'error',
            })
            return product
          }
          if (
            Number(limitedValue) > maxNegative &&
            (product.adj_value_type === false || product.adj_value_type === 0) &&
            !hasPermission
          ) {
            enqueueSnackbar(
              `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Product Formula Limit)`,
              { variant: 'error' },
            )
            return product
          }

          const numAdjustment = Number(limitedValue) || 0
          const signedAdj =
            product.adj_value_type === false || product.adj_value_type === 0
              ? -numAdjustment
              : numAdjustment
          const baselined = ensureCatalogBaselines(product)
          const originalActual = Number(
            baselined.original_actual_retail_price ?? 0,
          )
          const originalRetail = Number(
            baselined.original_retail_price ?? originalActual,
          )

          return {
            ...product,
            adjustment_draft: limitedValue,
            adjustment: limitedValue,
            actual_retail_price: Number((originalActual + signedAdj).toFixed(2)),
            retail_price: Number((originalRetail + signedAdj).toFixed(2)),
            retail_price_edited: numAdjustment !== 0,
            retail_price_draft: undefined,
          }
        }),
      )
      setRefreshCalculation((v) => !v)
      return
    }

    const normalizedValue = formatPriceToTwoDecimals(limitedValue)
    const numValue = Number(normalizedValue) || 0

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const hasPermission = explodedPermissions?.some((permission) =>
          ['Allow Negative Marketing Adjustment Sales Order'].includes(
            permission,
          ),
        )
        const { maxNegative } = getMaxNegativeAdjustment(product, hasPermission)
        if (
          numValue >= maxNegative &&
          (product.adj_value_type === false || product.adj_value_type === 0) &&
          hasPermission
        ) {
          enqueueSnackbar('Retail value cannot be zero or less', {
            variant: 'error',
          })
          return { ...product, adjustment_draft: undefined }
        }
        if (
          numValue > maxNegative &&
          (product.adj_value_type === false || product.adj_value_type === 0) &&
          !hasPermission
        ) {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Product Formula Limit)`,
            { variant: 'error' },
          )
          return { ...product, adjustment_draft: undefined }
        }

        const signedAdj =
          product.adj_value_type === false || product.adj_value_type === 0
            ? -numValue
            : numValue
        const baselined = ensureCatalogBaselines(product)
        const originalActual = Number(baselined.original_actual_retail_price ?? 0)
        const originalRetail = Number(
          baselined.original_retail_price ?? originalActual,
        )

        const reconciled = reconcileCatalogMarketingPrices(
          normalizeProductForSave({
            ...baselined,
            adjustment: numValue,
            adj_value_type: numValue === 0 ? true : product.adj_value_type ?? true,
            actual_retail_price: Number((originalActual + signedAdj).toFixed(2)),
            retail_price: Number((originalRetail + signedAdj).toFixed(2)),
            retail_price_edited: numValue !== 0,
            adjustment_draft: undefined,
            retail_price_draft: undefined,
          }),
        )

        setFieldValue(
          `adjustment_${product.product_id || product.id}`,
          numValue ? normalizedValue : '',
        )

        return reconciled
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleInstallPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, install_price_draft: undefined }
              : product,
          ),
        )
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, install_price_draft: limitedValue }
              : product,
          ),
        )
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.indexId === indexId
            ? { ...product, install_price_draft: limitedValue }
            : product,
        ),
      )
      return
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const editResult = applyInstallPriceEdit(
          ensureCatalogBaselines(product),
          valueToApply,
          {
            hasNegativePermission: explodedPermissions?.some((permission) =>
              ['Allow Negative Marketing Adjustment Sales Order'].includes(
                permission,
              ),
            ),
          },
        )

        if (!editResult) {
          return { ...product, install_price_draft: limitedValue }
        }

        if (editResult.error) {
          if (!isBlur) {
            return { ...product, install_price_draft: limitedValue }
          }
          enqueueSnackbar(editResult.error, { variant: 'error' })
          return { ...product, install_price_draft: undefined }
        }

        const normalized = normalizeProductForSave({
          ...product,
          ...editResult,
        })

        const total = calculateTotal(
          normalized.retail_price,
          Number(product.quantity),
          product.discount || 0,
          product.quantity,
          product.locationQuantity,
          normalized.adjustment,
          product.markAdjType,
          product?.split_percentage || splitPercentage,
          normalized.adj_value_type,
        )

        return {
          ...normalized,
          install_price_draft: isBlur ? undefined : limitedValue,
          install_adjustment_draft: undefined,
          product_total: total,
        }
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const applyProductAdjValueTypeChange = (product, newValue) => {
    const baselined = ensureCatalogBaselines(product)
    const adjustment = Number(baselined.adjustment) || 0
    const signedAdj = newValue ? adjustment : -adjustment
    const originalActual = Number(baselined.original_actual_retail_price ?? 0)
    const originalRetail = Number(
      baselined.original_retail_price ?? originalActual,
    )

    const reconciled = reconcileCatalogMarketingPrices({
      ...baselined,
      adj_value_type: newValue,
      actual_retail_price: Number((originalActual + signedAdj).toFixed(2)),
      product_retail_price: Number((originalActual + signedAdj).toFixed(2)),
      retail_price: Number((originalRetail + signedAdj).toFixed(2)),
      retail_price_edited: adjustment !== 0,
      retail_price_draft: undefined,
    })

    const total = calculateTotal(
      reconciled.retail_price,
      Number(product.quantity),
      product.discount || 0,
      product.quantity,
      product.locationQuantity,
      reconciled.adjustment,
      product.markAdjType,
      product?.split_percentage || splitPercentage,
      reconciled.adj_value_type,
    )

    return {
      ...reconciled,
      product_total: total,
    }
  }

  const applyInstallAdjValueTypeChange = (product, newValue) => {
    const baselined = ensureCatalogBaselines(product)
    const adjustment = Number(baselined.install_adjustment) || 0
    const signedAdj = newValue ? adjustment : -adjustment
    const baseInstall = Number(
      baselined.original_install_cost ?? baselined.install_cost ?? 0,
    )
    const originalActual = Number(baselined.original_actual_retail_price ?? 0)
    const signedProductAdj = getSignedMarketingAdjustment(baselined)
    const newInstallCost = baseInstall
      ? Number((baseInstall + signedAdj).toFixed(2))
      : baselined.install_cost
    const newActual = Number((originalActual + signedProductAdj).toFixed(2))
    const newRetail = Number((newActual + Number(newInstallCost || 0)).toFixed(2))

    const normalized = normalizeProductForSave({
      ...baselined,
      install_adj_value_type: newValue,
      install_cost: newInstallCost,
      install_price_edited: adjustment !== 0,
      retail_price: newRetail,
      install_price_draft: undefined,
    })

    const total = calculateTotal(
      normalized.retail_price,
      Number(product.quantity),
      product.discount || 0,
      product.quantity,
      product.locationQuantity,
      normalized.adjustment,
      product.markAdjType,
      product?.split_percentage || splitPercentage,
      normalized.adj_value_type,
    )

    return {
      ...normalized,
      product_total: total,
    }
  }

  const calculateServiceTotal = (price, quantity, discount, value, location = 1) => {

    const parsedQuantity = parseFloat(quantity ? quantity : value) || 0;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity = parseFloat(location) || 1
    const subtotal = price * parsedQuantity * locationQuantity;

    if (discount) {
      const totalDiscount = subtotal - discount;
      return totalDiscount;
    } else {
      return subtotal;
    }
  };
  let sum = 0
  let taxAmountData = 0 ;
  let grandTotalData = 0;
  let totalJobcostSum = 0
  let newTaxSum = 0;
  useEffect(() => {
    try {
      console.log('selectedProducts-----', selectedProducts);
      // if(selectedProducts?.length > 0 || selectedServices?.length > 0 || additionalSelectedServices?.length > 0){
      const groupIdsForProductLineTotal = new Set()
      let selectedProductsTotalDiscount = selectedProducts?.reduce((total, data, index) => {
        const gidRaw = getProductGroupId(data)
        if (gidRaw != null && String(gidRaw) !== '') {
          const gKey = String(gidRaw)
          if (groupIdsForProductLineTotal.has(gKey)) return total
          groupIdsForProductLineTotal.add(gKey)
          const group = groupedSelectedProductsMap.get(gKey)
          if (group) {
            return total + Number(group.adjustedGroupTotal || 0)
          }
        }

        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = (data.install_cost && parseFloat(data.install_cost) > 0) ? (data.product_retail_price || data.retail_price || 0) : (data.actual_retail_price || data.retail_price || 0)
        const dataWholesalePrice = data.product_price || data.price || 0
        
        // const dataQuantity = values[quantityFieldName]?values[quantityFieldName]:(data?.quantity||1)

        // const dataDiscount = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
        const dataQuantity = data?.quantity || 1

        const dataDiscount = data?.discount || 0;

        // Calculate product subtotal (same as Product Total calculation in table)
        const locQty = Number(data?.locationQuantity) || 1
        const productSubTotal = markupType == 1
          ? (Number(data?.price) || 0) * locQty
          : markupType == 2
          ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
          : 0

        // Calculate install subtotal (same as Install Subtotal calculation in table)
        // Null + install_cost → default 1 (new adds). Explicit 0 stays 0 (ALL-37 split orders).
        const installQty =
          data?.install_quantity == null && data?.install_cost
            ? 1
            : Number(data?.install_quantity ?? 0)
        const installSubTotal = (Number(data?.install_cost) || 0) * installQty

        // Product Total is the sum of both subtotals minus discount (same as table calculation)
        const productTotal = Math.max(0, productSubTotal + installSubTotal - dataDiscount)
        const fixedProductTotal = parseFloat(productTotal).toFixed(2);
        return total + parseFloat(fixedProductTotal);
      }, 0);

      const selectedProductsTotalDiscountForJobCost = selectedProducts?.reduce((total, data, index) => {
        const quantityFieldName = `quantity_${data.product_id || data.id}`;
        const discountFieldName = `discount_${data.product_id || data.id}`;
        const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
        const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
        console.log("###############quantityVal", quantityVal)
        console.log("###############quantityValdata", data)
        // const productTotal = calculateTotal(data.expected_material_cost, data.quantity, discountVal);
        const productTotal = calculateTotal(parseFloat(data.expected_material_cost), data.quantity, 0, null, data.locationQuantity, 0);
        console.log("###############product formula", productTotal)
        return total + productTotal;
      }, 0);
      // const allServices = [...selectedServices, ...additionalSelectedServices];
      const allServices = [...additionalSelectedServices];
      console.log("allServicesssss ",allServices)
      let selectedServicesCost = allServices?.reduce((total, service, index) => {
        // const quantityFieldName = `service_quantity_${index}`;
        // const quantityVal = values[quantityFieldName]?values[quantityFieldName]:1
        const quantityVal = service?.quantity ? Number(service?.quantity) : 0
        const serviceTotal = calculateServiceTotal(service.cost, quantityVal, 0);

        console.log("############SSSSSSSSSSSer", serviceTotal);

        // let selectedQuantity=selectedProducts.filter(product=>product.id===service.product_id)
        // console.log("############SSSSSSSSSSSer",selectedQuantity);
        // let quantity=selectedQuantity[0].quantity
        // return total + (serviceTotal*quantity);
        return total + serviceTotal;
      }, 0);
      // selectedServicesCost = selectedServicesCost - initialServiceCostInProductFormula
      console.log('allServices-----------', allServices);

      let selectedServicesTotalCost = allServices?.reduce((total, service, index) => {
        const quantityVal = service?.quantity ? Number(service?.quantity) : 0
        const costVal = service?.unit_cost ? Number(service?.unit_cost) : Number(service?.total_cost)
        const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0);
        // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
        return total + serviceTotal;
      }, 0);

      // New taxable toggle cost
      let selectedTaxServicesTotalCost = allServices?.reduce((total, service, index) => {
      if (service?.taxable === 0) return total;
      const quantityVal = service?.quantity ? Number(service?.quantity) : 0;
      const costVal = service?.unit_cost ? Number(service?.unit_cost) : Number(service?.total_cost);
      const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0);
      return total + serviceTotal;
    }, 0);

      // const productServices = selectedProducts?.reduce((services, product) => {
      //   if (product.services?.length > 0) {
      //     return services.concat(
      //       product.services.map((service) => {
      //         const cost = parseFloat(service.unit_cost ?? service.total_cost ?? 0);
      //         const quantity = parseFloat(service.quantity ?? 1);
      //         const retail_price = parseFloat(service.retail_price ?? 0);
      //         const locationQty = parseFloat(product.locationQuantity ?? 1);

      //         const subtotal = cost * quantity;
      //         const markup = (subtotal * retail_price) / 100;
      //         const total = (subtotal + markup) * locationQty;

      //         return {
      //           ...service,
      //           totalCost: total.toFixed(2),
      //         };
      //       })
      //     );
      //   }
      //   return services;
      // }, []);
      // console.log('productServicesproductServices', productServices)
      // const getTotalServiceCostSum = (services) => {
      //   return parseFloat(
      //     services.reduce((sum, item) => {
      //       console.log('itemservices', item);
      //       if (item.id !== 10) return sum;
      //       const cost = parseFloat(item.totalCost ?? 0);
      //       return sum + cost;
      //     }, 0).toFixed(2)
      //   );
      // };


      // const totalInstallServiceCostSum = getTotalServiceCostSum(productServices);

    // console.log("productServices ",productServices)

    const installCost = selectedProducts?.map((product) => {
      const retailPrice = parseFloat(product.install_cost  || 0);
      const locationQuantity = parseFloat(product.locationQuantity || 1);

      const total = retailPrice * locationQuantity;

      return {
        ...product,
        totalCost: total.toFixed(2),
      };
    });
        console.log('🧾 installCost', installCost);

    const getTotalInstallCostSum = (installCost = []) => {
      return installCost.reduce((sum, item) => {
        const cost = parseFloat(item.totalCost || 0);
        return sum + cost;
      }, 0).toFixed(2);
    };

    const totalInstallCostSum = getTotalInstallCostSum(installCost);
    console.log('🧾 Total cost production costtt', totalInstallCostSum);
    setInstallCost(totalInstallCostSum)
    console.log("selected serviceee old ",selectedServicesTotalCost)
    console.log("selected serviceee new ",selectedTaxServicesTotalCost)

      let initialServicesCost =0
      //  selectedProducts?.reduce((total, data, index) => {
      //   const serviceTotal = (data?.quantity) * (parseFloat(data?.expected_total_service_cost?.toFixed(2))) * (data?.locationQuantity || 1) || 0;
      //   // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
      //   return total + serviceTotal;
      // }, 0);
console.log('selectedProductsselectedProducts',selectedProducts)
            const productMaterial = selectedProducts?.reduce((materials, product) => {
        if (product.materials && product.materials.length > 0) {
          return materials.concat(
            product.materials
              .map((material) => {
                console.log('materialsssssss',material)
                const price = parseFloat(material.max_unit_cost || 0);
                const quantity = parseFloat(material.quantity || 1);
                const retail_price = parseFloat(material.retail_price || 0);

                const subtotal = price * quantity;
                const markup = (subtotal * retail_price) / 100;
                const total = (subtotal + markup) * (product.locationQuantity || 1)

                console.log('✅ total, subtotal, markup:', total, subtotal, markup);
                console.log('✅ price, quantity, retail_price:', price, quantity, retail_price);

                return {
                  ...material,
                  totalCost: total.toFixed(2),
                };
              })
          );
        }
        return materials;
      }, []);

      setProductFormulaMaterial(productMaterial)

      const getTotalCostSum = (productMaterial) => {
        return productMaterial.reduce((sum, item) => {
                  console.log('itemmmmmm',item)
          // Only include if taxable == 0 (string or number)
          if (Number(item.taxable) !== 0) return sum;

          const cost = parseFloat(item.totalCost || 0);
          return sum + cost;
        }, 0).toFixed(2);
      };

      const totalCostSum = getTotalCostSum(productMaterial);
      // setTotalMinusMaterialTax(totalCostSum)
      console.log('🧾 Total cost sum of all materials:', totalCostSum);

      console.log("###################1111selectedServicesTotalCost-1", selectedServicesTotalCost);
      console.log("###################1111initialServicesCost-1", initialServicesCost);

      const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000;
      const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;

      // selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
      // initialServicesCost = roundToThreeDecimals(initialServicesCost);
      selectedServicesTotalCost = roundToTwoDecimals(selectedServicesTotalCost);
      selectedTaxServicesTotalCost = roundToTwoDecimals(selectedTaxServicesTotalCost);
      initialServicesCost = roundToTwoDecimals(initialServicesCost);

      console.log("###################1111selectedServicesTotalCost-2", selectedServicesTotalCost);
      console.log("###################1111initialServicesCost-2", initialServicesCost);
      const selectedServicesSubTotal = roundToTwoDecimals(selectedServicesTotalCost - initialServicesCost)
      const selectedNewTaxServicesSubTotal = roundToTwoDecimals(selectedTaxServicesTotalCost - initialServicesCost)
      setTotalLabourCost(selectedServicesSubTotal)
      setTotalProductLabourCost(selectedServicesSubTotal)
      // setTotalProductInstallCost(totalInstallServiceCostSum)
      console.log("###################1111selectedServicesSubTotal", selectedServicesSubTotal);

      const newSum = (selectedProductsTotalDiscount + selectedServicesTotalCost) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      // setRFQSubTotal(newSum)
      console.log("###################1selectedProductsTotalDiscount", selectedProductsTotalDiscount);
      const selectedRfpProduct = cart?.reduce((total, data, index) => {
        let markup = markupType ? (markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup) : 0;

        let productTotal = parseFloat((data.product_price + data.product_price * markup / 100)?.toFixed(2)) * data.quantity * data.location_quantity;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);

      const selectedRfpProductJobCost = cart?.reduce((total, data, index) => {
        let productTotal = data.product_price * data.quantity * data.location_quantity;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);

      const selectedRfpServices = cartService?.reduce((total, data, index) => {
        //   let markup = data.originalMarkup;
        // data.sellingPrice = data.sellingPrice || data.unit_cost;
        let markup = Number(data.originalMarkup ?? data.product_markup ?? data.markup ?? 0);
        data.sellingPrice = Number(data.sellingPrice ?? data.unit_cost ?? 0);

        let productTotal = (data.sellingPrice + (data.sellingPrice * markup / 100)) * data.qty;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
      const selectedNonTaxRfpServices = cartService?.reduce((total, data, index) => {
        if (data?.taxable === 0) return total;
        //   let markup = data.originalMarkup;
        // data.sellingPrice = data.sellingPrice || data.unit_cost;
        let markup = Number(data.originalMarkup ?? data.product_markup ?? data.markup ?? 0);
        data.sellingPrice = Number(data.sellingPrice ?? data.unit_cost ?? 0);

        let productTotal = (data.sellingPrice + (data.sellingPrice * markup / 100)) * data.qty;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);

      const selectedRfpServicesJobCost = cartService?.reduce((total, data, index) => {
        //  let markup = data.originalMarkup;
        // data.sellingPrice = data.sellingPrice || data.unit_cost;
        data.sellingPrice = Number(data.sellingPrice ?? data.unit_cost ?? 0);

        let productTotal = data.sellingPrice * data.qty;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
      const selectedMaterialCostJobCost = selectedMaterials?.reduce((total, data, index) => {
        let productTotal = (data.product_price||data.price) * (data.quantity||0) ;
        if(data?.inhouse == 0){
          productTotal = 0
        }
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww1",data);
        console.log("#####################ProductTotalewwww1", productTotal);
        return total + productTotal;
      }, 0);
      const selectedMaterialCost = selectedMaterials?.reduce((total, data, index) => {
        data.price=data.price ? data.price : data.product_price
        // data.markup = data.markup ? data.markup : data.product_markup
        data.markup = data.product_markup ? data.product_markup : data.markup
        let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
        markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
        let adjustment = data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0);
        let productTotal = (markUpCost + adjustment || data.product_retail_price + adjustment) * (data.quantity||0) ;
        console.log("albiin###############productTotal", productTotal)
        console.log("albiin###############adjustment", adjustment)
        console.log("albiin###############markUpCost", markUpCost)
        if(data?.inhouse == 0 && values?.project_category?.id == 11){
          productTotal = 0
        }
        // productTotal = values?.project_category?.name == 'Time & Material' ? 0 : parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww2-data",data);
        console.log("#####################ProductTotalewwww2--markUpCost",markUpCost);
        console.log("#####################ProductTotalewwww2--productTotal", productTotal);
        return total + productTotal;
      }, 0);

      const selectedNonTaxMaterialCost = selectedMaterials?.reduce((total, data, index) => {
        if (data?.taxable === 0) return total;
        data.price=data.price ? data.price : data.product_price
        // data.markup = data.markup ? data.markup : data.product_markup
         data.markup = data.product_markup ? data.product_markup : data.markup
        let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
        markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
        let productTotal = (markUpCost || data.product_retail_price) * (data.quantity||0) ;
        if(data?.inhouse == 0){
          productTotal = 0
        }
        productTotal = values?.project_category?.name == 'Time & Material' ? 0 : parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww2-data",data);
        console.log("#####################ProductTotalewwww2--markUpCost",markUpCost);
        console.log("#####################ProductTotalewwww2--productTotal", productTotal);
        return total + productTotal;
      }, 0);

      console.log('selectedMaterialCostttttttt old',selectedMaterialCost)
      // console.log('totalInstallServiceCostSum old',totalInstallServiceCostSum)
      console.log('selectedMaterialCostttttttt new',selectedNonTaxMaterialCost)
      console.log("#####################Labour cost", selectedServicesSubTotal + selectedRfpServices);
      setTotalLabourCost(selectedServicesSubTotal + selectedRfpServices)
      console.log("#####################selectedRfpServices", selectedRfpServices);
      console.log("#####################selectedRfpProduct", selectedRfpProduct);
      sum = (selectedProductsTotalDiscount + selectedServicesSubTotal +selectedMaterialCost+ selectedRfpServices + selectedRfpProduct ) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      newTaxSum = (selectedProductsTotalDiscount + selectedNewTaxServicesSubTotal +selectedNonTaxMaterialCost+ selectedNonTaxRfpServices + selectedRfpProduct) - (values['invoice_discount'] ? values['invoice_discount'] : 0)- totalCostSum;
      taxAmountData = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (sum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
      const newTaxAmountData = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (newTaxSum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
      const taxAmountToFixed = parseFloat(parseFloat(taxAmountData).toFixed(2));
      console.log('taxAmounttttt old >',taxAmountData)
      console.log('taxAmounttttt new >',newTaxAmountData)
      let negativeCheck = (noCharge && sum > 0) ? -1 : 1
      // let negativeCheck = noCharge  ? -1 : 1
     console.log('negativeChecknegativeChecknegativeCheck',negativeCheck)
      const rushFeePct = Number(data?.rush_fee_percentage) || 0;
      const leadProductsForRush =
        selectedProducts?.length > 0
          ? selectedProducts
          : (values.products?.length > 0 ? values.products : (invoice?.cust_product || []));
      const rushAutoLocked = isInstallBeforeRequiredLead(values, leadProductsForRush);
      // Same rule as UI switch (canOverrideRushFeeLock is boolean — safe in deps)
      const rushOnForCalc =
        Number(values.rush_fee) === 1 ||
        (!!rushAutoLocked && !canOverrideRushFeeLock);
      const rushFeeAmt = rushOnForCalc
        ? parseFloat((parseFloat(sum || 0) * (rushFeePct / 100)).toFixed(2))
        : 0;
      values['rush_fee_amount'] = rushFeeAmt;
      // grandTotalData = ((parseFloat(sum) + parseFloat(taxAmountData)) * negativeCheck ).toFixed(2);
      if(!details?.avalara_code){
         grandTotalData = ((parseFloat(sum) + parseFloat(taxAmount) + rushFeeAmt) * negativeCheck ).toFixed(2); //new tax grand total
        //  grandTotalData = ((parseFloat(sum) + parseFloat(taxAmountToFixed)) * negativeCheck ).toFixed(2); //new tax grand total

       }else{
         grandTotalData = ((parseFloat(sum) + parseFloat(Number(taxAmount)) + rushFeeAmt) * negativeCheck ).toFixed(2); //new tax grand total with avalara
       }
      console.log("#####################selectedRfpServices", selectedRfpServices);
      console.log("#####################selectedProductsTotalDiscount", selectedProductsTotalDiscount);
      setTotalSum(sum);
      console.log('grandTotalData---------', grandTotalData)
      console.log('sum---------', sum)
      console.log('totalsum--------', totalsum)
      // setTaxAmount(taxAmountData);
      // console.log('newTaxAmountData',taxAmountToFixed)
      // if(!details?.avalara_code){
        // setTaxAmount(taxAmountToFixed);  no additional tax needed
      // }
      setGrandTotal(grandTotalData);

      let selectedProductsTotalProductFormula = selectedProducts?.reduce((total, data) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price;
        const dataWholesalePrice = data.product_price || data.price;
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1);

        let newTotalProductFormula = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity;
        newTotalProductFormula = newTotalProductFormula ? Number(newTotalProductFormula) : 0;


        return total + newTotalProductFormula;
      }, 0);

      selectedProductsTotalProductFormula = selectedProductsTotalProductFormula ? (Number(selectedProductsTotalProductFormula)) : 0

      setTotalProductFormula(selectedProductsTotalProductFormula)

      const groupIdsForWholesaleRollup = new Set()
      let selectedProductsTotalWholesalePrice = selectedProducts?.reduce((total, data, index) => {
        const gidRaw = getProductGroupId(data)
        if (gidRaw != null && String(gidRaw) !== '') {
          const gKey = String(gidRaw)
          if (groupIdsForWholesaleRollup.has(gKey)) return total
          groupIdsForWholesaleRollup.add(gKey)
          const group = groupedSelectedProductsMap.get(gKey)
          if (group && markupType === 1) {
            const sub = Number(group.adjustedGroupSubtotal || 0)
            return total + sub
          }
          if (group && markupType !== 1) return total
        }

        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)

        let newTotalWholesalePrice = dataWholesalePrice * data.quantity * data.locationQuantity
        if(data?.adjustment){
          newTotalWholesalePrice = newTotalWholesalePrice ? newTotalWholesalePrice + ((newTotalWholesalePrice * Number(data?.adjustment)) / 100) : 0
        }
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        // return total + newTotalWholesalePrice;
        const fixedProductTotal = parseFloat(newTotalWholesalePrice).toFixed(2);
        return total + parseFloat(fixedProductTotal);
      }, 0);
      selectedProductsTotalWholesalePrice = selectedProductsTotalWholesalePrice ? Number(selectedProductsTotalWholesalePrice) : 0

      let selectedServicesTotalWholesalePrice = selectedServices?.reduce((total, data, index) => {
        let newTotalWholesalePrice = (data?.unit_cost * data?.quantityDifference)?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedServicesTotalWholesalePrice = selectedServicesTotalWholesalePrice ? Number(selectedServicesTotalWholesalePrice) : 0

      let selectedAddlServicesTotalWholesalePrice = additionalSelectedServices?.reduce((total, data, index) => {
        let newTotalWholesalePrice = data?.total
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedAddlServicesTotalWholesalePrice = selectedAddlServicesTotalWholesalePrice ? Number(selectedAddlServicesTotalWholesalePrice) : 0

      let selectedCartTotalWholesalePrice = cart?.reduce((total, data, index) => {
        let markup = markupType ? (markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup) : 0;
        let newTotalWholesalePrice = (data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)) || 0)).toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedCartTotalWholesalePrice = selectedCartTotalWholesalePrice ? Number(selectedCartTotalWholesalePrice) : 0

      let selectedCartServicesTotalWholesalePrice = cartService?.reduce((total, data, index) => {
          // let newTotalWholesalePrice = (data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)
        const sellingPrice = Number(data.sellingPrice ?? data.unit_cost ?? 0)
        const markup = Number(data.originalMarkup ?? data.product_markup ?? data.markup ?? 0)
        let newTotalWholesalePrice = (data.qty * (sellingPrice + (sellingPrice * markup / 100)))?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedCartServicesTotalWholesalePrice = selectedCartServicesTotalWholesalePrice ? Number(selectedCartServicesTotalWholesalePrice) : 0
      
      let selectedMaterialsTotalWholesalePrice = selectedMaterials?.reduce((total, data, index) => {
        let newTotalWholesalePrice = ((data.markUpCost || 0) * (data.quantity||1))?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedMaterialsTotalWholesalePrice = selectedMaterialsTotalWholesalePrice ? Number(selectedMaterialsTotalWholesalePrice) : 0

      let newTotalWholesalePrice = selectedProductsTotalWholesalePrice + selectedServicesTotalWholesalePrice + selectedAddlServicesTotalWholesalePrice + selectedCartTotalWholesalePrice + selectedCartServicesTotalWholesalePrice + selectedMaterialsTotalWholesalePrice
      setTotalWholesalePrice(newTotalWholesalePrice)

      const groupIdsForRetailRollup = new Set()
      let selectedProductsTotalRetailPrice = selectedProducts?.reduce((total, data, index) => {
        const gidRaw = getProductGroupId(data)
        if (gidRaw != null && String(gidRaw) !== '') {
          const gKey = String(gidRaw)
          if (groupIdsForRetailRollup.has(gKey)) return total
          groupIdsForRetailRollup.add(gKey)
          const group = groupedSelectedProductsMap.get(gKey)
          if (group && markupType === 2) {
            const sub = Number(group.adjustedGroupSubtotal || 0)
            return total + sub
          }
          if (group && markupType !== 2) return total
        }

        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)

        let newTotalRetailPrice = dataRetailPrice * data.quantity * data.locationQuantity
        if(data?.adjustment){
          newTotalRetailPrice = newTotalRetailPrice ? newTotalRetailPrice + ((newTotalRetailPrice * Number(data?.adjustment)) / 100) : 0
        }
        newTotalRetailPrice = newTotalRetailPrice ? Number(newTotalRetailPrice) : 0
        // return total + newTotalRetailPrice;
        const fixedProductTotal = parseFloat(newTotalRetailPrice).toFixed(2);
        return total + parseFloat(fixedProductTotal);
      }, 0);
      selectedProductsTotalRetailPrice = selectedProductsTotalRetailPrice ? Number(selectedProductsTotalRetailPrice) : 0

      let newTotalRetailPrice = selectedProductsTotalRetailPrice + selectedServicesTotalWholesalePrice + selectedAddlServicesTotalWholesalePrice + selectedCartTotalWholesalePrice + selectedCartServicesTotalWholesalePrice + selectedMaterialsTotalWholesalePrice
      setTotalRetailPrice(newTotalRetailPrice)

      //discount count
      let selectedProductDiscount = selectedProducts?.reduce((acc, data, index) => {
        // const discountFieldName = `discount_${data.product_id?data.product_id:data.id}`;
        // const discountVal = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
        const discountVal = data.discount ? data.discount : 0
        let productDiscount = +discountVal || 0;
        return acc + productDiscount;
      }, 0);
      const newDiscountTotal = selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0);
      setDiscountTotal(selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0));

      console.log("#############selectedProductsTotalProductFormula", selectedProductsTotalProductFormula);
      console.log("#############selectedProductsTotalWholesalePrice", selectedProductsTotalWholesalePrice);
      console.log("#############selectedProductsTotalRetailPrice", selectedProductsTotalRetailPrice);
      console.log("#############newDiscountTotal", newDiscountTotal);
      console.log("#############selectedRfpProduct", selectedRfpProduct);
      console.log("#############selectedMaterialCost", selectedMaterialCost);
      console.log("#############selectedMaterialCostJobCost", selectedMaterialCostJobCost);
      console.log("#############selectedMaterialCostJobCost", selectedMaterialCostJobCost);
      console.log("#############selectedProductsTotalDiscountForJobCost", selectedProductsTotalDiscountForJobCost);
      console.log("#############selectedServicesCost", selectedServicesCost);
      console.log("#############selectedRfpProductJobCost", selectedRfpProductJobCost);
      console.log("#############selectedRfpServicesJobCost", selectedRfpServicesJobCost);


      totalJobcostSum = (selectedProductsTotalDiscountForJobCost + selectedServicesCost + selectedRfpProductJobCost + selectedRfpServicesJobCost+selectedMaterialCostJobCost);
      console.log('total job cost------- budget', totalJobcostSum);
      values['total'] = sum
      values['taxAmount'] = taxAmountData
      values['budget'] = totalJobcostSum
      setBudget(totalJobcostSum)
      let subTotal = markupType == 1 ? ((selectedProductsTotalWholesalePrice + selectedRfpProduct + selectedMaterialCost))
        : (markupType == 2 ? ((selectedProductsTotalRetailPrice + selectedRfpProduct + selectedMaterialCost)) : 0);
      console.log("################subTotal", subTotal);
      setRFQSubTotal(subTotal)
      // Determine when to show the Manager Approval toggle in edit view
      // setIsManagerApprovalLocked(isLocked);
      // const shouldShowManagerToggle = isNoChargeJob || (isNoChargeJob && isAboveLimit) || (hasNegativeMarketingAdjustment && !isAboveLimit && !isNoChargeJob) || (hasNegativeMarketingAdjustment && isAboveLimit);
      // setShowManagerApprovalToggle(shouldShowManagerToggle);


      // let selectedProductsTotalMarkupAmount = markupType == 1 ? ((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula)
      //   : (markupType == 2 ? ((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) : 0);
      // setTotalMarkupAmount(selectedProductsTotalMarkupAmount)
      let selectedProductsTotalMarkupAmount = sum - totalJobcostSum
      setTotalMarkupAmount(selectedProductsTotalMarkupAmount)

      // let selectedProductsTotalMarkup = (selectedProductsTotalMarkupAmount / totalJobcostSum) * 100
      let selectedProductsTotalMarkup = totalJobcostSum !== 0 
        ? (selectedProductsTotalMarkupAmount / totalJobcostSum) * 100 
        : 0;
      setTotalMarkupPercentage(selectedProductsTotalMarkup)

      console.log('selectedProductsTotalMarkupAmount-------', selectedProductsTotalMarkupAmount);
      console.log('totalJobcostSum-------', totalJobcostSum);
      console.log('selectedProductsTotalMarkup-------', selectedProductsTotalMarkup);
      console.log('initialServiceCost In ProductFormula-----', initialServicesCost);
      setInitialServiceCostInProductFormula(initialServicesCost)

    } catch (error) {
      console.log('Error--------------', error);
    }
  }, [currentRFQData, selectedTaxCategory, selectedProducts,selectedMaterials, selectedServices, additionalSelectedServices, values.markup_type, values.invoice_discount,values?.rush_fee,canOverrideRushFeeLock,refreshData, cartService, cart,loading,refreshCalculation, values.project_category, markupType, groupedSelectedProductsMap, groupProductMarketingValues, groupInstallMarketingValues, taxAmount, data?.rush_fee_percentage])

  const productsForLeadRaw =
    selectedProducts?.length > 0
      ? selectedProducts
      : (values.products?.length > 0 ? values.products : (invoice?.cust_product || []));
  const productsForLead = resolveProductsLeadTime(productsForLeadRaw, allProducts);
  const isRushFeeAutoLocked = isInstallBeforeRequiredLead(values, productsForLead);

  useEffect(() => {
    runRushFeeLeadSync({
      values,
      products: productsForLeadRaw,
      catalog: allProducts,
      canOverride: canOverrideRushFeeLock,
      setFieldValue,
      refs: rushFeeSyncRefs.current,
      enabled: openEdit,
      persistedOffWhileLocked:
        openEdit &&
        Number(details?.rush_fee ?? values?.rush_fee) === 0 &&
        isRushFeeAutoLocked,
    });
  }, [
    values?.end,
    values?.start,
    values?.installation_start_date,
    values?.installation_end_date,
    productsForLeadRaw,
    allProducts,
    isRushFeeAutoLocked,
    canOverrideRushFeeLock,
    setFieldValue,
    openEdit,
    details?.rush_fee,
  ]);

  // Toggle while editing
  const isRushFeeChecked =
    Number(values?.rush_fee) === 1 ||
    (!!isRushFeeAutoLocked && !canOverrideRushFeeLock);
  // Details / invoice / PDF: use saved DB flag when not editing (do not hide when formik not synced)
  const isRushFeeDisplayOn = openEdit
    ? !!isRushFeeChecked
    : (
      Number(details?.rush_fee) === 1 ||
      Number(details?.rush) === 1 ||
      Number(values?.rush_fee) === 1 ||
      (!!isRushFeeAutoLocked && !canOverrideRushFeeLock)
    );
  const rushFeeAccessDenied =
    !canControlRushFee && !isRushFeeAutoLocked && !isRushFeeChecked;
  // Only dim when user has no control permission; locked Manual users keep normal look (OFF blocked in onChange)
  const rushFeeSwitchDisabled = rushFeeAccessDenied;

  const rushFeePercentage = Number(data?.rush_fee_percentage) || 0;
  const rushFeeBaseSubtotal = Number(totalsum) > 0
    ? Number(totalsum)
    : Number(invoiceModalCustProductSubtotalForServices || invoice?.sub_total || 0);
  const isEditRushFeeOn = !!isRushFeeDisplayOn;
  const rushFeeAmount = calcRushFeeAmount({
    enabled: isEditRushFeeOn,
    subtotal: rushFeeBaseSubtotal,
    percentage: rushFeePercentage,
    storedAmount: values.rush_fee_amount || details?.rush_fee_amount,
    // Live % only while editing; otherwise keep saved order amount
    preferStored: !openEdit,
  });

  console.log('additionalSelectedServices--', additionalSelectedServices);
  console.log("####################selectedMaterials", selectedMaterials);
  ////image functionality
  const persistDeleteDesignAttachment = async (file) => {
    const attachmentId = getAttachmentRecordId(file);
    if (!attachmentId || !id) return true;
    const res = await axios.post(`${REST_API_END_POINT}request/update-designs`, {
      id: attachmentId,
      status: 0,
      requestId: id,
      userId: user.user_id,
    });
    return res.data?.status === 1;
  };

  const removeDesignFromState = (file) => {
    const removeKey = attachmentFileKey(file);
    const matches = (f) =>
      removeKey ? attachmentFileKey(f) !== removeKey : !attachmentMatches(f, file);
    setAvatarUrl((prev) => prev.filter(matches));
    setProductAttachments((prev) => pruneAttachmentMapsByFile(prev, file));
    setServiceAttachments((prev) => pruneAttachmentMapsByFile(prev, file));
    setSelectedUploadedImages((prev) => pruneAttachmentMapsByFile(prev, file));
    setSelectedUploadedImagesService((prev) => pruneAttachmentMapsByFile(prev, file));
  };

  const handleRemoveAll = async () => {
    const removed = [...avatarUrl];
    if (!removed.length) return;
    try {
      for (const file of removed) {
        if (getAttachmentRecordId(file)) {
          const ok = await persistDeleteDesignAttachment(file);
          if (!ok) {
            enqueueSnackbar('Failed to remove files', { variant: 'error' });
            return;
          }
        }
      }
      setAvatarUrl([]);
      if (removed.length) {
        setProductAttachments((prev) =>
          removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
        );
        setServiceAttachments((prev) =>
          removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
        );
        setSelectedUploadedImages((prev) =>
          removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
        );
        setSelectedUploadedImagesService((prev) =>
          removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
        );
      }
    } catch (error) {
      enqueueSnackbar('Failed to remove files', { variant: 'error' });
    }
  };

  // const handleRemove = (file) => {
  //   console.log('filefilefilefile',file)
  //   const filteredItems = avatarUrl.filter((_file) => _file !== file);
  //   setAvatarUrl([filteredItems]);
  // };

  ///////
  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     if (acceptedFiles && acceptedFiles.length > 0) {
  //       const file = acceptedFiles[0];
  //       const Filename = new Date().getTime() + file.name;

  //       const StorageRef = imageref(storage, Filename);
  //       const uploadTask = uploadBytesResumable(StorageRef, file);

  //       uploadTask.on(
  //         'state_changed',
  //         (snapshot) => {
  //           const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //         },
  //         (error) => {
  //           console.error(error.message);
  //         },
  //         () => {
  //           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //             setFieldValue('avatarUrl', downloadURL)

  //           });
  //         }
  //       );
  //     }
  //   },
  //   [setFieldValue]
  // );

  const handleRemove = async (file) => {
    if (file?._productAttachment) {
      const productIndexId = file?.product_index_id;
      if (productIndexId != null && String(productIndexId) !== '') {
        handleProductRemove(file, productIndexId);
        return;
      }
    }
    if (file?._serviceAttachment) {
      const serviceIndexId = file?.service_index_id;
      if (serviceIndexId != null && String(serviceIndexId) !== '') {
        handleServiceRemove(file, serviceIndexId);
        return;
      }
    }

    try {
      if (getAttachmentRecordId(file)) {
        const ok = await persistDeleteDesignAttachment(file);
        if (!ok) {
          enqueueSnackbar('Failed to remove file', { variant: 'error' });
          return;
        }
      }
      removeDesignFromState(file);
    } catch (error) {
      enqueueSnackbar('Failed to remove file', { variant: 'error' });
    }
  };
  

    // const handleDrop = useCallback(
    //   (acceptedFiles) => {
    //     let permission =!explodedPermissions?.some((permission) => ['Upload Files Sales Order'].includes(permission))
    //     if(permission &&  user?.added_by_client ==1){
    //       return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
    //     }
    //     if (acceptedFiles && acceptedFiles.length > 0) {
    //       setIsUploading(true);
    //       const uploadPromises = acceptedFiles?.map((file) => {
    //         return new Promise((resolve, reject) => {
    //           const Filename = new Date().getTime() + file.name;
    //           const StorageRef = imageref(storage, Filename);
    //           const uploadTask = uploadBytesResumable(StorageRef, file);
  
    //           uploadTask.on(
    //             'state_changed',
    //             (snapshot) => {
    //               const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
    //               setProgress(progress);
    //             },
    //             (error) => {
    //               console.error(error.message);
    //               setIsUploading(false);
    //               reject(error);
    //             },
    //             () => {
    //               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    //                 resolve({
    //                   url: downloadURL,
    //                   file_type: file.type,
    //                   extension: file.name.split('.').pop(),
    //                   size: file.size
    //                 });
    //               });
    //             }
    //           );
    //         });
    //       });
  
    //       Promise.all(uploadPromises)
    //         .then((downloadURLs) => {
    //           setAvatarUrl((prevAvatarUrls) => {
    //             const updatedFiles = downloadURLs.map((file) => ({
    //               url: file.url,
    //               file_type: file.file_type,
    //               extension: file.extension,
    //               size: file.size
    //             }));
    //             return [...prevAvatarUrls, ...updatedFiles]
    //           });
    //           setIsUploading(false);
    //         })
    //         .catch((error) => {
    //           console.error(error.message);
    //           setIsUploading(false);
    //         });
    //     }
    //   },
    //   [setFieldValue]
    // );

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      const noPermission = !explodedPermissions?.some((permission) =>
        ['Upload Files Sales Order'].includes(permission)
      );

      if (noPermission && user?.added_by_client === 1) {
        return enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error'
        });
      }

      if (!acceptedFiles?.length || !id) return;

      setIsUploading(true);
      try {
        const uploadedFiles = await Promise.all(
          acceptedFiles.map(async (file, index) => {
            const fileName = `${Date.now()}_${index}_${file.name.replace(/\s+/g, '_')}`;
            const filePath = `sales-orders/${fileName}`;

            const { error: uploadError } = await supabase.storage
              .from('signwise-attachments')
              .upload(filePath, file);

            if (uploadError) throw uploadError;

            const { data: publicUrlData, error: urlError } = supabase.storage
              .from('signwise-attachments')
              .getPublicUrl(filePath);

            if (urlError || !publicUrlData?.publicUrl) {
              throw new Error('Failed to get public URL');
            }

            return {
              url: publicUrlData.publicUrl,
              file_type: file.type,
              extension: file.name.split('.').pop(),
              size: file.size
            };
          })
        );

        const savedAttachments = [];
        for (const fileData of uploadedFiles) {
          const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
            requestId: id,
            userId: user.user_id,
            uploaded: [fileData.url],
            type: fileData.file_type,
            size: fileData.size,
            extension: fileData.extension,
            attachmentType: 'design',
          });
          if (res.data?.status !== 1) {
            throw new Error(res.data?.message || 'Failed to save design');
          }
          const saved = res.data?.data?.[0];
          savedAttachments.push({
            id: saved?.id,
            url: saved?.name || fileData.url,
            name: saved?.name || fileData.url,
            file_type: saved?.file_type || fileData.file_type,
            extension: saved?.extension || fileData.extension,
            size: saved?.file_size || saved?.size || fileData.size,
          });
        }

        setAvatarUrl((prev) => {
          const next = [...prev];
          savedAttachments.forEach((file) => {
            if (!next.some((f) => attachmentMatches(f, file))) next.push(file);
          });
          return next;
        });
        enqueueSnackbar('New design/document added!', { variant: 'success' });
      } catch (error) {
        console.error('Upload failed:', error.message);
        enqueueSnackbar(error.response?.data?.message || error.message || 'Upload failed', {
          variant: 'error'
        });
      } finally {
        setIsUploading(false);
      }
    },
    [explodedPermissions, user, id, enqueueSnackbar]
  ); // supabase integration

  const handleRejectFileDrop = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;

      const file = acceptedFiles[0];   // 🔥 SINGLE FILE ONLY
      setIsUploadingRejectFile(true);

      try {
        const timestamp = Date.now();
        // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
        const fileName = `${timestamp}_${sanitizedName}`;
        const filePath = `sales-order/rejected/${fileName}`;

        // 1️⃣ Upload
        const { error: uploadError } = await supabase.storage
          .from('signwise-attachments')
          .upload(filePath, file);

        if (uploadError) throw uploadError;

        setProgress(100);

        // 2️⃣ Public URL
        const { data: publicUrlData, error: urlError } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath);

        if (urlError || !publicUrlData?.publicUrl) {
          throw new Error('Failed to generate public URL');
        }

        // 3️⃣ Save ONLY ONE FILE
        setRejectFile({
          url: publicUrlData.publicUrl,
          file_type: file.type,
          extension: file.name.split('.').pop(),
          size: file.size
        });

      } catch (err) {
        console.error('Upload error:', err.message);
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
      } finally {
        setIsUploadingRejectFile(false);
        setProgress(null);
      }
    },
    [setRejectFile, setIsUploadingRejectFile, setProgress]
  );

  const hasNonTmGroupedMember = isGroupedCombinedView
    && (details?.grouped_invoice_members || []).some(
      (m) => Number(m?.requestDetails?.project_category) !== 12,
    );
  const isDedicatedGroupedParentView = Number(details?.is_grouped_request || 0) === 1;
  const treatInvoiceAsTimeMaterial = Number(invoice?.project_category) === 12 && !hasNonTmGroupedMember;
  const useTmProductLayout = details?.job_category_name == 'Time & Material' && !hasNonTmGroupedMember;

  let subTotal = treatInvoiceAsTimeMaterial ? invoice?.jobcostTotal + 0 : 0 // invoice?.jobcostTotal + 0

  const groupedCombinedDisplayTotal = useMemo(() => {
      // if (!hasNonTmGroupedMember) {
    if (!hasNonTmGroupedMember && !isDedicatedGroupedParentView) {
      return Number(invoice?.total || 0);
    }
    const productAndInstall = treatInvoiceAsTimeMaterial
      ? Number(subTotal || 0)
      : Number(invoiceModalCustProductSubtotalForServices || 0);
    const servicesTotal =
      (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
      (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
      (cartService?.reduce((s, x) => {
        //  const sp = x.sellingPrice || x.unit_cost || 0;
        // const markup = x.originalMarkup || x.product_markup || 0;
        const sp = Number(x.sellingPrice ?? x.unit_cost ?? 0);
        const markup = Number(x.originalMarkup ?? x.product_markup ?? x.markup ?? 0);
        const final = sp + (sp * markup / 100);
        return s + ((x.qty || 0) * final);
      }, 0) || 0);
    return (
      productAndInstall +
      servicesTotal -
      Number(invoice?.extra_discount || 0) +
      Number(invoice?.tax_amount || 0)
    );
  }, [
    hasNonTmGroupedMember,
    isDedicatedGroupedParentView,
    treatInvoiceAsTimeMaterial,
    subTotal,
    invoiceModalCustProductSubtotalForServices,
    invoiceSelectedServices,
    additionalSelectedServices,
    cartService,
    invoice?.extra_discount,
    invoice?.tax_amount,
    invoice?.total,
  ]);

  // Invoice modal / PDF summary: same subtotal as the Subtotal row
  const invoiceModalDisplayedSubtotal =
    (treatInvoiceAsTimeMaterial ? (subTotal || 0) : (invoiceModalCustProductSubtotalForServices || 0)) +
    (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
    (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
    (cartService?.reduce((s, x) => {
      const sp = x.sellingPrice || x.unit_cost || 0;
      const markup = x.originalMarkup || x.product_markup || 0;
      const final = sp + (sp * markup) / 100;
      return s + ((x.qty || 0) * final);
    }, 0) || 0);
  const isInvoiceRushFeeOn = !!isRushFeeDisplayOn;
  const invoiceModalRushFeePct = Number(data?.rush_fee_percentage) || 0;
  const invoiceModalRushFee = calcRushFeeAmount({
    enabled: isInvoiceRushFeeOn,
    subtotal: invoiceModalDisplayedSubtotal,
    percentage: invoiceModalRushFeePct,
    storedAmount: values?.rush_fee_amount || details?.rush_fee_amount,
    preferStored: true,
  });
  // When rush is on but % hasn't loaded yet, still show the row and keep Total = Subtotal + fees
  const invoiceModalDisplayTotalRaw = calcTotalWithRushFee({
    subtotal: invoiceModalDisplayedSubtotal,
    discount: invoice?.extra_discount,
    tax: invoice?.tax_amount,
    rushFee: invoiceModalRushFee,
  });
  // Match negativeCheck: No Charge totals display as negative
  const invoiceModalDisplayTotal =
    ((noCharge || Number(details?.project_category) === 13 || Number(invoice?.project_category) === 13) &&
      invoiceModalDisplayTotalRaw > 0)
      ? -invoiceModalDisplayTotalRaw
      : invoiceModalDisplayTotalRaw
// const invoiceDisplayTotal = hasNonTmGroupedMember
  const invoiceDisplayTotal = (hasNonTmGroupedMember || isDedicatedGroupedParentView)
    ? groupedCombinedDisplayTotal
    : (invoice?.total || 0);

  const ACCOUNT_TABS = [
    {
      value: `${user.isVendor ? '' : 'Sales Order '}Details`,
      component: details ? (
        <ViewRequest
          isMirrored={isMirrored}
          teamMembers={teamMembers}
          clientDetails={invoice}
          products={invoice?.cust_product}
          productsWithLocation={invoice?.cust_product_location}
          fetchRequestDetails={fetchRequestDetails}
          fetchRequestDetailsNew={fetchRequestDetailsNew}
          user={user}
          designs={designs}
          setDesigns={setDesigns}
          details={details}
          isRequest={true}
          fromSalesOrder={true}
          requestId={id}
          signAgreements={signAgreements}
          customTemplate={customTemplate}
          questionnaireTemplate={questionnaireTemplate}
          allDataEmpty={allDataEmpty}
          portfolio={portfolio}
          invoice={invoice}
          isSalesOrderss={true}
          setInvoice={setInvoice}
          setRenderCards={setRenderCards}
          renderCards={renderCards}
          rfpServicesEdit={rfpServicesEdit}
          requestServices={requestServices}
          labourInstallService={labourInstallService}
          explodedPermissions={explodedPermissions}
          designersList={designersList}
          unlinkedLocations={unlinkedLocations}
          splitIntiator={splitIntiator}
          allTeamMembers={allTeamMembers}
          onlineUsers={onlineUsers}
          hasViewCostPermission={hasViewCostPermission}
          taxRateData={taxRateData}
          totalTaxRate={totalTaxRate}
          taxAmount={taxAmount}
          
          depositAndProgressBilling={depositAndProgressBilling}
          rushFeePercentage={Number(data?.rush_fee_percentage) || 0}
          rushFeeEnabled={isInvoiceRushFeeOn}
        />
      ) : "",
    },
    ...((user.user_type === 3 || user.user_type === 1 || explodedPermissions?.some((permission) => ['View Sales Order Client Message Board','Access Sales Order Client Message Board'].includes(permission))) ? [
    {
      value: 'client message board',
      component: (
        <PublicMessageBoard
          products={invoice?.cust_product}
          requestDetails={details}
          requestId={id}
          acceptedClients={acceptedClients}
          setRenderCards={setRenderCards}
          renderCards={renderCards}
          fetchRequestDetails={fetchRequestDetails}
          details={details}
          accessPublicMessageBoard={accessPublicMessageBoard}
        />
      ),
    }
  ] : []),
     ...(!isGroupedCombinedView && (isMember && user.user_type !== 3
  ) ? [
    {
      value: 'Job Notes',
      component: (
        <Card sx={{ height: '72vh', display: 'flex' }}>
          <JobNoteWindow
          products={invoice?.cust_product}
            allUser={jobNoteMembers}
            requestIdd={id}
            designOrderId={details?.design_order_id || null}
          requestDetails={details}
            fromDesign={false}
            isDesignOrder={false}
            renderCards={renderCards}
          setRenderCards={setRenderCards}
            fetchRequestDetails={fetchRequestDetails}
            details={details}
            noteType="job"
            accessPublicMessageBoard={accessPublicMessageBoard}
          />
        </Card>
      ),
    },
    {
      value: 'Design Notes',
      component: (
        <Card sx={{ height: '72vh', display: 'flex' }}>
          <JobNoteWindow
            products={invoice?.cust_product}
            allUser={jobNoteMembers}
            requestIdd={id}
            designOrderId={details?.design_order_id || null}
            requestDetails={details}
            fromDesign={true}
            isDesignOrder={false}
          renderCards={renderCards}
            setRenderCards={setRenderCards}
          fetchRequestDetails={fetchRequestDetails}
          details={details}
            noteType="design"
          accessPublicMessageBoard={accessPublicMessageBoard}
        />
        </Card>
      ),
    }
  ] : []),
    ...(user.isVendor ? [] : [
      {
        // value: 'change order',
        value: 'Job Log',
        component: <RequestTabUpdates updates={updates?.length > 0 ? updates : []} details={details} searchable onSearchUpdates={handleJobLogSearch} />,
      },
      ...(!isGroupedCombinedView ? [
        {
          value: 'payments',
          component: <PaymentRequest popupOn={popupOn} idOfProject={idOfProject} totalValue={!empty(details?.allInstallationCompleted) ? invoice?.grandTotal : invoice?.total } setLoading={setLoading} setRefresh={setRefresh} refresh={refresh}  details={details}/>,
        },
        {
          value: 'Locations and Notes',
          component: <Locations products={invoice?.cust_product} details={details} additionalSelectedServices={requestServices} designs={designs} rfpServices={rfpServicesEdit} />,
        },
        ...(details?.noServiceNoTask !== 1 ? [
          {
            value: 'Installation Reports',
            component: <SalesOrderInstallationReportView products={invoice?.cust_product} details={details} additionalSelectedServices={requestServices} designs={designs} rfpServices={rfpServicesEdit} />,
          },
        ] : []),
      ] : []),
    ]),
    ...(!isGroupedCombinedView && details?.noServiceNoTask !== 1 ? [
      !details?.map_service ? 
      {
        value: 'Route - Map Services',
        component: <RouteMapInstall salesOrderDetails={details} refresh={refresh} setRefresh={setRefresh}/>,
      } : {
        value: 'Route - Map Services',
        component: <RouteMap details={details} id={id} route_id={details?.map_service} />,
      }
      ] : []),
    // ...(userType === 3 ? (user.isVendor ? [
    //   {
    //     value: 'My Proposal',
    //     component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} />,
    //   },
    // ] : []) : [
    //   {
    //     value: 'Proposals',
    //     component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} />,
    //   },
    // ]),
  ];

  const handleDeleteService = (servId, indexId, newIndexId, deletedIndex) => {
    setCheckLength(!checkLength)
    console.log('indexId--------',newIndexId,indexId,servId)
    // const newFilteredServices = additionalSelectedServices?.filter(data => !(data.id == servId && data.indexId == indexId));
    const newFilteredServices = additionalSelectedServices?.filter((data, index) => {
        console.log('indexId--------data-servId', servId, data.id)
        console.log('indexId--------data-indexId', indexId, data.indexId)
        console.log('indexId--------data-isAdditionalProduct', data.isAdditionalProduct)
        console.log('indexId--------data-newIndexId', newIndexId, data.newIndexId)
        console.log('handleDeleteService---deletedIndex', deletedIndex)
        console.log('handleDeleteService---index', index)
        if (data?.isAdditionalProduct) {
          // return data?.newIndexId !== newIndexId;
          return index != deletedIndex;
        }
        // return !(data.id == servId && data.indexId == indexId)
        return index != deletedIndex;
    });
    const newLocationStates = { ...serviceOnlyLocationStates };
    delete newLocationStates[indexId];
    setServiceOnlyLocationStates(newLocationStates);

    const newServiceAttachmentStates = { ...openServiceAttachment };
    delete newServiceAttachmentStates[indexId];
    setOpenServiceAttachment(newServiceAttachmentStates);

    const newServiceAttachments = { ...serviceAttachments };
    delete newServiceAttachments[indexId];
    setServiceAttachments(newServiceAttachments);

    // const allFilteredServices = filteredServices?.find(data => data.id !== servId);
    setFieldValue('services', newFilteredServices);
    setAdditionalSelectedServices(newFilteredServices);
  };
  // useEffect(() => {
  //   if (selectedProducts.length <= 0) {
  //     setAllLocationSame(false)
  //   }
  // }, [selectedProducts])

  useEffect(() => {
    if (selectedProducts.length <= 0) {
      setAllLocationSame(false)
    }
    if (additionalSelectedServices.length <= 0) {
      setAllServiceLocationSame(false)
    }
    if (cart.length <= 0) {
      setAllRfpProductsLocationSame(false)
    }
    if (cartService.length <= 0) {
      setAllRfpServiceLocationSame(false)
    }

  }, [checkLength])

  const handleCancel = async (isEdit) => {
//     alert('Are you sure you want to cancel? All unsaved changes will be lost.',isEdit)
// setOpenEmailModal(false)
// setOpenInvoice(false)
    setOpenEdit(false)
    setIsOpen(false)
    setCurrentRFQdata({})
    // resetForm();
    setSelectedProducts([])
    setSelectedMapserviceProducts([]);
    setSelectedServices([]);
    setAdditionalSelectedServices([])
    setFilteredServices([])
    fetchRequestDetailsNew()
    fetchRequestDetails()
    fetchProductAndMaterials()
    setAllLocationSame(false)
    // closeView()
    // onDataChange()
    // setRenderCards(!renderCards);
    if(popupOn && !isEdit){
      closeView()
      // setRenderCards(!renderCards)
      onDataChange()
      }
      if(editState){
        editState=false
        setOpenEdit(false)
        setIsOpen(false)
      }

      if (!popupOn && isEdit && (Number(details?.isFromEstimate) === 1 || Number(details?.isFromDesignOrder) === 1)) {
        if (fromSplitSalesOrder) {
          navigate(`/dashboard/split-order/split-sales-order`)
        } else {
          navigate(`/dashboard/official-request`)
        }
      } else if (!popupOn && !isEdit) {
        if (isFromCommunityInstalls) {
          let backState = location.state?.communityInstallsListState
          if (!backState && communityInstallsBackStorageKey) {
            try {
              const raw = sessionStorage.getItem(communityInstallsBackStorageKey)
              if (raw) backState = JSON.parse(raw)
            } catch (e) {
              backState = null
            }
          }
          if (communityInstallsStorageKey) {
            sessionStorage.removeItem(communityInstallsStorageKey)
          }
          if (communityInstallsBackStorageKey) {
            sessionStorage.removeItem(communityInstallsBackStorageKey)
          }
          const backCompleteStatus = Number(backState?.completeStatus) || 1
          const backPath =
            backCompleteStatus === 2
              ? PATH_DASHBOARD.community.rfqPickup
              : backCompleteStatus === 3
                ? PATH_DASHBOARD.community.rfqShipping
                : PATH_DASHBOARD.community.rfqInstalls
          navigate(backPath, {
            replace: true,
            ...(backState ? { state: backState } : {}),
          })
        } else if (isFromCommunitySalesOrder) {
          let backState = location.state?.communityRfqListState
          if (!backState && communityRfqBackStorageKey) {
            try {
              const raw = sessionStorage.getItem(communityRfqBackStorageKey)
              if (raw) backState = JSON.parse(raw)
            } catch (e) {
              backState = null
            }
          }
          if (communitySalesOrderStorageKey) {
            sessionStorage.removeItem(communitySalesOrderStorageKey)
          }
          if (communityRfqBackStorageKey) {
            sessionStorage.removeItem(communityRfqBackStorageKey)
          }
          navigate(PATH_DASHBOARD.community.rfqCommunity, {
            replace: true,
            ...(backState ? { state: backState } : {}),
          })
        } else if(isFromProjects){
          const projectIdFromState = location.state?.projectId;
          if (projectIdFromState) {
            navigate(`${PATH_DASHBOARD.project.viewproject}${projectIdFromState}`, {
              state: { currentTab: location.state?.currentTab },
            });
          } else {
            navigate(PATH_DASHBOARD.project.all);
          }
        }else{
          if(fromSplitSalesOrder){
            navigate(`/dashboard/split-order/split-sales-order`)
          }else{
            navigate(`/dashboard/official-request`)
          }
          // navigate(`/dashboard/official-request`)
        }
      }
    
    // if (edit) {
      localStorage.removeItem('salesOrderProjectId');
      localStorage.removeItem('salesOrderProjectName');
      localStorage.removeItem('isEditSalesOrder');
      localStorage.removeItem('salesOrderOpenPopup',);
      // closeView()
      // navigate(`/dashboard/official-request`)
     
      //  setOpenInvoice(true)
    // }
  }

  const handleCancelRef = useRef(handleCancel);
  handleCancelRef.current = handleCancel;

  useEffect(() => {
    if (!popupOn || !headerStepBackRef) {
      return undefined;
    }
    const openedAsEditIntent = isEditSalesOrder === true || isEditSalesOrder === 'true';
    headerStepBackRef.current = () => {
      if (openJobCostPopup) {
        setOpenJobCostPopup(false);
        setJobCostProjectId(null);
        return true;
      }
      if (openEdit) {
        void handleCancelRef.current(true);
        return true;
      }
      if (openedAsEditIntent) {
        onExitSalesOrderEditMode?.();
        return true;
      }
      return false;
    };
    return () => {
      headerStepBackRef.current = () => false;
      setSettingsAnchorEl(null)
    };
  }, [popupOn, openEdit, openJobCostPopup, isEditSalesOrder, onExitSalesOrderEditMode, headerStepBackRef]);

  const selectedProductsAdditionalCost = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)
    ?.reduce((total, item) => total + (item.product_total || 0), 0)
    ?.toFixed(2)

  const selectedMaterialSubTotal = selectedMaterials //?.filter(item=>item?.isAdditionalProduct == true)
  ?.reduce((total, item) => total + (((item.markUpCost + (item.adj_value_type ? Number(item.adjustment || 0) : -Number(item.adjustment || 0))) || 0) * (item.quantity || 0)), 0)
    ?.toFixed(2)

  console.log("cartService--cartService--", cartService);
  console.log("cartService--rfpServiceLocationStates--", rfpServiceLocationStates);
  console.log("cartService--cart--", cart);
  console.log("cartService--rfpLocationStates--", rfpLocationStates);

  let totalMarkup = 0;
  let totalServiceMarkup = 0;
  let originaltotalMarkup = 0
  let originaltotalServiceMarkup = 0
  let totalAmount = 0;
  let customerProductTotal = 0;
useEffect(() => {
  if (values.additionalMaterials?.length > 0) {
    setSelectedMaterials(values.additionalMaterials);
    setPendingAutocompleteMaterials(values.additionalMaterials);
  }
}, []);

// Split order: if user removes a facility after selecting products, drop products that belong to removed facilities.
// (Does not affect normal/non-split orders)
useEffect(() => {
  if (!isSplitOrder) return;

  const selectedFacilities = values?.facility_type || [];
  const currentFacilityIds = (selectedFacilities || []).map((f) => Number(f?.id)).filter((n) => !Number.isNaN(n));

  // Run cleanup ONLY when a facility is removed (avoid interfering with selection / initial load)
  if (!prevSplitFacilityIdsRef.current) {
    prevSplitFacilityIdsRef.current = currentFacilityIds;
    return;
  }
  const prevIds = prevSplitFacilityIdsRef.current || [];
  const removed = prevIds.some((id) => !currentFacilityIds.includes(id));
  prevSplitFacilityIdsRef.current = currentFacilityIds;
  if (!removed && currentFacilityIds.length >= prevIds.length) return;

  const regularSelectedProducts = selectedProducts?.filter(
    (item) => item?.fromMapServices != true && !item?.isAdditionalProduct
  ) || [];

  // If split order is on but no facility is selected, clear the regular selected products
  if (!selectedFacilities?.length) {
    if (!regularSelectedProducts.length) return;
    const updated = [];
    // In View page, cleanup should not trigger extra validation
    handleProduct(updated);
    setFieldValue('products', updated, false);
    return;
  }

  const selectedIds = new Set(selectedFacilities.map((f) => Number(f?.id)));
  const filteredRegular = regularSelectedProducts.filter((p) =>
    selectedIds.has(Number(p?.facility_id)) ||
    // Allow "default facility" products that may have null/undefined facility_id
    ((p?.facility_id === undefined || p?.facility_id === null) && selectedFacilities.some((fac) => fac?.default))
  );

  // Only run when we actually removed something
  if (filteredRegular.length === regularSelectedProducts.length) return;

  const updated = filteredRegular.map((item) => ({
    ...item,
    is_single_card: true
  }));

  handleProduct(updated);
  setFieldValue('products', updated, false);
}, [isSplitOrder, values?.facility_type]);

  // const filteredProductOptions = useMemo(() => {
  //   return (allProducts || []).filter((option) => {
  //   // OLD CODE - Prevents multiple selections of same product
  //   // const notAlreadySelected = !selectedProducts?.some((selected) => selected.id === option.id);
  //   // if (!notAlreadySelected) return false;
    
  //   // NEW CODE - Allow multiple selections of the same product for different designs
  //   // Commented out the filter to enable multiple selections

  //     const categoryId = values?.project_category?.id;
  //     const catalogType = values?.catalog_type;

  //     if (categoryId === 15) {
  //       if (catalogType?.inhouse == 4) {
  //         return option.inhouse === 4;
  //       } else if (catalogType?.inhouse == 5) {
  //         return option.inhouse === 5;
  //       } else if (catalogType?.isTrafficCatalog) {
  //         return option.isTrafficCatalog === 1
  //       }
  //     }else if(categoryId === 11) {
  //        return (option.inhouse === 5 || option.isTrafficCatalog)
  //     }

  //     return option;
  //     // return option.inhouse !== 0;
  //   });
  // }, [allProducts, selectedProducts, values?.project_category?.id,,values?.catalog_type?.inhouse]);


  const filteredProductOptions = useMemo(() => {
    const filtered = (allProducts || []).filter((option) => {
      // Active catalogs only (pending estimate catalogs may be status 0)
      const isPendingEstimateCatalog =
        Number(option.status) === 0 &&
        Number(option.created_with_approval) === 1 &&
        Number(option.inhouse) === 7
      if (Number(option.status) !== 1 && !isPendingEstimateCatalog) {
        return false
      }

      // Check if product is already selected for the same facility
      // const notAlreadySelected = !selectedProducts?.some(
      //   (selected) =>
      //     selected.id === option.id &&
      //     selected.facility_id === option.facility_id
      // );
      // if (!notAlreadySelected) return false;

      // Facility-based filtering will be applied only for split orders

      const categoryId = values?.project_category?.id;
      const catalogType = values?.catalog_type;
      const splitCatalogType = values?.split_catalog_type;

      // For split orders, apply facility match and then use split catalog type for filtering
      if (isSplitOrder) {
        const selectedFacilities = values?.facility_type || [];
        if (selectedFacilities.length === 0) {
          return false;
        }
        const selectedIds = new Set(selectedFacilities.map(f => Number(f.id)));
        const facilityMatch = selectedIds.has(Number(option.facility_id));
        if (!facilityMatch) return false;
        // If "All" is selected, show all products regardless of inhouse value
        if(splitCatalogType?.id === 'all' && categoryId == 11){
          return (option.inhouse === 5 || option.isTrafficCatalog === 1);
        }
        if (splitCatalogType?.id === 'all') {
          return true;
        }
        // Otherwise, filter based on the selected split catalog type
        if (splitCatalogType?.inhouse === 4) {
          return option.inhouse === 4;
        } else if (splitCatalogType?.inhouse === 5) {
          return option.inhouse === 5;
        } else if (splitCatalogType?.inhouse === 1 && !splitCatalogType?.isTrafficCatalog) {
          return option.inhouse === 1;
        } else if (splitCatalogType?.inhouse === 6) {
          return option.inhouse === 6;
        } else if (splitCatalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1;
        }else if (splitCatalogType?.inhouse === 7) {
          return option.inhouse === 7;
        }
        return true; // Default to show all for split orders
        }else{
          const selectedFacilities = FacilityTypes.filter((f) => Number(f.id) === Number(currentFacilityId));
          if (selectedFacilities.length === 0) return false;
          const selectedIds = new Set(selectedFacilities.map((f) => Number(f.id)));
          const facilityMatch = selectedIds.has(Number(option.facility_id));
          if (!facilityMatch) return false;
        }

      // Check for specific project category logic first
      if (categoryId === 15) {
        if (catalogType?.inhouse == 4) {
          return option.inhouse === 4;
        } else if (catalogType?.inhouse == 5) {
          return option.inhouse === 5;
        } else if (catalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1
        }
      }else if(categoryId === 11) {
        // Service Only: filter based on selected catalog type
        if (!isSplitOrder && values?.split_catalog_type) {
          const normalCatalogType = values.split_catalog_type;
          // If "All" is selected, show both client owned and traffic catalog
          if (normalCatalogType?.id === 'all') {
            return (option.inhouse === 5 || option.isTrafficCatalog === 1);
          }
          // Client Owned
          if (normalCatalogType?.inhouse === 5) {
            return option.inhouse === 5;
          }
          // Traffic Catalog
          if (normalCatalogType?.isTrafficCatalog) {
            return option.isTrafficCatalog === 1;
          }
        }
        // Default for Service Only: show both client owned and traffic catalog
        return (option.inhouse === 5 || option.isTrafficCatalog === 1);
      }

      // For normal orders, check split_catalog_type if it's set
      if (!isSplitOrder && values?.split_catalog_type) {
        const normalCatalogType = values.split_catalog_type;
        // If "All" is selected, show all products except split catalog
        if (normalCatalogType?.id === 'all') {
          return option.inhouse !== 6;
        }
        // Otherwise, filter based on the selected catalog type
        // Check isTrafficCatalog first before inhouse === 1 to avoid conflicts
        if (normalCatalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1;
        } else if (normalCatalogType?.inhouse === 4) {
          return option.inhouse === 4;
        } else if (normalCatalogType?.inhouse === 5) {
          return option.inhouse === 5;
        } else if (normalCatalogType?.inhouse === 1) {
          return option.inhouse === 1 && option.isTrafficCatalog !== 1; // Production Catalog (inhouse 1 but not traffic)
        } else if (normalCatalogType?.inhouse === 0) {
          return option.inhouse === 0; // Sub Contract
        } else if (normalCatalogType?.inhouse === 7) {
          return option.inhouse === 7; // Estimate Catalog
        }
        // If no match, exclude split catalog
        return option.inhouse !== 6;
      }

      // if (categoryId === 15) {
      //   if (catalogType?.inhouse == 4) {
      //     return option.inhouse === 4;
      //   } else if (catalogType?.inhouse == 5) {
      //     return option.inhouse === 5;
      //   } else if (catalogType?.isTrafficCatalog) {
      //     return option.isTrafficCatalog === 1
      //   }
      // }else if(categoryId === 11) {
      //    return (option.inhouse === 5 || option.isTrafficCatalog)
      // }
      return option.inhouse !== 6;
    });

    // Sort in strict alphanumeric order based on description and name only (ignore suffix)
    return filtered.sort((a, b) => {
      const getSortKey = (option) => {
        const name = (option.name || '').trim();
        const description = (option.description || '').trim();
        // Sort by description first, then by name for strict alphanumeric order
        const sortString = `${name}`.trim();
        return sortString;
      };

      const keyA = getSortKey(a);
      const keyB = getSortKey(b);
      
      // Strict alphanumeric sort: case-insensitive with natural numeric ordering
      return keyA.localeCompare(keyB, undefined, { 
        numeric: true, 
        sensitivity: 'base' 
      });
    });
  }, [allProducts, selectedProducts, values?.project_category?.id, values?.catalog_type?.inhouse, values?.facility_type, isSplitOrder, values?.split_catalog_type, currentFacilityId]);

  const catalogSuffixForProductOption = useCallback((option) => {
    if (!option) return ''
    return option.isTrafficCatalog
      ? '(TC)'
      : option.inhouse === 5
        ? '(Client Owned Catalog)'
        : option.inhouse === 4
          ? '(In Stock Catalog)'
          : option.inhouse === 0
            ? '(Sub Contract)'
            : option.inhouse === 6
              ? '(Split Catalog)'
              : option.inhouse === 7
                ? '(Estimate Catalog)'
                : '(Production Catalog)'
  }, [])

  /** One chip per group in the product Autocomplete (group name), not every member line. */
  const productAutocompleteDisplayValue = useMemo(
    () =>
      collapseProductsForAutocompleteChips(
        (selectedProducts || []).filter(
          (item) => item?.fromMapServices != true && !item.isAdditionalProduct,
        ),
        customerOrderProductGroups,
      ),
    [selectedProducts, customerOrderProductGroups],
  )

  const productAutocompleteDisplayValueForFacility = useCallback(
    (facilityId) => {
      const fid = Number(facilityId)
      return collapseProductsForAutocompleteChips(
        (selectedProducts || []).filter(
          (item) =>
            item?.fromMapServices != true &&
            !item.isAdditionalProduct &&
            Number(item?.facility_id) === fid,
        ),
        customerOrderProductGroups,
      )
    },
    [selectedProducts, customerOrderProductGroups],
  )

  const expandAutocompleteValueToMainProducts = useCallback((newCollapsed, prevSelected) => {
    const prev = prevSelected || []
    const mainPrev = prev.filter((p) => p?.fromMapServices != true && !p?.isAdditionalProduct)
    const expanded = []
    for (const chip of newCollapsed || []) {
      if (chip?.isGroupAutocompleteChip || (chip?.group_id != null && chip?.group_id !== '')) {
        const gid = String(chip.group_id)
        mainPrev
          .filter((p) => String(p.group_id) === gid)
          .sort((a, b) => Number(a.indexId || 0) - Number(b.indexId || 0))
          .forEach((p) => expanded.push(p))
        continue
      }
      const existing =
        chip?.indexId != null ? mainPrev.find((p) => Number(p.indexId) === Number(chip.indexId)) : undefined  
      if (existing) expanded.push(existing)
      else expanded.push(chip)
    }
    return expanded
  }, [])

  const filterSelectedProductsByFacility = (selectedFacilities) => {
    if (!selectedFacilities || selectedFacilities.length === 0) {
      return [];
    }

    const hasArizona = selectedFacilities.some(facility => facility.id === 1);
    const hasRiverside = selectedFacilities.some(facility => facility.id === 2);

    return selectedProducts.filter(product => {
      // If only Arizona is selected, keep products with undefined/null facility_id
      if (hasArizona && !hasRiverside) {
        return product.facility_id === undefined || product.facility_id === null;
      }
      // If only Riverside is selected, keep only products with facility_id = 2
      else if (hasRiverside && !hasArizona) {
        return product.facility_id === 2;
      }
      // If both are selected, keep all products
      return true;
    });
  };

  const filteredServiceOptions = useMemo(() => {
    const filtered = (filteredServices || []).filter((option) => {
      // const notAlreadySelected = !selectedProducts?.some((selected) => selected.id === option.id);
      // if (!notAlreadySelected) return false;

      const categoryId = values?.project_category?.id;
      const installLabour = option?.id;

      if (categoryId === 12) {
        if(installLabour){
          return option.id === 10;
        }
      }
      // Production catalog services (inhouse === 1): omit from sales-order additional-services picker.
      if (Number(option.inhouse) === 1) {
        return false;
      }
      return option.status == 1;
    });
    // Sort services alphanumerically by name
    return [...filtered].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''));
  }, [labourCostServices,filteredServices, selectedServices, values?.project_category?.id,invoice]);

  const getSplitFacilityServiceOptions = (facility) => {
    const options = [...(filteredServices?.filter(item =>
      item.status === 1 &&
      Number(item?.facility_id) === Number(facility?.id) &&
      Number(item.inhouse) !== 1
    ) || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
    if (Number(facility?.id) !== Number(currentFacilityId)) return options

    const seen = new Set()
    return options.filter((option) => {
      const key = `${option?.id ?? ''}-${option?.facility_id ?? currentFacilityId}`
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
  }

    // Function to auto-select install labour (id=10) when project_category changes to 12
    const autoSelectInstallLabour = (newProjectCategory) => {
      if (newProjectCategory?.id !== 12) return;
  
      // Auto-enable allServiceLocationSame when project_category changes to 12
      if (!allServiceLocationSame) {
        setAllServiceLocationSame(true);
      }
  
      const service10 = (labourCostServices || []).find(s => s.id === 10);
      if (!service10) return;
  
      const alreadySelected = (additionalSelectedServices || []).some(s => s.id === 10);
      if (alreadySelected) return;
  
      // Pull community address just like in onChange
      const {
        address: projAddress = '',
        city: projCity = '',
        state: projState = '',
        zip: projZip = '',
      } = values?.community || {};
  
      const communityAddress = {
        address: projAddress,
        city: projCity,
        state: projState,
        zip: projZip,
      };
      const hasCommunityAddress = projAddress && projCity && projState && projZip;
  
      // prev services for address propagation / allServiceLocationSame
      const prevServices = additionalSelectedServices || [];
      let assignedService;
  
      if (hasCommunityAddress) {
        // same utility used in onChange
        assignedService = assignServiceAddresses(
          prevServices,
          service10,
          allServiceLocationSame,
          communityAddress
        );
      } else {
        assignedService = {
          ...service10,
          addresses: [
            { id: 0, address: '', city: '', state: '', zip: '' },
          ],
        };
  
        // respect allServiceLocationSame like onChange
        if (allServiceLocationSame && prevServices.length > 0) {
          const commonAddress = { ...(prevServices[0]?.addresses?.[0] || {}) };
          assignedService.addresses[0] = commonAddress;
        }
      }
  
      const newIndexCounter = serviceIndexCounter + 1;
      setServiceIndexCounter(newIndexCounter);
  
      const serviceWithIndex = { ...assignedService, indexId: newIndexCounter, isAutoAdded: true, delivery_installation: { delivery_type_id: 1, installer_facility_id: Number(currentFacilityId),}, };
  
      const nextServices = [...prevServices, serviceWithIndex];
      setFieldValue('services', nextServices);
      setAdditionalSelectedServices(nextServices);
    };


    const syncProductsForJobTypeChange = (products = [], newValue) => {
      const nextIsNoCharge = newValue?.name == 'No Charge' || newValue?.id == 13

      return (products || []).map((product) => {
        if (product?.inhouse === 0) return product

        if (nextIsNoCharge) {
          const baseInstallCost = parseFloat(product?.expected_install_labor_cost) || 0
          const installAdj = parseFloat(product?.install_adjustment) || 0
          const signedInstallAdj = product?.install_adj_value_type === false ? -installAdj : installAdj
          const installCost = Math.max(0, baseInstallCost + signedInstallAdj)
          const expectedCost = (parseFloat(product?.expected_service_cost) || 0) + (parseFloat(product?.expected_material_cost) || 0)
          const installQty = Number(product?.install_quantity) || 1
          const prodQty = Number(product?.quantity) || 1
          const installEach = prodQty > 0 ? (installCost * (installQty / prodQty)) : installCost
          const calculatedRetailPrice = installEach > 0 ? expectedCost + installEach : expectedCost
          const adjustment = product?.adj_value_type ? (Number(product?.adjustment) || 0) : -(Number(product?.adjustment) || 0)

          return {
            ...product,
            expected_cost_before_no_charge: product?.expected_cost_before_no_charge ?? product?.expected_cost,
            retail_price_before_no_charge: product?.retail_price_before_no_charge ?? product?.retail_price,
            actual_retail_price_before_no_charge: product?.actual_retail_price_before_no_charge ?? product?.actual_retail_price,
            product_retail_price_before_no_charge: product?.product_retail_price_before_no_charge ?? product?.product_retail_price,
            price_before_no_charge: product?.price_before_no_charge ?? product?.price,
            original_actual_retail_price_before_no_charge: product?.original_actual_retail_price_before_no_charge ?? product?.original_actual_retail_price,
            original_retail_price_before_no_charge: product?.original_retail_price_before_no_charge ?? product?.original_retail_price,
            original_price_before_no_charge: product?.original_price_before_no_charge ?? product?.original_price,
            install_cost_before_no_charge: product?.install_cost_before_no_charge ?? product?.install_cost,
            original_install_cost_before_no_charge: product?.original_install_cost_before_no_charge ?? product?.original_install_cost,
            install_cost: installCost,
            expected_cost: expectedCost,
            original_actual_retail_price: expectedCost,
            original_retail_price: calculatedRetailPrice,
            original_price: expectedCost,
            retail_price: calculatedRetailPrice + adjustment,
            actual_retail_price: expectedCost + adjustment,
            product_retail_price: expectedCost + adjustment,
            retail_price_draft: undefined,
          }
        }

        if (product?.retail_price_before_no_charge == null && product?.actual_retail_price_before_no_charge == null) {
          return product
        }

        return {
          ...product,
          expected_cost: product?.expected_cost_before_no_charge ?? product?.expected_cost,
          retail_price: product?.retail_price_before_no_charge ?? product?.retail_price,
          actual_retail_price: product?.actual_retail_price_before_no_charge ?? product?.actual_retail_price,
          product_retail_price: product?.product_retail_price_before_no_charge ?? product?.product_retail_price,
          price: product?.price_before_no_charge ?? product?.price,
          original_actual_retail_price: product?.original_actual_retail_price_before_no_charge ?? product?.actual_retail_price_before_no_charge ?? product?.original_actual_retail_price,
          original_retail_price: product?.original_retail_price_before_no_charge ?? product?.retail_price_before_no_charge ?? product?.original_retail_price,
          original_price: product?.original_price_before_no_charge ?? product?.price_before_no_charge ?? product?.original_price,
          install_cost: product?.install_cost_before_no_charge ?? product?.install_cost,
          original_install_cost: product?.original_install_cost_before_no_charge ?? product?.original_install_cost,
          retail_price_draft: undefined,
        }
      })
    }

    const handleJobTypeChange = (newValue) => {
      // -------------------------------
      // 1) NO CHARGE LOGIC
      // -------------------------------
      if (newValue?.name == 'No Charge' || newValue?.id == 13) {
        setNoCharge(true);
        // For any No Charge job, always require manager approval
        // setFieldValue('manager_approval_required', isApprovalRequired);
      } else {
        setNoCharge(false);
        setFieldValue('no_charge_type', null);
      }
      const syncedProducts = syncProductsForJobTypeChange(selectedProducts, newValue)
      setSelectedProducts(syncedProducts)
      setFieldValue('products', syncedProducts)

      // -------------------------------
      // 2) SPLIT ORDER RESET
      // -------------------------------
      // if (newValue?.id !== 9) {
      //   setFieldValue('is_split', null);
      //   setIsSplitOrder(false);
      // }

      // -------------------------------
      // 3) SWITCHING TO TIME & MATERIAL OR SERVICE ONLY
      //    (Preserve services for Service Only, clear products)
      // -------------------------------
      const switchingToTM = newValue?.name === 'Time & Material';
      const switchingToServiceOnly = newValue?.name === 'Service only';

      if (switchingToTM || switchingToServiceOnly) {
        setSelectedProducts([]);
        setSelectedMapserviceProducts([]);
        setCart([]);
        setFieldValue('products', []);

        if (switchingToTM) {
          setSelectedMaterials([]);
          setFilteredServices(labourCostServices);
          setCartService([]);
          setTabIndex(0);
        }
      }

      // -------------------------------
      // 4) SWITCHING AWAY FROM TIME & MATERIAL
      //    (Remove only auto-added install labour)
      // -------------------------------
      const switchingAwayFromTM =
        values.project_category?.name === 'Time & Material' &&
        newValue?.name !== 'Time & Material';

      if (switchingAwayFromTM) {
        const filteredServices = (additionalSelectedServices || []).filter(
          s => !(s.id === 10 && s.isAutoAdded)  // Remove only auto-added install labour
        );

        setAdditionalSelectedServices(filteredServices);
        setFieldValue('services', filteredServices);
      }

      // -------------------------------
      // 5) AUTO-ADD INSTALL LABOUR (category 12)
      // -------------------------------
      autoSelectInstallLabour(newValue);

      // -------------------------------
      // SERVICE ONLY (ID = 11) - Clean selected products
      // -------------------------------
      if (newValue?.id === 11) {
        const allowed = selectedProducts.filter(
          (p) => p.inhouse === 5 || p.isTrafficCatalog === 1
        );

        setSelectedProducts(allowed);
        setSelectedMapserviceProducts([]);
        setSelectedMaterials([]);

        // ALSO update Formik values if needed
        setFieldValue('products', allowed);

        // Reset catalog type to 'All' for Service Only
        setFieldValue('split_catalog_type', splitOrderCatalogTypes.find((type) => type.id === 'all'));
      }

      // -------------------------------
      // 6) BUILD ORDER - Clear catalog type
      // -------------------------------
      if (newValue?.name == 'Build Order' || newValue?.id == 15) {
        setFieldValue('split_catalog_type', null) // Clear catalog type for Build Order
      }

      // -------------------------------
      // 7) SET FINAL CATEGORY VALUE
      // -------------------------------
      setFieldValue('project_category', newValue);

      // -------------------------------
      // 8) CLEAR MAP SERVICES ONLY IF NOT CATEGORY 14
      // -------------------------------
      if (values?.project_type?.name !== 'TS' || newValue?.id != 14) {
        setFieldValue('map_service', null);

        if (newValue?.name == 'Time & Material') {
          setSelectedProducts([]);
          setSelectedMapserviceProducts([]);
        }

        setSelectedMapserviceProducts([]);
      }
    };
//   let condition1 = (
//     userType == 3 ||
//     (isAdminUser (userType) && (details?.for_parent_facility != 1 && !isMirrored && details?.is_split_order != 1))
//     || (details?.for_parent_facility == 1 && details?.status == 2 && !isMirrored)
//     || (isAdminUser (userType) && details?.status !== 2) || hasInvoicePermissions
//   );
//   let condition2 = (
//     (
//       (details?.allInstallationCompleted == 1) && empty(details?.installation_acceptance) && !isMirrored && details?.received_status !== 1
//     )
//     || !(details?.status == 4 || details?.status == 3) || (details?.status == 4 && details?.proj_status == 1)
//   )
//   let condition3 = (
//     (isClient || userType == 3) ? (details?.client_approve == 1 || (details?.status == 4 && details?.proj_status == 1)) : true
//   )
//   let condition4 = details?.project_type && details?.status !== 6 && details?.installation_pending_review != 1 && details?.installation_pending_review != 2
// console.log("condition1",condition1);
// console.log("condition2",condition2);
// console.log("condition3",condition3);
// console.log("condition4",condition4);

 useEffect(() => {
    if(isOpenPopup && details && invoice?.id && !loadingEdit && !loadingEditInvoice && !loadingEditData){
      fetchRequestDetailsNew()
      setOpenInvoice(true)
      setIsOpenPopup(false)
    }
  },[isOpenPopup,details,invoice,loadingEdit,loadingEditInvoice,loadingEditData])

  useEffect(() => {
    if (openInvoice) {
      setAwaitingInvoicePopup(false)
    }
  }, [openInvoice]) 

const hasRunRef = useRef(false);
   useEffect(() => {
         const loadData = async () => {
            if (hasRunRef.current) return;
  if( openEmailModal && details && invoice?.id && !loadingEdit && !loadingEditInvoice   ) {
    console.log("tsssssssssssssssssssssssssssssssss");
 hasRunRef.current = true;
   await  fetchRequestDetailsNew()
    // setTimeout(() => {
    setOpenInvoice(true)   
    // }, 3000);
  }
}
  loadData();
}, [openEmailModal, details, invoice, loadingEdit, loadingEditInvoice]);


  if (openJobCostPopup && jobCostProjectId) {
    return (
      <Page title="Sign Wise Solutions">
        <RecipeCost
          popupOn={true}
          recipeCostId={jobCostProjectId}
          requestId={id}
          recipeCostCurrentTab={recipeCostCurrentTab}
          setRecipeCostCurrentTab={setRecipeCostCurrentTab}
          handleBackToAlljobs={() => {
            setOpenJobCostPopup(false);
            setJobCostProjectId(null);
          }}
          onDataChange={onDataChange}
          backButtonLabel="Back to Sales Order"
        />
      </Page>
    );
  }

  return (
    <Page title="Sign Wise Solutions" >

      {isGroupedCombinedLoading && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: alpha(theme.palette.common.black, 0.72),
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
          }}
        >
          <Box
            sx={{
              px: 4,
              py: 3.5,
              borderRadius: 3,
              textAlign: 'center',
              minWidth: 320,
              maxWidth: 420,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.35)}`,
              bgcolor: alpha(
                theme.palette.background.paper,
                theme.palette.mode === 'light' ? 0.95 : 0.12,
              ),
              boxShadow: `0 24px 48px ${alpha(theme.palette.common.black, 0.45)}, 0 0 24px ${alpha(theme.palette.primary.main, 0.2)}`,
            }}
          >
            <Box
              sx={{
                width: 120,
                height: 120,
                mx: 'auto',
                mb: 2,
                filter: `drop-shadow(0 0 16px ${alpha(theme.palette.primary.main, 0.45)})`,
              }}
            >
              <Lottie
                animationData={GroupedSalesOrdersLoadAnimation}
                loop
                autoplay
                style={{ width: '100%', height: '100%' }}
              />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main', mb: 0.75 }}>
              Fetching Grouped Orders
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2.5 }}>
              Loading combined sales order details. Please wait…
            </Typography>
            <LinearProgress
              sx={{
                height: 5,
                borderRadius: 3,
                bgcolor: alpha(theme.palette.primary.main, 0.15),
                '& .MuiLinearProgress-bar': {
                  borderRadius: 3,
                  background: `linear-gradient(90deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
                },
              }}
            />
          </Box>
        </Box>
      )}

      {(loading || convertToRFQ) ? 
        <Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center',mt:8 }} >
          <LoadingScreen />
        </Stack>
      :
        <Container sx={{mt:3}}>
          <Button
            variant="outlined"
            type="button"
            // onClick={()=>navigate(PATH_DASHBOARD.official.root)}
            // onClick={() => { window.history.back() }}
            onClick={() => {
              openEdit ? handleCancel(true) : handleCancel() //setOpenEdit(false) //handleCancel() // navigate(PATH_DASHBOARD.official.root)}
              setSettingsAnchorEl(null)
            }}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={ // Use the startIcon prop to add an icon to the left
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>

            }
          >
            Back
          </Button>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <HeaderBreadcrumbs
              heading={details?.name}
              headingSx={PRESERVE_WHITESPACE_SX}
            />
            {!openEdit && (
              <Stack marginBottom={5} flexDirection={'column'}>
                <Stack direction={'row'} alignItems={'center'} spacing={1}>
                  {(user.isVendor === 1 && proposalData && !proposalData?.length > 0) && (<Button
                    size="small"
                    variant="contained"
                    disabled={explodedPermissions?.some(permission => ['Submit Proposal'].includes(permission)) ? false : true}
                    onClick={() => setAddProposal(true)}
                    sx={{ height: 34 }}
                    startIcon={<Icon icon={plusFill} />}
                  >
                    Submit Proposal
                  </Button>)}
                </Stack>
                {(userType != 3 || (userType ==3 && details?.status == 2) )?
                  <Stack>
                    {((details && invoice) && (
                      Number(details?.status) === 10
                        ? explodedPermissions?.some(permission => ['Delete request'].includes(permission))
                        : (
                      (details?.proj_status !== 3 && userType !== 3) ||
                      ((((details?.status !== 6 && !details?.installationStatus && empty(details?.allInstallationCompleted)&& !details?.for_parent_facility) || (details?.noServiceNoTask != 1)) && details?.status !=10 && details?.allInstallationCompleted !== 1 && details?.hold !==1 && !details?.for_parent_facility ) || details?.isReview ==2) ||
                      ((details?.allInstallationCompleted !== 1) || details?.isReview ==2) ||
                      (details?.status === 6) ||
                      (explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request'].includes(permission)) && details?.status === 3 && details?.hold !== 1 && (details.project_category ==13 || details?.min_payment_status ==1)) ||
                      (explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request'].includes(permission)) && details?.installation_acceptance === 1 && details?.allInstallationCompleted) ||
                      (explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request'].includes(permission)) && details?.id)
                        )
                    )) && canShowGroupedParentSalesOrderActions && (
                    <Button
                     variant="contained"
                     color="success"
                     sx={{ color: 'white' }}
                      startIcon={
                     selectListLoading ? (
                     <CircularProgress size={16} color="inherit" />
                    ) : (
                   <span className="gg--menu-grid-o" />
                   )
                     }
                   disabled={selectListLoading}
                     onClick={(e) => setSettingsAnchorEl(e.currentTarget)}
                    >
                   {selectListLoading
                     ? 'Loading Actions...'
                         : 'Select from List'}
                  </Button>
                    )}
                    <Popover
                      open={Boolean(settingsAnchorEl)}
                      anchorEl={settingsAnchorEl}
                      onClose={() => setSettingsAnchorEl(null)}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <Paper sx={{ p: 2, width: 'fit-content', minWidth: 50 }}>
                        <Stack spacing={1}>
                        
                    {(details && invoice) ? (
                      <Stack flexDirection={'row'} gap={2}>
                        {Number(details?.status) !== 10 && Number(details?.status) !== 6 && Number(details?.rejected) !== 1 && details?.allInstallationCompleted !== 1 && userType !== 3 && details?.for_parent_facility == 0 ?
                          <Stack
                            direction={'row'} alignItems={'center'} spacing={1}
                          >
                            <Button
                              onClick={() => {
                                setOpenHoldPopup(true)
                                setSettingsAnchorEl(null)
                              }}
                              sx={{
                                borderRadius: 20,
                                backgroundColor: theme.palette.warning.main,
                                color: 'black',
                                boxShadow: 'none',
                                '&:hover': {
                                  backgroundColor: theme.palette.warning.dark,
                                  boxShadow: 'none',
                                },
                              }}
                              variant="contained"
                            >
                              {details?.hold === 0
                                ? 'Move to Hold'
                                : 'Release from Hold'}
                            </Button>
                          </Stack> : ''
                        }
                        {/* {((((details?.status !== 6 && !details?.installationStatus && empty(details?.allInstallationCompleted)&& !details?.for_parent_facility) || (details?.noServiceNoTask != 1)) && details?.status !=10 && details?.allInstallationCompleted !== 1 && details?.hold !==1 && !details?.for_parent_facility ) || details?.isReview ==2)? ( */}
                        {Number(details?.status) !== 10 && !(details?.isReview == 2 && details?.project_category == 12 && empty(details?.installation_acceptance)) && (
                          isDedicatedGroupedParent
                            ? explodedPermissions?.some((permission) => ['Edit Request'].includes(permission))
                            : (
                          ((((details?.status !== 6 && !details?.installationStatus && empty(details?.allInstallationCompleted)&& !details?.for_parent_facility) || (details?.noServiceNoTask != 1)) && details?.status !=10 &&  (((details?.allInstallationCompleted !== 1) && details?.installationStatus !==2) || (details?.installationStatus ==2 && hasPermission('Install Change Order'))) && details?.hold !==1 && !details?.for_parent_facility ) || details?.isReview ==2 || (hasEditFinalInvoicePermission && details?.allInstallationCompleted == 1 && mainCurrentTab !== 'ARCHIVE' && details?.is_split_order == 0)) && details?.hold !==1
                            )
                        ) ? (
                        /* {((details?.status !== 6 && !details?.installationStatus && empty(details?.allInstallationCompleted)) || (details?.noServiceNoTask != 1 && details?.proj_status != 3)) && details?.status !=10 && ( */
                          <Tooltip title={actionsLoading ? "Edit loading..." : "Edit"}>
  <span>
    <IconButton
      sx={{
        backgroundColor: theme.palette.mode === 'light' ? "#BDBDBD" : theme.palette.divider,
        '&:hover': {
          backgroundColor: theme.palette.mode === 'light' ? "#858585" : theme.palette.divider
        }
      }}
      onClick={() => {
        if (actionsLoading) return;

        if (explodedPermissions?.some(permission => ['Edit Request'].includes(permission))) {
          handleEditClick();
          setSettingsAnchorEl(null);
        } else if (!empty(details?.allInstallationCompleted)) {
          enqueueSnackbar("Cannot edit. Job has been completed", { variant: 'error' });
        } else if (details?.installationStatus) {
          enqueueSnackbar("Access Denied: Moved to Installation Phase", { variant: 'error' });
        } else {
          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
        }
      }}
      disabled={actionsLoading}
    >
      {actionsLoading ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        <Icon icon={editFill} width={24} height={24} color="#ffffff" />
      )}
    </IconButton>
  </span>
</Tooltip>
                        ) : ''}

                       {((Number(details?.status) === 10 && explodedPermissions?.some(permission => ['Delete request'].includes(permission))) || ((details?.allInstallationCompleted !== 1 ) || details?.isReview ==2 ) || isAdminUser (userType)) ? (
                            /* (details?.allInstallationCompleted !== 1 && details?.noServiceNoTask == 1) ? ( */
                            <Tooltip title={actionsLoading ? "Please wait..." : "Delete"}>
  <span>
    <IconButton
      sx={{
        backgroundColor: theme.palette.mode === 'light' ? "#BDBDBD" : theme.palette.divider,
        '&:hover': {
          backgroundColor: theme.palette.mode === 'light' ? "#858585" : theme.palette.divider
        }
      }}
      disabled={actionsLoading}
      onClick={() => {
        if (actionsLoading) return;

        explodedPermissions?.some(permission => ['Delete request'].includes(permission))
          ? handleDeleteMenu()
          : enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });

        setSettingsAnchorEl(null);
      }}
    >
      <Icon icon={trash2Outline} width={24} height={24} color="#ffffff" />
    </IconButton>
  </span>
</Tooltip>
                          ) : ''
                        }

                        {details?.isProject &&
                          explodedPermissions?.some((permission) =>
                            ['Manage Job Cost'].includes(permission),
                          ) ? (
                          <AnimatedButton
                            title="Job Cost"
                            onClick={() => {
                              localStorage.setItem('params', String(id));
                              setSettingsAnchorEl(null);
                              setRecipeCostCurrentTab('Labor');
                              setJobCostProjectId(details.isProject);
                              setOpenJobCostPopup(true);
                            }}
                          />
                        ) : null}


                        {Number(details?.status) !== 10 && details?.for_parent_facility != 1 && explodedPermissions?.some(permission => ['Void Sales Order'].includes(permission)) ? ( 
                          <Button
                            size="small"
                            variant="contained"
                            color="error"
                            onClick={() => {
                              handleVoidMenu();
                              setSettingsAnchorEl(null);
                            }}
                          >
                            Move to Void
                          </Button>
                        ) : ''}

                        {/* {!details || (details?.installationStatus || (details?.proj_status == 3 && !details?.total_installation_count)) || (details?.noServiceNoTask !== 1 && details?.proj_status == 3) ||  details?.status ==10 ? '' :
                          <Tooltip title="Delete">
                            <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={() => {
                              explodedPermissions?.some(permission => ['Delete request'].includes(permission))
                              ? handleDeleteMenu()
                              : enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                            }}>
                              <Icon icon={trash2Outline} width={24} height={24} color="#ffffff" />
                            </IconButton>
                          </Tooltip>
                        } */}

                        {Number(details?.status) === 10 && explodedPermissions?.some(permission => ['Void Sales Order'].includes(permission)) ? (
                          <AnimatedButton title={"Reopen"} onClick={() => { handleReopenVoidMenu(); setSettingsAnchorEl(null); }}/>
                        ) : ''}

                        {details?.status === 6 ? (
                          // <Tooltip title="Reopen">
                          //   <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={() => { handleReopen(); setSettingsAnchorEl(null); }}>
                          //     <Icon icon={lockOpenFill} width={24} height={24} color="#ffffff" />
                          //   </IconButton>
                          // </Tooltip> 
                          <AnimatedButton title={"Reopen"} onClick={() => { handleReopen(); setSettingsAnchorEl(null); }}/>
                        ) : ''}
                        {console.log("invouiceeeeeeeeee",invoice)}
                        {explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request'].includes(permission)) ?
                          (Number(details?.status) === 3 &&
                            details?.hold !== 1 &&
                            // When details indicate "New" (design order -> estimate -> new flow), don't show convert actions
                            !(Number(details?.new_order) === 1 && Number(details?.isFromDesignOrder) === 1) &&
                            (details.project_category ==13 || details?.min_payment_status ==1) && (
                            <AnimatedButton 
                            title={(
                              // details?.noServiceNoTask === 1 &&
                              invoice?.cust_product?.length === 0
                              && isConvertToInvoicing
                               ) ? 'Convert to Invoicing' : 'Convert to Production'} onClick={()=>{ if (!checkJobTypeBeforeApprovalAction(`Unable to convert this sales order to ${(invoice?.cust_product?.length === 0 && isConvertToInvoicing) ? 'Invoicing' : 'Production'}.`)) { setSettingsAnchorEl(null); return; } setOpenConvertToRFQ(true); setSettingsAnchorEl(null); console.log('details-setOpenConvertToRFQ--',details); }} />
                          )) : '' }
                          
                          {!details?.is_split_order && Number(details?.status) !== 10 && !isGroupedSalesOrderView && explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request'].includes(permission)) ?
                          // (details?.installation_acceptance === 1 && details?.allInstallationCompleted ? (
                          (details?.id ? (
                            <AnimatedButton title={'Duplicate Sales Order'} onClick={()=>{
                              setOpenDuplicate(true)
                              setSettingsAnchorEl(null)
                              // handleDuplicateSalesOrder()
                              }}
                            />
                          ) :"") : ''
                          }
                        {/* {details?.status === 3 && (
                          <Tooltip title="Convert to Production">
                            <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={()=>{ setOpenConvertToRFQ(true); console.log('details-setOpenConvertToRFQ--',details); }}>
                              <Icon icon={plusFill} width={24} height={24} color="#ffffff" />
                            </IconButton>
                          </Tooltip>
                        )} */}
                      </Stack>
                    ) : (
                      <Stack flexDirection="row" alignItems="center" gap={1}>
                        <CircularProgress size={20} color="primary" variant="indeterminate" />
                        <Typography variant="body2" color="textSecondary">Loading data...</Typography>
                      </Stack>
                    )}
                        </Stack>
                      </Paper>
                    </Popover>
                  </Stack>
                : ""}
              </Stack>
            )}
          </Stack>
          {openEdit && (loadingEdit ? (
            <LoadingScreen />
          ) : (
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <Grid container spacing={3}>

                  <Grid item xs={12} md={12}>
                    <Card sx={{ p: 3 }}>
                      {/* SW-114828 backup – pointer-events CSS lock removed; use tmInvoicingFieldDisabled on fields instead
                      <Stack spacing={3} sx={isTmInvoicingLimitedEdit ? { '& *:not([data-tm-editable]):not([data-tm-editable] *)': { pointerEvents: 'none' } } : {}}>
                      */}
                      <Stack spacing={3} sx={tmInvoicingFormReadOnlySx}>
                          <Stack
                            direction={{ xs: 'column', sm: 'column' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                            <Box display='flex' flexDirection='column' sx={{ mb: 3 }}>
                            <Typography variant="overline" sx={{ color: '#ffffff', ...PRESERVE_WHITESPACE_SX }}>
                              {details?.name}
                              {/* {sentenceCase(details?.name)} */}
                            </Typography>
                            {(details?.status == 6 && (details?.reason || details?.manager_reject_reason || details?.reject_file || details?.manager_reject_file)) ||
                            (Number(details?.status) === 10 && details?.reason) ? (
                              (() => {
                                const isVoidOrder = Number(details?.status) === 10;
                                const isManagerReject = false;
                                /* !isVoidOrder &&
                                  details?.status == 6 &&
                                  (details?.manager_approval_required === true || details?.manager_approval_required === 1) &&
                                  (details?.send_to_client == 0 || details?.quotation_status == 2); */
                                const displayReason = isVoidOrder
                                  ? (details?.reason ?? '')
                                  : isManagerReject
                                  ? (details?.manager_reject_reason ?? details?.reason ?? '')
                                  : (details?.reason ?? '');
                                const displayRejectFile = isVoidOrder
                                  ? null
                                  : isManagerReject
                                  ? (details?.manager_reject_file ?? details?.reject_file ?? null)
                                  : (details?.reject_file ?? null);
                                const displayRejectFileType = isVoidOrder
                                  ? null
                                  : isManagerReject
                                  ? (details?.manager_reject_file_type ?? details?.reject_file_type ?? null)
                                  : (details?.reject_file_type ?? null);

                                console.log('depositAndProgressBillingdepositAndProgressBilling1--',depositAndProgressBilling);
                                console.log('depositAndProgressBillingdepositAndProgressBilling2--',details);
                                return (
                                  <>
                                    {displayReason && (
                                      <Typography variant="subtitle2" color={'error'}>
                                        {isVoidOrder ? 'VOID REASON' : 'Reason'} :{displayReason}
                                      </Typography>
                                    )}
                                    {!isVoidOrder && displayRejectFile && (
                                      displayRejectFileType === 'application/pdf' ? (
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          color="primary"
                                          sx={{ mt: 0.5 }}
                                          onClick={() => window.open(displayRejectFile, '_blank')}
                                        >
                                          View Attached File (PDF)
                                        </Button>
                                      ) : (
                                        <Box
                                          component="img"
                                          src={displayRejectFile}
                                          onClick={() => window.open(displayRejectFile, '_blank')}
                                          sx={{
                                            width: 120,
                                            height: 120,
                                            borderRadius: 1,
                                            border: '1px solid #ccc',
                                            cursor: 'pointer',
                                            objectFit: 'cover',
                                            mt: 0.5
                                          }}
                                        />
                                      )
                                    )}
                                  </>
                                );
                              })()
                            ) : null}
                            {details?.hold === 1 && details?.hold_reason ? (
                              <Typography variant="subtitle2" color={'error'}>
                                Hold Reason : {details?.hold_reason}
                              </Typography>
                            ) : ''}
                          {userType != 3 && (
                            <Typography
                              variant="subtitle2"
                              sx={{
                                color: `${(false ? !details?.rfpQbId : !details?.estimate_id || !details?.doc_number || !details?.syncWithQuickbooks)
                                    ? 'red'
                                    : 'green'
                                  }`,
                              }}
                            >
                              {/* {details?.reasonWithQb? details?.reasonWithQb : 'Successfully Synced With QuickBooks'} */}
                              {false && details?.awarded == null
                                ? ''
                                : false
                                  ? details?.reasonWithQb
                                    ? details?.reasonWithQb.split('\n').map((line, index) => (
                                      <span key={index} style={{ display: 'block' }}>
                                        {line}
                                      </span>
                                    ))
                                    : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...'
                                  : (details?.estimate_id && details?.invoice_qb_id)
                                    ? 'Successfully Synced With QuickBooks'
                                    : details?.reasonWithQb
                                      ? details?.reasonWithQb.split('\n').map((line, index) => (
                                        <span key={index} style={{ display: 'block' }}>
                                          {line}
                                        </span>
                                      ))
                                      : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...'}
                            </Typography>
                          )}
                          </Box>
                          <Stack
                            direction={{ xs: 'column', sm: 'row', md: 'row' }}
                            sx={{ justifyContent: 'space-between' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                        <Box display='flex' flexDirection='column' sx={{ mb: 3 }}>
                          {/* BACKUP: detail page job/invoice numbers (single order only)
                          {
                            (depositAndProgressBilling ||  (details?.installation_acceptance && details?.est_doc_number)) && (details?.doc_number !== details?.est_doc_number)?
                            <>
                              <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                <strong>Job Number :</strong> {details?.est_doc_number ? `#${details?.est_doc_number}` : ''}
                              </Typography>
                              <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                <strong>Invoice Number :</strong> {details?.doc_number ? `#${details?.doc_number}` : ''}
                              </Typography>
                            </>
                            :
                            <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                              <strong>Order Id :</strong> {details?.doc_number ? `#${details?.doc_number}` : ''}
                            </Typography>
                          }
                          */}
                          {isGroupedInvoiceDetails && getGroupedJobNumbersText() ? (
                            <>
                              {getGroupedParentOrderIdText() ? (
                                <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                  <strong>Order Id :</strong> #{getGroupedParentOrderIdText()}
                                </Typography>
                              ) : null}
                              <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                <strong>Job Number :</strong> #{getGroupedJobNumbersText()}
                              </Typography>
                              {Number(details?.installation_acceptance || 0) === 1 && getGroupedInvoiceNumbersText() ? (
                                <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                  <strong>Invoice Number :</strong> #{getGroupedInvoiceNumbersText()}
                                </Typography>
                              ) : null}
                            </>
                          ) : (
                            (depositAndProgressBilling || (details?.installation_acceptance && details?.est_doc_number)) && (details?.doc_number !== details?.est_doc_number) ? (
                              <>
                                <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                  <strong>Job Number :</strong> {details?.est_doc_number ? `#${details?.est_doc_number}` : ''}
                                </Typography>
                                <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                  <strong>Invoice Number :</strong> {details?.doc_number ? `#${details?.doc_number}` : ''}
                                </Typography>
                              </>
                            ) : (
                              <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                <strong>Order Id :</strong> {getSalesOrderDisplayJobNumber(details) ? `#${getSalesOrderDisplayJobNumber(details)}` : ''}
                              </Typography>
                            )
                          )}
                          <Typography variant="overline" sx={{ color: '#fd6400' }}>
                            {details?.avalara_code ? <strong>Avalara Id : {details?.avalara_code}</strong> : ""}
                          </Typography>
                          {details?.design_order_id ? 
                            <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                              <strong>Design Order Id :</strong> #{details?.design_order_id}
                            </Typography> : ''}
                          <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Created by :</strong> {details?.added_by_name || ''}
                          </Typography>
                          <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Created on :</strong> {details?.created_at ? moment.unix(details.created_at).format('MM-DD-YYYY hh:mm:ss A') : 'N/A'}
                          </Typography>
                          <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Client Name :</strong> {
                              details?.is_split_order && details?.for_parent_facility == 1 
                                ? FacilityTypes?.find(facility => facility.id === details?.origin_facility_id)?.label || invoice?.customer_name || ''
                                : invoice?.customer_name || ''
                            }
                          </Typography>
                          {details?.is_split_order && details?.for_parent_facility == 1 ? '' :
                          <>
                          <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff', whiteSpace: 'pre-line' }}>
                            <strong>Client Address :</strong> {[
                              invoice?.customer_address || '',
                              [
                                invoice?.customer_city || details?.customer_city || '',
                                invoice?.customer_state || details?.customer_state || '',
                                invoice?.customer_zipcode || details?.customer_zipcode || '',
                              ].filter(Boolean).join(', ')
                            ].filter(Boolean).join('\n')}
                          </Typography>
                          <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Client Phone :</strong> {invoice?.customer_phone || ''}
                          </Typography>
                          </>}
                          <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Project Name :</strong> {details?.community_name || ''}
                          </Typography>
                          <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                            <strong>Sales Rep :</strong> {details?.sales_rep_names || ''}
                          </Typography>
                          
                          {details?.job_category_name ?
                            <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                              <strong>Job Type :</strong> {details?.job_category_name} 
                            </Typography>
                            : ""}
                          {(details?.bill_to || details?.ship_to) && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  // flexDirection: 'column',
                                  mt:1,
                                  gap: 1,
                                }}
                              >
                                {details?.bill_to && (
                                  <Box sx={{ flex: 1, width: 250 }}>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: '#ffffff', whiteSpace: 'pre-line',wordBreak: 'break-word', }}
                                    >
                                      <strong>Bill To :</strong> {details?.bill_to}
                                    </Typography>
                                  </Box>
                                )}
                                {details?.ship_to && (
                                  <Box sx={{ flex: 1, Width: 250 }}>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: '#ffffff', whiteSpace: 'pre-line' }}
                                    >
                                      <strong>Ship To :</strong> {details?.ship_to}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            )}
                        </Box>
                        <Stack spacing={2} sx={{ mt: 2 ,display:'flex',flexDirection:'row',justifyContent:'space-between',gap:25}}>
                                <Box sx={{ minWidth: 200 }}>
                                  {details?.collaborators && details?.collaborators?.length > 0 && (
                                    <>
                                      <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                        Collaborators
                                      </Typography>

                                      {(() => {
                                        const collaboratorIds = Array.isArray(details?.collaborators)
                                          ? details.collaborators.map((c) => String(c?.id ?? c))
                                          : String(details?.collaborators || '')
                                            .split(',')
                                            .map((id) => id.trim())
                                            .filter(Boolean)

                                        const filteredMembers = allTeamMembers?.filter((member) =>
                                          collaboratorIds.includes(String(member?.id))
                                        )

                                        const maxVisible = 4
                                        const visibleMembers = filteredMembers?.slice(0, maxVisible)
                                        const remainingCount =
                                          filteredMembers?.length > maxVisible
                                            ? filteredMembers.length - maxVisible
                                            : 0

                                        const membersToRender = showAllCollaborators ? filteredMembers : visibleMembers

                                        return (
                                          <Stack direction="row" alignItems="center">
                                            {membersToRender?.map((row, index) => {
                                              const isOnline = onlineUsers?.includes(String(row?.user_id || row?.id));

                                              return (
                                                <Box
                                                  key={row?.id}
                                                  sx={{
                                                    ml: index === 0 ? 0 : -1.5,
                                                    zIndex: 100 - index, // 👈 important
                                                    position: "relative",
                                                  }}
                                                >
                                                  <Tooltip
                                                    title={`${row?.first_name || ''} ${row?.last_name || ''}`}
                                                    arrow
                                                  >
                                                    <Badge
                                                      overlap="circular"
                                                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                      variant="dot"
                                                      sx={{
                                                        "& .MuiBadge-badge": {
                                                          backgroundColor: isOnline ? "#44b700" : "#bdbdbd",
                                                          boxShadow: "0 0 0 2px white",
                                                          height: 10,
                                                          minWidth: 10,
                                                          borderRadius: "50%",
                                                          zIndex: 200, // 👈 force dot above everything
                                                        },
                                                      }}
                                                    >
                                                      <Avatar
                                                        src={row?.profile_pic}
                                                        alt={`${row?.first_name} ${row?.last_name}`}
                                                        sx={{
                                                          width: 42,
                                                          height: 42,
                                                          fontSize: 14,
                                                          border: "2px solid #fff",
                                                          cursor: "pointer",
                                                          transition: "all 0.2s ease",
                                                          bgcolor: "primary.main",
                                                          "&:hover": {
                                                            transform: "scale(1.1)",
                                                            zIndex: 300,
                                                            boxShadow: 3,
                                                          },
                                                        }}
                                                      >
                                                        {row?.first_name?.charAt(0)}
                                                      </Avatar>
                                                    </Badge>
                                                  </Tooltip>
                                                </Box>
                                              );
                                            })}


                                            {remainingCount > 0 && (
                                              <Box sx={{ ml: -1.5 }}>
                                                <Tooltip title={showAllCollaborators ? 'Show less' : `${remainingCount} more collaborators`} arrow>
                                                  <Avatar
                                                    onClick={() => setShowAllCollaborators((s) => !s)}
                                                    sx={{
                                                      width: 42,
                                                      height: 42,
                                                      fontSize: 14,
                                                      border: '2px solid #fff',
                                                      bgcolor: 'grey.400',
                                                      cursor: 'pointer',
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center'
                                                    }}
                                                  >
                                                    {showAllCollaborators ? '−' : `+${remainingCount}`}
                                                  </Avatar>
                                                </Tooltip>
                                              </Box>
                                            )}
                                          </Stack>
                                        )
                                      })()}
                                    </>
                                  )}
                                </Box>

                            <Box sx={{ minWidth: 200, borderColor: 'GrayText' }}>
                              {/* empty(quotation)&& details?.job_category_name!='Service only' && details?.job_category_name!='Time & Material' && */}
                              {invoice && invoice?.total != 0 && userType != 3 && (
                                <>
                                  <Typography alignItems={'center'} variant="subtitle1">
                                    Staff Members
                                  </Typography>
                                  <Scrollbar sx={{ width: '100%', height: 100 }}>
                                    <Stack>
                                      {teamMembers?.map((row) => (
                                        <Stack
                                          direction={{ xs: 'column', sm: 'row', md: 'row' }}
                                          mb={1}
                                          spacing={{ xs: 3, sm: 2 }}
                                        >
                                          <Avatar
                                            src={row?.profile_pic}
                                            alt={row?.first_name + ' ' + row?.last_name}
                                          />
                                          <Typography variant="caption">
                                            {row?.first_name + ' ' + row?.last_name}
                                          </Typography>
                                        </Stack>
                                      ))}
                                    </Stack>
                                  </Scrollbar>
                                </>
                              )}
                            </Box>
                        </Stack>
                        </Stack>
                        </Stack>
                        {(() => {
                          const formattedDescription = Array.isArray(details?.description_lines) && details.description_lines.length
                            ? details.description_lines.join('\n')
                            : details?.description || '';
                          const submissionDate = details?.submission_deadline ? formatDateOnly(details.submission_deadline) : '';
                          const endDate = details?.installation_start_date && details?.installation_end_date 
                            ? `${formatDateOnly(details.installation_start_date)} - ${formatDateOnly(details.installation_end_date)}`
                            : details?.participation_ends ? formatDateOnly(details.participation_ends) : '';
                          return (
                            <Stack direction="column" spacing={2}>
                            <Stack
                              direction={{ xs: 'row', sm: 'row' }}
                              sx={{ justifyContent: 'space-between' }}
                              spacing={{ xs: 3, sm: 2 }}
                            >
                              <Box sx={{ width: '60%' }}>
                                <Stack sx={{ flexDirection: 'row' }}>
                                  <Tooltip title="Description">
                                    <Description />
                                  </Tooltip>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff', flexWrap: 'wrap', ml: 2, whiteSpace: 'pre-line' }}
                                  >
                                    {formattedDescription}
                                  </Typography>
                                </Stack>
                              </Box>
                              <Box sx={{ width: '35%' }}>
                                {!user.isVendor && empty(details?.quotation) && (
                                  <Stack>
                                    <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                      Requested Start Date: {submissionDate}
                                    </Typography>
                                    <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                                      Requested Installation Date: {endDate}
                                    </Typography>
                                  </Stack>
                                )}
                              </Box>
                              </Stack>
                            </Stack>
                          );
                        })()}

                        <Divider />
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Stack flexDirection={'column'}>
                            {/* <LabelStyle>Name</LabelStyle> */}
                            <TextField
                              //   fullWidth
                              sx={{ width: 400 }}
                              label="Order Name"
                              name="name"
                              disabled={tmInvoicingFieldDisabled}
                              InputProps={tmInvoicingFieldDisabled ? { readOnly: true } : undefined}
                              value={nameFileds?.name}
                              onChange={(e) => {
                                const v = e.target.value
                                setNameFileds({ ...nameFileds, name: v })
                                if (v.trim()) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    name: undefined,
                                  }))
                                }
                              }}
                              error={Boolean(fieldErrors.name)}
                              helperText={fieldErrors.name || ''}
                            />
                          </Stack>
                          <TextField
                              sx={{ width: 400 }}
                              label="#PO Number"
                              name="po_number"
                              disabled={tmInvoicingFieldDisabled}
                              InputProps={tmInvoicingFieldDisabled ? { readOnly: true } : undefined}
                              value={nameFileds?.po_number}
                              onChange={(e) =>
                                setNameFileds({ ...nameFileds, po_number: e.target.value })
                              }
                              error={Boolean(touched.po_number && errors.po_number)}
                              helperText={touched.po_number && errors.po_number}
                            />
                            <Box
                              data-tm-editable
                              component={MobileDatePicker}
                              disableFuture
                              label={((details?.installation_acceptance && details?.est_doc_number) && (details?.doc_number !== details?.est_doc_number)) ? "Invoice Date" : "Order Date"}
                              value={(() => {
                                const orderDateUnix = values.timestamp ?? details?.timestamp ;
                                return orderDateUnix ? moment.unix(Number(orderDateUnix)) : null;
                              })()}
                              onChange={(date) => {
                                const unix = date ? moment(date).unix() : null;
                                setFieldValue('timestamp', unix);
                                // setDetails((prev) => (prev ? { ...prev, timestamp: unix } : prev));
                                // setCurrentRFQdata((prev) => ({ ...prev, timestamp: unix }));
                              }}
                              renderInput={(params) => (
                                <TextField {...params} sx={{ width: 400 }} />
                              )}
                            />
                        </Stack>
                        {/* <LabelStyle>Description</LabelStyle> */}
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          label="keep the summary brief and make it communicates"
                          name="description"
                          disabled={tmInvoicingFieldDisabled}
                          InputProps={tmInvoicingFieldDisabled ? { readOnly: true } : undefined}
                          value={nameFileds?.description}
                          onChange={(e) => {
                            const v = e.target.value
                            setNameFileds({ ...nameFileds, description: v })
                            if (v.trim()) {
                              setFieldErrors((prev) => ({
                                ...prev,
                                description: undefined,
                              }))
                            }
                          }}
                          error={Boolean(fieldErrors.description)}
                          helperText={fieldErrors.description || ''}
                        />
                        {/* <LabelStyle>Upload Approved Design</LabelStyle> */}
                        {/* <UploadAvatar
                        accept="image/*"
                        file={values.avatarUrl}
                        maxSize={1024 * 1024 * 1024}
                        onDrop={handleDrop}
                        error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                      /> */}
                        {/* <UploadMultiFile
                         showPreview
                        maxSize={1024 * 1024 * 1024}
                        accept="image/*"
                         files={avatarUrl}
                        onDrop={handleDrop}
                        onRemove={handleRemove}
                        onRemoveAll={handleRemoveAll}
                    // error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                    /> */}

                    {userType !== 3 &&
                                      explodedPermissions?.some((permission) =>
                                        ['Create Request'].includes(permission),
                                      ) && (
                                        <>
                                          {/* {values?.project_category?.name  != 'Service only' &&
                                            values?.project_category?.name  !=
                                              'Time & Material' && (
                                              <> */}
                                                <LabelStyle>Upload Designs / Documents</LabelStyle>
                                                <Box sx={tmInvoicingFieldDisabled ? {
                                                  // SW-114828: keep download on preview; hide remove/delete controls only
                                                  '& .MuiListItem-root > .MuiBox-root:last-of-type:not(:only-of-type)': { display: 'none' },
                                                  '& .MuiListItemSecondaryAction': { display: 'none' },
                                                } : {}}>
                                                <UploadMultiFile
                                                  showPreview
                                                  allowDownload
                                                  // maxSize={1024 * 1024 * 1024}
                                                  maxSize={1024 * 1024 * 1024}
                                                  // accept="image/*,application/pdf"
                                                  files={uploadDesignsDisplayFiles}
                                                  onDrop={tmInvoicingFieldDisabled ? () => {} : handleDrop}
                                                  onRemove={tmInvoicingFieldDisabled ? () => {} : handleRemove}
                                                  onRemoveAll={tmInvoicingFieldDisabled ? () => {} : handleRemoveAll}
                                                  noClick={tmInvoicingFieldDisabled}
                                                  noDrag={tmInvoicingFieldDisabled}
                                                  disabled={tmInvoicingFieldDisabled}
                                                  isUploading={isUploading}
                                                  showProductLabels={true}
                                                  sx={tmInvoicingUploadDisabledSx}
                                                  // error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                                                />
                                                </Box>
                                              {/* </>
                                            )} */}
                                            </>)
                    }




                        {/* <LabelStyle>Skills or services required</LabelStyle> */}
                        {/* //for client */}
                         {
                        userType !==3 ?
                        
                        <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          {/* <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={skills}
                          value={values.skills}
                          onChange={(event, newValue) => setFieldValue('skills', newValue)}
                          renderInput={(params) => (
                            <TextField {...params} label="Skills or services required" />
                          )}
                          getOptionLabel={(option) => option.name}
                        /> */}
                          <Autocomplete
                            sx={{ width: '50%' }}
                            id="combo-box-demo"
                            disabled={ tmInvoicingFieldDisabled}
                            // disabled={details?.checkProjectExist ? true : false}
                            options={allClientsEdit}
                            value={values.clients}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setFieldValue('clients', newValue);
                                setFieldValue('community', null);
                                setSalesRepName('');
                                setSalesRepId(null);
                                setSalesRepOptions([]);
                                fetchAllCommunityByClient(newValue);
                              } else {
                                setFieldValue('clients', null);
                                setSalesRepName('');
                                setSalesRepId(null);
                                setFieldValue('community', null);
                                setCommunities([]);
                                setSalesRepOptions([]);
                              }
                            }}

                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Clients"
                                error={Boolean(touched.clients && errors.clients)}
                                helperText={touched.clients && errors.clients} />
                            )}
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      width: 40,
                                      justifyContent: 'center',
                                    }}
                                  >
                                    {option?.syncWithQuickBook === 1 && (
                                      <img
                                        src={quickbookLogo}
                                        width="40px"
                                        height="20px"
                                        alt="QuickBooks"
                                      />
                                    )}
                                  </div>
                                  <span
                                    style={{
                                      flex: 1,
                                      minWidth: 0,
                                      display: 'block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {option?.name}
                                  </span>
                                </li>
                              );
                            }}
                          />
                          {isCommunityLoading ?
                              <Stack flexDirection={'row'} alignItems='center' justifyContent='center'>
                                <CircularProgress color="primary" variant="indeterminate" />
                                <Typography variant='body2'>Loading projects...</Typography>
                              </Stack> :
                          communities.length > 0 ? (<Autocomplete
                            sx={{ width: '50%' }}
                            id="community"
                            options={
                              [...(communities || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                            }
                            disabled={tmInvoicingFieldDisabled}
                            value={values.community}
                            onChange={(event, newValue) => {
                              if(newValue){
                              setFieldValue('community', newValue)
                              // Sales reps dropdown: populate all sales reps for selected project
                              const matchedCommunity = communities?.find(
                                (community) => community?.id === newValue?.id
                              );
                              setCollaborators([])
                              const repOptions = getSalesRepOptionsFromCommunity(matchedCommunity);
                              console.log('repOptions',repOptions)
                              setSalesRepOptions(repOptions);
                              // Reset sales rep to null when project is changed
                              setSalesRepName('');
                              setSalesRepId(null);
                              setAllSalesRepIds('');
                              if (newValue.address || newValue.city || newValue.state || newValue.zip) {
                                const { address, city, state, zip } = newValue;
                        
                                // 3) Update selected products’ addresses
                                // setSelectedProducts((prevProducts) =>
                                //   prevProducts.map((product) => {
                                //     if (product?.fromMapServices == true) {
                                //       return product;
                                //     }else{
                                //       const updatedAddresses = product?.location.map((loc) => ({
                                //         ...loc,
                                //         address: address || loc.address,
                                //         city: city || loc.city,
                                //         state: state || loc.state,
                                //         zip: zip || loc.zip,
                                //       }));
                                //       return { ...product, location: updatedAddresses ,is_single_card: true,allLocationSame: true};
                                //     }
                                //   })
                                // );
                                setSelectedProducts((prevProducts) =>
                                  prevProducts.map((product) => {
                                   if (product?.fromMapServices == true) {
                                     return product;
                                   }else{
                                     // For split orders, ensure proper address population
                                     if (isSplitOrder) {
                                       // For split orders, create proper locations based on quantity
                                       const locationQuantity = product.locationQuantity || product.quantity || 1;
                                       const updatedAddresses = Array.from({ length: locationQuantity }, () => ({
                                         id: 0,
                                         address: address,
                                         city: city,
                                         state: state,
                                         zip: zip,
                                       }));
                                       return { ...product, location: updatedAddresses ,is_single_card: true,allLocationSame: true };
                                     } else {
                                       // For normal orders, use existing logic
                                       const updatedAddresses = product.location?.map((loc) => ({
                                         ...loc,
                                         address: address || loc.address,
                                         city: city || loc.city,
                                         state: state || loc.state,
                                         zip: zip || loc.zip,
                                       }))
                                       return { ...product, location: updatedAddresses ,is_single_card: true,allLocationSame: true };
                                     }
                                   }
                                  })
                                );


                                console.log("cartServicecartServicecartService",selectedProducts)
                                // 4) Update selected services’ addresses (if applicable)
                                setAdditionalSelectedServices((prevServices) =>
                                  prevServices.map((service) => {
                                    const updatedAddresses = service.addresses.map((loc) => ({
                                      ...loc,
                                      address: address || loc.address,
                                      city: city || loc.city,
                                      state: state || loc.state,
                                      zip: zip || loc.zip,
                                    }));
                                    return { ...service, addresses: updatedAddresses };
                                  })
                                );


                                // 5) Update RFP Products’ addresses
                                

                                setCart((prevCart) =>
                                  prevCart.map((product) => {
                                    const updatedAddresses = (product.location).map((loc) => ({
                                      ...loc,
                                      address: address || loc.address,
                                      city: city || loc.city,
                                      state: state || loc.state,
                                      zip: zip || loc.zip,
                                    }));
                                    return { ...product, location: updatedAddresses };
                                  })
                                );

                                  // 6) Update RFP Services’ addresses (only for 'Service only' category)
                                  //  if (values.project_category?.name === 'Service only') {
                                    // console.log("cartServicecartServicecartService",cartService)
                                    setCartService((prevServices) =>
                                      prevServices?.map((service) => {
                                        const updatedAddresses = (service?.location|| []).map((loc) => ({
                                          ...loc,
                                          address: address || loc.address,
                                          city: city || loc.city,
                                          state: state || loc.state,
                                          zip: zip || loc.zip,
                                        }));
                                        return { ...service, location: updatedAddresses };
                                      })
                                    );
                                  // }
                                }
                              if(newValue.tax_category){
                              let taxCat = taxCategories?.find(cat => newValue.tax_category === cat.id)
                              setSelectedTaxCategory(taxCat)
                              }
                            }else {
                              setFieldValue('community', null);
                              setSalesRepName('');
                              setSalesRepId(null);
                              setSelectedTaxCategory(null);
                            }
                            }}
                            renderInput={(params) => (
                              <Tooltip
                                title={values.community ? formatProjectAddress(values.community) : ''}
                              >
                                <TextField required
                                  {...params} label="Project"
                                  error={Boolean(touched.community && errors.community)}
                                  helperText={touched.community && errors.community} />
                              </Tooltip>
                            )}
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Tooltip title={formatProjectAddress(option)}>
                                    <span
                                      style={{
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'block',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {option?.name || ''}
                                      </span>
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option?.name || ''}</span>
                                </li>
                              );
                            }}
                          />) : (
                            <Stack sx={{ width: '50%' }} justifyContent={'center'}>
                              {values?.clients ?
                                <Typography sx={{ color: "red" }}>The selected client does not have any projects yet. Please create a new project for them!</Typography>
                                : <Typography sx={{ color: "red" }}>No client selected. Please choose a client from the list.</Typography>}
                            </Stack>
                          )
                        }
                        </Stack>
                        {salesRepOptions?.length > 0 && (
                          <Stack sx={{ width: '100%' }}>
                            <Autocomplete
                              id="sales-rep"
                              disabled={tmInvoicingFieldDisabled}
                              options={salesRepOptions}
                              value={
                                salesRepOptions.find((opt) => {
                                  if (salesRepId != null && opt?.id != null) {
                                    return String(opt.id) === String(salesRepId);
                                  }
                                  return salesRepName && opt?.name === salesRepName;
                                }) || null
                              }
                              onChange={(event, newValue) => {
                                console.log('newValuenewValuenewValuenewValue',newValue)
                                setSalesRepName(newValue?.name || '');
                                setSalesRepId(newValue?.id || null);
                                
                                // Update allSalesRepIds when field value changes
                                if (newValue?.id) {
                                  setAllSalesRepIds(String(newValue.id));
                                } else {
                                  setAllSalesRepIds('');
                                }
                              }}
                              isOptionEqualToValue={(option, value) =>
                                (option?.id != null && value?.id != null && String(option.id) === String(value.id)) ||
                                option?.name === value?.name
                              }
                              getOptionLabel={(option) => option?.name || ''}
                              renderInput={(params) => (
                                <TextField {...params} label="Sales Rep" fullWidth />
                              )}
                            />
                          </Stack>
                        )}
  
                        { /* Collaborators multiselect (same as OfficialRequestAdd) */ }
                        {/* {(values.community?.id != null && values.community?.sales_rep_names != null) &&( */}
                        <Stack sx={{ width: '100%' }}>
                          <Autocomplete
                            multiple
                            id="collaborators"
                            disabled={tmInvoicingFieldDisabled}
                            options={collaboratorOptions}
                            value={collaborators}
                            onChange={(event, newValue) => setCollaborators(newValue || [])}
                            loading={teamMembersLoading}
                            isOptionEqualToValue={(option, value) =>
                              String(option?.user_id || option?.id) ===
                              String(value?.user_id || value?.id)
                            }
                            getOptionLabel={(option) => {
                              if (!option) return '';
                              const name = option.name || [option.first_name, option.last_name].filter(Boolean).join(' ').trim();
                              return name || String(option.id || '');
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Collaborators"
                                fullWidth
                                placeholder={tmInvoicingFieldDisabled || collaborators?.length > 0 ? '' : 'Select Collaborators'}
                                InputProps={{
                                  ...params.InputProps,
                                  readOnly: tmInvoicingFieldDisabled,
                                }}
                              />
                            )}
                          />
                        </Stack>
                        {/* )} */}
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          {shouldHideJobClassDropdown ? (
                            <TextField
                              fullWidth
                              required
                              id="combo-box-demo-type"
                              label="Job Class"
                              value={
                                values.project_type?.name ?? ''
                              }
                              disabled={tmInvoicingFieldDisabled}
                              InputProps={
                                details?.allInstallationCompleted == 1
                                  ? undefined
                                  : { readOnly: true }
                              }
                              error={Boolean(
                                touched.project_type && errors.project_type,
                              )}
                              helperText={
                                touched.project_type && errors.project_type
                              }
                            />
                          ) : (
                            <Autocomplete
                              fullWidth
                              id="combo-box-demo-type"
                              disabled={tmInvoicingFieldDisabled}
                              options={projectTypes}
                              value={values.project_type}
                              onChange={(event, newValue) => {
                                setFieldValue('project_type', newValue)
                                setFieldValue('project_category', null)
                                setFieldValue('map_service', null)
                                if (newValue?.name !== 'TS') {
                                  setFieldValue('map_service', null)
                                  const filteredProducts = selectedProducts?.filter(product => product?.fromMapServices !== true);
                                  setSelectedProducts(filteredProducts);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="Job Class"
                                  error={Boolean(touched.project_type && errors.project_type)}
                                  helperText={touched.project_type && errors.project_type} />
                              )}
                              getOptionLabel={(option) => option.name}

                            />
                          )}

                          {/* <Autocomplete
                            fullWidth
                            disabled
                            id="combo-box-demo-type"
                            options={markupTypes}
                            value={values.markup_type}
                            onChange={(event, newValue) => {
                              setFieldValue('markup_type', newValue)
                              setMarkupType(newValue?.id)
                            }}
                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Markup Type"
                                error={Boolean(touched.markup_type && errors.markup_type)}
                                helperText={touched.markup_type && errors.markup_type} />
                            )}
                            getOptionLabel={(option) => option.name}
                          /> */}
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            // fullWidth
                            sx={{ width: '50%' }}
                            id="combo-box-demo-category"
                            // options={projectCategories}
                            // options={(values.project_type?.name == 'TS') ? projectCategories : projectCategories?.filter(ite=>ite.id != 14)}
                            options={
                              details?.allInstallationCompleted == 1 ? projectCategories?.filter((ite) => ite.id != 12 && ite.id != 14) :
                              (isSplitOrder || details?.is_split_order) ? projectCategories?.filter((ite) => ite.id !== 15 && ite.id != 14) :
                              values.project_type?.name == 'TS'
                                ? projectCategories
                                : projectCategories?.filter((ite) => ite.id != 14)
                            }
                            value={values.project_category}
                            disabled={tmInvoicingFieldDisabled}
                            onChange={(event, newValue) => {
                              const isSwitchingFromTM =
                                values.project_category?.name === "Time & Material" &&
                                newValue?.name !== "Time & Material";

                              if (isSwitchingFromTM && selectedProducts?.length > 0) {
                                setPendingJobType(newValue);
                                setOpenChangeJobTypeDialog(true);
                                return; // STOP → wait for dialog confirmation
                              }
                              handleJobTypeChange(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Job Type"
                                error={Boolean(touched.project_category && errors.project_category)}
                                helperText={touched.project_category && errors.project_category} />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                            
                          {values.project_category?.id == 14 ? 
                            <Autocomplete
                              // fullWidth
                              sx={{ width: '50%' }}
                              id="combo-box-demo-type"
                              options={mapServices}
                              value={values.map_service}
                              onChange={(event, newValue) => {
                                console.log('map_service==newValue', newValue)
                                setFieldValue('map_service', newValue)
                                if (newValue?.products) {
                                  let newIndexCounter = indexCounter;
                                  const updatedProductsWithLocations = newValue?.products?.map((product,index) => {
                                    const filteredData = allProducts?.find((i) => i.id === product.product_id);
                                    const associatedLocations = newValue?.locations
                                      .filter((location) => location?.route_product_id === product?.id)
                                      .map((location) => ({
                                        address: location.address,
                                        city: location.city,
                                        state: location.state,
                                        zip: location.zip,
                                        route_location_id: location.id,
                                      }));
                                      newIndexCounter += 1;
                                    return {
                                      ...product,
                                      ...filteredData,
                                      indexId: newIndexCounter, // `map_${index}`,
                                      fromMapServices:true,
                                      locationQuantity: product?.qty,
                                      location: associatedLocations,
                                      discount: 0,
                                      adjustment: 0,
                                      quantity: 1,
                                      markAdjType:2
                                    };
                                  });
                                  console.log('updatedProductsWithLocations-----------',updatedProductsWithLocations)
                                  const mergedSelectedProducts = [
                                    ...selectedProducts.filter((product) => product?.fromMapServices !== true), // Keep existing products without fromMapServices
                                    ...updatedProductsWithLocations, // Add the new products from map services
                                  ];
                                  setSelectedMapserviceProducts(updatedProductsWithLocations);
                                  setSelectedProducts(mergedSelectedProducts);
                                  setIndexCounter(newIndexCounter);
                                  const productServices = mergedSelectedProducts?.reduce((services, product) => {
                                    if (product.services && product.services.length > 0) {
                                      return services.concat(
                                        product.services.map((service) => ({
                                          ...service,
                                          fromMapServices:product?.fromMapServices || false,
                                          productIndex: product?.indexId,
                                          quantity: service.quantity * product.quantity * product.locationQuantity,
                                          previousQty: service.quantity,
                                          qtyData: product.quantity,
                                          locationQuantity: product.locationQuantity,
                                        }))
                                      );
                                    }
                                    return services;
                                  }, []);
                                  setSelectedServices(productServices);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="Routes"
                                  error={Boolean(touched.map_service && errors.map_service)}
                                  helperText={touched.map_service && errors.map_service} />
                              )}
                              // getOptionLabel={(option) => option.name}
                              getOptionLabel={(option) => `${option.name} (${option.locations_count})`}
                            /> 
                          : '' }

                          {values.project_category?.id  == 15 ? (
                              <Autocomplete
                                // fullWidth
                                sx={{ width: '50%' }}
                                id="combo-box-demo-type"
                                options={catalogTypes}
                                value={values.catalog_type}
                                onChange={(event, newValue) => {
                                  setFieldValue('catalog_type', newValue)
                                  setFieldValue('products', [])
                                  setSelectedProducts([])
                                  setSelectedServices([])
                                  console.log('newValue=======', newValue)
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    label="Catalog"
                                    error={Boolean(
                                      touched.catalog_type && errors.catalog_type,
                                    )}
                                    helperText={
                                      touched.catalog_type && errors.catalog_type
                                    }
                                  />
                                )}
                                getOptionLabel={(option) => option.label}
                              />
                            ) : (
                              ''
                            )}

                          {values?.project_category?.id===13 &&
                            <Autocomplete
                              // fullWidth
                              sx={{ width: '50%' }}
                              id="combo-box-demo-type"
                              options={noChargeType}
                              value={values.no_charge_type}
                              onChange={(event, newValue) => {
                                setFieldValue('no_charge_type', newValue)
                                // setMarkupType(newValue?.id)
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="No charge Type"
                                  error={Boolean(touched.no_charge_type && errors.no_charge_type)}
                                  helperText={touched.no_charge_type && errors.no_charge_type} />
                              )}
                              getOptionLabel={(option) => option.name}
                            />}
                        </Stack>
                        {(values?.project_category?.id == 13 || values?.project_category == 13) && (
                          <Stack sx={{ width: '100%' }}>
                            <TextField
                              fullWidth
                              id="no_charge_reason"
                              name="no_charge_reason"
                              label="No charge reason"
                              placeholder="Reason for no charge"
                              value={values.no_charge_reason ?? ''}
                              onChange={(e) => setFieldValue('no_charge_reason', e.target.value)}
                              multiline
                              minRows={3}
                            />
                          </Stack>
                        )}
                        {/* <Stack>
                      <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={workflow}
                          value={values.workflow}
                          onChange={(event, newValue) => setFieldValue('workflow', newValue)}
                          renderInput={(params) => (
                            <TextField {...params} label="Workflow" />
                          )}
                          getOptionLabel={(option) => option.name}

                          />
                      </Stack> */}
                      </>
                      :""}

                  {
                    isSplitOrder ? (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Autocomplete
                          sx={{ width: '50%' }}
                          id="split-type-autocomplete"
                          options={[{ id: 1, label: 'Split' }]}
                          disabled={isSplitOrder}
                          value={values.is_split || null}
                              onChange={(event, newValue) => {
                                setFieldValue('is_split', newValue);
                                // Update isSplitOrder based on the form field value
                                setIsSplitOrder(!!newValue);
                                
                                // If split order is enabled, set default facility
                                if (newValue) {
                                  const defaultFacility = FacilityTypes?.filter(fac => fac.default);
                                  setFieldValue('facility_type', defaultFacility || []);
                                } else {
                                  // If split order is disabled, clear facility_type
                                  setFieldValue('facility_type', []);
                                }
                          }}
                          getOptionLabel={(option) => option?.label ?? ''}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Choose Split Type"
                              placeholder="Select split type"
                              error={Boolean(touched.is_split && errors.is_split)}
                              helperText={touched.is_split && errors.is_split}
                            />
                          )}
                        />

                        {
                          isSplitOrder ?(
                          
                            <Autocomplete
                            multiple
                            disableCloseOnSelect
                            filterSelectedOptions
                            sx={{ width: '50%' }}
                            id="combo-box-demo-type"
                            options={FacilityTypes || []}
                            value={values.facility_type || []}   
                            onChange={(event, newValue) => {
                              setFieldValue('facility_type', newValue);
                              let filteredVaue = newValue.find(v => !v.default )
                              const selectedData = (Array.isArray(filteredVaue) ? filteredVaue : [filteredVaue]) .map(v => {
                                const id = typeof v === 'object' ? v?.id : v;
                                return splitManagementSettings?.find(s => String(s?.id) === String(id));
                              })
                              .filter(Boolean);

                              setSelectedSplitOrderSettings(selectedData)
                            }}
                            getOptionLabel={(option) => option?.label ?? ''}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderTags={(selected, getTagProps) =>
                              selected.map((option, index) => (
                                <Chip
                                  key={option?.id ?? option?.label ?? index}
                                  label={option?.label}
                                  size="small"
                                  color={option?.color}//"primary"
                                  variant="outlined"
                                  {...getTagProps({ index })} // handles delete icon
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Choose Facility"
                                placeholder="Select facilities"
                                error={Boolean(touched.facility_type && errors.facility_type)}
                                helperText={touched.facility_type && errors.facility_type}
                              />
                            )}
                          />
                          )
                          :""
                        }

                        </Stack>
                    )
                      : ''
                    }

                        <Stack data-tm-editable direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Box
                            component={MobileDatePicker}
                            label="Start Date"
                            // minDate={moment()}
                            defaultValue={formatDateOnly(values.start)}
                            value={dateOnlyMoment(values.start)}
                            onChange={(date) => {
                              const newStartUnix = dateOnlyToUnix(date);
                              setFieldValue('start', newStartUnix);
                              applyInstallationFromStartAndLead(newStartUnix);
                            }}
                            renderInput={(params) => (
                              <TextField size="small" {...params} fullWidth />
                            )}
                          />

                          <Box
                            component={MobileDatePicker}
                            label="Installation Date"
                            minDate={dateOnlyMoment(values.start)}
                            // defaultValue={formatDateOnly(values.end)}
                            value={values.end ? dateOnlyMoment(values.end) : null}
                            onChange={(date) => {
                              setFieldValue('end', dateOnlyToUnix(date));
                              // Clear installation start/end dates when single date is selected
                              setFieldValue('installation_start_date', null);
                              setFieldValue('installation_end_date', null);
                            }}
                            renderInput={(params) => (
                              <TextField size="small" {...params} fullWidth
                                error={Boolean(touched.end && errors.end)}
                                helperText={touched.end && errors.end}
                              />
                            )}
                          />
                        </Stack>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 1, fontStyle: 'italic' }}>
                          Choose either single installation date above OR installation date range below
                        </Typography>
                        <Stack data-tm-editable direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                          <Box
                            component={MobileDatePicker}
                            minDate={dateOnlyMoment(values.start)}
                            label="Installation Start Date"
                            value={values.installation_start_date ? dateOnlyMoment(values.installation_start_date) : null}
                            onChange={(date) => {
                              const ux = dateOnlyToUnix(date);
                              setFieldValue('installation_start_date', ux);
                              setFieldValue('end', null);
                              applyLeadTimeInstallPatch(ux);
                            }}
                            renderInput={(params) => (
                              <TextField 
                                size="small" 
                                {...params} 
                                fullWidth
                                error={Boolean(touched.installation_start_date && errors.installation_start_date)}
                                helperText={touched.installation_start_date && errors.installation_start_date}
                              />
                            )}
                          />
                          <Box
                            component={MobileDatePicker}
                            minDate={values.installation_start_date ? dateOnlyMoment(values.installation_start_date) : dateOnlyMoment(values.start)}
                            label="Installation End Date"
                            value={values.installation_end_date ? dateOnlyMoment(values.installation_end_date) : null}
                            onChange={(date) => {
                              setFieldValue('installation_end_date', dateOnlyToUnix(date));
                              // Clear single installation date when range is selected
                              setFieldValue('end', null);
                            }}
                            renderInput={(params) => (
                              <TextField 
                                size="small" 
                                {...params} 
                                fullWidth
                                error={Boolean(touched.installation_end_date && errors.installation_end_date)}
                                helperText={touched.installation_end_date && errors.installation_end_date}
                              />
                            )}
                          />
                        </Stack>

              {/* //for client */}
                       {
                        userType !==3 ?
                        
                        <>
                        {values.project_category?.name == 'Service only old' || values.project_category?.name == 'Time & Material' || values.project_category?.name == 'Service only'  ? '' : <>
                        <Divider />
                        <LabelStyleHead>Products</LabelStyleHead>
                        {false ? 
                        // {values.project_category?.name == 'Time & Material' ? 
                        <>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 500 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {VALUE_TIME?.map((val) => (
                                    val.id === 14 ? (
                                      <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip>) :
                                    <TableCell key={val.id}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedProducts?.sort((a, b) => a.indexId - b.indexId)?.map((data, index) => {
                                  console.log("edit product log ---",data)
                                  const quantityFieldName = `quantity_${data.product_id || data.id}`;
                                  const discountFieldName = `discount_${data.product_id || data.id}`;
                                  const adjustmentFieldName = `adjustment_${data.product_id || data.id}`;

                                  let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                  unitName = unitName[0]?.name
                                  let shortUnitName = ''
                                  if (unitName == 'Square feet') {
                                    shortUnitName = 'Sq ft'
                                  } else if (unitName == 'Lineal feet') {
                                    shortUnitName = 'Lin ft'
                                  } else if (unitName == 'Square Inches') {
                                    shortUnitName = 'Sq Inches'
                                  } else if (unitName == 'Unit') {
                                    shortUnitName = 'Unit'
                                  }
                                  data['expected_cost'] = data.expected_cost || 0
                                  data['expected_material_cost'] = data.expected_material_cost || 0
                                  data['expected_service_cost'] = data.expected_service_cost || 0
                                  data['expected_total_service_cost'] = data.expected_total_service_cost || 0
                                  const dataPrice = data.price ? data.price : 0
                                  const dataretailPrice = data.retail_price ? data.retail_price : 0
                                  const dataWholesalePrice = data.price ? data.price : 0
                                  // const dataQuantity = values[quantityFieldName]
                                  const dataQuantity = data.quantity || 1
                                  console.log('data.discount--', data.discount);
                                  const dataDiscount = data.discount ? data.discount : 0

                                  const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? dataretailPrice : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType,0,data?.adj_value_type);
                                  // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                  const invoiceAmount = parseFloat(data?.expected_material_cost) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                  console.log("rowTotal---------", rowTotal)
                                  
                                  data['markup'] = 0
                                  totalMarkup += 0
                                  data['markup_type'] = markupType
                                  data['totalMarkup'] = totalMarkup?.toFixed(2)
                                  
                                  // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                  productFormulaCost += parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity

                                  const pfc = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity // total product formula cost
                                  const rtp = dataretailPrice * data.quantity * data.locationQuantity // total retail price
                                  const wsp = dataWholesalePrice * data.quantity * data.locationQuantity // total wholesale price

                                  const maxDiscount_wholesale = wsp - pfc
                                  const maxDiscount_retail = rtp - pfc

                                  // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                  // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                  console.log('dataWholesalePrice--', dataWholesalePrice);
                                  console.log('dataretailPrice--', dataretailPrice);
                                  console.log('maxDiscount_wholesale--', maxDiscount_wholesale);
                                  console.log('maxDiscount_retail--', maxDiscount_retail);
                                  console.log('DiscountTotal--', DiscountTotal);
                                  console.log('pfc--', pfc);
                                  console.log('rtp--', rtp);
                                  console.log('wsp--', wsp);
                                  data['product_total']=Number(rowTotal)
                                  data['retail_price']=Number(dataretailPrice)
                                  data['price']=Number(dataPrice)
                                  data['product_id']=null

                                  let SPMA = 0
                                  if(markupType){
                                    if(markupType == 1){
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataPrice) || 0) + (data.adjustment ? Number(data.adjustment) : 0)
                                      }else{
                                        SPMA = (dataPrice ? Number(dataPrice) : 0) + (((dataPrice ? Number(dataPrice) : 0) * (data.adjustment ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }else{
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataretailPrice) || 0) + (dataretailPrice ? Number(data.adjustment) : 0)
                                      }else{
                                        SPMA = (dataretailPrice ? Number(dataretailPrice) : 0) + (((dataretailPrice ? Number(dataretailPrice) : 0) * (dataretailPrice ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }
                                  }
                                  console.log('SPMA-----data.price-----',dataPrice)
                                  console.log('SPMA-----data.adjustment-----',data.adjustment)
                                  console.log('SPMA-----data.retail_price-----',dataretailPrice)
                                  console.log('SPMA-----SPMA-----SPMA',SPMA)

                                  SPMA = Number(SPMA)
                                  data['SPMA'] = SPMA?.toFixed(2)

                                  return (
                                    <>
                                      <TableRow
                                        key={index}
                                        onDragEnterCapture={(e) => handleProductIconDragOver(e, data.indexId)}
                                        onDragOverCapture={(e) => handleProductIconDragOver(e, data.indexId)}
                                        onDragLeave={(e) => handleProductIconDragLeave(e, data.indexId)}
                                        onDropCapture={(e) => handleProductIconDrop(e, data.indexId)}
                                        sx={{
                                          ...(productAttachmentDragOver[data.indexId] && {
                                            backgroundColor: 'action.hover',
                                            outline: `2px dashed ${theme.palette.primary.main}`,
                                            outlineOffset: -2,
                                          }),
                                        }}
                                      >
                                        <TableCell>#{data.indexId}</TableCell>
                                        <TableCell>
                                          {/* albin */}
                                        {/* <TextField required
                                            fullWidth
                                            type='text'
                                            label={'Product Name'}
                                            sx={{ width: 85 }}
                                            value={data.product_name || data.name}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue !== "") {
                                                setSelectedProducts(pv => ([...pv.map(p => {
                                                  if (p.indexId === data.indexId) {
                                                    return {
                                                      ...p,
                                                      name: newValue,
                                                    }
                                                  } else {
                                                    return p;
                                                  }
                                                })]));
                                                data['name'] = newValue || '';
                                              }
                                            }}
                                            // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          /> */}

                                          {/* ram */}

                                          <TextField
                                            required
                                            fullWidth
                                            type="text"
                                            label="Product Name"
                                            sx={{ width: 85 }}
                                            value={data.product_name || ''} // Controlled component with default to empty string
                                            onChange={(event) => {
                                              const newValue = event.target.value;

                                              // Update the selected product's name based on its indexId
                                              setSelectedProducts((prevProducts) =>
                                                prevProducts.map((product) => {
                                                  if (product.indexId === data.indexId) {
                                                    return {
                                                      ...product,
                                                      product_name: newValue, // Update the product_name with newValue
                                                    };
                                                  }
                                                  return product;
                                                })
                                              );
                                              data['product_name'] = newValue || '';
                                              if (isSubmitted) setIsSubmitted(false);
                                            }}
                                            error={isSubmitted && (!data.product_name?.trim())}
                                            helperText={isSubmitted && (!data.product_name?.trim()) ? 'Product Name is required' : ''}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <IconButton onClick={() => handleOpenNote(data.indexId, data.product_notes)}>
                                            <NoteAdd
                                              sx={{
                                                color: (!data?.product_notes || data?.product_notes === '') ? '' : theme.palette.primary.main,
                                              }}
                                            />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell>
                                          <Tooltip title="Drop files on row or click to open attachments">
                                            <IconButton onClick={() => handleOpenAttachment(data.indexId)}>
                                              {isUploadingProduct[data.indexId] ? (
                                                <CircularProgress size={34} />
                                              ) : (
                                                <UploadFile
                                                  sx={{
                                                    color:
                                                      !productAttachments[data.indexId] ||
                                                      productAttachments[data.indexId]?.length === 0
                                                        ? 'error.main'
                                                        : theme.palette
                                                            .primary.main,
                                                  }}
                                                />
                                              )}
                                            </IconButton>
                                          </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                          <TextField required
                                            fullWidth
                                            type='number'
                                            label={'Retail Price Each'}
                                            sx={{ width: 85 }}
                                            // disabled={(values.project_category?.name == 'Time & Material') ? true : false}
                                            value={roundMoneyValue(data.actual_retail_price || data.retail_price || data.price)}
                                            defaultValue={0}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              console.log('Selling Price newValue',newValue)
                                              if (newValue !== "") {
                                                setSelectedProducts(pv => ([...pv.map(p => {
                                                  console.log('Selling Price---data',data.indexId)
                                                  console.log('Selling Price---p',p.indexId)
                                                  if (p.indexId === data.indexId) {
                                                    return {
                                                      ...p,
                                                      retail_price: Number(newValue),
                                                      price: Number(newValue),
                                                      product_retail_price : Number(newValue),
                                                      product_price : Number(newValue),
                                                    }
                                                  } else {
                                                    return p;
                                                  }
                                                })]));
                                                data['retail_price'] = Number(newValue) || 0;
                                                data['product_retail_price'] = Number(newValue) || 0;
                                                data['price'] = Number(newValue) || 0;
                                                data['product_price'] = Number(newValue) || 0;
                                              }
                                            }}
                                            // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        {/* <TableCell>{hasMarkupPermission ? (data.SPMA || null) : null}</TableCell> */}
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            label={shortUnitName}
                                            disabled={shortUnitName == 'Unit' ? true : false}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data.quantity ? data.quantity : 1}
                                            value={data.quantity ? data.quantity : 1}
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}

                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                // if (p.id === data.id) {
                                                if (p.indexId === data.indexId) {


                                                  return {
                                                    ...p,
                                                    quantity: newValue,
                                                    // location: arrayAddr
                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              console.log("###############SElected services", selectedServices);
                                              setSelectedServices(pv => ([...pv.map(service => {
                                                // if (service.product_id === data.id && service.prQty) {
                                                console.log('data---new----', data);
                                                console.log('service---new----', service);
                                                if (service.productIndex === data.indexId && service.prQty) {
                                                  return {
                                                    ...service,
                                                    quantity: (service.prQty * (newValue) * (service?.locationQuantity || 1)).toFixed(2),
                                                    qtyData: Number(newValue),
                                                  };
                                                } else {
                                                  return {
                                                    ...service,

                                                  }
                                                }
                                              })]));
                                              
                                              data['quantity'] = newValue || 1;

                                              setFieldValue(quantityFieldName, newValue);
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            label={"Qty"}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data.locationQuantity ? data.locationQuantity : 1}
                                            value={data.locationQuantity ? data.locationQuantity : 1}
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}
                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                // if (p.id === data.id) {
                                                if (p.indexId === data.indexId) {

                                                  let arrayAddr

                                                  const commonAddresses = (data?.allLocationSame && pv.length > 0) ? p.location[0] : null;
                                                  console.log("Hifiiiiiiiiiiiiii Aff", commonAddresses);
                                                  if (data?.allLocationSame && commonAddresses) {
                                                    arrayAddr = Array(Number(newValue)).fill().map((_, i) => ({ //1
                                                      ...commonAddresses,
                                                      id: i,
                                                      req_loc_id: p.location[i]?.req_loc_id ?? null,
                                                    }));

                                                  }
                                                  else {
                                                    arrayAddr = [...p.location]
                                                    console.log("Hifiiiiiiiiiiiiii Aff", arrayAddr);
                                                    if (p.location.length <= Number(newValue)) { //1
                                                      arrayAddr.push(...[...Array(Number(newValue) - p.location.length)].map((a, i) => { //1
                                                        return {
                                                          id: p.location.length + i,
                                                          address: '',
                                                          city: '',
                                                          state: '',
                                                          zip: '',
                                                        }
                                                      }))
                                                    }
                                                    else if (p.location.length > Number(newValue)) { //1
                                                      arrayAddr = arrayAddr.slice(0, Number(newValue)); //1
                                                    }
                                                    else {
                                                      arrayAddr = arrayAddr.slice(0, -(p.location.length - (newValue)));
                                                    }
                                                  }

                                                  return {
                                                    ...p,
                                                    // quantity:newValue,
                                                    locationQuantity: newValue,
                                                    location: arrayAddr
                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              setSelectedServices(pv => ([...pv.map(service => {
                                                console.log("############@@@@@@@@@@service", service);
                                                console.log("############@@@@@@@@@@data", data);
                                                if (service.productIndex === data.indexId && service.prQty) {
                                                  console.log("############service.newValue", newValue);
                                                  return {
                                                    ...service,
                                                    quantity: (newValue * (service.qtyData || 1) * service.prQty).toFixed(2),
                                                    locationQuantity: newValue,
                                                  };
                                                } else {
                                                  return {
                                                    ...service,

                                                  }
                                                }
                                              })]));
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <IconButton
                                            onClick={() => {
                                              setLocationStates({ ...locationStates, [data.indexId]: true });
                                            }}
                                          >
                                            <LocationOn sx={{
                                              color: data.location.some(obj =>
                                                [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                              ) ? '' : theme.palette.primary.main
                                            }} />
                                          </IconButton>
                                        </TableCell>
                                        
                                        <TableCell>
                                          {rowTotal.toFixed(2)}
                                        </TableCell>
                                        <TableCell >
                                          <IconButton disabled={tmInvoicingFieldDisabled} onClick={() => handleDeleteProduct(data.id || data.product_id, data.indexId)}>
                                            <Delete />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                      <Modal
                                        open={locationStates[data.indexId]}
                                        handleClose={() => {
                                          setLocationStates({ ...locationStates, [data.indexId]: false });
                                        }}
                                      >
                                        <FormControlLabel
                                          disabled={tmInvoicingFieldDisabled}
                                          sx={tmInvoicingReadOnlyCursorSx}
                                          control={
                                            <Switch
                                              checked={data?.allLocationSame}
                                              disabled={tmInvoicingFieldDisabled}
                                              onChange={()=>handleAllLocationSameChange(index)}
                                            />
                                          }
                                          label="All Locations Same"
                                        />
                                        <Box component="fieldset" disabled={tmInvoicingFieldDisabled} sx={{ border: 'none', m: 0, p: 0, minWidth: 0, ...tmInvoicingReadOnlyCursorSx }}>
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                          {data.location.map((addr, i) => (
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Location
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="Address"
                                                  size="small"
                                                  value={data.location[i].address || ''}
                                                  disabled={(i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].address = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              address: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              address: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                              </Stack>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="City"
                                                  size="small"
                                                  value={data.location[i].city || ''}
                                                  disabled={(i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].city = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              city: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              city: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="State"
                                                  size="small"
                                                  value={data.location[i].state || ''}
                                                  disabled={(i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].state = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              state: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              state: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="Zip / Postal Code"
                                                  size="small"
                                                  value={data.location[i].zip || ''}
                                                  disabled={(i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].zip = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              zip: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              zip: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          ))}
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                          {/* {(i !== 0 && data?.allLocationSame) ? '' : */}
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton variant="contained" onClick={() => {
                                                setIsSaving(true)
                                                setTimeout(() => {
                                                  setIsSaving(false)
                                                  setLocationStates(false)
                                                }, 100)
                                              }} loading={isSaving} disabled={tmInvoicingFieldDisabled}>
                                                {' Save '}
                                              </LoadingButton>
                                            </Box>
                                            {/* } */}
                                          </Grid>
                                        </Grid>
                                        </Box>
                                      </Modal>
                                      <Modal
                                        open={openProductNote[data.indexId] || false}
                                        handleClose={() => handleCloseNote(data.indexId)}
                                      >
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Note
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={handleNoteChange}
                                                  error={!currentNote.trim() && currentNote.length > 0}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={
                                                    !currentNote.trim() && currentNote.length > 0
                                                      ? 'Note cannot be empty or contain only spaces'
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                />
                                              </Stack>
                                            </Grid>
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton
                                                variant="contained"
                                                onClick={() => handleSaveNote(data.indexId)}
                                                loading={isSavingNote}
                                                disabled={!currentNote.trim()}>
                                                Save
                                              </LoadingButton>
                                              <LoadingButton
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleClearNote(data.indexId)}
                                                loading={isClearingNote}
                                                disabled={!currentNote.trim()}>
                                                Clear
                                              </LoadingButton>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                      <Modal
                                        open={openInstallNote[data.indexId] || false}
                                        handleClose={() => handleCloseInstallNote(data.indexId)}
                                      >
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Install Note
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={handleNoteChange}
                                                  error={!currentNote.trim() && currentNote.length > 0}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={
                                                    !currentNote.trim() && currentNote.length > 0
                                                      ? 'Note cannot be empty or contain only spaces'
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                />
                                              </Stack>
                                            </Grid>
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton
                                                variant="contained"
                                                onClick={() => handleSaveInstallNote(data.indexId)}
                                                loading={isSavingNote}
                                                disabled={!currentNote.trim()}>
                                                Save
                                              </LoadingButton>
                                              <LoadingButton
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleClearInstallNote(data.indexId)}
                                                loading={isClearingNote}
                                                disabled={!currentNote.trim()}>
                                                Clear
                                              </LoadingButton>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                      <Modal
                                        open={
                                          openProductAttachment[data.indexId] ||
                                          false
                                        }
                                        handleClose={() =>
                                          handleCloseAttachment(data.indexId)
                                        }
                                      >
                                        {renderAttachmentModalContent({
                                          itemKey: String(data.indexId),
                                          tabValue: attachmentTabValue[data.indexId],
                                          onTabChange: handleAttachmentTabChange,
                                          selectedImages:
                                            selectedUploadedImages[String(data.indexId)] ||
                                            selectedUploadedImages[data.indexId] ||
                                            [],
                                          linkedAttachments: getProductAttachmentsList(data.indexId),
                                          onImageSelect: handleImageSelect,
                                          onAddSelected: handleAddSelectedImages,
                                          onDrop: handleProductDrop,
                                          onRemove: handleProductRemove,
                                          isUploadingItem: isUploadingProduct[data.indexId] || false,
                                          disabled: tmInvoicingFieldDisabled,
                                        })}
                                      </Modal>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        <Stack sx={{ justifyContent:'center' }}>
                        {/* <Box sx={{ justifyContent:'center' }}>
                          <Button variant="outlined" startIcon={ <Stack> <Add /> </Stack> }
                          onClick={()=>{
                            addNewProductRow()
                            // setMarkupType(1)
                          }}>Add Product Row</Button>
                        </Box> */}
                        </Stack>
                        </>
                        : <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                          {isSplitOrder && (values?.facility_type || []).filter(Boolean).length > 1 ? (
                            <Stack sx={{ width: '60%' }} spacing={2}>
                              {(values?.facility_type || []).filter(Boolean).map((facility) => (
                                <Autocomplete
                                  key={`product-autocomplete-${facility?.id}`}
                                  sx={{ width: '100%' }}
                                  multiple
                                  disableCloseOnSelect
                                  clearOnBlur={false}
                                  inputValue={facilityProductInputs[String(facility?.id)] ?? ''}
                                  onInputChange={(event, newInputValue, reason) => {
                                    const fid = String(facility?.id);
                                    if (reason === 'reset' && newInputValue === '') {
                                      return;
                                    }
                                    setFacilityProductInputs((prev) => ({
                                      ...prev,
                                      [fid]: newInputValue,
                                    }));
                                  }}
                                  id={`combo-box-demo-${facility?.id}`}
                                  options={filteredProductOptions?.filter((opt) => Number(opt?.facility_id) === Number(facility?.id))}
                                  disabled={tmInvoicingFieldDisabled}
                                  value={productAutocompleteDisplayValueForFacility(facility?.id)}
                                  onChange={(event, newValue) => {
                                    const regularSelectedProducts =
                                      selectedProducts?.filter(
                                        (item) => item?.fromMapServices != true && !item.isAdditionalProduct,
                                      ) || [];
                                    const otherFacilities =
                                      regularSelectedProducts?.filter(
                                        (p) => Number(p?.facility_id) !== Number(facility?.id),
                                      ) || [];
                                    const expanded = expandAutocompleteValueToMainProducts(newValue, selectedProducts);
                                    const updated = [...otherFacilities, ...(expanded || [])].map((item) => ({
                                      ...item,
                                      is_single_card: values.project_category?.id !== 14 ? true : false,
                                    }));
                                    handleProduct(updated);
                                    setFieldValue('products', updated);
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label={`Select a product - ${facility?.label || ''}`} />
                                  )}
                                  renderOption={(props, option) => {
                                    const { style, ...liProps } = props;
                                    const description = option.description;
                                    const Name = option.name;
                                    const suffix = catalogSuffixForProductOption(option);
                                    return (
                                      <li
                                        {...liProps}
                                        style={{
                                          ...style,
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: 40,
                                            justifyContent: 'center',
                                          }}
                                        >
                                          {option?.syncWithQuickbooks === 1 && (
                                            <img
                                              src={quickbookLogo}
                                              width="40px"
                                              height="20px"
                                              alt="QuickBooks"
                                            />
                                          )}
                                        </div>
                                        <Tooltip title={`${description} ${suffix}`}>
                                          <span
                                            style={{
                                              flex: 1,
                                              minWidth: 0,
                                              display: 'block',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              color: isSplitOrder
                                                ? theme.palette[
                                                    FacilityTypes.find((f) => f.id === option?.facility_id)?.color ||
                                                      'primary'
                                                  ]?.main
                                                : 'inherit',
                                            }}
                                          >
                                            {`${Name} ${suffix}`}
                                          </span>
                                        </Tooltip>
                                        <span style={{ display: 'none' }}>{option.name}</span>
                                      </li>
                                    );
                                  }}
                                  isOptionEqualToValue={() => false}
                                  getOptionLabel={(option) => {
                                    if (option?.isGroupAutocompleteChip) {
                                      const name = getCatalogAutocompleteDisplayName(
                                        option,
                                        customerOrderProductGroups,
                                      );
                                      const suffix = catalogSuffixForProductOption(option);
                                      return `${name} ${suffix}`;
                                    }
                                    const name = option.product_name || option.name || '';
                                    const description = option.description || option.name || '';
                                    const suffix = catalogSuffixForProductOption(option);
                                    return `${description} ${suffix} \u200B${name}`;
                                  }}
                                  filterOptions={(options, { inputValue }) => {
                                    const fid = String(facility?.id);
                                    const raw = facilityProductInputs[fid] ?? inputValue ?? '';
                                    const searchText = raw.toString().trim().toLowerCase();
                                    if (!searchText) return options;
                                    return options.filter((option) => {
                                      const nameMatch = option.name?.toLowerCase().includes(searchText);
                                      const descMatch = option.description?.toLowerCase().includes(searchText);
                                      const idMatch = String(option.id)?.includes(searchText);
                                      const tagsMatch = String(option.tags ?? '').toLowerCase().includes(searchText);
                                      return nameMatch || descMatch || idMatch || tagsMatch;
                                    });
                                  }}
                                  renderTags={(value, getTagProps) =>
                                    value.map((option, index) => {
                                      const name = getCatalogAutocompleteDisplayName(
                                        option,
                                        customerOrderProductGroups,
                                      );
                                      const suffix = catalogSuffixForProductOption(option);
                                      const tip = getCatalogAutocompleteTooltip(
                                        option,
                                        suffix,
                                        customerOrderProductGroups,
                                      );
                                      return (
                                        <Tooltip
                                          key={
                                            option?.isGroupAutocompleteChip
                                              ? `grp-chip-${option.group_id}`
                                              : `prod-chip-${option.indexId ?? index}`
                                          }
                                          title={tip}
                                        >
                                          <Chip
                                            sx={{
                                              color: isSplitOrder
                                                ? theme.palette[
                                                    FacilityTypes.find((f) => f.id === option?.facility_id)?.color ||
                                                      'primary'
                                                  ]?.main
                                                : 'inherit',
                                            }}
                                            {...getTagProps({ index })}
                                            label={`${name} ${suffix}`}
                                          />
                                        </Tooltip>
                                      );
                                    })
                                  }
                                />
                              ))}
                            </Stack>
                          ) : (
                            <Autocomplete
                              key={`product-autocomplete-${isSplitOrder}-${values?.facility_type?.length || 0}-${filteredProductOptions?.length || 0}`}
                              sx={{ width: '60%' }}
                              multiple
                              id="combo-box-demo"
                              options={filteredProductOptions}
                              disabled={tmInvoicingFieldDisabled}
                              value={productAutocompleteDisplayValue}
                              onChange={(event, newValue) => {
                                const expanded = expandAutocompleteValueToMainProducts(newValue, selectedProducts);
                                const updated = expanded.map((item) => ({
                                  ...item,
                                  is_single_card: values.project_category?.id !== 14 ? true : false,
                                }));
                                handleProduct(updated);
                                setFieldValue('products', updated);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Select a product" />
                              )}
                              renderOption={(props, option) => {
                                const { style, ...liProps } = props;
                                const description = option.description;
                                const Name = option.name;
                                const suffix = catalogSuffixForProductOption(option);
                                return (
                                  <li
                                    {...liProps}
                                    style={{
                                      ...style,
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: 40,
                                        justifyContent: 'center',
                                      }}
                                    >
                                      {option?.syncWithQuickbooks === 1 && (
                                        <img
                                          src={quickbookLogo}
                                          width="40px"
                                          height="20px"
                                          alt="QuickBooks"
                                        />
                                      )}
                                    </div>
                                    <Tooltip title={`${description} ${suffix}`}>
                                      <span
                                        style={{
                                          flex: 1,
                                          minWidth: 0,
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          color: isSplitOrder
                                            ? theme.palette[
                                                FacilityTypes.find((f) => f.id === option?.facility_id)?.color ||
                                                  'primary'
                                              ]?.main
                                            : 'inherit',
                                        }}
                                      >
                                        {`${Name} ${suffix}`}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </li>
                                );
                              }}
                              isOptionEqualToValue={() => false}
                              getOptionLabel={(option) => {
                                if (option?.isGroupAutocompleteChip) {
                                  const name = getCatalogAutocompleteDisplayName(
                                    option,
                                    customerOrderProductGroups,
                                  );
                                  const suffix = catalogSuffixForProductOption(option);
                                  return `${name} ${suffix}`;
                                }
                                const name = option.product_name || option.name || '';
                                const description = option.description || option.name || '';
                                const suffix = catalogSuffixForProductOption(option);
                                return `${description} ${suffix} \u200B${name}`;
                              }}
                              onInputChange={(event, newInputValue, reason) => {
                                productInputValueRef.current = newInputValue || '';
                                if (reason === 'input') {
                                  // keep ref in sync for filterOptions (production builds)
                                }
                              }}
                              filterOptions={(options, { inputValue }) => {
                                const currentInput =
                                  productInputValueRef.current ||
                                  (inputValue !== undefined && inputValue !== null ? inputValue : '');
                                const searchText = (currentInput || '').toString().trim().toLowerCase();
                                if (!searchText) return options;
                                return options.filter((option) => {
                                  const nameMatch = option.name?.toLowerCase().includes(searchText);
                                  const descMatch = option.description?.toLowerCase().includes(searchText);
                                  const tagsMatch = String(option.tags ?? '').toLowerCase().includes(searchText);
                                  const idMatch = String(option.id)?.includes(searchText);
                                  return nameMatch || descMatch || idMatch || tagsMatch;
                                });
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const name = getCatalogAutocompleteDisplayName(
                                    option,
                                    customerOrderProductGroups,
                                  );
                                  const suffix = catalogSuffixForProductOption(option);
                                  const tip = getCatalogAutocompleteTooltip(
                                    option,
                                    suffix,
                                    customerOrderProductGroups,
                                  );
                                  return (
                                    <Tooltip
                                      key={
                                        option?.isGroupAutocompleteChip
                                          ? `grp-chip-${option.group_id}`
                                          : `prod-chip-${option.indexId ?? index}`
                                      }
                                      title={tip}
                                    >
                                      <Chip
                                        sx={{
                                          color: isSplitOrder
                                            ? theme.palette[
                                                FacilityTypes.find((f) => f.id === option?.facility_id)?.color ||
                                                  'primary'
                                              ]?.main
                                            : 'inherit',
                                        }}
                                        {...getTagProps({ index })}
                                        label={`${name} ${suffix}`}
                                      />
                                    </Tooltip>
                                  );
                                })
                              }
                            />
                          )}
                          {/* Split Order Catalog Type Autocomplete - Only visible for split orders */}
                          {isSplitOrder ? (
                            <Autocomplete
                              sx={{ width: '40%' }}
                              id="split-catalog-type"
                              options={[...splitOrderCatalogTypes]
                                // ✅ filter only when Service Only
                                .filter(type =>
                                  values?.project_category?.id === 11
                                    ? (
                                        type.id === 'all' ||
                                        type.id === 'client_owned' ||
                                        type.id === 'traffic'
                                      )
                                    : true
                                )
                                // ✅ keep your existing sort
                                .sort((a, b) => {
                                  if (a.id === 'all') return -1;
                                  if (b.id === 'all') return 1;
                                  return a.label.localeCompare(b.label);
                                })
                              }
                              value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                              onChange={(event, newValue) => {
                                const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                setFieldValue('split_catalog_type', finalValue)
                                console.log('Split catalog type changed:', finalValue)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Catalog Type"
                                  placeholder="Select catalog type"
                                />
                              )}
                              getOptionLabel={(option) => option.label}
                            />
                          ):
                          (() => {
                            // Hide Catalog Type field when project category is Build Order (id 15)
                            const categoryId = values?.project_category?.id;
                            const isBuildOrder = categoryId === 15;
                            const isServiceOnly = categoryId === 11;

                            // Don't show Catalog Type for Build Order
                            if (isBuildOrder) {
                              return null;
                            }

                            // For Service Only: show only All, Client Owned, and Traffic
                            if (isServiceOnly) {
                              const serviceOnlyCatalogTypes = splitOrderCatalogTypes
                                .filter(type => type.id === 'all' || type.id === 'client_owned' || type.id === 'traffic')
                                .sort((a, b) => {
                                  // Keep "All" at the top, then sort rest alphabetically
                                  if (a.id === 'all') return -1;
                                  if (b.id === 'all') return 1;
                                  return a.label.localeCompare(b.label);
                                });

                              return (
                                <Autocomplete
                                  sx={{ width: '50%' }}
                                  id="normal-catalog-type"
                                  options={serviceOnlyCatalogTypes}
                                  value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                  onChange={(event, newValue) => {
                                    const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                    setFieldValue('split_catalog_type', finalValue)
                                    console.log('Service Only catalog type changed:', finalValue)
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Catalog Type"
                                      placeholder="Select catalog type"
                                    />
                                  )}
                                  getOptionLabel={(option) => option.label}
                                />
                              );
                            }

                            // For normal orders: remove split_catalog, add sub_contract (keep production_catalog)
                            const filteredCatalogTypes = splitOrderCatalogTypes
                              .filter(type => type.id !== 'split_catalog')
                              .concat([{ id: 'sub_contract', label: 'Sub Contract', inhouse: 0, isTrafficCatalog: false }])
                              .sort((a, b) => {
                                // Keep "All" at the top, then sort rest alphabetically
                                if (a.id === 'all') return -1;
                                if (b.id === 'all') return 1;
                                return a.label.localeCompare(b.label);
                              });
                            
                            return (
                              <Autocomplete
                                sx={{ width: '50%' }}
                                id="normal-catalog-type"
                                options={filteredCatalogTypes}
                                value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                onChange={(event, newValue) => {
                                  const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                  setFieldValue('split_catalog_type', finalValue)
                                  console.log('Normal catalog type changed:', finalValue)
                                  // Trigger product filtering by updating a dependency
                                  // The filteredProductOptions will react to values.split_catalog_type change
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Catalog Type"
                                    placeholder="Select catalog type"
                                  />
                                )}
                                getOptionLabel={(option) => option.label}
                              />
                            );
                          })()}
                        </Stack>
                        <LabelStyle>Selected Products </LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 500 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {editFormValuesEnabled && (
                                    <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  )}
                                  {visibleOfficialRequestProductColumns?.map((val) =>
                                    val.id === 10 ? (
                                      <Tooltip key={val.id} title="Product Formula Cost Per Unit * Quantity">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip>
                                    ) : val.id === 14 ? (
                                      <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip>
                                    ) : (
                                      <TableCell key={val.id}>{val.value}</TableCell>
                                    ),
                                  )}
                                  {/* {VALUE?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))} */}
                                </TableRow>
                              </TableHead>
                              <DragDropContext onDragEnd={handleProductTableDragEnd}>
                                <Droppable droppableId="view-official-request-product-rows" isDropDisabled={!editFormValuesEnabled}>
                                  {(droppableProvided) => (
                              <TableBody
                                ref={droppableProvided.innerRef}
                                {...droppableProvided.droppableProps}
                              >
                                {(() => {
                                  const renderOfficialRequestSalesOrderProductRow = (data, index, rowOptions = {}) => {
                                  console.log('data-----', data)
                                  // Sl No follows productTableBodyRenderOrder (groups + ungrouped products share one sequence).
                                  const displaySlNo = index + 1
                                  const quantityFieldName = `quantity_${data.product_id || data.id}`;
                                  const discountFieldName = `discount_${data.product_id || data.id}`;
                                  const adjustmentFieldName = `adjustment_${data.product_id || data.id}`;

                                  let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                  unitName = unitName[0]?.name
                                  let shortUnitName = ''
                                  if (unitName == 'Square feet') {
                                    shortUnitName = 'Sq ft'
                                  } else if (unitName == 'Lineal feet') {
                                    shortUnitName = 'Lin ft'
                                  } else if (unitName == 'Square Inches') {
                                    shortUnitName = 'Sq Inches'
                                  } else if (unitName == 'Unit') {
                                    shortUnitName = 'Unit'
                                  }

                                  // ALL-815 backup - previous catalog price reset without retail_price_edited guard:
                                  // if((data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)) && !isSplitOrder){
                                  if((data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)) && !isSplitOrder && !data.retail_price_edited){
                                    let price = data.max_price ? data.max_price : data.actual_retail_price
                                    const installCost = parseFloat(data?.install_cost) || 0
                                    const installQty = (data?.install_quantity == null && data?.install_cost) ? 1 : Number(data?.install_quantity ?? 0)
                                    data['actual_retail_price'] = price
                                    const calculatedRetailPrice = (installCost > 0 && installQty > 0) ? price + installCost : price
                                    data['retail_price'] = calculatedRetailPrice
                                  }

                                  if(isSplitOrder && data?.facility_id !== currentFacilityId && !details?.for_parent_facility){
                                    const splitSetting = selectedSplitOrderSettings?.find(setting => setting?.id == data?.facility_id);
                                    let outgoingPercentage = data?.split_percentage || splitSetting?.split_percentage || 0;
                                    let incomingPercentage = data?.incoming_split_percentage || incomingSplitMarkup || 0;
                                    if (!data.originalExpectedCost) {
                                     data.originalExpectedCost = Number(data?.expected_cost)
                                   }
                                   
                                   let amountWithOutgoingPercentage = data.originalExpectedCost * (outgoingPercentage / 100)
                                   const calculatedExpectedCost = data.originalExpectedCost + amountWithOutgoingPercentage
                                   data.expected_cost = Number(calculatedExpectedCost.toFixed(2))
                                   console.log('data.expected_costtttttt', data.expected_cost)
                                   console.log('data.originalExpectedCosttttttt', data.originalExpectedCost)
                                   let amountWithIncomingPercentage = data.expected_cost * (incomingPercentage / 100)
                                   console.log('amountWithIncomingPercentageeee', amountWithIncomingPercentage)
                                   const calculatedActualRetailPrice = data.expected_cost + amountWithIncomingPercentage
                                   data['actual_retail_price'] = Number(calculatedActualRetailPrice.toFixed(2))
                                   const calculatedRetailPrice = (Number(data?.install_quantity) > 0) ? data.actual_retail_price + (data?.install_cost || 0) : data.actual_retail_price
                                   data['retail_price'] = Number(calculatedRetailPrice.toFixed(2))
                                   console.log('data?.actual_retail_priceee', data?.actual_retail_price)
                                   console.log('data?.retail_priceee', data?.retail_price)
                                   // data['retail_price'] =data?.originalExpectedCost + data?.install_cost
                                   data['incoming_split_percentage'] =incomingPercentage || 0
                                   data['split_percentage'] =outgoingPercentage || 0
                                   data['outgoing_split_percentage'] =outgoingPercentage || 0
                                   }else if(isSplitOrder && data?.facility_id == currentFacilityId && details?.for_parent_facility){
                                    // Don't set install_cost to null, preserve the original value
                                    // data['install_cost'] =null
                                    data['retail_price'] =data?.expected_cost
                                    data['actual_retail_price'] =data?.expected_cost
                                    data['expected_cost'] =data?.expected_cost
                                   }
                                  
                                  // Apply no charge logic similar to OfficialRequestAdd.js
                                  if(isNoChargeJob && data.inhouse !==0 && data.facility_id == currentFacilityId){
                                    const baseInstallCost = parseFloat(data?.expected_install_labor_cost) || 0
                                    const installAdj = parseFloat(data?.install_adjustment) || 0
                                    const signedInstallAdj = data?.install_adj_value_type === false ? -installAdj : installAdj
                                    const backupAdjustment = data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)
                                    const backupActualRetail = data.product_retail_price ?? data.actual_retail_price
                                    const backupOriginalActualRetail = backupActualRetail != null ? Number(backupActualRetail) - backupAdjustment : data.original_actual_retail_price
                                    const backupInstallCost = parseFloat(data?.original_install_cost ?? data?.install_cost) || 0
                                    const backupInstallQty = Number(data?.install_quantity) || 1
                                    const backupProdQty = Number(data?.quantity) || 1
                                    const backupInstallEach = backupProdQty > 0 ? (backupInstallCost * (backupInstallQty / backupProdQty)) : backupInstallCost
                                    data.expected_cost_before_no_charge = data.expected_cost_before_no_charge ?? data.expected_cost
                                    data.retail_price_before_no_charge = data.retail_price_before_no_charge ?? ((backupOriginalActualRetail != null ? backupOriginalActualRetail + backupInstallEach + backupAdjustment : data.retail_price))
                                    data.actual_retail_price_before_no_charge = data.actual_retail_price_before_no_charge ?? (backupActualRetail ?? data.actual_retail_price)
                                    data.product_retail_price_before_no_charge = data.product_retail_price_before_no_charge ?? (backupActualRetail ?? data.product_retail_price)
                                    data.price_before_no_charge = data.price_before_no_charge ?? data.price
                                    data.original_actual_retail_price_before_no_charge = data.original_actual_retail_price_before_no_charge ?? backupOriginalActualRetail
                                    data.original_retail_price_before_no_charge = data.original_retail_price_before_no_charge ?? ((backupOriginalActualRetail != null ? backupOriginalActualRetail + backupInstallEach : data.original_retail_price))
                                    data.original_price_before_no_charge = data.original_price_before_no_charge ?? data.original_price
                                    data.install_cost_before_no_charge = data.install_cost_before_no_charge ?? data.install_cost
                                    data.original_install_cost_before_no_charge = data.original_install_cost_before_no_charge ?? data.original_install_cost
                                    data.install_cost = Math.max(0, baseInstallCost + signedInstallAdj)
                                    data.original_install_cost = baseInstallCost
                                    // const expectedCost = parseFloat(data?.expected_cost) || 0
                                    const expectedCost = (parseFloat(data?.expected_service_cost) || 0) + (parseFloat(data?.expected_material_cost) || 0);
                                    const installCost = parseFloat(data?.install_cost) || 0
                                    const calculatedRetailPrice = installCost > 0 ? expectedCost + installCost : expectedCost
                                    data['retail_price'] = calculatedRetailPrice
                                    data['actual_retail_price'] = expectedCost
                                    data['expected_cost'] = expectedCost
                                    data['original_actual_retail_price'] = expectedCost
                                    data['original_retail_price'] = calculatedRetailPrice
                                    data['original_product_retail_price'] = expectedCost
                                  }
                                  // ALL-815 backup - previous install recalc without install_price_edited guard:
                                  // }else{
                                  // this  is  hide becaus the install price is not showing in the edit page 
                                  // else if(!data.install_price_edited){
                                  //   // Apply install adjustment calculation similar to OfficialRequestAdd.js
                                  //   const baseInstallCost = parseFloat(data?.original_install_cost) || 0
                                  //   const installAdj = parseFloat(data?.install_adjustment) || 0
                                  //   const signedInstallAdj = isNegativeAdjustmentMode(data?.install_adj_value_type) ? -installAdj : installAdj
                                  //   console.log('signedInstallAdj', signedInstallAdj)
                                  //   console.log('signedInstallAdj', data?.install_adj_value_type)
                                  //   data.install_cost = baseInstallCost ? Math.max(0, baseInstallCost + signedInstallAdj) : null
                                  // }

                                  if(data.adj_value_type == null){
                                    data.adj_value_type =true
                                   }

                                  if (
                                    data.original_actual_retail_price == null &&
                                    data.original_product_retail_price == null
                                  ) {
                                    Object.assign(
                                      data,
                                      hydrateEstimateLineMarketingPrices(data, {
                                        variant: 'view_official_request',
                                      }),
                                    )
                                  }
                                  const signedProductAdj = getSignedMarketingAdjustment(data)
                                  const signedInstallAdj = getSignedInstallMarketingAdjustment(data)

                                  const dataPrice = data.price
                                  const dataretailPrice = data.product_retail_price || data.retail_price
                                  const dataActualRetail = data.original_actual_retail_price != null
                                    ? data.original_actual_retail_price + signedProductAdj
                                    : (data.actual_retail_price ?? data.retail_price ?? 0)
                                  const dataWholesalePrice = data.product_price || data.price
                                  console.log('dataretailPrice---------', dataretailPrice)
                                  console.log('dataPrice---------', dataPrice)
                                  console.log('dataActualRetail---------', dataActualRetail)
                                  console.log('dataWholesalePrice---------', dataWholesalePrice)
                                  console.log('markupType---------', markupType)
                                  // const dataQuantity = values[quantityFieldName]
                                  const dataQuantity = data.quantity || 1
                                  console.log('data.discount--', data.discount);
                                  const dataDiscount = data.discount ? data.discount : 0
                                  const productCost = data.actual_retail_price ? data.actual_retail_price * data.locationQuantity : data.retail_price * data.locationQuantity
                                  let persentageSplit = data?.split_percentage || splitPercentage
                                  let incomingPercentage = data?.incoming_split_percentage || incomingSplitMarkup
                                  const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? (data.install_cost && parseFloat(data.install_cost) > 0 ? dataretailPrice : dataActualRetail) : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType,persentageSplit,data.adj_value_type);
                                  const locQtyForLineTotal = Number(data?.locationQuantity) || 1
                                  const installQtyForLineTotal = Number(data?.install_quantity) || 1
                                  const discountForLineTotal =
                                    Number(values[discountFieldName]) || Number(dataDiscount) || 0
                                  const lineProductSubTotal =
                                    markupType == 1
                                      ? (Number(data?.price) || 0) * locQtyForLineTotal
                                      : markupType == 2
                                      ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQtyForLineTotal
                                      : 0
                                  const lineInstallSubTotal =
                                    (Number(data?.install_cost) || 0) * installQtyForLineTotal
                                  const lineProductTotal = Math.max(
                                    0,
                                    lineProductSubTotal + lineInstallSubTotal - discountForLineTotal,
                                  )
                                  console.log('rowTotal------', rowTotal)
                                  // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                  const invoiceAmount = parseFloat(data?.expected_material_cost) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                  // let markup = markupType ? (invoiceAmount / rowTotal) : null

                                  let markup = markupType == 1 ? (((dataWholesalePrice - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100)
                                    : (markupType == 2 ? (((dataretailPrice - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100) : 0);
                                  markup = markup ? Number(markup) : 0
                                  if (isNoChargeJob) markup = 0
                                  data['markup'] = markup
                                  let markupData = data.product_markup?.toFixed(2) || data.markup?.toFixed(2)
                                  markupData = Number(markupData) * data.quantity
                                  data['markup'] = markupData
                                  totalMarkup += Number(data.product_markup) || Number(data.markup) || 0
                                  data['markup_type'] = markupType
                                  data['totalMarkup'] = totalMarkup?.toFixed(2)
                                  let originalMarkup = markupType == 1 ? data.wholesaleMarkup : markupType == 2 ? data.retailMarkup : 0
                                  originaltotalMarkup += originalMarkup
                                  // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                  productFormulaCost += parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity

                                  const pfc = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity // total product formula cost
                                  const rtp = dataretailPrice * data.quantity * data.locationQuantity // total retail price
                                  const wsp = dataWholesalePrice * data.quantity * data.locationQuantity // total wholesale price

                                  const maxDiscount_wholesale = wsp - pfc
                                  const maxDiscount_retail = rtp - pfc

                                  // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                  // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                  console.log('maxDiscount_wholesale--', maxDiscount_wholesale);
                                  console.log('maxDiscount_retail--', maxDiscount_retail);
                                  console.log('DiscountTotal--', DiscountTotal);
                                  console.log('pfc--', pfc);
                                  console.log('rtp--', rtp);
                                  console.log('wsp--', wsp);
                                  data['product_total']=lineProductTotal

                                  let SPMA = 0
                                  if(markupType){
                                    if(markupType == 1){
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataPrice) || 0) + (data.adjustment ? Number(data.adjustment) : 0)
                                      }else{

                                        SPMA = (Number(dataPrice) || 0) + (((Number(dataPrice) || 0) * (data.adjustment ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }else{
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataretailPrice) || 0) + (dataretailPrice ? Number(data.adjustment) : 0)
                                      }else{

                                        SPMA = (Number(dataretailPrice) || 0) + (((Number(dataretailPrice) || 0) * (dataretailPrice ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }
                                  }
                                  console.log('SPMA-----markupType-----',markupType,data.markAdjType)
                                  console.log('SPMA-----data.price-----',dataPrice)
                                  console.log('SPMA-----data.adjustment-----',data.adjustment)
                                  console.log('SPMA-----data.retail_price-----',dataretailPrice)
                                  console.log('SPMA-----SPMA-----',SPMA)
                                  SPMA = Number(SPMA)
                                  data['SPMA'] = SPMA?.toFixed(2)

                                  console.log(
                                    'location-colour---',data.location,
                                    data.location.some(obj =>
                                      [obj.address, obj.city, obj.state, obj.zip]?.some(value => value === '' || value === null)
                                    )
                                  );

                                  const locationSameProductIndex = (() => {
                                    const i = selectedProducts.findIndex(
                                      (x) => Number(x?.indexId) === Number(data.indexId),
                                    )
                                    return i >= 0 ? i : index
                                  })() 
                                  const productFormulaEach =
                                    data?.inhouse === 0
                                      ? Number(data?.sub_contract_price || 0)
                                      : Number(
                                          (data?.expected_material_cost_with_markup ||
                                            0) +
                                            (data?.expected_service_cost_with_markup ||
                                              0),
                                        )
                                  const hasNegativeRetailPermission =
                                    explodedPermissions?.some((permission) =>
                                      [
                                        'Allow Negative Marketing Adjustment Sales Order',
                                      ].includes(permission),
                                    )
                                  const retailPriceMin = hasNegativeRetailPermission
                                    ? 0.01
                                    : Math.max(0.01, productFormulaEach)
                                  const productRetailEach = Math.max(
                                    0,
                                    Number(
                                      data?.actual_retail_price ??
                                        data?.retail_price ??
                                        data?.product_retail_price ??
                                        0,
                                    ),
                                  )
                                  const isNegativeProductAdjustmentMode =
                                    data?.adj_value_type === false ||
                                    data?.adj_value_type === 0 ||
                                    data?.adj_value_type === '0' ||
                                    data?.adj_value_type === 'false'
                                  const isProductLosingMoney =
                                    isNegativeProductAdjustmentMode &&
                                    productRetailEach < productFormulaEach

                                  const installFormulaEach = Number(
                                    data?.expected_install_labor_cost_with_markup ||
                                      0,
                                  )
                                  const installRetailEach = Math.max(
                                    0,
                                    Number(data?.install_cost || 0),
                                  )
                                  const isNegativeInstallAdjustmentMode =
                                    data?.install_adj_value_type === false ||
                                    data?.install_adj_value_type === 0 ||
                                    data?.install_adj_value_type === '0' ||
                                    data?.install_adj_value_type === 'false'
                                  const isInstallLosingMoney =
                                    installRetailEach > 0 &&
                                    isNegativeInstallAdjustmentMode &&
                                    installRetailEach < installFormulaEach

                                  const isLosingMoneyItem =
                                    isProductLosingMoney ||
                                    isInstallLosingMoney

                                  const losingMoneyRowSx = getLosingMoneyRowSx(isLosingMoneyItem)

                                  return (
                                    <>
                                      {!rowOptions?.modalsOnly && (
                                      <Draggable
                                      key={`product-${data.indexId}`}
                                      draggableId={`product-${data.indexId}`}
                                      index={index}
                                      isDragDisabled={!editFormValuesEnabled}
                                    >
                                      {(provided, snapshot) => (
                                    <>
                                      <TableRow
                                        key={`main-${data.indexId}`}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        onDragEnterCapture={(e) => handleProductIconDragOver(e, data.indexId)}
                                        onDragOverCapture={(e) => handleProductIconDragOver(e, data.indexId)}
                                        onDragLeave={(e) => handleProductIconDragLeave(e, data.indexId)}
                                        onDropCapture={(e) => handleProductIconDrop(e, data.indexId)}
                                        sx={{
                                          ...losingMoneyRowSx,
                                          ...(productAttachmentDragOver[data.indexId] && {
                                            backgroundColor: 'action.hover',
                                            outline: `2px dashed ${theme.palette.primary.main}`,
                                            outlineOffset: -2,
                                          }),
                                        }}
                                        style={{
                                          ...provided.draggableProps.style,
                                          ...(snapshot.isDragging
                                            ? { backgroundColor: theme.palette.action.hover }
                                            : {}),
                                        }}
                                      >
                                        {editFormValuesEnabled && (
                                          <TableCell
                                            padding="checkbox"
                                            {...provided.dragHandleProps}
                                            sx={{ width: 40, cursor: 'grab' }}
                                          >
                                            <DragIndicator fontSize="small" color="action" />
                                          </TableCell>
                                        )}
                                      {/* <TableRow key={`main-${data.indexId}`} sx={losingMoneyRowSx} sx={rowOptions?.groupRowSx}> */}
                                        <TableCell>#{displaySlNo}</TableCell>
                                        <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                        <TableCell>{data?.isAdditionalProduct ?
                                          <TextField
                                            required
                                            fullWidth
                                            type="text"
                                            label={'Product Name'}
                                            sx={{ width: 85 }}
                                            value={data.product_name ?? data.name ?? ''}
                                            onChange={(event) => {
                                              let newValue =
                                                event.target.value

                                              // Update the selectedProducts state
                                              setSelectedProducts(
                                                (prevProducts) =>
                                                  prevProducts.map(
                                                    (product) => {
                                                      if (
                                                        product.indexId ===
                                                        data.indexId
                                                      ) {
                                                        return {
                                                          ...product,
                                                          name: newValue,
                                                          product_name: newValue,
                                                        }
                                                      } else {
                                                        return product
                                                      }
                                                    },
                                                  ),
                                              )
                                              data['name'] = newValue || ''
                                              data['product_name'] = newValue || ''
                                              if (isSubmitted)
                                                setIsSubmitted(false)
                                            }}
                                            error={
                                              isSubmitted && !data.name?.trim() && !data.product_name?.trim()
                                            }
                                            helperText={
                                              isSubmitted && !data.name?.trim() && !data.product_name?.trim()
                                                ? 'Product Name is required'
                                                : ''
                                            }                                            
                                          />
                                        :
                                   <Box>
                                         <Typography >{data.product_name || data.name}</Typography>
                                      { data.product_notes ?  <Typography sx={{color:isSplitOrder ? theme.palette[
                                          FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                        ]?.main
                                      : (data.product_notes ? theme.palette.error.main : 'inherit') }}> Note:{data.product_notes}</Typography> :" "}
                                   </Box>
                                      }
                                        </TableCell>
                                        <TableCell>
                                          <IconButton onClick={() => handleOpenNote(data.indexId, data.product_notes)}>
                                            <NoteAdd
                                              sx={{
                                                color: (!data?.product_notes || data?.product_notes === '') ? '' : theme.palette.primary.main,
                                              }}
                                            />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell>
                                          <Tooltip title="Drop files on row or click to open attachments">
                                            <IconButton onClick={() => handleOpenAttachment(data.indexId)}>
                                              {isUploadingProduct[data.indexId] ? (
                                                <CircularProgress size={34} />
                                              ) : (
                                                <UploadFile
                                                  sx={{
                                                    color:
                                                      !productAttachments[data.indexId] ||
                                                      productAttachments[data.indexId]?.length === 0
                                                        ? 'error.main'
                                                        : theme.palette
                                                            .primary.main,
                                                  }}
                                                />
                                              )}
                                            </IconButton>
                                          </Tooltip>
                                        </TableCell>
                                        <TableCell align="center">
                                          {canShowProductFormulaIcon(data, currentFacilityId) ? (
                                            <IconButton size="small" onClick={() => handleOpenProductFormula(data.recipe_id)}>
                                              <span class="heroicons-solid--beaker"></span>
                                            </IconButton>
                                          ) : '-'}
                                        </TableCell>
                                        <Tooltip 
                                               title={
                                                (isSplitOrder && 
                                                 data.facility_id != currentFacilityId) 
                                                  ? ''
                                                  // (
                                                  //     <>
                                                  //       {`${data?.originalExpectedCost} + ${data?.originalExpectedCost} * (${data?.outgoing_split_percentage} / 100) = ${parseFloat(data?.expected_cost * data.locationQuantity)?.toFixed(2)}`}
                                                  //       <br />
                                                  //       {"Expected Cost + (Expected Cost * Outgoing Percentage / 100)"}
                                                  //     </>
                                                  //     <>
                                                  //     {`(${data?.outgoing_split_percentage} % Outgoing Percentage Included with Expected Cost ${data?.expected_cost}`}
                                                  //     </>
                                                  //   ) 
                                                  : ""
                                              }
                                              >
                                        {/* <TableCell>{data?.isAdditionalProduct ? 'N/A' : (data.inhouse === 0 ? '0.00' : (parseFloat(data.expected_cost || 0) * data.quantity * data.locationQuantity).toFixed(2))}</TableCell> */}
                                        <TableCell>
                                          {data?.isAdditionalProduct
                                            ? 'N/A'
                                            : data?.product_formula_cost_each != null &&
                                              data?.product_formula_cost_each !== ''
                                            ? Number(data.product_formula_cost_each).toFixed(2)
                                            : (data.inhouse === 0
                                                ? data?.sub_contract_price?.toFixed(2) || '0.00'
                                                : 
                                                // (
                                                //     parseFloat(data.formula_cost ?? data.expected_cost ?? 0) *
                                                //     (data.quantity || 1) *
                                                //     (data.locationQuantity || 1)
                                                isSplitOrder && data?.facility_id !== currentFacilityId ?
                                                (data?.expected_cost || 0)?.toFixed(2)
                                                 :
                                                ((data?.expected_material_cost_with_markup || 0) + (data?.expected_service_cost_with_markup || 0))?.toFixed(2)

                                                // : isSplitOrder && data?.facility_id !== currentFacilityId
                                                //   ? Math.max(
                                                //       0,
                                                //       (data?.expected_cost || 0) -
                                                //         (data?.expected_install_labor_cost_with_markup || 0),
                                                //     ).toFixed(2)
                                                //   : Math.max(
                                                //       0,
                                                //       (data?.expected_material_cost_with_markup || 0) +
                                                //         (data?.expected_service_cost_with_markup || 0) -
                                                //         (data?.expected_install_labor_cost_with_markup || 0),
                                                //     ).toFixed(2)
                                              )
                                          }
                                        </TableCell>
                                        </Tooltip>
                                        {/* Incoming Percentage column - only show when isSplitOrder is true */}
                                        {isSplitOrder ? (
                                          <TableCell align='center'>
                                            {data?.isAdditionalProduct ? 'N/A' : (
                                              data?.facility_id != currentFacilityId ? 
                                                `${incomingPercentage || 0}%` : 
                                                '-'
                                            )}
                                          </TableCell>
                                        ) : (
                                          <TableCell align='center'>
                                            {isNoChargeJob ? '-' : (data.inhouse === 0 ? (data?.sub_contract_markup != null && data?.sub_contract_markup !== '' ? `${Number(data.sub_contract_markup).toFixed(2)}` : '0.00') : '-')}
                                          </TableCell>
                                        )}
                                        {/* <TableCell>{invoiceAmount}</TableCell> */}
                                        {(hasMarkupPermission && markupType == 2) ? (
                                        <Tooltip title={isSplitOrder && data?.facility_id != currentFacilityId ? `Product formula cost + (Product formula cost * incoming split markup (${incomingPercentage}) / 100)` : ""}>
                                        <TableCell>
                                          {data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Retail Price Each'}
                                              // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                              sx={{ width: 85 }}
                                              value={
                                                data.retail_price_draft !== undefined
                                                  ? limitDecimalInput(data.retail_price_draft)
                                                  : formatRetailPriceDisplay(
                                                      roundMoneyValue(dataActualRetail) ?? 0,
                                                    )
                                              }
                                              // onWheel={(e) => e.target.blur()}
                                              onKeyPress={(event) => {
                                                // if (event.key === '0' && event.target.value === '') {
                                                //   event.preventDefault();
                                                // }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === 'ArrowUp' ||
                                                  event.key === 'ArrowDown'
                                                ) {
                                                  event.preventDefault()
                                                  const current =
                                                    data.retail_price_draft !== undefined
                                                      ? data.retail_price_draft
                                                      : formatRetailPriceDisplay(
                                                          dataActualRetail ?? 0,
                                                        )
                                                  handleRetailPriceChange(
                                                    data.indexId,
                                                    stepRetailPriceByArrow(
                                                      current,
                                                      event.key === 'ArrowUp'
                                                        ? 'up'
                                                        : 'down',
                                                      retailPriceMin,
                                                    ),
                                                    { isBlur: true },
                                                  )
                                                }
                                              }}
                                              inputProps={{ min: retailPriceMin, step: 1 }}
                                              defaultValue={0}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onChange={(event) => {
                                                const current =
                                                  data.retail_price_draft !== undefined
                                                    ? data.retail_price_draft
                                                    : formatRetailPriceDisplay(
                                                        dataActualRetail ?? 0,
                                                      )
                                                handleRetailPriceChange(
                                                  data.indexId,
                                                  normalizeRetailArrowChange(
                                                    current,
                                                    event.target.value,
                                                    retailPriceMin,
                                                  ),
                                                )
                                              }}
                                              onBlur={(event) => {
                                                handleRetailPriceChange(
                                                  data.indexId,
                                                  event.target.value,
                                                  { isBlur: true },
                                                )
                                              }}
                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            /> :
                                            <>
                                              {/* ALL-815 backup - previous read-only retail display:
                                              Number(dataActualRetail).toFixed(2) */}
                                              <TextField
                                                required
                                                fullWidth
                                                type="number"
                                                label={'Retail Price Each'}
                                                sx={{ width: 120 }}
                                                value={
                                                  data.retail_price_draft !== undefined
                                                    ? limitDecimalInput(data.retail_price_draft)
                                                    : formatRetailPriceDisplay(
                                                        roundMoneyValue(dataActualRetail) ?? 0,
                                                      )
                                                }
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onKeyPress={(event) => {
                                                  if (event.key === '-') {
                                                    event.preventDefault();
                                                  }
                                                  if (event.key === 'e') {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onKeyDown={(event) => {
                                                  if (
                                                    event.key === 'ArrowUp' ||
                                                    event.key === 'ArrowDown'
                                                  ) {
                                                    event.preventDefault()
                                                    const current =
                                                      data.retail_price_draft !== undefined
                                                        ? data.retail_price_draft
                                                        : formatRetailPriceDisplay(
                                                            dataActualRetail ?? 0,
                                                          )
                                                    handleRetailPriceChange(
                                                      data.indexId,
                                                      stepRetailPriceByArrow(
                                                        current,
                                                        event.key === 'ArrowUp'
                                                          ? 'up'
                                                          : 'down',
                                                        retailPriceMin,
                                                      ),
                                                      { isBlur: true },
                                                    )
                                                  }
                                                }}
                                                inputProps={{ min: retailPriceMin, step: 1 }}
                                                defaultValue={0}
                                                onChange={(event) => {
                                                  const current =
                                                    data.retail_price_draft !== undefined
                                                      ? data.retail_price_draft
                                                      : formatRetailPriceDisplay(
                                                          dataActualRetail ?? 0,
                                                        )
                                                  handleRetailPriceChange(
                                                    data.indexId,
                                                    normalizeRetailArrowChange(
                                                      current,
                                                      event.target.value,
                                                      retailPriceMin,
                                                    ),
                                                  )
                                                }}
                                                onBlur={(event) => {
                                                  handleRetailPriceChange(
                                                    data.indexId,
                                                    event.target.value,
                                                    { isBlur: true },
                                                  )
                                                }}
                                              />
                                            </>
                                          }
                                        </TableCell>
                                        </Tooltip>
                                        ) : null}
                                        {(hasMarkupPermission && markupType == 1) ? (
                                        <TableCell>
                                        {data?.isAdditionalProduct ?
                                          <TextField
                                            required
                                            fullWidth
                                            type="number"
                                            label={'Retail Price Each'}
                                            // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                            sx={{ width: 85 }}
                                            value={
                                              data.retail_price_draft !== undefined
                                                ? limitDecimalInput(data.retail_price_draft)
                                                : formatRetailPriceDisplay(roundMoneyValue(dataPrice) ?? 0)
                                            }
                                            // onWheel={(e) => e.target.blur()}
                                            onKeyPress={(event) => {
                                              // if (event.key === '0' && event.target.value === '') {
                                              //   event.preventDefault();
                                              // }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                              if (event.key === 'e') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onKeyDown={(event) => {
                                              if (
                                                event.key === 'ArrowUp' ||
                                                event.key === 'ArrowDown'
                                              ) {
                                                event.preventDefault()
                                                const current =
                                                  data.retail_price_draft !== undefined
                                                    ? data.retail_price_draft
                                                    : formatRetailPriceDisplay(dataPrice ?? 0)
                                                handleRetailPriceChange(
                                                  data.indexId,
                                                  stepRetailPriceByArrow(
                                                    current,
                                                    event.key === 'ArrowUp' ? 'up' : 'down',
                                                    retailPriceMin,
                                                  ),
                                                  { isBlur: true },
                                                )
                                              }
                                            }}
                                            inputProps={{ min: retailPriceMin, step: 1 }}
                                            defaultValue={0}
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}
                                            onChange={(event) => {
                                              const current =
                                                data.retail_price_draft !== undefined
                                                  ? data.retail_price_draft
                                                  : formatRetailPriceDisplay(dataPrice ?? 0)
                                              handleRetailPriceChange(
                                                data.indexId,
                                                normalizeRetailArrowChange(
                                                  current,
                                                  event.target.value,
                                                  retailPriceMin,
                                                ),
                                              )
                                            }}
                                            onBlur={(event) => {
                                              handleRetailPriceChange(
                                                data.indexId,
                                                event.target.value,
                                                { isBlur: true },
                                              )
                                            }}
                                            // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          /> :
                                          <>
                                            {/* ALL-815 backup - previous read-only retail display: dataPrice?.toFixed(2) */}
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Retail Price Each'}
                                              sx={{ width: 120 }}
                                              value={
                                                data.retail_price_draft !== undefined
                                                  ? limitDecimalInput(data.retail_price_draft)
                                                  : formatRetailPriceDisplay(roundMoneyValue(dataPrice) ?? 0)
                                              }
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === 'ArrowUp' ||
                                                  event.key === 'ArrowDown'
                                                ) {
                                                  event.preventDefault()
                                                  const current =
                                                    data.retail_price_draft !== undefined
                                                      ? data.retail_price_draft
                                                      : formatRetailPriceDisplay(dataPrice ?? 0)
                                                  handleRetailPriceChange(
                                                    data.indexId,
                                                    stepRetailPriceByArrow(
                                                      current,
                                                      event.key === 'ArrowUp' ? 'up' : 'down',
                                                      retailPriceMin,
                                                    ),
                                                    { isBlur: true },
                                                  )
                                                }
                                              }}
                                              inputProps={{ min: retailPriceMin, step: 1 }}
                                              defaultValue={0}
                                              onChange={(event) => {
                                                const current =
                                                  data.retail_price_draft !== undefined
                                                    ? data.retail_price_draft
                                                    : formatRetailPriceDisplay(dataPrice ?? 0)
                                                handleRetailPriceChange(
                                                  data.indexId,
                                                  normalizeRetailArrowChange(
                                                    current,
                                                    event.target.value,
                                                    retailPriceMin,
                                                  ),
                                                )
                                              }}
                                              onBlur={(event) => {
                                                handleRetailPriceChange(
                                                  data.indexId,
                                                  event.target.value,
                                                  { isBlur: true },
                                                )
                                              }}
                                            />
                                          </>
                                          }
                                        </TableCell>
                                        ) : null}
                                       
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            disabled={(data?.fromMapServices == true) ? true : false}
                                            label={"Qty"}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data.locationQuantity ? data.locationQuantity : 1}
                                            value={data.locationQuantity ? data.locationQuantity : 1}
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}
                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }
                                              const newAddr = data?.is_single_card ? 1 : newValue

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                // if (p.id === data.id) {
                                                if (p.indexId === data.indexId) {

                                                  let arrayAddr

                                                  const commonAddresses = (data?.allLocationSame && pv.length > 0) ? p.location[0] : null;
                                                  console.log("Hifiiiiiiiiiiiiii Aff", commonAddresses);
                                                  if (data?.allLocationSame && commonAddresses) {
                                                    arrayAddr = Array(Number(newAddr)).fill().map((_, i) => ({
                                                      ...commonAddresses,
                                                      id: i,
                                                      req_loc_id: p.location[i]?.req_loc_id ?? null,
                                                    }));

                                                  }
                                                  else {
                                                    arrayAddr = [...p.location]
                                                    console.log("Hifiiiiiiiiiiiiii Aff", arrayAddr);
                                                    if (p.location.length <= Number(newAddr)) {
                                                      arrayAddr.push(...[...Array(Number(newAddr) - p.location.length)].map((a, i) => {
                                                        return {
                                                          id: p.location.length + i,
                                                          address: '',
                                                          city: '',
                                                          state: '',
                                                          zip: '',
                                                        }
                                                      }))
                                                    }
                                                    else if (p.location.length > Number(newAddr)) {
                                                      arrayAddr = arrayAddr.slice(0, Number(newAddr));
                                                    }
                                                    else {
                                                      arrayAddr = arrayAddr.slice(0, -(p.location.length - Number(newAddr)));
                                                    }
                                                  }

                                                  return {
                                                    ...p,
                                                    // quantity:newValue,
                                                    locationQuantity: newValue,
                                                    location: arrayAddr,
                                                    install_quantity: p.manually_updated_install_quantity ?  p.install_quantity :Number(newValue) ,
                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              setSelectedServices(pv => ([...pv.map(service => {
                                                console.log("############@@@@@@@@@@service", service);
                                                console.log("############@@@@@@@@@@data", data);
                                                if (service.productIndex === data.indexId && service.prQty) {
                                                  console.log("############service.newValue", newValue);
                                                  return {
                                                    ...service,
                                                    quantity: (newValue * (service.qtyData || 1) * service.prQty).toFixed(2),
                                                    locationQuantity: newValue,
                                                  };
                                                } else {
                                                  return {
                                                    ...service,

                                                  }
                                                }
                                              })]));
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        {isSplitOrder && Number(data?.facility_id) !== Number(currentFacilityId) ? (
                                        <TableCell align="center">
                                          {Number(data?.facility_id) !== Number(currentFacilityId) ? (
                                            <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                              <Button
                                                size="small"
                                                variant={data?.delivery_installation?.installer_facility_id ? "contained" : "outlined"}
                                                onClick={() => openDeliveryInstallDialog(data)}
                                                disabled={details?.allInstallationCompleted == 1 || tmInvoicingFieldDisabled}
                                              >
                                                {data?.delivery_installation?.installer_facility_id ? 'Edit' : 'Set'}
                                              </Button>
                                              {data?.delivery_installation?.installer_facility_id ? (
                                                <Tooltip
                                                  title={`${deliveryTypeLabelById(
                                                    data?.delivery_installation?.delivery_type_id ||
                                                      data?.delivery_installation?.complete_status,
                                                  )} • ${
                                                    data?.delivery_installation?.installer_facility_name ||
                                                    getFacilityOption(data?.delivery_installation?.installer_facility_id)?.name ||
                                                    ''
                                                  }`}
                                                >
                                                  <Typography variant="caption" noWrap sx={{ maxWidth: 140 }}>
                                                    {deliveryTypeLabelById(
                                                      data?.delivery_installation?.delivery_type_id ||
                                                        data?.delivery_installation?.complete_status,
                                                    )}
                                                    {' • '}
                                                    {data?.delivery_installation?.installer_facility_name ||
                                                      getFacilityOption(data?.delivery_installation?.installer_facility_id)?.name ||
                                                      ''}
                                                  </Typography>
                                                </Tooltip>
                                              ) : null}
                                            </Stack>
                                          ) : (
                                            '-'
                                          )}
                                        </TableCell>
                                        ) : isDedicatedGroupedParent ? (
                                        <TableCell align='center'>-</TableCell>
                                        ) : (
                                          <TableCell align='center'>
                                            <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                              <Button
                                                size="small"
                                                variant={data?.delivery_installation?.delivery_type_id ? "contained" : "outlined"}
                                                onClick={() => openDeliveryTypeDialog(data, 'product')}
                                                sx={{ textAlign: 'center' }}
                                                disabled={details?.allInstallationCompleted == 1 || tmInvoicingFieldDisabled}
                                              >
                                                {data?.delivery_installation?.delivery_type_id ? 'Edit' : 'Set'}
                                              </Button>
                                              {data?.delivery_installation?.delivery_type_id || data?.delivery_installation?.complete_status ? (
                                                <Tooltip
                                                  title={`${deliveryTypeLabelById(
                                                    data?.delivery_installation?.delivery_type_id ||
                                                    data?.delivery_installation?.complete_status,
                                                  )}`}
                                                >
                                                  <Typography
                                                    variant="caption"
                                                    noWrap
                                                    sx={{ maxWidth: 140 }}
                                                  >
                                                    {deliveryTypeLabelById(
                                                      data?.delivery_installation?.delivery_type_id ||
                                                      data?.delivery_installation?.complete_status,
                                                    )}
                                                  </Typography>
                                                </Tooltip>
                                              ) : null}
                                            </Stack>
                                          </TableCell>
                                        )}
                                        <TableCell>
                                          <IconButton
                                            onClick={() => {
                                              setLocationStates({ ...locationStates, [data.indexId]: true });
                                            }}
                                            disabled={details?.allInstallationCompleted == 1 || tmInvoicingFieldDisabled}
                                          >
                                            <LocationOn sx={{
                                              color: data.location.some(obj =>
                                                [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                              ) ? '' : theme.palette.primary.main
                                            }} />
                                          </IconButton>
                                        </TableCell>
                                   {/* //maketting adjustment */}
                                      {
                                        isSplitOrder ? null :
                                        <>
                                           <TableCell>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                  <Remove 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const hasPermission =  explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                      )
                                                      // if(!hasPermission) {
                                                      //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      // }
                                                      const formulaEach = Number(
                                                        (data?.expected_material_cost_with_markup || 0) +
                                                          (data?.expected_service_cost_with_markup || 0),
                                                      )
                                                      const retailEachBase = Math.max(
                                                        0,
                                                        Number(
                                                          data.original_actual_retail_price ??
                                                            data.original_retail_price ??
                                                            data.actual_retail_price ??
                                                            data.retail_price ??
                                                            data.product_retail_price ??
                                                            0,
                                                        ),
                                                      )
                                                      if (retailEachBase <= formulaEach && !hasPermission) {
                                                        return enqueueSnackbar(
                                                          'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                          { variant: 'error' },
                                                        )
                                                      }
                                                      // const expected = Number(data.expected_cost) || 0;
                                                      // const qty = Number(data.quantity) || 1;
                                                      // const locQty = Number(data.locationQuantity) || 1;
                                                      // const pfCost =expected ? (parseFloat((expected)?.toFixed(2))*qty*locQty) : 0
                                                      // const adjustment = Number(data.adjustment) || 0;
                                                      // if(Number(adjustment) > Number(pfCost)) {
                                                      //   return enqueueSnackbar('Negative Adjustment Amount cannot be Greater than product formula cost', { variant: 'error' })
                                                      // }
                                                      const { maxNegative } = getMaxNegativeAdjustment(data, hasPermission);
                                                      const adjustment = Number(data.adjustment) || 0;

                                                      if (adjustment >= maxNegative && hasPermission) {
                                                        return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (adjustment > maxNegative && !hasPermission) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                          { variant: 'error' }
                                                        );
                                                      }
                                                      const newValue = false
                                                      setSelectedProducts(
                                                        (prevProducts) =>
                                                          prevProducts.map(
                                                            (product) => {
                                                              if (
                                                                product.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return applyProductAdjValueTypeChange(
                                                                  product,
                                                                  newValue,
                                                                )
                                                              }
                                                              return product
                                                            },
                                                          ),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                      // setFieldValue('manager_approval_required', true)
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={data.adj_value_type}
                                                        onChange={(event) => {
                                                          const newValue = event.target.checked
                                                          const hasPermission =  explodedPermissions?.some((permission) =>
                                                            ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                          )
                                                          // if(!hasPermission && newValue === false) {
                                                          //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                          // }
                                                        if (newValue === false) {
                                                          const formulaEach = Number(
                                                            (data?.expected_material_cost_with_markup || 0) +
                                                              (data?.expected_service_cost_with_markup || 0),
                                                          )
                                                          const retailEachBase = Math.max(
                                                            0,
                                                            Number(
                                                              data.original_actual_retail_price ??
                                                                data.original_retail_price ??
                                                                data.actual_retail_price ??
                                                                data.retail_price ??
                                                                data.product_retail_price ??
                                                                0,
                                                            ),
                                                          )
                                                          if (retailEachBase <= formulaEach && !hasPermission) {
                                                            return enqueueSnackbar(
                                                              'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                              { variant: 'error' },
                                                            )
                                                          }
                                                        }
                                                          // const expected = Number(data.expected_cost) || 0;
                                                          // const qty = Number(data.quantity) || 1;
                                                          // const locQty = Number(data.locationQuantity) || 1;
                                                          // const pfCost =expected ? (parseFloat((expected)?.toFixed(2))*qty*locQty) : 0
                                                          // const adjustment = Number(data.adjustment) || 0;
                                                          // if(Number(adjustment) > Number(pfCost) && newValue === false) {
                                                          //   return enqueueSnackbar('Negative Adjustment Amount cannot be Greater than product formula cost', { variant: 'error' })
                                                          // }
                                                          const { maxNegative } = getMaxNegativeAdjustment(data, hasPermission);
                                                          const adjustment = Number(data.adjustment) || 0;

                                                          if (adjustment >= maxNegative && newValue === false && hasPermission) {
                                                            return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                          } else if (adjustment > maxNegative && newValue === false && !hasPermission) {
                                                            return enqueueSnackbar(
                                                              `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                              { variant: 'error' }
                                                            );
                                                          }
                                                          setSelectedProducts(
                                                            (prevProducts) =>
                                                              prevProducts.map(
                                                                (product) => {
                                                                  if (
                                                                    product.indexId ===
                                                                    data.indexId
                                                                  ) {
                                                                    return applyProductAdjValueTypeChange(
                                                                      product,
                                                                      newValue,
                                                                    )
                                                                  }
                                                                  return product
                                                                },
                                                              ),
                                                          )
                                                          data['adj_value_type'] = newValue
                                                          if (newValue === false) {
                                                            // setFieldValue('manager_approval_required', true)
                                                          }
                                                        }}
                                                      />
                                                    }
                                                    label=""
                                                  />
                                                  <Add 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const newValue = true
                                                      setSelectedProducts(
                                                        (prevProducts) =>
                                                          prevProducts.map(
                                                            (product) => {
                                                              if (
                                                                product.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return applyProductAdjValueTypeChange(
                                                                  product,
                                                                  newValue,
                                                                )
                                                              }
                                                              return product
                                                            },
                                                          ),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                    }}
                                                  />
                                                </Stack>
                                              </TableCell>
                                            <TableCell>
                                               <TextField
                                                  type="number"
                                                  inputProps={{ min: 0 }}
                                                  label='$'
                                                  value={
                                                    data.adjustment_draft !== undefined
                                                      ? limitDecimalInput(
                                                          data.adjustment_draft,
                                                        )
                                                      : Number(data.adjustment) || ''
                                                  }
                                                  InputLabelProps={{
                                                    shrink: Boolean(
                                                      data.adjustment_draft !== undefined
                                                        ? data.adjustment_draft !== ''
                                                        : Number(data.adjustment),
                                                    ),
                                                  }}
                                                  onWheel={(e) => e.target.blur()}
                                                  onBeforeInput={(e) => {
                                                    const inputElement = e.target;
                                                    const nextValue = inputElement.value; 
                                                    const hasPermission =  explodedPermissions?.some((permission) =>
                                                      ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                    )
                                                    const { maxNegative } = getMaxNegativeAdjustment(data, hasPermission);
                                                    if (Number(nextValue) >= maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && hasPermission) {
                                                      e.preventDefault();
                                                      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                    } else if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && !hasPermission) {
                                                      e.preventDefault();
                                                      enqueueSnackbar(
                                                        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                        { variant: "error" }
                                                      );
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    handleMarketingAdjustmentChange(
                                                      data.indexId,
                                                      event.target.value,
                                                    )
                                                  }}
                                                  onBlur={(event) => {
                                                    handleMarketingAdjustmentChange(
                                                      data.indexId,
                                                      event.target.value,
                                                      { isBlur: true },
                                                    )
                                                  }}
                                                  onKeyDown={(event) => {
                                                    if (
                                                      event.key === '-' ||
                                                      event.key === '+'
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    // Prevent arrow down key when value is 0 or would go negative
                                                    if (event.key === 'ArrowDown') {
                                                      const inputValue = event.target.value
                                                      const currentValue = parseFloat(inputValue) || 0
                                                      const step = parseFloat(event.target.step) || 1
                                                      if (currentValue - step < 0) {
                                                        event.preventDefault()
                                                      }
                                                    }
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                      errors[
                                                        adjustmentFieldName
                                                      ],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                    errors[adjustmentFieldName]
                                                  }
                                                />
                                              </TableCell>
                                        </>
                                      }
                                              



                                        <TableCell>
                                          {productCost?.toFixed(2)}
                                          {/* {data?.adj_value_type ? (productCost + Number(data.adjustment)).toFixed(2) : (productCost - Number(data.adjustment)).toFixed(2)}        */}
                                          </TableCell>
                                        <TableCell>
                                          {
                                            data?.install_cost ? '' :
                                              lineProductTotal.toFixed(2)
                                          } 
                                        </TableCell>
                                        <TableCell>
                                        {(data?.fromMapServices == true) ? '' : 
                                          <IconButton disabled={tmInvoicingFieldDisabled} onClick={() => handleDeleteProduct(data.id || data.product_id, data.indexId)}>
                                            <Delete />
                                          </IconButton>
                                        }
                                        </TableCell>
                                      </TableRow>
                                      {
                                        data?.install_cost ?
                                          <TableRow key={`summary-${data.indexId}`} sx={losingMoneyRowSx}>
                                          {/* <TableRow key={`summary-${data.indexId}`} sx={losingMoneyRowSx} sx={rowOptions?.groupRowSx}> */}
                                              {editFormValuesEnabled && (
                                              <TableCell padding="checkbox" sx={{ width: 40 }} />
                                            )}
                                            <TableCell>—</TableCell>
                                            <TableCell> </TableCell>
                                            <TableCell>
                                              <Typography>Install Price</Typography>
                                       {data?.install_notes ?       <Typography sx={{color: data?.install_notes ? theme.palette.error.main  : (isSplitOrder ? theme.palette[
                                        FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                      ]?.main : 'inherit') ,whiteSpace: 'pre-wrap'}}>Note: {data?.install_notes ? data?.install_notes : ` `}</Typography>:""}
                                      </TableCell>
                                            
                                            <TableCell align='center'>
                                              <IconButton onClick={() => handleOpenInstallNote(data.indexId, data.install_notes)}>
                                                <NoteAdd
                                                  sx={{
                                                    color: (!data?.install_notes || data?.install_notes === '') ? '' : theme.palette.primary.main,
                                                  }}
                                                />
                                              </IconButton>
                                            </TableCell>
                                            <TableCell align='center'>-</TableCell>
                                            <TableCell align='center'>-</TableCell>
                                            <TableCell>{
                                              isSplitOrder && data?.facility_id !== currentFacilityId ?
                                              data?.install_cost?.toFixed(2) || 0 :
                                            data?.install_formula_cost_each != null &&
                                            data?.install_formula_cost_each !== ''
                                              ? Number(data.install_formula_cost_each).toFixed(2)
                                              : (data?.expected_install_labor_cost_with_markup?.toFixed(2) || 0)}</TableCell>
                                            {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                                            {isSplitOrder ? (
                                              <TableCell align='center'>-</TableCell>
                                            ) : (
                                              <TableCell align='center'>-</TableCell>
                                            )}
                                            {/* {isSplitOrder ? (
                                              <TableCell align='center'>-</TableCell>
                                            ) : null} */}
                                            {/* {isSplitOrder ? (
                                              <TableCell align='center'>-</TableCell>
                                            ) : null} */}
                                            {(hasMarkupPermission && markupType == 2) ? (
                                            <TableCell align='center'>
                                              {/* ALL-815 backup - previous read-only install price display:
                                              (parseFloat(data?.install_cost || 0)).toFixed(2) */}
                                              {(() => {
                                                const installFormulaEach = Number(
                                                  data?.expected_install_labor_cost_with_markup ||
                                                    0,
                                                )
                                                const hasNegativeInstallPermission =
                                                  explodedPermissions?.some(
                                                    (permission) =>
                                                      [
                                                        'Allow Negative Marketing Adjustment Sales Order',
                                                      ].includes(permission),
                                                  )
                                                const installPriceMin =
                                                  hasNegativeInstallPermission
                                                    ? 0.01
                                                    : Math.max(
                                                        0.01,
                                                        installFormulaEach,
                                                      )
                                                const dataInstallCost = getDisplayedInstallPrice(data)
                                                return (
                                              <TextField
                                                required
                                                fullWidth
                                                type="number"
                                                label={'Install Price Each'}
                                                sx={{ width: 120 }}
                                                value={
                                                  data.install_price_draft !== undefined
                                                    ? limitDecimalInput(
                                                        data.install_price_draft,
                                                      )
                                                    : formatRetailPriceDisplay(
                                                        dataInstallCost,
                                                      )
                                                }
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onKeyPress={(event) => {
                                                  if (event.key === '-') {
                                                    event.preventDefault();
                                                  }
                                                  if (event.key === 'e') {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onKeyDown={(event) => {
                                                  if (
                                                    event.key === 'ArrowUp' ||
                                                    event.key === 'ArrowDown'
                                                  ) {
                                                    event.preventDefault()
                                                    const current =
                                                      data.install_price_draft !== undefined
                                                        ? data.install_price_draft
                                                        : formatRetailPriceDisplay(
                                                            dataInstallCost,
                                                          )
                                                    handleInstallPriceChange(
                                                      data.indexId,
                                                      stepRetailPriceByArrow(
                                                        current,
                                                        event.key === 'ArrowUp'
                                                          ? 'up'
                                                          : 'down',
                                                        installPriceMin,
                                                      ),
                                                      { isBlur: true },
                                                    )
                                                  }
                                                }}
                                                inputProps={{
                                                  min: installPriceMin,
                                                  step: 1,
                                                }}
                                                defaultValue={0}
                                                onChange={(event) => {
                                                  const current =
                                                    data.install_price_draft !== undefined
                                                      ? data.install_price_draft
                                                      : formatRetailPriceDisplay(
                                                          dataInstallCost,
                                                        )
                                                  handleInstallPriceChange(
                                                    data.indexId,
                                                    normalizeRetailArrowChange(
                                                      current,
                                                      event.target.value,
                                                      installPriceMin,
                                                    ),
                                                  )
                                                }}
                                                onBlur={(event) => {
                                                  handleInstallPriceChange(
                                                    data.indexId,
                                                    event.target.value,
                                                    { isBlur: true },
                                                  )
                                                }}
                                              />
                                                )
                                              })()}
                                            </TableCell>
                                            ) : null}
                                            {(hasMarkupPermission && markupType == 1) ? (
                                            <TableCell align='center'>
                                              {/* ALL-815 backup - previous read-only install price display:
                                              (parseFloat(data?.install_cost || 0)).toFixed(2) */}
                                              {(() => {
                                                const installFormulaEach = Number(
                                                  data?.expected_install_labor_cost_with_markup ||
                                                    0,
                                                )
                                                const hasNegativeInstallPermission =
                                                  explodedPermissions?.some(
                                                    (permission) =>
                                                      [
                                                        'Allow Negative Marketing Adjustment Sales Order',
                                                      ].includes(permission),
                                                  )
                                                const installPriceMin =
                                                  hasNegativeInstallPermission
                                                    ? 0.01
                                                    : Math.max(
                                                        0.01,
                                                        installFormulaEach,
                                                      )
                                                const dataInstallCost = getDisplayedInstallPrice(data)
                                                return (
                                              <TextField
                                                required
                                                fullWidth
                                                type="number"
                                                label={'Install Price Each'}
                                                sx={{ width: 120 }}
                                                value={
                                                  data.install_price_draft !== undefined
                                                    ? limitDecimalInput(
                                                        data.install_price_draft,
                                                      )
                                                    : formatRetailPriceDisplay(
                                                        dataInstallCost,
                                                      )
                                                }
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onKeyPress={(event) => {
                                                  if (event.key === '-') {
                                                    event.preventDefault();
                                                  }
                                                  if (event.key === 'e') {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onKeyDown={(event) => {
                                                  if (
                                                    event.key === 'ArrowUp' ||
                                                    event.key === 'ArrowDown'
                                                  ) {
                                                    event.preventDefault()
                                                    const current =
                                                      data.install_price_draft !== undefined
                                                        ? data.install_price_draft
                                                        : formatRetailPriceDisplay(
                                                            dataInstallCost,
                                                          )
                                                    handleInstallPriceChange(
                                                      data.indexId,
                                                      stepRetailPriceByArrow(
                                                        current,
                                                        event.key === 'ArrowUp'
                                                          ? 'up'
                                                          : 'down',
                                                        installPriceMin,
                                                      ),
                                                      { isBlur: true },
                                                    )
                                                  }
                                                }}
                                                inputProps={{
                                                  min: installPriceMin,
                                                  step: 1,
                                                }}
                                                defaultValue={0}
                                                onChange={(event) => {
                                                  const current =
                                                    data.install_price_draft !== undefined
                                                      ? data.install_price_draft
                                                      : formatRetailPriceDisplay(
                                                          dataInstallCost,
                                                        )
                                                  handleInstallPriceChange(
                                                    data.indexId,
                                                    normalizeRetailArrowChange(
                                                      current,
                                                      event.target.value,
                                                      installPriceMin,
                                                    ),
                                                  )
                                                }}
                                                onBlur={(event) => {
                                                  handleInstallPriceChange(
                                                    data.indexId,
                                                    event.target.value,
                                                    { isBlur: true },
                                                  )
                                                }}
                                              />
                                                )
                                              })()}
                                            </TableCell>
                                            ) : null}
                                            <TableCell align='center'>
                                              <TextField
                                                required
                                                fullWidth
                                                type="number"
                                                min={0}
                                                label={'Qty'}
                                                // sx={{ width: 85 }}
                                                value={Number(isSplitOrder ? (data.install_quantity ?? 0) : (data.install_quantity || 1))}
                                                defaultValue={1}
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onKeyPress={(event) => {
                                                  if (
                                                    event.key === '0' &&
                                                    event.target.value === ''
                                                  ) {
                                                    event.preventDefault()
                                                  }
                                                  if (event.key === '-') {
                                                    event.preventDefault()
                                                  }
                                                  if (event.key === '.') {
                                                    event.preventDefault()
                                                  }
                                                }}
                                                onChange={(event) => {
                                                  let newValue = event.target.value
                                                  if (Number(newValue) < 0) return
                                                  if ((newValue !== '0' && newValue !== '') || (isSplitOrder && newValue === '0')) {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId !== data.indexId) return p
                                                        console.log('newValue1234569887------', newValue , p?.actual_retail_price ,p?.install_cost , p?.locationQuantity )
                                                        return {
                                                          ...p,
                                                          install_quantity: Number(newValue),
                                                          retail_price: (Number(newValue) === 0 ? (Number(p?.actual_retail_price) || 0) : (Number(p?.actual_retail_price) || 0) + (Number(p?.install_cost) || 0)) * (p?.locationQuantity || 1),
                                                          manually_updated_install_quantity: true,
                                                        }
                                                      }),
                                                    )
                                                    data['install_quantity'] = Number(newValue)
                                                    data['retail_price'] = (Number(newValue) === 0 ? (Number(data?.actual_retail_price) || 0) : (Number(data?.actual_retail_price) || 0) + (Number(data?.install_cost) || 0)) * (data?.locationQuantity || 1)
                                                  }
                                                }}
                                              />
                                            </TableCell>
                                            {/* {isSplitOrder ? ( */}
                                              <TableCell align='center'>-</TableCell>
                                            {/* ) : null} */}
                                            <TableCell align='center'></TableCell>
                                            {/* Marketing adjustment for Install Price (separate from product marketing adjustment) */}
                                            {
                                              isSplitOrder ? null :
                                              <>
                                            <TableCell>
                                              <Stack direction="row" spacing={1} alignItems="center">
                                                <Remove
                                                  fontSize="small"
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => {
                                                    const hasPermission =
                                                      explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                      )
                                                    // if (!hasPermission) {
                                                    //   return enqueueSnackbar(
                                                    //     'Access Denied : You do not have Suffient Permission',
                                                    //     { variant: 'error' },
                                                    //   )
                                                    // }
                                                  const formulaEach = Number(
                                                    data?.expected_install_labor_cost_with_markup || 0,
                                                  )
                                                  const retailEachBase = Math.max(
                                                    0,
                                                    Number(data.install_cost || 0),
                                                  )
                                                  if (retailEachBase <= formulaEach) {
                                                    return enqueueSnackbar(
                                                      'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                      { variant: 'error' },
                                                    )
                                                  }
                                                    const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                    const adjustment = Number(data.install_adjustment) || 0
                                                    if (Number(adjustment) >= maxNegative && hasPermission) {
                                                      return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                    } else if (Number(adjustment) > maxNegative && !hasPermission) {
                                                      return enqueueSnackbar(
                                                        `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                        { variant: 'error' },
                                                      )
                                                    }

                                                    const newValue = false
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((product) => {
                                                        if (product.indexId !== data.indexId) return product

                                                        return applyInstallAdjValueTypeChange(
                                                          product,
                                                          newValue,
                                                        )
                                                      }),
                                                    )
                                                    data['install_adj_value_type'] = newValue
                                                    // setFieldValue('manager_approval_required', true)
                                                    setRefreshCalculation(!refreshCalculation)
                                                  }}
                                                />
                                                <FormControlLabel
                                                  control={
                                                    <Switch
                                                      checked={!isNegativeAdjustmentMode(data.install_adj_value_type)}
                                                      onChange={(event) => {
                                                        const newValue = event.target.checked
                                                        const hasPermission =
                                                          explodedPermissions?.some((permission) =>
                                                            ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                          )
                                                        // if (!hasPermission && newValue === false) {
                                                        //   return enqueueSnackbar(
                                                        //     'Access Denied : You do not have Suffient Permission',
                                                        //     { variant: 'error' },
                                                        //   )
                                                        // }
                                                      if (newValue === false) {
                                                        const formulaEach = Number(
                                                          data?.expected_install_labor_cost_with_markup || 0,
                                                        )
                                                        const retailEachBase = Math.max(
                                                          0,
                                                          Number(data.install_cost || 0),
                                                        )
                                                        if (retailEachBase <= formulaEach && !hasPermission) {
                                                          return enqueueSnackbar(
                                                            'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                            { variant: 'error' },
                                                          )
                                                        }
                                                      }
                                                        const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                        const adjustment = Number(data.install_adjustment) || 0
                                                        if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
                                                          return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                        } else if (Number(adjustment) > maxNegative && newValue === false && !hasPermission) {
                                                          return enqueueSnackbar(
                                                            `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                            { variant: 'error' },
                                                          )
                                                        }

                                                        setSelectedProducts((prevProducts) =>
                                                          prevProducts.map((product) => {
                                                            if (product.indexId !== data.indexId) return product

                                                            return applyInstallAdjValueTypeChange(
                                                              product,
                                                              newValue,
                                                            )
                                                          }),
                                                        )
                                                        data['install_adj_value_type'] = newValue
                                                        if (newValue === false) {
                                                          // setFieldValue('manager_approval_required', true)
                                                        }
                                                        setRefreshCalculation(!refreshCalculation)
                                                      }}
                                                    />
                                                  }
                                                  label=""
                                                />
                                                <Add
                                                  fontSize="small"
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => {
                                                    const newValue = true
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((product) => {
                                                        if (product.indexId !== data.indexId) return product

                                                        return applyInstallAdjValueTypeChange(
                                                          product,
                                                          newValue,
                                                        )
                                                      }),
                                                    )
                                                    data['install_adj_value_type'] = newValue
                                                    setRefreshCalculation(!refreshCalculation)
                                                  }}
                                                />
                                              </Stack>
                                            </TableCell>
                                            <TableCell>
                                              <TextField
                                                type="number"
                                                inputProps={{ min: 0 }}
                                                label="$"
                                                InputLabelProps={{
                                                  shrink: Boolean(
                                                    data.install_adjustment_draft !== undefined
                                                      ? data.install_adjustment_draft !== ''
                                                      : Number(data.install_adjustment),
                                                  ),
                                                }}
                                                value={
                                                  data.install_adjustment_draft !== undefined
                                                    ? limitDecimalInput(
                                                        data.install_adjustment_draft,
                                                      )
                                                    : Number(data.install_adjustment) || ''
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                onBeforeInput={(e) => {
                                                  // const char = e.data
                                                  // const nextValue = e.target.value + char
                                                  const inputElement = e.target;
                                                  const nextValue = inputElement.value; 
                                                  const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                  if (Number(nextValue) >= maxNegative &&  isNegativeAdjustmentMode(data.install_adj_value_type) && hasPermission) {
                                                    e.preventDefault()
                                                    enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                  } else if (
                                                    Number(nextValue) > maxNegative &&
                                                    isNegativeAdjustmentMode(data.install_adj_value_type) &&
                                                    !hasPermission
                                                  ) {
                                                    e.preventDefault()
                                                    enqueueSnackbar(
                                                      `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                      { variant: 'error' },
                                                    )
                                                  }
                                                }}
                                                onChange={(event) => {
                                                  let newValue = event.target.value
                                                  const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                  if (Number(newValue) >= maxNegative  &&  isNegativeAdjustmentMode(data.install_adj_value_type) && hasPermission) {
                                                    enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                    return
                                                  } else if (
                                                    Number(newValue) > maxNegative &&
                                                    isNegativeAdjustmentMode(data.install_adj_value_type) &&
                                                    !hasPermission
                                                  ) {
                                                    enqueueSnackbar(
                                                      `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                      { variant: 'error' },
                                                    )
                                                    return
                                                  }

                                                  const numValue = parseFloat(newValue) || 0
                                                  if (numValue < 0) {
                                                    newValue = 0
                                                  } else {
                                                    newValue = String(numValue)
                                                  }

                                                  // Allow only two decimal places
                                                  if (newValue.includes('.')) {
                                                    const parts = newValue.split('.')
                                                    if (parts[1].length > 2) {
                                                      newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
                                                    }
                                                  }

                                                  setSelectedProducts((prevProducts) =>
                                                    prevProducts.map((product) => {
                                                      if (product.indexId !== data.indexId) return product

                                                      const baseInstall = Number(data?.original_install_cost) || 0
                                                      const adj = Number(newValue) || 0
                                                      const newInstallCost = baseInstall
                                                        ? Math.max(
                                                            0,
                                                            baseInstall +
                                                              (isNegativeAdjustmentMode(product.install_adj_value_type)
                                                                ? -adj
                                                                : adj),
                                                          )
                                                        : null
                                                      console.log('newInstallCost123---newInstallCost------', newInstallCost)
                                                      console.log('newInstallCost123---data?.original_install_cost------', data?.original_install_cost)
                                                      console.log('newInstallCost123---product.install_adj_value_type------', product.install_adj_value_type)
                                                      console.log('newInstallCost123---newValue------', newValue)
                                                      return {
                                                        ...product,
                                                        install_adjustment: newValue,
                                                        install_adjustment_draft: newValue,
                                                        install_cost: newInstallCost,
                                                        install_price_draft: undefined,
                                                        retail_price: Number(
                                                          (
                                                            (Number(product.actual_retail_price) || 0) +
                                                            (Number(newInstallCost) || 0)
                                                          ).toFixed(2),
                                                        ),
                                                      }
                                                    }),
                                                  )
                                                  data['install_adjustment'] = newValue
                                                  setRefreshCalculation(!refreshCalculation)
                                                }}
                                                onKeyDown={(event) => {
                                                  if (event.key === '-' || event.key === '+') {
                                                    event.preventDefault()
                                                  }
                                                  if (event.key === 'ArrowDown') {
                                                    const inputValue = event.target.value
                                                    const currentValue = parseFloat(inputValue) || 0
                                                    const step = parseFloat(event.target.step) || 1
                                                    if (currentValue - step < 0) {
                                                      event.preventDefault()
                                                    }
                                                  }
                                                }}
                                              />
                                            </TableCell>
                                              </>
                                            }
                                            <TableCell align='center'>
                                              {(
                                              parseFloat(data?.install_cost || 0) *
                                              (isSplitOrder ? (Number(data?.install_quantity) || 0) : (Number(data?.install_quantity) || 1))
                                              ).toFixed(2)}
                                            </TableCell>
                                            <TableCell>
                                               {(() => {
                                                  const locQty = Number(data?.locationQuantity) || 1
                                                  const installQty = isSplitOrder ? (Number(data?.install_quantity) || 0) : (Number(data?.install_quantity) || 1)
                                                  const discount = Number(data?.discount) || 0

                                                  // Use the exact same calculation as the product subtotal column
                                                  const productSubTotal =
                                                    markupType == 1
                                                      ? (Number(data?.price) || 0) * locQty
                                                      : markupType == 2
                                                      ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
                                                      : 0

                                                  // Use the exact same calculation as the install subtotal column
                                                  const installSubTotal =
                                                    (Number(data?.install_cost) || 0) *
                                                    installQty

                                                  // Product Total is the sum of both subtotals minus discount
                                                  return Math.max(
                                                    0,
                                                    productSubTotal + installSubTotal - discount,
                                                  ).toFixed(2)
                                                })()}
                                            </TableCell>
                                            <TableCell>
                                              <IconButton onClick={() => handleDeleteInstallCost(data.id || data.product_id, data.indexId)}>
                                                <Delete />
                                              </IconButton>
                                            </TableCell>
                                          </TableRow> :
                                          ''
                                      }
                                      <TableRow>
                                        <TableCell colSpan={15} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow>
                                      </>
                                      )}
                                    </Draggable>
                                    )}
                                    <Modal
                                        open={locationStates[data.indexId]}
                                        handleClose={() => {
                                          setLocationStates({ ...locationStates, [data.indexId]: false });
                                        }}
                                      >
                                        {((data?.fromMapServices != true)
                                        // && index === 0
                                      ) && <FormControlLabel
                                          disabled={tmInvoicingFieldDisabled}
                                          sx={tmInvoicingReadOnlyCursorSx}
                                          control={
                                            <Switch
                                              checked={data?.allLocationSame}
                                              disabled={tmInvoicingFieldDisabled}
                                              onChange={() => {
                                                const gid = getProductGroupId(data)
                                                if (gid != null && gid !== '') {
                                                  applyGroupLocationUpdate(gid, (representative, locationQuantity) => {
                                                    const nextAllSame = !representative?.allLocationSame
                                                    const sourceAddr =
                                                      representative?.location || representative?.addresses || []
                                                    const templateAddresses = buildGroupAddressesForProduct(
                                                      { ...representative, locationQuantity },
                                                      sourceAddr,
                                                      {
                                                        allLocationSame: nextAllSame,
                                                        isSingleCard: representative?.is_single_card,
                                                        locationQuantity,
                                                      },
                                                    )
                                                    return {
                                                      allLocationSame: nextAllSame,
                                                      is_single_card: Boolean(representative?.is_single_card),
                                                      location: templateAddresses,
                                                    }
                                                  })
                                                  return
                                                }
                                                handleAllLocationSameChange(locationSameProductIndex)
                                              }}
                                            />
                                          }
                                          label="All Locations Same"
                                        />}
                                        <Box component="fieldset" disabled={tmInvoicingFieldDisabled} sx={{ border: 'none', m: 0, p: 0, minWidth: 0, ...tmInvoicingReadOnlyCursorSx }}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'}>
                                        {
                                          values.project_category?.id !==14 ?
                                        <Box sx={{ display: 'flex', flexDirection: 'column',width:'50%', alignItems: 'center', mt: 2 }}>
                                        <LabelStyle>Qty Location Settings</LabelStyle>
                                          <Box display="flex" alignItems="center" gap={1} mt={1}>
                                            <Typography variant="subtitle2">Multiple</Typography>
                                            <Switch
                                              color="primary"
                                              checked={Boolean(data?.is_single_card)}
                                              onChange={(event) => {
                                                const checked = event.target.checked;
                                                const gid = getProductGroupId(data)
                                                if (gid != null && gid !== '') {
                                                  applyGroupLocationUpdate(gid, (representative, locationQuantity) => {
                                                    const sourceAddr =
                                                      representative?.location || representative?.addresses || []
                                                    const templateAddresses = buildGroupAddressesForProduct(
                                                      { ...representative, locationQuantity },
                                                      sourceAddr,
                                                      {
                                                        allLocationSame: representative?.allLocationSame,
                                                        isSingleCard: checked,
                                                        locationQuantity,
                                                      },
                                                    )
                                                    return {
                                                      allLocationSame: Boolean(representative?.allLocationSame),
                                                      is_single_card: checked,
                                                      location: templateAddresses,
                                                    }
                                                  })
                                                  return
                                                }
                                                setSelectedProducts((prev) =>
                                                  prev.map((p) => {
                                                    if (p.indexId !== data.indexId) return p;
                                                
                                                    const count = Number(p.locationQuantity || 1);
                                                
                                                    if (checked) {
                                                      return {
                                                        ...p,
                                                        is_single_card: true,
                                                        location: p.location?.length
                                                          ? [p.location[0]]
                                                          : [
                                                              {
                                                                id: 0,
                                                                address: '',
                                                                city: '',
                                                                state: '',
                                                                zip: '',
                                                              },
                                                            ],
                                                      };
                                                    } else {
                                                      const allSame = p.allLocationSame;
                                                      const firstAddress = p.location?.[0];
                                                      let arrayAddr = [];
                                                
                                                      if (allSame && firstAddress) {
                                                        arrayAddr = Array(count)
                                                          .fill()
                                                          .map((_, i) => ({
                                                            ...firstAddress,
                                                            id: i,
                                                            req_loc_id: p.location[i]?.req_loc_id ?? null,
                                                          }));
                                                      } else {
                                                        arrayAddr = [...(p.location || [])];
                                                        if (arrayAddr.length < count) {
                                                          arrayAddr.push(
                                                            ...Array(count - arrayAddr.length)
                                                              .fill()
                                                              .map((_, i) => ({
                                                                id: arrayAddr.length + i,
                                                                address: '',
                                                                city: '',
                                                                state: '',
                                                                zip: '',
                                                              }))
                                                          );
                                                        } else if (arrayAddr.length > count) {
                                                          arrayAddr = arrayAddr.slice(0, count);
                                                        }
                                                      }
                                                
                                                      return {
                                                        ...p,
                                                        is_single_card: false,
                                                        location: arrayAddr,
                                                      };
                                                    }
                                                  })
                                                );
                                              }}
                                            />
                                            <Typography variant="subtitle2">Single</Typography>
                                          </Box>
                                        </Box> : ''
                                        }
                                        </Stack>
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                          {data.location.map((addr, i) => (
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Location {data?.fromMapServices == true ? i+1 : i+1}
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="Address1"
                                                  size="small"
                                                  value={data.location[i].address || ''}
                                                  disabled={(data?.fromMapServices == true && data.location[i].address) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].address = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    handleProductLocationFieldChange(
                                                      data,
                                                      i,
                                                      'address',
                                                      event.target.value,
                                                    )
                                                  }}
                                                />
                                              </Stack>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="City"
                                                  size="small"
                                                  value={data.location[i].city || ''}
                                                  disabled={(data?.fromMapServices == true && data.location[i].city) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].city = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    handleProductLocationFieldChange(
                                                      data,
                                                      i,
                                                      'city',
                                                      event.target.value,
                                                    )
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="State"
                                                  size="small"
                                                  value={data.location[i].state || ''}
                                                  disabled={(data?.fromMapServices == true && data.location[i].state) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].state = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    handleProductLocationFieldChange(
                                                      data,
                                                      i,
                                                      'state',
                                                      event.target.value,
                                                    )
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="Zip / Postal Code"
                                                  size="small"
                                                  value={data.location[i].zip || ''}
                                                  disabled={(data?.fromMapServices == true && data.location[i].zip) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].zip = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    handleProductLocationFieldChange(
                                                      data,
                                                      i,
                                                      'zip',
                                                      event.target.value,
                                                    )
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          ))}
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                          {/* {(data?.fromMapServices == true) ? '' : (i !== 0 && data?.allLocationSame) ? '' : */}
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton variant="contained" onClick={() => {
                                                setIsSaving(true)
                                                setTimeout(() => {
                                                  setIsSaving(false)
                                                  setLocationStates(false)
                                                }, 100)
                                              }} loading={isSaving} disabled={tmInvoicingFieldDisabled}>
                                                {' Save '}
                                              </LoadingButton>
                                            </Box>
                                            {/* } */}
                                          </Grid>
                                        </Grid>
                                        </Box>
                                      </Modal>
                                      <Modal
                                        open={
                                          openProductAttachment[data.indexId] ||
                                          false
                                        }
                                        handleClose={() =>
                                          handleCloseAttachment(data.indexId)
                                        }
                                      >
                                        {renderAttachmentModalContent({
                                          itemKey: String(data.indexId),
                                          tabValue: attachmentTabValue[data.indexId],
                                          onTabChange: handleAttachmentTabChange,
                                          selectedImages:
                                            selectedUploadedImages[String(data.indexId)] ||
                                            selectedUploadedImages[data.indexId] ||
                                            [],
                                          linkedAttachments: getProductAttachmentsList(data.indexId),
                                          onImageSelect: handleImageSelect,
                                          onAddSelected: handleAddSelectedImages,
                                          onDrop: handleProductDrop,
                                          onRemove: handleProductRemove,
                                          isUploadingItem: isUploadingProduct[data.indexId] || false,
                                          disabled: tmInvoicingFieldDisabled,
                                        })}
                                      </Modal>
                                  </>
                                );
                                };

                                const renderOfficialRequestInstallationTableCell = (data, keyPrefix) => {
                                  if (!data) {
                                    return (
                                      <TableCell key={keyPrefix} align="center">
                                        -
                                      </TableCell>
                                    )
                                  }
                                  return (
                                    <TableCell key={keyPrefix} align="center">
                                      {isSplitOrder && Number(data?.facility_id) !== Number(currentFacilityId) ? (
                                        Number(data?.facility_id) !== Number(currentFacilityId) ? (
                                          <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                            <Button
                                              size="small"
                                              variant={
                                                data?.delivery_installation?.installer_facility_id
                                                  ? 'contained'
                                                  : 'outlined'
                                              }
                                              onClick={() => openDeliveryInstallDialog(data)}
                                              disabled={details?.allInstallationCompleted == 1 || tmInvoicingFieldDisabled}
                                            >
                                              {data?.delivery_installation?.installer_facility_id ? 'Edit' : 'Set'}
                                            </Button>
                                            {data?.delivery_installation?.installer_facility_id ? (
                                              <Tooltip
                                                title={`${deliveryTypeLabelById(
                                                  data?.delivery_installation?.delivery_type_id ||
                                                    data?.delivery_installation?.complete_status,
                                                )} • ${
                                                  data?.delivery_installation?.installer_facility_name ||
                                                  getFacilityOption(data?.delivery_installation?.installer_facility_id)
                                                    ?.name ||
                                                  ''
                                                }`}
                                              >
                                                <Typography variant="caption" noWrap sx={{ maxWidth: 140 }}>
                                                  {deliveryTypeLabelById(
                                                    data?.delivery_installation?.delivery_type_id ||
                                                      data?.delivery_installation?.complete_status,
                                                  )}
                                                  {' • '}
                                                  {data?.delivery_installation?.installer_facility_name ||
                                                    getFacilityOption(data?.delivery_installation?.installer_facility_id)
                                                      ?.name ||
                                                    ''}
                                                </Typography>
                                              </Tooltip>
                                            ) : null}
                                          </Stack>
                                        ) : (
                                          '-'
                                        )
                                      ) : isDedicatedGroupedParent ? (
                                        '-'
                                      ) : (
                                        <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                          <Button
                                            size="small"
                                            variant={
                                              data?.delivery_installation?.delivery_type_id ? 'contained' : 'outlined'
                                            }
                                            onClick={() => openDeliveryTypeDialog(data, 'product')}
                                            sx={{ textAlign: 'center' }}
                                            disabled={details?.allInstallationCompleted == 1 || tmInvoicingFieldDisabled}
                                          >
                                            {data?.delivery_installation?.delivery_type_id ? 'Edit' : 'Set'}
                                          </Button>
                                          {data?.delivery_installation?.delivery_type_id ||
                                          data?.delivery_installation?.complete_status ? (
                                            <Tooltip
                                              title={`${deliveryTypeLabelById(
                                                data?.delivery_installation?.delivery_type_id ||
                                                  data?.delivery_installation?.complete_status,
                                              )}`}
                                            >
                                              <Typography variant="caption" noWrap sx={{ maxWidth: 140 }}>
                                                {deliveryTypeLabelById(
                                                  data?.delivery_installation?.delivery_type_id ||
                                                    data?.delivery_installation?.complete_status,
                                                )}
                                              </Typography>
                                            </Tooltip>
                                          ) : null}
                                        </Stack>
                                      )}
                                    </TableCell>
                                  )
                                }

                                return (
                                  <>
                                    {productTableBodyRenderOrder.map((bodyItem, index) => {
                                  if (bodyItem.type === 'group') {
                                    const group = groupedSelectedProductsMap.get(bodyItem.groupId)
                                    if (!group) return null
                                    const anchorId = getGroupAnchorIndexId(group)
                                    const anchorProduct =
                                      (group.products || []).find(
                                        (p) => Number(p?.indexId) === Number(anchorId),
                                      ) || (group.products || [])[0]
                                    const groupMemberProducts = (selectedProducts || []).filter(
                                      (p) =>
                                        String(getProductGroupId(p) || '') === String(group.id),
                                    )
                                    const groupDisplayNote =
                                      groupMemberProducts.find(
                                        (p) =>
                                          p?.product_notes != null &&
                                          String(p.product_notes).trim() !== '',
                                      )?.product_notes || ''
                                    const isGroupOpen = openGroupedRows?.[group.id] === true
                                    const groupHasAttachments =
                                      anchorId != null && getProductAttachmentsList(anchorId).length > 0
                                    const groupQty = Number(group.groupQuantity || 1)
                                    const groupFormulaEach = Number(group.totalProductFormulaEach || 0)
                                    const groupRetailEach = Number(group.adjustedGroupRetailEach || 0)
                                    const groupSubTotal = Number(group.adjustedGroupSubtotal || 0)
                                    const groupInstallSubtotal = Number(group.adjustedGroupInstallSubtotal || 0)
                                    const groupTotal = Number(group.adjustedGroupTotal || 0)
                                    const cols = visibleOfficialRequestProductColumns
                                    const visibleColumnCount = cols.length
                                    const groupHasAnyQuickbooks = (group.products || []).some(
                                      (p) => Number(p?.syncWithQuickbooks) === 1,
                                    )
                                    const {
                                      isGroupProductLosingMoney,
                                      isGroupInstallLosingMoney,
                                    } = getGroupLosingMoneyFlags(group)
                                    const groupProductLosingMoneyRowSx = getLosingMoneyRowSx(
                                      isGroupProductLosingMoney,
                                    )
                                    const groupInstallLosingMoneyRowSx = getLosingMoneyRowSx(
                                      isGroupInstallLosingMoney,
                                    )
                                    return (
                                      <Draggable
                                        key={`group-${group.id}`}
                                        draggableId={`group-${group.id}`}
                                        index={index}
                                        isDragDisabled={!editFormValuesEnabled}
                                      >
                                        {(provided, snapshot) => (
                                      <React.Fragment key={`group-${group.id}`}>
                                        <TableRow
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          onDragEnterCapture={(e) =>
                                            anchorId != null && handleProductIconDragOver(e, anchorId)
                                          }
                                          onDragOverCapture={(e) =>
                                            anchorId != null && handleProductIconDragOver(e, anchorId)
                                          }
                                          onDragLeave={(e) =>
                                            anchorId != null && handleProductIconDragLeave(e, anchorId)
                                          }
                                          onDropCapture={(e) =>
                                            anchorId != null && handleProductIconDrop(e, anchorId)
                                          }
                                          sx={{
                                            ...(groupProductLosingMoneyRowSx || groupInstallLosingMoneyRowSx),
                                            ...(anchorId != null && productAttachmentDragOver[anchorId] && {
                                              backgroundColor: 'action.hover',
                                              outline: `2px dashed ${theme.palette.primary.main}`,
                                              outlineOffset: -2,
                                            }),
                                          }}
                                          style={{
                                            ...provided.draggableProps.style,
                                            ...(snapshot.isDragging
                                              ? { backgroundColor: theme.palette.action.hover }
                                              : {}),
                                          }}
                                        >
                                          {editFormValuesEnabled && (
                                            <TableCell
                                              padding="checkbox"
                                              {...provided.dragHandleProps}
                                              sx={{ width: 40, cursor: 'grab' }}
                                            >
                                              <DragIndicator fontSize="small" color="action" />
                                            </TableCell>
                                          )}
                                          {cols.map((val) => {
                                            if (val.id === 1) {
                                              return (
                                                <TableCell key={`g-${group.id}-c1`} sx={{ fontWeight: 700 }}>
                                                  <Stack direction="row" spacing={1} alignItems="center">
                                                    {/* <IconButton
                                                      size="small"
                                                      onClick={() =>
                                                        setOpenGroupedRows((prev) => ({
                                                          ...prev,
                                                          [group.id]: prev?.[group.id] !== true,
                                                        }))
                                                      }
                                                    >
                                                      {isGroupOpen ? <Remove fontSize="small" /> : <Add fontSize="small" />}
                                                    </IconButton> */}
                                                    <span>#{index + 1}</span>
                                                  </Stack>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 22) {
                                              return (
                                                <TableCell key={`g-${group.id}-c22`}>
                                                  <div
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      width: 40,
                                                      height: 20,
                                                    }}
                                                  >
                                                    {groupHasAnyQuickbooks ? (
                                                      <img
                                                        src={quickbookLogo}
                                                        alt="QuickBooks"
                                                        style={{
                                                          width: '100%',
                                                          height: '100%',
                                                          objectFit: 'contain',
                                                        }}
                                                      />
                                                    ) : null}
                                                  </div>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 2) {
                                              return (
                                                <TableCell key={`g-${group.id}-c2`} sx={{ fontWeight: 700 }}>
                                                  <Box>
                                                    <Typography sx={{ fontWeight: 700 }}>
                                                      {group.name || 'Group'}
                                                    </Typography>
                                                    {groupDisplayNote ? (
                                                      <Typography
                                                        sx={{
                                                          color: theme.palette.error.main,
                                                        }}
                                                      >
                                                        Note: {groupDisplayNote}
                                                      </Typography>
                                                    ) : null}
                                                  </Box>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 3) {
                                              return (
                                                <TableCell key={`g-${group.id}-c3`}>
                                                  <Stack direction="row" spacing={1} alignItems="center">
                                                    {anchorId != null ? (
                                                      <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                          handleOpenNote(
                                                            anchorId,
                                                            groupDisplayNote || '',
                                                            true,
                                                          )
                                                        }}
                                                      >
                                                        <NoteAdd
                                                          style={{
                                                            color: !groupDisplayNote
                                                              ? undefined
                                                              : theme.palette.primary.main,
                                                          }}
                                                        />
                                                      </IconButton>
                                                    ) : null}
                                                  </Stack>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 19) {
                                              return (
                                                <TableCell key={`g-${group.id}-c19`}>
                                                  {anchorId != null ? (
                                                    <Tooltip title="Drop files on row or click to open attachments">
                                                      <IconButton
                                                        size="small"
                                                        onClick={() => handleOpenAttachment(anchorId)}
                                                      >
                                                        {isUploadingProduct[anchorId] ? (
                                                          <CircularProgress size={34} />
                                                        ) : (
                                                          <UploadFile
                                                            style={{
                                                              color: groupHasAttachments
                                                                ? theme.palette.primary.main
                                                                : theme.palette.error.main,
                                                            }}
                                                          />
                                                        )}
                                                      </IconButton>
                                                    </Tooltip>
                                                  ) : (
                                                    '-'
                                                  )}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 5) {
                                              return (
                                                <TableCell key={`g-${group.id}-c5`}>
                                                  {Number(groupFormulaEach || 0).toFixed(2)}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 20 || val.id === 16) {
                                              return <TableCell key={`g-${group.id}-c${val.id}`}>-</TableCell>
                                            }
                                            if (val.id === 6 || val.id === 7) {
                                              const isRetailIteration =
                                                (markupType == 2 && val.id === 6) || (markupType == 1 && val.id === 7)
                                              if (!isRetailIteration) {
                                                return (
                                                  <TableCell key={`g-${group.id}-c${val.id}-empty`}>-</TableCell>
                                                )
                                              }
                                              return (
                                                <TableCell key={`g-${group.id}-c${val.id}`}>
                                                  {hasMarkupPermission ? (
                                                    <TextField
                                                      required
                                                      fullWidth
                                                      type="number"
                                                      label={'Retail Price Each'}
                                                      sx={{ width: 120 }}
                                                      value={
                                                        groupProductRetailDrafts[group.id] != null &&
                                                        groupProductRetailDrafts[group.id] !== ''
                                                          ? limitDecimalInput(
                                                              groupProductRetailDrafts[group.id],
                                                            )
                                                          : formatRetailPriceDisplay(
                                                              groupRetailEach || 0,
                                                            )
                                                      }
                                                      onFocus={selectInputValue}
                                                      onClick={selectInputValue}
                                                      onKeyPress={(event) => {
                                                        if (event.key === '-') {
                                                          event.preventDefault()
                                                        }
                                                        if (event.key === 'e') {
                                                          event.preventDefault()
                                                        }
                                                      }}
                                                      inputProps={{ min: 0 }}
                                                      defaultValue={0}
                                                      onChange={(event) => {
                                                        handleGroupRetailPriceChange(
                                                          group.id,
                                                          event.target.value,
                                                        )
                                                      }}
                                                      onBlur={(event) => {
                                                        handleGroupRetailPriceChange(
                                                          group.id,
                                                          event.target.value,
                                                          { isBlur: true },
                                                        )
                                                      }}
                                                    />
                                                  ) : null}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 10) {
                                              return (
                                                <TableCell key={`g-${group.id}-c10`}>
                                                  <TextField
                                                    type="number"
                                                    // size="small"
                                                    sx={{ minWidth: 84 }}
                                                    label="Qty"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={groupQty}
                                                    onChange={(e) =>
                                                      handleGroupQuantityChange(group.id, e.target.value)
                                                    }
                                                  />
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 18) {
                                              return renderOfficialRequestInstallationTableCell(
                                                anchorProduct,
                                                `g-${group.id}-c18`,
                                              )
                                            }
                                            if (val.id === 11) {
                                              return (
                                                <TableCell key={`g-${group.id}-c11`}>
                                                  {anchorId != null ? (
                                                    <IconButton
                                                      size="small"
                                                      onClick={() => {
                                                        const groupQty = Math.max(
                                                          1,
                                                          Number(group?.groupQuantity || 1),
                                                        )
                                                        const isSingle = Boolean(
                                                          group?.groupIsSingleCard ??
                                                            anchorProduct?.is_single_card,
                                                        )
                                                        const allSame = Boolean(
                                                          group?.groupAllLocationSame ??
                                                            anchorProduct?.allLocationSame,
                                                        )
                                                        const sourceAddr =
                                                          (group?.groupAddresses &&
                                                          group.groupAddresses.length > 0
                                                            ? group.groupAddresses
                                                            : null) ||
                                                          anchorProduct?.location ||
                                                          []
                                                        const templateAddresses =
                                                          buildGroupAddressesForProduct(
                                                            {
                                                              ...anchorProduct,
                                                              locationQuantity: groupQty,
                                                            },
                                                            sourceAddr,
                                                            {
                                                              allLocationSame: allSame,
                                                              isSingleCard: isSingle,
                                                              locationQuantity: groupQty,
                                                            },
                                                          )
                                                        setSelectedProducts((prev) =>
                                                          (prev || []).map((p) =>
                                                            String(getProductGroupId(p) || '') ===
                                                            String(group.id)
                                                              ? {
                                                                  ...p,
                                                                  allLocationSame: allSame,
                                                                  is_single_card: isSingle,
                                                                  location: templateAddresses,
                                                                }
                                                              : p,
                                                          ),
                                                        )
                                                        setCustomerOrderProductGroups((prev) => {
                                                          const list = prev || []
                                                          const idx = list.findIndex(
                                                            (g) =>
                                                              String(g?.id ?? g?.group_id) ===
                                                              String(group.id),
                                                          )
                                                          const metaPatch = {
                                                            group_addresses: templateAddresses,
                                                            group_all_location_same: allSame ? 1 : 0,
                                                            group_is_single_card: isSingle ? 1 : 0,
                                                          }
                                                          if (idx === -1) {
                                                            return [
                                                              ...list,
                                                              {
                                                                id: group.id,
                                                                group_id: group.id,
                                                                ...metaPatch,
                                                              },
                                                            ]
                                                          }
                                                          return list.map((g, i) =>
                                                            i === idx ? { ...g, ...metaPatch } : g,
                                                          )
                                                        })
                                                        setLocationStates((prev) => ({
                                                          ...prev,
                                                          [anchorId]: true,
                                                        }))
                                                      }}
                                                    >
                                                      <LocationOn
                                                        style={{
                                                          color: (
                                                            group?.groupAddresses ||
                                                            anchorProduct?.location ||
                                                            []
                                                          )?.some((obj) =>
                                                            [obj.address, obj.city, obj.state, obj.zip].some(
                                                              (value) => value === '' || value === null,
                                                            ),
                                                          )
                                                            ? undefined
                                                            : theme.palette.primary.main,
                                                        }}
                                                      />
                                                    </IconButton>
                                                  ) : (
                                                    '-'
                                                  )}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 17) {
                                              return (
                                                <TableCell key={`g-${group.id}-c17`}>
                                                  <Stack direction="row" spacing={1} alignItems="center">
                                                    <Remove
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() => handleGroupMarketingTypeChange(group.id, false)}
                                                    />
                                                    <Switch
                                                      checked={
                                                        !(
                                                          group.groupAdjValueType === false ||
                                                          Number(group.groupAdjValueType) === 0
                                                        )
                                                      }
                                                      onChange={(e) =>
                                                        handleGroupMarketingTypeChange(group.id, e.target.checked)
                                                      }
                                                    />
                                                    <Add
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() => handleGroupMarketingTypeChange(group.id, true)}
                                                    />
                                                  </Stack>
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 12) {
                                              return (
                                                <TableCell key={`g-${group.id}-c12`}>
                                                  <TextField
                                                    type="number"
                                                    // size="small"
                                                    fullWidth
                                                    inputProps={{ min: 0 }}
                                                    label="$"
                                                    value={Number(group.groupAdjustment) || null}
                                                    onChange={(e) =>
                                                      handleGroupMarketingAdjustmentChange(group.id, e.target.value)
                                                    }
                                                  />
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 13) {
                                              return (
                                                <TableCell key={`g-${group.id}-c13`}>
                                                  {Number(groupSubTotal || 0).toFixed(2)}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 14) {
                                              return (
                                                <TableCell key={`g-${group.id}-c14`}>
                                                  {Number(groupInstallSubtotal || 0) > 0
                                                    ? ''
                                                    : Number(groupTotal || 0).toFixed(2)}
                                                </TableCell>
                                              )
                                            }
                                            if (val.id === 15) {
                                              return (
                                                <TableCell key={`g-${group.id}-c15`}>
                                                  {anchorProduct?.fromMapServices == true ? (
                                                    ''
                                                  ) : (
                                                    <IconButton size="small" onClick={() => handleDeleteGroup(group.id)}>
                                                      <Delete />
                                                    </IconButton>
                                                  )}
                                                </TableCell>
                                              )
                                            }
                                            return <TableCell key={`g-${group.id}-cx-${val.id}`}>-</TableCell>
                                          })}
                                        </TableRow>
                                        {Number(groupInstallSubtotal || 0) > 0 ? (
                                          <TableRow sx={groupProductLosingMoneyRowSx || groupInstallLosingMoneyRowSx}>
                                            {editFormValuesEnabled && (
                                              <TableCell padding="checkbox" sx={{ width: 40 }} />
                                            )}
                                            {cols.map((val) => {
                                              if (val.id === 1 || val.id === 18) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c${val.id}`}>-</TableCell>
                                                )
                                              }
                                              if (val.id === 22) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c22`}>
                                                    <div
                                                      style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: 40,
                                                        height: 20,
                                                      }}
                                                    >
                                                      {groupHasAnyQuickbooks ? (
                                                        <img
                                                          src={quickbookLogo}
                                                          alt="QuickBooks"
                                                          style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain',
                                                          }}
                                                        />
                                                      ) : null}
                                                    </div>
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 15) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c15`}>
                                                    <IconButton
                                                      size="small"
                                                      onClick={() => handleDeleteGroupInstall(group.id)}
                                                    >
                                                      <Delete />
                                                    </IconButton>
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 2) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c2`} sx={{ fontWeight: 600 }}>
                                                    Install Price
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 3) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c3`}>
                                                    {anchorId != null ? (
                                                      <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                          handleOpenInstallNote(
                                                            anchorId,
                                                            anchorProduct?.install_notes || '',
                                                            true,
                                                          )
                                                        }}
                                                      >
                                                        <NoteAdd
                                                          style={{
                                                            color: !anchorProduct?.install_notes
                                                              ? undefined
                                                              : theme.palette.primary.main,
                                                          }}
                                                        />
                                                      </IconButton>
                                                    ) : (
                                                      '-'
                                                    )}
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 19) {
                                                return <TableCell key={`gi-${group.id}-c19`}>-</TableCell>
                                              }
                                              if (val.id === 4) {
                                                return <TableCell key={`gi-${group.id}-c4`}>-</TableCell>
                                              }
                                              if (val.id === 5) {
                                                const installFormulaEach = (group.products || []).reduce(
                                                  (sum, p) => sum + Number(p?.expected_install_labor_cost_with_markup || 0),
                                                  0,
                                                )
                                                return (
                                                  <TableCell key={`gi-${group.id}-c5`} sx={{ fontWeight: 600 }}>
                                                    {installFormulaEach.toFixed(2)}
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 20 || val.id === 16) {
                                                return <TableCell key={`gi-${group.id}-c${val.id}`}>-</TableCell>
                                              }
                                              if (val.id === 6 || val.id === 7) {
                                                const isRetailIteration =
                                                  (markupType == 2 && val.id === 6) || (markupType == 1 && val.id === 7)
                                                if (!isRetailIteration) {
                                                  return null
                                                }
                                                const installRetailEach = Number(
                                                  group.adjustedGroupInstallRetailEach || 0,
                                                )
                                                return (
                                                  <TableCell key={`gi-${group.id}-c${val.id}`} sx={{ fontWeight: 600 }}>
                                                    {hasMarkupPermission ? (
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label={'Install Price Each'}
                                                        sx={{ width: 120 }}
                                                        value={
                                                          groupInstallRetailDrafts[group.id] != null &&
                                                          groupInstallRetailDrafts[group.id] !== ''
                                                            ? groupInstallRetailDrafts[group.id]
                                                            : installRetailEach
                                                        }
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(event) => {
                                                          if (event.key === '-') {
                                                            event.preventDefault()
                                                          }
                                                          if (event.key === 'e') {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        inputProps={{ min: 0 }}
                                                        defaultValue={0}
                                                        onChange={(event) => {
                                                          handleGroupInstallRetailPriceChange(
                                                            group.id,
                                                            event.target.value,
                                                          )
                                                        }}
                                                        onBlur={(event) => {
                                                          handleGroupInstallRetailPriceChange(
                                                            group.id,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }}
                                                      />
                                                    ) : null}
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 10) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c10`} sx={{ fontWeight: 600 }}>
                                                    <TextField
                                                      type="number"
                                                      size="small"
                                                      fullWidth
                                                      sx={{ minWidth: 84 }}
                                                      label="Qty"
                                                      InputLabelProps={{ shrink: true }}
                                                      value={Number(group.groupInstallQuantity || 1)}
                                                      onChange={(e) =>
                                                        handleGroupInstallQuantityChange(group.id, e.target.value)
                                                      }
                                                    />
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 11) {
                                                return <TableCell key={`gi-${group.id}-c11`} />
                                              }
                                              if (val.id === 17) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c17`}>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                      <Remove
                                                        fontSize="small"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() =>
                                                          handleGroupInstallMarketingTypeChange(group.id, false)
                                                        }
                                                      />
                                                      <Switch
                                                        checked={
                                                          !(
                                                            group.groupInstallAdjValueType === false ||
                                                            Number(group.groupInstallAdjValueType) === 0
                                                          )
                                                        }
                                                        onChange={(e) =>
                                                          handleGroupInstallMarketingTypeChange(
                                                            group.id,
                                                            e.target.checked,
                                                          )
                                                        }
                                                      />
                                                      <Add
                                                        fontSize="small"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() =>
                                                          handleGroupInstallMarketingTypeChange(group.id, true)
                                                        }
                                                      />
                                                    </Stack>
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 12) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c12`}>
                                                    <TextField
                                                      type="number"
                                                      // size="small"
                                                      fullWidth
                                                      inputProps={{ min: 0 }}
                                                      label="$"
                                                      value={Number(group.groupInstallAdjustment) || null}
                                                      onChange={(e) =>
                                                        handleGroupInstallMarketingAdjustmentChange(
                                                          group.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 13) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c13`} sx={{ fontWeight: 600 }}>
                                                    {groupInstallSubtotal.toFixed(2)}
                                                  </TableCell>
                                                )
                                              }
                                              if (val.id === 14) {
                                                return (
                                                  <TableCell key={`gi-${group.id}-c14`} sx={{ fontWeight: 600 }}>
                                                    {(groupSubTotal + groupInstallSubtotal).toFixed(2)}
                                                  </TableCell>
                                                )
                                              }
                                              return <TableCell key={`gi-${group.id}-cx-${val.id}`}>-</TableCell>
                                            })}
                                          </TableRow>
                                        ) : null}
                                        {isGroupOpen &&
                                          [...(group.products || [])]
                                            .sort((a, b) => (a?.indexId || 0) - (b?.indexId || 0))
                                            .map((member, memberIdx) => {
                                              const memberRetailEach =
                                                Number(
                                                  markupType == 2
                                                    ? member?.actual_retail_price || member?.retail_price || 0
                                                    : member?.product_price || member?.price || 0,
                                                ) || 0
                                              const memberQty = getGroupMemberProductQty(member)
                                              const memberProductSubtotal = memberRetailEach * memberQty
                                              const memberInstallEach = Number(member?.install_cost || 0)
                                              const memberInstallQty = getGroupMemberInstallQty(member)
                                              const memberInstallSubtotal = memberInstallEach * memberInstallQty
                                              const memberTotal = memberProductSubtotal + memberInstallSubtotal
                                              return (
                                                <React.Fragment key={`group-member-${group.id}-${member.indexId}`}>
                                                  <TableRow
                                                    onDragEnterCapture={(e) =>
                                                      handleProductIconDragOver(e, member.indexId)
                                                    }
                                                    onDragOverCapture={(e) =>
                                                      handleProductIconDragOver(e, member.indexId)
                                                    }
                                                    onDragLeave={(e) =>
                                                      handleProductIconDragLeave(e, member.indexId)
                                                    }
                                                    onDropCapture={(e) =>
                                                      handleProductIconDrop(e, member.indexId)
                                                    }
                                                    sx={{
                                                      ...(productAttachmentDragOver[member.indexId] && {
                                                        backgroundColor: 'action.hover',
                                                        outline: `2px dashed ${theme.palette.primary.main}`,
                                                        outlineOffset: -2,
                                                      }),
                                                    }}
                                                  >
                                                    {editFormValuesEnabled && (
                                                      <TableCell padding="checkbox" sx={{ width: 40 }} />
                                                    )}
                                                    {cols.map((val) => {
                                                      if (val.id === 1) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c1`}>
                                                            {`#${index + 1}.${memberIdx + 1}`}
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 22) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c22`}>
                                                            <div
                                                              style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: 40,
                                                                height: 20,
                                                              }}
                                                            >
                                                              {Number(member?.syncWithQuickbooks) === 1 ? (
                                                                <img
                                                                  src={quickbookLogo}
                                                                  alt="QuickBooks"
                                                                  style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'contain',
                                                                  }}
                                                                />
                                                              ) : null}
                                                            </div>
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 2) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c2`}>
                                                            {getInvoiceProductDisplayName(member) || '-'}
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 3) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c3`}>
                                                            <IconButton
                                                              onClick={() =>
                                                                handleOpenNote(member.indexId, member.product_notes)
                                                              }
                                                            >
                                                              <NoteAdd
                                                                style={{
                                                                  color:
                                                                    !member?.product_notes || member?.product_notes === ''
                                                                      ? undefined
                                                                      : theme.palette.primary.main,
                                                                }}
                                                              />
                                                            </IconButton>
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 19) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c19`}>
                                                            <Tooltip title="Drop files on row or click to open attachments">
                                                              <IconButton onClick={() => handleOpenAttachment(member.indexId)}>
                                                                {isUploadingProduct[member.indexId] ? (
                                                                  <CircularProgress size={34} />
                                                                ) : (
                                                                  <UploadFile
                                                                    style={{
                                                                      color:
                                                                        getProductAttachmentsList(member.indexId).length > 0
                                                                          ? theme.palette.primary.main
                                                                          : theme.palette.error.main,
                                                                    }}
                                                                  />
                                                                )}
                                                              </IconButton>
                                                            </Tooltip>
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 5) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c5`}>
                                                            {member?.product_formula_cost_each != null &&
                                                            member?.product_formula_cost_each !== ''
                                                              ? Number(member.product_formula_cost_each).toFixed(2)
                                                              : (
                                                                  (member?.expected_material_cost_with_markup || 0) +
                                                                  (member?.expected_service_cost_with_markup || 0)
                                                                ).toFixed(2)}
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 20 || val.id === 16) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c${val.id}`}>
                                                            -
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 6 || val.id === 7) {
                                                        const isRetailIteration =
                                                          (markupType == 2 && val.id === 6) ||
                                                          (markupType == 1 && val.id === 7)
                                                        if (!isRetailIteration) {
                                                          return (
                                                            <TableCell key={`gm-${group.id}-${member.indexId}-c${val.id}-empty`}>
                                                              -
                                                            </TableCell>
                                                          )
                                                        }
                                                        const cellVal = hasMarkupPermission
                                                          ? memberRetailEach.toFixed(2)
                                                          : null
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c${val.id}`}>
                                                            {cellVal}
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 10) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c10`}>
                                                            {memberQty}
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 18) {
                                                        return renderOfficialRequestInstallationTableCell(
                                                          member,
                                                          `gm-${group.id}-${member.indexId}-c18`,
                                                        )
                                                      }
                                                      if (val.id === 11) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c11`} align="center">
                                                            <Tooltip
                                                              title={
                                                                member?.location
                                                                  ?.map((loc) => loc.address)
                                                                  .filter(Boolean)
                                                                  .join(', ') || 'No locations'
                                                              }
                                                            >
                                                              <LocationOn
                                                                sx={{
                                                                  color: member?.location?.length
                                                                    ? theme.palette.primary.main
                                                                    : '',
                                                                }}
                                                              />
                                                            </Tooltip>
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 17) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c17`}>
                                                            <Stack
                                                              direction="row"
                                                              spacing={1}
                                                              alignItems="center"
                                                              sx={{ color: 'text.secondary', opacity: 0.7 }}
                                                            >
                                                              <Remove fontSize="small" />
                                                              <Switch
                                                                checked={getNestedLineMarketingAdjValueType(
                                                                  member,
                                                                  markupType,
                                                                  'product',
                                                                )}
                                                                disabled
                                                              />
                                                              <Add fontSize="small" />
                                                            </Stack>
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 12) {
                                                        return (
                                                          <TableCell
                                                            key={`gm-${group.id}-${member.indexId}-c12`}
                                                            align="center"
                                                          >
                                                            {formatNestedMarketingAdjustmentDisplay(
                                                              getNestedLineMarketingAdjustmentValue(
                                                                member,
                                                                markupType,
                                                                'product',
                                                              ),
                                                            )}
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 15) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c15`} />
                                                        )
                                                      }
                                                      if (val.id === 13) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c13`}>
                                                            {memberProductSubtotal.toFixed(2)}
                                                          </TableCell>
                                                        )
                                                      }
                                                      if (val.id === 14) {
                                                        return (
                                                          <TableCell key={`gm-${group.id}-${member.indexId}-c14`}>
                                                            {memberInstallEach > 0 ? '' : memberProductSubtotal.toFixed(2)}
                                                          </TableCell>
                                                        )
                                                      }
                                                      return (
                                                        <TableCell key={`gm-${group.id}-${member.indexId}-cx-${val.id}`}>
                                                          -
                                                        </TableCell>
                                                      )
                                                    })}
                                                  </TableRow>
                                                  {memberInstallEach > 0 ? (
                                                    <TableRow>
                                                      {editFormValuesEnabled && (
                                                        <TableCell padding="checkbox" sx={{ width: 40 }} />
                                                      )}
                                                      {cols.map((val) => {
                                                        if (
                                                          val.id === 1 ||
                                                          val.id === 22 ||
                                                          val.id === 18 ||
                                                          val.id === 15
                                                        ) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c${val.id}`}>
                                                              -
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 2) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c2`}>
                                                              Install Price
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 3) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c3`}>
                                                              <IconButton
                                                                onClick={() =>
                                                                  handleOpenInstallNote(member.indexId, member.install_notes)
                                                                }
                                                              >
                                                                <NoteAdd
                                                                  style={{
                                                                    color:
                                                                      !member?.install_notes || member.install_notes === ''
                                                                        ? undefined
                                                                        : theme.palette.primary.main,
                                                                  }}
                                                                />
                                                              </IconButton>
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 19) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c19`}>
                                                              -
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 4) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c4`}>
                                                              -
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 5) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c5`}>
                                                              {member?.install_formula_cost_each != null &&
                                                              member?.install_formula_cost_each !== ''
                                                                ? Number(member.install_formula_cost_each).toFixed(2)
                                                                : Number(
                                                                    member?.expected_install_labor_cost_with_markup || 0,
                                                                  ).toFixed(2)}
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 20 || val.id === 16) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c${val.id}`}>
                                                              -
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 6 || val.id === 7) {
                                                          const isRetailIteration =
                                                            (markupType == 2 && val.id === 6) ||
                                                            (markupType == 1 && val.id === 7)
                                                          if (!isRetailIteration) {
                                                            return null
                                                          }
                                                          const cellVal = hasMarkupPermission
                                                            ? memberInstallEach.toFixed(2)
                                                            : null
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c${val.id}`}>
                                                              {cellVal}
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 10) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c10`}>
                                                              {memberInstallQty}
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 11) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c11`}>
                                                              -
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 17) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c17`}>
                                                              <Stack
                                                                direction="row"
                                                                spacing={1}
                                                                alignItems="center"
                                                                sx={{ color: 'text.secondary', opacity: 0.7 }}
                                                              >
                                                                <Remove fontSize="small" />
                                                                <Switch
                                                                  checked={getNestedLineMarketingAdjValueType(
                                                                    member,
                                                                    markupType,
                                                                    'install',
                                                                  )}
                                                                  disabled
                                                                />
                                                                <Add fontSize="small" />
                                                              </Stack>
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 12) {
                                                          return (
                                                            <TableCell
                                                              key={`gmi-${group.id}-${member.indexId}-c12`}
                                                              align="center"
                                                            >
                                                              {formatNestedMarketingAdjustmentDisplay(
                                                                getNestedLineMarketingAdjustmentValue(
                                                                  member,
                                                                  markupType,
                                                                  'install',
                                                                ),
                                                              )}
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 15) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c15`} />
                                                          )
                                                        }
                                                        if (val.id === 13) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c13`}>
                                                              {memberInstallSubtotal.toFixed(2)}
                                                            </TableCell>
                                                          )
                                                        }
                                                        if (val.id === 14) {
                                                          return (
                                                            <TableCell key={`gmi-${group.id}-${member.indexId}-c14`}>
                                                              {memberTotal.toFixed(2)}
                                                            </TableCell>
                                                          )
                                                        }
                                                        return (
                                                          <TableCell key={`gmi-${group.id}-${member.indexId}-cx-${val.id}`}>
                                                            -
                                                          </TableCell>
                                                        )
                                                      })}
                                                    </TableRow>
                                                  ) : null}
                                                </React.Fragment>
                                              )
                                            })}
                                        <TableRow>
                                          <TableCell colSpan={(visibleColumnCount || 1) + (editFormValuesEnabled ? 1 : 0)}>
                                            <Box sx={{ borderBottom: (t) => `solid 1px ${t.palette.divider}` }} />
                                          </TableCell>
                                        </TableRow>
                                      </React.Fragment>
                                        )}
                                      </Draggable>
                                    )
                                  }
                                  const data = selectedProducts.find((p) => p.indexId === bodyItem.indexId)
                                  if (!data) return null
                                  return renderOfficialRequestSalesOrderProductRow(data, index)
                                })}
                                {(selectedProducts || []).map((p) => {
                                  const id = p?.indexId
                                  if (id == null) return null
                                  return (
                                    <React.Fragment key={`so-product-note-modals-${id}`}>
                                      <Modal
                                        open={Boolean(openProductNote[id] ?? openProductNote[String(id)])}
                                        handleClose={() => handleCloseNote(id)}
                                      >
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                          <Grid item xs={12}>
                                            <Typography variant="h5" sx={{ mb: 2 }}>
                                              Note
                                            </Typography>
                                            <Stack
                                              direction={{ xs: 'column', sm: 'row' }}
                                              spacing={{ xs: 3, sm: 2 }}
                                              sx={{ mb: 2 }}
                                            >
                                              <TextField
                                                fullWidth
                                                multiline
                                                rows={4}
                                                size="medium"
                                                value={currentNote}
                                                onChange={handleNoteChange}
                                                error={!currentNote.trim() && currentNote.length > 0}
                                                inputProps={{ maxLength: MAX_CHARACTERS }}
                                                helperText={
                                                  !currentNote.trim() && currentNote.length > 0
                                                    ? 'Note cannot be empty or contain only spaces'
                                                    : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                }
                                                InputProps={{
                                                  sx: {
                                                    color: 'error.main',
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </Grid>
                                        </Grid>
                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton
                                                variant="contained"
                                                onClick={() => handleSaveNote(id)}
                                                loading={isSavingNote}
                                                disabled={!currentNote.trim()}
                                              >
                                                Save
                                              </LoadingButton>
                                              <LoadingButton
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleClearNote(id)}
                                                loading={isClearingNote}
                                                disabled={!currentNote.trim()}
                                              >
                                                Clear
                                              </LoadingButton>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                      <Modal
                                        open={Boolean(openInstallNote[id] ?? openInstallNote[String(id)])}
                                        handleClose={() => handleCloseInstallNote(id)}
                                      >
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                          <Grid item xs={12}>
                                            <Typography variant="h5" sx={{ mb: 2 }}>
                                              Install Note
                                            </Typography>
                                            <Stack
                                              direction={{ xs: 'column', sm: 'row' }}
                                              spacing={{ xs: 3, sm: 2 }}
                                              sx={{ mb: 2 }}
                                            >
                                              <TextField
                                                fullWidth
                                                multiline
                                                rows={4}
                                                size="medium"
                                                value={currentNote}
                                                onChange={handleNoteChange}
                                                error={!currentNote.trim() && currentNote.length > 0}
                                                inputProps={{ maxLength: MAX_CHARACTERS }}
                                                helperText={
                                                  !currentNote.trim() && currentNote.length > 0
                                                    ? 'Note cannot be empty or contain only spaces'
                                                    : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                }
                                                InputProps={{
                                                  sx: {
                                                    color: 'error.main',
                                                  },
                                                }}
                                              />
                                            </Stack>
                                          </Grid>
                                        </Grid>
                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton
                                                variant="contained"
                                                onClick={() => handleSaveInstallNote(id)}
                                                loading={isSavingNote}
                                                disabled={!currentNote.trim()}
                                              >
                                                Save
                                              </LoadingButton>
                                              <LoadingButton
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleClearInstallNote(id)}
                                                loading={isClearingNote}
                                                disabled={!currentNote.trim()}
                                              >
                                                Clear
                                              </LoadingButton>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                    </React.Fragment>
                                  )
                                })}
                                {(selectedProducts || [])
                                  .filter((p) => getProductGroupId(p))
                                  .map((p) => {
                                    const idx = selectedProducts.findIndex(
                                      (x) => Number(x?.indexId) === Number(p.indexId),
                                    )
                                    return (
                                      <React.Fragment key={`so-group-loc-attach-${p.indexId}`}>
                                        {renderOfficialRequestSalesOrderProductRow(
                                          p,
                                          idx >= 0 ? idx : 0,
                                          { modalsOnly: true },
                                        )}
                                      </React.Fragment>
                                    )
                                  })}
                                  </>
                                );
                              })()}
                                {droppableProvided.placeholder}
                              </TableBody>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        </>}   
                        </>}

                        <Divider />
                        <Stack direction='row'>
                          <LabelStyleHead>Services</LabelStyleHead>
                          {tmInvoicingFieldDisabled ? null : (showServices ? <Remove sx={{ color: theme.palette.primary.main }} onClick={(e) => { setShowServices(false) }} /> : <Add sx={{ color: theme.palette.primary.main }} onClick={(e) => { setShowServices(true) }} />)}
                        </Stack>
                        {showServices && <>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} alignItems={'center'}>
                            {isSplitOrder && (values?.facility_type || []).filter(Boolean).length > 1 ? (
                              <Stack sx={{ width: { xs: '100%', sm: '60%' } }} spacing={2}>
                                {(values?.facility_type || []).filter(Boolean).map((facility) => (
                                  <Autocomplete
                                    key={`service-autocomplete-${facility?.id}`}
                                    sx={{ width: '100%' }}
                                    multiple
                                    disabled={tmInvoicingFieldDisabled}
                                    id={`combo-box-demo-service-${facility?.id}`}
                                    options={getSplitFacilityServiceOptions(facility)}
                                    value={additionalSelectedServices?.filter((item) => (!item.isAdditionalProduct && Number(item?.facility_id) === Number(facility?.id)))}
                           
                                    onChange={(event, newValue) => {
                                      const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
                                      const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
                                      setAdditionalSelectedServices((prevServices) => {
                                        const additionals = prevServices?.filter(item => item.isAdditionalProduct === true || item.isAdditionalProduct === 1)
                                        const regularSelectedServices = prevServices?.filter((item) => !item.isAdditionalProduct) || [];
                                        const otherFacilities = regularSelectedServices?.filter((s) => Number(s?.facility_id) !== Number(facility?.id)) || [];
                                        const updatedServices = newValue?.map((service) => {
                                          const existingService = prevServices.find(
                                            (p) => p?.id === service?.id && p?.indexId === service?.indexId,
                                          )
                                          if (existingService) {
                                            let addresses = [...existingService?.addresses];
                                            for (let i = addresses.length; i < 1; i++) {
                                              addresses.push({
                                                id: i,
                                                address: '',
                                                city: '',
                                                state: '',
                                                zip: '',
                                              });
                                            }
                                            return {
                                              ...existingService,
                                              addresses,
                                            };
                                          } else {
                                            const assignedService = assignServiceAddresses(
                                              prevServices,
                                              service,
                                              allServiceLocationSame,
                                              communityAddress
                                            );
                                            const newIndexCounter = serviceIndexCounter + 1;
                                            setServiceIndexCounter(newIndexCounter);

                                            // Auto-apply existing delivery/installer settings for this facility
                                            const existingDeliverySettings = getExistingDeliverySettingsForFacility(facility?.id);

                                            return {
                                              ...assignedService,
                                              indexId: newIndexCounter,
                                              quantity: 1,
                                              ...(existingDeliverySettings && { delivery_installation: existingDeliverySettings })
                                            };
                                          }
                                        }) || [];
                                        const finalServices = [...otherFacilities, ...updatedServices, ...additionals];
                                        setFieldValue('services', finalServices);
                                        return finalServices;
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        error={Boolean(touched.services && errors.services)}
                                        helperText={touched.services && errors.services}
                                        label={`${values.project_category?.name == 'Service only' ? 'Select services' : 'Select additional services'} - ${facility?.label || ''}`}
                                      />
                                    )}
                                    getOptionLabel={(option) =>
                                      option?.name
                                        ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                        : ''
                                    }
                                    renderOption={(props, option) => {
                                      const { style, ...liProps } = props;
                                      const suffix = getLabourCostServiceTabLabel(option.inhouse);
                                      const label = `${option.name} (${suffix})`;
                                      return (
                                        <li
                                          {...liProps}
                                          style={{
                                            ...style,
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                            {option?.syncWithQuickbooks === 1 && (
                                              <img
                                                src={quickbookLogo}
                                                width="40px"
                                                height="20px"
                                                // style={{ marginRight: 8 }}
                                                alt="QuickBooks"
                                              />
                                            )}
                                          </div>
                                          <Tooltip title={label}>
                                            <span
                                              style={{
                                                flex: 1,
                                                minWidth: 0,
                                                display: 'block',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                color: theme.palette[
                                                  FacilityTypes.find(
                                                    (f) => f.id === option?.facility_id,
                                                  )?.color || 'primary'
                                                ]?.main,
                                              }}
                                            >
                                              {label}
                                            </span>
                                          </Tooltip>
                                        </li>
                                      );
                                    }}
                                    renderTags={(value, getTagProps) =>
                                      value.map((option, index) => {
                                        const suffix = getLabourCostServiceTabLabel(option.inhouse);
                                        const label = `${option.name} (${suffix})`;
                                        return (
                                          <Tooltip key={index} title={label}>
                                            <Chip
                                              sx={{
                                                color: theme.palette[
                                                  FacilityTypes.find(
                                                    (f) => f.id === option?.facility_id,
                                                  )?.color || 'primary'
                                                ]?.main,
                                              }}
                                              {...getTagProps({ index })}
                                              label={label}
                                            />
                                          </Tooltip>
                                        );
                                      })
                                    }
                                    filterOptions={(options, state) => {
                                      const searchText = state.inputValue.toLowerCase();
                                      return options.filter(
                                        (option) =>
                                          option.name.toLowerCase().includes(searchText) ||
                                          (option.description && option.description.toLowerCase().includes(searchText)) // Include description in search
                                      );
                                    }}
                                  />
                                ))}
                              </Stack>
                            ) : (
                              <Autocomplete
                                sx={{ width: 400 }}
                                multiple
                                disabled={tmInvoicingFieldDisabled}
                                id="combo-box-demo"
                                options={
                                  [...(filteredServices?.filter(item =>
                                    item.status === 1 &&
                                    Number(item.inhouse) !== 1
                                  ) || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                                }
                                value={additionalSelectedServices?.filter(item=>!item.isAdditionalProduct)}
                                onChange={(event, newValue) => {
                                  const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
                                  const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
                                  setFieldValue('services', newValue);
                                  setAdditionalSelectedServices((prevProducts) => {
                                    const additionals = prevProducts?.filter(item => item.isAdditionalProduct === true || item.isAdditionalProduct === 1)
                                    const updatedProducts = newValue?.map((product) => {
                                      const existingProduct = prevProducts.find(
                                        (p) => p?.id === product?.id && p?.indexId === product?.indexId
                                      );
                                      if (existingProduct) {
                                        let addresses = [...existingProduct?.addresses];
                                        for (let i = addresses.length; i < 1; i++) {
                                          addresses.push({
                                            id: i,
                                            address: '',
                                            city: '',
                                            state: '',
                                            zip: '',
                                          });
                                        }
                                        return {
                                          ...existingProduct,
                                          addresses,
                                        };
                                      } else {
                                        const assignedService = assignServiceAddresses(
                                          prevProducts,
                                          product,
                                          allServiceLocationSame,
                                          communityAddress
                                        );
                                        const newIndexCounter = serviceIndexCounter + 1;
                                        setServiceIndexCounter(newIndexCounter);

                                        // Auto-apply existing delivery/installer settings for this facility
                                        const existingDeliverySettings = getExistingDeliverySettingsForFacility(product.facility_id);

                                        return {
                                          ...assignedService,
                                          indexId: newIndexCounter,
                                          quantity: 1,
                                          ...(existingDeliverySettings && { delivery_installation: {... existingDeliverySettings,delivery_type_id: 1 } }),
                                          ...(!existingDeliverySettings && { delivery_installation: {delivery_type_id: 1, installer_facility_id: Number(currentFacilityId) } })
                                        };
                                      }
                                    });
                                    const finalServices = [...updatedProducts, ...additionals];
                                    return finalServices;
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} required
                                    error={Boolean(touched.services && errors.services)}
                                    helperText={touched.services && errors.services}
                                    label={
                                      values.project_category?.name == 'Service only'
                                      ? "Select services" : "Select additional services"
                                    } />
                                )}
                                getOptionLabel={(option) =>
                                  option?.name
                                    ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                    : ''
                                }
                                renderOption={(props, option) => {
                                  const { style, ...liProps } = props;
                                  const suffix = getLabourCostServiceTabLabel(option.inhouse);
                                  const label = `${option.name} (${suffix})`;
                                  return (
                                    <li
                                      {...liProps}
                                      style={{
                                        ...style,
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                          {option?.syncWithQuickbooks === 1 && (
                                            <img
                                              src={quickbookLogo}
                                              width="40px"
                                              height="20px"
                                              // style={{ marginRight: 8 }}
                                              alt="QuickBooks"
                                            />
                                          )}
                                        </div>
                                      <Tooltip title={label}>
                                        <span
                                          style={{
                                            flex: 1,
                                            minWidth: 0,
                                            display: 'block',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            color: isSplitOrder
                                              ? theme.palette[
                                                  FacilityTypes.find(
                                                    (f) => f.id === option?.facility_id,
                                                  )?.color || 'primary'
                                                ]?.main
                                              : 'inherit',
                                          }}
                                        >
                                          {label}
                                        </span>
                                      </Tooltip>
                                    </li>
                                  );
                                }}
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => {
                                    const suffix = getLabourCostServiceTabLabel(option.inhouse);
                                    const label = `${option.name} (${suffix})`;
                                    return (
                                      <Tooltip key={index} title={label}>
                                        <Chip
                                          sx={{
                                            color: isSplitOrder
                                              ? theme.palette[
                                                  FacilityTypes.find(
                                                    (f) => f.id === option?.facility_id,
                                                  )?.color || 'primary'
                                                ]?.main
                                              : 'inherit',
                                          }}
                                          {...getTagProps({ index })}
                                          label={label}
                                        />
                                      </Tooltip>
                                    );
                                  })
                                }
                                filterOptions={(options, state) => {
                                  const searchText = state.inputValue.toLowerCase();
                                  return options.filter(
                                    (option) =>
                                      option.name.toLowerCase().includes(searchText) ||
                                      (option.description && option.description.toLowerCase().includes(searchText)) // Include description in search
                                  );
                                }}
                              />
                            )}
                          </Stack>
                          <LabelStyle>Selected services</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                              {editFormValuesEnabled && (
                                      <TableCell padding="checkbox" sx={{ width: 40 }} />
                                    )}
                                    {/* {VALUE_SERVICES?.map((val) => (
                                      // ((values.project_category?.name == 'Time & Material') && val.id === 6) ? <TableCell></TableCell> : 
                                      (((values.project_category?.name == 'Service only') 
                                      // || 
                                      // (values.project_category?.name == 'Time & Material')
                                    
                                      && val.id === 0)
                                      // || ((values.project_category?.name !== 'Service only') && val.id === 6)
                                      ) ? null : (
                                        <TableCell>{val.value}</TableCell>
                                      ))
                                    )} */}
                                     {VALUE_SERVICES?.map((val) => {
                                      if (val.id === 4 && isSplitOrder) {
                                        return (
                                          <>
                                            <TableCell key={`${val.id}-cost`}>{val.value}</TableCell>
                                            <TableCell key={`${val.id}-incoming`}>Incoming Percentage</TableCell>
                                          </>
                                        );
                                      }
                                      if (val.id === 18) {
                                        return isSplitOrder ? (
                                          <TableCell key={val.id}>
                                            {val.value}
                                          </TableCell>
                                        ) : null;
                                      }
                                      return (
                                        <TableCell key={val.id}>
                                          {val.value}
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                </TableHead>

                                {/* <TableBody>
                                  {selectedServices?.map((data, index) => {
                                    const quantityFieldName = `service_quantity_${index}`;
                                    // if(values.project_category?.name == 'Time & Material'){
                                    //   data['total_cost'] = 0
                                    //   data['unit_cost'] = 0
                                    //   data['cost'] = 0
                                    //   data['quantity'] = 0
                                    // }
                                    const dataCost = data.unit_cost || data.total_cost
                                    const total = dataCost * data.quantity
                                    totalAmount += total
                                    data['totalAmount'] = totalAmount?.toFixed(2)
                                    let markup = 0
                                    if(total > 0){
                                      markup = dataCost / total
                                    }
                                    data['markup'] = markup?.toFixed(2)
                                    totalServiceMarkup += markup
                                    data['total'] = total?.toFixed(2)
                                    data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    let originalMarkup = data.originalMarkup || 0
                                    originaltotalServiceMarkup += originalMarkup
                                    // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    console.log("############WWWWW", originalMarkup);
                                    let qtyData = data.qtyData || 1
                                    console.log("############qtyData", qtyData);
                                    const previousQty = data.prQty*qtyData * (data.locationQuantity||1);
                                    const newQty = (data.prQty * qtyData * data.locationQuantity || 1)?.toFixed(2)
                                    let quantityDifference = 0
                                    if(values.project_category?.name == 'Time & Material'){
                                      // quantityDifference = 0
                                      quantityDifference = Number(data.quantity) - newQty;
                                    }else{
                                      quantityDifference = Number(data.quantity) - newQty;
                                    }
                                    data['quantityDifference'] = quantityDifference
                                    data['jobcost_unit_cost'] = data.cost
                                    data['jobcost_quantity'] = quantityDifference
                                    data['jobcost_total_cost'] = (data.cost*Number(data.quantity))?.toFixed(2)
                                    return (
                                      <>
                                        <TableRow key={index}>
                                          <TableCell>#{data?.productIndex}</TableCell>
                                          <TableCell>{data.name}</TableCell>
                                          <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                          <TableCell>{data.cost}</TableCell>
                                          <TableCell>{dataCost}</TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }}           
                                              sx={{ minWidth: '80px' }}                                                                     
                                              label={'Hours'}
                                              // {...getFieldProps(quantityFieldName)}
                                              // disabled={(data?.fromMapServices == true) ? true : false}
                                              value={Number(data.quantity)}
                                              // disabled={(data?.fromMapServices == true) ? true : values.project_category?.name == 'Time & Material' ? true : false}
                                              disabled
                                              // value={values.project_category?.name == 'Time & Material' ? 0 : Number(data.quantity)}
                                              // defaultValue={(values.project_category?.name == 'Time & Material' && Number(data?.id) === 10) ? 0 : (data.quantity ? Number(data.quantity) : 0)}
                                              defaultValue={data.quantity ? Number(data.quantity) : 0}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                const newData = { ...data, quantity: newValue || 0 };
                                                if (newValue.startsWith('-')) {
                                                  newValue = newValue.slice(1);
                                                }
                                                if (newValue < previousQty) {
                                                  setShowWarning(prev => {
                                                    const newWarnings = [...prev];
                                                    newWarnings[index] = true;
                                                    return newWarnings;
                                                  });
                                                  console.log('data?.prQty---', data?.prQty);
                                                  data['quantity'] = previousQty;
                                                  setFieldValue(quantityFieldName, previousQty);
                                                } else {
                                                  setShowWarning(prev => {
                                                    const newWarnings = [...prev];
                                                    newWarnings[index] = false;
                                                    return newWarnings;
                                                  });
                                                  data['quantity'] = newValue || 1;
                                                  setFieldValue(quantityFieldName, newValue);
                                                }

                                                const updatedServices = [...selectedServices];
                                                updatedServices[index] = newData;
                                                updatedServices[index] = newData;

                                                updatedServices[index] = newData;

                                                setSelectedServices(updatedServices);
                                              }}
                                              inputProps={{ min: previousQty}}
                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                            {showWarning[index] && (
                                              <Typography color="error" variant='body2'>
                                                Cannot reduce the added hours in the product formula. If you need to reduce, change it in the product formula.
                                              </Typography>
                                            )}
                                          </TableCell>
                                          <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                          <TableCell>{(data.unit_cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                          <TableCell>{total?.toFixed(2)}</TableCell>
                                        </TableRow>
                                      </>
                                    );
                                  })}
                                  
                                </TableBody> */}
                                  {console.log(additionalSelectedServices,'------------------------------additionalSelectedServices')}
                                <DragDropContext onDragEnd={handleServiceTableDragEnd}>
                                  <Droppable droppableId="view-official-request-service-rows" isDropDisabled={!editFormValuesEnabled}>
                                    {(droppableProvided) => (
                                <TableBody
                                  ref={droppableProvided.innerRef}
                                  {...droppableProvided.droppableProps}
                                >
                                  {[...(additionalSelectedServices || [])]
                                    .sort(
                                      (a, b) =>
                                        (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
                                        (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
                                    )
                                    .map((data, index) => {
                                    console.log("############additional services", data);
                                    const serviceLineKey = getServiceLineKey(data);
                                    // if(values.project_category?.name == 'Time & Material'){
                                    //   data['total_cost'] = 0
                                    //   data['unit_cost'] = 0
                                    //   data['cost'] = 0
                                    //   data['quantity'] = 0
                                    // }
                                    const quantityFieldName = `service_quantity_${index}`;
                                    const dataQuantity = data?.quantity ? data?.quantity : 0;
                                    let total, originalMarkup
                                    
                                    // Check if service is from other facility
                                    const isOtherFacilityService = data?.facility_id && Number(data.facility_id) !== Number(currentFacilityId);
                                    if (!isOtherFacilityService) {
                                      if (data.original_total_cost == null) data.original_total_cost = data.total_cost
                                      if (data.original_unit_cost == null) data.original_unit_cost = data.unit_cost
                                      if (data.original_service_markup == null) data.original_service_markup = data.originalMarkup
                                    }
                                    if (isNoChargeJob && !isOtherFacilityService) {
                                      data['unit_cost'] = data?.cost
                                    } else if (!isOtherFacilityService) {
                                      data['total_cost'] = data.original_total_cost
                                      data['unit_cost'] = data.original_unit_cost
                                      data['originalMarkup'] = data.original_service_markup
                                    }
                                    const dataCost = data.unit_cost || data.total_cost
                                    
                                    // For other facility services: set originalMarkup to 0 and calculate total_cost with split percentage
                                    let costWithOutgoing = data.cost; // Default to original cost
                                    
                                    if (isOtherFacilityService) {
                                      originalMarkup = 0
                                      data['originalMarkup'] = 0
                                      
                                      // Get outgoing percentage from split settings
                                      const splitSetting = selectedSplitOrderSettings?.find(setting => setting?.id == data?.facility_id);
                                      let outgoingPercentage = splitSetting?.split_percentage || 0;
                                      
                                      // Calculate cost with outgoing percentage: cost + (cost * outgoingPercentage / 100)
                                      let amountWithOutgoingPercentage = data.cost * (outgoingPercentage / 100)
                                      costWithOutgoing = data.cost + amountWithOutgoingPercentage
                                      
                                      // Calculate total_cost: add incoming percentage to cost with outgoing
                                      const incomingPercentage = incomingSplitMarkup || 0
                                      let amountWithIncomingPercentage = costWithOutgoing * (incomingPercentage / 100)
                                      data['total_cost'] = Number((costWithOutgoing + amountWithIncomingPercentage).toFixed(2))
                                      data['incoming_split_percentage'] = incomingPercentage
                                      data['split_percentage'] = outgoingPercentage
                                      data['outgoing_split_percentage'] = outgoingPercentage
                                      // Store calculated cost for display (don't mutate original cost)
                                      data['costWithOutgoing'] = Number(costWithOutgoing.toFixed(2))
                                    }
                                    
                                    // Check if nocharge is enabled
                                    if (isNoChargeJob && !isOtherFacilityService) {
                                      // Nocharge case: markup = 0, original markup = 0, total = cost * quantity
                                      total = data.cost * dataQuantity
                                      data['markup'] = 0.00
                                      data['quantity'] = dataQuantity
                                      totalServiceMarkup += 0
                                      data['total'] = total ? total?.toFixed(2) : 0.00
                                      data['total_cost'] = data?.cost
                                      data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                      originalMarkup = 0
                                      data['originalMarkup'] = 0
                                      originaltotalServiceMarkup += 0
                                    } else {
                                      // Normal case: existing logic
                                      total = dataCost * dataQuantity
                                      // Fix division by zero issue that causes infinity
                                      const markup = (total > 0) ? (dataCost / Number(total)) : 0
                                      data['markup'] = markup ? markup?.toFixed(2) : 0.00
                                      data['quantity'] = dataQuantity
                                      totalServiceMarkup += markup
                                      data['total'] = total ? total?.toFixed(2) : 0.00
                                      data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                      if (!isOtherFacilityService) {
                                        originalMarkup = data.originalMarkup || 0
                                        data['originalMarkup'] = data.originalMarkup || 0
                                        originaltotalServiceMarkup += originalMarkup
                                      }
                                    }
                                    const quantityDifference = Number(data.quantity)
                                    data['quantityDifference'] = quantityDifference
                                    data['jobcost_unit_cost'] = data.cost
                                    data['jobcost_quantity'] = quantityDifference
                                    data['jobcost_total_cost'] = (data.cost*Number(data?.quantity) || 1)?.toFixed(2)
                                    // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    console.log('total---', total);
                                    console.log('data---', data);
                                    return (
                                      <Draggable
                                        key={`service-${serviceLineKey}`}
                                        draggableId={`service-${serviceLineKey}`}
                                        index={index}
                                        isDragDisabled={!editFormValuesEnabled}
                                      >
                                        {(provided, snapshot) => (
                                      <>
                                        <TableRow
                                          key={index}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          onDragEnterCapture={(e) =>
                                            handleServiceIconDragOver(e, data.indexId || data.newIndexId)
                                          }
                                          onDragOverCapture={(e) =>
                                            handleServiceIconDragOver(e, data.indexId || data.newIndexId)
                                          }
                                          onDragLeave={(e) =>
                                            handleServiceIconDragLeave(e, data.indexId || data.newIndexId)
                                          }
                                          onDropCapture={(e) =>
                                            handleServiceIconDrop(e, data.indexId || data.newIndexId)
                                          }
                                          sx={{
                                            ...(serviceAttachmentDragOver[data.indexId || data.newIndexId] && {
                                              backgroundColor: 'action.hover',
                                              outline: `2px dashed ${theme.palette.primary.main}`,
                                              outlineOffset: -2,
                                            }),
                                          }}
                                          style={{
                                            ...provided.draggableProps.style,
                                            ...(snapshot.isDragging
                                              ? { backgroundColor: theme.palette.action.hover }
                                              : {}),
                                          }}
                                        >
                                          {editFormValuesEnabled && (
                                            <TableCell
                                              padding="checkbox"
                                              {...provided.dragHandleProps}
                                              sx={{ width: 40, cursor: 'grab' }}
                                            >
                                              <DragIndicator fontSize="small" color="action" />
                                            </TableCell>
                                          )}
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                        {/* {(values.project_category?.name != 'Service only' && values.project_category?.name != 'Time & Material') ? ( */}
                                        {values.project_category?.name != 'Service only old' ? (
                                          null
                                        ) : <TableCell>5555</TableCell>}
                                        
                                          <TableCell>{
                                            data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="text"
                                              label={'Service Name'}
                                              sx={{ width: 85 }}
                                              value={data.name}
                                              onChange={(event) => {
                                                let newValue = event.target.value

                                                // Update the selectedProducts state
                                                setAdditionalSelectedServices(
                                                  (prevProducts) =>
                                                    prevProducts.map((service) => {
                                                        if ( service.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...service,
                                                            name: newValue,
                                                          }
                                                        } else {
                                                          return service
                                                        }
                                                      },
                                                    ),
                                                )
                                                data['name'] = newValue || ''
                                                if (isSubmitted)
                                                  setIsSubmitted(false)
                                              }}
                                              error={
                                                isSubmitted && data?.name?.trim() === ''
                                              }
                                              helperText={
                                                isSubmitted && data?.name?.trim() === '' ? 'Service Name is required' : ''
                                              }
                                            />
                                            :
                                            isSplitOrder ? (
                                              <Typography sx={{color:theme.palette[
                                                FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                              ]?.main, whiteSpace: 'pre-wrap'}}>{data.service_notes && data.service_notes !== '' ? data.service_notes : data.name}</Typography>
                                            ) :
                                            //  data.name
                                         <Box>
                                          <Typography>{data.name}</Typography>
                                             {data.service_notes ? <Typography sx={{color: data.service_notes ? theme.palette.error.main : 'inherit', whiteSpace: 'pre-wrap'}}>Note:{" "}{data.service_notes && data.service_notes !== '' ? data.service_notes :""}</Typography>:""}
                                         </Box>
                                            }</TableCell>
                                          <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.indexId || data.newIndexId, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell>
                                            <Tooltip title="Drop files on row or click to open attachments">
                                              <IconButton
                                                onClick={() => handleOpenServiceAttachment(data.indexId || data.newIndexId)}
                                              >
                                                {isUploadingService[data.indexId || data.newIndexId] ? (
                                                  <CircularProgress size={34} />
                                                ) : (
                                                  <UploadFile
                                                    sx={{
                                                      color:
                                                        !serviceAttachments[data.indexId || data.newIndexId] ||
                                                        serviceAttachments[data.indexId || data.newIndexId]?.length === 0
                                                          ? 'error.main'
                                                          : theme.palette.primary.main,
                                                    }}
                                                  />
                                                )}
                                              </IconButton>
                                            </Tooltip>
                                          </TableCell>
                                          <TableCell>{isNoChargeJob ? '-' : (isOtherFacilityService ? '-' : (originalMarkup ? originalMarkup?.toFixed(2) : 0.00))}</TableCell>
                                          <TableCell>{isOtherFacilityService ? (data?.costWithOutgoing || data.cost) : data.cost}</TableCell>
                                          {isSplitOrder ? (
                                            <TableCell>
                                              {data?.facility_id !== currentFacilityId ?
                                                `${data?.incoming_split_percentage || incomingSplitMarkup || 0}%`
                                                : '-'
                                              }
                                            </TableCell>
                                          ) : ''}
                                          <Tooltip 
                                            title={
                                              (isSplitOrder && 
                                                data.facility_id != currentFacilityId) 
                                                ? `Cost + (Cost * incoming split markup (${data?.incoming_split_percentage || incomingSplitMarkup || 0}) / 100)`
                                                : ""
                                            }
                                          >
                                            <TableCell>{
                                              data?.isAdditionalProduct ?
                                              <TextField
                                                required
                                                fullWidth
                                                type="number"
                                                label={'Hourly Cost'}
                                                // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                                sx={{ width: 85 }}
                                                value={dataCost}
                                                // onWheel={(e) => e.target.blur()}
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onKeyPress={(event) => {
                                                  // if (event.key === '0' && event.target.value === '') {
                                                  //   event.preventDefault();
                                                  // }
                                                  if (event.key === '-') {
                                                    event.preventDefault();
                                                  }
                                                  if (event.key === 'e') {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                inputProps={{ min: 0 }}
                                                defaultValue={0}
                                                onChange={(event) => {
                                                  let newValue = event.target.value
                                                  if (newValue !== '') {
                                                    setAdditionalSelectedServices((pv) => [
                                                        ...pv.map((p) => {
                                                          if ( p.newIndexId === data.newIndexId ) {
                                                            return {
                                                              ...p,
                                                              total_cost: newValue,
                                                              unit_cost: newValue,
                                                              original_total_cost: newValue,
                                                              original_unit_cost: newValue,
                                                            }
                                                          } else {
                                                            return p
                                                          }
                                                        }),
                                                      ],
                                                    )
                                                    data['total_cost'] =  newValue || 0
                                                    data['unit_cost'] =  newValue || 0
                                                    data['original_total_cost'] = newValue || 0
                                                    data['original_unit_cost'] = newValue || 0
                                                  }
                                                }}
                                                // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                              /> :
                                              dataCost}</TableCell>
                                          </Tooltip>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }} 
                                              sx={{ minWidth: '80px' }}
                                              label={'Hours'}
                                              {...getFieldProps(quantityFieldName)}
                                              disabled={tmInvoicingFieldDisabled}
                                              // disabled={(values.project_category?.name == 'Time & Material') ? true : false }
                                              // value={(values.project_category?.name == 'Time & Material' && Number(data?.id) === 10) ? 0 : Number(data?.quantity) || 0}
                                              value={Number(data?.quantity) || 0}
                                              // defaultValue={(values.project_category?.name == 'Time & Material' && Number(data?.id) === 10 ) ? 0 : 1}
                                              defaultValue={1}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => { 
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={(event) => {
                                                let newValue = event.target.value || 0;
                                                // if (newValue.startsWith('-')) {
                                                //   newValue = newValue.slice(1);
                                                // }
                                                // data['quantity'] = newValue || 1;
                                                const newData = { ...data, quantity: newValue || 0 };
                                                const updatedServices = [...additionalSelectedServices];
                                                updatedServices[index] = newData;
                                                setAdditionalSelectedServices(updatedServices);
                                                setFieldValue(quantityFieldName, newValue);
                                              }}

                                              onWheel={(e) => e.target.blur()}

                                              onKeyDown={(event) => {
                                                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                  const newValue = event.target.value || 0;
                                                  if (newValue < 1 && event.key === 'ArrowDown') {
                                                    event.preventDefault(); 
                                                  }
                                                }
                                              }}

                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          </TableCell>
                                          {isSplitOrder ? (
                                        <TableCell align="center">
                                          {Number(data?.facility_id) !== Number(currentFacilityId) ? (
                                            <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                              <Button
                                                size="small"
                                                variant={data?.delivery_installation?.installer_facility_id ? "contained" : "outlined"}
                                                onClick={() => openDeliveryInstallDialog(data)}
                                                disabled={details?.allInstallationCompleted == 1 || tmInvoicingFieldDisabled}
                                              >
                                                {data?.delivery_installation?.installer_facility_id ? 'Edit' : 'Set'}
                                              </Button>
                                              {data?.delivery_installation?.installer_facility_id ? (
                                                <Tooltip
                                                  title={`${deliveryTypeLabelById(
                                                    data?.delivery_installation?.delivery_type_id ||
                                                      data?.delivery_installation?.complete_status,
                                                  )} • ${
                                                    data?.delivery_installation?.installer_facility_name ||
                                                    getFacilityOption(data?.delivery_installation?.installer_facility_id)?.name ||
                                                    ''
                                                  }`}
                                                >
                                                  <Typography variant="caption" noWrap sx={{ maxWidth: 140 }}>
                                                    {deliveryTypeLabelById(
                                                      data?.delivery_installation?.delivery_type_id ||
                                                        data?.delivery_installation?.complete_status,
                                                    )}
                                                    {' • '}
                                                    {data?.delivery_installation?.installer_facility_name ||
                                                      getFacilityOption(data?.delivery_installation?.installer_facility_id)?.name ||
                                                      ''}
                                                  </Typography>
                                                </Tooltip>
                                              ) : null}
                                            </Stack>
                                          ) : (
                                            '-'
                                          )}
                                        </TableCell>
                                        ) : null
                                        //  (
                                        //   <TableCell align='center'>
                                        //     {
                                        //   values?.project_category?.id == 11 && data?.makeInstallCard == 0 && data?.makeAsTask == 0 ?
                                        //   null :
                                        //     <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                        //       <Button
                                        //         size="small"
                                        //         variant={data?.delivery_installation?.delivery_type_id ? "contained" : "outlined"}
                                        //         onClick={() => openDeliveryTypeDialog(data, 'service')}
                                        //         sx={{ textAlign: 'center' }}
                                        //       >
                                        //         {data?.delivery_installation?.delivery_type_id ? 'Edit' : 'Set'}
                                        //       </Button>
                                        //       {data?.delivery_installation?.delivery_type_id || data?.delivery_installation?.complete_status ? (
                                        //         <Tooltip
                                        //           title={`${deliveryTypeLabelById(
                                        //             data?.delivery_installation?.delivery_type_id ||
                                        //             data?.delivery_installation?.complete_status,
                                        //           )}`}
                                        //         >
                                        //           <Typography
                                        //             variant="caption"
                                        //             noWrap
                                        //             sx={{ maxWidth: 140 }}
                                        //           >
                                        //             {deliveryTypeLabelById(
                                        //               data?.delivery_installation?.delivery_type_id ||
                                        //               data?.delivery_installation?.complete_status,
                                        //             )}
                                        //           </Typography>
                                        //         </Tooltip>
                                        //       ) : null}
                                        //     </Stack>
                                        //   }
                                        //   </TableCell>
                                        // )
                                        } 
                                          {/* <TableCell>
                                            {data?.is_dos == 1 ? 'N/A' : (
                                            <Switch
                                              checked={data.makeAsTask === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setAdditionalSelectedServices((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.indexId === data.indexId
                                                      ? { ...service, makeAsTask: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeAsTask'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            {data?.is_dos == 1 ? 'N/A' : (
                                            <Switch
                                              checked={data.makeInstallCard === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setAdditionalSelectedServices((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.indexId === data.indexId
                                                      ? { ...service, makeInstallCard: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeInstallCard'] = newValue;
                                              }}
                                              color="primary"
                                            />)}
                                          </TableCell> */}
                                          {/* {values.project_category?.name == 'Service only'  || (values?.project_category?.name == 'Time & Material') ? ( */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                const indexKey = data.indexId ?? data.newIndexId;
                                                setServiceOnlyLocationStates({ ...serviceOnlyLocationStates, [indexKey]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data?.addresses?.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          {/* ) : null}                                   */}
                                          {/* <TableCell>{data?.isAdditionalProduct ? 'N/A' : (data.cost*quantityDifference)?.toFixed(2)}</TableCell> */}
                                          <TableCell>{total ? total?.toFixed(2) : 0.00}</TableCell>
                                          <TableCell>{total ? total?.toFixed(2) : 0.00}</TableCell>
                                          <TableCell align='right'>
                                            <IconButton disabled={tmInvoicingFieldDisabled} onClick={() => handleDeleteService(data.id, data.indexId, data.newIndexId, index)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={openServiceAttachment[data.indexId ?? data.newIndexId] || false}
                                          handleClose={() => handleCloseServiceAttachment(data.indexId ?? data.newIndexId)}
                                        >
                                          {renderAttachmentModalContent({
                                            itemKey: String(data.indexId ?? data.newIndexId),
                                            isService: true,
                                            tabValue: attachmentTabValueService[data.indexId ?? data.newIndexId],
                                            onTabChange: handleAttachmentTabChangeService,
                                            selectedImages:
                                              selectedUploadedImagesService[String(data.indexId ?? data.newIndexId)] ||
                                              selectedUploadedImagesService[data.indexId ?? data.newIndexId] ||
                                              [],
                                            linkedAttachments:
                                              serviceAttachments[String(data.indexId ?? data.newIndexId)] ||
                                              serviceAttachments[data.indexId ?? data.newIndexId] ||
                                              [],
                                            onImageSelect: handleImageSelectService,
                                            onAddSelected: handleAddSelectedImagesService,
                                            onDrop: handleServiceDrop,
                                            onRemove: handleServiceRemove,
                                            isUploadingItem: isUploadingService[data.indexId ?? data.newIndexId] || false,
                                            disabled: tmInvoicingFieldDisabled,
                                          })}
                                        </Modal>
                                        <Modal
                                            open={serviceOnlyLocationStates[data.indexId]}
                                            handleClose={() => {
                                              const indexKey = data.indexId ?? data.newIndexId;
                                              setServiceOnlyLocationStates({ ...serviceOnlyLocationStates, [indexKey]: false });
                                            }}
                                          >
                                          <FormControlLabel
                                            disabled={tmInvoicingFieldDisabled || index !== 0}
                                            sx={tmInvoicingReadOnlyCursorSx}
                                            control={
                                              <Switch
                                                checked={allServiceLocationSame}
                                                disabled={tmInvoicingFieldDisabled || index !== 0}
                                                onChange={handleAllServiceLocationSameChange}
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                          <Box component="fieldset" disabled={tmInvoicingFieldDisabled} sx={{ border: 'none', m: 0, p: 0, minWidth: 0, ...tmInvoicingReadOnlyCursorSx }}>
                                            <Grid
                                              container
                                              spacing={3}
                                              sx={{ justifyContent: 'center', width: '100%' }}
                                            >

                                              {data?.addresses?.map((addr, i) => (
                                                <Grid item xs={12}>
                                                  {/* Side Heading */}
                                                  <Typography variant="h5" sx={{ mb: 2 }}>
                                                    Location
                                                  </Typography>

                                                  {/* Address Fields */}

                                                  <Stack
                                                    direction={{ xs: 'column', sm: 'row' }}
                                                    spacing={{ xs: 3, sm: 2 }}
                                                    sx={{ mb: 2 }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      label="Address"
                                                      size="small"
                                                      value={data.addresses[i].address || ''}
                                                      disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                      onChange={(event) => {
                                                        let arrayAddr = [...data.addresses]
                                                        arrayAddr[i].address = event.target.value;
                                                        setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                          // if (p.id === data.id) {
                                                          if (p.indexId === data.indexId) {
                                                            return {
                                                              ...p,
                                                              addresses: arrayAddr
                                                            }
                                                          } else {
                                                            return p;
                                                          }
                                                        })]))
                                                      }}
                                                    />
                                                  </Stack>

                                                  {/* City, State, Zip Fields */}
                                                  <Stack
                                                    direction={{ xs: 'column', sm: 'row' }}
                                                    spacing={{ xs: 3, sm: 2 }}
                                                    sx={{ mb: 2 }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      label="City"
                                                      size="small"
                                                      value={data.addresses[i].city || ''}
                                                      disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                      onChange={(event) => {
                                                        let arrayAddr = [...data.addresses]
                                                        arrayAddr[i].city = event.target.value;
                                                        setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                          // if (p.id === data.id) {
                                                          if (p.indexId === data.indexId) {
                                                            return {
                                                              ...p,
                                                              addresses: arrayAddr
                                                            }
                                                          } else {
                                                            return p;
                                                          }
                                                        })]))
                                                      }}
                                                    />
                                                    <TextField
                                                      fullWidth
                                                      label="State"
                                                      size="small"
                                                      value={data.addresses[i].state || ''}
                                                      disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                      onChange={(event) => {
                                                        let arrayAddr = [...data.addresses]
                                                        arrayAddr[i].state = event.target.value;
                                                        setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                          // if (p.id === data.id) {
                                                          if (p.indexId === data.indexId) {
                                                            return {
                                                              ...p,
                                                              addresses: arrayAddr
                                                            }
                                                          } else {
                                                            return p;
                                                          }
                                                        })]))
                                                      }}
                                                    />
                                                    <TextField
                                                      fullWidth
                                                      label="Zip / Postal Code"
                                                      size="small"
                                                      value={data.addresses[i].zip || ''}
                                                      disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                      onChange={(event) => {
                                                        let arrayAddr = [...data.addresses]
                                                        arrayAddr[i].zip = event.target.value;
                                                        setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                          if (p.indexId === data.indexId) {
                                                            // if (p.id === data.id) {
                                                            return {
                                                              ...p,
                                                              addresses: arrayAddr
                                                            }
                                                          } else {
                                                            return p;
                                                          }
                                                        })]))
                                                      }}
                                                    />
                                                  </Stack>
                                                </Grid>
                                              ))}
                                            </Grid>

                                            {index !== 0 && allServiceLocationSame ? '' :
                                            <Grid container justifyContent="center" alignItems="center">
                                              <Grid item xs={12} md={4}>
                                                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                  <LoadingButton variant="contained" onClick={() => {
                                                    setIsSaving(true)
                                                    setTimeout(() => {
                                                      setIsSaving(false)
                                                      setServiceOnlyLocationStates(false)
                                                    }, 100)
                                                  }} loading={isSaving} disabled={tmInvoicingFieldDisabled}>
                                                    {' Save '}
                                                  </LoadingButton>
                                                  {/* <Button variant="outlined" type="submit" onClick={() => { setLocationStates(false) }}>
                                                  Cancel
                                                </Button> */}
                                                </Box>
                                              </Grid>
                                            </Grid>}
                                          </Box>
                                          </Modal>
                                      </>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {droppableProvided.placeholder}
                                  {/* <TableRow>
                                    <TableCell colSpan={8}>
                                      <Typography variant="h6" align="right">
                                        Total Additional Cost: {totalProductLabourCost.toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </TableRow> */}
                                </TableBody>
                                    )}
                                  </Droppable>
                                </DragDropContext>

                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Stack sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', display:'flex', flexDirection:'column' }}>
                            {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewServiceRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Service Row
                            </Button> */}
                            <Typography variant="h6">
                              Total Additional Service Cost:{' '}
                              {totalProductLabourCost?.toFixed(2)}
                            </Typography>
                            {/* <Typography variant="h6">
                              Total Product Labor Cost:{' '}
                              {Number(totalProductInstallCost || 0).toFixed(2)}
                            </Typography> */}
                          </Stack>
                          {/* {(values.project_category?.name == 'Time & Material') ? '' :
                          <> */}
                          {(values?.project_type?.name == 'TS' && values?.project_category?.id == 14) || values?.project_category?.id == 12  ? '' :
                          <>
                          <LabelStyleHead>Proposals</LabelStyleHead>

                          <Autocomplete
                            options={rfps}
                            // getOptionLabel={(option) => option.description}
                            getOptionLabel={(option) =>
                            option && option.description
                              ? `${option.description} ( ${option.vendor_name || ''})`
                              : ''
                            }
                            value={values.rfp}
                            onChange={(event, value) => {handleRfpSelect(event, value)
                              setFieldValue('rfp',value)
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Proposal" />}
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                  // option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }
                          />

                          {/* Modal for RFP Selection */}
                          <Modal open={openModal} handleClose={closeModal}>
                            <Box sx={{ position: 'relative', p: 3, bgcolor: 'background.paper', boxShadow: 24 }}>

                              <Tabs value={tabIndex}
                                variant="fullWidth"
                                sx={{
                                  marginBottom: 4

                                }}
                                onChange={handleTabChange}>
                                <Tab label="Products" sx={{ width: '50%', minWidth: 0 }} />
                                <Tab label="Services" sx={{ width: '50%', minWidth: 0 }} />
                                {/* {((values?.project_category?.name != 'Service only') && (values?.project_category?.name != 'Time & Material')) && <Tab label="Products" sx={{ width: '50%', minWidth: 0 }}  />} */}
                                <Tab label="Materials" sx={{ width: '50%', minWidth: 0 }} />
                              </Tabs>
                              
                              {tabIndex === 0 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    <TableRow>
                                    <TableCell align='center'>Name</TableCell>
                                    <TableCell align='center'>Unit Cost</TableCell>
                                    <TableCell align='center'>Unit</TableCell>
                                    <TableCell align='center'>Qty</TableCell>
                                    <TableCell align='center'>Total Cost</TableCell>
                                    <TableCell align='center'></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  {rfpProducts?.filter((product)=>product.material == 0 ).map((product) => {
                                    let unitName = UNITS?.filter((item) => item?.id == product?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if(values?.project_category?.name == 'Time & Material'){
                                      product.product_price = 0
                                      // product.quantity = 0
                                    }
                                    return(
                                    // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={product.id}>
                                        <TableCell align='center'>{product.product_name}</TableCell>
                                        <TableCell align='center'>${product.product_price}</TableCell>
                                        <TableCell align='center'>{product.quantity} {shortUnitName}</TableCell>
                                        <TableCell align='center'>{product.location_quantity}</TableCell>
                                        <TableCell align='center'>${(product.location_quantity*product.quantity * ((product.product_price).toFixed(2) || 0)).toFixed(2)}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(product)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  )})}
                                  </Table>
                                </TableContainer>
                              )}
                                {tabIndex === 1 && (
                                  <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    {/* <TableRow> */}
                                      <TableCell align='center'>Name</TableCell>
                                      <TableCell align='center'>Unit Cost</TableCell>
                                      <TableCell align='center'>Hours</TableCell>
                                      <TableCell align='center'>Total Cost</TableCell>
                                      <TableCell align='center'></TableCell>
                                    {/* </TableRow> */}
                                  </TableHead>
                                  {rfpServices.map((service) => {
                                    if(values?.project_category?.name == 'Time & Material'){
                                      service.sellingPrice = 0
                                      service.quantity = 0
                                      service.total_cost = 0
                                    }
                                    return(
                                    // <Box key={service.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={service.id}>
                                        <TableCell align='center'>{service.name}</TableCell>
                                        <TableCell align='center'>${service.sellingPrice}</TableCell>
                                        <TableCell align='center'>{service.quantity}</TableCell>
                                        <TableCell align='center'>${service.total_cost}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(service)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  )})}
                                  </Table>
                                  </TableContainer>
                              )}
                              {tabIndex === 2 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    <TableRow>
                                    <TableCell align='center'>Name</TableCell>
                                    <TableCell align='center'>Unit Cost</TableCell>
                                    <TableCell align='center'>Unit</TableCell>
                                    <TableCell align='center'>Qty</TableCell>
                                    <TableCell align='center'>Total Cost</TableCell>
                                    <TableCell align='center'></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  {rfpProducts.filter((product)=>product.material == 1).map((product) => {
                                    let unitName = UNITS?.filter((item) => item?.id == product?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    return(
                                    // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={product.id}>
                                        <TableCell align='center'>{product.product_name}</TableCell>
                                        <TableCell align='center'>${product.product_price}</TableCell>
                                        <TableCell align='center'>{product.quantity} {shortUnitName}</TableCell>
                                        <TableCell align='center'>{product.location_quantity}</TableCell>
                                        <TableCell align='center'>${(product.location_quantity*product.quantity * ((product.product_price).toFixed(2) || 0)).toFixed(2)}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(product)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  )})}
                                  </Table>
                                </TableContainer>
                              )}
                            </Box>
                          </Modal>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_RFP_Product?.map((val,index) => (

                                      <TableCell key={val.id}>{val.value}</TableCell>

                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 0)?.map((data, index) => {
                                    console.log('cart---------', cart)
                                    console.log('data---------1', data)
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if(values.project_category?.name == 'Time & Material'){
                                      data.product_price = 0
                                      data.product_retail_price = 0
                                      data.sellingPrice = 0
                                    }
                                    // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup : 0
                                    let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup
                                    if(isNoChargeJob){
                                      data.product_markup = 0
                                      data.markup = 0
                                      markup = 0
                                    }
                                const productFormulaEach =
                                  data?.inhouse === 0
                                    ? Number(data?.sub_contract_price || 0)
                                    : Number(
                                        (data?.expected_material_cost_with_markup ||
                                          0) +
                                          (data?.expected_service_cost_with_markup ||
                                            0),
                                      )
                                const productRetailEach = Math.max(
                                  0,
                                  Number(
                                    data?.actual_retail_price ??
                                      data?.retail_price ??
                                      data?.product_retail_price ??
                                      0,
                                  ),
                                )
                                const isNegativeProductAdjustmentMode =
                                  data?.adj_value_type === false ||
                                  data?.adj_value_type === 0 ||
                                  data?.adj_value_type === '0' ||
                                  data?.adj_value_type === 'false'
                                const isProductLosingMoney =
                                  isNegativeProductAdjustmentMode &&
                                  productRetailEach < productFormulaEach

                                const installFormulaEach = Number(
                                  data?.expected_install_labor_cost_with_markup ||
                                    0,
                                )
                                const installRetailEach = Math.max(
                                  0,
                                  Number(data?.install_cost || 0),
                                )
                                const isNegativeInstallAdjustmentMode =
                                  data?.install_adj_value_type === false ||
                                  data?.install_adj_value_type === 0 ||
                                  data?.install_adj_value_type === '0' ||
                                  data?.install_adj_value_type === 'false'
                                const isInstallLosingMoney =
                                  installRetailEach > 0 &&
                                  isNegativeInstallAdjustmentMode &&
                                  installRetailEach < installFormulaEach

                                const isLosingMoneyItem =
                                  isProductLosingMoney ||
                                  isInstallLosingMoney

                                const losingMoneyRowSx = getLosingMoneyRowSx(isLosingMoneyItem)

                                return (
                                      <>
                                  <TableRow key={data.id} sx={losingMoneyRowSx}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {isNoChargeJob ? '-' : (markup?.toFixed(2) || 0.00)}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) || 0}
                                          </TableCell>
                                          <TableCell>
                                            {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)) || 0)).toFixed(2)}
                                          </TableCell>  
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell>*/}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPProduct(data.product_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpLocationStates[data.product_id]}
                                          handleClose={() => {
                                            setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: false });
                                          }}
                                        >
                                          <FormControlLabel
                                            disabled={tmInvoicingFieldDisabled}
                                            sx={tmInvoicingReadOnlyCursorSx}
                                            control={
                                              <Switch
                                                checked={data?.allRfpProductsLocationSame}
                                                disabled={tmInvoicingFieldDisabled}
                                                onChange={()=>handleAllRfpProductsLocationSameChange(index) }
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                          <Box component="fieldset" disabled={tmInvoicingFieldDisabled} sx={{ border: 'none', m: 0, p: 0, minWidth: 0, ...tmInvoicingReadOnlyCursorSx }}>
                                          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'}>
                                          <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%', alignItems: 'center', mt: 2 }}>
                                            <LabelStyle>Qty Location Settings</LabelStyle>
                                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                              <Typography variant="subtitle2">Multiple</Typography>
                                              <Switch
                                                color="primary"
                                                checked={data?.is_single_card}
                                                onChange={(event) => {
                                                  const checked = event.target.checked;

                                                  setCart((prevCart) =>
                                                    prevCart.map((p) => {
                                                      if (p.product_id !== data.product_id) return p;

                                                      const count = Number(p.location_quantity || 1);

                                                      if (checked) {
                                                        // Single: always exactly one location
                                                        const first = p.location?.[0] || {
                                                          id: 0,
                                                          address: '',
                                                          city: '',
                                                          state: '',
                                                          zip: '',
                                                        };

                                                        return {
                                                          ...p,
                                                          is_single_card: true,
                                                          location: [first],
                                                        };
                                                      } else {
                                                        // Multiple: create `location_quantity` locations from first
                                                        const first = p.location?.[0] || {
                                                          id: 0,
                                                          address: '',
                                                          city: '',
                                                          state: '',
                                                          zip: '',
                                                        };

                                                        const arrayLoc = Array(count)
                                                          .fill()
                                                          .map((_, i) => ({
                                                            ...first,
                                                            id: i,
                                                          }));

                                                        return {
                                                          ...p,
                                                          is_single_card: false,
                                                          location: arrayLoc,
                                                        };
                                                      }
                                                    })
                                                  );
                                                }}
                                              />
                                              <Typography variant="subtitle2">Single</Typography>
                                            </Box>
                                          </Box>
                                          </Stack>
                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}

                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>


                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving} disabled={tmInvoicingFieldDisabled}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>
                                          </Box>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                                {
                                  cartService?.length > 0 ?
                                    <Typography variant='subtitle2' sx={{ fontWeight: 500 }}>Services</Typography>
                                    : ''
                                }
                                <TableBody>
                                  {cartService?.map((data, index) => {
                                    if(values.project_category?.name == 'Time & Material'){
                                      data.sellingPrice = 0
                                      data.unit_cost = 0
                                      data.qty = 0
                                    }
                                    if(isNoChargeJob){
                                      data.product_markup = 0
                                      data.originalMarkup = 0
                                      data.markup = 0
                                    }
                                          // data.sellingPrice = data.sellingPrice || data.unit_cost
                                    data.sellingPrice = Number(data.sellingPrice ?? data.unit_cost ?? 0)
                                    if (!isNoChargeJob) {
                                        //  data.originalMarkup = data.originalMarkup || data.product_markup
                                      // Use ?? so markup 0 is kept (|| would wipe it and make Retail/Total NaN)
                                      data.originalMarkup = Number(
                                        data.originalMarkup ?? data.product_markup ?? data.markup ?? 0,
                                      )
                                    }

                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>
                                            {/* <Typography>{data.name || data.product_name}</Typography> */}
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: data.service_notes ? theme.palette.error.main : 'inherit' }}>
                                              {data.service_notes && data.service_notes !== '' ? data.service_notes : (data.name || data.product_name)}
                                            </Typography>
                                            {data?.service_notes ? 
                                              <Stack direction={'column'}>
                                                {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{data.service_notes}</Typography> 
                                              </Stack>
                                              : ''}
                                          </TableCell>
                                          
                                          <TableCell>
                                            {isNoChargeJob ? '-' : (data.originalMarkup?.toFixed(2) ?? '0')}
                                          </TableCell>
                                          <TableCell>
                                            {data.sellingPrice?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {((data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {data.qty} Hours
                                          </TableCell>
                                          <TableCell>-</TableCell>                                     
                                          {/* <TableCell>
                                            {(data.qty*data.sellingPrice).toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                          </TableCell>
                                          

                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpServiceLocationStates({ ...rfpServiceLocationStates, [data.id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          {/* ):
                                          <TableCell></TableCell>
                                          } */}
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPService(data.labour_cost_service_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpServiceLocationStates[data.id]}
                                          handleClose={() => {
                                            setRfpServiceLocationStates({ ...rfpServiceLocationStates, [data.id]: false });
                                          }}
                                        >
                                          <FormControlLabel
                                            disabled={tmInvoicingFieldDisabled || index !== 0}
                                            sx={tmInvoicingReadOnlyCursorSx}
                                            control={
                                              <Switch
                                                checked={allRfpServiceLocationSame}
                                                disabled={tmInvoicingFieldDisabled || index !== 0}
                                                onChange={handleAllRfpServiceLocationSameChange}
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                          <Box component="fieldset" disabled={tmInvoicingFieldDisabled} sx={{ border: 'none', m: 0, p: 0, minWidth: 0, ...tmInvoicingReadOnlyCursorSx }}>

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                address: updatedValue, // Update address field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].address = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}                                                    
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                city: updatedValue, // Update city field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].city = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}                                                    
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {

                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                state: updatedValue, // Update state field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].state = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}                                                    
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                zip: updatedValue, // Update ZIP field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].zip = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}                                                    
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>

                                          {index !== 0 && allRfpServiceLocationSame ? '' :
                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpServiceLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving} disabled={tmInvoicingFieldDisabled}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>}
                                          </Box>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                                {cart?.filter((item)=>item.material == 1).length > 0 ?
                                  <Typography variant='subtitle2' sx={{fontWeight:500}}>Materials</Typography>
                                  :''}
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 1)?.map((data, index) => {
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if(values.project_category?.name == 'Time & Material'){
                                      data.product_price = 0
                                      data.product_retail_price = 0
                                      data.sellingPrice = 0
                                    }
                                    // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup : 0
                                    let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup
                                    if(isNoChargeJob){
                                      data.product_markup = 0
                                      data.markup = 0
                                      markup = 0
                                    }
                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {isNoChargeJob ? '-' : (markup?.toFixed(2) || 0.00)}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) || 0}
                                          </TableCell>
                                          <TableCell>
                                            {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)) || 0)).toFixed(2)}
                                          </TableCell>  
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell>*/}
                                          <TableCell>
                                            {/* material doesn't have loacation its not creating installations */}
                                            {/* <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton> */}
                                            N/A
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPProduct(data.product_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpLocationStates[data.product_id]}
                                          handleClose={() => {
                                            setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: false });
                                          }}
                                        >
                                          <FormControlLabel
                                            disabled={tmInvoicingFieldDisabled}
                                            sx={tmInvoicingReadOnlyCursorSx}
                                            control={
                                              <Switch
                                                checked={data?.allRfpProductsLocationSame}
                                                disabled={tmInvoicingFieldDisabled}
                                                onChange={()=>handleAllRfpProductsLocationSameChange(index) }
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                          <Box component="fieldset" disabled={tmInvoicingFieldDisabled} sx={{ border: 'none', m: 0, p: 0, minWidth: 0, ...tmInvoicingReadOnlyCursorSx }}>

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {

                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>


                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving} disabled={tmInvoicingFieldDisabled}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>
                                          </Box>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          </>}
                          <LabelStyleHead>Materials</LabelStyleHead>
                          {/* <Typography></Typography> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              disabled={tmInvoicingFieldDisabled}
                              id="combo-box-demo"
                              options={
                                materials?.filter((option) =>
                                  option.inhouse === 0 || option.inhouse === 1
                                ) || []
                              }
                              value={selectedMaterials?.filter(item => !item?.isAdditionalProduct)}
onChange={(event, newValue) => {
  if (!newValue) return;

  // 1. Full clear
  if (newValue.length === 0) {
    const onlyAdditional = selectedMaterials.filter(item => item.isAdditionalProduct === true);
    setSelectedMaterials(onlyAdditional);
    setPendingAutocompleteMaterials(onlyAdditional);
    setFieldValue('additionalMaterials', onlyAdditional);
    handleMaterial(onlyAdditional);
    return;
  }

  // 2. Detect removed items
  const removedItems = selectedMaterials.filter(
    prev => !newValue.some(cur =>
      (cur.product_id || cur.id) === (prev.product_id || prev.id) &&
      cur.stock_type === prev.stock_type &&
      (cur.stock_type === 1 || cur.convertion_unit === prev.convertion_unit)
    )
  );

  if (removedItems.length > 0) {
    const remainingAdditionalRows = selectedMaterials.filter(
      item => item.isAdditionalProduct === true &&
        !newValue.some(u =>
          (u.product_id || u.id) === (item.product_id || item.id) &&
          u.stock_type === item.stock_type &&
          (item.stock_type === 1 || u.convertion_unit === item.convertion_unit)
        )
    );

    const finalList = [...newValue, ...remainingAdditionalRows];
    setFieldValue('additionalMaterials', finalList);
    setPendingAutocompleteMaterials(newValue); // Sync base state
    setSelectedMaterials(finalList);
    handleMaterial(finalList);
    return;
  }

  // 3. If added new item
  const lastSelected = newValue[newValue.length - 1];
  if (lastSelected) {
    handleMaterialStockCheck(lastSelected); // 🧠 Your main addition logic
  }
}}



                              getOptionLabel={(option) => {
                                const name = option.name || option.product_name || '';
                                const description = option.description || option.product_description || option.product_name || '';
                                const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                return `${description}${ownership} \u200B${name}`;
                              }}
                              isOptionEqualToValue={(option, value) =>
                                option.product_id === value.product_id &&
                                option.stock_type === value.stock_type &&
                                option.convertion_unit === value.convertion_unit
                              }

                              renderOption={(props, option) => {
                                const { style, ...liProps } = props;
                                const description = option.description || option.product_description || option.product_name || '';
                                const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                // const stockLabel = option.stock_type === 1
                                //   ? 'Finished'
                                //   : `Partial - ${UNITS?.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                // const fullText = `${description} ${ownership} [${stockLabel}]`;
                                const fullText = `${description || option.name || option.product_name} ${ownership}`;
                                return (
                                  <li
                                    {...liProps}
                                    style={{
                                      ...style,
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                          {option?.syncWithQuickbooks === 1 && (
                                            <img
                                              src={quickbookLogo}
                                              width="40px"
                                              height="20px"
                                              // style={{ marginRight: 8 }}
                                              alt="QuickBooks"
                                            />
                                          )}
                                        </div>
                                    <Tooltip title={fullText}>
                                      <span style={{
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}>
                                        {fullText}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Materials"
                                  error={Boolean(touched.additionalMaterials && errors.additionalMaterials)}
                                  helperText={touched.additionalMaterials && errors.additionalMaterials}
                                />
                              )}
                              filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                  const searchText = inputValue.toLowerCase();
                                  return (
                                    option.name?.toLowerCase().includes(searchText) ||
                                    option.description?.toLowerCase().includes(searchText) ||
                                    String(option.tags ?? '').toLowerCase().includes(searchText)
                                  );
                                })
                              }
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                  const stockLabel = option.stock_type === 1
                                    ? 'Finished'
                                    : `Partial - ${UNITS?.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                  const tooltipText = `${option.description || option.name || option.product_name || ''} ${suffix} [${stockLabel}]`;
                                  return (
                                    <Tooltip key={index} title={tooltipText}>
                                      <Chip
                                        {...getTagProps({ index })}
                                        label={`${option.description || option.name || option.product_name || ''} ${suffix} [${stockLabel}]`}
                                      />
                                    </Tooltip>
                                  );
                                })
                              }
                            />

                          </Stack>
                          <LabelStyle>Selected Materials</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_MATERIAL?.map((val,index) => (
                                      val.id === 3 ? (
                                        <Tooltip key={val.id} title="Unit Price + ((Unit Price * Markup)/100)">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 5 ? (
                                        <Tooltip key={val.id} title="Unit Price * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 6 ? (
                                        <Tooltip key={val.id} title="Markup Cost * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) :
                                      <TableCell key={val.id}>{val.value}</TableCell>
                                     
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedMaterials?.map((data, index) => {
                                    console.log("################Materials",data);
                                    const adjustmentFieldName = `adjustment_${index}`;
                                    let unitName ='';
                                    if(data?.stock_type===1){
                                    unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    }else{
                                     unitName = UNITS?.filter((item) => item?.id == data?.convertion_unit)
                                    }
                                      let shortUnitName = unitName[0]?.short_name
                                    // if (unitName == 'Square feet') {
                                    //   shortUnitName = 'Sq ft'
                                    // } else if (unitName == 'Lineal feet') {
                                    //   shortUnitName = 'Lin ft'
                                    // } else if (unitName == 'Square Inches') {
                                    //   shortUnitName = 'Sq Inches'
                                    // } else if (unitName == 'Unit') {
                                    //   shortUnitName = 'Unit'
                                    // }
                                    // data.price=data.price ? data.price : data.product_price 
                                       data.price= data.product_price  ?  data.product_price : data.price
                                    // if(values.project_category?.name == 'Time & Material'){
                                    //   data['price'] = 0
                                    //   data['quantity'] = 0
                                    // }
                                    if (values.project_category?.name == 'Service only' && data?.inhouse == 0 ) {
                                      data['price'] = 0
                                    }
                                    data.product_id= data.product_id ? data.product_id : data.id
                                    // data.markup = data.markup ? data.markup : data.product_markup
                                    data.markup = data?.product_markup ||  data.markup 
                                    if(isNoChargeJob){
                                      data.product_markup = 0
                                      data.markup = 0
                                    }
                                    const markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
                                    data['markUpCost'] = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0; 
                                                                        
                                    let stock= 'Partial'
                                    if(data.stock_type===1 ){
                                      stock ='Finished'
                                    }
                                    const isNegativeMaterialAdjustmentMode =
                                      data?.adj_value_type === false ||
                                      data?.adj_value_type === 0 ||
                                      data?.adj_value_type === '0' ||
                                      data?.adj_value_type === 'false'
                                    const materialAdjustmentValue =
                                      Number(data?.adjustment) || 0
                                    const adjustedMarkupCostEach =
                                      Number(data?.markUpCost || 0) +
                                      (isNegativeMaterialAdjustmentMode
                                        ? -materialAdjustmentValue
                                        : materialAdjustmentValue)
                                    const materialFormulaEach =
                                      Number(data?.price) || 0
                                    const isLosingMoneyItem =
                                      isNegativeMaterialAdjustmentMode &&
                                      adjustedMarkupCostEach < materialFormulaEach

                                    const losingMoneyRowSx = isLosingMoneyItem
                                      ? {
                                          '& .MuiTableCell-root:not(:nth-of-type(4)), & .MuiTableCell-root:not(:nth-of-type(4)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)) .MuiFormLabel-root':
                                            {
                                              color: `${theme.palette.error.main} !important`,
                                            },
                                        }
                                      : undefined
                                    return (
                                      <>
                                        <TableRow key={data?.newIndexId || index} sx={losingMoneyRowSx}>
                                         <TableCell>{index + 1}</TableCell>
                                         <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                         <TableCell>
                                          {data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="text"
                                              label={'Material Name'}
                                              sx={{ width: 85 }}
                                              value={data.name||data.product_name}
                                              onChange={(event) => {
                                                let newValue = event.target.value

                                                // Update the selectedProducts state
                                                setSelectedMaterials(
                                                  (prevProducts) =>
                                                    prevProducts.map((service) => {
                                                        if ( service.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...service,
                                                            name: newValue,
                                                            product_name: newValue,
                                                          }
                                                        } else {
                                                          return service
                                                        }
                                                      },
                                                    ),
                                                )
                                                data['name'] = newValue || ''
                                                data['product_name'] = newValue || ''
                                                if (isSubmitted)
                                                  setIsSubmitted(false)
                                              }}
                                              error={
                                                isSubmitted && !data.name?.trim() && !data.product_name?.trim()
                                              }
                                              helperText={
                                                isSubmitted && !data.name?.trim() && !data.product_name?.trim()
                                                  ? 'Material Name is required'
                                                  : ''
                                              }                                              
                                            />
                                          : 
                                          // || data.name || data.product_name
                                       <Box>
                                        <Typography sx={{color:"inherit"}}>{data.name || data.product_name}</Typography>
                                          {data.material_notes? <Typography sx={{color: data.material_notes ? theme.palette.error.main : 'inherit' }}>Note:{" "}{data.material_notes }</Typography>:""}
                                       </Box>
                                          }
                                          {/* {data?.isAdditionalProduct ? '' : data.inhouse==1 ? ' (Inhouse)' : ' (Client owned)'} */}
                                          </TableCell>
                                          <TableCell>
                                            <IconButton onClick={() => handleOpenMaterialNote(data.newIndexId, data.material_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.material_notes || data?.material_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell>
                                            {stock}
                                          </TableCell>
                                         

                                         <TableCell>{
                                          data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Unit Price'}
                                              // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                              sx={{ width: 85 }}
                                              value={roundMoneyValue(data.price)}
                                              // onWheel={(e) => e.target.blur()}
                                              onKeyPress={(event) => {
                                                // if (event.key === '0' && event.target.value === '') {
                                                //   event.preventDefault();
                                                // }
                                                 if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              inputProps={{ min: 0 }}
                                              defaultValue={0}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                if (newValue !== '') {
                                                  setAdditionalSelectedServices((pv) => [
                                                      ...pv.map((p) => {
                                                        if ( p.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...p,
                                                            price: Number(newValue),
                                                          }
                                                        } else {
                                                          return p
                                                        }
                                                      }),
                                                    ],
                                                  )
                                                  data['price'] =  Number(newValue || 0)
                                                }
                                              }}
                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          : 
                                          roundMoneyValue(data.price).toFixed(2)}</TableCell>
                                      <TableCell>
                                        <TextField
                                          required
                                          fullWidth
                                          type='number'
                                          label='Markup'
                                          disabled={isNoChargeJob}
                                          value={isNoChargeJob ? 0 : (Number(data.markup) || 0)}
                                          defaultValue={0}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            if (['-', 'e'].includes(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue === '' || /^0[0-9]+$/.test(newValue)) newValue = '0';

                                            setSelectedMaterials((pv) =>
                                              pv.map((p) => {
                                                const isMatch = data.isAdditionalProduct
                                                  ? p.newIndexId === data.newIndexId
                                                  : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                    p.stock_type === data.stock_type &&
                                                    (p.stock_type === 1 || p.convertion_unit === data.convertion_unit);

                                                const isNegativeMode =
                                                  p?.adj_value_type === false ||
                                                  p?.adj_value_type === 0 ||
                                                  p?.adj_value_type === '0' ||
                                                  p?.adj_value_type === 'false';

                                                return isMatch
                                                  ? (isNegativeMode
                                                      ? {
                                                          ...p,
                                                          markup: Number(newValue),
                                                          product_markup: Number(newValue),
                                                          adj_value_type: true,
                                                          adjustment: 0,
                                                        }
                                                      : {
                                                          ...p,
                                                          markup: Number(newValue),
                                                          product_markup: Number(newValue),
                                                        })
                                                  : p;
                                              })
                                            );

                                            data['markup'] = Number(newValue);
                                            data['product_markup'] = Number(newValue);
                                            const isNegativeMode =
                                              data?.adj_value_type === false ||
                                              data?.adj_value_type === 0 ||
                                              data?.adj_value_type === '0' ||
                                              data?.adj_value_type === 'false';
                                            if (isNegativeMode) {
                                              data['adj_value_type'] = true;
                                              data['adjustment'] = 0;
                                              setFieldValue(adjustmentFieldName, 0);
                                            }
                                          }}
                                        />
                                      </TableCell>
                                      {/* <TableCell>{data.markUpCost || 0}</TableCell> */}
                                      <TableCell>{(data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))).toFixed(2) || 0}</TableCell>
                                      <TableCell>
                                        <TextField
                                          required
                                          fullWidth
                                          type='number'
                                          label={shortUnitName || 'Quantity'}
                                          disabled={tmInvoicingFieldDisabled}
                                          value={(()=>{
                                            const isTMJob = details?.job_category_name === 'Time & Material' || values?.project_category?.name === 'Time & Material' || values?.project_category?.id === 12 || details?.project_category === 12;
                                            let currentQty = Number(data.quantity) || 0;
                                            if (isTMJob && currentQty < 1) {
                                              currentQty = 1;
                                              data['quantity'] = 1;
                                            }
                                            return currentQty;
                                          })()}
                                          defaultValue={1}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            if (['-', 'e'].includes(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            const isTMJob = details?.job_category_name === 'Time & Material' || values?.project_category?.name === 'Time & Material' || values?.project_category?.id === 12 || details?.project_category === 12;
                                            let newValue = event.target.value;
                                            if (newValue === '') return;
                                            if (isTMJob && Number(newValue) < 1) {
                                              return;
                                            }
                                            // if(details?.job_category_name == 'Time & Material' && details?.allInstallationCompleted == 1){
                                            //   let stock = data.stock_type === 1 ? 'Finished' : 'Partial';
                                            // if (stock === 'Finished' && Number(newValue) > data.finishedProductQty) {
                                            //   enqueueSnackbar('Quantity exceeds finished material stock', { variant: 'error' })
                                            //   return;
                                            // } else if (stock === 'Partial' && Number(newValue) > data.partial_stock) {
                                            //   enqueueSnackbar('Quantity exceeds partial material stock', { variant: 'error' })
                                            //   return; 
                                            // }
                                            // }
                                            setSelectedMaterials((prev) =>
                                              prev.map((p) => {
                                                const isMatch = data.isAdditionalProduct
                                                  ? p.newIndexId === data.newIndexId
                                                  : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                    p.stock_type === data.stock_type &&
                                                    (p.stock_type === 1 || p.convertion_unit === data.convertion_unit);

                                                return isMatch ? { ...p, quantity: Number(newValue) } : p;
                                              })
                                            );

                                            data['quantity'] = Number(newValue);
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyDown={(event) => {
                                            if (['ArrowUp', 'ArrowDown'].includes(event.key)) {
                                              const isTMJob = details?.job_category_name === 'Time & Material' || values?.project_category?.name === 'Time & Material' || values?.project_category?.id === 12 || details?.project_category === 12;
                                              const newValue = Number(event.target.value) || 0;
                                              const limit = isTMJob ? 1 : 0;
                                              if (newValue <= limit && event.key === 'ArrowDown') {
                                                event.preventDefault();
                                              }
                                            }
                                          }}
                                        />
                                      </TableCell>
                                          <TableCell>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                              <Remove
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const hasPermission = explodedPermissions?.some((permission) =>
                                                    ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                  )
                                                  // if (!hasPermission) {
                                                  //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                  // }
                                                  // const formulaEach = Number(data.markUpCost)
                                                  // const retailEachBase = Number(data.price)
                                                  const formulaEach = Number(data.price)
                                                  const retailEachBase = Number(data.markUpCost)
                                                  if (retailEachBase <= formulaEach && !hasPermission) {
                                                    return enqueueSnackbar(
                                                      'To apply a negative marketing adjustment, Markup Cost Each must be higher than Unit Price.',
                                                      { variant: 'error' },
                                                    )
                                                  }
                                                  const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                  const adjustment = Number(data?.adjustment) || 0;
                                                  // console.log('aaaaaaaaaaaaaa', data?.adjustment);
                                                  // console.log('aaaaaaaaaaaaaa', adjustment);
                                                  // console.log('aaaaaaaaaaaaaa', maxNegative);

                                                  if (adjustment >= maxNegative && hasPermission) {
                                                    return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                  } else if (adjustment > maxNegative && !hasPermission) {
                                                    return enqueueSnackbar(
                                                      `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                      { variant: 'error' }
                                                    );
                                                  }
                                                  const newValue = false
                                                  // setSelectedMaterials((prevMaterials) =>
                                                  //   prevMaterials.map((p) => {
                                                  //     if (p.newIndexId === data.newIndexId) {
                                                  //       console.log('aaaaaaaaaaaaaaaaaaaaaaaaa',p);
                                                  //       console.log('aaaaaaaaaaaaaaaaaaaaaaaaa',data);

                                                  //       return {
                                                  //         ...p,
                                                  //         adj_value_type: newValue,
                                                  //       };
                                                  //     }
                                                  //     return p;
                                                  //   }),
                                                  // )
                                                  setSelectedMaterials((prevMaterials) =>
                                                    prevMaterials.map((p) => {
                                                      const isMatchingProduct = data.isAdditionalProduct
                                                        ? p.newIndexId === data.newIndexId
                                                        : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                        p.stock_type === data.stock_type &&
                                                        (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                        (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));
                                                        
                                                      return isMatchingProduct
                                                        ? { ...p, adj_value_type: newValue }
                                                        : p;
                                                    }),
                                                  );
                                                  // setFieldValue('manager_approval_required', true)
                                                  // data['adj_value_type'] = newValue
                                                  // markUnsavedChanges();
                                                }}
                                              />
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={data.adj_value_type}
                                                    onChange={(event) => {
                                                      const newValue = event.target.checked
                                                      const hasPermission = explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                      )
                                                      // if (!hasPermission && newValue === false) {
                                                      //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      // }
                                                      if (newValue === false) {
                                                        const formulaEach = Number(data?.price)
                                                        const retailEachBase = Number(data.markUpCost)
                                                        if (retailEachBase <= formulaEach && !hasPermission) {
                                                          return enqueueSnackbar(
                                                            'To apply a negative marketing adjustment, Markup Cost Each must be higher than Unit Price.',
                                                            { variant: 'error' },
                                                          )
                                                        }
                                                      }
                                                      const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                      const adjustment = Number(data.adjustment) || 0;
                                                      if (adjustment >= maxNegative && newValue === false && hasPermission) {
                                                        return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (adjustment > maxNegative && newValue === false && !hasPermission) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                          { variant: 'error' }
                                                        );
                                                      }

                                                      // setSelectedMaterials((prevMaterials) =>
                                                      //   prevMaterials.map((p) => {
                                                      //     if (p.newIndexId === data.newIndexId) {
                                                      //       return {
                                                      //         ...p,
                                                      //         adj_value_type: newValue,
                                                      //       };
                                                      //     }
                                                      //     return p;
                                                      //   }),
                                                      // )
                                                      setSelectedMaterials((prevMaterials) =>
                                                        prevMaterials.map((p) => {
                                                          const isMatchingProduct = data.isAdditionalProduct
                                                            ? p.newIndexId === data.newIndexId
                                                            : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                            p.stock_type === data.stock_type &&
                                                            (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                            (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));

                                                          return isMatchingProduct
                                                            ? { ...p, adj_value_type: newValue }
                                                            : p;
                                                        }),
                                                      );
                                                      data['adj_value_type'] = newValue
                                                      if (newValue === false) {
                                                        // setFieldValue('manager_approval_required', true)
                                                      }
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                }
                                                label=""
                                              />
                                              <Add
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const newValue = true
                                                  // setSelectedMaterials(
                                                  //   (prevProducts) =>
                                                  //     prevProducts.map(
                                                  //       (product) => {
                                                  //         if (
                                                  //           product.newIndexId ===
                                                  //           data.newIndexId
                                                  //         ) {
                                                  //           return {
                                                  //             ...product,
                                                  //             adj_value_type: newValue,
                                                  //           }
                                                  //         }
                                                  //         return product
                                                  //       },
                                                  //     ),
                                                  // )
                                                  setSelectedMaterials((prevMaterials) =>
                                                    prevMaterials.map((p) => {
                                                      const isMatchingProduct = data.isAdditionalProduct
                                                        ? p.newIndexId === data.newIndexId
                                                        : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                        p.stock_type === data.stock_type &&
                                                        (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                        (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));

                                                      return isMatchingProduct
                                                        ? { ...p, adj_value_type: newValue }
                                                        : p;
                                                    }),
                                                  );
                                                  // data['adj_value_type'] = newValue
                                                  // markUnsavedChanges();
                                                }}
                                              />
                                            </Stack>
                                          </TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              inputProps={{ min: 0 }}
                                              // label={
                                              //   data.markAdjType === 2
                                              //     ? '$'
                                              //     : data.markAdjType === 3
                                              //     ? '¢'
                                              //     : '%'
                                              // }
                                              label='$'
                                              value={data.adjustment ?
                                                Number(data.adjustment) ||
                                                null : ''
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              // onBeforeInput={(e) => {
                                              //   // const char = e.data; // next typed character
                                              //   // const nextValue = e.target.value + char;
                                              //   const inputElement = e.target;
                                              //   const nextValue = inputElement.value;

                                              //   const maxNegative = getMaterialMaxNegativeAdjustment(data);
                                              //   console.log('getMaxNegativeAdjustment1-maxNegative--maxNegative1',maxNegative);
                                              //   console.log('getMaxNegativeAdjustment1-maxNegative--nextValue',nextValue);


                                              //   if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0)) {
                                              //     e.preventDefault(); // ← stops the key BEFORE appearing
                                              //     enqueueSnackbar(
                                              //       `1 Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative.toFixed(2)}`,
                                              //       { variant: "error" }
                                              //     );
                                              //   }
                                              // }}
                                              onBeforeInput={(e) => {
                                                // const char = e.data; // next typed character
                                                // const nextValue = e.target.value + char;
                                                const inputElement = e.target;
                                                const nextValue = inputElement.value;
                                                const hasPermission = explodedPermissions?.some((permission) =>
                                                  ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                )

                                                const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                const isNegativeMode =
                                                  data?.adj_value_type === false ||
                                                  data?.adj_value_type === 0 ||
                                                  data?.adj_value_type === '0' ||
                                                  data?.adj_value_type === 'false';
                                                if (Number(nextValue) >= maxNegative && isNegativeMode && hasPermission) {
                                                  e.preventDefault(); // ← stops the key BEFORE appearing
                                                  enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                } else if (Number(nextValue) > maxNegative && isNegativeMode && !hasPermission) {
                                                  e.preventDefault(); // ← stops the key BEFORE appearing
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative}`,
                                                    { variant: "error" }
                                                  );
                                                }
                                              }}

                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                const hasPermission = explodedPermissions?.some((permission) =>
                                                  ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                )
                                                const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--maxNegative2', maxNegative);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--newValue', newValue);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--newValue', Number(newValue) > maxNegative);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--adj_value_type', data.adj_value_type);
                                                const isNegativeMode =
                                                  data?.adj_value_type === false ||
                                                  data?.adj_value_type === 0 ||
                                                  data?.adj_value_type === '0' ||
                                                  data?.adj_value_type === 'false';
                                                if (Number(newValue) >= maxNegative && isNegativeMode && hasPermission) {
                                                  enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                  return;
                                                } else if (Number(newValue) > maxNegative && isNegativeMode && !hasPermission) {
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                    { variant: 'error' }
                                                  );

                                                  return;
                                                }
                                                console.log('getMaxNegativeAdjustment1-maxNegative--adj_value_type2', data.adj_value_type);
                                                const numValue = parseFloat(newValue) || 0
                                                if (numValue < 0) {
                                                  newValue = 0
                                                } else {
                                                  newValue = String(numValue)
                                                }
                                                // Allow only two decimal places
                                                if (
                                                  newValue.includes('.')
                                                ) {
                                                  const parts =
                                                    newValue.split('.')
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]
                                                      }.${parts[1].slice(
                                                        0,
                                                        2,
                                                      )}`
                                                  }
                                                }
                                                data['adjustment'] =
                                                  newValue
                                                setFieldValue(
                                                  adjustmentFieldName,
                                                  newValue,
                                                );
                                                setRefreshCalculation(!refreshCalculation)
                                                // markUnsavedChanges();
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === '-' ||
                                                  event.key === '+'
                                                ) {
                                                  event.preventDefault()
                                                }
                                                // Prevent arrow down key when value is 0 or would go negative
                                                if (event.key === 'ArrowDown') {
                                                  const inputValue = event.target.value
                                                  const currentValue = parseFloat(inputValue) || 0
                                                  const step = parseFloat(event.target.step) || 1
                                                  if (currentValue - step < 0) {
                                                    event.preventDefault()
                                                  }
                                                }
                                              }}
                                              error={Boolean(
                                                touched[
                                                adjustmentFieldName
                                                ] &&
                                                errors[
                                                adjustmentFieldName
                                                ],
                                              )}
                                              helperText={
                                                touched[
                                                adjustmentFieldName
                                                ] &&
                                                errors[adjustmentFieldName]
                                              }
                                            />
                                          </TableCell>
                                         {/* <TableCell>{(data.price*(data.quantity||0))?.toFixed(2)}</TableCell>
                                         <TableCell>{((data.markUpCost || 0) * (data.quantity||0))?.toFixed(2)}</TableCell> */}
                                         <TableCell>
                                            {(
                                              (data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))) * (data.quantity || 0)
                                            )?.toFixed(2)}
                                          </TableCell>
                                          <TableCell >
                                            {/* <IconButton onClick={() => handleDeleteMaterial(data.id, data.newIndexId,)}> */}
                                            <IconButton disabled={tmInvoicingFieldDisabled}
                                                onClick={() => handleDeleteMaterial(data.product_id || data.id, data.stock_type, data.stock_type === 2 ? data.convertion_unit : 0)}
                                              >
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={openMaterialNote[data.newIndexId] || false}
                                          handleClose={() => handleCloseMaterialNote(data.newIndexId)}
                                        >
                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >
                                              <Grid item xs={12}>
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Note
                                                </Typography>

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    size="medium"
                                                    value={currentNote}
                                                    onChange={handleNoteChange}
                                                    disabled={tmInvoicingFieldDisabled}
                                                    InputProps={{ readOnly: tmInvoicingFieldDisabled }}
                                                    sx={{
                                                      '& .MuiInputBase-input': {
                                                        color: 'red',
                                                      },
                                                    }}
                                                    error={!currentNote.trim() && currentNote.length > 0}
                                                    inputProps={{ maxLength: MAX_CHARACTERS }}
                                                    helperText={
                                                      !currentNote.trim() && currentNote.length > 0
                                                        ? 'Note cannot be empty or contain only spaces'
                                                        : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                    }
                                                  />
                                                </Stack>
                                              </Grid>
                                          </Grid>

                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => handleSaveMaterialNote(data.newIndexId)}
                                                  loading={isSavingNote}
                                                  disabled={!currentNote.trim() || tmInvoicingFieldDisabled}>
                                                  Save
                                                </LoadingButton>
                                                <LoadingButton
                                                  variant="outlined"
                                                  color="error"
                                                  onClick={() => handleClearMaterialNote(data.newIndexId)}
                                                  loading={isClearingNote}
                                                  disabled={!currentNote.trim() || tmInvoicingFieldDisabled}>
                                                  Clear
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                        
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Stack sx={{ justifyContent: 'flex-end', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                            {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewMaterialRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Material Row
                            </Button> */}
                            <Typography variant="h6">
                              Total Additional Material Cost:{' '}
                              {selectedMaterialSubTotal}
                            </Typography>
                          </Stack>
                          {/* </>
                           )
                          } */}

                            {
                    values?.project_category?.id ==13 ? "" :
                      <Stack direction={{ xs: 'column', md: 'column' }} display="flex" justifyContent="space-between">
                        <FormControlLabel
                          disabled={tmInvoicingFieldDisabled}
                          control={
                            <Switch
                              checked={depositAndProgressBilling}
                              disabled={tmInvoicingFieldDisabled}
                              onChange={(e) => setDepositAndProgressBilling(e.target.checked)}
                            />
                          }
                          label="DEPOSIT AND PROGRESS BILLING"
                        />
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 1, mb: 1 }}>
                          {[
                            { label: 'Grand Total', value: grandTotal ? fUSPrice(grandTotal) : fUSPrice(0), icon: <Receipt fontSize="small" /> },
                            { label: 'Balance Due', value: fUSPrice(getDepositProgressBillingBalanceDue()), icon: <AccountBalanceWallet fontSize="small" /> },
                            { label: 'Balance', value:fUSPrice(Number(grandTotal || 0) - Number(getDepositProgressBillingTotal() || 0)), icon: <AttachMoney fontSize="small" /> },
                          ].map((item) => (
                            <Paper
                              key={item.label}
                              variant="outlined"
                              sx={{
                                flex: 1,
                                p: 1.25,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                borderRadius: 1,
                              }}
                            >
                              <Box sx={{ color: 'primary.main', display: 'flex' }}>
                                {item.icon}
                              </Box>
                              <Box>
                                <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
                                  {item.label}
                                </Typography>
                                <Typography variant="subtitle2">
                                  {item.value}
                                </Typography>
                              </Box>
                            </Paper>
                          ))}
                        </Stack>
                        {/* {depositAndProgressBilling && (
                          <Autocomplete
                            options={billingTypes}
                            fullWidth
                            getOptionLabel={(option) => option?.name}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            // sx={{ minWidth: 200 }}
                            onChange={(event, newValue) => {
                              if(newValue){
                                setFieldValue('billing_type', newValue)
                                setFieldValue('customerTypeId', newValue?.id)
                                setInitialBillingType(newValue)
                              }else{
                                setFieldValue('billing_type', null)
                                setFieldValue('customerTypeId', null)
                                setInitialBillingType(null)
                              }
                            }}
                            value={values.billing_type || initialBillingType}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Billing Type"
                                placeholder="Select billing type"
                                error={Boolean(touched.billing_type && errors.billing_type)}
                                helperText={touched.billing_type && errors.billing_type}
                              />
                            )}
                          />
                        )} */}
                        
                        {depositAndProgressBilling && (
                          <Stack spacing={2} sx={{ mt: 1 }}>
                            {depositProgressBillingRows.map((row, index) => (
                              <Stack
                                key={row.id || index}
                                direction={{ xs: 'column', md: 'row' }}
                                spacing={2}
                                alignItems={{ xs: 'stretch', md: 'center' }}
                              >
                                <TextField
                                  fullWidth
                                  label="Title"
                                  disabled={Number(row.markAsPaid) === 1 || Boolean(row.paymentMode) || tmInvoicingFieldDisabled}
                                  value={row.title}
                                  onChange={(e) =>
                                    handleDepositProgressBillingChange(index, 'title', e.target.value)
                                  }
                                  sx={{
                                    '& .MuiInputBase-input.Mui-disabled': {
                                      WebkitTextFillColor: '#9e9e9e !important',
                                      color: '#9e9e9e !important',
                                    },
                                    '& .MuiInputLabel-root.Mui-disabled': {
                                      color: '#9e9e9e !important',
                                    },
                                  }}
                                />
                             <Tooltip
                                title={ <span style={{ whiteSpace: 'pre-line' }}>
                                              {`Total amount: ${row.amount}
                                                Paid amount: ${row.partialAmount|| 0}
                                                Remaining Amount: ${Number(row.amount || 0) - Number(row.partialAmount || 0)}`}
                                         </span>}
                                arrow
                              >
                                <span style={{ display: 'block', width: '100%' }}>
                                 <TextField
                                  fullWidth
                                  disabled={Number(row.markAsPaid) === 1 || Boolean(row.paymentMode) || tmInvoicingFieldDisabled}
                                  type="number"
                                  label="Amount"
                                  value={Number(row.amount || 0) - Number(row.partialAmount || 0)===0?row.amount:Number(row.amount || 0) - Number(row.partialAmount || 0)}
                                  inputProps={{ min: 0, max: getDepositProgressBillingMaxAmount(index), disabled: Number(row.markAsPaid) === 1 || Boolean(row.paymentMode) }}
                                  sx={{
                                    '& .MuiInputBase-input.Mui-disabled': {
                                      WebkitTextFillColor: '#9e9e9e !important',
                                      color: '#9e9e9e !important',
                                    },
                                    '& .MuiInputLabel-root.Mui-disabled': {
                                      color: '#9e9e9e !important',
                                    },
                                  }}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    if (!/^\d*\.?\d{0,2}$/.test(value)) {
                                      return
                                    }

                                    handleDepositProgressBillingChange(index, 'amount', value)
                                  }}
                                />
                               </span>
                           </Tooltip>
                                <Stack
                                  direction="row"
                                  spacing={2}
                                  alignItems="center"
                                  justifyContent={{ xs: 'flex-end', md: 'flex-start' }}
                                  sx={{ width: { xs: '100%', md: 'auto' } }}
                                >
                                  {/* check box for payement complted fro inside edit sales order */}
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={row.paymentMode !== 'partaily paid' && ([1, 2].includes(Number(row.markAsPaid)) || Boolean(row.paymentMode))}
                                        // disabled={Number(row.markAsPaid) === 1 && Boolean(row.originalPaymentMode)}
                                        disabled={true}
                                        sx={{
                                          '&.Mui-checked, &.Mui-disabled.Mui-checked': {
                                            color: 'success.main',
                                          },
                                        }}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            const remainingAmount = Number(row.amount || 0) - Number(row.partialAmount || 0);
                                            handleDepositProgressBillingChange(index, 'markAsPaid', 1);
                                            handleDepositProgressBillingChange(index, 'partialAmount', remainingAmount > 0 ? remainingAmount : row.amount);
                                            handleOpenDepositPaymentModeDialog(row, index);
                                          } else {
                                            handleDepositProgressBillingChange(index, 'markAsPaid', 0);
                                            handleDepositProgressBillingChange(index, 'partialAmount', null);
                                            handleDepositProgressBillingChange(index, 'paymentMode', '');
                                          }
                                        }}
                                      />
                                    }
                                    label={
                                      row.paymentMode === 'partaily paid'
                                        ? 'Partially Paid'
                                        : ([1, 2].includes(Number(row.markAsPaid)) || Boolean(row.paymentMode))
                                          ? 'Paid'
                                          : 'Not paid'
                                    }
                                    sx={{
                                      minWidth: 140,
                                      m: 0,
                                      // display: { xs: 'none', md: 'inline-flex' },
                                      alignSelf: 'center',
                                      '& .MuiFormControlLabel-label': {
                                        whiteSpace: 'nowrap',
                                        color: (Number(row.markAsPaid) === 1 || Boolean(row.paymentMode)) ? 'success.main' : 'inherit',
                                        fontWeight: (Number(row.markAsPaid) === 1 || Boolean(row.paymentMode)) ? 600 : 400,
                                      },
                                      '& .MuiFormControlLabel-label.Mui-disabled': {
                                        color: (Number(row.markAsPaid) === 1 || Boolean(row.paymentMode)) ? 'success.main' : 'text.disabled',
                                      },
                                    }}
                                  />
                                  {/* {(Number(row.markAsPaid) === 1) && ( */}
                                    {/* <Tooltip title={row.paymentMode ? 'Edit Payment Mode' : 'Add Payment Mode'}> */}
                                      <IconButton
                                        size="small"
                                        // disabled={true}
                                        // onClick={() => handleOpenDepositPaymentModeDialog(row, index)}
                                        sx={{
                                          alignSelf: 'center',
                                          border: 1,
                                          borderColor: row.paymentMode ? 'success.main' : 'primary.main',
                                          color: row.paymentMode ? 'success.main' : 'primary.main',
                                        }}
                                      >
                                        <MonetizationOn fontSize="small" />
                                      </IconButton>
                                    {/* </Tooltip> */}
                                  {/* )} */}
                                  <IconButton
                                    onClick={
                                      Boolean(row.paymentMode) || Number(row.markAsPaid) === 1
                                        ? undefined
                                        : () => handleDeleteDepositProgressBillingRow(index)
                                    }
                                    disabled={Boolean(row.paymentMode) || Number(row.markAsPaid) === 1}
                                    sx={{ alignSelf: 'center' }}
                                  >
                                    <Icon icon={trash2Outline} sx={{ color: (Boolean(row.paymentMode) || Number(row.markAsPaid) === 1) ? '#9e9e9e !important' : 'white !important' }} />
                                  </IconButton>
                                </Stack>
                                <hr/>
                              </Stack>
                            ))}
                            {canAddDepositProgressBillingRow() && !tmInvoicingFieldDisabled && (
                              <Button
                                variant="outlined"
                                startIcon={<Icon icon={plusFill} />}
                                onClick={handleAddDepositProgressBillingRow}
                                sx={{ alignSelf: 'flex-start' }}
                              >
                                Add Row
                              </Button>
                            )}
                          </Stack>
                        )}
                      </Stack>
                     }

                          <Divider />
                          <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            maxRows={7}
                            label="Notes"
                            name="notes"
                            disabled={tmInvoicingFieldDisabled}
                            InputProps={tmInvoicingFieldDisabled ? { readOnly: true, sx: { color: 'error.main' } } : { sx: { color: 'error.main' } }}
                            value={nameFileds?.notes}
                            onChange={(e) => {
                              const v = e.target.value
                              setNameFileds({ ...nameFileds, notes: v })
                              if (v.trim()) {
                                setFieldErrors((prev) => ({
                                  ...prev,
                                  notes: undefined,
                                }))
                              }
                            }}
                            error={Boolean(touched.notes && errors.notes)}
                            helperText={
                              touched.notes && errors.notes
                                ? errors.notes
                                : `${nameFileds?.notes?.length || 0}/${MAX_CHARACTERS} characters`
                            }
                            inputProps={{
                              maxLength: MAX_CHARACTERS,
                            }}
                          />
                        </>}
                        {/* Discount hidden — restore when needed
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent={'space-between'}>
                          <TextField
                            sx={{ width: 400 }}
                            type='number'
                            onKeyPress={(event) => {
                              if (event.key === '-') {
                                event.preventDefault();
                              }
                            }}
                            onChange={(event) => {
                              let newValue = event.target.value
                              let data = 0
                              if (markupType === 1) {
                                data = totalWholesalePrice - budget
                                
                              } else if (markupType === 2) {
                                data = totalRetailPrice - budget
                              }
                              if (Number(newValue) > data) {
                                newValue = data?.toFixed(2);
                              }
                              if (newValue === '-0.00') {
                                newValue = 0;
                              }
                                console.log("discounttttttttttttttttttt",totalWholesalePrice - budget);

                              console.log('newValue-2-------', newValue);
                              setFieldValue('invoice_discount', newValue)
                            }}
                            label={hasDiscountPermission ? "Discount (Access Denied)" : "Discount"}
                            disabled={hasDiscountPermission || tmInvoicingFieldDisabled}
                            InputProps={tmInvoicingFieldDisabled ? { readOnly: true } : undefined}
                            value={values.invoice_discount}
                            // {...getFieldProps('invoice_discount')}
                            error={Boolean(touched.invoice_discount && errors.invoice_discount)}
                            helperText={touched.invoice_discount && errors.invoice_discount}
                            inputProps={{ max: (markupType === 1) ? totalWholesalePrice - budget : ((markupType === 2) ? totalRetailPrice - budget : 0) , min: 0 }}
                          />
                        */}
                          {/* <Autocomplete
                            sx={{ width: 400 }}
                            id="combo-box-demo"
                            disabled={true}
                            options={taxCategories || []}
                            value={selectedTaxCategory || null}
                            onChange={(event, newValue) => {
                              setSelectedTaxCategory(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Tax category" />
                            )}
                            getOptionLabel={(option) => option.name ? option.name : ''}
                          /> */}
                        {/* </Stack> */}
                                {
                                  details?.installationStatus == 2 ? (
                                    <>
                                      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                                        <TextField
                                          fullWidth
                                          multiline
                                          minRows={3}
                                          maxRows={7}
                                          label="Reason for Edit"
                                          {...getFieldProps('edit_reason')}
                                          error={Boolean(touched.reasedit_reasonon && errors.edit_reason)}
                                          helperText={touched.edit_reason && errors.edit_reason}
                                          InputProps={{
                                            sx: {
                                              color: 'error.main',
                                            }
                                          }}
                                          FormHelperTextProps={{
                                            sx: {
                                              color: 'error.main', // This changes the color of the error text to red
                                            },
                                          }}
                                        />
                                      </Stack>
                                    </>)
                                    : ""
                                }
                        <Stack data-tm-editable direction={{ xs: 'column', sm: 'row' }} alignItems={'flex-start'} spacing={{ xs: 2, sm: 2 }} sx={{ mb: 2 }}>
                          <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            maxRows={7}
                            label="Bill To"
                            placeholder="Enter billing address"
                            name="bill_to"
                            value={billToInputValue || ''}
                            onChange={(event) => {
                              const nextValue = event.target.value;
                              setIsBillToDirty(true);
                              setBillToInputValue(nextValue);
                              setFieldValue('bill_to', nextValue, false);
                            }}
                            onBlur={(event) => setFieldValue('bill_to', event.target.value, false)}
                          />
                          <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            maxRows={7}
                            label="Ship To"
                            placeholder="Enter shipping address"
                            name="ship_to"
                            value={shipToInputValue || ''}
                            onChange={(event) => {
                              const nextValue = event.target.value;
                              setIsShipToDirty(true);
                              setShipToInputValue(nextValue);
                              setFieldValue('ship_to', nextValue, false);
                            }}
                            onBlur={(event) => setFieldValue('ship_to', event.target.value, false)}
                          />
                        </Stack>
                        <Typography sx={{ color: theme.palette.error.main }}>**All values in the software are rounded to two decimal places in accordance with standard US calculation practices.</Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                          <Stack>
                            
                            {/* <TextField
                            sx={{ width: 400 }}
                            type='number'
                            onChange={(event, newValue) => setFieldValue('invoice_discount', newValue)}
                            label="Extra Discount"
                            {...getFieldProps('invoice_discount')}
                            error={Boolean(touched.invoice_discount && errors.invoice_discount)}
                            helperText={touched.invoice_discount && errors.invoice_discount}
                          /> */}

                            {/* <Typography sx={{ color: 'text.secondary' }}>Sub Total: {rfqSubTotal ? rfqSubTotal?.toFixed(2) : 0}</Typography>
                          <Typography sx={{ color: 'text.secondary' }}>Service cost in Product Formula: {initialServiceCostInProductFormula ? initialServiceCostInProductFormula?.toFixed(2) : 0}</Typography>
                          <Typography sx={{ color: 'text.secondary' }}>Total ({rfqSubTotal?.toFixed(2)} - {initialServiceCostInProductFormula?.toFixed(2)}): {totalsum ? totalsum?.toFixed(2) : 0}</Typography> */}
                          {/* {canViewCosts && ( */}
                          <>
                          <Typography >
                              Sub Total: {totalsum ? fUSPrice(totalsum) : fUSPrice(0)}
                            </Typography>
                            {/* <Typography >
                              Tax: {parseFloat(taxAmount).toFixed(2) || 0.00}  
                            </Typography> */}
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography>
                                Tax: {parseFloat(taxAmount).toFixed(2) || '0.00'}
                              </Typography>
                              {/* {
                                details?.avalara_code ? ( */}
                              <>
                              <img
                                src={AVALARALOGO}
                                width="20px"
                                height="12px"
                                style={{ marginTop: '2px' }} // Adjust for alignment if needed
                                alt="Avalara logo"
                              />
                               <Typography sx={{ marginTop: '8px',color:"#fd6400",fontSize:"12px"}}>
                                             Synced with Avalara
                                </Typography>
                                </>
{/* // ):""} */}

                            </Box>
                            {isRushFeeChecked && (
                              <Typography>
                                Rush Fee: {fUSPrice(rushFeeAmount)}
                              </Typography>
                            )}
                            <Typography sx={{ color: noCharge ? 'red' : theme.palette.mode === 'light' ? '#FFAF00' : 'yellow' }}>
                              Grand Total: {(noCharge && grandTotal >0) ?fUSPrice(grandTotal * -1) :fUSPrice(grandTotal) || fUSPrice(0)}
                            </Typography>
                            {/* <Typography sx={{ color: 'yellow' }}>Grand Total : {totalsum ? totalsum?.toFixed(2) : 0}</Typography> */}
                            {/* <Typography sx={{ color: 'yellow' }}>Total Product Formula Cost: {budget ? budget?.toFixed(2) : 0}</Typography> */}
                            {/* Discount hidden — restore when needed
                            <Typography >Total Discount: {DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00}</Typography>
                            */}
                          </>
                          {/* )} */}

                            {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                              <Typography sx={{ cursor: 'pointer' }}>Total Markup Amount: {totalMarkupAmount ? parseFloat(Number(totalMarkupAmount))?.toFixed(2) : 0}</Typography>
                            </Tooltip>

                            <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                              <Typography sx={{ cursor: 'pointer' }}>Total Markup Percentage: {totalMarkupPercentage ? parseFloat(Number(totalMarkupPercentage))?.toFixed(2) : 0}</Typography>
                            </Tooltip> */}

                            {/* <Typography sx={{ color: 'text.secondary' }}>Total Product Markup: {(originaltotalMarkup/selectedProducts.length)?.toFixed(2)}</Typography> */}
                            {/* { showServices ?<Typography sx={{ color: 'text.secondary' }}>Total Service Markup: {(originaltotalServiceMarkup/(selectedServices.length+additionalSelectedServices.length))?.toFixed(2)}</Typography>:""} */}
                          </Stack>
                          <Stack direction={'column'} display={'flex'} justifyContent={'center'}>
                          <FormControlLabel
                            disabled={tmInvoicingFieldDisabled}
                            onChange={() => {
                              if (tmInvoicingFieldDisabled) return;
                              // Toggle the value of welcome_message using setCurrentRFQdata
                              setCurrentRFQdata((prevData) => ({
                                ...prevData,
                                welcome_message: !prevData.welcome_message,
                              }));
                            }}
                            control={<Switch  {...getFieldProps('welcome_message')} color="primary"
                              checked={values.welcome_message == 1}
                              disabled={tmInvoicingFieldDisabled}
                            />}
                            labelPlacement="end"
                            label="Use Custom Welcome Message"
                            sx={{ mt: 6 , mb:2 }}
                          />
                          {
                            noCharge ? ""
                          :
                          <>
                          <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('client_approve')}
                              color="primary"
                              checked={values.client_approve}
                              onChange={(event) => setFieldValue('client_approve', event.target.checked)}
                            />
                          }
                          labelPlacement="end"
                          disabled={details?.installationStatus == 2 || details?.allInstallationCompleted == 1}
                          label="Enable for Client Approval"
                          sx={{ mt: 0 }}
                        />
                        {
                          details?.installationStatus == 2 ? (
                        <Typography sx={{ color: 'text.secondary' }}>Installation Moved to Installling Phase</Typography>
                            ) : ""
                          }
                          </>
                          }
                          {/* Sales orders no longer use manager approval toggle
                          {showManagerApprovalToggle && details?.allInstallationCompleted != 1 && (
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps('manager_approval_required')}
                                  color="primary"
                                  checked={values.manager_approval_required}
                                  onChange={(event) => setFieldValue('manager_approval_required', event.target.checked)}
                                  readOnly={details?.installationStatus == 2 || isManagerApprovalLocked}
                                  inputProps={{ readOnly: details?.installationStatus == 2 || isManagerApprovalLocked }}
                                />
                              }
                              labelPlacement="end"
                              disabled={details?.installationStatus == 2}
                              label="Enable for Manager approval"
                              sx={{ mt: 0 }}
                            />
                          )} */}
                       <FormControlLabel
                          disabled={tmInvoicingFieldDisabled}
                          control={
                            <Switch
                            {...getFieldProps('show_install_price')}
                              color="primary"
                              checked={values.show_install_price == 0 ? false : true}
                              disabled={tmInvoicingFieldDisabled}
                              onChange={(event) => setFieldValue('show_install_price', event.target.checked ? 1 : 0)}
                            />
                          }
                          labelPlacement="end"
                          label="Show Install Price"
                          sx={{ mt: 2 }}
                        />
                        <FormControlLabel
                          disabled={tmInvoicingFieldDisabled || rushFeeSwitchDisabled}
                          control={
                            <Switch
                              color="primary"
                              checked={isRushFeeChecked}
                              disabled={tmInvoicingFieldDisabled || rushFeeSwitchDisabled}
                              onChange={(event) => {
                                if (tmInvoicingFieldDisabled || rushFeeSwitchDisabled) return;
                                if (isRushFeeAutoLocked && !canOverrideRushFeeLock) return;
                                const turningOff = !event.target.checked;
                                markRushFeeUserToggled(rushFeeSyncRefs.current, {
                                  turnedOn: event.target.checked,
                                  declinedWhileLocked: turningOff && isRushFeeAutoLocked && canOverrideRushFeeLock,
                                });
                                setFieldValue('rush_fee', event.target.checked ? 1 : 0);
                              }}
                            />
                          }
                          labelPlacement="end"
                          label={
                            rushFeeAccessDenied
                              ? 'Rush Fee (Access Denied)'
                              : 'Rush Fee'
                          }
                          sx={{ mt: 2 }}
                        />
                        </Stack>
                        </Stack>
                        {values.welcome_message == true && (
                          <>
                            <Stack>
                              <LabelStyle>Subject</LabelStyle>
                              <TextField
                                //   fullWidth
                                type='text'
                                sx={{ width: 400 }}
                                defaultValue={values.subject}
                                {...getFieldProps('subject')}
                                error={Boolean(touched.subject && errors.subject)}
                                helperText={touched.subject && errors.subject}
                              />
                            </Stack>
                            <LabelStyle>Email Content</LabelStyle>
                            <TextField
                              fullWidth
                              multiline
                              minRows={3}
                              maxRows={7}
                              label="Email Content"
                              defaultValue={values.email_content}
                              {...getFieldProps('email_content')}
                              error={Boolean(touched.email_content && errors.email_content)}
                              helperText={touched.email_content && errors.email_content}
                            />
                          </>
                        )}
                        <LabelStyle>Order state</LabelStyle>
                        <Typography>While in draft mode, clients you add to order tasks won't be notified</Typography>
                        <FormControlLabel
                          onChange={() => {

                            setCurrentRFQdata((prevData) => ({
                              ...prevData,
                              draft: !prevData.draft,
                            }));
                          }}
                          disabled ={details?.allInstallationCompleted == 1}
                          control={<Switch {...getFieldProps('draft')} color="primary" checked={values.draft} />}
                          labelPlacement="end"
                          label="Draft"
                          sx={{ mt: 5 }}
                        />
                        <Dialog open={openMakeTaskDialog} onClose={handleCloseMakeTastDialog}>
                          <DialogTitle>Do you want to continue?</DialogTitle>
                          <DialogContent>
                            {(() => {
                              // Filter out items with id == 10 when project_category.id !== 11
                            const filteredAdditionalServices = values.project_category?.id !== 11 ? additionalSelectedServices.filter(item => {
                                            if (item?.labour_cost_service_id) {
                                              // Exclude if labour_cost_service_id is 10
                                              return item?.labour_cost_service_id !== 10;
                                            } else {
                                              // Exclude if id is 10
                                              return item?.id !== 10;
                                            }
                                          })
                                          : additionalSelectedServices;
                              
                              const additionalServicesWithoutTask = filteredAdditionalServices?.filter(item => item?.makeAsTask === 0) || [];
                              const additionalServicesWithoutInstallCard = filteredAdditionalServices?.filter(item => item?.makeInstallCard === 0) || [];
                              const additionalServicesWithoutJobCost = filteredAdditionalServices?.filter(item => item?.jobCost === 0) || [];
                              const proposalServicesWithoutTask = cartService?.filter(item => item?.makeAsTask === 0) || [];
                              const proposalServicesWithoutInstallCard = cartService?.filter(item => item?.makeInstallCard === 0) || [];
                              const proposalServicesWithoutJobCost = cartService?.filter(item => item?.jobCost === 0) || [];
                              return (
                                <Alert severity="warning">
                                  {additionalServicesWithoutTask.length > 0 || proposalServicesWithoutTask.length > 0 ? (
                                    <div>
                                      {additionalServicesWithoutTask.length > 0 && (
                                        <>The additional services <em>{additionalServicesWithoutTask.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {additionalServicesWithoutTask.length > 0 && proposalServicesWithoutTask.length > 0 && <> and </>}
                                      {proposalServicesWithoutTask.length > 0 && (
                                        <>The proposal services <em>{proposalServicesWithoutTask.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {' '}have the <strong>Make As Task</strong> toggle turned off. {`${values?.project_category?.id == 12 ? "This will appear in production without tasks" :"These will not appear in production as they are not creating tasks."}`}
                                      <br /><br />
                                    </div>
                                  ) : null}

                                  {additionalServicesWithoutInstallCard.length > 0 || proposalServicesWithoutInstallCard.length > 0 ? (
                                    <div>
                                      {additionalServicesWithoutInstallCard.length > 0 && (
                                        <>The additional services <em>{additionalServicesWithoutInstallCard.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {additionalServicesWithoutInstallCard.length > 0 && proposalServicesWithoutInstallCard.length > 0 && <> and </>}
                                      {proposalServicesWithoutInstallCard.length > 0 && (
                                        <>The proposal services <em>{proposalServicesWithoutInstallCard.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {' '}have the <strong>Make Install Card</strong> toggle turned off. These will not appear in installation as they are not creating install cards.
                                      <br /><br />
                                    </div>
                                  ) : null}

                                  {additionalServicesWithoutJobCost.length > 0 || proposalServicesWithoutJobCost.length > 0 ? (
                                    <div>
                                      {additionalServicesWithoutJobCost.length > 0 && (
                                        <>The additional services <em>{additionalServicesWithoutJobCost.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {additionalServicesWithoutJobCost.length > 0 && proposalServicesWithoutJobCost.length > 0 && <> and </>}
                                      {proposalServicesWithoutJobCost.length > 0 && (
                                        <>The proposal services <em>{proposalServicesWithoutJobCost.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {' '}have the <strong>Job Cost Toggle</strong> turned off, and will not appear in the job cost.
                                      <br /><br />
                                    </div>
                                  ) : null}

                                  Do you want to continue?
                                </Alert>
                              );
                            })()}
                          </DialogContent>
                          <DialogActions>
                            <Button variant='outlined' onClick={handleCloseMakeTastDialog} color="inherit">
                              No
                            </Button>
                            <Button
                              onClick={() => {
                                handleContinueMakeTastDialog();
                                setTimeout(() => {
                                  handleSubmit();
                                }, 100); // small delay ensures dialog closes before submission
                              }}
                              variant="contained"
                            >
                              Yes
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Dialog open={showMakeTaskErrorDialog} onClose={() => setShowMakeTaskErrorDialog(false)}>
                          <DialogTitle>Action Required: Enable Service Install Card</DialogTitle>
                          <DialogContent>
                            <Alert severity="error">
                              {values?.project_category?.id == 11 ? (
                                <>
                                  You cannot submit a <strong>Service Only</strong> job if all selected services have the <em>Make Install Card</em> toggle turned off.
                                  At least one service must generate an install card to proceed.
                                </>
                              ) : (
                                <>
                                  You cannot submit a <strong>Time & Material</strong> job without any products or materials,
                                  and with all services having the <em>Make Install Card</em> toggle turned off. Please add a
                                  product, material, or enable the <em>Make Install Card</em> toggle for at least one service.
                                </>
                              )}
                            </Alert>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={() => setShowMakeTaskErrorDialog(false)} color="primary" variant="contained">
                              OK, I Understand
                            </Button>
                          </DialogActions>
                        </Dialog>

                        <Dialog
                          open={openChangeJobTypeDialog}
                          onClose={() => setOpenChangeJobTypeDialog(false)}
                        >
                          <DialogTitle>Confirm Job Type Change</DialogTitle>

                          <DialogContent>
                            <Typography>
                              Switching from <strong>Time & Material</strong> will clear all selected Products, Materials,
                              Map Services and related calculations. Your existing Services will be preserved.
                              Do you want to continue?
                            </Typography>
                          </DialogContent>

                          <DialogActions>
                            <Button
                              onClick={() => {
                                setOpenChangeJobTypeDialog(false);
                                setPendingJobType(null);
                              }}
                              color="inherit"
                            >
                              Cancel
                            </Button>

                            <Button
                              onClick={() => {
                                setOpenChangeJobTypeDialog(false);
                                handleJobTypeChange(pendingJobType); // Apply change
                                setPendingJobType(null);
                              }}
                              color="error"
                              variant="contained"
                            >
                              Yes, Change
                            </Button>
                          </DialogActions>
                        </Dialog>


                                          {/* Service Note Modal */}
                  {cartService?.map((data, index) => (
                    <Modal
                      key={`service-note-${data.indexId || data.id}`}
                      open={serviceNoteState?.[data.indexId || data.id] || false}
                      handleClose={() => handleCloseServiceNote(data.indexId || data.id)}
                    >
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'center', width: '100%' }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2, }}>
                            Note
                          </Typography>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{ mb: 2 }}
                          >
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              size="medium"
                              value={serviceCurrentNote}
                              onChange={handleServiceNoteChange}
                              disabled={tmInvoicingFieldDisabled}
                              error={!serviceCurrentNote.trim() && serviceCurrentNote.length > 0}
                              inputProps={{ maxLength: MAX_CHARACTERS, readOnly: tmInvoicingFieldDisabled }}
                              helperText={
                                !serviceCurrentNote.trim() && serviceCurrentNote.length > 0
                                  ? 'Note cannot be empty or contain only spaces'
                                  : `${serviceCurrentNote.length}/${MAX_CHARACTERS} characters`
                              }
                              InputProps={{
                                readOnly: tmInvoicingFieldDisabled,
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => handleSaveServiceNote(data.indexId || data.id)}
                              loading={serviceIsSavingNote}
                              disabled={!serviceCurrentNote.trim() || tmInvoicingFieldDisabled}>
                              Save
                            </LoadingButton>
                            <LoadingButton
                              variant="outlined"
                              color="error"
                              onClick={() => handleClearServiceNote(data.indexId || data.id)}
                              loading={serviceIsClearingNote}
                              disabled={!serviceCurrentNote.trim() || tmInvoicingFieldDisabled}>
                              Clear
                            </LoadingButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Modal>
                  ))}

                  {/* Service Note Modal for additionalSelectedServices */}
                  {additionalSelectedServices?.map((data, index) => (
                    <Modal
                      key={`additional-service-note-${data.indexId || data.newIndexId || index}`}
                      open={serviceNoteState?.[data.indexId || data.newIndexId || index] || false}
                      handleClose={() => handleCloseServiceNote(data.indexId || data.newIndexId || index)}
                    >
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'center', width: '100%' }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2, }}>
                            Note
                          </Typography>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{ mb: 2 }}
                          >
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              size="medium"
                              value={serviceCurrentNote}
                              onChange={handleServiceNoteChange}
                              disabled={tmInvoicingFieldDisabled}
                              error={!serviceCurrentNote.trim() && serviceCurrentNote.length > 0}
                              inputProps={{ maxLength: MAX_CHARACTERS, readOnly: tmInvoicingFieldDisabled }}
                              helperText={
                                !serviceCurrentNote.trim() && serviceCurrentNote.length > 0
                                  ? 'Note cannot be empty or contain only spaces'
                                  : `${serviceCurrentNote.length}/${MAX_CHARACTERS} characters`
                              }
                              InputProps={{
                                readOnly: tmInvoicingFieldDisabled,
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => handleSaveServiceNote(data.indexId || data.newIndexId || index)}
                              loading={serviceIsSavingNote}
                              disabled={!serviceCurrentNote.trim() || tmInvoicingFieldDisabled}>
                              Save
                            </LoadingButton>
                            <LoadingButton
                              variant="outlined"
                              color="error"
                              onClick={() => handleClearServiceNote(data.indexId || data.newIndexId || index)}
                              loading={serviceIsClearingNote}
                              disabled={!serviceCurrentNote.trim() || tmInvoicingFieldDisabled}>
                              Clear
                            </LoadingButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Modal>
                  ))}

                  {/* Service Note Modal for selectedServices */}
                  {selectedServices?.map((data, index) => (
                    <Modal
                      key={`selected-service-note-${data.indexId || data.id || index}`}
                      open={serviceNoteState?.[data.indexId || data.id || index] || false}
                      handleClose={() => handleCloseServiceNote(data.indexId || data.id || index)}
                    >
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'center', width: '100%' }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2, }}>
                            Note
                          </Typography>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{ mb: 2 }}
                          >
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              size="medium"
                              value={serviceCurrentNote}
                              onChange={handleServiceNoteChange}
                              disabled={tmInvoicingFieldDisabled}
                              error={!serviceCurrentNote.trim() && serviceCurrentNote.length > 0}
                              inputProps={{ maxLength: MAX_CHARACTERS, readOnly: tmInvoicingFieldDisabled }}
                              helperText={
                                !serviceCurrentNote.trim() && serviceCurrentNote.length > 0
                                  ? 'Note cannot be empty or contain only spaces'
                                  : `${serviceCurrentNote.length}/${MAX_CHARACTERS} characters`
                              }
                              InputProps={{
                                readOnly: tmInvoicingFieldDisabled,
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => handleSaveServiceNote(data.indexId || data.id || index)}
                              loading={serviceIsSavingNote}
                              disabled={!serviceCurrentNote.trim() || tmInvoicingFieldDisabled}>
                              Save
                            </LoadingButton>
                            <LoadingButton
                              variant="outlined"
                              color="error"
                              onClick={() => handleClearServiceNote(data.indexId || data.id || index)}
                              loading={serviceIsClearingNote}
                              disabled={!serviceCurrentNote.trim() || tmInvoicingFieldDisabled}>
                              Clear
                            </LoadingButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Modal>
                  ))}

                        </>
                        :""}
                        <Box data-tm-editable sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                          <LoadingButton
                            type="button"
                            variant="contained"
                            loading={isSubmitting}
                            onClick={() => {
                              setSettingsAnchorEl(null);
                              if (Number(details?.proj_status) === 2) {
                                setChangeOrderReason(values.change_order_reason || '');
                                setOpenChangeOrderReasonDialog(true);
                                return;
                              }
                              handleSubmit();
                            }}
                          >
                            Save Order
                          </LoadingButton>
                          <Button variant="outlined" onClick={() => {
                            setOpenPreview(!openPreview)
                            setValuesToPreview()
                            setSettingsAnchorEl(null)
                          }}>
                            Preview
                          </Button>
                          <Button variant="outlined" onClick={() => { openEdit ? handleCancel(true): handleCancel(); setSettingsAnchorEl(null); }}>
                            Cancel
                          </Button>
                        </Box>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>

                {/* Split-order: Delivery & Installation picker (facility + installs/pickup/shipping) */}
                {/* Normal sales order: Delivery type picker (installs/pickup/shipping only) */}
                <Dialog
                  open={deliveryInstallDialog.open}
                  onClose={closeDeliveryInstallDialog}
                  maxWidth="xs"
                  fullWidth
                >
                  <DialogTitle>
                    {isSplitOrder && Number(deliveryInstallDialog?.productFacilityId) !== Number(currentFacilityId) 
                      ? 'Delivery & Installation' 
                      : 'Installation'}
                  </DialogTitle>
                  <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                      {isSplitOrder && Number(deliveryInstallDialog?.productFacilityId) !== Number(currentFacilityId) ? (
                        <Autocomplete
                          options={deliveryInstallDialog.facilityOptions || []}
                          value={deliveryInstallDialog.installerFacility}
                          onChange={(event, newValue) => {
                            setDeliveryInstallDialog((prev) => {
                              const nextInstallerId = Number(newValue?.id)
                              const isCurrentFacilityInstaller =
                                nextInstallerId === Number(currentFacilityId)

                              // If current facility is selected as installer, hide "Installs" and prevent selecting it
                              const nextCompleteStatus =
                                isCurrentFacilityInstaller && Number(prev.complete_status) === 1
                                  ? 2
                                  : prev.complete_status

                              return {
                                ...prev,
                                installerFacility: newValue,
                                complete_status: nextCompleteStatus,
                              }
                            })
                          }}
                          getOptionLabel={(option) => option?.name || option?.label || option?.value || ''}
                          isOptionEqualToValue={(option, value) => String(option?.id) === String(value?.id)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Who is installing?"
                              placeholder="Select facility"
                            />
                          )}
                        />
                      ) : null}

                      <RadioGroup
                        value={String(deliveryInstallDialog.complete_status)}
                        onChange={(e) => {
                          const val = Number(e.target.value)
                          setDeliveryInstallDialog((prev) => ({
                            ...prev,
                            complete_status: val,
                          }))
                        }}
                      >
                        {(isSplitOrder && Number(deliveryInstallDialog?.productFacilityId) !== Number(currentFacilityId)
                          ? Number(deliveryInstallDialog?.installerFacility?.id) !== Number(currentFacilityId)
                          : true) && (
                          <FormControlLabel value="1" control={<Radio />} label="Installs" />
                        )}
                        {
                          (Number(deliveryInstallDialog?.productFacilityId) == Number(currentFacilityId) && values?.project_category?.id == 11) ?
                          null :
                          <>
                        <FormControlLabel value="2" control={<Radio />} label="Pickup" />
                        <FormControlLabel value="3" control={<Radio />} label="Shipping" />
                          </>
                        }
                      </RadioGroup>
                    </Stack>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={closeDeliveryInstallDialog} color="inherit">
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      onClick={isSplitOrder && Number(deliveryInstallDialog?.productFacilityId) !== Number(currentFacilityId) 
                        ? saveDeliveryInstallSelection 
                        : saveDeliveryTypeSelection}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Dialog>
              </Form>
            </FormikProvider>
          ))}
          {!openEdit && (
            <>
            {/* {(details && (invoice?.id || (details?.status === 2 && details?.quotation_status === 2)) && !loadingEditInvoice) ? ( */}
            {/* Show loader in Invoice / status / email area until details + invoice finish refetch (e.g. after combined SO save) */}
            {/* Also keep spinner on Sales Order / Invoice btn until post-edit data is ready and preview popup opens */}
            {(details && (invoice?.id || (details?.status === 2 && details?.quotation_status === 2 && (details?.manager_approval_required === true || details?.manager_approval_required === 1))) && !loadingEditInvoice && !loadingEditData && !awaitingInvoicePopup && !isOpenPopup) ? (
            // {(details && invoice?.id &&!loadingEditInvoice) ? (
            // OLD: only waited on !loadingEditInvoice — after save, loadingEditData was true but stale Invoice/status still showed
              <Stack direction={'row'} display={'flex'} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                {/* <Typography  fontSize={'1.09rem'} variant="overline" sx={{ color: 'text.secondary', }}>RFQ</Typography> */}
                {/* {(details?.id && (invoice?.total !== 0 || details?.job_category_name == 'Time & Material') && !user.isVendor) ? ( */}
                {Number(details?.status) !== 10 && details?.id  && !user.isVendor && (
                  (empty(details?.installation_acceptance) && !empty(details?.allInstallationCompleted)) ?
                    <AnimatedButton title={ details?.isReview ==2 ? "Review" :'Sales Order'} onClick={() => {
                      let permission =!explodedPermissions?.some((permission) => ['View Billing /Download/ Invoices Sales Order'].includes(permission))
                      if(permission &&  user?.added_by_client ==1){
                        return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      }
                      setOpenInvoice(!openInvoice)}} />
                  :

                  details?.status === 2 ? (
                    <Badge badgeContent={'1'} color={'warning'}>
                      <AnimatedButton title={(details?.installation_acceptance == 1) ? 'Invoice' : 'Sales Order'} onClick={() => {
                        let permission =!explodedPermissions?.some((permission) => ['View Billing /Download/ Invoices Sales Order'].includes(permission));
                        
                        // const hasInvoicePermission = explodedPermissions?.some((permission) => ['View Sales Order Invoices'].includes(permission));
                        const hasInvoicePermission = hasPermission('View Sales Order Invoices')
                        console.log('hasInvoicePermission====',hasInvoicePermission)
                        let invoicePermission = details?.installation_acceptance == 1 ? hasInvoicePermission :true;                        
                        if(permission &&  user?.added_by_client ==1){
                          return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                        }
                        if(!invoicePermission){
                          return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                        }
                        setOpenInvoice(!openInvoice)}} />
                    </Badge>
                  ) : (
                    <AnimatedButton title={(details?.installation_acceptance == 1) ? 'Invoice' : 'Sales Order'} onClick={() => {
                      let permission =!explodedPermissions?.some((permission) => ['View Billing /Download/ Invoices Sales Order'].includes(permission))
                      // const hasInvoicePermission = explodedPermissions?.some((permission) => ['View Sales Order Invoices'].includes(permission));
                      const hasInvoicePermission = hasPermission('View Sales Order Invoices')
                        console.log('hasInvoicePermission====',hasInvoicePermission)
                        let invoicePermission = details?.installation_acceptance == 1 ? hasInvoicePermission :true;
                        console.log('hasInvoicePermission====',details?.installation_acceptance)
                        console.log('hasInvoicePermission====',invoicePermission)
                      if(permission &&  user?.added_by_client ==1){
                        return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      }
                      if(!invoicePermission ){
                        return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      }
                      setOpenInvoice(!openInvoice)}} />
                  )
                )}
                {/* {details?.status === 2 ? (
                  <Badge badgeContent={'1'} color={'warning'}>
                    <Typography fontSize={'1.09rem'} variant="overline">
                      <span style={{ textDecoration: 'underline' }}>{(details?.installation_acceptance == 1) ? 'Invoice' : 'Sales Order'}</span>
                    </Typography>
                  </Badge>) : (
                  <Typography fontSize={'1.09rem'} variant="overline">{(details?.installation_acceptance == 1) ? 'Invoice' : 'Sales Order'}</Typography>
                )} */}
                <Typography fontWeight={'0.09rem'} variant="overline" >
                  <Label
                    sx={{ p: '12px' }}
                    variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
                    color={getEffectiveSalesOrderStatusInfo().color} >
                    {getEffectiveSalesOrderStatusInfo().label}
                  </Label>
                  {/* BACKUP: detail page header status (first item status for grouped)
                  <Label
                    sx={{ p: '12px' }}
                    variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
                    color={getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install, details?.received_status, details?.manager_approval_required, details?.send_to_client, details?.quotation_status, details?.is_scheduled ).color} >
                    {getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install, details?.received_status, details?.manager_approval_required, details?.send_to_client, details?.quotation_status, details?.is_scheduled ).label}
                  </Label>
                  */}
                </Typography>
                {Number(details?.status) === 10 && explodedPermissions?.some(permission => ['Delete request'].includes(permission)) && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleReopenVoidMenu}
                    disabled={loadingReopenVoid}
                  >
                    Reopen
                  </Button>
                )}
                {Number(details?.status) !== 10 && (
                <>
                {details.is_split_order !== 1 && availableRevertOptions.length > 0 && details.installation_acceptance !== 1 && details?.allInstallationCompleted && !isGroupedSalesOrderView ?(
                  <>
                    <Button
                      variant="outlined"
                      color="warning"
                      onClick={handleOpenRevertStatusDialog}
                      disabled={isSubmittingStatusRevert}
                      size="small"
                    >
                      {isSubmittingStatusRevert ? '...' : 'Revert Status'}
                    </Button>
                    <RevertStatusDialog
                      open={openRevertStatusDialog}
                      onClose={handleCloseRevertStatusDialog}
                      options={availableRevertOptions}
                      selectedKey={selectedRevertOptionKey}
                      onSelect={setSelectedRevertOptionKey}
                      onConfirm={handleConfirmRevertStatus}
                      isSubmitting={isSubmittingStatusRevert}
                    />
                  </>
                ) : null }
                
                {/* Sales orders no longer use Manager Approve/Reject
                {(details?.status === 2 && details?.quotation_status === 2 && (details?.manager_approval_required === true || details?.manager_approval_required === 1) && userType != 3 && details?.project_type != null && Number(details?.hold) !== 1) ? (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Button
                      type="button"
                      size="small"
                      variant="contained"
                      onClick={() => {
                        if (!canSalesOrderManagerApprove) {
                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                          return;
                        }
                        setConfirmManagerAccept(true);
                      }}
                    >
                      Manager Approve
                    </Button>
                    <Button
                      type="button"
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        if (!canSalesOrderManagerReject) {
                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                          return;
                        }
                        setRejectInvoice(true);
                      }}
                      sx={{ color: theme.palette.error.main }}
                    >
                      Manager Reject
                    </Button>
                  </Box>
                ) : null} */}

                {(userType == 3 || isClient || details?.installation_acceptance !== 1) ? '' :
                  <Tooltip title="Send Invoice PDF via Email">
                    <IconButton
                      onClick={handleSendInvoiceEmail}
                      color="primary"
                      sx={{
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        '&:hover': {
                          backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                      }}
                    >
                      <Icon icon={emailFillIcon} width={24} height={24} />
                    </IconButton>
                  </Tooltip>
                }

                {(() => {
                  const isAwaitingManagerApproval = false;

                  // Mirror the Estimate (ViewQuotation) behaviour:
                  // 1) While awaiting manager approval → only show Manager Approve/Reject (handled above).
                  // 2) After manager approval, when sent to client (quotation_status 2 or 9, send_to_client != 0) → show client Approve/Reject.
                  // 3) Internal users can still see their normal Approve/Reject when applicable.
                  const canClientApproveOrReject =
                    (userType == 3 || isClient) &&
                    details?.client_approve == 1 &&
                    details?.send_to_client != 0 &&
                    (details?.quotation_status === 2 || details?.quotation_status === 9) &&
                    details?.project_type != null;

                  const canInternalApproveOrReject =
                    (isAdminUser (userType) &&
                      (details?.for_parent_facility != 1 && !isMirrored && details?.is_split_order != 1)) ||
                    (details?.for_parent_facility == 1 && details?.status == 2 && !isMirrored) ||
                    (isAdminUser (userType) && details?.status !== 2) || (hasInvoicePermissions && details?.is_split_order != 1 ) ||
                    userType == 3;

                  const hasInternalApprovalWindow =
                    (((details?.allInstallationCompleted == 1) &&
                      empty(details?.installation_acceptance) &&
                      !isMirrored &&
                      details?.received_status !== 1) ||
                      !(details?.status == 4 || details?.status == 3) ||
                      (details?.status == 4 && details?.proj_status == 1)) &&
                    details?.project_type &&
                    details?.status !== 6 &&
                    ((isClient || userType == 3)
                      ? (details?.client_approve == 1 || (details?.status == 4 && details?.proj_status == 1))
                      : true);

                  const showNormalApproveReject =
                    !isAwaitingManagerApproval && details?.project_type && details?.status !== 6 && details?.installation_pending_review != 1 && details?.installation_pending_review != 2 && Number(details?.hold) !== 1 &&
                    ((canInternalApproveOrReject && hasInternalApprovalWindow) || canClientApproveOrReject);

                  return showNormalApproveReject ? (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {(requestAccept || checkingGroupedQbSync) ? 
                      <Stack alignItems='center' justifyContent='center'>
                        <CircularProgress color="primary" variant="indeterminate" />
                      </Stack> 
                      : 
                      <>
                      {(details?.status == 4 && details?.proj_status == 1) || details?.isReview == 2 ? '' :
                        <>
                       {hasInvoicePermissions ? 
                       <>
                        {confirmInvoice ? 
                          <Stack alignItems='center' justifyContent='center'>
                            <CircularProgress color="primary" variant="indeterminate" />
                          </Stack>
                        :
                          <Button type="submit" variant="contained"
                          // onClick={() =>{
                          //   let permission =!explodedPermissions?.some((permission) => ['Approve Proofs(Final Client invoice approval)'].includes(permission))
                         
                          // if(details?.status==4 && user.added_by_client ==1 && permission ){
                          //  return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                           
                          // }else if (!checkJobTypeBeforeApprovalAction()) {
                          //   return;
                          // }else{
                          //   setConfirmInvoice(true)}
                          // }
                          // }
                        // onClick={()=>handleAcceptorRejectInvoice(1)}  
                          onClick={handleApproveInvoiceClick}
                          >
                            Approve
                          </Button>
                          }
                        </>:''}
                        </>
                        }
                          {invoiceReject ? 
                          <Stack alignItems='center' justifyContent='center'>
                            <CircularProgress color="primary" variant="indeterminate" />
                          </Stack>
                        :
                          <>
                            {(!empty(details?.installationStatus) || details?.isReview ==2 || details?.installation_pending_review == 1 || details?.installation_pending_review == 2 ) ? null  :
                            <Button size="small" variant="outlined"
                              onClick={() => {
                                if (!checkJobTypeBeforeApprovalAction()) return;
                                setRejectInvoice(true);
                              }}
                              //  onClick={()=>handleAcceptorRejectInvoice(2)}
                              sx={{ color: theme.palette.error.main }} >
                              Reject
                            </Button>}
                          </>
                        }
                      </>
                    }
                  </Box>
                  ) : null;
                })()}

                  {/* Additional approve button for split orders from other facilities */}
                  {details?.status == 4 && details?.for_parent_facility == 1 && details?.min_payment_status == 0 && details?.project_category == 15 && details?.origin_facility_id == currentFacilityId && Number(details?.hold) !== 1 && (
                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={() => setConfirmInvoice(true)}
                      >
                        Approve
                      </Button>
                    </Box>
                  )}
                  {details?.status == 4 && details?.for_parent_facility == 1  && details?.project_category == 15 && details?.origin_facility_id == currentFacilityId && details?.received_status == 1 && (
                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setOrderTypeSelection(true)}
                      >
                        Receive Order
                      </Button>
                    </Box>
                  )}
                  {
                    details?.mirror_approve_status ?
                      <Stack>
                        <Typography variant="body2" color="primary.main">Split Status: {details?.mirror_approve_status}</Typography>
                      </Stack>
                      : ''}
                </>
                )}
              </Stack>
            ) : <Stack direction={'row'} display={'flex'} alignItems={'flex-start'} spacing={{ xs: 3, sm: 2 }}>
                          <Tooltip title="Loading...">  
                            <CircularProgress color="primary" variant="indeterminate" size={22} style={{ paddingLeft: 3 }} />
                          </Tooltip>
                          </Stack> }

              <Grid container spacing={3}>

                <Grid sx={{ mt: 3 }} item xs={12} md={12}>
                  <Stack spacing={3}>
                    <Stack spacing={5}>
                      <Tabs
                        value={currentTab}
                        scrollButtons="auto"
                        variant="scrollable"
                        allowScrollButtonsMobile
                        onChange={handleChangeTab}
                      >
                        {ACCOUNT_TABS.map((tab) => (
                          <Tab
                            disableRipple
                            key={tab.value}
                            label={
                              <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                                {capitalCase(tab.value)}
                                {tab.value === 'Design Notes' && designNotesHasNew && (
                                  <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                                )}
                                {tab.value === 'Job Notes' && jobNotesHasNew && (
                                  <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                                )}
                              </Box>
                            }
                            value={tab.value}
                            sx={{
                              fontWeight:500
                            }}
                          />
                        ))}
                      </Tabs>

                      {ACCOUNT_TABS.map((tab) => {
                        const isMatched = tab.value === currentTab
                        return isMatched && <Box key={tab.value}>{tab.component}</Box>
                      })}
                    </Stack>
                  </Stack>
                </Grid>

              </Grid>
            </>)}

          {/* adding client modal  */}
          <AddClients
            request_id={id}
            setIsOpen={setIsOpen}
            setAllClients={setAllClients}
            allClients={allClients?.filter(a => !a.isVendor)}
            addClient={addClient}
            setAddClient={setAddClient} />
          <AddClients
            isVendor
            request_id={id}
            setIsOpen={setIsOpen}
            setAllClients={setAllClients}
            allClients={allClients?.filter(a => a.isVendor)}
            addClient={addVendor}
            setAddClient={setAddVendor} />
          <AddProposal
            request_id={id}
            setIsOpen={setIsOpen}
            setReloadData={() => setRefresh(!refresh)}
            addProposal={addProposal}
            setAddProposal={setAddProposal} />
          <SendDesignsEmailModal
            open={openInvoiceEmailModal}
            onClose={() => setOpenInvoiceEmailModal(false)}
            selectedDesigns={invoicePdfData || []}
            designOrderId={details?.id}
            requestId={id}
            userId={user?.user_id}
            userType={user?.user_type}
            onSuccess={handleInvoiceEmailSent}
            pageType="request"
            canChangeSender={details?.installation_acceptance === 1 ? true : false}
            clientEmail={invoice?.clientEmail || ''}
            clientProfilePic={invoice?.userProfilePic || customerData?.userProfilePic || customerData?.profile_pic || ''}
            hasViewCostPermission={hasViewCostPermission}

          />
          {/* invoice modal */}
          <Modal modalTitle={(details?.installation_acceptance == 1) ? 'Invoice Details' : 'Sales Order Details'} open={openInvoice === true} handleClose={() => {setOpenInvoice(false); setOpenEmailModal && setOpenEmailModal(false)}}>
            <Stack direction={{ xs: 'column', sm: 'row', md: 'column' }}
              spacing={{ xs: 3, sm: 2 }}>
              <Stack direction="row" justifyContent={'flex-end'} alignItems="center" spacing={1} sx={{ position: 'relative', zIndex: 10 }}>
                {(userType == 3 || isClient) ? '' :
                  <Tooltip title={isFromCompletedTab ? "Send Invoice PDF via Email" : "Send Sales Order PDF via Email"}>
                    <IconButton
                      onClick={handleSendInvoiceEmail}
                      color="primary"
                      sx={{
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        '&:hover': {
                          backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                      }}
                    >
                      <Icon icon={emailFillIcon} width={24} height={24} />
                    </IconButton>
                  </Tooltip>
                }
                <Box sx={{ ml: 4, position: 'relative', zIndex: 10 }}>
                <AnimatedButton
                  title={invoicePreviewReady ? 'Print A3' : 'Loading...'}
                  startIcon={invoicePreviewReady ? <Print /> : <CircularProgress size={14} color="inherit" />}
                  size="small"
                  onClick={() => {
                    if (!invoicePreviewReady) return;
                    handlePrintA3();
                  }}
                />
                </Box>
  {/* trigger={() => (<Button> <Print />Print A3</Button>)}
                    content={() => componentRef.current}
                    copyStyles={false}
                    pageStyle={`
                      @media print {
                        body {
                          font-size: 12pt;
                        }
                        table {
                          width: 100%;
                          border-collapse: collapse;
                          margin-bottom: 10px;
                        }

                        th, td {
                          border: 1px solid #ddd;
                          padding: 4px;
                          text-align: left;
                        }
                        #right {
                          text-align: right;
                          margin-top: -200px; 
                        }
                        #total {
                          text-align: right;
                          display:flex;
                          justify-content: flex-end;
                        }
                        #subtotal {
                          text-align: left;
                          
                        }
                        #discount {
                          text-align: left;
                          word-wrap: break-word;
                          margin-right: 100px;
                      }
                      
                        #totalmain {
                          text-align: left;
                          
                        }
                        #subtotal1 {
                          text-align: left;
                          
                        }
                        #discount1 {
                          text-align: left;
                          word-wrap: break-word;
                          margin-right: 30px;
                      }
                      
                        #totalmain1 {
                          text-align: left;
                          
                        }
                        .sales-order-heading-print {
                          text-align: center;
                          width: 100%;
                          position: absolute;
                          left: -60px;
                          top: -20px;
                        }
                        #total1 {
                          text-align: right;
                          display:flex;
                          justify-content: flex-end;
                          margin-top: -320px; 
                          
                        }
                        #logoImage {
                          height: 100px;
                          width:100px;
                        }
                        #order{
                          margin-bottom:-20px
                        }
                        #title{
                          margin-bottom:-20px
                        }
                        #orderID {
                          margin-bottom:-20px
                        }
                        #to {
                          margin-bottom:-20px
                        }
                        
                      }
                    `}
                  /> */}
                {(details?.status === 4 || details?.status === 3) && SEND_EMAIL && <Button onClick={handleSendEmail}>Send Email</Button>}
                <div style={{ display: "none" }}>
                  <SalesOrderInvoicePage
                    invoiceDate={invoiceDate}
                    openInvoice={openInvoice}
                    details={{
                      ...details,
                      rush_fee: isInvoiceRushFeeOn ? 1 : (details?.rush_fee || 0),
                      rush_fee_amount: invoiceModalRushFee,
                    }}
                    invoice={invoice}
                    subTotal={subTotal}
                    ref={componentRef}
                    cartService={cartService}
                    additionalSelectedServices={additionalSelectedServices}
                    invoiceSelectedServices={invoiceSelectedServices}
                    data={data}
                    userType={userType}
                    labourInstallService={labourInstallService}
                    isFromCompletedTab={location.state?.isFromCompletedTab ?? isFromCompletedTab ?? false}
                    hasViewCostPermission={hasViewCostPermission}
                    customerOrderProductGroups={customerOrderProductGroups}
                    markupType={markupType}
                    groupProductMarketingValues={groupProductMarketingValues}
                    groupInstallMarketingValues={groupInstallMarketingValues}
                    taxRateData={taxRateData}
                    taxAmount={taxAmount}
                    rushFeeEnabled={isInvoiceRushFeeOn}
                    rushFeeAmount={invoiceModalRushFee}
                    rushFeePercentage={invoiceModalRushFeePct}
                  />
                  
                </div>

              </Stack>
            </Stack>
            {!invoicePreviewReady ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 240, width: '100%' }}>
                <CircularProgress />
              </Box>
            ) : (
            <>
            <Grid container spacing={3} >

              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                  <Box component="img" alt="logo" src={COMPANY_LOGO} sx={{ height: 98 }} />
                </Grid>
                <Typography variant="body2">{COMPANY_NAME}</Typography>
                <Typography variant="body2">{data?.company_website ? data?.company_website : ''}</Typography>
                <Typography variant="body2">
                  {data?.address}
                </Typography>
                <Typography variant="body2">
                 {data?.city}, {data?.state}, {data?.zipcode}
                </Typography>
                {/* <Typography variant="body2">Telephone: +15208362947</Typography> */}
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                <Typography variant="body2" sx={{ textTransform: 'uppercase', }}>Telephone: {(data?.phone_country_code || data?.phone) ? `+${data?.phone_country_code}${data?.phone}` : '951-682-9660'}</Typography>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>|</Typography>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_fax_number ? `Fax: ${data?.company_fax_number}` : ''}</Typography>
              </Box>
              <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_mail}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>

                <Typography variant="body2">
                  Order date: {invoiceDate}
                </Typography>
                {/* <Stack sx={{display:'flex',flexDirection:'row'}}> */}
                {/* <Typography variant="body2">Order status:</Typography> */}
                <Label
                  variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
                  color={getEffectiveSalesOrderStatusInfo().color} >
                  {getEffectiveSalesOrderStatusInfo().label}
                </Label>
                {/* BACKUP: invoice modal status (first item status for grouped)
                <Label
                  variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
                  color={getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install, details?.received_status, details?.manager_approval_required, details?.send_to_client, details?.quotation_status, details?.is_scheduled ).color} >
                  {getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install, details?.received_status, details?.manager_approval_required, details?.send_to_client, details?.quotation_status, details?.is_scheduled ).label}
                </Label>
                */}
                {/* </Stack> */}
                <Typography variant="body2" sx={PRESERVE_WHITESPACE_SX}>Job Name: {details?.name}</Typography>
                <Typography variant="body2">Project Name: {details?.community_name || ''}</Typography>
                {/* BACKUP: invoice modal job/invoice numbers (single order only)
                {
                 (depositAndProgressBilling ||  (details?.installation_acceptance && details?.est_doc_number)) && (details?.doc_number !== details?.est_doc_number)?
                 <>
                   <Typography variant="body2">
                 Job Number : {details?.est_doc_number ? `#${details?.est_doc_number}` : ''}
               </Typography>
                    <Typography variant="body2">
                  Invoice Number : {details?.doc_number ? `#${details?.doc_number}` : ''}
               </Typography>
               </>
                 :
                <Typography variant="body2">
                Order ID: #{details?.doc_number}
               </Typography>
               }
                */}
                {renderSalesOrderJobInvoiceNumbers('body2')}
                <Box sx={{ gap : 0.5, mt:2, alignItems:'flex-start'}}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>To,</Typography>
                  {/* <Box sx={{ ml: 2 }}> */}
                    <Typography variant="body2">Customer: {
                      details?.is_split_order && details?.for_parent_facility == 1 
                        ? FacilityTypes?.find(facility => facility.id === details?.origin_facility_id)?.label || invoice?.customer_name || ''
                        : invoice?.customer_name || ''
                    }</Typography>
                    {details?.is_split_order && details?.for_parent_facility == 1 ? '' :
                    <>
                    {/* <Typography variant="body2">Project Name: {details?.community_name || ''}</Typography> */}
                    <Typography variant="body2">Address: {invoice?.customer_address || ''}</Typography>
                    <Typography variant="body2">Phone: {invoice?.customer_phone || ''}</Typography>
                    </>}
                  {/* </Box> */}
                </Box>
                {(details?.job_category_name == 'Time & Material') ? 
                  <Label variant='filled' color="info">Time & Material</Label>
                : ''}
              </Grid>
            </Grid>
            <Grid container spacing={2}>

              <Scrollbar>
                {/* {((details?.job_category_name == 'Time & Material') && (details?.allInstallationCompleted == 1)) ?  */}
                {useTmProductLayout ? 
                  <>
                  {(invoice?.cust_product?.filter(item=>item.material != 1)?.length > 0) ? <>
                  <Typography variant='h6'>{'Products'}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>1</TableCell>
                          {invoice?.cust_product?.filter(item=>item.material != 1)?.some(item => item.product_notes) && <TableCell>SKU</TableCell>}
                          <TableCell align="center">UNIT</TableCell>
                          {canViewCosts && <TableCell>UNIT PRICE</TableCell>}
                          <TableCell>QTY</TableCell>
                          {canViewCosts && <TableCell>TOTAL</TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {groupedTandMDisplayRows?.map((row, i) => {
                          if (row?.__type === 'group') {
                            const representative = row?.representative || {}
                            const facility = FacilityTypes?.find((f) => f.id == representative?.facility_id)
                            const facilityColor = theme.palette[facility?.color]?.main || 'inherit'
                            const members = row?.members || []
                            const groupName = getCustomerOrderProductGroupDisplayName({
                              groupMeta: row?.groupMeta,
                              representative,
                              members,
                              groupId: row?.groupId,
                            })
                            const groupProductDisplayQty = Number(row?.groupProductDisplayQty ?? 1) || 1
                            const displayGroupTotal = Number(row?.totalValue || 0)
                            const unitEach = Number(row?.adjustedGroupRetailEach ?? 0) || (groupProductDisplayQty > 0 ? displayGroupTotal / groupProductDisplayQty : 0)

                            return (
                              <React.Fragment key={`group-tm-${row?.groupId}`}>
                                <TableRow>
                                  <TableCell sx={{ color: facilityColor }}>{i + 1}</TableCell>
                                  <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: facilityColor }}>
                                      {groupName}
                                    </Typography>
                                  </TableCell>
                                  {invoice?.cust_product?.filter(item => item.material != 1)?.some(item => item.product_notes) && (
                                    <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                  )}
                                  <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                  {canViewCosts && (
                                    <TableCell align="center" sx={{ color: facilityColor }}>
                                      ${unitEach.toFixed(2)}
                                    </TableCell>
                                  )}
                                  <TableCell align="center" sx={{ color: facilityColor }}>
                                    {groupProductDisplayQty}
                                  </TableCell>
                                  {canViewCosts && (
                                    <TableCell sx={{ color: facilityColor }}>
                                      ${displayGroupTotal.toFixed(2)}
                                    </TableCell>
                                  )}
                                </TableRow>
                                <TableRow>
                                  <TableCell colSpan={6}>
                                    <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            )
                          }

                          const val = row;
                          const { vid, product_name, product_notes,vpt_number, product_price, product_retail_price, adjustment, 
                            quantity, locationQuantity,actual_retail_price,install_cost,install_qty, product_total, discount, unit, unit_qty, material,rfp,markAdjType,install_notes,
                            services = [],
                          } = val
                          console.log('product_total', product_total)
                          
                          // Get labor install
                          const labourService = services?.find(service => service.labour_cost_service_id === 10);
                          const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                          const labourQty = (labourService?.prQty || 0) * locationQuantity;
                          const labourRate = labourService?.service_original_cost || 0;
                          const labourTotal = labourQty * labourRate;
                          const labourInitial = (labourService?.prQty || 0) * labourRate;
                          
                          // Unit name logic
                          let unitData = UNITS?.filter((item) => item?.id == unit)
                          let shortUnitName = unitData[0]?.short_name || 'Unit'
                          let unitName = unitData[0]?.name

                          //  subTotal += product_total    
                          let basePriceForUnit = Number(actual_retail_price) || Number(product_retail_price) || 0;
                          let SPMA = basePriceForUnit;
                          // material != 1
                          SPMA = parseFloat(SPMA)?.toFixed(2);           

                          let rowTotal = install_cost
                            ? ((Number(actual_retail_price) * (locationQuantity || 1) * (quantity || 1)) || 0)
                            : ((Number(SPMA) * (locationQuantity || 1) * (quantity || 1)) || 0);

                          // Ensure rowTotal is a number before calling toFixed
                          let customerProductTotal = "0.00";
                          if (typeof rowTotal === 'number') {
                              customerProductTotal = rowTotal.toFixed(2);
                          }
                          console.log('customerProductTotal', customerProductTotal , invoice?.jobcostTotal)
                          return (
                          <React.Fragment key={vid}>
                            {/* Product Row */}
                            <TableRow
                            //  sx={{
                            //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            // }}
                            >
                              <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                {product_notes ? 
                                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold',wordBreak: 'break-word', overflowWrap: 'break-word',color: 'error.main'}}>{product_notes}</Typography> 
                                  
                                  : 
                                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                                  }
                                {(material === 1 && rfp==0 && details?.job_category_name != 'Time & Material') && (
                                  // <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                  //   (Addl. Material{val?.stock_type === 1 
                                  //     ? ' - Finished' 
                                  //     : val?.stock_type === 2 
                                  //       ? ` - Partial (${UNITS?.find(u => u.id === val?.convertion_unit)?.short_name || 'Unit'})` 
                                  //       : ''})
                                  // </Typography>
                                  <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Addl. Material)</Typography> 
                                )}
                                {(material === 1 && rfp==1 && details?.job_category_name != 'Time & Material') ? 
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Material)</Typography> 
                              : null}
                              </TableCell>
                              <TableCell align="center">{material === 1 ? '1' : quantity}({shortUnitName})</TableCell>
                              {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                              {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                              {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''}
                              {canViewCosts && <TableCell>${install_cost ? (Number(actual_retail_price) || 0).toFixed(2) : (Number(SPMA) || 0).toFixed(2)}</TableCell>}
                              <TableCell>{locationQuantity}</TableCell>
                              {canViewCosts && (
                                <TableCell>${
                                  install_cost ?
                                  ((Number(actual_retail_price) * (locationQuantity || 1) * (quantity || 1)) || 0).toFixed(2) :
                                  ((Number(SPMA) * (locationQuantity || 1) * (quantity || 1)) || 0).toFixed(2)
                                }</TableCell>
                              )}
                            </TableRow>
                            {/* Labor Install Row (if exists) */}
                            {/* {labourService && (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                                <TableCell align="center">N/A</TableCell>
                                <TableCell>${labourRate?.toFixed(2)}</TableCell>
                                <TableCell>{labourQty?.toFixed(2)}</TableCell>
                                <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                              </TableRow>
                            )} */}
                            {install_cost && showInstallPriceInView ? (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>
                                  <Typography sx={{color: install_notes ? 'red' : 'inherit' ,whiteSpace: 'pre-wrap'}}>{install_notes ? install_notes : (canViewCosts ? `Install Price` : 'Installation')}</Typography>
                                  </TableCell>
                                {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>-</TableCell> : ''}
                                <TableCell align="center">-</TableCell>
                                <TableCell align="center">-</TableCell>
                                {canViewCosts && (
                                <>
                                <TableCell>${install_cost || 0}</TableCell>
                                <TableCell>
                                  ${((install_cost || 0) * (val?.install_qty ?? 1)).toFixed(2)}
                                </TableCell>
                                </>
                                )}

                              </TableRow>
                            ):''}
                            <TableRow>
                              <TableCell colSpan={(invoice?.cust_product?.filter(item=>item.material != 1)?.some(item => item.product_notes) ? 6 : 5) - (canViewCosts ? 0 : 2)}>
                                <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                          )
                        }
                        )}

                      </TableBody>
                    </Table>
                  </TableContainer>
                </> : null}
                {/* <Typography variant='h6' sx={{ mt: 2 }}>{(labourInstallService?.length > 0 ) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Services(Labor Install)" : 'Services(Labor Install)') : ""}</Typography>
                    <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                      <Table>
                        {(labourInstallService?.length > 0 ) &&
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan={2}>NAME</TableCell>
                              <TableCell>COST (HOURLY)</TableCell>
                              <TableCell>HOURS</TableCell>
                              <TableCell>TOTAL COST</TableCell>
                            </TableRow>
                          </TableHead>}
                        <TableBody>
                        {labourInstallService?.map((ser) => {
                            console.log('invoiceSelectedServices--@@ 1', ser);
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                    {ser?.name}-({ser.productName})
                                  </Typography>
                                  {ser?.service_notes ? 
                                    <Stack direction={'column'}>
                                      <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                      <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{ser.service_notes}</Typography> 
                                    </Stack>
                                    : ''}
                                </TableCell>
                                <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                                <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                                <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                              </TableRow>
                            )
                          })}
                          </TableBody>
                          </Table>
                      </TableContainer> */}
                    {(!empty(invoice?.jobcost_product)) ? 
                    <>
                    <Typography variant='h6' sx={{ mt: 2 }}>Materials</Typography> 
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>NAME</TableCell>
                            {canViewCosts && <TableCell>UNIT COST</TableCell>}
                            <TableCell>QUANTITY</TableCell>
                            {canViewCosts && <TableCell>TOTAL COST</TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {invoice?.jobcost_product?.map((val,index) => {
                            const { id, product_name, unit_price, quantity, total, unit,partial_unit, unit_qty, material_notes } = val
                            let unitToUse = partial_unit ? partial_unit : unit
                            let unitName = UNITS?.filter((item) => item?.id == unitToUse)
                            let shortUnitName = unitName[0]?.short_name || 'Unit'
                            unitName = unitName[0]?.name
                            // let shortUnitName = ''
                            // if (unitName == 'Square feet') {
                            //   shortUnitName = 'Sq ft'
                            // } else if (unitName == 'Lineal feet') {
                            //   shortUnitName = 'Lin ft'
                            // } else if (unitName == 'Square Inches') {
                            //   shortUnitName = 'Sq Inches'
                            // } else if (unitName == 'Unit') {
                            //   shortUnitName = 'Unit'
                            // }
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                    {product_name}
                                  </Typography>
                                  {material_notes ? 
                                    <Stack direction={'column'}>
                                      <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Note : </Typography> 
                                      <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main', whiteSpace: 'pre-line'}}>{material_notes}</Typography> 
                                    </Stack>
                                    : ''}
                                </TableCell>
                                {canViewCosts && <TableCell> ${unit_price}</TableCell>}
                                <TableCell>{quantity}({shortUnitName})</TableCell>
                                {canViewCosts && <TableCell> ${total}</TableCell>}
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </>
                    : ''}
                    {/* {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? <Typography variant='h6' sx={{ mt: 2 }}>Additional Services</Typography> : ''} */}
                    <TableContainer>
                        <Table>
                        {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? 
                        <>
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan={2}>ADDITIONAL SERVICES</TableCell>
                              {canViewCosts && <TableCell>HOURLY COST</TableCell>}
                              <TableCell>HOURS</TableCell>
                              {canViewCosts && <TableCell>TOTAL COST</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.map((ser,index) => {
                              return (
                                <TableRow sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  <TableCell colSpan={2}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      {ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : (ser?.service_name || ser?.name )}
                                    </Typography>
                                  </TableCell>
                                  {canViewCosts && <TableCell>${ser ? parseFloat(ser?.service_original_cost)?.toFixed(2) : 0}</TableCell>}
                                  {/* <TableCell>{ser ? parseFloat(ser?.jobcost_quantity)?.toFixed(2) : 0}</TableCell> */}
                                  <TableCell>{ser ? parseFloat(ser?.quantity)?.toFixed(2) : 0}</TableCell>
                                  {canViewCosts && <TableCell>${ser ? ser?.total_service_cost : 0}</TableCell>}
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </> : ''}
                    {canViewCosts && (invoice?.jobcostTotal && invoice?.jobcostTotal > 0) ? (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Material Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">${invoice ? invoice?.jobcostTotal?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>
                    ) : ''}
                    {/* {(invoice?.project_category == 12 && details?.allInstallationCompleted == 1) ? '' : */}
                    {(treatInvoiceAsTimeMaterial || !canViewCosts) ? '' :
                    <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Product Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">
                          {/* ${invoice?.cust_product?.reduce((sum, val) => {
                              const {
                                product_retail_price = 0, adjustment = 0, markAdjType,
                                product_total = 0, locationQuantity = 1, quantity = 1,
                                services = []
                              } = val;

                              const labourService = services?.find(s => s.labour_cost_service_id === 10);
                              const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;

                              let SPMA = (markAdjType === 2 || markAdjType === 3)
                                ? product_retail_price + Number(adjustment)
                                : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                              const effectiveTotal = markAdjType === 1
                                // ? product_total - labourTotal
                                // : (SPMA * (locationQuantity * quantity)) - labourTotal;
                                ? product_total
                                  : (SPMA * (locationQuantity * quantity));

                              return sum + effectiveTotal;
                            }, 0)?.toFixed(2)} */}
                            ${invoiceModalProductTotalFromRows.toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                    }

                    {canViewCosts && (labourInstallService?.length > 0 || 
                      additionalSelectedServices?.some(
                        x => x.labour_cost_service_id === 10 && (x.total_cost || 0) > 0
                      ) ||
                        invoice?.cust_product?.some(
                          val => parseFloat(val.install_cost || 0) > 0
                        )
                    ) && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Install Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          {/* <Typography variant="overline">
                              ${invoice?.cust_product?.reduce((sum, val) => {
                                const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                                return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                              }, 0)?.toFixed(2)}
                          </Typography> */}
                          <Typography variant="overline">
                            ${(
                              // (invoice?.cust_product?.reduce((sum, val) => {
                              //     const labourService = val?.services?.find(
                              //       s => s.labour_cost_service_id === 10
                              //     );
                              //     return (
                              //       sum +
                              //       (labourService?.service_original_cost || 0) *
                              //         (labourService?.prQty || 0) *
                              //         (val?.locationQuantity || 1)
                              //     );
                              //   }, 0) || 0) +
                                (invoiceModalInstallTotalFromRows || 0) +
                                (additionalSelectedServices?.reduce(
                                  (s, x) =>
                                    x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                  0
                                ) || 0)
                              ).toFixed(2)}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                    )}

                    {canViewCosts && (
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                        {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                        <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                        <Typography variant="overline">
                          ${(
                            (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10  
                                        ? s
                                        : s + (x.total_cost || 0),
                                    0
                                ) || 0) +
                            (cartService?.reduce((s, x) => {
                              const sp = x.sellingPrice || x.unit_cost || 0;
                              const markup = x.originalMarkup || x.product_markup || 0;
                              const final = sp + (sp * markup / 100);
                              return s + ((x.qty || 0) * final);
                            }, 0) || 0)
                          )?.toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}

                    {canViewCosts && (details?.job_category_name != 'Service only' || subTotal > 0 || (!treatInvoiceAsTimeMaterial && (invoiceModalCustProductSubtotalForServices || 0) > 0)) && (
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="overline">Subtotal</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">
                          ${fUSPrice(
                            (treatInvoiceAsTimeMaterial ? (subTotal || 0) : (invoiceModalCustProductSubtotalForServices || 0)) +
                            (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            (cartService?.reduce((s, x) => {
                              const sp = x.sellingPrice || x.unit_cost || 0;
                              const markup = x.originalMarkup || x.product_markup || 0;
                              const final = sp + (sp * markup / 100);
                              return s + ((x.qty || 0) * final);
                            //    }, 0) || 0)+
                            // (invoice?.cust_product?.reduce((sum, val) => {
                            //   const labourService = val?.services?.find(
                            //     s => s.labour_cost_service_id === 10
                            //   );
                            //   return (
                            //     sum +
                            //     (labourService?.service_original_cost || 0) *
                            //       (labourService?.prQty || 0) *
                            //       (val?.locationQuantity || 1)
                            //   )
                            }, 0) || 0)
                          )}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}

                    {/* Discount hidden — restore when needed
                    {canViewCosts && invoice?.extra_discount > 0 && (
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="overline">Discount</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}
                    */}
                    
                    {canViewCosts && invoice?.tax_amount > 0 && (
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="overline">Tax</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}

                    {canViewCosts && isInvoiceRushFeeOn && (
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="overline">Rush Fee</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">${Number(invoiceModalRushFee || 0).toFixed(2)}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}

                    {canViewCosts && (
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="subtitle1"  sx={{ color: invoiceModalDisplayTotal < 0 ? 'red' : 'inherit' }}>Total</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="subtitle1"  sx={{ color: invoiceModalDisplayTotal < 0 ? 'red' : 'inherit' }}>${fUSPrice(invoiceModalDisplayTotal)}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}

                          {canViewCosts && invoice?.project_category != 13 ? 
                            <>
                            {(userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
                            (details?.billing_type ? (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right" sx={{display:"flex"}}>
                              <Typography fontSize={"small"} variant="caption"  sx={{ color:  'inherit' }}> (only viewable for admin)</Typography>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>Billing Type</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            ) : '')
                            :""}
                         {
                         (invoice?.total && details?.billing_type)?

                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>Minimum Payable Amount</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>${(invoice?.total && details?.billing_type)? parseFloat((invoice?.total *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            :""
                            }
                            {details?.totalPaidAmount > 0 && (
                              <RowResultStyle>
                                <TableCell colSpan={3} />
                                <TableCell align="right">
                                  <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>Amount Paid</Typography>
                                </TableCell>
                                <TableCell align="left" width={10}>
                                  <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>${details?.totalPaidAmount ? parseFloat(details?.totalPaidAmount)?.toFixed(2) : 0.00}</Typography>
                                </TableCell>
                              </RowResultStyle>
                            )}
                            {details?.totalPaidAmount > 0 && (
                              <RowResultStyle>
                                <TableCell colSpan={3} />
                                <TableCell align="right">
                                  <Typography variant="subtitle1"  sx={{ color: invoice?.newBalanceDue <= 0 ? 'inherit' : 'red' }}>Balance Due</Typography>
                                </TableCell>
                                <TableCell align="left" width={10}>
                                  <Typography variant="subtitle1"  sx={{ color: invoice?.newBalanceDue <= 0 ? 'inherit' : 'red' }}>${invoice?.newBalanceDue ? parseFloat(invoice?.newBalanceDue <= 0 ? 0.00 : invoice?.newBalanceDue)?.toFixed(2) : 0.00}</Typography>
                                </TableCell>
                              </RowResultStyle>
                            )}
                            </>
                          : ''}
                      </Table>
                    </TableContainer>
                    {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
                      <>
                        <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                        <Stack spacing={2}>
                          {invoice?.note_data?.map((val, index) => {
                            const { id, authorized_by, note, timestamp } = val;
                            return (
                              <Paper
                                key={id}
                                elevation={3}
                                sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                              >
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={8}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                      {note}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                    {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                                    <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                      Added By: {authorized_by}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                      {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Paper>
                            );
                          })}
                        </Stack>
                      </>
                    ) : ''}
                  </> :
                  <>
                  {(invoice?.cust_product?.length > 0) ? <>
                  <Typography variant='h6'>{details?.job_category_name != 'Time & Material' ? 'Products' : 'Products'}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Sl No.</TableCell>
                          {/* <TableCell align="center"> </TableCell> */}
                          <TableCell>PRODUCT & NOTE</TableCell>
                          {/* {invoice?.cust_product?.some(item => item.product_notes) && <TableCell>SKU</TableCell>} */}
                          <TableCell align="center">SKU</TableCell>
                          <TableCell align="center">QTY</TableCell>
                          {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>WHOLESALE PRICE</TableCell> : ''}
                          {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>SPLIT MARKUP</TableCell> : ''} */}
                          {canViewCosts && <TableCell align="center">UNIT PRICE EACH</TableCell>}
                          {canViewCosts && <TableCell>TOTAL</TableCell>}
                        </TableRow>
                      </TableHead>
                      
                      <TableBody>
                        {groupedInvoiceDisplayRows?.map((row, i) => {
                          if (row?.__type === 'group') {
                            const representative = row?.representative || {}
                            const facility = FacilityTypes?.find((f) => f.id == representative?.facility_id)
                            const facilityColor = theme.palette[facility?.color]?.main || 'inherit'
                            const members = row?.members || []
                            const groupName = getCustomerOrderProductGroupDisplayName({
                              groupMeta: row?.groupMeta,
                              representative,
                              members,
                              groupId: row?.groupId,
                            })
                            const groupDescription = row?.groupMeta?.group_description || representative?.group_description || '-'
                            const groupProductDisplayQty = Number(row?.groupProductDisplayQty ?? 1) || 1
                            const groupInstallDisplayQty = Number(row?.groupInstallDisplayQty ?? 1) || 1
                            const groupInstallSubtotal = Number(row?.groupInstallSubtotal ?? 0)
                            const groupHasInstall = groupInstallSubtotal > 0
                            const displayGroupTotal = groupHasInstall ? Number(row?.groupProductOnlyTotal ?? 0) : Number(row?.totalValue || 0)
                            const unitEach = Number(row?.adjustedGroupRetailEach ?? 0) || (groupProductDisplayQty > 0 ? displayGroupTotal / groupProductDisplayQty : 0)
                            const groupInstallUnitEach = Number(row?.adjustedGroupInstallRetailEach ?? 0) || (groupInstallDisplayQty > 0 ? groupInstallSubtotal / groupInstallDisplayQty : 0)
                            const groupInstallNotes = getGroupInstallNotesDisplay(members)
                            const groupDisplayName = groupName
                            const groupDisplayNote =
                              members.find(
                                (m) =>
                                  m?.product_notes != null &&
                                  String(m.product_notes).trim() !== '',
                              )?.product_notes || ''

                            return (
                              <React.Fragment key={`group-${row?.groupId}`}>
                                <TableRow>
                                  <TableCell>{i + 1}</TableCell>
                                  <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word',color:groupDisplayNote ? 'error.main': '' }}>
                                      {groupDisplayNote || groupDisplayName}
                                    </Typography>
                                    {/* {groupDisplayNote ? (
                                      <Typography
                                        variant='body2'
                                        sx={{
                                          color: 'error.main',
                                          whiteSpace: 'pre-wrap',
                                          wordBreak: 'break-word',
                                          overflowWrap: 'break-word',
                                        }}
                                      >
                                        Note: {groupDisplayNote}
                                      </Typography>
                                    ) : null} */}
                                    {/* <Typography variant='body2' sx={{ mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: facilityColor }}>
                                      {groupDescription}
                                    </Typography> */}
                                  </TableCell>
                                  <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                  <TableCell align="center" sx={{ color: facilityColor }}>
                                    {groupProductDisplayQty}
                                  </TableCell>
                                  {canViewCosts && <TableCell align="center" sx={{ color: facilityColor }}>
                                    ${unitEach.toFixed(2)}
                                  </TableCell>}
                                  {canViewCosts && <TableCell sx={{ color: facilityColor }}>
                                    ${displayGroupTotal.toFixed(2)}
                                  </TableCell>}
                                </TableRow>
                                {groupHasInstall && showInstallPriceInView && (
                                  <TableRow>
                                    <TableCell>-</TableCell>
                                    <TableCell sx={{ pl: 4 }}>
                                      <Typography sx={{ color: groupInstallNotes ? 'red' : 'inherit', whiteSpace: 'pre-wrap' }}>
                                        {groupInstallNotes || 'Install Price'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center">-</TableCell>
                                    <TableCell align="center">{groupInstallDisplayQty}</TableCell>
                                    {canViewCosts && <TableCell align="center">${groupInstallUnitEach.toFixed(2)}</TableCell>}
                                    {canViewCosts && <TableCell>${groupInstallSubtotal.toFixed(2)}</TableCell>}
                                  </TableRow>
                                )}
                                <TableRow>
                                  <TableCell colSpan={
                                    (invoice?.cust_product?.some(item => item.product_notes) ? 6 : 5) + 
                                   (details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3 ? 2 : 0)
                                   - hiddenPriceColumnCount
                                  }>
                                    <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            )
                          }

                          const val = row;
                          const { vid,split_percentage,wholesale_price, product_name,facility_id,expected_cost, product_notes, material_notes, vpt_number, product_price, product_retail_price, adjustment, product_index,
                            quantity, locationQuantity,actual_retail_price,install_cost,install_qty, product_total, discount, unit, unit_qty, material,rfp,markAdjType,adj_value_type,install_notes,
                            services = [], quickbookId
                          } = val
                          // Get labor install
                          const labourService = services?.find(service => service.labour_cost_service_id === 10);
                          const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                          const labourQty = (labourService?.prQty || 0) * locationQuantity;
                          const labourRate = labourService?.service_original_cost || 0;
                          const labourTotal = labourQty * labourRate;
                          const labourInitial = (labourService?.prQty || 0) * labourRate;
                          
                          // Unit name logic
                          let unitData = UNITS?.filter((item) => item?.id == unit)
                          let shortUnitName = unitData[0]?.short_name || 'Unit'
                          let unitName = unitData[0]?.name   

                          let basePriceForUnit = Number(actual_retail_price) || Number(product_retail_price) || 0;
                          let SPMA = basePriceForUnit;
                          if (material == 1) {
                            SPMA = SPMA + (adj_value_type == 1 ? Number(adjustment || 0) : -Number(adjustment || 0));
                          }
                          SPMA = parseFloat(SPMA)?.toFixed(2);                 
                          return (
                          <React.Fragment key={vid}>
                            {/* Product Row */}
                            <TableRow
                            //  sx={{
                            //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            // }}
                            >
                              <TableCell>{i+1}</TableCell>
                                {/* {(() => {
                                const matchingProductTaxItem = Array.isArray(taxRateData) && quickbookId
                                  ? taxRateData.find(item => 
                                      String(item.item_id) === String(quickbookId) || 
                                      (item.item_name && String(item.item_name).toLowerCase() === String(product_name).toLowerCase())
                                    )
                                  : Array.isArray(taxRateData)
                                  ? taxRateData.find(item => 
                                      item.item_name && String(item.item_name).toLowerCase() === String(product_name).toLowerCase()
                                    )
                                  : null;
                                return (
                                  <TableCell 
                                    align="center" 
                                    sx={{ 
                                      color: matchingProductTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                    }}
                                  >
                                    {matchingProductTaxItem?.is_taxable && taxAmount !=0?  <><span class="tabler--letter-t-small"></span><span style={{fontSize:"12px"}}>{matchingProductTaxItem?.tax_percent}%</span></>  : '-'}
                                  </TableCell>
                                );
                              })()} */}
                              <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                {product_notes ? (
                                  <Typography variant='body2' sx={{ fontWeight: 'bold',wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{product_notes}</Typography>
                                ) : !material_notes ? (
                                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                                ) : (
                                  ''
                                )}
                                {material_notes ? (
                                  <Stack direction={'column'}>
                                    {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Note : </Typography>  */}
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main', whiteSpace: 'pre-line'}}>{material_notes}</Typography> 
                                  </Stack>
                                ) : ''}
                                {/* {(material === 1 && details?.job_category_name != 'Time & Material') ? 
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      (Addl. Material{val?.stock_type === 1 
                                        ? ' - Finished' 
                                        : val?.stock_type === 2 
                                          ? ` - Partial (${UNITS?.find(u => u.id === val?.convertion_unit)?.short_name || 'Unit'})` 
                                          : ''})
                                    </Typography>
                                : ''} */}
                                {(material === 1 && rfp==0 &&  details?.job_category_name != 'Time & Material') ? 
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Addl. Material)</Typography> 
                              : ''}
                              {(material === 1 && rfp==1 && details?.job_category_name != 'Time & Material') ? 
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Material)</Typography> 
                              : null}

                              </TableCell>
                              {/* {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''} */}
                              {/* <TableCell align="center">{material === 1 ? '1' : quantity}({shortUnitName})</TableCell> */}
                              <TableCell align="center">{vpt_number ? vpt_number : '-'}</TableCell>
                              <TableCell align="center">{locationQuantity}</TableCell>
                            
                              {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                              {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                              {/* {(details?.is_split_order  && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? `$${wholesale_price || 0}` : '-'}
                              </TableCell>
                              :''
                              }
                              {(details?.is_split_order  && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? `${incomingSplitMarkup || 0}%` : '-'}
                              </TableCell>
                              :''
                              } */}
                              {/* <Tooltip title={
                                details?.is_split_order && facility_id != currentFacilityId 
                                  ? `Wholesale price + (Wholesale price  * incoming split markup (${incomingSplitMarkup || 0}) / 100)` 
                                  : ""
                              }> */}
                                {canViewCosts && <TableCell align="center">${install_cost ? (Number(actual_retail_price) || 0).toFixed(2) : (Number(SPMA) || 0).toFixed(2)}</TableCell>}
                              {/* </Tooltip> */}
                              {/* <TableCell>{locationQuantity}</TableCell> */}
                              {canViewCosts && (
                                <TableCell>${
                                  install_cost ?
                                  ((Number(actual_retail_price) * (locationQuantity || 1) * (quantity || 1)) || 0).toFixed(2) :
                                  material === 1 ?
                                  ((Number(SPMA) * (locationQuantity || 1)) || 0).toFixed(2) :
                                  ((Number(SPMA) * (locationQuantity || 1) * (quantity || 1)) || 0).toFixed(2)
                                }</TableCell>
                              )}
                            </TableRow>
                            {/* Labor Install Row (if exists) */}
                            {/* {labourService && (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                                <TableCell align="center">N/A</TableCell>
                                <TableCell>${labourRate?.toFixed(2)}</TableCell>
                                <TableCell>{labourQty?.toFixed(2)}</TableCell>
                                <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                              </TableRow>
                            )} */}
                            {install_cost && showInstallPriceInView ? (
                              <TableRow>
                                <TableCell>-</TableCell>
                                   {/* {(() => {
                                  const matchingInstallTaxItem = Array.isArray(taxRateData)
                                    ? taxRateData.find(item => 
                                        item.item_name && String(item.item_name).toLowerCase().includes('install')
                                      )
                                    : null;
                                  return (
                                    <TableCell 
                                      align="center" 
                                      sx={{ 
                                        color: matchingInstallTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                      }}
                                    >
                                        {matchingInstallTaxItem?.is_taxable && taxAmount!=0?  <><span class="tabler--letter-t-small"></span><span style={{fontSize:"12px"}}>{matchingInstallTaxItem?.tax_percent}%</span></>  : '-'}
                                    </TableCell>
                                  );
                                })()} */}
                                <TableCell sx={{ pl: 4 }}>
                               

                                  <Typography sx={{color: install_notes ? 'red' : 'inherit' ,whiteSpace: 'pre-wrap'}}>{install_notes ? install_notes : (canViewCosts ? `Install Price` : 'Installation')}</Typography></TableCell>
                                <TableCell align="center">-</TableCell>
                                {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                                  <TableCell align="center">
                                    {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                                  </TableCell>
                                  : ''
                                }
                                {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                                  <TableCell align="center">
                                    {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                                  </TableCell>
                                  : ''
                                } */}
                                <TableCell align="center">{install_qty ?? 1}</TableCell>
                             
                                {canViewCosts && (
                                <>
                                <TableCell align="center">${install_cost || 0}</TableCell>
                                <TableCell>
                                  {/* ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)} */}
                                  ${((install_cost || 0) * (install_qty ?? 1)).toFixed(2)}
                                </TableCell>
                                </>
                                )}

                              </TableRow>
                            ):''}
                            <TableRow>
                                <TableCell colSpan={
                                  (invoice?.cust_product?.some(item => item.product_notes) ? 6 : 5) + 
                                 (details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3 ? 2 : 0)
                                 - hiddenPriceColumnCount
                                }>
                                <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </> : null}
                  {/* <Typography variant='h6' sx={{ mt: 2 }}>{(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Additional Services" : 'Services') : ""}</Typography> */}
                  {/* <Typography variant='h6' sx={{ mt: 2 }}>{(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) ? ((details?.job_category_name != 'Service only' ) ? "Additional Services" : 'Services') : ""}</Typography> */}
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      {(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) &&
                        <TableHead>
                          <TableRow>
                            <TableCell>Sl No.</TableCell>
                            {/* <TableCell></TableCell> */}
                            <TableCell colSpan={2}>{((details?.job_category_name != 'Service only' ) ? "ADDITIONAL SERVICES" : 'SERVICES')}</TableCell>
                            {canViewCosts && <TableCell>COST (HOURLY)</TableCell>}
                            <TableCell>HOURS</TableCell>
                            {canViewCosts && <TableCell>TOTAL COST</TableCell>}
                          </TableRow>
                        </TableHead>}
                      <TableBody>
                        {invoice?.cust_product?.map((val) => {
                          const { vid, product_name, product_price, product_retail_price,install_total,install_qty,
                            quantity, product_total, discount, unit, unit_qty,markAdjType,adjustment,locationQuantity,adj_value_type,material,
                          } = val
                          let unitName = UNITS?.filter((item) => item?.id == unit)
                          unitName = unitName[0]?.name
                          let shortUnitName = ''
                          if (unitName == 'Square feet') {
                            shortUnitName = 'Sq ft'
                          } else if (unitName == 'Lineal feet') {
                            shortUnitName = 'Lin ft'
                          } else if (unitName == 'Square Inches') {
                            shortUnitName = 'Sq Inches'
                          } else if (unitName == 'Unit') {
                            shortUnitName = 'Unit'
                          }

                          let SPMA = 0
                        if(markAdjType==2 || markAdjType==3) {
                          SPMA = (product_retail_price || 0) //+ (adjustment ? Number(adjustment) : 0)
                        }else{
                          SPMA = (product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)

                        }
                        if(material==1){
                          let newSPMA = Number(SPMA) + (adj_value_type==1 ? Number(adjustment) : -Number(adjustment));
                          SPMA = newSPMA
                          console.log('SPMA-material==11111',SPMA);
                          // console.log('SPMA-material==1',newSPMA);
                          // console.log('SPMA-material==1',adj_value_type);
                          // console.log('SPMA-material==1',adjustment);
                        }
                        SPMA = parseFloat(SPMA)?.toFixed(2)  

                        // let theSubTotalAmount =markAdjType==1?product_total: ((SPMA * (locationQuantity * quantity))) //+ (adj_value_type ?  +adjustment : -adjustment))
                        let theSubTotalAmount =0
                        if(markAdjType==1){
                          theSubTotalAmount = product_total
                        }else{
                          if(material==1){
                            theSubTotalAmount = (SPMA * locationQuantity)
                          }else{
                            theSubTotalAmount = (SPMA * (locationQuantity * quantity))
                          }
                        }
                          subTotal += theSubTotalAmount
                          if(install_total && install_total != 0){
                            subTotal += (install_qty == 0 ? 0 : Number(install_total)||0)
                          }     
                          return (
                            null
                          )
                        })}
                        {(() => {
                          let serviceIndex = 1;
                          return (
                            <>
                              {openInvoice && invoiceSelectedServices?.map((ser) => {
                                console.log('invoiceSelectedServices--@@', ser);
                                return (
                                  <TableRow sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                  }}>
                                    <TableCell>{serviceIndex++}</TableCell>
                                    {/* {(() => {
                                      const serviceQuickbookId = ser.quickbookId || ser.quickbook_id;
                                      const serviceName = ser.service_name || ser.name;
                                      const matchingProductTaxItem = Array.isArray(taxRateData) && serviceQuickbookId
                                        ? taxRateData.find(item => 
                                            String(item.item_id) === String(serviceQuickbookId) || 
                                            (item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase())
                                          )
                                        : Array.isArray(taxRateData)
                                        ? taxRateData.find(item => 
                                            item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase()
                                          )
                                        : null;
                                      return (
                                        <TableCell 
                                          align="center" 
                                          sx={{ 
                                            color: matchingProductTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                          }}
                                        >
                                          {matchingProductTaxItem?.qb_item_taxable && taxAmount!=0 ?  <><span class="tabler--letter-t-small"></span> <br/><span style={{fontSize:"12px"}}>{matchingProductTaxItem?.tax_percent}%</span></>  : '-'}
                                        </TableCell>
                                      );
                                    })()} */}
                                    <TableCell colSpan={2}>
                                      <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{ser?.service_notes ? 
                                  <Stack direction={'column'}>
                                    {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{ser.service_notes}</Typography> 
                                  </Stack>
                                  : (ser?.service_name || ser?.name )}</Typography>
                              </TableCell>
                              {canViewCosts && <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>}
                              <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                              {canViewCosts && <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>}
                            </TableRow>
                          )
                        })}

                        {openInvoice && additionalSelectedServices
                          ?.filter(servItem=>{
                            // if (details?.job_category_name != 'Time & Material' && servItem.labour_cost_service_id == 10) {
                            //   return false;
                            // }
                            return true;
                          })?.map((ser) => {
                            console.log('additionalSelectedServices--', ser);
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell>{serviceIndex++}</TableCell>
                                      {/* {(() => {
                                const serviceQuickbookId = ser.quickbookId || ser.quickbook_id;
                                const serviceName = ser.service_name || ser.name;
                                const matchingProductTaxItem = Array.isArray(taxRateData) && serviceQuickbookId
                                  ? taxRateData.find(item => 
                                      String(item.item_id) === String(serviceQuickbookId) || 
                                      (item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase())
                                    )
                                  : Array.isArray(taxRateData)
                                  ? taxRateData.find(item => 
                                      item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase()
                                    )
                                  : null;
                                return (
                                  <TableCell 
                                    align="center" 
                                    sx={{ 
                                      color: matchingProductTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                    }}
                                  >
                                    { matchingProductTaxItem?.is_taxable && taxAmount!=0?  <><span class="tabler--letter-t-small"></span><br/> <span style={{fontSize:"12px"}}>{matchingProductTaxItem?.tax_percent}%</span></>  : '-'}
                                  </TableCell>
                                );
                              })()} */}
                                <TableCell colSpan={2}>
                                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{ser?.service_notes ? 
                                    <Stack direction={'column'}>
                                      {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                      <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{ser.service_notes}</Typography> 
                                    </Stack>
                                    : (ser?.service_name || ser?.name )}</Typography>
                                </TableCell>
                                {canViewCosts && <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>}
                                <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                                {canViewCosts && <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>}
                              </TableRow>
                            )
                          }
                        )}

                        {openInvoice && cartService?.map((ser) => {
                          console.log('cartService--', ser);
                          ser.sellingPrice = details?.project_category == 13 ? ser.unit_cost : ser.sellingPrice || ser.unit_cost
                          ser.originalMarkup = details?.project_category == 13 ? 0 :ser.originalMarkup || ser.product_markup || ser.markup
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell>{serviceIndex++}</TableCell>
                              {/* {(() => {
                                const serviceQuickbookId = ser.quickbookId || ser.quickbook_id;
                                const serviceName = ser.service_name || ser.name;
                                const matchingProductTaxItem = Array.isArray(taxRateData) && serviceQuickbookId
                                  ? taxRateData.find(item => 
                                      String(item.item_id) === String(serviceQuickbookId) || 
                                      (item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase())
                                    )
                                  : Array.isArray(taxRateData)
                                  ? taxRateData.find(item => 
                                      item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase()
                                    )
                                  : null;
                                return (
                                  <TableCell 
                                    align="center" 
                                    sx={{ 
                                      color: matchingProductTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                    }}
                                  >
                                    {matchingProductTaxItem?.qb_item_taxable && taxAmount!=0?  <><span class="tabler--letter-t-small"></span> <br/> <span style={{fontSize:"12px"}}>{matchingProductTaxItem?.tax_percent}%</span></>  : '-'}
                                  </TableCell>
                                );
                              })()} */}
                              <TableCell colSpan={2}>
                                <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{ser?.service_notes ? 
                                  <Stack direction={'column'}>
                                    {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{ser.service_notes}</Typography> 
                                  </Stack>
                                  : (ser?.service_name || ser?.name )}</Typography>
                              </TableCell>
                              {canViewCosts && <TableCell> ${((ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>}
                              <TableCell>{ser ? ser?.qty?.toFixed(2) : 0}</TableCell>
                              {canViewCosts && <TableCell> ${(ser.qty * (ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>}
                            </TableRow>
                          )
                        }
                        )}

                        </>
                          )
                        })()}
                       
                      {(treatInvoiceAsTimeMaterial || !canViewCosts) ? '' :
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                              {/* {details?.project_category !== 11 && ( */}
                                <Typography variant="overline">Product Total</Typography>
                              {/* )} */}
                        </TableCell>
                        <TableCell align="left" width={10}>
                          {/* {details?.project_category !== 11 && ( */}
                          <Typography variant="overline">
                            {/* ${invoice?.cust_product?.reduce((sum, val) => {
                              const {
                                product_retail_price = 0,material= 0, adjustment = 0, markAdjType,
                                product_total = 0,actual_retail_price,install_cost, locationQuantity = 1, quantity = 1,adj_value_type,
                                services = []
                              } = val;

                              const labourService = services?.find(s => s.labour_cost_service_id === 10);
                              const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;
                              const basePrice = actual_retail_price !== 0 && actual_retail_price != null
                              ? actual_retail_price
                              : product_retail_price;
                              // let SPMA = (markAdjType === 2 || markAdjType === 3)
                              //   ? product_retail_price + Number(adjustment)
                              //   : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                              // const effectiveTotal = markAdjType === 1
                              //   // ? product_total - labourTotal
                              //   // : (SPMA * (locationQuantity * quantity)) - labourTotal;
                              //   ? product_total
                              //     : (SPMA * (locationQuantity * quantity));
                              let SPMA = (markAdjType === 2 || markAdjType === 3)
                                  ? basePrice //+ Number(adjustment)
                                  : basePrice //+ ((basePrice * Number(adjustment)) / 100);
                                  if(material==1){
                                    let newSPMA = Number(SPMA) + (adj_value_type==1 ? Number(adjustment) : -Number(adjustment));
                                    SPMA = newSPMA
                                    // console.log('SPMA-material==1',SPMA);
                                    // console.log('SPMA-material==1',newSPMA);
                                    // console.log('SPMA-material==1',adj_value_type);
                                    // console.log('SPMA-material==1',adjustment);
            
                                  }
                              const effectiveTotal = markAdjType === 1 && material === 0
                              // ? product_total
                              ? (SPMA * (locationQuantity * quantity)) :
                              material === 1 ? (SPMA * locationQuantity)
                              : (SPMA * (locationQuantity * quantity)) //+ (adj_value_type ?  +adjustment : -adjustment);

                              return sum + effectiveTotal;
                            }, 0)?.toFixed(2)} */}
                            ${invoiceModalProductTotalFromRows.toFixed(2)}
                        </Typography>
                        {/* )} */}
                        </TableCell>
                      </RowResultStyle>
                      }

                      {canViewCosts && (labourInstallService?.length > 0 || 
                        additionalSelectedServices?.some(
                          x => x.labour_cost_service_id === 10 && (x.total_cost || 0) > 0
                        ) ||
                        invoice?.cust_product?.some(
                          val => parseFloat(val.install_cost || 0) > 0
                        )
                      ) &&
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Install Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          {/* <Typography variant="overline">
                              ${invoice?.cust_product?.reduce((sum, val) => {
                                const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                                return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                              }, 0)?.toFixed(2)}
                          </Typography> */}
                          <Typography variant="overline">
                                  ${(
                                    // (invoice?.cust_product?.reduce((sum, val) => {
                                    //   const labourService = val?.services?.find(
                                    //     s => s.labour_cost_service_id === 10
                                    //   );
                                    //   return (
                                    //     sum +
                                    //     (labourService?.service_original_cost || 0) *
                                    //     (labourService?.prQty || 0) *
                                    //     (val?.locationQuantity || 1)
                                    //   );
                                    // }, 0) || 0) +
                                    
                                  //   (invoice?.cust_product?.reduce((sum, val) => {
                                  //   const installCost = val?.install_qty == 0 ? 0 : parseFloat(val?.install_cost || 0);
                                  //   const locationQty = parseFloat(val?.locationQuantity || 1);
                                  //   // const quantity = parseFloat(val?.quantity || 1);
                                  //   const quantity = parseFloat(val?.install_qty ?? 1);

                                  //   if (installCost) {
                                  //     // return sum + installCost * locationQty * quantity;
                                  //     return sum + installCost * quantity;
                                  //   }
                                  //   return sum;
                                  // }, 0) || 0) +

                                    (invoiceModalInstallTotalFromRows || 0) +
                                    (additionalSelectedServices?.reduce(
                                      (s, x) =>
                                        x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                      0
                                    ) || 0)
                                  ).toFixed(2)}
                                </Typography>
                        </TableCell>
                      </RowResultStyle>
                      }

                      {canViewCosts && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                          {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                          <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                          <Typography variant="overline">
                            ${(
                              (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                              // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                              (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10 
                                        ? s
                                        : s + (x.total_cost || 0),
                                    0
                                ) || 0) +
                              (cartService?.reduce((s, x) => {
                                const sp = x.sellingPrice || x.unit_cost || 0;
                                const markup = x.originalMarkup || x.product_markup || 0;
                                const final = sp + (sp * markup / 100);
                                return s + ((x.qty || 0) * final);
                              }, 0) || 0)
                            )?.toFixed(2)}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      )}

                      {canViewCosts && (details?.job_category_name != 'Service only' || subTotal > 0 || (!treatInvoiceAsTimeMaterial && (invoiceModalCustProductSubtotalForServices || 0) > 0)) && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Subtotal</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">
                            ${fUSPrice(
                              (treatInvoiceAsTimeMaterial ? (subTotal || 0) : (invoiceModalCustProductSubtotalForServices || 0)) +
                              (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                              (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                              (cartService?.reduce((s, x) => {
                                const sp = x.sellingPrice || x.unit_cost || 0;
                                let markup = x.originalMarkup || x.product_markup || 0;
                                // console.log("SSSSSSSSSSSSSSSSSSSSSS",x);
                                
                                // if(x.material==1){
                                //   let newSPMA = Number(markup) + (x.adj_value_type==1 ? Number(x.adjustment) : -Number(x.adjustment));
                                //   markup = newSPMA
                                 
          
                                // }
                                const final = sp + (sp * markup / 100);
                                return s + ((x.qty || 0) * final);
                              }, 0) || 0)
                            //   (invoice?.cust_product?.reduce((sum, val) => {
                            //   const labourService = val?.services?.find(
                            //     s => s.labour_cost_service_id === 10
                            //   );
                            //   return (
                            //     sum +
                            //     (labourService?.service_original_cost || 0) *
                            //       (labourService?.prQty || 0) *
                            //       (val?.locationQuantity || 1)
                            //   )
                            // }, 0) || 0)
                            )}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      )}

                      {/* Discount hidden — restore when needed
                      {canViewCosts && invoice?.extra_discount > 0 && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Discount</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>
                      )}
                      */}
                      
                      {canViewCosts && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Tax</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>
                      )}

                      {canViewCosts && isInvoiceRushFeeOn && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Rush Fee</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">${Number(invoiceModalRushFee || 0).toFixed(2)}</Typography>
                        </TableCell>
                      </RowResultStyle>
                      )}

                      {canViewCosts && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="subtitle1" sx={{ color: invoiceModalDisplayTotal < 0 ? 'red' : 'inherit' }}>Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="subtitle1" sx={{ color: invoiceModalDisplayTotal < 0 ? 'red' : 'inherit' }}>${fUSPrice(invoiceModalDisplayTotal)}</Typography>
                        </TableCell>
                      </RowResultStyle>
                      )}
                                           
                      {canViewCosts && invoice?.project_category != 13 ? 
                        <>
                          {(userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
                          (details?.billing_type ? (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right" sx={{display:"flex", alignItems: "center",gap: 1}}>
                                <Typography fontSize={"small"} variant="caption"  sx={{ color:  'inherit' }}> (only viewable for admin)</Typography>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>Billing Type</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
                              </TableCell>
                            </RowResultStyle>
                          ) : '')
                          :""}
                        {(invoice?.total && details?.billing_type) ?
                          <RowResultStyle>
                            <TableCell colSpan={3} />
                            <TableCell align="right">
                              <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>Minimum Payable Amount</Typography>
                            </TableCell>
                            <TableCell align="left" width={10}>
                              <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>${(invoice?.total && details?.billing_type)? parseFloat((invoice?.total *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                            </TableCell>
                          </RowResultStyle>
                          :""
                          }
                          {details?.totalPaidAmount > 0 && (
                          <RowResultStyle>
                            <TableCell colSpan={3} />
                            <TableCell align="right">
                              <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>Amount Paid</Typography>
                            </TableCell>
                            <TableCell align="left" width={10}>
                              <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>${details?.totalPaidAmount ? parseFloat(details?.totalPaidAmount)?.toFixed(2) : 0.00}</Typography>
                            </TableCell>
                          </RowResultStyle>
                          )}
                          {details?.totalPaidAmount > 0 && (
                          <RowResultStyle>
                            <TableCell colSpan={3} />
                            <TableCell align="right">
                              <Typography variant="subtitle1"  sx={{ color: details?.dueAmount <= 0 ? 'inherit' : 'red' }}>Balance Due</Typography>
                            </TableCell>
                            <TableCell align="left" width={10}>
                              <Typography variant="subtitle1"  sx={{ color: details?.dueAmount <= 0 ? 'inherit' : 'red' }}>${details?.dueAmount ? parseFloat(details?.dueAmount <= 0 ? 0.00 : details?.dueAmount)?.toFixed(2) : 0.00}</Typography>
                            </TableCell>
                          </RowResultStyle>
                          )}
                        </>
                      : ''}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
                    <>
                      <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                      <Stack spacing={2}>
                        {invoice?.note_data?.map((val, index) => {
                          const { id, authorized_by, note, timestamp } = val;
                          return (
                            <Paper
                              key={id}
                              elevation={3}
                              sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={8}>
                                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                    {note}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                  {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                                  <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                    Added By: {authorized_by}
                                  </Typography>
                                  <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                    {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Paper>
                          );
                        })}
                      </Stack>
                    </>
                  ) : ''}
                  </>
                }
                {/* Sales orders no longer use Manager Approve/Reject in popup
                {Number(details?.status) !== 10 && (details?.status === 2 && details?.quotation_status === 2 && (details?.manager_approval_required === true || details?.manager_approval_required === 1) && userType != 3 && details?.project_type != null && Number(details?.hold) !== 1) ? (
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button
                      type="button"
                      size="small"
                      variant="contained"
                      disabled={!canSalesOrderManagerApprove}
                      onClick={() => {
                        if (!canSalesOrderManagerApprove) {
                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                          return;
                        }
                        setConfirmManagerAccept(true);
                      }}
                    >
                      Manager Approve
                    </Button>
                    <Button
                      type="button"
                      size="small"
                      variant="outlined"
                      disabled={!canSalesOrderManagerReject}
                      onClick={() => {
                        if (!canSalesOrderManagerReject) {
                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                          return;
                        }
                        setRejectInvoice(true);
                      }}
                      sx={{ color: theme.palette.error.main }}
                    >
                      Manager Reject
                    </Button>
                  </Box>
                ) : null} */}
                {Number(details?.status) !== 10 && Number(details?.hold) !== 1 && ((userType == 3 ||!isAdminUser (userType) ||  (isAdminUser (userType) && details?.status !==2)) && (((details?.allInstallationCompleted == 1) && empty(details?.installation_acceptance) && details?.received_status !== 1) || !(details?.status == 4 || details?.status == 3) || (details?.status == 4 && details?.proj_status == 1)) && ((isClient || userType == 3) ? (details?.client_approve == 1 || (details?.status == 4 && details?.proj_status == 1)) : true)) && details?.project_type && details?.status !==6 && details?.installation_pending_review != 1 && details?.installation_pending_review != 2 && !isMirrored  &&
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    {(requestAccept) ? 
                      <Stack alignItems='center' justifyContent='center'>
                        <CircularProgress color="primary" variant="indeterminate" />
                      </Stack> 
                      : 
                      <>
                        {/* {(details?.status == 4 && details?.proj_status == 1) ? '' :
                          <>
                          {hasInvoicePermissions ? <>
                          {confirmInvoice ? 
                            <Stack alignItems='center' justifyContent='center'>
                              <CircularProgress color="primary" variant="indeterminate" />
                            </Stack>
                          :
                            <Button type="submit" variant="contained"
                              onClick={() =>{
                                let permission =!explodedPermissions?.some((permission) => ['Approve Proofs(Final Client invoice approval)'].includes(permission))
                            
                              if(details?.status==4 && user.added_by_client ==1 && permission ){
                              return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                              
                              }else{

                                setConfirmInvoice(true)}
                              }
                              }
                            // onClick={()=>handleAcceptorRejectInvoice(1)}
                            >
                              Approve
                            </Button>
                          }
                          </>:""}
                          </>
                        } */}

                        {/* Approval button hidden for TM Review as it is handled in Job Cost section */}
                        {(details?.status == 4 && details?.proj_status == 1) || details?.isReview == 2 ? '' : 
                          <>
                          {hasInvoicePermissions ? <>
                          {confirmInvoice ? 
                            <Stack alignItems='center' justifyContent='center'>
                              <CircularProgress color="primary" variant="indeterminate" />
                            </Stack>
                          :
                            <Button type="submit" variant="contained"
                              onClick={() =>{
                                let permission =!explodedPermissions?.some((permission) => ['Approve Proofs(Final Client invoice approval)'].includes(permission))
                            
                              if(details?.status==4 && user.added_by_client ==1 && permission ){
                              return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                              
                              }else{

                                setConfirmInvoice(true)}
                              }
                              }
                            // onClick={()=>handleAcceptorRejectInvoice(1)}
                            >
                              Approve
                            </Button>
                          }
                          </>:""}
                          </>
                        }
                          {invoiceReject ? 
                          <Stack alignItems='center' justifyContent='center'>
                            <CircularProgress color="primary" variant="indeterminate" />
                          </Stack>
                        :
                          <>
                            {(!empty(details?.installationStatus) || details?.isReview ==2 || details?.installation_pending_review == 1 || details?.installation_pending_review == 2) ? ''  :
                            <Button size="small" variant="outlined"
                              onClick={() => setRejectInvoice(true)}
                              //  onClick={()=>handleAcceptorRejectInvoice(2)}
                              sx={{ color: theme.palette.error.main }} >
                              Reject
                            </Button>}
                          </>
                        }
                      </>
                    }
                  </Box>}
                {/* {(userType ==3&&details?.status!=4&&details?.onboard_complete==0) && 
                <Box sx={{ mt: 3,  display: 'flex', justifyContent: 'flex-end',gap:1 }}>
                  <Button type="submit" variant="contained" 
                   onClick={()=> navigate(PATH_DASHBOARD.official.process,{state:{requestId:id}})}
                  // onClick={()=>handleAcceptorRejectInvoice(1)}
                   >                 
                   Proceed to Workflow
                  </Button>
                 
                </Box>} */}
              </Scrollbar>

            </Grid>
            </>
            )}
          </Modal>
          {/* delete popup */}
          <ConfirmationPopup
            open={openDelete}
            handleClick={handleDeleteRFQ}
            handleClose={() => { setOpenDelete(!openDelete), setIsOpen(false) }}
            message={'You want to delete this order '}
            warningMessage={
              (isSplitOrder && Number(values?.project_category?.id) !== 15)
                ? 'If this split sales order is deleted, the related build orders will also be deleted.'
                : ''
            }
            loading={loadingDelete}
          />
          <ConfirmationPopup
            open={openVoid}
            handleClick={handleVoidSalesOrder}
            handleClose={() => {
              setOpenVoid(false);
              setIsOpen(false);
              setVoidReason('');
              setVoidReasonError('');
            }}
            message={'You want to void this Sales Order?'}
            warningMessage={'The order will remain in SignWise with a Void status and will be voided in QuickBooks when applicable.'}
            loading={loadingVoid}
            showReasonField
            reasonRequired
            reasonLabel="Reason for void"
            reasonValue={voidReason}
            reasonError={voidReasonError}
            onReasonChange={(value) => {
              setVoidReason(value);
              if (voidReasonError) setVoidReasonError('');
            }}
          />
          <ConfirmationPopup
            open={openReopenVoid}
            handleClick={handleReopenVoidSalesOrder}
            handleClose={() => {
              setOpenReopenVoid(false);
              setIsOpen(false);
            }}
            message={'You want to reopen this voided sales order? It will be restored to its previous workflow status.'}
            loading={loadingReopenVoid}
          />
          <ConfirmationPopup
            open={openJobTypeWarning}
            handleClick={() => setOpenJobTypeWarning(false)}
            handleClose={() => setOpenJobTypeWarning(false)}
            message={jobTypeWarningMessage}
            warningMessage={'Job type is not selected. Please select a job type and continue.'}
            forWarning = {true}
          />
          <ConfirmationPopup
            open={openDialog}
            handleClick={handleConfirmSubmit}
            handleClose={handleCloseDialog}
            message={'you want to submit this order? The changes will be applied to the job upon client acceptance.'}
          />

          <ConfirmationPopup
            open={openConvertToRFQ}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true);
              await handleConvertToJob();
              setIsLoading(false);
            }}
            handleClose={() => { setOpenConvertToRFQ(false) }}
            message={`You want to convert this Sales Order to ${(
              // details?.noServiceNoTask === 1 &&
              invoice?.cust_product?.length === 0 &&
              isConvertToInvoicing
            ) ? "Invoicing" : "Production"}`}
          />

          <ConfirmationPopup
            open={openDuplicate}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true);
              await handleDuplicateSalesOrder();
              setIsLoading(false);
            }}
            handleClose={() => { setOpenDuplicate(false) }}
            message={'You want to duplicate this Sales Order ?'}
          />

          <ConfirmationPopup
            open={openDuplicate}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true);
              await handleDuplicateSalesOrder();
              setIsLoading(false);
            }}
            handleClose={() => { setOpenDuplicate(false) }}
            message={'You want to duplicate this Sales Order ?'}
          />

          <Dialog
            open={openGroupedQbWarning && Number(details?.hold) !== 1}
            onClose={() => setOpenGroupedQbWarning(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                QuickBooks sync required
              </Typography>
            </DialogTitle>
            <DialogContent dividers>
              <Alert severity="warning" sx={{ mb: 2 }}>
                If you approve without syncing, the invoice will be created in our system but not in QuickBooks.
                Please make sure all sales orders are synced to QuickBooks.
              </Alert>
              <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600 }}>
                The following sales orders are not synced to QuickBooks:
              </Typography>
              <Stack spacing={1.5}>
                {groupedQbSyncIssues.map((issue) => (
                  <Paper
                    key={issue.requestId}
                    variant="outlined"
                    sx={{
                      p: 1.5,
                      borderColor: 'warning.main',
                      bgcolor: (theme) => alpha(theme.palette.warning.main, 0.08),
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      {issue.name}
                    </Typography>
                    <Typography variant="body2" color="error" component="div" sx={{ mt: 1 }}>
                      {(issue.reason || '').split('\n').map((line, lineIndex) => (
                        line.trim() ? (
                          <Box component="span" key={lineIndex} sx={{ display: 'block' }}>
                            {line.trim()}
                          </Box>
                        ) : null
                      ))}
                    </Typography>
                  </Paper>
                ))}
              </Stack>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
              <Button
                variant="outlined"
                color="inherit"
                onClick={() => setOpenGroupedQbWarning(false)}
              >
                Cancel
              </Button>
              <LoadingButton
                variant="contained"
                color="primary"
                loading={isLoadingInvoice}
                onClick={async () => {
                  setOpenGroupedQbWarning(false);
                  await submitGroupedFinalInvoiceApproval();
                }}
              >
                Approve
              </LoadingButton>
            </DialogActions>
          </Dialog>

          {/* Accept request invoice */}
          <ConfirmationPopup
            open={confirmInvoice && Number(details?.hold) !== 1}
            loading={isLoadingInvoice}
            handleClick={async () => {
              setIsLoadingInvoice(true);
               /*  if(details?.isReview ==2) {
                 await handleAcceptorRejectInvoice(3,true);
               }else */ if (
                details?.allInstallationCompleted === 1 &&
                details?.status === 4 &&
                empty(details?.installation_acceptance)
              ) {
                await handleAcceptorRejectInvoice(3);
              } else if (details?.status == 4 && details?.for_parent_facility == 1 && details?.min_payment_status == 0){
                handleSplitOrderApproval()
              }else {
                await handleAcceptorRejectInvoice(1);
              }

              setIsLoadingInvoice(false);
            }}
            handleClose={() => setConfirmInvoice(false)}
            // message={'You want to Approve this invoice'} if the message not needed any change in "Open" status sales order then uncomment this and comment below one
            message={details?.status === 2 ? 'You want to Approve this ?' : 'You want to Approve this invoice'}
          />
          {/* Sales orders no longer use manager approval
          <ConfirmationPopup
            open={confirmManagerAccept && Number(details?.hold) !== 1}
            handleClick={() => handleManagerAccept()}
            handleClose={() => setConfirmManagerAccept(false)}
            message={'You want to accept this sales order? It will be sent to the client.'}
          /> */}
          {/* reject request invoice */}
          {/* <ConfirmationPopup 
        open={invoiceReject}
        handleClick={()=>handleAcceptorRejectInvoice(2)}
         handleClose={()=>setRejectInvoice(false)}
         message={'You want to reject this invoice '}
        /> */}
          {/* Reopen rejected request  */}
          <ConfirmationPopup
            open={reOpen}
            handleClick={() => handleReopeningRequest()}
            handleClose={() => setReopen(false)}
            message={'You want to reopen this order '}
          />
          {/* Preview Modal */}
          {openPreview && (
            <Modal
              width={900}
              open={openPreview}
              handleClose={() => {
                setOpenPreview(false);
              }}
              modalTitle={'Preview'}
            >
              <AnimatedButton title="Print A3" startIcon={<Print />} size="small" onClick={handlePrintPreview} />
              <div ref={printableContentRef} className="print-black">
                <Grid container sx={{ justifyContent: 'center', }} spacing={3} >
                  <Grid item xs={12} md={12}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={2}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Name: </span>
                          {previewData?.name}
                        </Typography>

                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Use custom welcome message: </span>
                          {previewData.welcome_message == null ? 'No' : previewData.welcome_message == false ? 'No' : 'Yes'}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography variant="subtitle2" style={{ color: theme.palette.primary.darker }}>
                          Description:
                        </Typography>
                        <Typography variant="subtitle2" style={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>
                          {previewData?.description}
                        </Typography>
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker,
                        overflowWrap: 'break-word', wordWrap: 'break-word',
                         wordBreak: 'break-word' }}>Skills or services required:</span> <br/>
                          <List>
                           {previewData?.skills?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'disc', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                        {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Workflows: </span> <br/>                                           
                      <List>
                           {previewData?.workflow?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'dics', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary?.darker }}>Job Class: </span>
                          {previewData?.project_type?.name}
                        </Typography>
                        {/* <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker, }}>Markup Type: </span>
                          {previewData?.markup_type?.name}
                        </Typography> */}
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary?.darker, }}>Job Type: </span>
                          {previewData?.project_category?.name}
                        </Typography>
                        {previewData?.project_category?.id===13 &&<Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary?.darker, }}>No Charge Type: </span>
                          {previewData?.no_charge_type?.name}
                        </Typography>}
                        {previewData?.project_category?.id===14 &&<Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary?.darker, }}>Routes: </span>
                          {previewData?.map_service?.name}
                        </Typography>}
                      </Stack>

                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Client: </span>
                          {previewData?.clients?.name}
                        </Typography>
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Project: </span>
                          {previewData?.community?.name}
                        </Typography>
                      </Stack>
                      

                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Start Date: </span>
                          {formatDateOnly(previewData.start)}
                        </Typography>
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>installation Date: </span>
                          {formatDateOnly(previewData.end)}
                        </Typography>
                      </Stack>
                      {details?.all_sales_rep_ids ?
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Sales Rep :</span> {details?.sales_rep_names}
                        </Typography>
                        : ""}
                      {/* {(previewData?.project_category?.name == 'Service only' || previewData?.project_category?.name == 'Time & Material') ? null : <> */}
                      {/* || previewData?.project_category?.name == 'Time & Material' */}
                      {(previewData?.project_category?.name == 'Service only') ? null : <>
                      <Typography>PRODUCTS</Typography>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                {/* {VALUEPreview?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))} */}
                                {previewData?.project_category?.name == 'Time & Material' ?
                                VALUE_TIME_Preview?.map((val) => (
                                  val.id === 14 ? (
                                    <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                      <TableCell>{val.value}</TableCell>
                                    </Tooltip>) :
                                  <TableCell>{val.value}</TableCell>
                                )) :
                                VALUEPreview?.map((val) => (
                                  val.id === 14 ? (
                                    <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                      <TableCell>{val.value}</TableCell>
                                    </Tooltip>) :
                                  <TableCell>{val.value}</TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(() => {
                                const previewRows = previewData?.project_category?.name === 'Time & Material'
                                  ? groupedPreviewTandMDisplayRows
                                  : groupedPreviewDisplayRows;
                                return previewRows?.map((row, index) => {
                                  if (row?.__type === 'group') {
                                    const representative = row?.representative || {}
                                    const members = row?.members || []
                                    const groupName = getCustomerOrderProductGroupDisplayName({
                                      groupMeta: row?.groupMeta,
                                      representative,
                                      members,
                                      groupId: row?.groupId,
                                    })
                                    const groupProductDisplayQty = Number(row?.groupProductDisplayQty ?? 1) || 1
                                    const groupInstallDisplayQty = Number(row?.groupInstallDisplayQty ?? 1) || 1
                                    const groupInstallSubtotal = Number(row?.groupInstallSubtotal ?? 0)
                                    const groupHasInstall = groupInstallSubtotal > 0
                                    const displayGroupTotal = groupHasInstall ? Number(row?.groupProductOnlyTotal ?? 0) : Number(row?.totalValue || 0)
                                    const unitEach = Number(row?.adjustedGroupRetailEach ?? 0) || (groupProductDisplayQty > 0 ? displayGroupTotal / groupProductDisplayQty : 0)
                                    const groupInstallUnitEach = Number(row?.adjustedGroupInstallRetailEach ?? 0) || (groupInstallDisplayQty > 0 ? groupInstallSubtotal / groupInstallDisplayQty : 0)
                                    const groupInstallNotes = getGroupInstallNotesDisplay(members)
                                    const groupDisplayName = groupName
                                    const groupDisplayNote =
                                      members.find(
                                        (m) =>
                                          m?.product_notes != null &&
                                          String(m.product_notes).trim() !== '',
                                      )?.product_notes || ''
                                    const anchorProduct = representative
                                    const anchorId = anchorProduct?.indexId || ''

                                    return (
                                      <React.Fragment key={`group-preview-${row?.groupId}`}>
                                        <TableRow>
                                          <TableCell>#{anchorId}</TableCell>
                                          <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: groupDisplayNote ? 'error.main' : '' }}>
                                              {groupDisplayNote || groupDisplayName}
                                            </Typography>
                                          </TableCell>
                                          {previewData?.project_category?.name === 'Time & Material' ?
                                            <TableCell>{(hasMarkupPermission) ? unitEach : null}</TableCell>
                                          : <>
                                            <TableCell>{(hasMarkupPermission && markupType == 2) ? unitEach : null}</TableCell>
                                            <TableCell>{(hasMarkupPermission && markupType == 1) ? unitEach : null}</TableCell>
                                          </>}
                                          <TableCell>
                                            -
                                          </TableCell>
                                          <TableCell>
                                            {groupProductDisplayQty}
                                          </TableCell>
                                          {(() => {
                                            const representativeQuickbookId = representative?.quickbookId || representative?.quickbook_id;
                                            const representativeProductName = representative?.product_name || representative?.name;
                                            const matchingProductTaxItem = Array.isArray(taxRateData) && representativeQuickbookId
                                              ? taxRateData.find(item => 
                                                  String(item.item_id) === String(representativeQuickbookId) || 
                                                  (item.item_name && String(item.item_name).toLowerCase() === String(representativeProductName).toLowerCase())
                                                )
                                              : Array.isArray(taxRateData)
                                              ? taxRateData.find(item => 
                                                  item.item_name && String(item.item_name).toLowerCase() === String(representativeProductName).toLowerCase()
                                                )
                                              : null;
                                            return (
                                              <TableCell 
                                                align="center" 
                                                sx={{ 
                                                  color: matchingProductTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                                }}
                                              >
                                                {matchingProductTaxItem 
                                                  ? (matchingProductTaxItem.qb_tax_display || (matchingProductTaxItem.qb_item_taxable ? 'T' : '-')) 
                                                  : '-'}
                                              </TableCell>
                                            );
                                          })()}
                                          <TableCell>
                                            {displayGroupTotal.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {groupHasInstall ? '' : displayGroupTotal.toFixed(2)}
                                          </TableCell>
                                        </TableRow>
                                        {groupHasInstall && (
                                          <TableRow key={`group-install-preview-${row?.groupId}`}>
                                            <TableCell>#{anchorId}</TableCell>
                                            <TableCell>
                                              <Typography>Install Price</Typography>
                                              {groupInstallNotes ? (
                                                <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>
                                                  Note: {groupInstallNotes}
                                                </Typography>
                                              ) : null}
                                            </TableCell>
                                            {previewData?.project_category?.name === 'Time & Material' ?
                                              <TableCell>{groupInstallUnitEach}</TableCell>
                                            : <>
                                              <TableCell>{(hasMarkupPermission && markupType == 2) ? groupInstallUnitEach : null}</TableCell>
                                              <TableCell>{(hasMarkupPermission && markupType == 1) ? groupInstallUnitEach : null}</TableCell>
                                            </>}
                                            <TableCell>
                                              -
                                            </TableCell>
                                            <TableCell>
                                              {groupInstallDisplayQty}
                                            </TableCell>
                                            {(() => {
                                              const matchingInstallTaxItem = Array.isArray(taxRateData)
                                                ? taxRateData.find(item => 
                                                    item.item_name && String(item.item_name).toLowerCase().includes('install')
                                                  )
                                                : null;
                                              return (
                                                <TableCell 
                                                  align="center" 
                                                  sx={{ 
                                                    color: matchingInstallTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                                  }}
                                                >
                                                  {matchingInstallTaxItem 
                                                    ? (matchingInstallTaxItem.qb_tax_display || (matchingInstallTaxItem.qb_item_taxable ? 'T' : '-')) 
                                                    : '-'}
                                                </TableCell>
                                              );
                                            })()}
                                            <TableCell>
                                              {groupInstallSubtotal.toFixed(2)}
                                            </TableCell>
                                            <TableCell>
                                              {row?.totalValue?.toFixed(2)}
                                            </TableCell>
                                          </TableRow>
                                        )}
                                        <TableRow>
                                          <TableCell colSpan={15} sx={{ padding: 0 }}>
                                            <Divider />
                                          </TableCell>
                                        </TableRow>
                                      </React.Fragment>
                                    )
                                  }

                                  const data = row;
                                const quantityFieldName = `quantity_${data.product_id || data.id}`;
                                const discountFieldName = `discount_${data.product_id || data.id}`;
                                let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                unitName = unitName[0]?.name
                                let shortUnitName = ''
                                if (unitName == 'Square feet') {
                                  shortUnitName = 'Sq ft'
                                } else if (unitName == 'Lineal feet') {
                                  shortUnitName = 'Lin ft'
                                } else if (unitName == 'Square Inches') {
                                  shortUnitName = 'Sq Inches'
                                } else if (unitName == 'Unit') {
                                  shortUnitName = 'Unit'
                                }
                                
                                // Apply no charge logic similar to OfficialRequestAdd.js
                                if(noCharge){
                                  // For no charge products, calculate retail_price based on expected_cost + install_cost
                                  const expectedCost = parseFloat(data?.expected_cost) || 0
                                  const installCost = parseFloat(data?.install_cost) || 0
                                  
                                  // If install_cost is available, add it to expected_cost
                                  const calculatedRetailPrice = installCost > 0 ? expectedCost + installCost : expectedCost
                                  
                                  data['retail_price'] = calculatedRetailPrice
                                  data['actual_retail_price'] = expectedCost
                                  data['expected_cost'] = expectedCost
                                }
                                
                                const dataPrice = data.product_price || data.price
                                
                                const dataWholesalePrice = data.product_price || data.price
                                const dataQuantity = values[quantityFieldName]
                                const dataDiscount = data.discount ? data.discount : values[discountFieldName]
                                const dataretailPrice = data.product_retail_price || data.retail_price
                                const dataActualPrice = data.actual_retail_price || data.retail_price
                              
                                const rowTotal = calculateTotal(markupType == 1 ? dataPrice : (markupType == 2 ? (data.install_cost && parseFloat(data.install_cost) > 0 ? dataretailPrice : dataActualPrice) : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType,0,data.adj_value_type);
                                const invoiceAmount = parseFloat(data?.expected_material_cost) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                let markup = markupType ? (invoiceAmount / rowTotal) : null
                                markup = markup ? Number(markup) : 0
                                
                                const isNegativeMaterialAdjustmentMode =
                                      data?.adj_value_type === false ||
                                      data?.adj_value_type === 0 ||
                                      data?.adj_value_type === '0' ||
                                      data?.adj_value_type === 'false'
                                const materialAdjustmentValue =
                                  Number(data?.adjustment) || 0
                                const adjustedMarkupCostEach =
                                  Number(data?.markUpCost || 0) +
                                  (isNegativeMaterialAdjustmentMode
                                    ? -materialAdjustmentValue
                                    : materialAdjustmentValue)
                                const materialFormulaEach =
                                  Number(data?.price) || 0
                                  
                                const isLosingMoneyItem =
                                      isNegativeMaterialAdjustmentMode &&
                                      adjustedMarkupCostEach < materialFormulaEach

                                const losingMoneyRowSx = isLosingMoneyItem
                                  ? {
                                      '& .MuiTableCell-root:not(:nth-of-type(4)), & .MuiTableCell-root:not(:nth-of-type(4)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)) .MuiFormLabel-root':
                                        {
                                          color: `${theme.palette.error.main} !important`,
                                        },
                                    }
                                  : undefined

                                return (
                                <React.Fragment key={data.indexId || index}>
                                <TableRow sx={losingMoneyRowSx}>
                                    <TableCell>#{data.indexId}</TableCell>
                                    <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                      <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{data?.product_name || data?.name}</Typography>
                                      {data?.product_notes ? 
                                      <Stack direction={'column'}>
                                        <Typography variant='body2' sx={{textDecoration: 'underline',color: 'error.main'}}>Note : </Typography> 
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{data?.product_notes}</Typography> 
                                      </Stack>
                                      : ''}
                                    </TableCell>

                                    {previewData?.project_category?.name == 'Time & Material' ? 
                                    <TableCell>{dataActualPrice || dataPrice || 0}</TableCell>
                                  : <>
                                    <TableCell>{(hasMarkupPermission && markupType == 2) ? dataActualPrice : null}</TableCell>
                                    <TableCell>{(hasMarkupPermission && markupType == 1) ? dataPrice : null}</TableCell>
                                  </>}
                                    <TableCell>
                                      {Number(data.quantity)} {shortUnitName}
                                    </TableCell>
                                    <TableCell>
                                      {Number(data.locationQuantity)}
                                    </TableCell>
                                    {(() => {
                                      const productQuickbookId = data.quickbookId || data.quickbook_id;
                                      const productName = data.product_name || data.name;
                                      const matchingProductTaxItem = Array.isArray(taxRateData) && productQuickbookId
                                        ? taxRateData.find(item => 
                                            String(item.item_id) === String(productQuickbookId) || 
                                            (item.item_name && String(item.item_name).toLowerCase() === String(productName).toLowerCase())
                                          )
                                        : Array.isArray(taxRateData)
                                        ? taxRateData.find(item => 
                                            item.item_name && String(item.item_name).toLowerCase() === String(productName).toLowerCase()
                                          )
                                        : null;
                                      return (
                                        <TableCell 
                                          align="center" 
                                          sx={{ 
                                            color: matchingProductTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                          }}
                                        >
                                          {matchingProductTaxItem 
                                            ? (matchingProductTaxItem.qb_tax_display || (matchingProductTaxItem.qb_item_taxable ? 'T' : '-')) 
                                            : '-'}
                                        </TableCell>
                                      );
                                    })()}
                                      <TableCell >
                                        {data?.install_cost && parseFloat(data?.install_cost) > 0 ?
                                        (
                                          parseFloat(data?.actual_retail_price || 0) *
                                          (data?.locationQuantity || 1)
                                        ).toFixed(2):
                                        (
                                          parseFloat(data?.actual_retail_price || 0) *
                                          (data?.locationQuantity || 1)
                                        ).toFixed(2)
                                      }
                                      
                                      </TableCell>
                                    <TableCell>
                                      {data?.install_cost && parseFloat(data?.install_cost) > 0 ? '' :
                                      rowTotal?.toFixed(2)
                                      }
                                    </TableCell>
                                  </TableRow>
                                    {
                                      data?.install_cost && parseFloat(data?.install_cost) > 0 ?
                                        <TableRow key={`summary-${data.indexId}`} sx={losingMoneyRowSx}>
                                          <TableCell>#{data?.indexId}</TableCell>
                                          <TableCell>
                                        <Typography>Install Price</Typography>
                                            
                                        {data?.install_notes ?    <Typography sx={{color: data?.install_notes ? 'red' : 'inherit' ,whiteSpace: 'pre-wrap'}}> Note : {" "}{data?.install_notes ? data?.install_notes : ``}</Typography>:""}
                                        </TableCell>
                                          <TableCell >
                                            {data?.install_cost}
                                          </TableCell>
                                          <TableCell align='center'></TableCell>
                                          <TableCell align='center'></TableCell>
                                          <TableCell align='center'></TableCell>
                                          <TableCell >
                                            {(
                                              parseFloat(data?.install_cost || 0) *
                                              (data?.locationQuantity || 1)
                                            ).toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {rowTotal?.toFixed(2)}
                                          </TableCell>
                                        </TableRow>
                                        :
                                        ''
                                    }
                                <TableRow>
                                      <TableCell colSpan={15} sx={{ padding: 0 }}>
                                        <Divider />
                                      </TableCell>
                                    </TableRow>
                                </React.Fragment>
                                );
                              });
                            })()}

                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      </>}
                      <LabelStyle>SERVICES</LabelStyle>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                {VALUE_SERVICES?.map((val,index) => (
                                  (((previewData?.project_category?.name == 'Service only') && val.id === 0) || (val.id === 6)) ? null : (
                                    <TableCell>{val.value}</TableCell>
                                  )
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* {selectedServices?.map((data, index) => {
                                const dataCost = data.unit_cost || data.total_cost
                                let originalMarkup = data.originalMarkup || 0
                                let markup = data.markup || 0
                                const total = dataCost * data.quantity
                                data['total'] = total?.toFixed(2)
                                console.log("###########data total", data);
                                const newQty = (data.prQty * (data.qtyData || 1) * data.locationQuantity)?.toFixed(2)
                                const quantityDifference = data.quantity - newQty;
                                data['quantityDifference'] = quantityDifference
                                return (
                                  <>
                                    <TableRow key={index}>
                                      <TableCell>#{data?.productIndex}</TableCell>
                                      <TableCell>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                          {data.name}
                                        </Typography>
                                        {data?.service_notes ? 
                                          <Stack direction={'column'}>
                                            <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                            <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{data.service_notes}</Typography> 
                                          </Stack>
                                          : ''}
                                      </TableCell>
                                      <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                      <TableCell>{data.cost}</TableCell>
                                      <TableCell>{dataCost}</TableCell>
                                      <TableCell>{data.quantity}</TableCell>
                                      <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                      <TableCell>{(data.unit_cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                      <TableCell>{data.total}</TableCell>
                                      <TableCell></TableCell>
                                      <TableCell align='right'>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              })} */}
                              {additionalSelectedServices?.map((data, index) => {
                                const dataCost = data.unit_cost || data.total_cost
                                const total = dataCost * (data?.quantity || 1)
                                data['total'] = total ? total?.toFixed(2) : 0.00
                                let originalMarkup = isNoChargeJob ? 0 : (data.originalMarkup || 0)
                                console.log("###########data total", data);
                                const quantityDifference = Number(data.quantity)
                                data['quantityDifference'] = quantityDifference
                                return (
                                  <TableRow key={data.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    {/* {(previewData?.project_category?.name == 'Service only' || previewData?.project_category?.name == 'Time & Material') ? <TableCell></TableCell> : <TableCell>5555</TableCell>} */}
                                    <TableCell></TableCell>
                                    <TableCell>{data.name}</TableCell>
                                    <TableCell>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                        {data?.service_notes ? 
                                        <Stack direction={'column'}>
                                          {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                          <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{data.service_notes}</Typography> 
                                        </Stack>
                                        : ""}
                                      </Typography>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell>{isNoChargeJob ? '-' : originalMarkup?.toFixed(2)}</TableCell>
                                    <TableCell>{data.cost}</TableCell>
                                    <TableCell>{data.unit_cost || data.total_cost}</TableCell>
                                    <TableCell>{previewData?.project_category?.name == 'Time & Material' ? 0 : data?.quantity || 1}</TableCell>
                                    <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                    <TableCell>{data.total}</TableCell>
                                    <TableCell>{data.total}</TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      
                      <Divider />
                      { (cart?.length > 0 || cartService?.length > 0 ) ? <>
                      <Typography>Proposals</Typography>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500}}>
                        {/* <TableContainer sx={{ minWidth: 500, whiteSpace: 'nowrap' }}> */}
                          <Table>
                            <TableHead>
                              <TableRow>

                                {VALUE_RFP_Product?.map((val,index) => (

                                  <TableCell key={val.id}>{val.value}</TableCell>

                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody >
                              {cart?.map((data, index) => {
                                let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                unitName = unitName[0]?.name
                                let shortUnitName = ''
                                if (unitName == 'Square feet') {
                                  shortUnitName = 'Sq ft'
                                } else if (unitName == 'Lineal feet') {
                                  shortUnitName = 'Lin ft'
                                } else if (unitName == 'Square Inches') {
                                  shortUnitName = 'Sq Inches'
                                } else if (unitName == 'Unit') {
                                  shortUnitName = 'Unit'
                                }
                                // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup : data.RetailMarkup : 0
                                let markup = isNoChargeJob ? 0 : (parseFloat(Number(data?.markup)) || 0)
                                return (
                                  <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{data.name || data.product_name}</TableCell>
                                    {/* <TableCell>{invoiceAmount}</TableCell> */}
                                    <TableCell>
                                      {isNoChargeJob ? '-' : (markup?.toFixed(2) || 0.00)}
                                    </TableCell>
                                    <TableCell>
                                      {data.product_price?.toFixed(2) || 0}
                                    </TableCell>
                                    <TableCell>
                                      {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                    </TableCell>
                                    <TableCell>
                                      {data.quantity} {shortUnitName}
                                    </TableCell>
                                    <TableCell>
                                      {data.location_quantity}
                                    </TableCell>
                                    {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                    </TableCell> */}
                                    <TableCell>
                                      {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0)).toFixed(2)}
                                    </TableCell>
                                   
                                  </TableRow>
                                );
                              })}

                            </TableBody>
                            {cartService?.length > 0 ? <h6>Services</h6> : null}
                            <TableBody>
                              {cartService?.map((data, index) => {
                                const sellingPrice = Number(data.sellingPrice ?? data.unit_cost ?? 0)
                                const originalMarkup = Number(
                                  data.originalMarkup ?? data.product_markup ?? data.markup ?? 0,
                                )
                                const retailEach = sellingPrice + (sellingPrice * originalMarkup / 100)

                                return (
                                  <>
                                    <TableRow key={data.id}>
                                      <TableCell>{index + 1}</TableCell>
                                      <TableCell>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                          {data?.service_notes ? 
                                          <Stack direction={'column'}>
                                            {/* <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography>  */}
                                            <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{data.service_notes}</Typography> 
                                          </Stack>
                                          : (data.name || data.product_name)}
                                        </Typography>
                                      </TableCell>
                                      {/* <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.indexId, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell> */}
                                      {/* <TableCell>{invoiceAmount}</TableCell> */}
                                      <TableCell>
                                         {/* {isNoChargeJob ? '-' : (data.originalMarkup?.toFixed(2) ?? '0')} */}
                                        {isNoChargeJob ? '-' : originalMarkup.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                           {/* {data.sellingPrice?.toFixed(2)} */}
                                        {sellingPrice.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                           {/* {((data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)} */}
                                        {retailEach.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        {data.qty} Hours
                                      </TableCell>
                                      <TableCell>-</TableCell>
                                      {/* <TableCell>
                                            {(data.qty*data.sellingPrice).toFixed(2)||0}
                                      </TableCell> */}
                                      <TableCell>
                                          {/* {(data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)} */}
                                        {((data.qty || 0) * retailEach).toFixed(2)}
                                      </TableCell>
                                    
                                    </TableRow>

                                  </>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      </> : null}
                      {selectedMaterials?.length > 0 ? <>
                      <Typography>MATERIALS</Typography>
                      <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {/* {VALUE_MATERIAL?.map((val,index) => ( */}
                                    {VALUE_MATERIAL?.filter(val => val.id !== 8).map((val,index) => (
                                      val.id === 3 ? (
                                        <Tooltip key={val.id} title="Unit Price + ((Unit Price * Markup)/100)">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 5 ? (
                                        <Tooltip key={val.id} title="Unit Price * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 6 ? (
                                        <Tooltip key={val.id} title="Markup Cost * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) :
                                      val.id === 8 || val.id === 10 ? (
                                        null 
                                      ) :
                                      <TableCell key={val.id}>{val.value}</TableCell>
                                     
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedMaterials?.map((data, index) => {
                                    console.log("################Materials",data);
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    data.price=data.price ? data.price : data.product_price || 0 
                                    data.product_id= data.product_id ? data.product_id : data.id
                                    data.markup = data.markup ? data.markup : data.product_markup
                                    const markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
                                    data['markUpCost'] = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
                                     let stock= 'Partial'
                                    if(data.stock_type===1 ){
                                      stock ='Finished'
                                    } 
                                    return (
                                      <>
                                        <TableRow key={index}>
                                          <TableCell>{index + 1}</TableCell>
                                         <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                           <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{data?.name || data?.product_name}</Typography>
                                           {data?.material_notes ? 
                                           <Stack direction={'column'}>
                                             <Typography variant='body2' sx={{textDecoration: 'underline',color: 'error.main'}}>Note : </Typography> 
                                             <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{data?.material_notes}</Typography> 
                                           </Stack>
                                           : ''}
                                         </TableCell>
                                         {/* <TableCell>
  <IconButton onClick={() => handleOpenMaterialNote(data.newIndexId, data.material_notes)}>
    <NoteAdd
      sx={{
        color: (!data?.material_notes || data?.material_notes === '') ? '' : theme.palette.primary.main,
      }}
    />
  </IconButton>
</TableCell> */}
                                         <TableCell>{stock}</TableCell>
                                         <TableCell>{roundMoneyValue(data.price).toFixed(2)}</TableCell>
                                         <TableCell>{data.markup || 0}</TableCell>
                                         {/* <TableCell>{data.markUpCost || 0}</TableCell> */}
                                         <TableCell>{(data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))).toFixed(2) || 0}</TableCell>
                                         <TableCell>{data.quantity || 1} {shortUnitName}</TableCell>
                                         {/* <TableCell>{(data.price * (data.quantity || 1))?.toFixed(2)}</TableCell> */}
                                         {/* <TableCell>{((data.markUpCost || 0) * (data.quantity || 1))?.toFixed(2)}</TableCell> */}
                                          <TableCell >
                                          {(
                                              (data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))) * (data.quantity || 0)
                                            )?.toFixed(2)}
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={openMaterialNote[data.newIndexId] || false}
                                          handleClose={() => handleCloseMaterialNote(data.newIndexId)}
                                        >
                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >
                                              <Grid item xs={12}>
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Note
                                                </Typography>

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    size="medium"
                                                    value={currentNote}
                                                    onChange={handleNoteChange}
                                                    disabled={tmInvoicingFieldDisabled}
                                                    InputProps={{ readOnly: tmInvoicingFieldDisabled }}
                                                    error={!currentNote.trim() && currentNote.length > 0}
                                                    inputProps={{ maxLength: MAX_CHARACTERS }}
                                                    helperText={
                                                      !currentNote.trim() && currentNote.length > 0
                                                        ? 'Note cannot be empty or contain only spaces'
                                                        : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                    }
                                                  />
                                                </Stack>
                                              </Grid>
                                          </Grid>

                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => handleSaveMaterialNote(data.newIndexId)}
                                                  loading={isSavingNote}
                                                  disabled={!currentNote.trim() || tmInvoicingFieldDisabled}>
                                                  Save
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                        
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Divider />
                          </> : null}
                      <Stack>
                        <Typography variant="subtitle2" style={{ color: theme.palette.primary.darker }}>
                          Notes:
                        </Typography>
                        <Typography variant="subtitle2" sx={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word', color:'error.main', whiteSpace: 'pre-line' }}>
                          <Scrollbar
                            sx={{
                              maxHeight: 200,
                              '& .simplebar-content': {
                                maxHeight: 200,
                                display: 'flex',
                                flexDirection: 'column',
                              },
                            }}
                          >{previewData?.notes}</Scrollbar>

                        </Typography>
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        {canViewCosts && (
                        <Typography variant="subtitle2">
                          <span style={{ color:noCharge? 'red' : theme.palette.primary.darker }}>Grand Total: </span>
                          <span style={{ color:noCharge? 'red' : theme.palette.primary.darker }}> 
                            {grandTotal ? fUSPrice((noCharge && grandTotal >0) ? fUSPrice(grandTotal * -1) : fUSPrice(grandTotal)) : fUSPrice(0)} </span>
                        </Typography>
                        )}

                        {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                          <Typography variant="subtitle2" sx={{ cursor: 'pointer' }}>
                            <span style={{ color: theme.palette.primary.darker }}>Total Markup Amount: </span>
                            {totalMarkupAmount ? parseFloat(Number(totalMarkupAmount))?.toFixed(2) : 0}
                          </Typography>
                        </Tooltip>

                        <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                          <Typography variant="subtitle2" sx={{ cursor: 'pointer' }}>
                            <span style={{ color: theme.palette.primary.darker }}>Total Markup Percentage: </span>
                            {totalMarkupPercentage ? parseFloat(Number(totalMarkupPercentage))?.toFixed(2) : 0}
                          </Typography>
                        </Tooltip> */}

                        {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Total Service Markup: </span>
                      {totalServiceMarkup ? totalServiceMarkup?.toFixed(2) : 0}
                    </Typography> */}
                        {/* Discount hidden — restore when needed
                        {canViewCosts && (
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Total Discount: </span>
                          {DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00}
                        </Typography>
                        )}
                        */}
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <Label
                            variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
                            color={getEffectiveSalesOrderStatusInfo().color} >
                            {getEffectiveSalesOrderStatusInfo().label}
                          </Label>
                          {/* BACKUP: preview modal status (first item status for grouped)
                          <Label
                            variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
                            color={getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install, details?.received_status, details?.manager_approval_required, details?.send_to_client, details?.quotation_status, details?.is_scheduled ).color} >
                            {getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install, details?.received_status, details?.manager_approval_required, details?.send_to_client, details?.quotation_status, details?.is_scheduled ).label}
                          </Label>
                          */}
                        </Typography>
                      </Stack>

                    </Stack>
                  </Grid>
                </Grid>
              </div>
            </Modal>
          )}
          {/* reject request invoice */}
          {invoiceReject == true && Number(details?.hold) !== 1 && <Dialog
            open={invoiceReject}
            onClose={() => { setRejectInvoice(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            BackdropComponent={Backdrop}
            BackdropProps={{ invisible: true }}
            PaperProps={{
              sx: {
                width: 700,
                borderRadius: 2,
                bgcolor: '#0f1b1e',
                border: '1px solid rgba(255,255,255,0.12)'
              }
            }}
          >
            <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 600, color: '#fff', pb: 1 }}>
              {"Are you sure ?"}
            </DialogTitle>
            <DialogContent sx={{ pt: 0 }}>
              <DialogContentText id="alert-dialog-description" sx={{ color: 'grey.400', mb: 2 }}>
                {`You want to reject this ${isMirrored ? 'Split Order' : 'invoice'}.`}
                {(details?.checkProjectExist || details?.isProject) &&
                  Number(details?.status) === 4 &&
                  Number(details?.proj_status) === 1 ? (
                  <Box component="span" display="block" sx={{ color: 'warning.main', fontWeight: 600, mt: 1 }}>
                    Rejecting this sales order will also move the job to Rejected.
                  </Box>
                ) : null}
              </DialogContentText>
              <TextField
                fullWidth
                label="Reason For Rejection"
                type="text"
                multiline
                minRows={3}
                maxRows={7}
                onInput={(event) => setReason(event.target.value)}
                sx={{
                  mb: 2,
                  bgcolor: 'rgba(255,255,255,0.05)',
                  borderRadius: 1,
                  input: { color: '#fff' },
                  '& .MuiInputLabel-root': { color: 'grey.400' }
                }}
              />
              <UploadMultiFile
                showPreview
                files={rejectFile ? [rejectFile] : []}
                // accept="image/*,application/pdf"
                maxSize={1024 * 1024 * 1024}
                multiple={false}
                onDrop={handleRejectFileDrop}
                onRemove={() => setRejectFile(null)}
                onRemoveAll={() => setRejectFile(null)}
                isUploading={isUploadingRejectFile}
                sx={{ mt: 1 }}
              />
            </DialogContent>
            <DialogActions>
              <Button 
                size="small" 
                variant="contained"
                onClick={async () => {
                  setIsSubmittingReject(true);
                  await handleAcceptorRejectInvoice(2);
                  setIsSubmittingReject(false);
                }}
                disabled={isSubmittingReject || isUploadingRejectFile}
                sx={{ 
                  color: theme.palette.background.paper,
                  fontWeight: 600,
                  px: 3
                }}
              >
                {isSubmittingReject ? <CircularProgress size={20} color="inherit" /> : 'OK'}
              </Button>

              <Button 
                size="small" 
                variant="outlined"
                onClick={() => { 
                  setRejectInvoice(false)
                  setReason('') 
                  setRejectFile(null)
                }}
                sx={{ color: theme.palette.error.main }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>}
          <Dialog open={openDialogNoStock} >
            <DialogTitle>
              No stock available for this material.
            </DialogTitle>
            {/* <DialogContent>
              No stock available for this material. Please add stock first.
            </DialogContent> */}
            <DialogActions>
              <Button onClick={closeDialogNoStock} color="error">Close</Button>
            </DialogActions>
          </Dialog>
         <Dialog open={openDialogPartial} >
          <DialogTitle>Select Stock Type</DialogTitle>
          <DialogContent>
            <RadioGroup
              value={String(stockType)}
              onChange={(e) => {
                const val = e.target.value;
                setStockType(val === '1' ? 1 : 2);
                if (val === '1') setConvertionUnit(0);
              }}
            >
              <FormControlLabel value="1" control={<Radio />} label={`Finished Product (${finishedProducts?.length === 0 ? 'No stock' : finishedProducts?.length})`} />
              <FormControlLabel value="2" control={<Radio />} label="Partial Finished Product" />
            </RadioGroup>

            {stockType === 2 && (
              partialProducts.length > 0 ? (
                <>
                  <Typography>Select Conversion Unit</Typography>
                  <RadioGroup
                    value={convertionUnit}
                    onChange={(e) => setConvertionUnit(Number(e.target.value))}
                  >
                    {UNITS
                      .filter(u => partialProducts.some(p => p.partial_unit === u.id))
                      .map(u => (
                        <FormControlLabel
                          key={u.id}
                          value={u.id}
                          control={<Radio />}
                          label={u.name}
                        />
                      ))}
                  </RadioGroup>
                </>
              ) : (
                <Typography color="error">No partial stock found</Typography>
              )
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog} color="error">Cancel</Button>
            <Button
              onClick={handleSubmitPopUp}
              disabled={stockType === 1 ? finishedProducts?.length === 0 : stockType === 2 && partialProducts.length === 0}
              variant="contained"
            >
              Add Material
            </Button>
          </DialogActions>
        </Dialog>
          <Dialog
            open={openChangeOrderReasonDialog}
            onClose={() => {
              setOpenChangeOrderReasonDialog(false);
              setChangeOrderReason('');
            }}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Change Order Reason</DialogTitle>
            <DialogContent>
              <TextField
                sx={{ mt: 1 }}
                fullWidth
                multiline
                minRows={3}
                label="Reason"
                value={changeOrderReason}
                onChange={(e) => setChangeOrderReason(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenChangeOrderReasonDialog(false);
                  setChangeOrderReason('');
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                disabled={!changeOrderReason.trim()}
                onClick={() => {
                  const reason = changeOrderReason.trim();
                  setFieldValue('change_order_reason', reason);
                  setOpenChangeOrderReasonDialog(false);
                  handleSubmit();
                }}
              >
                Save Order
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openHoldPopup && Number(details?.status) !== 6 && Number(details?.rejected) !== 1}
            onClose={() => {
              setOpenHoldPopup(false);
              setHoldReason('');
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            BackdropProps={{ invisible: true }}
          >
            <DialogTitle id="alert-dialog-title">
              {details?.hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {
                  details?.hold === 1
                    ? 'You want to move this Sales Order from Hold.'
                    : 'You want to move this Sales Order to Hold.'
                }
              </DialogContentText>
              {(details?.hold === 0) ? (
                <TextField
                  sx={{ width: 400 }}
                  label="Reason"
                  type="text"
                  multiline
                  minRows={3}
                  maxRows={7}
                  value={holdReason}
                  onChange={(e) => {
                    setHoldReason(e.target.value);
                    if (holdReasonError) setHoldReasonError('');
                  }}
                  error={Boolean(holdReasonError)}
                  helperText={holdReasonError}
                />
              ) : ''}
            </DialogContent>
            <DialogActions>
              <Button
                size="small"
                variant="contained"
                onClick={async () => {
                  if ((details?.hold === 0) && !holdReason.trim()) {
                    setHoldReasonError(`Reason is required to put this Sales Order on Hold`);
                    return;
                  }
                  setIsSubmittingHold(true);
                  await handleUpdateSalesOrderHoldStatus(holdReason)
                  setIsSubmittingHold(false);
                  setOpenHoldPopup(false);
                  setHoldReason('');
                  setHoldReasonError('');
                }}
                disabled={isSubmittingHold}
              >
                {isSubmittingHold ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  'OK'
                )}
              </Button>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  setOpenHoldPopup(false);
                  setHoldReason('');
                }}
                sx={{ color: theme.palette.error.main }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      }
      {/* Progress Modal */}
      {/* <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        onSocketReady={setSocketReady}
        heading={progressHeading}
      /> */}
      
      <AttachmentPreviewDialog
        open={openPDFModal}
        onClose={() => {
          setOpenPDFModal(false)
          setSelectedPDFFile(null)
        }}
        fileUrl={selectedPDF}
        file={selectedPDFFile}
        isClient={isClient}
        userType={userType}
        pdfLoading={pdfLoading}
        setPdfLoading={setPdfLoading}
        useOfficeViewer={useOfficeViewer}
        setUseOfficeViewer={setUseOfficeViewer}
      />
      <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        heading={progressHeading}
        message="We're processing your request. Please wait..."
      />
      {/* Changes Confirmation Dialog */}
      <Dialog open={showChangesDialog} onClose={() => setShowChangesDialog(false)}>
        <DialogTitle>Changes Detected</DialogTitle>
        {/* <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            The following changes have been detected in your sales order:
          </Typography>
          <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
            {detectedChanges.map((change, index) => (
              <Typography key={index} variant="body2" sx={{ mb: 1, pl: 2 }}>
                • {change}
              </Typography>
            ))}
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Do you want to send these changes for client approval?
          </Typography>
        </DialogContent> */}
       <DialogContent>
  <Typography variant="body1" sx={{ mb: 2 }}>
    Changes have been made to this sales order.
  </Typography>

  {/* Show list of changed sections */}
  {getChangedSectionNames().length > 0 && (
    <>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Sections with detected changes:
      </Typography>
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', mb: 2 }}>
        {getChangedSectionNames().map((section) => (
          <Chip key={section} label={section} color="warning" variant="outlined" />
        ))}
      </Stack>
    </>
  )}

  <Typography
    variant="body1"
    sx={{
      mt: 1,
      fontWeight: 500,
      color: 'warning.main',
    }}
  >
    Do you want to send these changes for client approval?
  </Typography>
</DialogContent>

<DialogActions>
  <Button onClick={() => handleChangesDialogSubmit(false)} color="error" variant="outlined">
    No
  </Button>
  <Button onClick={() => handleChangesDialogSubmit(true)} variant="contained" color="primary">
    Yes
  </Button>
</DialogActions>

      </Dialog>
      <Dialog
        open={openDepositPaymentModeDialog}
        onClose={() => {
          setOpenDepositPaymentModeDialog(false);
          setSelectedDepositPaymentModeRow(null);
          setSelectedDepositPaymentMode(null);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Add Payment Mode</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={paymentModeOptions}
            fullWidth
            value={selectedDepositPaymentMode}
            getOptionLabel={(option) => option?.name || ''}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            onChange={(event, newValue) => setSelectedDepositPaymentMode(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Payment Mode"
                placeholder="Select payment mode"
                sx={{ mt: 1 }}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="outlined"
            onClick={() => {
              setOpenDepositPaymentModeDialog(false);
              setSelectedDepositPaymentModeRow(null);
              setSelectedDepositPaymentMode(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveDepositPaymentMode}
            disabled={isSavingDepositPaymentMode}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDepositPaymentModeWarningDialog}
        onClose={() => {
          setOpenDepositPaymentModeWarningDialog(false);
          setSubmitAfterDepositPaymentModeWarning(false);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Payment Mode Required</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You are continuing without adding a payment mode. This payment will need to be added  later.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setOpenDepositPaymentModeWarningDialog(false);
              if (submitAfterDepositPaymentModeWarning) {
                setSubmitAfterDepositPaymentModeWarning(false);
                if(details?.status == 4){
                  setOpenDialog(true);
                }else{
                  handleConfirmSubmit(formValues, formDatas);
                }
                return;
              }
              setSubmitAfterDepositPaymentModeWarning(false);
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Order Type Selection Dialog */}
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        sx={{ minWidth: 400 }}
        open={orderTypeSelection}
        onClose={() => setOrderTypeSelection(false)}
        onBackdropClick={() => setOrderTypeSelection(false)}
      >
        <DialogTitle>Please Choose from the following</DialogTitle>
        <DialogContent sx={{ minWidth: 300 }}>
          <DialogContentText sx={{color:'#ffffff'}} id="alert-dialog-description">
            <RadioGroup
              value={selectedOrderType}
              onChange={(e) => setSelectedOrderType(e.target.value)}
              sx={{ mt: 2 }}
            >
              <FormControlLabel
                value="1"
                control={<Radio sx={{color: '#ffffff'}} />}
                label="Install"
                sx={{color: '#ffffff'}}
              />
              <FormControlLabel
                value="2"
                control={<Radio sx={{color: '#ffffff'}} />}
                label="Pickup"
                sx={{color: '#ffffff'}}
              />
              <FormControlLabel
                value="3"
                control={<Radio sx={{color: '#ffffff'}} />}
                label="Shipping"
                sx={{color: '#ffffff'}}
              />
            </RadioGroup>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-end !important' }}>
          <Button
            size="small"
            variant="contained"
            disabled={isLoadingInvoice}
            onClick={(e) => {
              e.stopPropagation()
              handleUpdateReceivedStatus();
            }}
            sx={{ color: theme.palette.primary.main }}
          >
            {isLoadingInvoice ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <Typography sx={{ color: theme.palette.common.white }} variant="overline">
                OK
              </Typography>
            )}
          </Button>
          <Button
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              setOrderTypeSelection(false);
              enqueueSnackbar('Operation was cancelled', { variant: 'error' });
            }}
            sx={{
                background: '#BB2525',
                boxShadow: `0 8px 16px 0 ${alpha('#BB2525', 0.24)}`,
                '&:hover': {
                  background: '#FF8F8F',
                  boxShadow: `0 8px 16px 0 ${alpha('#FF8F8F', 0.24)}`,
                },
              }}
          >
            <Typography sx={{ color: theme.palette.common.white }} variant="overline">
              Cancel
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
      <ViewProductFormulaModal
        open={openProductFormulaModal}
        onClose={() => setOpenProductFormulaModal(false)}
        formulaId={selectedProductFormulaId}
        user={user}
        explodedPermissions={explodedPermissions}
        hideEdit={true}
      />
    </Page >
  )
}